
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5f6c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5f6c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bQdkN", function(module, exports) {

$parcel$export(module.exports, "pure", () => $89eee4fa6eb013bc$export$48ec4a2b1cfc6557);
$parcel$export(module.exports, "unless", () => $89eee4fa6eb013bc$export$6f0673371501d6b6);
$parcel$export(module.exports, "when", () => $89eee4fa6eb013bc$export$a55877ca9db47377);
$parcel$export(module.exports, "liftA1", () => $89eee4fa6eb013bc$export$53544bd8de5a7427);
$parcel$export(module.exports, "applicativeProxy", () => $89eee4fa6eb013bc$export$598532d07e20ffc2);
$parcel$export(module.exports, "applicativeFn", () => $89eee4fa6eb013bc$export$e68c32b2a06f106c);
$parcel$export(module.exports, "applicativeArray", () => $89eee4fa6eb013bc$export$8f0ac76856b1d87e);
// Generated by purs version 0.15.16

var $26ZCq = parcelRequire("26ZCq");

var $7FzSN = parcelRequire("7FzSN");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");

var $g13tD = parcelRequire("g13tD");
var $89eee4fa6eb013bc$export$48ec4a2b1cfc6557 = function(dict) {
    return dict.pure;
};
var $89eee4fa6eb013bc$export$6f0673371501d6b6 = function(dictApplicative) {
    var pure1 = $89eee4fa6eb013bc$export$48ec4a2b1cfc6557(dictApplicative);
    return function(v) {
        return function(v1) {
            if (!v) return v1;
            if (v) return pure1($ivFwO.unit);
            throw new Error("Failed pattern match at Control.Applicative (line 68, column 1 - line 68, column 65): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $89eee4fa6eb013bc$export$a55877ca9db47377 = function(dictApplicative) {
    var pure1 = $89eee4fa6eb013bc$export$48ec4a2b1cfc6557(dictApplicative);
    return function(v) {
        return function(v1) {
            if (v) return v1;
            if (!v) return pure1($ivFwO.unit);
            throw new Error("Failed pattern match at Control.Applicative (line 63, column 1 - line 63, column 63): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $89eee4fa6eb013bc$export$53544bd8de5a7427 = function(dictApplicative) {
    var apply = $26ZCq.apply(dictApplicative.Apply0());
    var pure1 = $89eee4fa6eb013bc$export$48ec4a2b1cfc6557(dictApplicative);
    return function(f) {
        return function(a) {
            return apply(pure1(f))(a);
        };
    };
};
var $89eee4fa6eb013bc$export$598532d07e20ffc2 = {
    pure: function(v) {
        return $g13tD.Proxy.value;
    },
    Apply0: function() {
        return $26ZCq.applyProxy;
    }
};
var $89eee4fa6eb013bc$export$e68c32b2a06f106c = {
    pure: function(x) {
        return function(v) {
            return x;
        };
    },
    Apply0: function() {
        return $26ZCq.applyFn;
    }
};
var $89eee4fa6eb013bc$export$8f0ac76856b1d87e = {
    pure: function(x) {
        return [
            x
        ];
    },
    Apply0: function() {
        return $26ZCq.applyArray;
    }
};

});
parcelRegister("26ZCq", function(module, exports) {

$parcel$export(module.exports, "applyProxy", () => $189bf0864ea6e9d6$export$e24166bf2f1a6c73);
$parcel$export(module.exports, "applyFn", () => $189bf0864ea6e9d6$export$2f68caa5c730775d);
$parcel$export(module.exports, "applyArray", () => $189bf0864ea6e9d6$export$60d7bd9d686a5521);
$parcel$export(module.exports, "apply", () => $189bf0864ea6e9d6$export$5635d7ef4b8fee1c);
$parcel$export(module.exports, "applySecond", () => $189bf0864ea6e9d6$export$3d5d566a030a20fc);
$parcel$export(module.exports, "lift2", () => $189bf0864ea6e9d6$export$f016650e64b51e7d);
// Generated by purs version 0.15.16

var $bPXvl = parcelRequire("bPXvl");

var $26SV5 = parcelRequire("26SV5");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $g13tD = parcelRequire("g13tD");
var $189bf0864ea6e9d6$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $189bf0864ea6e9d6$export$e24166bf2f1a6c73 = {
    apply: function(v) {
        return function(v1) {
            return $g13tD.Proxy.value;
        };
    },
    Functor0: function() {
        return $7FzSN.functorProxy;
    }
};
var $189bf0864ea6e9d6$export$2f68caa5c730775d = {
    apply: function(f) {
        return function(g) {
            return function(x) {
                return f(x)(g(x));
            };
        };
    },
    Functor0: function() {
        return $7FzSN.functorFn;
    }
};
var $189bf0864ea6e9d6$export$60d7bd9d686a5521 = {
    apply: $bPXvl.arrayApply,
    Functor0: function() {
        return $7FzSN.functorArray;
    }
};
var $189bf0864ea6e9d6$export$5635d7ef4b8fee1c = function(dict) {
    return dict.apply;
};
var $189bf0864ea6e9d6$export$e48e2da4536c2eea = function(dictApply) {
    var apply1 = $189bf0864ea6e9d6$export$5635d7ef4b8fee1c(dictApply);
    var map = $7FzSN.map(dictApply.Functor0());
    return function(a) {
        return function(b) {
            return apply1(map($jhsiw.const)(a))(b);
        };
    };
};
var $189bf0864ea6e9d6$export$3d5d566a030a20fc = function(dictApply) {
    var apply1 = $189bf0864ea6e9d6$export$5635d7ef4b8fee1c(dictApply);
    var map = $7FzSN.map(dictApply.Functor0());
    return function(a) {
        return function(b) {
            return apply1(map($jhsiw.const($189bf0864ea6e9d6$var$identity))(a))(b);
        };
    };
};
var $189bf0864ea6e9d6$export$f016650e64b51e7d = function(dictApply) {
    var apply1 = $189bf0864ea6e9d6$export$5635d7ef4b8fee1c(dictApply);
    var map = $7FzSN.map(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return apply1(map(f)(a))(b);
            };
        };
    };
};
var $189bf0864ea6e9d6$export$30190e46300cc996 = function(dictApply) {
    var apply1 = $189bf0864ea6e9d6$export$5635d7ef4b8fee1c(dictApply);
    var map = $7FzSN.map(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return apply1(apply1(map(f)(a))(b))(c);
                };
            };
        };
    };
};
var $189bf0864ea6e9d6$export$6659660f0e855aea = function(dictApply) {
    var apply1 = $189bf0864ea6e9d6$export$5635d7ef4b8fee1c(dictApply);
    var map = $7FzSN.map(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return function(d) {
                        return apply1(apply1(apply1(map(f)(a))(b))(c))(d);
                    };
                };
            };
        };
    };
};
var $189bf0864ea6e9d6$export$6c80f2f7f1ad8105 = function(dictApply) {
    var apply1 = $189bf0864ea6e9d6$export$5635d7ef4b8fee1c(dictApply);
    var map = $7FzSN.map(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return function(d) {
                        return function(e) {
                            return apply1(apply1(apply1(apply1(map(f)(a))(b))(c))(d))(e);
                        };
                    };
                };
            };
        };
    };
};

});
parcelRegister("bPXvl", function(module, exports) {

$parcel$export(module.exports, "arrayApply", () => $89e29d8504bad11a$export$4add775dfee37121);
const $89e29d8504bad11a$export$4add775dfee37121 = function(fs) {
    return function(xs) {
        var l = fs.length;
        var k = xs.length;
        var result = new Array(l * k);
        var n = 0;
        for(var i = 0; i < l; i++){
            var f = fs[i];
            for(var j = 0; j < k; j++)result[n++] = f(xs[j]);
        }
        return result;
    };
};

});

parcelRegister("26SV5", function(module, exports) {

$parcel$export(module.exports, "identity", () => $1896be37818a7915$export$f0954fd7d5368655);
$parcel$export(module.exports, "categoryFn", () => $1896be37818a7915$export$7037e3b2ba3bd7aa);
// Generated by purs version 0.15.16

var $gZ030 = parcelRequire("gZ030");
var $1896be37818a7915$export$f0954fd7d5368655 = function(dict) {
    return dict.identity;
};
var $1896be37818a7915$export$7037e3b2ba3bd7aa = {
    identity: function(x) {
        return x;
    },
    Semigroupoid0: function() {
        return $gZ030.semigroupoidFn;
    }
};

});
parcelRegister("gZ030", function(module, exports) {

$parcel$export(module.exports, "semigroupoidFn", () => $c5d26143dbfb44fe$export$3af17640bddf7212);
$parcel$export(module.exports, "compose", () => $c5d26143dbfb44fe$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "composeFlipped", () => $c5d26143dbfb44fe$export$b5a9558a7176e41b);
// Generated by purs version 0.15.16
var $c5d26143dbfb44fe$export$3af17640bddf7212 = {
    compose: function(f) {
        return function(g) {
            return function(x) {
                return f(g(x));
            };
        };
    }
};
var $c5d26143dbfb44fe$export$f672e0b6f7222cd7 = function(dict) {
    return dict.compose;
};
var $c5d26143dbfb44fe$export$b5a9558a7176e41b = function(dictSemigroupoid) {
    var compose1 = $c5d26143dbfb44fe$export$f672e0b6f7222cd7(dictSemigroupoid);
    return function(f) {
        return function(g) {
            return compose1(g)(f);
        };
    };
};

});


parcelRegister("jhsiw", function(module, exports) {

$parcel$export(module.exports, "on", () => $e0958e2d5c3d5881$export$af631764ddc44097);
$parcel$export(module.exports, "flip", () => $e0958e2d5c3d5881$export$8a83211c878a3f1f);
$parcel$export(module.exports, "const", () => $e0958e2d5c3d5881$export$5b38a098e5a9e7ca);
$parcel$export(module.exports, "applyFlipped", () => $e0958e2d5c3d5881$export$5f9c390da86b6e49);
// Generated by purs version 0.15.16

var $26SV5 = parcelRequire("26SV5");

var $iQTlW = parcelRequire("iQTlW");
var $e0958e2d5c3d5881$export$af631764ddc44097 = function(f) {
    return function(g) {
        return function(x) {
            return function(y) {
                return f(g(x))(g(y));
            };
        };
    };
};
var $e0958e2d5c3d5881$export$8a83211c878a3f1f = function(f) {
    return function(b) {
        return function(a) {
            return f(a)(b);
        };
    };
};
var $e0958e2d5c3d5881$export$5b38a098e5a9e7ca = function(a) {
    return function(v) {
        return a;
    };
};
var $e0958e2d5c3d5881$export$32c25ff0a0410173 = function(f) {
    var go = function($copy_n) {
        return function($copy_acc) {
            var $tco_var_n = $copy_n;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(n, acc) {
                if (n <= 0) {
                    $tco_done = true;
                    return acc;
                }
                if ($iQTlW.otherwise) {
                    $tco_var_n = n - 1 | 0;
                    $copy_acc = f(acc);
                    return;
                }
                throw new Error("Failed pattern match at Data.Function (line 107, column 3 - line 109, column 37): " + [
                    n.constructor.name,
                    acc.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_n, $copy_acc);
            return $tco_result;
        };
    };
    return go;
};
var $e0958e2d5c3d5881$export$5f9c390da86b6e49 = function(x) {
    return function(f) {
        return f(x);
    };
};
var $e0958e2d5c3d5881$export$5635d7ef4b8fee1c = function(f) {
    return function(x) {
        return f(x);
    };
};

});
parcelRegister("iQTlW", function(module, exports) {

$parcel$export(module.exports, "otherwise", () => $db98053c75d1e348$export$4bed41887d8c5096);
// Generated by purs version 0.15.16
var $db98053c75d1e348$export$4bed41887d8c5096 = true;

});


parcelRegister("7FzSN", function(module, exports) {

$parcel$export(module.exports, "map", () => $5958325713d42282$export$871de8747c9eaa88);
$parcel$export(module.exports, "mapFlipped", () => $5958325713d42282$export$5c8c64e4bc0bcb7a);
$parcel$export(module.exports, "void", () => $5958325713d42282$export$490e536ee7389aeb);
$parcel$export(module.exports, "voidLeft", () => $5958325713d42282$export$6775eb02dd4c5e2a);
$parcel$export(module.exports, "voidRight", () => $5958325713d42282$export$b818c54ed8d3e90a);
$parcel$export(module.exports, "functorProxy", () => $5958325713d42282$export$816e5e05deb8955e);
$parcel$export(module.exports, "functorFn", () => $5958325713d42282$export$11c8d16a3c15d11b);
$parcel$export(module.exports, "functorArray", () => $5958325713d42282$export$2330f868b62ed546);
// Generated by purs version 0.15.16

var $kMhwP = parcelRequire("kMhwP");

var $gZ030 = parcelRequire("gZ030");

var $jhsiw = parcelRequire("jhsiw");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");

var $g13tD = parcelRequire("g13tD");
var $5958325713d42282$export$871de8747c9eaa88 = function(dict) {
    return dict.map;
};
var $5958325713d42282$export$5c8c64e4bc0bcb7a = function(dictFunctor) {
    var map1 = $5958325713d42282$export$871de8747c9eaa88(dictFunctor);
    return function(fa) {
        return function(f) {
            return map1(f)(fa);
        };
    };
};
var $5958325713d42282$export$490e536ee7389aeb = function(dictFunctor) {
    return $5958325713d42282$export$871de8747c9eaa88(dictFunctor)($jhsiw.const($ivFwO.unit));
};
var $5958325713d42282$export$6775eb02dd4c5e2a = function(dictFunctor) {
    var map1 = $5958325713d42282$export$871de8747c9eaa88(dictFunctor);
    return function(f) {
        return function(x) {
            return map1($jhsiw.const(x))(f);
        };
    };
};
var $5958325713d42282$export$b818c54ed8d3e90a = function(dictFunctor) {
    var map1 = $5958325713d42282$export$871de8747c9eaa88(dictFunctor);
    return function(x) {
        return map1($jhsiw.const(x));
    };
};
var $5958325713d42282$export$816e5e05deb8955e = {
    map: function(v) {
        return function(v1) {
            return $g13tD.Proxy.value;
        };
    }
};
var $5958325713d42282$export$11c8d16a3c15d11b = {
    map: /* #__PURE__ */ $gZ030.compose($gZ030.semigroupoidFn)
};
var $5958325713d42282$export$2330f868b62ed546 = {
    map: $kMhwP.arrayMap
};
var $5958325713d42282$export$18c957606d8bdf09 = function(dictFunctor) {
    var map1 = $5958325713d42282$export$871de8747c9eaa88(dictFunctor);
    return function(ff) {
        return function(x) {
            return map1(function(f) {
                return f(x);
            })(ff);
        };
    };
};

});
parcelRegister("kMhwP", function(module, exports) {

$parcel$export(module.exports, "arrayMap", () => $f205e32026e39501$export$dc30017ac4432edc);
const $f205e32026e39501$export$dc30017ac4432edc = function(f) {
    return function(arr) {
        var l = arr.length;
        var result = new Array(l);
        for(var i = 0; i < l; i++)result[i] = f(arr[i]);
        return result;
    };
};

});

parcelRegister("2jM6U", function(module, exports) {

$parcel$export(module.exports, "unit", () => (parcelRequire("ivFwO")).unit);
// Generated by purs version 0.15.16

var $ivFwO = parcelRequire("ivFwO");

});
parcelRegister("ivFwO", function(module, exports) {

$parcel$export(module.exports, "unit", () => $d79b55df67957793$export$523c0b569236b342);
const $d79b55df67957793$export$523c0b569236b342 = undefined;

});


parcelRegister("g13tD", function(module, exports) {

$parcel$export(module.exports, "Proxy", () => $03025041379443b9$export$accffb5fb4579e0d);
// Generated by purs version 0.15.16
var $03025041379443b9$export$accffb5fb4579e0d = /* #__PURE__ */ function() {
    function $$Proxy() {}
    $$Proxy.value = new $$Proxy();
    return $$Proxy;
}();

});




parcelRegister("cADnC", function(module, exports) {

$parcel$export(module.exports, "discard", () => $92a764da4342ca29$export$584af591d945b55a);
$parcel$export(module.exports, "bindProxy", () => $92a764da4342ca29$export$6dbdf4766af04452);
$parcel$export(module.exports, "bindFn", () => $92a764da4342ca29$export$2c348afe2becdb4f);
$parcel$export(module.exports, "bindArray", () => $92a764da4342ca29$export$794f9574ca20b986);
$parcel$export(module.exports, "bind", () => $92a764da4342ca29$export$2385a24977818dd0);
$parcel$export(module.exports, "bindFlipped", () => $92a764da4342ca29$export$f2077a1c19a006d9);
$parcel$export(module.exports, "composeKleisliFlipped", () => $92a764da4342ca29$export$ea9fbbe247ef8e50);
$parcel$export(module.exports, "composeKleisli", () => $92a764da4342ca29$export$61a2047e1b1e0d3e);
$parcel$export(module.exports, "discardUnit", () => $92a764da4342ca29$export$f73711e565ded7e);
$parcel$export(module.exports, "join", () => $92a764da4342ca29$export$f7e2c8231c57a8bd);
// Generated by purs version 0.15.16

var $kFzRn = parcelRequire("kFzRn");

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $26SV5 = parcelRequire("26SV5");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $g13tD = parcelRequire("g13tD");
var $92a764da4342ca29$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $92a764da4342ca29$export$584af591d945b55a = function(dict) {
    return dict.discard;
};
var $92a764da4342ca29$export$6dbdf4766af04452 = {
    bind: function(v) {
        return function(v1) {
            return $g13tD.Proxy.value;
        };
    },
    Apply0: function() {
        return $26ZCq.applyProxy;
    }
};
var $92a764da4342ca29$export$2c348afe2becdb4f = {
    bind: function(m) {
        return function(f) {
            return function(x) {
                return f(m(x))(x);
            };
        };
    },
    Apply0: function() {
        return $26ZCq.applyFn;
    }
};
var $92a764da4342ca29$export$794f9574ca20b986 = {
    bind: $kFzRn.arrayBind,
    Apply0: function() {
        return $26ZCq.applyArray;
    }
};
var $92a764da4342ca29$export$2385a24977818dd0 = function(dict) {
    return dict.bind;
};
var $92a764da4342ca29$export$f2077a1c19a006d9 = function(dictBind) {
    return $jhsiw.flip($92a764da4342ca29$export$2385a24977818dd0(dictBind));
};
var $92a764da4342ca29$export$ea9fbbe247ef8e50 = function(dictBind) {
    var bindFlipped1 = $92a764da4342ca29$export$f2077a1c19a006d9(dictBind);
    return function(f) {
        return function(g) {
            return function(a) {
                return bindFlipped1(f)(g(a));
            };
        };
    };
};
var $92a764da4342ca29$export$61a2047e1b1e0d3e = function(dictBind) {
    var bind1 = $92a764da4342ca29$export$2385a24977818dd0(dictBind);
    return function(f) {
        return function(g) {
            return function(a) {
                return bind1(f(a))(g);
            };
        };
    };
};
var $92a764da4342ca29$export$9a012077684d4c76 = {
    discard: function(dictBind) {
        return $92a764da4342ca29$export$2385a24977818dd0(dictBind);
    }
};
var $92a764da4342ca29$export$f73711e565ded7e = {
    discard: function(dictBind) {
        return $92a764da4342ca29$export$2385a24977818dd0(dictBind);
    }
};
var $92a764da4342ca29$export$2937bb6ffdfdda28 = function(dictBind) {
    var bind1 = $92a764da4342ca29$export$2385a24977818dd0(dictBind);
    return function(cond) {
        return function(t) {
            return function(f) {
                return bind1(cond)(function(cond$prime) {
                    if (cond$prime) return t;
                    return f;
                });
            };
        };
    };
};
var $92a764da4342ca29$export$f7e2c8231c57a8bd = function(dictBind) {
    var bind1 = $92a764da4342ca29$export$2385a24977818dd0(dictBind);
    return function(m) {
        return bind1(m)($92a764da4342ca29$var$identity);
    };
};

});
parcelRegister("kFzRn", function(module, exports) {

$parcel$export(module.exports, "arrayBind", () => $f0c37402300fd38a$export$4d853d3353098e5a);
const $f0c37402300fd38a$export$4d853d3353098e5a = function(arr) {
    return function(f) {
        var result = [];
        for(var i = 0, l = arr.length; i < l; i++)Array.prototype.push.apply(result, f(arr[i]));
        return result;
    };
};

});


parcelRegister("beQI1", function(module, exports) {

$parcel$export(module.exports, "Left", () => $82e9e36957344565$export$37c4d04eafdc5515);
$parcel$export(module.exports, "Right", () => $82e9e36957344565$export$19db0165690c701a);
$parcel$export(module.exports, "functorEither", () => $82e9e36957344565$export$f0a413d3d6075601);
$parcel$export(module.exports, "ordEither", () => $82e9e36957344565$export$f105364bfbaa033b);
$parcel$export(module.exports, "either", () => $82e9e36957344565$export$5f5be1bb6cd1fded);
$parcel$export(module.exports, "hush", () => $82e9e36957344565$export$3a6c138b8d0f3874);
$parcel$export(module.exports, "bindEither", () => $82e9e36957344565$export$3806e10d0c441ac5);
$parcel$export(module.exports, "applicativeEither", () => $82e9e36957344565$export$400f1ef3f3ec304d);
$parcel$export(module.exports, "monadEither", () => $82e9e36957344565$export$b3b4ecb28e3a8df3);
// Generated by purs version 0.15.16

var $56VjJ = parcelRequire("56VjJ");

var $26ZCq = parcelRequire("26ZCq");

var $8zsOy = parcelRequire("8zsOy");

var $aJhEx = parcelRequire("aJhEx");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $7nwca = parcelRequire("7nwca");

var $ebQYe = parcelRequire("ebQYe");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $d5vvq = parcelRequire("d5vvq");

var $2XxiF = parcelRequire("2XxiF");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
var $82e9e36957344565$export$37c4d04eafdc5515 = /* #__PURE__ */ function() {
    function Left(value0) {
        this.value0 = value0;
    }
    Left.create = function(value0) {
        return new Left(value0);
    };
    return Left;
}();
var $82e9e36957344565$export$19db0165690c701a = /* #__PURE__ */ function() {
    function Right(value0) {
        this.value0 = value0;
    }
    Right.create = function(value0) {
        return new Right(value0);
    };
    return Right;
}();
var $82e9e36957344565$export$37ab35e89b41eda = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return function(dictShow1) {
        var show1 = $2XxiF.show(dictShow1);
        return {
            show: function(v) {
                if (v instanceof $82e9e36957344565$export$37c4d04eafdc5515) return "(Left " + (show(v.value0) + ")");
                if (v instanceof $82e9e36957344565$export$19db0165690c701a) return "(Right " + (show1(v.value0) + ")");
                throw new Error("Failed pattern match at Data.Either (line 173, column 1 - line 175, column 46): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $82e9e36957344565$export$e29cdc8bc2cafc59 = function(f) {
    return $h2xUu.maybe$prime(function($138) {
        return $82e9e36957344565$export$37c4d04eafdc5515.create(f($138));
    })($82e9e36957344565$export$19db0165690c701a.create);
};
var $82e9e36957344565$export$a92e4c44d367d0af = function(a) {
    return $h2xUu.maybe(new $82e9e36957344565$export$37c4d04eafdc5515(a))($82e9e36957344565$export$19db0165690c701a.create);
};
var $82e9e36957344565$export$72a1c23d752d2155 = {
    to: function(x) {
        if (x instanceof $ebQYe.Inl) return new $82e9e36957344565$export$37c4d04eafdc5515(x.value0);
        if (x instanceof $ebQYe.Inr) return new $82e9e36957344565$export$19db0165690c701a(x.value0);
        throw new Error("Failed pattern match at Data.Either (line 33, column 1 - line 33, column 56): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $82e9e36957344565$export$37c4d04eafdc5515) return new $ebQYe.Inl(x.value0);
        if (x instanceof $82e9e36957344565$export$19db0165690c701a) return new $ebQYe.Inr(x.value0);
        throw new Error("Failed pattern match at Data.Either (line 33, column 1 - line 33, column 56): " + [
            x.constructor.name
        ]);
    }
};
var $82e9e36957344565$export$f0a413d3d6075601 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $82e9e36957344565$export$37c4d04eafdc5515) return new $82e9e36957344565$export$37c4d04eafdc5515(m.value0);
            if (m instanceof $82e9e36957344565$export$19db0165690c701a) return new $82e9e36957344565$export$19db0165690c701a(f(m.value0));
            throw new Error("Failed pattern match at Data.Either (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $82e9e36957344565$var$map = /* #__PURE__ */ $7FzSN.map($82e9e36957344565$export$f0a413d3d6075601);
var $82e9e36957344565$export$26473b852950cc9f = {
    imap: /* #__PURE__ */ $7nwca.imapF($82e9e36957344565$export$f0a413d3d6075601)
};
var $82e9e36957344565$export$f41f6e6ed5e42617 = function(v) {
    return function(v1) {
        if (v1 instanceof $82e9e36957344565$export$19db0165690c701a) return v1.value0;
        return v($ivFwO.unit);
    };
};
var $82e9e36957344565$export$27d3ca2b5d864fdd = function(v) {
    return function(v1) {
        if (v1 instanceof $82e9e36957344565$export$19db0165690c701a) return v1.value0;
        return v;
    };
};
var $82e9e36957344565$export$a6bf632a63e8a255 = function(v) {
    return function(v1) {
        if (v1 instanceof $82e9e36957344565$export$37c4d04eafdc5515) return v1.value0;
        return v($ivFwO.unit);
    };
};
var $82e9e36957344565$export$ed20f362be8f8b52 = function(v) {
    return function(v1) {
        if (v1 instanceof $82e9e36957344565$export$37c4d04eafdc5515) return v1.value0;
        return v;
    };
};
var $82e9e36957344565$export$d6a44bcd37031227 = {
    extend: function(v) {
        return function(v1) {
            if (v1 instanceof $82e9e36957344565$export$37c4d04eafdc5515) return new $82e9e36957344565$export$37c4d04eafdc5515(v1.value0);
            return new $82e9e36957344565$export$19db0165690c701a(v(v1));
        };
    },
    Functor0: function() {
        return $82e9e36957344565$export$f0a413d3d6075601;
    }
};
var $82e9e36957344565$export$bde8fea66b0f9f9a = function(dictEq) {
    var eq = $aJhEx.eq(dictEq);
    return function(dictEq1) {
        var eq1 = $aJhEx.eq(dictEq1);
        return {
            eq: function(x) {
                return function(y) {
                    if (x instanceof $82e9e36957344565$export$37c4d04eafdc5515 && y instanceof $82e9e36957344565$export$37c4d04eafdc5515) return eq(x.value0)(y.value0);
                    if (x instanceof $82e9e36957344565$export$19db0165690c701a && y instanceof $82e9e36957344565$export$19db0165690c701a) return eq1(x.value0)(y.value0);
                    return false;
                };
            }
        };
    };
};
var $82e9e36957344565$export$f105364bfbaa033b = function(dictOrd) {
    var compare = $gwBF5.compare(dictOrd);
    var eqEither1 = $82e9e36957344565$export$bde8fea66b0f9f9a(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $gwBF5.compare(dictOrd1);
        var eqEither2 = eqEither1(dictOrd1.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    if (x instanceof $82e9e36957344565$export$37c4d04eafdc5515 && y instanceof $82e9e36957344565$export$37c4d04eafdc5515) return compare(x.value0)(y.value0);
                    if (x instanceof $82e9e36957344565$export$37c4d04eafdc5515) return $ibsD5.LT.value;
                    if (y instanceof $82e9e36957344565$export$37c4d04eafdc5515) return $ibsD5.GT.value;
                    if (x instanceof $82e9e36957344565$export$19db0165690c701a && y instanceof $82e9e36957344565$export$19db0165690c701a) return compare1(x.value0)(y.value0);
                    throw new Error("Failed pattern match at Data.Either (line 0, column 0 - line 0, column 0): " + [
                        x.constructor.name,
                        y.constructor.name
                    ]);
                };
            },
            Eq0: function() {
                return eqEither2;
            }
        };
    };
};
var $82e9e36957344565$export$551ea40f4c230981 = function(dictEq) {
    var eqEither1 = $82e9e36957344565$export$bde8fea66b0f9f9a(dictEq);
    return {
        eq1: function(dictEq1) {
            return $aJhEx.eq(eqEither1(dictEq1));
        }
    };
};
var $82e9e36957344565$export$f4a01dc57c45522b = function(dictOrd) {
    var ordEither1 = $82e9e36957344565$export$f105364bfbaa033b(dictOrd);
    var eq1Either1 = $82e9e36957344565$export$551ea40f4c230981(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return $gwBF5.compare(ordEither1(dictOrd1));
        },
        Eq10: function() {
            return eq1Either1;
        }
    };
};
var $82e9e36957344565$export$5f5be1bb6cd1fded = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $82e9e36957344565$export$37c4d04eafdc5515) return v(v2.value0);
            if (v2 instanceof $82e9e36957344565$export$19db0165690c701a) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Either (line 208, column 1 - line 208, column 64): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $82e9e36957344565$export$3a6c138b8d0f3874 = /* #__PURE__ */ function() {
    return $82e9e36957344565$export$5f5be1bb6cd1fded($jhsiw.const($h2xUu.Nothing.value))($h2xUu.Just.create);
}();
var $82e9e36957344565$export$d649b6842e09f2b = /* #__PURE__ */ $82e9e36957344565$export$5f5be1bb6cd1fded(/* #__PURE__ */ $jhsiw.const(true))(/* #__PURE__ */ $jhsiw.const(false));
var $82e9e36957344565$export$a9d71693f0c1a85d = /* #__PURE__ */ $82e9e36957344565$export$5f5be1bb6cd1fded(/* #__PURE__ */ $jhsiw.const(false))(/* #__PURE__ */ $jhsiw.const(true));
var $82e9e36957344565$export$7877a478dd30fd3d = function(dictAlt) {
    var alt = $56VjJ.alt(dictAlt);
    var map1 = $7FzSN.map(dictAlt.Functor0());
    return function(a) {
        return function(b) {
            return alt(map1($82e9e36957344565$export$37c4d04eafdc5515.create)(a))(map1($82e9e36957344565$export$19db0165690c701a.create)(b));
        };
    };
};
var $82e9e36957344565$export$39ea3c8fac814734 = function(dictBounded) {
    var bottom = $8zsOy.bottom(dictBounded);
    var ordEither1 = $82e9e36957344565$export$f105364bfbaa033b(dictBounded.Ord0());
    return function(dictBounded1) {
        var ordEither2 = ordEither1(dictBounded1.Ord0());
        return {
            top: new $82e9e36957344565$export$19db0165690c701a($8zsOy.top(dictBounded1)),
            bottom: new $82e9e36957344565$export$37c4d04eafdc5515(bottom),
            Ord0: function() {
                return ordEither2;
            }
        };
    };
};
var $82e9e36957344565$export$521d8864384143c6 = /* #__PURE__ */ function() {
    return $82e9e36957344565$export$5f5be1bb6cd1fded($h2xUu.Just.create)($jhsiw.const($h2xUu.Nothing.value));
}();
var $82e9e36957344565$export$d5df7cb019d08f04 = {
    apply: function(v) {
        return function(v1) {
            if (v instanceof $82e9e36957344565$export$37c4d04eafdc5515) return new $82e9e36957344565$export$37c4d04eafdc5515(v.value0);
            if (v instanceof $82e9e36957344565$export$19db0165690c701a) return $82e9e36957344565$var$map(v.value0)(v1);
            throw new Error("Failed pattern match at Data.Either (line 70, column 1 - line 72, column 30): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $82e9e36957344565$export$f0a413d3d6075601;
    }
};
var $82e9e36957344565$var$apply = /* #__PURE__ */ $26ZCq.apply($82e9e36957344565$export$d5df7cb019d08f04);
var $82e9e36957344565$export$3806e10d0c441ac5 = {
    bind: /* #__PURE__ */ $82e9e36957344565$export$5f5be1bb6cd1fded(function(e) {
        return function(v) {
            return new $82e9e36957344565$export$37c4d04eafdc5515(e);
        };
    })(function(a) {
        return function(f) {
            return f(a);
        };
    }),
    Apply0: function() {
        return $82e9e36957344565$export$d5df7cb019d08f04;
    }
};
var $82e9e36957344565$export$56cf4be43732c31d = function(dictSemigroup) {
    var append1 = $d5vvq.append(dictSemigroup);
    return {
        append: function(x) {
            return function(y) {
                return $82e9e36957344565$var$apply($82e9e36957344565$var$map(append1)(x))(y);
            };
        }
    };
};
var $82e9e36957344565$export$400f1ef3f3ec304d = /* #__PURE__ */ function() {
    return {
        pure: $82e9e36957344565$export$19db0165690c701a.create,
        Apply0: function() {
            return $82e9e36957344565$export$d5df7cb019d08f04;
        }
    };
}();
var $82e9e36957344565$export$b3b4ecb28e3a8df3 = {
    Applicative0: function() {
        return $82e9e36957344565$export$400f1ef3f3ec304d;
    },
    Bind1: function() {
        return $82e9e36957344565$export$3806e10d0c441ac5;
    }
};
var $82e9e36957344565$export$79ac44fe35dcf650 = {
    alt: function(v) {
        return function(v1) {
            if (v instanceof $82e9e36957344565$export$37c4d04eafdc5515) return v1;
            return v;
        };
    },
    Functor0: function() {
        return $82e9e36957344565$export$f0a413d3d6075601;
    }
};

});
parcelRegister("56VjJ", function(module, exports) {

$parcel$export(module.exports, "altArray", () => $3b89f9475babb12f$export$186d613bb872946c);
$parcel$export(module.exports, "alt", () => $3b89f9475babb12f$export$228be17d80722ab);
// Generated by purs version 0.15.16

var $7FzSN = parcelRequire("7FzSN");

var $d5vvq = parcelRequire("d5vvq");
var $3b89f9475babb12f$export$186d613bb872946c = {
    alt: /* #__PURE__ */ $d5vvq.append($d5vvq.semigroupArray),
    Functor0: function() {
        return $7FzSN.functorArray;
    }
};
var $3b89f9475babb12f$export$228be17d80722ab = function(dict) {
    return dict.alt;
};

});
parcelRegister("d5vvq", function(module, exports) {

$parcel$export(module.exports, "semigroupUnit", () => $98742e614f0f0f6e$export$824c37c4afd77b1);
$parcel$export(module.exports, "semigroupString", () => $98742e614f0f0f6e$export$d9b7100b101f2c5b);
$parcel$export(module.exports, "semigroupRecordNil", () => $98742e614f0f0f6e$export$955753116dc9242c);
$parcel$export(module.exports, "semigroupArray", () => $98742e614f0f0f6e$export$d082f07d0a8e9909);
$parcel$export(module.exports, "semigroupRecord", () => $98742e614f0f0f6e$export$dbfe6b321632d7c9);
$parcel$export(module.exports, "append", () => $98742e614f0f0f6e$export$10d8903dec122b9d);
$parcel$export(module.exports, "semigroupFn", () => $98742e614f0f0f6e$export$49c9dc4575956c55);
$parcel$export(module.exports, "semigroupRecordCons", () => $98742e614f0f0f6e$export$74eae24c3d2a7535);
// Generated by purs version 0.15.16

var $8Uf3w = parcelRequire("8Uf3w");

var $3Xcli = parcelRequire("3Xcli");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");

var $Hhp3L = parcelRequire("Hhp3L");
parcelRequire("lMTwl");
var $hV6x3 = parcelRequire("hV6x3");

var $g13tD = parcelRequire("g13tD");
var $98742e614f0f0f6e$export$36aabcd6b6e45f3b = {
    append: function(v) {
        return $Hhp3L.absurd;
    }
};
var $98742e614f0f0f6e$export$824c37c4afd77b1 = {
    append: function(v) {
        return function(v1) {
            return $ivFwO.unit;
        };
    }
};
var $98742e614f0f0f6e$export$d9b7100b101f2c5b = {
    append: $8Uf3w.concatString
};
var $98742e614f0f0f6e$export$955753116dc9242c = {
    appendRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    }
};
var $98742e614f0f0f6e$export$af5ddea0c4d23f3c = {
    append: function(v) {
        return function(v1) {
            return $g13tD.Proxy.value;
        };
    }
};
var $98742e614f0f0f6e$export$d082f07d0a8e9909 = {
    append: $8Uf3w.concatArray
};
var $98742e614f0f0f6e$export$1e8e5e81637c934d = function(dict) {
    return dict.appendRecord;
};
var $98742e614f0f0f6e$export$dbfe6b321632d7c9 = function() {
    return function(dictSemigroupRecord) {
        return {
            append: $98742e614f0f0f6e$export$1e8e5e81637c934d(dictSemigroupRecord)($g13tD.Proxy.value)
        };
    };
};
var $98742e614f0f0f6e$export$10d8903dec122b9d = function(dict) {
    return dict.append;
};
var $98742e614f0f0f6e$export$49c9dc4575956c55 = function(dictSemigroup) {
    var append1 = $98742e614f0f0f6e$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(f) {
            return function(g) {
                return function(x) {
                    return append1(f(x))(g(x));
                };
            };
        }
    };
};
var $98742e614f0f0f6e$export$74eae24c3d2a7535 = function(dictIsSymbol) {
    var reflectSymbol = $3Xcli.reflectSymbol(dictIsSymbol);
    return function() {
        return function(dictSemigroupRecord) {
            var appendRecord1 = $98742e614f0f0f6e$export$1e8e5e81637c934d(dictSemigroupRecord);
            return function(dictSemigroup) {
                var append1 = $98742e614f0f0f6e$export$10d8903dec122b9d(dictSemigroup);
                return {
                    appendRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = appendRecord1($g13tD.Proxy.value)(ra)(rb);
                                var key = reflectSymbol($g13tD.Proxy.value);
                                var insert = $hV6x3.unsafeSet(key);
                                var get = $hV6x3.unsafeGet(key);
                                return insert(append1(get(ra))(get(rb)))(tail);
                            };
                        };
                    }
                };
            };
        };
    };
};

});
parcelRegister("8Uf3w", function(module, exports) {

$parcel$export(module.exports, "concatString", () => $67bf3b73e07caf71$export$171e7edd26203a84);
$parcel$export(module.exports, "concatArray", () => $67bf3b73e07caf71$export$4fd8af2c48c43416);
const $67bf3b73e07caf71$export$171e7edd26203a84 = function(s1) {
    return function(s2) {
        return s1 + s2;
    };
};
const $67bf3b73e07caf71$export$4fd8af2c48c43416 = function(xs) {
    return function(ys) {
        if (xs.length === 0) return ys;
        if (ys.length === 0) return xs;
        return xs.concat(ys);
    };
};

});

parcelRegister("3Xcli", function(module, exports) {

$parcel$export(module.exports, "reflectSymbol", () => $2e1074c3ca41b8ac$export$e5ed8a20a1c4d576);
// Generated by purs version 0.15.16

var $a67R6 = parcelRequire("a67R6");

var $g13tD = parcelRequire("g13tD");
var $2e1074c3ca41b8ac$export$340e995c37375b7a = function(s) {
    return function(f) {
        return $a67R6.unsafeCoerce(function(dictIsSymbol) {
            return f(dictIsSymbol);
        })({
            reflectSymbol: function(v) {
                return s;
            }
        })($g13tD.Proxy.value);
    };
};
var $2e1074c3ca41b8ac$export$e5ed8a20a1c4d576 = function(dict) {
    return dict.reflectSymbol;
};

});
parcelRegister("a67R6", function(module, exports) {

$parcel$export(module.exports, "unsafeCoerce", () => $75a08edc431f31bf$export$401372c57776dc);
// module Data.Symbol
const $75a08edc431f31bf$export$401372c57776dc = function(arg) {
    return arg;
};

});


parcelRegister("Hhp3L", function(module, exports) {

$parcel$export(module.exports, "absurd", () => $0821842d7ec0973a$export$f172309911142386);
// Generated by purs version 0.15.16
var $0821842d7ec0973a$var$Void = function(x) {
    return x;
};
var $0821842d7ec0973a$export$f172309911142386 = function(a) {
    var spin = function($copy_v) {
        var $tco_result;
        function $tco_loop(v) {
            $copy_v = v;
            return;
        }
        while(true)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return spin(a);
};

});

parcelRegister("lMTwl", function(module, exports) {

$parcel$export(module.exports, "unsafeGet", () => (parcelRequire("hV6x3")).unsafeGet);
$parcel$export(module.exports, "unsafeSet", () => (parcelRequire("hV6x3")).unsafeSet);
// Generated by purs version 0.15.16

var $hV6x3 = parcelRequire("hV6x3");

});
parcelRegister("hV6x3", function(module, exports) {

$parcel$export(module.exports, "unsafeGet", () => $d0bcd3b495a9d045$export$1d94535d2cda4eda);
$parcel$export(module.exports, "unsafeSet", () => $d0bcd3b495a9d045$export$444262986932b766);
const $d0bcd3b495a9d045$export$12c1b2b255bc527d = function(label) {
    return function(rec) {
        return ({}).hasOwnProperty.call(rec, label);
    };
};
const $d0bcd3b495a9d045$export$1d94535d2cda4eda = function(label) {
    return function(rec) {
        return rec[label];
    };
};
const $d0bcd3b495a9d045$export$444262986932b766 = function(label) {
    return function(value) {
        return function(rec) {
            var copy = {};
            for(var key in rec)if (({}).hasOwnProperty.call(rec, key)) copy[key] = rec[key];
            copy[label] = value;
            return copy;
        };
    };
};
const $d0bcd3b495a9d045$export$14b6a75b3eb38458 = function(label) {
    return function(rec) {
        var copy = {};
        for(var key in rec)if (key !== label && ({}).hasOwnProperty.call(rec, key)) copy[key] = rec[key];
        return copy;
    };
};

});




parcelRegister("8zsOy", function(module, exports) {

$parcel$export(module.exports, "top", () => $63d7f18df31fb2d5$export$1e95b668f3b82d);
$parcel$export(module.exports, "boundedUnit", () => $63d7f18df31fb2d5$export$48259b86288d7b58);
$parcel$export(module.exports, "boundedOrdering", () => $63d7f18df31fb2d5$export$2e0fd44408d4861);
$parcel$export(module.exports, "boundedInt", () => $63d7f18df31fb2d5$export$c84fa7e5ca2385dd);
$parcel$export(module.exports, "boundedChar", () => $63d7f18df31fb2d5$export$7cd7c97ac7ec5b79);
$parcel$export(module.exports, "boundedBoolean", () => $63d7f18df31fb2d5$export$b6c012947af8ebbc);
$parcel$export(module.exports, "bottom", () => $63d7f18df31fb2d5$export$40e543e69a8b3fbb);
// Generated by purs version 0.15.16

var $4ttqR = parcelRequire("4ttqR");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $3Xcli = parcelRequire("3Xcli");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
parcelRequire("lMTwl");
var $hV6x3 = parcelRequire("hV6x3");

var $g13tD = parcelRequire("g13tD");
var $63d7f18df31fb2d5$var$ordRecord = /* #__PURE__ */ $gwBF5.ordRecord();
var $63d7f18df31fb2d5$export$407dd25a598bb432 = function(dict) {
    return dict.topRecord;
};
var $63d7f18df31fb2d5$export$1e95b668f3b82d = function(dict) {
    return dict.top;
};
var $63d7f18df31fb2d5$export$48259b86288d7b58 = {
    top: $ivFwO.unit,
    bottom: $ivFwO.unit,
    Ord0: function() {
        return $gwBF5.ordUnit;
    }
};
var $63d7f18df31fb2d5$export$8978fddf7d98bede = {
    topRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    bottomRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    OrdRecord0: function() {
        return $gwBF5.ordRecordNil;
    }
};
var $63d7f18df31fb2d5$export$6001ef8e188ae2f5 = /* #__PURE__ */ function() {
    return {
        bottom: $g13tD.Proxy.value,
        top: $g13tD.Proxy.value,
        Ord0: function() {
            return $gwBF5.ordProxy;
        }
    };
}();
var $63d7f18df31fb2d5$export$2e0fd44408d4861 = /* #__PURE__ */ function() {
    return {
        top: $ibsD5.GT.value,
        bottom: $ibsD5.LT.value,
        Ord0: function() {
            return $gwBF5.ordOrdering;
        }
    };
}();
var $63d7f18df31fb2d5$export$5acaecf0b0cd5fa9 = {
    top: $4ttqR.topNumber,
    bottom: $4ttqR.bottomNumber,
    Ord0: function() {
        return $gwBF5.ordNumber;
    }
};
var $63d7f18df31fb2d5$export$c84fa7e5ca2385dd = {
    top: $4ttqR.topInt,
    bottom: $4ttqR.bottomInt,
    Ord0: function() {
        return $gwBF5.ordInt;
    }
};
var $63d7f18df31fb2d5$export$7cd7c97ac7ec5b79 = {
    top: $4ttqR.topChar,
    bottom: $4ttqR.bottomChar,
    Ord0: function() {
        return $gwBF5.ordChar;
    }
};
var $63d7f18df31fb2d5$export$b6c012947af8ebbc = {
    top: true,
    bottom: false,
    Ord0: function() {
        return $gwBF5.ordBoolean;
    }
};
var $63d7f18df31fb2d5$export$72232990c70f5e82 = function(dict) {
    return dict.bottomRecord;
};
var $63d7f18df31fb2d5$export$8d7db335b27db939 = function() {
    return function(dictBoundedRecord) {
        var ordRecord1 = $63d7f18df31fb2d5$var$ordRecord(dictBoundedRecord.OrdRecord0());
        return {
            top: $63d7f18df31fb2d5$export$407dd25a598bb432(dictBoundedRecord)($g13tD.Proxy.value)($g13tD.Proxy.value),
            bottom: $63d7f18df31fb2d5$export$72232990c70f5e82(dictBoundedRecord)($g13tD.Proxy.value)($g13tD.Proxy.value),
            Ord0: function() {
                return ordRecord1;
            }
        };
    };
};
var $63d7f18df31fb2d5$export$40e543e69a8b3fbb = function(dict) {
    return dict.bottom;
};
var $63d7f18df31fb2d5$export$53fc630a84ecc59b = function(dictIsSymbol) {
    var reflectSymbol = $3Xcli.reflectSymbol(dictIsSymbol);
    return function(dictBounded) {
        var top1 = $63d7f18df31fb2d5$export$1e95b668f3b82d(dictBounded);
        var bottom1 = $63d7f18df31fb2d5$export$40e543e69a8b3fbb(dictBounded);
        var Ord0 = dictBounded.Ord0();
        return function() {
            return function() {
                return function(dictBoundedRecord) {
                    var topRecord1 = $63d7f18df31fb2d5$export$407dd25a598bb432(dictBoundedRecord);
                    var bottomRecord1 = $63d7f18df31fb2d5$export$72232990c70f5e82(dictBoundedRecord);
                    var ordRecordCons = $gwBF5.ordRecordCons(dictBoundedRecord.OrdRecord0())()(dictIsSymbol)(Ord0);
                    return {
                        topRecord: function(v) {
                            return function(rowProxy) {
                                var tail = topRecord1($g13tD.Proxy.value)(rowProxy);
                                var key = reflectSymbol($g13tD.Proxy.value);
                                var insert = $hV6x3.unsafeSet(key);
                                return insert(top1)(tail);
                            };
                        },
                        bottomRecord: function(v) {
                            return function(rowProxy) {
                                var tail = bottomRecord1($g13tD.Proxy.value)(rowProxy);
                                var key = reflectSymbol($g13tD.Proxy.value);
                                var insert = $hV6x3.unsafeSet(key);
                                return insert(bottom1)(tail);
                            };
                        },
                        OrdRecord0: function() {
                            return ordRecordCons;
                        }
                    };
                };
            };
        };
    };
};

});
parcelRegister("4ttqR", function(module, exports) {

$parcel$export(module.exports, "topInt", () => $3420b37b9d1a97c5$export$afdd678689eb299);
$parcel$export(module.exports, "bottomInt", () => $3420b37b9d1a97c5$export$4a17ba08fd82d88b);
$parcel$export(module.exports, "topChar", () => $3420b37b9d1a97c5$export$4ffd3705721c8b5b);
$parcel$export(module.exports, "bottomChar", () => $3420b37b9d1a97c5$export$d6be889e229abd84);
$parcel$export(module.exports, "topNumber", () => $3420b37b9d1a97c5$export$ef55dfccfe3a15b);
$parcel$export(module.exports, "bottomNumber", () => $3420b37b9d1a97c5$export$d1edf35dfee544b5);
const $3420b37b9d1a97c5$export$afdd678689eb299 = 2147483647;
const $3420b37b9d1a97c5$export$4a17ba08fd82d88b = -2147483648;
const $3420b37b9d1a97c5$export$4ffd3705721c8b5b = String.fromCharCode(65535);
const $3420b37b9d1a97c5$export$d6be889e229abd84 = String.fromCharCode(0);
const $3420b37b9d1a97c5$export$ef55dfccfe3a15b = Number.POSITIVE_INFINITY;
const $3420b37b9d1a97c5$export$d1edf35dfee544b5 = Number.NEGATIVE_INFINITY;

});

parcelRegister("gwBF5", function(module, exports) {

$parcel$export(module.exports, "ordUnit", () => $c07cd952c329ea4b$export$f6b429625e3530b0);
$parcel$export(module.exports, "ordString", () => $c07cd952c329ea4b$export$c5f2758e49b2b86a);
$parcel$export(module.exports, "ordRecordNil", () => $c07cd952c329ea4b$export$927f7db8ecc0069f);
$parcel$export(module.exports, "ordProxy", () => $c07cd952c329ea4b$export$55c25d215527e8e8);
$parcel$export(module.exports, "ordOrdering", () => $c07cd952c329ea4b$export$dcb5533042a37f3c);
$parcel$export(module.exports, "ordNumber", () => $c07cd952c329ea4b$export$5ed021ff2336715c);
$parcel$export(module.exports, "ordInt", () => $c07cd952c329ea4b$export$ff461bf68e7dd332);
$parcel$export(module.exports, "ordChar", () => $c07cd952c329ea4b$export$3abd12c96be3b09b);
$parcel$export(module.exports, "ordBoolean", () => $c07cd952c329ea4b$export$ef759d57a4e44836);
$parcel$export(module.exports, "ordRecord", () => $c07cd952c329ea4b$export$ebb7a7956d139174);
$parcel$export(module.exports, "compare1", () => $c07cd952c329ea4b$export$693feb0c3c484b70);
$parcel$export(module.exports, "compare", () => $c07cd952c329ea4b$export$398604a469f7de9a);
$parcel$export(module.exports, "comparing", () => $c07cd952c329ea4b$export$e9509a298f6befc2);
$parcel$export(module.exports, "greaterThan", () => $c07cd952c329ea4b$export$f517ea36c68d4644);
$parcel$export(module.exports, "greaterThanOrEq", () => $c07cd952c329ea4b$export$4be320a4fd1ac499);
$parcel$export(module.exports, "lessThan", () => $c07cd952c329ea4b$export$9b050841a3a1b328);
$parcel$export(module.exports, "lessThanOrEq", () => $c07cd952c329ea4b$export$f0c1dc893917aeba);
$parcel$export(module.exports, "max", () => $c07cd952c329ea4b$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $c07cd952c329ea4b$export$96ec731ed4dcb222);
$parcel$export(module.exports, "ordArray", () => $c07cd952c329ea4b$export$6ace7ea8ac01a75e);
$parcel$export(module.exports, "ordRecordCons", () => $c07cd952c329ea4b$export$a9b387b18fb85611);
// Generated by purs version 0.15.16

var $6Mxvn = parcelRequire("6Mxvn");

var $aJhEx = parcelRequire("aJhEx");

var $ibsD5 = parcelRequire("ibsD5");

var $aop8q = parcelRequire("aop8q");

var $iVjQa = parcelRequire("iVjQa");

var $3Xcli = parcelRequire("3Xcli");
parcelRequire("lMTwl");
var $hV6x3 = parcelRequire("hV6x3");

var $g13tD = parcelRequire("g13tD");
var $c07cd952c329ea4b$var$eqRec = /* #__PURE__ */ $aJhEx.eqRec();
var $c07cd952c329ea4b$var$notEq = /* #__PURE__ */ $aJhEx.notEq($ibsD5.eqOrdering);
var $c07cd952c329ea4b$export$752cdd067643c910 = {
    compare: function(v) {
        return function(v1) {
            return $ibsD5.EQ.value;
        };
    },
    Eq0: function() {
        return $aJhEx.eqVoid;
    }
};
var $c07cd952c329ea4b$export$f6b429625e3530b0 = {
    compare: function(v) {
        return function(v1) {
            return $ibsD5.EQ.value;
        };
    },
    Eq0: function() {
        return $aJhEx.eqUnit;
    }
};
var $c07cd952c329ea4b$export$c5f2758e49b2b86a = /* #__PURE__ */ function() {
    return {
        compare: $6Mxvn.ordStringImpl($ibsD5.LT.value)($ibsD5.EQ.value)($ibsD5.GT.value),
        Eq0: function() {
            return $aJhEx.eqString;
        }
    };
}();
var $c07cd952c329ea4b$export$927f7db8ecc0069f = {
    compareRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return $ibsD5.EQ.value;
            };
        };
    },
    EqRecord0: function() {
        return $aJhEx.eqRowNil;
    }
};
var $c07cd952c329ea4b$export$55c25d215527e8e8 = {
    compare: function(v) {
        return function(v1) {
            return $ibsD5.EQ.value;
        };
    },
    Eq0: function() {
        return $aJhEx.eqProxy;
    }
};
var $c07cd952c329ea4b$export$dcb5533042a37f3c = {
    compare: function(v) {
        return function(v1) {
            if (v instanceof $ibsD5.LT && v1 instanceof $ibsD5.LT) return $ibsD5.EQ.value;
            if (v instanceof $ibsD5.EQ && v1 instanceof $ibsD5.EQ) return $ibsD5.EQ.value;
            if (v instanceof $ibsD5.GT && v1 instanceof $ibsD5.GT) return $ibsD5.EQ.value;
            if (v instanceof $ibsD5.LT) return $ibsD5.LT.value;
            if (v instanceof $ibsD5.EQ && v1 instanceof $ibsD5.LT) return $ibsD5.GT.value;
            if (v instanceof $ibsD5.EQ && v1 instanceof $ibsD5.GT) return $ibsD5.LT.value;
            if (v instanceof $ibsD5.GT) return $ibsD5.GT.value;
            throw new Error("Failed pattern match at Data.Ord (line 126, column 1 - line 133, column 20): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $ibsD5.eqOrdering;
    }
};
var $c07cd952c329ea4b$export$5ed021ff2336715c = /* #__PURE__ */ function() {
    return {
        compare: $6Mxvn.ordNumberImpl($ibsD5.LT.value)($ibsD5.EQ.value)($ibsD5.GT.value),
        Eq0: function() {
            return $aJhEx.eqNumber;
        }
    };
}();
var $c07cd952c329ea4b$export$ff461bf68e7dd332 = /* #__PURE__ */ function() {
    return {
        compare: $6Mxvn.ordIntImpl($ibsD5.LT.value)($ibsD5.EQ.value)($ibsD5.GT.value),
        Eq0: function() {
            return $aJhEx.eqInt;
        }
    };
}();
var $c07cd952c329ea4b$export$3abd12c96be3b09b = /* #__PURE__ */ function() {
    return {
        compare: $6Mxvn.ordCharImpl($ibsD5.LT.value)($ibsD5.EQ.value)($ibsD5.GT.value),
        Eq0: function() {
            return $aJhEx.eqChar;
        }
    };
}();
var $c07cd952c329ea4b$export$ef759d57a4e44836 = /* #__PURE__ */ function() {
    return {
        compare: $6Mxvn.ordBooleanImpl($ibsD5.LT.value)($ibsD5.EQ.value)($ibsD5.GT.value),
        Eq0: function() {
            return $aJhEx.eqBoolean;
        }
    };
}();
var $c07cd952c329ea4b$export$f595b73424c1647a = function(dict) {
    return dict.compareRecord;
};
var $c07cd952c329ea4b$export$ebb7a7956d139174 = function() {
    return function(dictOrdRecord) {
        var eqRec1 = $c07cd952c329ea4b$var$eqRec(dictOrdRecord.EqRecord0());
        return {
            compare: $c07cd952c329ea4b$export$f595b73424c1647a(dictOrdRecord)($g13tD.Proxy.value),
            Eq0: function() {
                return eqRec1;
            }
        };
    };
};
var $c07cd952c329ea4b$export$693feb0c3c484b70 = function(dict) {
    return dict.compare1;
};
var $c07cd952c329ea4b$export$398604a469f7de9a = function(dict) {
    return dict.compare;
};
var $c07cd952c329ea4b$var$compare2 = /* #__PURE__ */ $c07cd952c329ea4b$export$398604a469f7de9a($c07cd952c329ea4b$export$ff461bf68e7dd332);
var $c07cd952c329ea4b$export$e9509a298f6befc2 = function(dictOrd) {
    var compare3 = $c07cd952c329ea4b$export$398604a469f7de9a(dictOrd);
    return function(f) {
        return function(x) {
            return function(y) {
                return compare3(f(x))(f(y));
            };
        };
    };
};
var $c07cd952c329ea4b$export$f517ea36c68d4644 = function(dictOrd) {
    var compare3 = $c07cd952c329ea4b$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $ibsD5.GT) return true;
            return false;
        };
    };
};
var $c07cd952c329ea4b$export$4be320a4fd1ac499 = function(dictOrd) {
    var compare3 = $c07cd952c329ea4b$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $ibsD5.LT) return false;
            return true;
        };
    };
};
var $c07cd952c329ea4b$export$9b050841a3a1b328 = function(dictOrd) {
    var compare3 = $c07cd952c329ea4b$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $ibsD5.LT) return true;
            return false;
        };
    };
};
var $c07cd952c329ea4b$export$23e3e2011c250f0f = function(dictOrd) {
    var lessThan1 = $c07cd952c329ea4b$export$9b050841a3a1b328(dictOrd);
    var greaterThan1 = $c07cd952c329ea4b$export$f517ea36c68d4644(dictOrd);
    return function(dictRing) {
        var Semiring0 = dictRing.Semiring0();
        var zero = $iVjQa.zero(Semiring0);
        var negate1 = $aop8q.negate(dictRing);
        var one = $iVjQa.one(Semiring0);
        return function(x) {
            var $89 = lessThan1(x)(zero);
            if ($89) return negate1(one);
            var $90 = greaterThan1(x)(zero);
            if ($90) return one;
            return x;
        };
    };
};
var $c07cd952c329ea4b$export$f0c1dc893917aeba = function(dictOrd) {
    var compare3 = $c07cd952c329ea4b$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $ibsD5.GT) return false;
            return true;
        };
    };
};
var $c07cd952c329ea4b$export$8960430cfd85939f = function(dictOrd) {
    var compare3 = $c07cd952c329ea4b$export$398604a469f7de9a(dictOrd);
    return function(x) {
        return function(y) {
            var v = compare3(x)(y);
            if (v instanceof $ibsD5.LT) return y;
            if (v instanceof $ibsD5.EQ) return x;
            if (v instanceof $ibsD5.GT) return x;
            throw new Error("Failed pattern match at Data.Ord (line 181, column 3 - line 184, column 12): " + [
                v.constructor.name
            ]);
        };
    };
};
var $c07cd952c329ea4b$export$96ec731ed4dcb222 = function(dictOrd) {
    var compare3 = $c07cd952c329ea4b$export$398604a469f7de9a(dictOrd);
    return function(x) {
        return function(y) {
            var v = compare3(x)(y);
            if (v instanceof $ibsD5.LT) return x;
            if (v instanceof $ibsD5.EQ) return x;
            if (v instanceof $ibsD5.GT) return y;
            throw new Error("Failed pattern match at Data.Ord (line 172, column 3 - line 175, column 12): " + [
                v.constructor.name
            ]);
        };
    };
};
var $c07cd952c329ea4b$export$6ace7ea8ac01a75e = function(dictOrd) {
    var compare3 = $c07cd952c329ea4b$export$398604a469f7de9a(dictOrd);
    var eqArray = $aJhEx.eqArray(dictOrd.Eq0());
    return {
        compare: function() {
            var toDelta = function(x) {
                return function(y) {
                    var v = compare3(x)(y);
                    if (v instanceof $ibsD5.EQ) return 0;
                    if (v instanceof $ibsD5.LT) return 1;
                    if (v instanceof $ibsD5.GT) return -1;
                    throw new Error("Failed pattern match at Data.Ord (line 79, column 7 - line 82, column 17): " + [
                        v.constructor.name
                    ]);
                };
            };
            return function(xs) {
                return function(ys) {
                    return $c07cd952c329ea4b$var$compare2(0)($6Mxvn.ordArrayImpl(toDelta)(xs)(ys));
                };
            };
        }(),
        Eq0: function() {
            return eqArray;
        }
    };
};
var $c07cd952c329ea4b$export$8e34cc59438cf1bf = {
    compare1: function(dictOrd) {
        return $c07cd952c329ea4b$export$398604a469f7de9a($c07cd952c329ea4b$export$6ace7ea8ac01a75e(dictOrd));
    },
    Eq10: function() {
        return $aJhEx.eq1Array;
    }
};
var $c07cd952c329ea4b$export$a9b387b18fb85611 = function(dictOrdRecord) {
    var compareRecord1 = $c07cd952c329ea4b$export$f595b73424c1647a(dictOrdRecord);
    var eqRowCons = $aJhEx.eqRowCons(dictOrdRecord.EqRecord0())();
    return function() {
        return function(dictIsSymbol) {
            var reflectSymbol = $3Xcli.reflectSymbol(dictIsSymbol);
            var eqRowCons1 = eqRowCons(dictIsSymbol);
            return function(dictOrd) {
                var compare3 = $c07cd952c329ea4b$export$398604a469f7de9a(dictOrd);
                var eqRowCons2 = eqRowCons1(dictOrd.Eq0());
                return {
                    compareRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var key = reflectSymbol($g13tD.Proxy.value);
                                var left = compare3($hV6x3.unsafeGet(key)(ra))($hV6x3.unsafeGet(key)(rb));
                                var $95 = $c07cd952c329ea4b$var$notEq(left)($ibsD5.EQ.value);
                                if ($95) return left;
                                return compareRecord1($g13tD.Proxy.value)(ra)(rb);
                            };
                        };
                    },
                    EqRecord0: function() {
                        return eqRowCons2;
                    }
                };
            };
        };
    };
};
var $c07cd952c329ea4b$export$7d15b64cf5a3a4c4 = function(dictOrd) {
    var min1 = $c07cd952c329ea4b$export$96ec731ed4dcb222(dictOrd);
    var max1 = $c07cd952c329ea4b$export$8960430cfd85939f(dictOrd);
    return function(low) {
        return function(hi) {
            return function(x) {
                return min1(hi)(max1(low)(x));
            };
        };
    };
};
var $c07cd952c329ea4b$export$cf95c51b03f10bae = function(dictOrd) {
    var lessThan1 = $c07cd952c329ea4b$export$9b050841a3a1b328(dictOrd);
    var greaterThan1 = $c07cd952c329ea4b$export$f517ea36c68d4644(dictOrd);
    return function(low) {
        return function(hi) {
            return function(x) {
                if (lessThan1(x)(low)) return false;
                if (greaterThan1(x)(hi)) return false;
                return true;
            };
        };
    };
};
var $c07cd952c329ea4b$export$2335f513bbd82c6d = function(dictOrd) {
    var greaterThanOrEq1 = $c07cd952c329ea4b$export$4be320a4fd1ac499(dictOrd);
    return function(dictRing) {
        var zero = $iVjQa.zero(dictRing.Semiring0());
        var negate1 = $aop8q.negate(dictRing);
        return function(x) {
            var $99 = greaterThanOrEq1(x)(zero);
            if ($99) return x;
            return negate1(x);
        };
    };
};

});
parcelRegister("6Mxvn", function(module, exports) {

$parcel$export(module.exports, "ordBooleanImpl", () => $4f01372bf880921b$export$fcb09e9654c4896a);
$parcel$export(module.exports, "ordIntImpl", () => $4f01372bf880921b$export$654933317498633e);
$parcel$export(module.exports, "ordNumberImpl", () => $4f01372bf880921b$export$a509696eaf723ed7);
$parcel$export(module.exports, "ordStringImpl", () => $4f01372bf880921b$export$bfcbb0304ffa620f);
$parcel$export(module.exports, "ordCharImpl", () => $4f01372bf880921b$export$5a20025607cdef3f);
$parcel$export(module.exports, "ordArrayImpl", () => $4f01372bf880921b$export$6d083685ddc7682f);
var $4f01372bf880921b$var$unsafeCompareImpl = function(lt) {
    return function(eq) {
        return function(gt) {
            return function(x) {
                return function(y) {
                    return x < y ? lt : x === y ? eq : gt;
                };
            };
        };
    };
};
const $4f01372bf880921b$export$fcb09e9654c4896a = $4f01372bf880921b$var$unsafeCompareImpl;
const $4f01372bf880921b$export$654933317498633e = $4f01372bf880921b$var$unsafeCompareImpl;
const $4f01372bf880921b$export$a509696eaf723ed7 = $4f01372bf880921b$var$unsafeCompareImpl;
const $4f01372bf880921b$export$bfcbb0304ffa620f = $4f01372bf880921b$var$unsafeCompareImpl;
const $4f01372bf880921b$export$5a20025607cdef3f = $4f01372bf880921b$var$unsafeCompareImpl;
const $4f01372bf880921b$export$6d083685ddc7682f = function(f) {
    return function(xs) {
        return function(ys) {
            var i = 0;
            var xlen = xs.length;
            var ylen = ys.length;
            while(i < xlen && i < ylen){
                var x = xs[i];
                var y = ys[i];
                var o = f(x)(y);
                if (o !== 0) return o;
                i++;
            }
            if (xlen === ylen) return 0;
            else if (xlen > ylen) return -1;
            else return 1;
        };
    };
};

});

parcelRegister("aJhEx", function(module, exports) {

$parcel$export(module.exports, "eqVoid", () => $7cfbccdb42891d3d$export$2965418ef5ae9704);
$parcel$export(module.exports, "eqUnit", () => $7cfbccdb42891d3d$export$671c8820f3b36bad);
$parcel$export(module.exports, "eqString", () => $7cfbccdb42891d3d$export$fa624555ca2acbc8);
$parcel$export(module.exports, "eqRowNil", () => $7cfbccdb42891d3d$export$d12253326f924cb1);
$parcel$export(module.exports, "eqRec", () => $7cfbccdb42891d3d$export$691c0e424728509e);
$parcel$export(module.exports, "eqProxy", () => $7cfbccdb42891d3d$export$db5a78c472a81a32);
$parcel$export(module.exports, "eqNumber", () => $7cfbccdb42891d3d$export$e24978670be1e4f3);
$parcel$export(module.exports, "eqInt", () => $7cfbccdb42891d3d$export$e65788c6d4494539);
$parcel$export(module.exports, "eqChar", () => $7cfbccdb42891d3d$export$bcd79f9321394c38);
$parcel$export(module.exports, "eqBoolean", () => $7cfbccdb42891d3d$export$d7927e8ffc1afb48);
$parcel$export(module.exports, "eq1", () => $7cfbccdb42891d3d$export$96fd6c73d03c9dd2);
$parcel$export(module.exports, "eq", () => $7cfbccdb42891d3d$export$9663ddc1cf085b32);
$parcel$export(module.exports, "eqArray", () => $7cfbccdb42891d3d$export$159e06dc5ec60b00);
$parcel$export(module.exports, "eq1Array", () => $7cfbccdb42891d3d$export$861eb926e0b8ea5b);
$parcel$export(module.exports, "eqRowCons", () => $7cfbccdb42891d3d$export$730b16b2c839caa0);
$parcel$export(module.exports, "notEq", () => $7cfbccdb42891d3d$export$5475dfc31a65c2cd);
// Generated by purs version 0.15.16

var $kZzb2 = parcelRequire("kZzb2");

var $3Xcli = parcelRequire("3Xcli");
parcelRequire("lMTwl");
var $hV6x3 = parcelRequire("hV6x3");

var $g13tD = parcelRequire("g13tD");
var $7cfbccdb42891d3d$export$2965418ef5ae9704 = {
    eq: function(v) {
        return function(v1) {
            return true;
        };
    }
};
var $7cfbccdb42891d3d$export$671c8820f3b36bad = {
    eq: function(v) {
        return function(v1) {
            return true;
        };
    }
};
var $7cfbccdb42891d3d$export$fa624555ca2acbc8 = {
    eq: $kZzb2.eqStringImpl
};
var $7cfbccdb42891d3d$export$d12253326f924cb1 = {
    eqRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return true;
            };
        };
    }
};
var $7cfbccdb42891d3d$export$14e60b8fdd01f41c = function(dict) {
    return dict.eqRecord;
};
var $7cfbccdb42891d3d$export$691c0e424728509e = function() {
    return function(dictEqRecord) {
        return {
            eq: $7cfbccdb42891d3d$export$14e60b8fdd01f41c(dictEqRecord)($g13tD.Proxy.value)
        };
    };
};
var $7cfbccdb42891d3d$export$db5a78c472a81a32 = {
    eq: function(v) {
        return function(v1) {
            return true;
        };
    }
};
var $7cfbccdb42891d3d$export$e24978670be1e4f3 = {
    eq: $kZzb2.eqNumberImpl
};
var $7cfbccdb42891d3d$export$e65788c6d4494539 = {
    eq: $kZzb2.eqIntImpl
};
var $7cfbccdb42891d3d$export$bcd79f9321394c38 = {
    eq: $kZzb2.eqCharImpl
};
var $7cfbccdb42891d3d$export$d7927e8ffc1afb48 = {
    eq: $kZzb2.eqBooleanImpl
};
var $7cfbccdb42891d3d$export$96fd6c73d03c9dd2 = function(dict) {
    return dict.eq1;
};
var $7cfbccdb42891d3d$export$9663ddc1cf085b32 = function(dict) {
    return dict.eq;
};
var $7cfbccdb42891d3d$var$eq2 = /* #__PURE__ */ $7cfbccdb42891d3d$export$9663ddc1cf085b32($7cfbccdb42891d3d$export$d7927e8ffc1afb48);
var $7cfbccdb42891d3d$export$159e06dc5ec60b00 = function(dictEq) {
    return {
        eq: $kZzb2.eqArrayImpl($7cfbccdb42891d3d$export$9663ddc1cf085b32(dictEq))
    };
};
var $7cfbccdb42891d3d$export$861eb926e0b8ea5b = {
    eq1: function(dictEq) {
        return $7cfbccdb42891d3d$export$9663ddc1cf085b32($7cfbccdb42891d3d$export$159e06dc5ec60b00(dictEq));
    }
};
var $7cfbccdb42891d3d$export$730b16b2c839caa0 = function(dictEqRecord) {
    var eqRecord1 = $7cfbccdb42891d3d$export$14e60b8fdd01f41c(dictEqRecord);
    return function() {
        return function(dictIsSymbol) {
            var reflectSymbol = $3Xcli.reflectSymbol(dictIsSymbol);
            return function(dictEq) {
                var eq3 = $7cfbccdb42891d3d$export$9663ddc1cf085b32(dictEq);
                return {
                    eqRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = eqRecord1($g13tD.Proxy.value)(ra)(rb);
                                var key = reflectSymbol($g13tD.Proxy.value);
                                var get = $hV6x3.unsafeGet(key);
                                return eq3(get(ra))(get(rb)) && tail;
                            };
                        };
                    }
                };
            };
        };
    };
};
var $7cfbccdb42891d3d$export$5475dfc31a65c2cd = function(dictEq) {
    var eq3 = $7cfbccdb42891d3d$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return function(y) {
            return $7cfbccdb42891d3d$var$eq2(eq3(x)(y))(false);
        };
    };
};
var $7cfbccdb42891d3d$export$d0aa07ff560ecb = function(dictEq1) {
    var eq11 = $7cfbccdb42891d3d$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq) {
        var eq12 = eq11(dictEq);
        return function(x) {
            return function(y) {
                return $7cfbccdb42891d3d$var$eq2(eq12(x)(y))(false);
            };
        };
    };
};

});
parcelRegister("kZzb2", function(module, exports) {

$parcel$export(module.exports, "eqBooleanImpl", () => $f484ca97238d7424$export$373f9c52154d3177);
$parcel$export(module.exports, "eqIntImpl", () => $f484ca97238d7424$export$123e3cb4a5e139f4);
$parcel$export(module.exports, "eqNumberImpl", () => $f484ca97238d7424$export$9fc9964c874ac58);
$parcel$export(module.exports, "eqCharImpl", () => $f484ca97238d7424$export$b056fd0da0447ba9);
$parcel$export(module.exports, "eqStringImpl", () => $f484ca97238d7424$export$bb9bce33bd088a97);
$parcel$export(module.exports, "eqArrayImpl", () => $f484ca97238d7424$export$e89e5efeb0be06bc);
var $f484ca97238d7424$var$refEq = function(r1) {
    return function(r2) {
        return r1 === r2;
    };
};
const $f484ca97238d7424$export$373f9c52154d3177 = $f484ca97238d7424$var$refEq;
const $f484ca97238d7424$export$123e3cb4a5e139f4 = $f484ca97238d7424$var$refEq;
const $f484ca97238d7424$export$9fc9964c874ac58 = $f484ca97238d7424$var$refEq;
const $f484ca97238d7424$export$b056fd0da0447ba9 = $f484ca97238d7424$var$refEq;
const $f484ca97238d7424$export$bb9bce33bd088a97 = $f484ca97238d7424$var$refEq;
const $f484ca97238d7424$export$e89e5efeb0be06bc = function(f) {
    return function(xs) {
        return function(ys) {
            if (xs.length !== ys.length) return false;
            for(var i = 0; i < xs.length; i++){
                if (!f(xs[i])(ys[i])) return false;
            }
            return true;
        };
    };
};

});


parcelRegister("ibsD5", function(module, exports) {

$parcel$export(module.exports, "LT", () => $d3cf764e79652aef$export$7158f0ceb70f54c7);
$parcel$export(module.exports, "GT", () => $d3cf764e79652aef$export$b023c82b48e70453);
$parcel$export(module.exports, "EQ", () => $d3cf764e79652aef$export$1c0a5d05eb3f6e18);
$parcel$export(module.exports, "semigroupOrdering", () => $d3cf764e79652aef$export$d04ea36c3e51a408);
$parcel$export(module.exports, "eqOrdering", () => $d3cf764e79652aef$export$82d306ead3b703cd);
// Generated by purs version 0.15.16
var $d3cf764e79652aef$export$7158f0ceb70f54c7 = /* #__PURE__ */ function() {
    function LT() {}
    LT.value = new LT();
    return LT;
}();
var $d3cf764e79652aef$export$b023c82b48e70453 = /* #__PURE__ */ function() {
    function GT() {}
    GT.value = new GT();
    return GT;
}();
var $d3cf764e79652aef$export$1c0a5d05eb3f6e18 = /* #__PURE__ */ function() {
    function EQ() {}
    EQ.value = new EQ();
    return EQ;
}();
var $d3cf764e79652aef$export$c1dd7b0030d4618e = {
    show: function(v) {
        if (v instanceof $d3cf764e79652aef$export$7158f0ceb70f54c7) return "LT";
        if (v instanceof $d3cf764e79652aef$export$b023c82b48e70453) return "GT";
        if (v instanceof $d3cf764e79652aef$export$1c0a5d05eb3f6e18) return "EQ";
        throw new Error("Failed pattern match at Data.Ordering (line 26, column 1 - line 29, column 17): " + [
            v.constructor.name
        ]);
    }
};
var $d3cf764e79652aef$export$d04ea36c3e51a408 = {
    append: function(v) {
        return function(v1) {
            if (v instanceof $d3cf764e79652aef$export$7158f0ceb70f54c7) return $d3cf764e79652aef$export$7158f0ceb70f54c7.value;
            if (v instanceof $d3cf764e79652aef$export$b023c82b48e70453) return $d3cf764e79652aef$export$b023c82b48e70453.value;
            if (v instanceof $d3cf764e79652aef$export$1c0a5d05eb3f6e18) return v1;
            throw new Error("Failed pattern match at Data.Ordering (line 21, column 1 - line 24, column 18): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $d3cf764e79652aef$export$6897c284b6f9f4dc = function(v) {
    if (v instanceof $d3cf764e79652aef$export$b023c82b48e70453) return $d3cf764e79652aef$export$7158f0ceb70f54c7.value;
    if (v instanceof $d3cf764e79652aef$export$1c0a5d05eb3f6e18) return $d3cf764e79652aef$export$1c0a5d05eb3f6e18.value;
    if (v instanceof $d3cf764e79652aef$export$7158f0ceb70f54c7) return $d3cf764e79652aef$export$b023c82b48e70453.value;
    throw new Error("Failed pattern match at Data.Ordering (line 33, column 1 - line 33, column 31): " + [
        v.constructor.name
    ]);
};
var $d3cf764e79652aef$export$82d306ead3b703cd = {
    eq: function(v) {
        return function(v1) {
            if (v instanceof $d3cf764e79652aef$export$7158f0ceb70f54c7 && v1 instanceof $d3cf764e79652aef$export$7158f0ceb70f54c7) return true;
            if (v instanceof $d3cf764e79652aef$export$b023c82b48e70453 && v1 instanceof $d3cf764e79652aef$export$b023c82b48e70453) return true;
            if (v instanceof $d3cf764e79652aef$export$1c0a5d05eb3f6e18 && v1 instanceof $d3cf764e79652aef$export$1c0a5d05eb3f6e18) return true;
            return false;
        };
    }
};

});

parcelRegister("aop8q", function(module, exports) {

$parcel$export(module.exports, "sub", () => $790fa48f9eefeeae$export$f93b5905241a7cca);
$parcel$export(module.exports, "ringUnit", () => $790fa48f9eefeeae$export$e2da189c845067f9);
$parcel$export(module.exports, "ringRecordNil", () => $790fa48f9eefeeae$export$38dc985ea1e564cd);
$parcel$export(module.exports, "ringRecordCons", () => $790fa48f9eefeeae$export$857cf13a2f74264d);
$parcel$export(module.exports, "ringRecord", () => $790fa48f9eefeeae$export$492fe4fa507ea6ad);
$parcel$export(module.exports, "ringProxy", () => $790fa48f9eefeeae$export$948aff48831eff14);
$parcel$export(module.exports, "ringNumber", () => $790fa48f9eefeeae$export$194f4464e73e7816);
$parcel$export(module.exports, "ringInt", () => $790fa48f9eefeeae$export$d40e27c88e22a303);
$parcel$export(module.exports, "ringFn", () => $790fa48f9eefeeae$export$9f43d8c61dde305d);
$parcel$export(module.exports, "negate", () => $790fa48f9eefeeae$export$aef51622e549b8b0);
// Generated by purs version 0.15.16

var $1u16w = parcelRequire("1u16w");

var $iVjQa = parcelRequire("iVjQa");

var $3Xcli = parcelRequire("3Xcli");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
parcelRequire("lMTwl");
var $hV6x3 = parcelRequire("hV6x3");

var $g13tD = parcelRequire("g13tD");
var $790fa48f9eefeeae$var$semiringRecord = /* #__PURE__ */ $iVjQa.semiringRecord();
var $790fa48f9eefeeae$export$11a6fe76b07a0 = function(dict) {
    return dict.subRecord;
};
var $790fa48f9eefeeae$export$f93b5905241a7cca = function(dict) {
    return dict.sub;
};
var $790fa48f9eefeeae$export$e2da189c845067f9 = {
    sub: function(v) {
        return function(v1) {
            return $ivFwO.unit;
        };
    },
    Semiring0: function() {
        return $iVjQa.semiringUnit;
    }
};
var $790fa48f9eefeeae$export$38dc985ea1e564cd = {
    subRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    SemiringRecord0: function() {
        return $iVjQa.semiringRecordNil;
    }
};
var $790fa48f9eefeeae$export$857cf13a2f74264d = function(dictIsSymbol) {
    var reflectSymbol = $3Xcli.reflectSymbol(dictIsSymbol);
    var semiringRecordCons = $iVjQa.semiringRecordCons(dictIsSymbol)();
    return function() {
        return function(dictRingRecord) {
            var subRecord1 = $790fa48f9eefeeae$export$11a6fe76b07a0(dictRingRecord);
            var semiringRecordCons1 = semiringRecordCons(dictRingRecord.SemiringRecord0());
            return function(dictRing) {
                var sub1 = $790fa48f9eefeeae$export$f93b5905241a7cca(dictRing);
                var semiringRecordCons2 = semiringRecordCons1(dictRing.Semiring0());
                return {
                    subRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = subRecord1($g13tD.Proxy.value)(ra)(rb);
                                var key = reflectSymbol($g13tD.Proxy.value);
                                var insert = $hV6x3.unsafeSet(key);
                                var get = $hV6x3.unsafeGet(key);
                                return insert(sub1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    SemiringRecord0: function() {
                        return semiringRecordCons2;
                    }
                };
            };
        };
    };
};
var $790fa48f9eefeeae$export$492fe4fa507ea6ad = function() {
    return function(dictRingRecord) {
        var semiringRecord1 = $790fa48f9eefeeae$var$semiringRecord(dictRingRecord.SemiringRecord0());
        return {
            sub: $790fa48f9eefeeae$export$11a6fe76b07a0(dictRingRecord)($g13tD.Proxy.value),
            Semiring0: function() {
                return semiringRecord1;
            }
        };
    };
};
var $790fa48f9eefeeae$export$948aff48831eff14 = {
    sub: function(v) {
        return function(v1) {
            return $g13tD.Proxy.value;
        };
    },
    Semiring0: function() {
        return $iVjQa.semiringProxy;
    }
};
var $790fa48f9eefeeae$export$194f4464e73e7816 = {
    sub: $1u16w.numSub,
    Semiring0: function() {
        return $iVjQa.semiringNumber;
    }
};
var $790fa48f9eefeeae$export$d40e27c88e22a303 = {
    sub: $1u16w.intSub,
    Semiring0: function() {
        return $iVjQa.semiringInt;
    }
};
var $790fa48f9eefeeae$export$9f43d8c61dde305d = function(dictRing) {
    var sub1 = $790fa48f9eefeeae$export$f93b5905241a7cca(dictRing);
    var semiringFn = $iVjQa.semiringFn(dictRing.Semiring0());
    return {
        sub: function(f) {
            return function(g) {
                return function(x) {
                    return sub1(f(x))(g(x));
                };
            };
        },
        Semiring0: function() {
            return semiringFn;
        }
    };
};
var $790fa48f9eefeeae$export$aef51622e549b8b0 = function(dictRing) {
    var sub1 = $790fa48f9eefeeae$export$f93b5905241a7cca(dictRing);
    var zero = $iVjQa.zero(dictRing.Semiring0());
    return function(a) {
        return sub1(zero)(a);
    };
};

});
parcelRegister("1u16w", function(module, exports) {

$parcel$export(module.exports, "intSub", () => $11497314e7a73c9e$export$8964faf538cd4472);
$parcel$export(module.exports, "numSub", () => $11497314e7a73c9e$export$592dc8db1291fc5e);
const $11497314e7a73c9e$export$8964faf538cd4472 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x - y | 0;
    };
};
const $11497314e7a73c9e$export$592dc8db1291fc5e = function(n1) {
    return function(n2) {
        return n1 - n2;
    };
};

});

parcelRegister("iVjQa", function(module, exports) {

$parcel$export(module.exports, "zero", () => $dc6cf0c36eba60ef$export$7f9972325ebfd559);
$parcel$export(module.exports, "semiringUnit", () => $dc6cf0c36eba60ef$export$348dab40c63d4f3e);
$parcel$export(module.exports, "semiringRecordNil", () => $dc6cf0c36eba60ef$export$5f825cdfc30c8d7a);
$parcel$export(module.exports, "semiringProxy", () => $dc6cf0c36eba60ef$export$28b7adff71d7e2f2);
$parcel$export(module.exports, "semiringNumber", () => $dc6cf0c36eba60ef$export$f48694d6539477b9);
$parcel$export(module.exports, "semiringInt", () => $dc6cf0c36eba60ef$export$7e80d6910c05bd77);
$parcel$export(module.exports, "one", () => $dc6cf0c36eba60ef$export$80bf7733f1207381);
$parcel$export(module.exports, "mul", () => $dc6cf0c36eba60ef$export$6e3a27864ab166fe);
$parcel$export(module.exports, "semiringRecord", () => $dc6cf0c36eba60ef$export$93af3fe715165fc8);
$parcel$export(module.exports, "add", () => $dc6cf0c36eba60ef$export$e16d8520af44a096);
$parcel$export(module.exports, "semiringFn", () => $dc6cf0c36eba60ef$export$4946f164d066bdc5);
$parcel$export(module.exports, "semiringRecordCons", () => $dc6cf0c36eba60ef$export$8d7f5ae13d42a4f9);
// Generated by purs version 0.15.16

var $4gGcW = parcelRequire("4gGcW");

var $3Xcli = parcelRequire("3Xcli");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
parcelRequire("lMTwl");
var $hV6x3 = parcelRequire("hV6x3");

var $g13tD = parcelRequire("g13tD");
var $dc6cf0c36eba60ef$export$2fbd183cf91e4d96 = function(dict) {
    return dict.zeroRecord;
};
var $dc6cf0c36eba60ef$export$7f9972325ebfd559 = function(dict) {
    return dict.zero;
};
var $dc6cf0c36eba60ef$export$348dab40c63d4f3e = {
    add: function(v) {
        return function(v1) {
            return $ivFwO.unit;
        };
    },
    zero: $ivFwO.unit,
    mul: function(v) {
        return function(v1) {
            return $ivFwO.unit;
        };
    },
    one: $ivFwO.unit
};
var $dc6cf0c36eba60ef$export$5f825cdfc30c8d7a = {
    addRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    mulRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    oneRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    zeroRecord: function(v) {
        return function(v1) {
            return {};
        };
    }
};
var $dc6cf0c36eba60ef$export$28b7adff71d7e2f2 = /* #__PURE__ */ function() {
    return {
        add: function(v) {
            return function(v1) {
                return $g13tD.Proxy.value;
            };
        },
        mul: function(v) {
            return function(v1) {
                return $g13tD.Proxy.value;
            };
        },
        one: $g13tD.Proxy.value,
        zero: $g13tD.Proxy.value
    };
}();
var $dc6cf0c36eba60ef$export$f48694d6539477b9 = {
    add: $4gGcW.numAdd,
    zero: 0.0,
    mul: $4gGcW.numMul,
    one: 1.0
};
var $dc6cf0c36eba60ef$export$7e80d6910c05bd77 = {
    add: $4gGcW.intAdd,
    zero: 0,
    mul: $4gGcW.intMul,
    one: 1
};
var $dc6cf0c36eba60ef$export$e9e5a13b3096dd62 = function(dict) {
    return dict.oneRecord;
};
var $dc6cf0c36eba60ef$export$80bf7733f1207381 = function(dict) {
    return dict.one;
};
var $dc6cf0c36eba60ef$export$ff4422e298afd4cc = function(dict) {
    return dict.mulRecord;
};
var $dc6cf0c36eba60ef$export$6e3a27864ab166fe = function(dict) {
    return dict.mul;
};
var $dc6cf0c36eba60ef$export$ab0ab92b3cb31c66 = function(dict) {
    return dict.addRecord;
};
var $dc6cf0c36eba60ef$export$93af3fe715165fc8 = function() {
    return function(dictSemiringRecord) {
        return {
            add: $dc6cf0c36eba60ef$export$ab0ab92b3cb31c66(dictSemiringRecord)($g13tD.Proxy.value),
            mul: $dc6cf0c36eba60ef$export$ff4422e298afd4cc(dictSemiringRecord)($g13tD.Proxy.value),
            one: $dc6cf0c36eba60ef$export$e9e5a13b3096dd62(dictSemiringRecord)($g13tD.Proxy.value)($g13tD.Proxy.value),
            zero: $dc6cf0c36eba60ef$export$2fbd183cf91e4d96(dictSemiringRecord)($g13tD.Proxy.value)($g13tD.Proxy.value)
        };
    };
};
var $dc6cf0c36eba60ef$export$e16d8520af44a096 = function(dict) {
    return dict.add;
};
var $dc6cf0c36eba60ef$export$4946f164d066bdc5 = function(dictSemiring) {
    var add1 = $dc6cf0c36eba60ef$export$e16d8520af44a096(dictSemiring);
    var zero1 = $dc6cf0c36eba60ef$export$7f9972325ebfd559(dictSemiring);
    var mul1 = $dc6cf0c36eba60ef$export$6e3a27864ab166fe(dictSemiring);
    var one1 = $dc6cf0c36eba60ef$export$80bf7733f1207381(dictSemiring);
    return {
        add: function(f) {
            return function(g) {
                return function(x) {
                    return add1(f(x))(g(x));
                };
            };
        },
        zero: function(v) {
            return zero1;
        },
        mul: function(f) {
            return function(g) {
                return function(x) {
                    return mul1(f(x))(g(x));
                };
            };
        },
        one: function(v) {
            return one1;
        }
    };
};
var $dc6cf0c36eba60ef$export$8d7f5ae13d42a4f9 = function(dictIsSymbol) {
    var reflectSymbol = $3Xcli.reflectSymbol(dictIsSymbol);
    return function() {
        return function(dictSemiringRecord) {
            var addRecord1 = $dc6cf0c36eba60ef$export$ab0ab92b3cb31c66(dictSemiringRecord);
            var mulRecord1 = $dc6cf0c36eba60ef$export$ff4422e298afd4cc(dictSemiringRecord);
            var oneRecord1 = $dc6cf0c36eba60ef$export$e9e5a13b3096dd62(dictSemiringRecord);
            var zeroRecord1 = $dc6cf0c36eba60ef$export$2fbd183cf91e4d96(dictSemiringRecord);
            return function(dictSemiring) {
                var add1 = $dc6cf0c36eba60ef$export$e16d8520af44a096(dictSemiring);
                var mul1 = $dc6cf0c36eba60ef$export$6e3a27864ab166fe(dictSemiring);
                var one1 = $dc6cf0c36eba60ef$export$80bf7733f1207381(dictSemiring);
                var zero1 = $dc6cf0c36eba60ef$export$7f9972325ebfd559(dictSemiring);
                return {
                    addRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = addRecord1($g13tD.Proxy.value)(ra)(rb);
                                var key = reflectSymbol($g13tD.Proxy.value);
                                var insert = $hV6x3.unsafeSet(key);
                                var get = $hV6x3.unsafeGet(key);
                                return insert(add1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    mulRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = mulRecord1($g13tD.Proxy.value)(ra)(rb);
                                var key = reflectSymbol($g13tD.Proxy.value);
                                var insert = $hV6x3.unsafeSet(key);
                                var get = $hV6x3.unsafeGet(key);
                                return insert(mul1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    oneRecord: function(v) {
                        return function(v1) {
                            var tail = oneRecord1($g13tD.Proxy.value)($g13tD.Proxy.value);
                            var key = reflectSymbol($g13tD.Proxy.value);
                            var insert = $hV6x3.unsafeSet(key);
                            return insert(one1)(tail);
                        };
                    },
                    zeroRecord: function(v) {
                        return function(v1) {
                            var tail = zeroRecord1($g13tD.Proxy.value)($g13tD.Proxy.value);
                            var key = reflectSymbol($g13tD.Proxy.value);
                            var insert = $hV6x3.unsafeSet(key);
                            return insert(zero1)(tail);
                        };
                    }
                };
            };
        };
    };
};

});
parcelRegister("4gGcW", function(module, exports) {

$parcel$export(module.exports, "intAdd", () => $31b9659f25f9b671$export$3493e4651621d0b);
$parcel$export(module.exports, "intMul", () => $31b9659f25f9b671$export$9961c9313a91a4c2);
$parcel$export(module.exports, "numAdd", () => $31b9659f25f9b671$export$7851ca78a7fd68e5);
$parcel$export(module.exports, "numMul", () => $31b9659f25f9b671$export$3c84e2814d77f9f0);
const $31b9659f25f9b671$export$3493e4651621d0b = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x + y | 0;
    };
};
const $31b9659f25f9b671$export$9961c9313a91a4c2 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x * y | 0;
    };
};
const $31b9659f25f9b671$export$7851ca78a7fd68e5 = function(n1) {
    return function(n2) {
        return n1 + n2;
    };
};
const $31b9659f25f9b671$export$3c84e2814d77f9f0 = function(n1) {
    return function(n2) {
        return n1 * n2;
    };
};

});





parcelRegister("7nwca", function(module, exports) {

$parcel$export(module.exports, "imapF", () => $55f3a7ac65995d27$export$eb38b1c8c5f72ca8);
$parcel$export(module.exports, "imap", () => $55f3a7ac65995d27$export$b2517b0ab3a58435);
// Generated by purs version 0.15.16

var $7FzSN = parcelRequire("7FzSN");
var $55f3a7ac65995d27$export$e8c9127d2f50172d = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $55f3a7ac65995d27$export$8824a2bea4c1012c = {
    imap: function(ab) {
        return function(ba) {
            return function(v) {
                return function($42) {
                    return ab(v(ba($42)));
                };
            };
        };
    }
};
var $55f3a7ac65995d27$export$1c6d49d5878078c3 = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $55f3a7ac65995d27$export$ef56ebe0e8112a3f = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $55f3a7ac65995d27$export$562bca5a8a46bf61 = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $55f3a7ac65995d27$export$bf44d3d4196f3d53 = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $55f3a7ac65995d27$export$eb38b1c8c5f72ca8 = function(dictFunctor) {
    var map = $7FzSN.map(dictFunctor);
    return function(f) {
        return function(v) {
            return map(f);
        };
    };
};
var $55f3a7ac65995d27$export$c469d4e9c6f65eae = {
    imap: /* #__PURE__ */ $55f3a7ac65995d27$export$eb38b1c8c5f72ca8($7FzSN.functorArray)
};
var $55f3a7ac65995d27$export$993789ec90a91854 = {
    imap: /* #__PURE__ */ $55f3a7ac65995d27$export$eb38b1c8c5f72ca8($7FzSN.functorFn)
};
var $55f3a7ac65995d27$export$b2517b0ab3a58435 = function(dict) {
    return dict.imap;
};
var $55f3a7ac65995d27$export$6e542772b026aecb = function(dictInvariant) {
    var imap1 = $55f3a7ac65995d27$export$b2517b0ab3a58435(dictInvariant);
    return {
        imap: function(f) {
            return function(g) {
                return function(v) {
                    return imap1(f)(g)(v);
                };
            };
        }
    };
};

});

parcelRegister("ebQYe", function(module, exports) {

$parcel$export(module.exports, "Inl", () => $a54b2e9d8f65f0f1$export$dd5fad028b7772cd);
$parcel$export(module.exports, "Inr", () => $a54b2e9d8f65f0f1$export$df71ca4577dbdff6);
$parcel$export(module.exports, "Product", () => $a54b2e9d8f65f0f1$export$264ad599d7cef668);
$parcel$export(module.exports, "NoArguments", () => $a54b2e9d8f65f0f1$export$928c7f2d618c070b);
// Generated by purs version 0.15.16

var $2XxiF = parcelRequire("2XxiF");

var $3Xcli = parcelRequire("3Xcli");

var $g13tD = parcelRequire("g13tD");
var $a54b2e9d8f65f0f1$var$show = /* #__PURE__ */ $2XxiF.show($2XxiF.showString);
var $a54b2e9d8f65f0f1$export$dd5fad028b7772cd = /* #__PURE__ */ function() {
    function Inl(value0) {
        this.value0 = value0;
    }
    Inl.create = function(value0) {
        return new Inl(value0);
    };
    return Inl;
}();
var $a54b2e9d8f65f0f1$export$df71ca4577dbdff6 = /* #__PURE__ */ function() {
    function Inr(value0) {
        this.value0 = value0;
    }
    Inr.create = function(value0) {
        return new Inr(value0);
    };
    return Inr;
}();
var $a54b2e9d8f65f0f1$export$264ad599d7cef668 = /* #__PURE__ */ function() {
    function Product(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Product.create = function(value0) {
        return function(value1) {
            return new Product(value0, value1);
        };
    };
    return Product;
}();
var $a54b2e9d8f65f0f1$var$NoConstructors = function(x) {
    return x;
};
var $a54b2e9d8f65f0f1$export$928c7f2d618c070b = /* #__PURE__ */ function() {
    function NoArguments() {}
    NoArguments.value = new NoArguments();
    return NoArguments;
}();
var $a54b2e9d8f65f0f1$export$8bfc33963ccbb2a = function(x) {
    return x;
};
var $a54b2e9d8f65f0f1$export$84637ea037d2e218 = function(x) {
    return x;
};
var $a54b2e9d8f65f0f1$export$2c618a4308a30424 = function(dict) {
    return dict.to;
};
var $a54b2e9d8f65f0f1$export$a76fa7ac9b018069 = function(dictShow) {
    var show1 = $2XxiF.show(dictShow);
    return function(dictShow1) {
        var show2 = $2XxiF.show(dictShow1);
        return {
            show: function(v) {
                if (v instanceof $a54b2e9d8f65f0f1$export$dd5fad028b7772cd) return "(Inl " + (show1(v.value0) + ")");
                if (v instanceof $a54b2e9d8f65f0f1$export$df71ca4577dbdff6) return "(Inr " + (show2(v.value0) + ")");
                throw new Error("Failed pattern match at Data.Generic.Rep (line 32, column 1 - line 34, column 42): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $a54b2e9d8f65f0f1$export$821c121fea76e4f5 = function(dictShow) {
    var show1 = $2XxiF.show(dictShow);
    return function(dictShow1) {
        var show2 = $2XxiF.show(dictShow1);
        return {
            show: function(v) {
                return "(Product " + (show1(v.value0) + (" " + (show2(v.value1) + ")")));
            }
        };
    };
};
var $a54b2e9d8f65f0f1$export$1275f813f7f7622c = {
    show: function(v) {
        return "NoArguments";
    }
};
var $a54b2e9d8f65f0f1$export$4133b31869b937df = function(dictIsSymbol) {
    var reflectSymbol = $3Xcli.reflectSymbol(dictIsSymbol);
    return function(dictShow) {
        var show1 = $2XxiF.show(dictShow);
        return {
            show: function(v) {
                return "(Constructor @" + ($a54b2e9d8f65f0f1$var$show(reflectSymbol($g13tD.Proxy.value)) + (" " + (show1(v) + ")")));
            }
        };
    };
};
var $a54b2e9d8f65f0f1$export$b1716375e6f06e2d = function(dictShow) {
    var show1 = $2XxiF.show(dictShow);
    return {
        show: function(v) {
            return "(Argument " + (show1(v) + ")");
        }
    };
};
var $a54b2e9d8f65f0f1$export$3d0c2c94453de4b8 = function(dictGeneric) {
    return function(v) {
        return $g13tD.Proxy.value;
    };
};
var $a54b2e9d8f65f0f1$export$6788812c4e6611e6 = function(dict) {
    return dict.from;
};

});
parcelRegister("2XxiF", function(module, exports) {

$parcel$export(module.exports, "showString", () => $227aec2e0a8a8160$export$e4b6cd05df3043f6);
$parcel$export(module.exports, "showNumber", () => $227aec2e0a8a8160$export$e5aa470f8f97c3fe);
$parcel$export(module.exports, "showInt", () => $227aec2e0a8a8160$export$3d7cf516d27998a0);
$parcel$export(module.exports, "showChar", () => $227aec2e0a8a8160$export$def6059c21714f2a);
$parcel$export(module.exports, "show", () => $227aec2e0a8a8160$export$57bf213be019eeb0);
$parcel$export(module.exports, "showArray", () => $227aec2e0a8a8160$export$5bda33a3389a7225);
// Generated by purs version 0.15.16

var $eIPxy = parcelRequire("eIPxy");

var $3Xcli = parcelRequire("3Xcli");

var $Hhp3L = parcelRequire("Hhp3L");
parcelRequire("lMTwl");
var $hV6x3 = parcelRequire("hV6x3");

var $g13tD = parcelRequire("g13tD");
var $227aec2e0a8a8160$export$2052789f27d4993d = {
    show: $Hhp3L.absurd
};
var $227aec2e0a8a8160$export$5a8c7efb782a6055 = {
    show: function(v) {
        return "unit";
    }
};
var $227aec2e0a8a8160$export$e4b6cd05df3043f6 = {
    show: $eIPxy.showStringImpl
};
var $227aec2e0a8a8160$export$a673323aec880979 = {
    showRecordFields: function(v) {
        return function(v1) {
            return "";
        };
    }
};
var $227aec2e0a8a8160$export$2633f2b0f857f544 = function(dict) {
    return dict.showRecordFields;
};
var $227aec2e0a8a8160$export$28b0be767d2bc2c2 = function() {
    return function() {
        return function(dictShowRecordFields) {
            var showRecordFields1 = $227aec2e0a8a8160$export$2633f2b0f857f544(dictShowRecordFields);
            return {
                show: function(record) {
                    return "{" + (showRecordFields1($g13tD.Proxy.value)(record) + "}");
                }
            };
        };
    };
};
var $227aec2e0a8a8160$export$3805d09d172f9aca = {
    show: function(v) {
        return "Proxy";
    }
};
var $227aec2e0a8a8160$export$e5aa470f8f97c3fe = {
    show: $eIPxy.showNumberImpl
};
var $227aec2e0a8a8160$export$3d7cf516d27998a0 = {
    show: $eIPxy.showIntImpl
};
var $227aec2e0a8a8160$export$def6059c21714f2a = {
    show: $eIPxy.showCharImpl
};
var $227aec2e0a8a8160$export$ad55f318773e3cd5 = {
    show: function(v) {
        if (v) return "true";
        if (!v) return "false";
        throw new Error("Failed pattern match at Data.Show (line 29, column 1 - line 31, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $227aec2e0a8a8160$export$57bf213be019eeb0 = function(dict) {
    return dict.show;
};
var $227aec2e0a8a8160$export$5bda33a3389a7225 = function(dictShow) {
    return {
        show: $eIPxy.showArrayImpl($227aec2e0a8a8160$export$57bf213be019eeb0(dictShow))
    };
};
var $227aec2e0a8a8160$export$70f8f8693d114c9d = function(dictIsSymbol) {
    var reflectSymbol = $3Xcli.reflectSymbol(dictIsSymbol);
    return function(dictShowRecordFields) {
        var showRecordFields1 = $227aec2e0a8a8160$export$2633f2b0f857f544(dictShowRecordFields);
        return function(dictShow) {
            var show1 = $227aec2e0a8a8160$export$57bf213be019eeb0(dictShow);
            return {
                showRecordFields: function(v) {
                    return function(record) {
                        var tail = showRecordFields1($g13tD.Proxy.value)(record);
                        var key = reflectSymbol($g13tD.Proxy.value);
                        var focus = $hV6x3.unsafeGet(key)(record);
                        return " " + (key + (": " + (show1(focus) + ("," + tail))));
                    };
                }
            };
        };
    };
};
var $227aec2e0a8a8160$export$d57593979a3bd7f3 = function(dictIsSymbol) {
    var reflectSymbol = $3Xcli.reflectSymbol(dictIsSymbol);
    return function(dictShow) {
        var show1 = $227aec2e0a8a8160$export$57bf213be019eeb0(dictShow);
        return {
            showRecordFields: function(v) {
                return function(record) {
                    var key = reflectSymbol($g13tD.Proxy.value);
                    var focus = $hV6x3.unsafeGet(key)(record);
                    return " " + (key + (": " + (show1(focus) + " ")));
                };
            }
        };
    };
};

});
parcelRegister("eIPxy", function(module, exports) {

$parcel$export(module.exports, "showIntImpl", () => $ab7d2790bedac8b4$export$c7cd64a71178c531);
$parcel$export(module.exports, "showNumberImpl", () => $ab7d2790bedac8b4$export$e43176eac712254a);
$parcel$export(module.exports, "showCharImpl", () => $ab7d2790bedac8b4$export$91f9c7a21f1f86c8);
$parcel$export(module.exports, "showStringImpl", () => $ab7d2790bedac8b4$export$336c8e5b2153cec7);
$parcel$export(module.exports, "showArrayImpl", () => $ab7d2790bedac8b4$export$a23154580f12ac67);
const $ab7d2790bedac8b4$export$c7cd64a71178c531 = function(n) {
    return n.toString();
};
const $ab7d2790bedac8b4$export$e43176eac712254a = function(n) {
    var str = n.toString();
    return isNaN(str + ".0") ? str : str + ".0";
};
const $ab7d2790bedac8b4$export$91f9c7a21f1f86c8 = function(c) {
    var code = c.charCodeAt(0);
    if (code < 0x20 || code === 0x7F) {
        switch(c){
            case "\x07":
                return "'\\a'";
            case "\b":
                return "'\\b'";
            case "\f":
                return "'\\f'";
            case "\n":
                return "'\\n'";
            case "\r":
                return "'\\r'";
            case "\t":
                return "'\\t'";
            case "\v":
                return "'\\v'";
        }
        return "'\\" + code.toString(10) + "'";
    }
    return c === "'" || c === "\\" ? "'\\" + c + "'" : "'" + c + "'";
};
const $ab7d2790bedac8b4$export$336c8e5b2153cec7 = function(s) {
    var l = s.length;
    return "\"" + s.replace(/[\0-\x1F\x7F"\\]/g, function(c, i) {
        switch(c){
            case "\"":
            case "\\":
                return "\\" + c;
            case "\x07":
                return "\\a";
            case "\b":
                return "\\b";
            case "\f":
                return "\\f";
            case "\n":
                return "\\n";
            case "\r":
                return "\\r";
            case "\t":
                return "\\t";
            case "\v":
                return "\\v";
        }
        var k = i + 1;
        var empty = k < l && s[k] >= "0" && s[k] <= "9" ? "\\&" : "";
        return "\\" + c.charCodeAt(0).toString(10) + empty;
    }) + "\"";
};
const $ab7d2790bedac8b4$export$a23154580f12ac67 = function(f) {
    return function(xs) {
        var ss = [];
        for(var i = 0, l = xs.length; i < l; i++)ss[i] = f(xs[i]);
        return "[" + ss.join(",") + "]";
    };
};

});



parcelRegister("h2xUu", function(module, exports) {

$parcel$export(module.exports, "Nothing", () => $c67ced6cbc89321b$export$bebe9059409a0d04);
$parcel$export(module.exports, "Just", () => $c67ced6cbc89321b$export$8a67b48435b5d073);
$parcel$export(module.exports, "showMaybe", () => $c67ced6cbc89321b$export$9b814e760fdd264a);
$parcel$export(module.exports, "maybe$prime", () => $c67ced6cbc89321b$export$76f250758a65e763);
$parcel$export(module.exports, "maybe", () => $c67ced6cbc89321b$export$f8b8b9ce72e9ccbf);
$parcel$export(module.exports, "isNothing", () => $c67ced6cbc89321b$export$4967676db1b89293);
$parcel$export(module.exports, "isJust", () => $c67ced6cbc89321b$export$c15bd07a493e1236);
$parcel$export(module.exports, "functorMaybe", () => $c67ced6cbc89321b$export$fdd2427f0e60fd66);
$parcel$export(module.exports, "invariantMaybe", () => $c67ced6cbc89321b$export$62eda6ff839a0571);
$parcel$export(module.exports, "fromMaybe", () => $c67ced6cbc89321b$export$43db023a260c5e9f);
$parcel$export(module.exports, "fromJust", () => $c67ced6cbc89321b$export$2506262575dd10a7);
$parcel$export(module.exports, "extendMaybe", () => $c67ced6cbc89321b$export$cb6d304dbd10aa95);
$parcel$export(module.exports, "eqMaybe", () => $c67ced6cbc89321b$export$8f45bb76abf9699e);
$parcel$export(module.exports, "ordMaybe", () => $c67ced6cbc89321b$export$e35c29f98d259c46);
$parcel$export(module.exports, "eq1Maybe", () => $c67ced6cbc89321b$export$b59095d05faa8cf6);
$parcel$export(module.exports, "ord1Maybe", () => $c67ced6cbc89321b$export$c82772423d5de0b);
$parcel$export(module.exports, "boundedMaybe", () => $c67ced6cbc89321b$export$158982e65b249847);
$parcel$export(module.exports, "applyMaybe", () => $c67ced6cbc89321b$export$22d9917da16590e7);
$parcel$export(module.exports, "bindMaybe", () => $c67ced6cbc89321b$export$e5fea5661dee377);
$parcel$export(module.exports, "applicativeMaybe", () => $c67ced6cbc89321b$export$b203ef4465f15037);
$parcel$export(module.exports, "monadMaybe", () => $c67ced6cbc89321b$export$f78a1c2d38efcc13);
$parcel$export(module.exports, "alternativeMaybe", () => $c67ced6cbc89321b$export$92d23d3d8fa78a80);
// Generated by purs version 0.15.16

var $56VjJ = parcelRequire("56VjJ");

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $26SV5 = parcelRequire("26SV5");

var $8zsOy = parcelRequire("8zsOy");

var $aJhEx = parcelRequire("aJhEx");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $7nwca = parcelRequire("7nwca");

var $ebQYe = parcelRequire("ebQYe");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $d5vvq = parcelRequire("d5vvq");

var $iVjQa = parcelRequire("iVjQa");

var $2XxiF = parcelRequire("2XxiF");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
var $c67ced6cbc89321b$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $c67ced6cbc89321b$export$bebe9059409a0d04 = /* #__PURE__ */ function() {
    function Nothing() {}
    Nothing.value = new Nothing();
    return Nothing;
}();
var $c67ced6cbc89321b$export$8a67b48435b5d073 = /* #__PURE__ */ function() {
    function Just(value0) {
        this.value0 = value0;
    }
    Just.create = function(value0) {
        return new Just(value0);
    };
    return Just;
}();
var $c67ced6cbc89321b$export$9b814e760fdd264a = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(v) {
            if (v instanceof $c67ced6cbc89321b$export$8a67b48435b5d073) return "(Just " + (show(v.value0) + ")");
            if (v instanceof $c67ced6cbc89321b$export$bebe9059409a0d04) return "Nothing";
            throw new Error("Failed pattern match at Data.Maybe (line 223, column 1 - line 225, column 28): " + [
                v.constructor.name
            ]);
        }
    };
};
var $c67ced6cbc89321b$export$fb85b8a3a6158141 = function(dictSemigroup) {
    var append1 = $d5vvq.append(dictSemigroup);
    return {
        append: function(v) {
            return function(v1) {
                if (v instanceof $c67ced6cbc89321b$export$bebe9059409a0d04) return v1;
                if (v1 instanceof $c67ced6cbc89321b$export$bebe9059409a0d04) return v;
                if (v instanceof $c67ced6cbc89321b$export$8a67b48435b5d073 && v1 instanceof $c67ced6cbc89321b$export$8a67b48435b5d073) return new $c67ced6cbc89321b$export$8a67b48435b5d073(append1(v.value0)(v1.value0));
                throw new Error("Failed pattern match at Data.Maybe (line 182, column 1 - line 185, column 43): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        }
    };
};
var $c67ced6cbc89321b$export$516e28dec6a4b6d4 = function(dictAlt) {
    var alt = $56VjJ.alt(dictAlt);
    var map1 = $7FzSN.map(dictAlt.Functor0());
    return function(dictApplicative) {
        var pure = $bQdkN.pure(dictApplicative);
        return function(a) {
            return alt(map1($c67ced6cbc89321b$export$8a67b48435b5d073.create)(a))(pure($c67ced6cbc89321b$export$bebe9059409a0d04.value));
        };
    };
};
var $c67ced6cbc89321b$export$89fc9eb1adf8ed28 = function(dictSemigroup) {
    var semigroupMaybe1 = $c67ced6cbc89321b$export$fb85b8a3a6158141(dictSemigroup);
    return {
        mempty: $c67ced6cbc89321b$export$bebe9059409a0d04.value,
        Semigroup0: function() {
            return semigroupMaybe1;
        }
    };
};
var $c67ced6cbc89321b$export$76f250758a65e763 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $c67ced6cbc89321b$export$bebe9059409a0d04) return v($ivFwO.unit);
            if (v2 instanceof $c67ced6cbc89321b$export$8a67b48435b5d073) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Maybe (line 250, column 1 - line 250, column 62): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $c67ced6cbc89321b$export$f8b8b9ce72e9ccbf = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $c67ced6cbc89321b$export$bebe9059409a0d04) return v;
            if (v2 instanceof $c67ced6cbc89321b$export$8a67b48435b5d073) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Maybe (line 237, column 1 - line 237, column 51): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $c67ced6cbc89321b$export$4967676db1b89293 = /* #__PURE__ */ $c67ced6cbc89321b$export$f8b8b9ce72e9ccbf(true)(/* #__PURE__ */ $jhsiw.const(false));
var $c67ced6cbc89321b$export$c15bd07a493e1236 = /* #__PURE__ */ $c67ced6cbc89321b$export$f8b8b9ce72e9ccbf(false)(/* #__PURE__ */ $jhsiw.const(true));
var $c67ced6cbc89321b$export$a1265319b56c5090 = {
    to: function(x) {
        if (x instanceof $ebQYe.Inl) return $c67ced6cbc89321b$export$bebe9059409a0d04.value;
        if (x instanceof $ebQYe.Inr) return new $c67ced6cbc89321b$export$8a67b48435b5d073(x.value0);
        throw new Error("Failed pattern match at Data.Maybe (line 227, column 1 - line 227, column 52): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $c67ced6cbc89321b$export$bebe9059409a0d04) return new $ebQYe.Inl($ebQYe.NoArguments.value);
        if (x instanceof $c67ced6cbc89321b$export$8a67b48435b5d073) return new $ebQYe.Inr(x.value0);
        throw new Error("Failed pattern match at Data.Maybe (line 227, column 1 - line 227, column 52): " + [
            x.constructor.name
        ]);
    }
};
var $c67ced6cbc89321b$export$fdd2427f0e60fd66 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $c67ced6cbc89321b$export$8a67b48435b5d073) return new $c67ced6cbc89321b$export$8a67b48435b5d073(v(v1.value0));
            return $c67ced6cbc89321b$export$bebe9059409a0d04.value;
        };
    }
};
var $c67ced6cbc89321b$var$map = /* #__PURE__ */ $7FzSN.map($c67ced6cbc89321b$export$fdd2427f0e60fd66);
var $c67ced6cbc89321b$export$62eda6ff839a0571 = {
    imap: /* #__PURE__ */ $7nwca.imapF($c67ced6cbc89321b$export$fdd2427f0e60fd66)
};
var $c67ced6cbc89321b$export$770f48d991b0f2a2 = function(a) {
    return $c67ced6cbc89321b$export$76f250758a65e763(a)($c67ced6cbc89321b$var$identity);
};
var $c67ced6cbc89321b$export$43db023a260c5e9f = function(a) {
    return $c67ced6cbc89321b$export$f8b8b9ce72e9ccbf(a)($c67ced6cbc89321b$var$identity);
};
var $c67ced6cbc89321b$export$2506262575dd10a7 = function() {
    return function(v) {
        if (v instanceof $c67ced6cbc89321b$export$8a67b48435b5d073) return v.value0;
        throw new Error("Failed pattern match at Data.Maybe (line 288, column 1 - line 288, column 46): " + [
            v.constructor.name
        ]);
    };
};
var $c67ced6cbc89321b$export$cb6d304dbd10aa95 = {
    extend: function(v) {
        return function(v1) {
            if (v1 instanceof $c67ced6cbc89321b$export$bebe9059409a0d04) return $c67ced6cbc89321b$export$bebe9059409a0d04.value;
            return new $c67ced6cbc89321b$export$8a67b48435b5d073(v(v1));
        };
    },
    Functor0: function() {
        return $c67ced6cbc89321b$export$fdd2427f0e60fd66;
    }
};
var $c67ced6cbc89321b$export$8f45bb76abf9699e = function(dictEq) {
    var eq = $aJhEx.eq(dictEq);
    return {
        eq: function(x) {
            return function(y) {
                if (x instanceof $c67ced6cbc89321b$export$bebe9059409a0d04 && y instanceof $c67ced6cbc89321b$export$bebe9059409a0d04) return true;
                if (x instanceof $c67ced6cbc89321b$export$8a67b48435b5d073 && y instanceof $c67ced6cbc89321b$export$8a67b48435b5d073) return eq(x.value0)(y.value0);
                return false;
            };
        }
    };
};
var $c67ced6cbc89321b$export$e35c29f98d259c46 = function(dictOrd) {
    var compare = $gwBF5.compare(dictOrd);
    var eqMaybe1 = $c67ced6cbc89321b$export$8f45bb76abf9699e(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                if (x instanceof $c67ced6cbc89321b$export$bebe9059409a0d04 && y instanceof $c67ced6cbc89321b$export$bebe9059409a0d04) return $ibsD5.EQ.value;
                if (x instanceof $c67ced6cbc89321b$export$bebe9059409a0d04) return $ibsD5.LT.value;
                if (y instanceof $c67ced6cbc89321b$export$bebe9059409a0d04) return $ibsD5.GT.value;
                if (x instanceof $c67ced6cbc89321b$export$8a67b48435b5d073 && y instanceof $c67ced6cbc89321b$export$8a67b48435b5d073) return compare(x.value0)(y.value0);
                throw new Error("Failed pattern match at Data.Maybe (line 0, column 0 - line 0, column 0): " + [
                    x.constructor.name,
                    y.constructor.name
                ]);
            };
        },
        Eq0: function() {
            return eqMaybe1;
        }
    };
};
var $c67ced6cbc89321b$export$b59095d05faa8cf6 = {
    eq1: function(dictEq) {
        return $aJhEx.eq($c67ced6cbc89321b$export$8f45bb76abf9699e(dictEq));
    }
};
var $c67ced6cbc89321b$export$c82772423d5de0b = {
    compare1: function(dictOrd) {
        return $gwBF5.compare($c67ced6cbc89321b$export$e35c29f98d259c46(dictOrd));
    },
    Eq10: function() {
        return $c67ced6cbc89321b$export$b59095d05faa8cf6;
    }
};
var $c67ced6cbc89321b$export$158982e65b249847 = function(dictBounded) {
    var ordMaybe1 = $c67ced6cbc89321b$export$e35c29f98d259c46(dictBounded.Ord0());
    return {
        top: new $c67ced6cbc89321b$export$8a67b48435b5d073($8zsOy.top(dictBounded)),
        bottom: $c67ced6cbc89321b$export$bebe9059409a0d04.value,
        Ord0: function() {
            return ordMaybe1;
        }
    };
};
var $c67ced6cbc89321b$export$22d9917da16590e7 = {
    apply: function(v) {
        return function(v1) {
            if (v instanceof $c67ced6cbc89321b$export$8a67b48435b5d073) return $c67ced6cbc89321b$var$map(v.value0)(v1);
            if (v instanceof $c67ced6cbc89321b$export$bebe9059409a0d04) return $c67ced6cbc89321b$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Data.Maybe (line 67, column 1 - line 69, column 30): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $c67ced6cbc89321b$export$fdd2427f0e60fd66;
    }
};
var $c67ced6cbc89321b$var$apply = /* #__PURE__ */ $26ZCq.apply($c67ced6cbc89321b$export$22d9917da16590e7);
var $c67ced6cbc89321b$export$e5fea5661dee377 = {
    bind: function(v) {
        return function(v1) {
            if (v instanceof $c67ced6cbc89321b$export$8a67b48435b5d073) return v1(v.value0);
            if (v instanceof $c67ced6cbc89321b$export$bebe9059409a0d04) return $c67ced6cbc89321b$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Data.Maybe (line 125, column 1 - line 127, column 28): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Apply0: function() {
        return $c67ced6cbc89321b$export$22d9917da16590e7;
    }
};
var $c67ced6cbc89321b$export$9e0396ae96a86801 = function(dictSemiring) {
    var add = $iVjQa.add(dictSemiring);
    var mul = $iVjQa.mul(dictSemiring);
    return {
        zero: $c67ced6cbc89321b$export$bebe9059409a0d04.value,
        one: new $c67ced6cbc89321b$export$8a67b48435b5d073($iVjQa.one(dictSemiring)),
        add: function(v) {
            return function(v1) {
                if (v instanceof $c67ced6cbc89321b$export$bebe9059409a0d04) return v1;
                if (v1 instanceof $c67ced6cbc89321b$export$bebe9059409a0d04) return v;
                if (v instanceof $c67ced6cbc89321b$export$8a67b48435b5d073 && v1 instanceof $c67ced6cbc89321b$export$8a67b48435b5d073) return new $c67ced6cbc89321b$export$8a67b48435b5d073(add(v.value0)(v1.value0));
                throw new Error("Failed pattern match at Data.Maybe (line 190, column 1 - line 198, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        },
        mul: function(x) {
            return function(y) {
                return $c67ced6cbc89321b$var$apply($c67ced6cbc89321b$var$map(mul)(x))(y);
            };
        }
    };
};
var $c67ced6cbc89321b$export$b203ef4465f15037 = /* #__PURE__ */ function() {
    return {
        pure: $c67ced6cbc89321b$export$8a67b48435b5d073.create,
        Apply0: function() {
            return $c67ced6cbc89321b$export$22d9917da16590e7;
        }
    };
}();
var $c67ced6cbc89321b$export$f78a1c2d38efcc13 = {
    Applicative0: function() {
        return $c67ced6cbc89321b$export$b203ef4465f15037;
    },
    Bind1: function() {
        return $c67ced6cbc89321b$export$e5fea5661dee377;
    }
};
var $c67ced6cbc89321b$export$a22c94fdeac581ff = {
    alt: function(v) {
        return function(v1) {
            if (v instanceof $c67ced6cbc89321b$export$bebe9059409a0d04) return v1;
            return v;
        };
    },
    Functor0: function() {
        return $c67ced6cbc89321b$export$fdd2427f0e60fd66;
    }
};
var $c67ced6cbc89321b$export$164e6bcbae9cfdd0 = /* #__PURE__ */ function() {
    return {
        empty: $c67ced6cbc89321b$export$bebe9059409a0d04.value,
        Alt0: function() {
            return $c67ced6cbc89321b$export$a22c94fdeac581ff;
        }
    };
}();
var $c67ced6cbc89321b$export$92d23d3d8fa78a80 = {
    Applicative0: function() {
        return $c67ced6cbc89321b$export$b203ef4465f15037;
    },
    Plus1: function() {
        return $c67ced6cbc89321b$export$164e6bcbae9cfdd0;
    }
};

});


parcelRegister("1rTTn", function(module, exports) {

$parcel$export(module.exports, "monadEffect", () => $10e3ab1b4b429816$export$7e900d895707a1af);
$parcel$export(module.exports, "applicativeEffect", () => $10e3ab1b4b429816$export$89bf999217d3022a);
$parcel$export(module.exports, "bindEffect", () => $10e3ab1b4b429816$export$855330f8a2a9f2e8);
$parcel$export(module.exports, "functorEffect", () => $10e3ab1b4b429816$export$91fce01ecf0438e1);
$parcel$export(module.exports, "applyEffect", () => $10e3ab1b4b429816$export$59a7b217c53300d2);
$parcel$export(module.exports, "semigroupEffect", () => $10e3ab1b4b429816$export$58139e981c60cf43);
$parcel$export(module.exports, "monoidEffect", () => $10e3ab1b4b429816$export$2d8226ee4b2722f7);
// Generated by purs version 0.15.16

var $goqL2 = parcelRequire("goqL2");

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $kkdfo = parcelRequire("kkdfo");

var $3aOYV = parcelRequire("3aOYV");

var $d5vvq = parcelRequire("d5vvq");
var $10e3ab1b4b429816$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $10e3ab1b4b429816$export$7e900d895707a1af = {
    Applicative0: function() {
        return $10e3ab1b4b429816$export$89bf999217d3022a;
    },
    Bind1: function() {
        return $10e3ab1b4b429816$export$855330f8a2a9f2e8;
    }
};
var $10e3ab1b4b429816$export$855330f8a2a9f2e8 = {
    bind: $goqL2.bindE,
    Apply0: function() {
        return $10e3ab1b4b429816$var$$lazy_applyEffect(0);
    }
};
var $10e3ab1b4b429816$export$89bf999217d3022a = {
    pure: $goqL2.pureE,
    Apply0: function() {
        return $10e3ab1b4b429816$var$$lazy_applyEffect(0);
    }
};
var $10e3ab1b4b429816$var$$lazy_functorEffect = /* #__PURE__ */ $10e3ab1b4b429816$var$$runtime_lazy("functorEffect", "Effect", function() {
    return {
        map: $bQdkN.liftA1($10e3ab1b4b429816$export$89bf999217d3022a)
    };
});
var $10e3ab1b4b429816$var$$lazy_applyEffect = /* #__PURE__ */ $10e3ab1b4b429816$var$$runtime_lazy("applyEffect", "Effect", function() {
    return {
        apply: $kkdfo.ap($10e3ab1b4b429816$export$7e900d895707a1af),
        Functor0: function() {
            return $10e3ab1b4b429816$var$$lazy_functorEffect(0);
        }
    };
});
var $10e3ab1b4b429816$export$91fce01ecf0438e1 = /* #__PURE__ */ $10e3ab1b4b429816$var$$lazy_functorEffect(20);
var $10e3ab1b4b429816$export$59a7b217c53300d2 = /* #__PURE__ */ $10e3ab1b4b429816$var$$lazy_applyEffect(23);
var $10e3ab1b4b429816$var$lift2 = /* #__PURE__ */ $26ZCq.lift2($10e3ab1b4b429816$export$59a7b217c53300d2);
var $10e3ab1b4b429816$export$58139e981c60cf43 = function(dictSemigroup) {
    return {
        append: $10e3ab1b4b429816$var$lift2($d5vvq.append(dictSemigroup))
    };
};
var $10e3ab1b4b429816$export$2d8226ee4b2722f7 = function(dictMonoid) {
    var semigroupEffect1 = $10e3ab1b4b429816$export$58139e981c60cf43(dictMonoid.Semigroup0());
    return {
        mempty: $goqL2.pureE($3aOYV.mempty(dictMonoid)),
        Semigroup0: function() {
            return semigroupEffect1;
        }
    };
};

});
parcelRegister("goqL2", function(module, exports) {

$parcel$export(module.exports, "pureE", () => $bef3a4ba6b9a469a$export$f6d4f01ca39c2fe);
$parcel$export(module.exports, "bindE", () => $bef3a4ba6b9a469a$export$b771a24b80e4c766);
const $bef3a4ba6b9a469a$export$f6d4f01ca39c2fe = function(a) {
    return function() {
        return a;
    };
};
const $bef3a4ba6b9a469a$export$b771a24b80e4c766 = function(a) {
    return function(f) {
        return function() {
            return f(a())();
        };
    };
};
const $bef3a4ba6b9a469a$export$161ebd47ed3ced60 = function(f) {
    return function() {
        while(!f());
    };
};
const $bef3a4ba6b9a469a$export$27334490557f84d2 = function(f) {
    return function(a) {
        return function() {
            while(f())a();
        };
    };
};
const $bef3a4ba6b9a469a$export$3dfbdd78bf0090db = function(lo) {
    return function(hi) {
        return function(f) {
            return function() {
                for(var i = lo; i < hi; i++)f(i)();
            };
        };
    };
};
const $bef3a4ba6b9a469a$export$eff012ca4e6ded0b = function(as) {
    return function(f) {
        return function() {
            for(var i = 0, l = as.length; i < l; i++)f(as[i])();
        };
    };
};

});

parcelRegister("kkdfo", function(module, exports) {

$parcel$export(module.exports, "unlessM", () => $ecbff385d18db1dd$export$551dd5524146e426);
$parcel$export(module.exports, "monadFn", () => $ecbff385d18db1dd$export$513f938006a06509);
$parcel$export(module.exports, "liftM1", () => $ecbff385d18db1dd$export$167848c32e61a4d4);
$parcel$export(module.exports, "ap", () => $ecbff385d18db1dd$export$2f6ca3d3b1f80bf5);
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $7FzSN = parcelRequire("7FzSN");
var $ecbff385d18db1dd$export$7e7b1df9f5185791 = function(dictMonad) {
    var bind = $cADnC.bind(dictMonad.Bind1());
    var when = $bQdkN.when(dictMonad.Applicative0());
    return function(mb) {
        return function(m) {
            return bind(mb)(function(b) {
                return when(b)(m);
            });
        };
    };
};
var $ecbff385d18db1dd$export$551dd5524146e426 = function(dictMonad) {
    var bind = $cADnC.bind(dictMonad.Bind1());
    var unless = $bQdkN.unless(dictMonad.Applicative0());
    return function(mb) {
        return function(m) {
            return bind(mb)(function(b) {
                return unless(b)(m);
            });
        };
    };
};
var $ecbff385d18db1dd$export$d34b9ad93b1f095a = {
    Applicative0: function() {
        return $bQdkN.applicativeProxy;
    },
    Bind1: function() {
        return $cADnC.bindProxy;
    }
};
var $ecbff385d18db1dd$export$513f938006a06509 = {
    Applicative0: function() {
        return $bQdkN.applicativeFn;
    },
    Bind1: function() {
        return $cADnC.bindFn;
    }
};
var $ecbff385d18db1dd$export$68aea3a98a23c265 = {
    Applicative0: function() {
        return $bQdkN.applicativeArray;
    },
    Bind1: function() {
        return $cADnC.bindArray;
    }
};
var $ecbff385d18db1dd$export$167848c32e61a4d4 = function(dictMonad) {
    var bind = $cADnC.bind(dictMonad.Bind1());
    var pure = $bQdkN.pure(dictMonad.Applicative0());
    return function(f) {
        return function(a) {
            return bind(a)(function(a$prime) {
                return pure(f(a$prime));
            });
        };
    };
};
var $ecbff385d18db1dd$export$2f6ca3d3b1f80bf5 = function(dictMonad) {
    var bind = $cADnC.bind(dictMonad.Bind1());
    var pure = $bQdkN.pure(dictMonad.Applicative0());
    return function(f) {
        return function(a) {
            return bind(f)(function(f$prime) {
                return bind(a)(function(a$prime) {
                    return pure(f$prime(a$prime));
                });
            });
        };
    };
};

});

parcelRegister("3aOYV", function(module, exports) {

$parcel$export(module.exports, "monoidUnit", () => $24f9da30898e911b$export$852b4040eee6c6ba);
$parcel$export(module.exports, "monoidString", () => $24f9da30898e911b$export$fc39f3d77fa2e58a);
$parcel$export(module.exports, "mempty", () => $24f9da30898e911b$export$9a7d64bc1d75357);
$parcel$export(module.exports, "monoidFn", () => $24f9da30898e911b$export$192e81b9fe7e4abe);
// Generated by purs version 0.15.16

var $iQTlW = parcelRequire("iQTlW");

var $8tuSi = parcelRequire("8tuSi");

var $ibsD5 = parcelRequire("ibsD5");

var $d5vvq = parcelRequire("d5vvq");

var $3Xcli = parcelRequire("3Xcli");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
parcelRequire("lMTwl");
var $hV6x3 = parcelRequire("hV6x3");

var $g13tD = parcelRequire("g13tD");
var $24f9da30898e911b$var$semigroupRecord = /* #__PURE__ */ $d5vvq.semigroupRecord();
var $24f9da30898e911b$var$mod = /* #__PURE__ */ $8tuSi.mod($8tuSi.euclideanRingInt);
var $24f9da30898e911b$var$div = /* #__PURE__ */ $8tuSi.div($8tuSi.euclideanRingInt);
var $24f9da30898e911b$export$852b4040eee6c6ba = {
    mempty: $ivFwO.unit,
    Semigroup0: function() {
        return $d5vvq.semigroupUnit;
    }
};
var $24f9da30898e911b$export$fc39f3d77fa2e58a = {
    mempty: "",
    Semigroup0: function() {
        return $d5vvq.semigroupString;
    }
};
var $24f9da30898e911b$export$254fca207e30c208 = {
    memptyRecord: function(v) {
        return {};
    },
    SemigroupRecord0: function() {
        return $d5vvq.semigroupRecordNil;
    }
};
var $24f9da30898e911b$export$84dd8432d2bb1dc3 = /* #__PURE__ */ function() {
    return {
        mempty: $ibsD5.EQ.value,
        Semigroup0: function() {
            return $ibsD5.semigroupOrdering;
        }
    };
}();
var $24f9da30898e911b$export$db307f59121ffcc4 = {
    mempty: [],
    Semigroup0: function() {
        return $d5vvq.semigroupArray;
    }
};
var $24f9da30898e911b$export$ae16212c99887b7f = function(dict) {
    return dict.memptyRecord;
};
var $24f9da30898e911b$export$b6526a2ab5064058 = function() {
    return function(dictMonoidRecord) {
        var semigroupRecord1 = $24f9da30898e911b$var$semigroupRecord(dictMonoidRecord.SemigroupRecord0());
        return {
            mempty: $24f9da30898e911b$export$ae16212c99887b7f(dictMonoidRecord)($g13tD.Proxy.value),
            Semigroup0: function() {
                return semigroupRecord1;
            }
        };
    };
};
var $24f9da30898e911b$export$9a7d64bc1d75357 = function(dict) {
    return dict.mempty;
};
var $24f9da30898e911b$export$192e81b9fe7e4abe = function(dictMonoid) {
    var mempty1 = $24f9da30898e911b$export$9a7d64bc1d75357(dictMonoid);
    var semigroupFn = $d5vvq.semigroupFn(dictMonoid.Semigroup0());
    return {
        mempty: function(v) {
            return mempty1;
        },
        Semigroup0: function() {
            return semigroupFn;
        }
    };
};
var $24f9da30898e911b$export$d672019c76a5af4a = function(dictIsSymbol) {
    var reflectSymbol = $3Xcli.reflectSymbol(dictIsSymbol);
    var semigroupRecordCons = $d5vvq.semigroupRecordCons(dictIsSymbol)();
    return function(dictMonoid) {
        var mempty1 = $24f9da30898e911b$export$9a7d64bc1d75357(dictMonoid);
        var Semigroup0 = dictMonoid.Semigroup0();
        return function() {
            return function(dictMonoidRecord) {
                var memptyRecord1 = $24f9da30898e911b$export$ae16212c99887b7f(dictMonoidRecord);
                var semigroupRecordCons1 = semigroupRecordCons(dictMonoidRecord.SemigroupRecord0())(Semigroup0);
                return {
                    memptyRecord: function(v) {
                        var tail = memptyRecord1($g13tD.Proxy.value);
                        var key = reflectSymbol($g13tD.Proxy.value);
                        var insert = $hV6x3.unsafeSet(key);
                        return insert(mempty1)(tail);
                    },
                    SemigroupRecord0: function() {
                        return semigroupRecordCons1;
                    }
                };
            };
        };
    };
};
var $24f9da30898e911b$export$836601bcef5ff40 = function(dictMonoid) {
    var mempty1 = $24f9da30898e911b$export$9a7d64bc1d75357(dictMonoid);
    var append = $d5vvq.append(dictMonoid.Semigroup0());
    return function(x) {
        var go = function(p) {
            if (p <= 0) return mempty1;
            if (p === 1) return x;
            if ($24f9da30898e911b$var$mod(p)(2) === 0) {
                var x$prime = go($24f9da30898e911b$var$div(p)(2));
                return append(x$prime)(x$prime);
            }
            if ($iQTlW.otherwise) {
                var x$prime = go($24f9da30898e911b$var$div(p)(2));
                return append(x$prime)(append(x$prime)(x));
            }
            throw new Error("Failed pattern match at Data.Monoid (line 88, column 3 - line 88, column 17): " + [
                p.constructor.name
            ]);
        };
        return go;
    };
};
var $24f9da30898e911b$export$864d727b48066337 = function(dictMonoid) {
    var mempty1 = $24f9da30898e911b$export$9a7d64bc1d75357(dictMonoid);
    return function(v) {
        return function(v1) {
            if (v) return v1;
            if (!v) return mempty1;
            throw new Error("Failed pattern match at Data.Monoid (line 96, column 1 - line 96, column 49): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};

});
parcelRegister("8tuSi", function(module, exports) {

$parcel$export(module.exports, "mod", () => $62b8fb3a38cbc554$export$842a2cf37af977e1);
$parcel$export(module.exports, "euclideanRingInt", () => $62b8fb3a38cbc554$export$437776face1858ae);
$parcel$export(module.exports, "div", () => $62b8fb3a38cbc554$export$159d9494db57879b);
$parcel$export(module.exports, "degree", () => $62b8fb3a38cbc554$export$a23b7da4bc008930);
// Generated by purs version 0.15.16

var $6m9lc = parcelRequire("6m9lc");

var $bozfm = parcelRequire("bozfm");

var $aJhEx = parcelRequire("aJhEx");

var $aop8q = parcelRequire("aop8q");

var $iVjQa = parcelRequire("iVjQa");
var $62b8fb3a38cbc554$export$842a2cf37af977e1 = function(dict) {
    return dict.mod;
};
var $62b8fb3a38cbc554$export$f81847884871263e = function(dictEq) {
    var eq = $aJhEx.eq(dictEq);
    return function(dictEuclideanRing) {
        var zero = $iVjQa.zero(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0());
        var mod1 = $62b8fb3a38cbc554$export$842a2cf37af977e1(dictEuclideanRing);
        return function(a) {
            return function(b) {
                var $24 = eq(b)(zero);
                if ($24) return a;
                return $62b8fb3a38cbc554$export$f81847884871263e(dictEq)(dictEuclideanRing)(b)(mod1(a)(b));
            };
        };
    };
};
var $62b8fb3a38cbc554$export$ea62662521882766 = {
    degree: function(v) {
        return 1;
    },
    div: $6m9lc.numDiv,
    mod: function(v) {
        return function(v1) {
            return 0.0;
        };
    },
    CommutativeRing0: function() {
        return $bozfm.commutativeRingNumber;
    }
};
var $62b8fb3a38cbc554$export$437776face1858ae = {
    degree: $6m9lc.intDegree,
    div: $6m9lc.intDiv,
    mod: $6m9lc.intMod,
    CommutativeRing0: function() {
        return $bozfm.commutativeRingInt;
    }
};
var $62b8fb3a38cbc554$export$159d9494db57879b = function(dict) {
    return dict.div;
};
var $62b8fb3a38cbc554$export$f686d97e407ec4ef = function(dictEq) {
    var eq = $aJhEx.eq(dictEq);
    var gcd1 = $62b8fb3a38cbc554$export$f81847884871263e(dictEq);
    return function(dictEuclideanRing) {
        var Semiring0 = dictEuclideanRing.CommutativeRing0().Ring0().Semiring0();
        var zero = $iVjQa.zero(Semiring0);
        var div1 = $62b8fb3a38cbc554$export$159d9494db57879b(dictEuclideanRing);
        var mul = $iVjQa.mul(Semiring0);
        var gcd2 = gcd1(dictEuclideanRing);
        return function(a) {
            return function(b) {
                var $26 = eq(a)(zero) || eq(b)(zero);
                if ($26) return zero;
                return div1(mul(a)(b))(gcd2(a)(b));
            };
        };
    };
};
var $62b8fb3a38cbc554$export$a23b7da4bc008930 = function(dict) {
    return dict.degree;
};

});
parcelRegister("6m9lc", function(module, exports) {

$parcel$export(module.exports, "intDegree", () => $4a0c0b103c3cde69$export$748d824f642f540d);
$parcel$export(module.exports, "intDiv", () => $4a0c0b103c3cde69$export$baf7824ae32165f5);
$parcel$export(module.exports, "intMod", () => $4a0c0b103c3cde69$export$faa51fbcd7b05d8f);
$parcel$export(module.exports, "numDiv", () => $4a0c0b103c3cde69$export$6db30f2997f70499);
const $4a0c0b103c3cde69$export$748d824f642f540d = function(x) {
    return Math.min(Math.abs(x), 2147483647);
};
const $4a0c0b103c3cde69$export$baf7824ae32165f5 = function(x) {
    return function(y) {
        if (y === 0) return 0;
        return y > 0 ? Math.floor(x / y) : -Math.floor(x / -y);
    };
};
const $4a0c0b103c3cde69$export$faa51fbcd7b05d8f = function(x) {
    return function(y) {
        if (y === 0) return 0;
        var yy = Math.abs(y);
        return (x % yy + yy) % yy;
    };
};
const $4a0c0b103c3cde69$export$6db30f2997f70499 = function(n1) {
    return function(n2) {
        return n1 / n2;
    };
};

});

parcelRegister("bozfm", function(module, exports) {

$parcel$export(module.exports, "commutativeRingNumber", () => $84bd46e25812b9c1$export$ed11bb9ee1d36807);
$parcel$export(module.exports, "commutativeRingInt", () => $84bd46e25812b9c1$export$5745e05f6b169cee);
// Generated by purs version 0.15.16

var $aop8q = parcelRequire("aop8q");

var $iVjQa = parcelRequire("iVjQa");
var $84bd46e25812b9c1$var$ringRecord = /* #__PURE__ */ $aop8q.ringRecord();
var $84bd46e25812b9c1$export$4fcc4024c8011653 = {
    Ring0: function() {
        return $aop8q.ringUnit;
    }
};
var $84bd46e25812b9c1$export$a2ce2b4503316dcc = {
    RingRecord0: function() {
        return $aop8q.ringRecordNil;
    }
};
var $84bd46e25812b9c1$export$dc394faf01ed3f4e = function(dictIsSymbol) {
    var ringRecordCons = $aop8q.ringRecordCons(dictIsSymbol)();
    return function() {
        return function(dictCommutativeRingRecord) {
            var ringRecordCons1 = ringRecordCons(dictCommutativeRingRecord.RingRecord0());
            return function(dictCommutativeRing) {
                var ringRecordCons2 = ringRecordCons1(dictCommutativeRing.Ring0());
                return {
                    RingRecord0: function() {
                        return ringRecordCons2;
                    }
                };
            };
        };
    };
};
var $84bd46e25812b9c1$export$d4bbb7afedb09bfd = function() {
    return function(dictCommutativeRingRecord) {
        var ringRecord1 = $84bd46e25812b9c1$var$ringRecord(dictCommutativeRingRecord.RingRecord0());
        return {
            Ring0: function() {
                return ringRecord1;
            }
        };
    };
};
var $84bd46e25812b9c1$export$7f39ee449b822938 = {
    Ring0: function() {
        return $aop8q.ringProxy;
    }
};
var $84bd46e25812b9c1$export$ed11bb9ee1d36807 = {
    Ring0: function() {
        return $aop8q.ringNumber;
    }
};
var $84bd46e25812b9c1$export$5745e05f6b169cee = {
    Ring0: function() {
        return $aop8q.ringInt;
    }
};
var $84bd46e25812b9c1$export$bdad616b79aca10 = function(dictCommutativeRing) {
    var ringFn = $aop8q.ringFn(dictCommutativeRing.Ring0());
    return {
        Ring0: function() {
            return ringFn;
        }
    };
};

});




parcelRegister("7O0Q4", function(module, exports) {

$parcel$export(module.exports, "Tuple", () => $5aedda7c2b102c7b$export$1908877435b1d5e9);
$parcel$export(module.exports, "uncurry", () => $5aedda7c2b102c7b$export$7864d59d01b6d6bf);
$parcel$export(module.exports, "snd", () => $5aedda7c2b102c7b$export$6f71268a1666ab58);
$parcel$export(module.exports, "showTuple", () => $5aedda7c2b102c7b$export$c29279d1dfdefb95);
$parcel$export(module.exports, "functorTuple", () => $5aedda7c2b102c7b$export$19ab04734dcb0ff0);
$parcel$export(module.exports, "fst", () => $5aedda7c2b102c7b$export$9e770fa6ce19a9d6);
$parcel$export(module.exports, "eqTuple", () => $5aedda7c2b102c7b$export$d625e8a97ba36bd6);
$parcel$export(module.exports, "ordTuple", () => $5aedda7c2b102c7b$export$8f11eb03746a66e2);
$parcel$export(module.exports, "curry", () => $5aedda7c2b102c7b$export$c3095a23b368d1f2);
// Generated by purs version 0.15.16

var $dxuBz = parcelRequire("dxuBz");

var $8zsOy = parcelRequire("8zsOy");

var $aJhEx = parcelRequire("aJhEx");

var $7nwca = parcelRequire("7nwca");

var $ebQYe = parcelRequire("ebQYe");

var $IhyKA = parcelRequire("IhyKA");

var $3aOYV = parcelRequire("3aOYV");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $aop8q = parcelRequire("aop8q");

var $d5vvq = parcelRequire("d5vvq");

var $iVjQa = parcelRequire("iVjQa");

var $2XxiF = parcelRequire("2XxiF");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
var $5aedda7c2b102c7b$export$1908877435b1d5e9 = /* #__PURE__ */ function() {
    function Tuple(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Tuple.create = function(value0) {
        return function(value1) {
            return new Tuple(value0, value1);
        };
    };
    return Tuple;
}();
var $5aedda7c2b102c7b$export$7864d59d01b6d6bf = function(f) {
    return function(v) {
        return f(v.value0)(v.value1);
    };
};
var $5aedda7c2b102c7b$export$b0e76d9850c64156 = function(v) {
    return new $5aedda7c2b102c7b$export$1908877435b1d5e9(v.value1, v.value0);
};
var $5aedda7c2b102c7b$export$6f71268a1666ab58 = function(v) {
    return v.value1;
};
var $5aedda7c2b102c7b$export$c29279d1dfdefb95 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return function(dictShow1) {
        var show1 = $2XxiF.show(dictShow1);
        return {
            show: function(v) {
                return "(Tuple " + (show(v.value0) + (" " + (show1(v.value1) + ")")));
            }
        };
    };
};
var $5aedda7c2b102c7b$export$a55548456e48767 = function(dictSemiring) {
    var add = $iVjQa.add(dictSemiring);
    var one = $iVjQa.one(dictSemiring);
    var mul = $iVjQa.mul(dictSemiring);
    var zero = $iVjQa.zero(dictSemiring);
    return function(dictSemiring1) {
        var add1 = $iVjQa.add(dictSemiring1);
        var mul1 = $iVjQa.mul(dictSemiring1);
        return {
            add: function(v) {
                return function(v1) {
                    return new $5aedda7c2b102c7b$export$1908877435b1d5e9(add(v.value0)(v1.value0), add1(v.value1)(v1.value1));
                };
            },
            one: new $5aedda7c2b102c7b$export$1908877435b1d5e9(one, $iVjQa.one(dictSemiring1)),
            mul: function(v) {
                return function(v1) {
                    return new $5aedda7c2b102c7b$export$1908877435b1d5e9(mul(v.value0)(v1.value0), mul1(v.value1)(v1.value1));
                };
            },
            zero: new $5aedda7c2b102c7b$export$1908877435b1d5e9(zero, $iVjQa.zero(dictSemiring1))
        };
    };
};
var $5aedda7c2b102c7b$export$ab2b4b200e457b99 = {
    compose: function(v) {
        return function(v1) {
            return new $5aedda7c2b102c7b$export$1908877435b1d5e9(v1.value0, v.value1);
        };
    }
};
var $5aedda7c2b102c7b$export$1f8404c41aab4117 = function(dictSemigroup) {
    var append1 = $d5vvq.append(dictSemigroup);
    return function(dictSemigroup1) {
        var append2 = $d5vvq.append(dictSemigroup1);
        return {
            append: function(v) {
                return function(v1) {
                    return new $5aedda7c2b102c7b$export$1908877435b1d5e9(append1(v.value0)(v1.value0), append2(v.value1)(v1.value1));
                };
            }
        };
    };
};
var $5aedda7c2b102c7b$export$9ba4b2debe474100 = function(dictRing) {
    var sub = $aop8q.sub(dictRing);
    var semiringTuple1 = $5aedda7c2b102c7b$export$a55548456e48767(dictRing.Semiring0());
    return function(dictRing1) {
        var sub1 = $aop8q.sub(dictRing1);
        var semiringTuple2 = semiringTuple1(dictRing1.Semiring0());
        return {
            sub: function(v) {
                return function(v1) {
                    return new $5aedda7c2b102c7b$export$1908877435b1d5e9(sub(v.value0)(v1.value0), sub1(v.value1)(v1.value1));
                };
            },
            Semiring0: function() {
                return semiringTuple2;
            }
        };
    };
};
var $5aedda7c2b102c7b$export$a9eaa17b3ab5a78d = function(dictMonoid) {
    var mempty = $3aOYV.mempty(dictMonoid);
    var semigroupTuple1 = $5aedda7c2b102c7b$export$1f8404c41aab4117(dictMonoid.Semigroup0());
    return function(dictMonoid1) {
        var semigroupTuple2 = semigroupTuple1(dictMonoid1.Semigroup0());
        return {
            mempty: new $5aedda7c2b102c7b$export$1908877435b1d5e9(mempty, $3aOYV.mempty(dictMonoid1)),
            Semigroup0: function() {
                return semigroupTuple2;
            }
        };
    };
};
var $5aedda7c2b102c7b$export$47e10f15d8f6e8d8 = function(dictHeytingAlgebra) {
    var tt = $IhyKA.tt(dictHeytingAlgebra);
    var ff = $IhyKA.ff(dictHeytingAlgebra);
    var implies = $IhyKA.implies(dictHeytingAlgebra);
    var conj1 = $IhyKA.conj(dictHeytingAlgebra);
    var disj = $IhyKA.disj(dictHeytingAlgebra);
    var not = $IhyKA.not(dictHeytingAlgebra);
    return function(dictHeytingAlgebra1) {
        var implies1 = $IhyKA.implies(dictHeytingAlgebra1);
        var conj2 = $IhyKA.conj(dictHeytingAlgebra1);
        var disj1 = $IhyKA.disj(dictHeytingAlgebra1);
        var not1 = $IhyKA.not(dictHeytingAlgebra1);
        return {
            tt: new $5aedda7c2b102c7b$export$1908877435b1d5e9(tt, $IhyKA.tt(dictHeytingAlgebra1)),
            ff: new $5aedda7c2b102c7b$export$1908877435b1d5e9(ff, $IhyKA.ff(dictHeytingAlgebra1)),
            implies: function(v) {
                return function(v1) {
                    return new $5aedda7c2b102c7b$export$1908877435b1d5e9(implies(v.value0)(v1.value0), implies1(v.value1)(v1.value1));
                };
            },
            conj: function(v) {
                return function(v1) {
                    return new $5aedda7c2b102c7b$export$1908877435b1d5e9(conj1(v.value0)(v1.value0), conj2(v.value1)(v1.value1));
                };
            },
            disj: function(v) {
                return function(v1) {
                    return new $5aedda7c2b102c7b$export$1908877435b1d5e9(disj(v.value0)(v1.value0), disj1(v.value1)(v1.value1));
                };
            },
            not: function(v) {
                return new $5aedda7c2b102c7b$export$1908877435b1d5e9(not(v.value0), not1(v.value1));
            }
        };
    };
};
var $5aedda7c2b102c7b$export$8b71b9e63ea20f7b = {
    to: function(x) {
        return new $5aedda7c2b102c7b$export$1908877435b1d5e9(x.value0, x.value1);
    },
    from: function(x) {
        return new $ebQYe.Product(x.value0, x.value1);
    }
};
var $5aedda7c2b102c7b$export$19ab04734dcb0ff0 = {
    map: function(f) {
        return function(m) {
            return new $5aedda7c2b102c7b$export$1908877435b1d5e9(m.value0, f(m.value1));
        };
    }
};
var $5aedda7c2b102c7b$export$9801206bd382aee0 = {
    imap: /* #__PURE__ */ $7nwca.imapF($5aedda7c2b102c7b$export$19ab04734dcb0ff0)
};
var $5aedda7c2b102c7b$export$9e770fa6ce19a9d6 = function(v) {
    return v.value0;
};
var $5aedda7c2b102c7b$export$28de2725b8db0d42 = function(dictLazy) {
    var defer = $dxuBz.defer(dictLazy);
    return function(dictLazy1) {
        var defer1 = $dxuBz.defer(dictLazy1);
        return {
            defer: function(f) {
                return new $5aedda7c2b102c7b$export$1908877435b1d5e9(defer(function(v) {
                    return $5aedda7c2b102c7b$export$9e770fa6ce19a9d6(f($ivFwO.unit));
                }), defer1(function(v) {
                    return $5aedda7c2b102c7b$export$6f71268a1666ab58(f($ivFwO.unit));
                }));
            }
        };
    };
};
var $5aedda7c2b102c7b$export$1d78bbb1aca8569c = {
    extend: function(f) {
        return function(v) {
            return new $5aedda7c2b102c7b$export$1908877435b1d5e9(v.value0, f(v));
        };
    },
    Functor0: function() {
        return $5aedda7c2b102c7b$export$19ab04734dcb0ff0;
    }
};
var $5aedda7c2b102c7b$export$d625e8a97ba36bd6 = function(dictEq) {
    var eq = $aJhEx.eq(dictEq);
    return function(dictEq1) {
        var eq1 = $aJhEx.eq(dictEq1);
        return {
            eq: function(x) {
                return function(y) {
                    return eq(x.value0)(y.value0) && eq1(x.value1)(y.value1);
                };
            }
        };
    };
};
var $5aedda7c2b102c7b$export$8f11eb03746a66e2 = function(dictOrd) {
    var compare = $gwBF5.compare(dictOrd);
    var eqTuple1 = $5aedda7c2b102c7b$export$d625e8a97ba36bd6(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $gwBF5.compare(dictOrd1);
        var eqTuple2 = eqTuple1(dictOrd1.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    var v = compare(x.value0)(y.value0);
                    if (v instanceof $ibsD5.LT) return $ibsD5.LT.value;
                    if (v instanceof $ibsD5.GT) return $ibsD5.GT.value;
                    return compare1(x.value1)(y.value1);
                };
            },
            Eq0: function() {
                return eqTuple2;
            }
        };
    };
};
var $5aedda7c2b102c7b$export$11462014c11c050e = function(dictEq) {
    var eqTuple1 = $5aedda7c2b102c7b$export$d625e8a97ba36bd6(dictEq);
    return {
        eq1: function(dictEq1) {
            return $aJhEx.eq(eqTuple1(dictEq1));
        }
    };
};
var $5aedda7c2b102c7b$export$2c05c340f808b07c = function(dictOrd) {
    var ordTuple1 = $5aedda7c2b102c7b$export$8f11eb03746a66e2(dictOrd);
    var eq1Tuple1 = $5aedda7c2b102c7b$export$11462014c11c050e(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return $gwBF5.compare(ordTuple1(dictOrd1));
        },
        Eq10: function() {
            return eq1Tuple1;
        }
    };
};
var $5aedda7c2b102c7b$export$c3095a23b368d1f2 = function(f) {
    return function(a) {
        return function(b) {
            return f(new $5aedda7c2b102c7b$export$1908877435b1d5e9(a, b));
        };
    };
};
var $5aedda7c2b102c7b$export$8e995acc5599767e = {
    extract: $5aedda7c2b102c7b$export$6f71268a1666ab58,
    Extend0: function() {
        return $5aedda7c2b102c7b$export$1d78bbb1aca8569c;
    }
};
var $5aedda7c2b102c7b$export$4b53a8a87c01bf43 = function(dictCommutativeRing) {
    var ringTuple1 = $5aedda7c2b102c7b$export$9ba4b2debe474100(dictCommutativeRing.Ring0());
    return function(dictCommutativeRing1) {
        var ringTuple2 = ringTuple1(dictCommutativeRing1.Ring0());
        return {
            Ring0: function() {
                return ringTuple2;
            }
        };
    };
};
var $5aedda7c2b102c7b$export$f1ad4da5028a9f5f = function(dictBounded) {
    var top = $8zsOy.top(dictBounded);
    var bottom = $8zsOy.bottom(dictBounded);
    var ordTuple1 = $5aedda7c2b102c7b$export$8f11eb03746a66e2(dictBounded.Ord0());
    return function(dictBounded1) {
        var ordTuple2 = ordTuple1(dictBounded1.Ord0());
        return {
            top: new $5aedda7c2b102c7b$export$1908877435b1d5e9(top, $8zsOy.top(dictBounded1)),
            bottom: new $5aedda7c2b102c7b$export$1908877435b1d5e9(bottom, $8zsOy.bottom(dictBounded1)),
            Ord0: function() {
                return ordTuple2;
            }
        };
    };
};
var $5aedda7c2b102c7b$export$cc556dd69d46ad4 = function(dictBooleanAlgebra) {
    var heytingAlgebraTuple1 = $5aedda7c2b102c7b$export$47e10f15d8f6e8d8(dictBooleanAlgebra.HeytingAlgebra0());
    return function(dictBooleanAlgebra1) {
        var heytingAlgebraTuple2 = heytingAlgebraTuple1(dictBooleanAlgebra1.HeytingAlgebra0());
        return {
            HeytingAlgebra0: function() {
                return heytingAlgebraTuple2;
            }
        };
    };
};
var $5aedda7c2b102c7b$export$c87751c00e30fc9e = function(dictSemigroup) {
    var append1 = $d5vvq.append(dictSemigroup);
    return {
        apply: function(v) {
            return function(v1) {
                return new $5aedda7c2b102c7b$export$1908877435b1d5e9(append1(v.value0)(v1.value0), v.value1(v1.value1));
            };
        },
        Functor0: function() {
            return $5aedda7c2b102c7b$export$19ab04734dcb0ff0;
        }
    };
};
var $5aedda7c2b102c7b$export$5266c91ec2409601 = function(dictSemigroup) {
    var append1 = $d5vvq.append(dictSemigroup);
    var applyTuple1 = $5aedda7c2b102c7b$export$c87751c00e30fc9e(dictSemigroup);
    return {
        bind: function(v) {
            return function(f) {
                var v1 = f(v.value1);
                return new $5aedda7c2b102c7b$export$1908877435b1d5e9(append1(v.value0)(v1.value0), v1.value1);
            };
        },
        Apply0: function() {
            return applyTuple1;
        }
    };
};
var $5aedda7c2b102c7b$export$2f2c2cdaef7b685e = function(dictMonoid) {
    var applyTuple1 = $5aedda7c2b102c7b$export$c87751c00e30fc9e(dictMonoid.Semigroup0());
    return {
        pure: $5aedda7c2b102c7b$export$1908877435b1d5e9.create($3aOYV.mempty(dictMonoid)),
        Apply0: function() {
            return applyTuple1;
        }
    };
};
var $5aedda7c2b102c7b$export$d5a06b0f6aa5b11a = function(dictMonoid) {
    var applicativeTuple1 = $5aedda7c2b102c7b$export$2f2c2cdaef7b685e(dictMonoid);
    var bindTuple1 = $5aedda7c2b102c7b$export$5266c91ec2409601(dictMonoid.Semigroup0());
    return {
        Applicative0: function() {
            return applicativeTuple1;
        },
        Bind1: function() {
            return bindTuple1;
        }
    };
};

});
parcelRegister("dxuBz", function(module, exports) {

$parcel$export(module.exports, "defer", () => $9db618ee106d8861$export$260e5c0943f31606);
$parcel$export(module.exports, "fix", () => $9db618ee106d8861$export$d838837eb5b184e3);
// Generated by purs version 0.15.16
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
var $9db618ee106d8861$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $9db618ee106d8861$export$15718d19459d1753 = {
    defer: function(v) {
        return $ivFwO.unit;
    }
};
var $9db618ee106d8861$export$5dc1db391e531241 = {
    defer: function(f) {
        return function(x) {
            return f($ivFwO.unit)(x);
        };
    }
};
var $9db618ee106d8861$export$260e5c0943f31606 = function(dict) {
    return dict.defer;
};
var $9db618ee106d8861$export$d838837eb5b184e3 = function(dictLazy) {
    var defer1 = $9db618ee106d8861$export$260e5c0943f31606(dictLazy);
    return function(f) {
        var $lazy_go = $9db618ee106d8861$var$$runtime_lazy("go", "Control.Lazy", function() {
            return defer1(function(v) {
                return f($lazy_go(25));
            });
        });
        var go = $lazy_go(25);
        return go;
    };
};

});

parcelRegister("IhyKA", function(module, exports) {

$parcel$export(module.exports, "tt", () => $0851bb1ff1a31448$export$80bf595f9d9a1157);
$parcel$export(module.exports, "not", () => $0851bb1ff1a31448$export$6003a5f097c73977);
$parcel$export(module.exports, "implies", () => $0851bb1ff1a31448$export$6c53455e54f455ef);
$parcel$export(module.exports, "ff", () => $0851bb1ff1a31448$export$f59495b1b7502b33);
$parcel$export(module.exports, "disj", () => $0851bb1ff1a31448$export$9bd7ee00e37438db);
$parcel$export(module.exports, "heytingAlgebraBoolean", () => $0851bb1ff1a31448$export$d7d9283ee84f4c3f);
$parcel$export(module.exports, "conj", () => $0851bb1ff1a31448$export$fb254c661fe9c0db);
$parcel$export(module.exports, "heytingAlgebraFunction", () => $0851bb1ff1a31448$export$e9ae480d80dfc592);
// Generated by purs version 0.15.16

var $dXt3C = parcelRequire("dXt3C");

var $3Xcli = parcelRequire("3Xcli");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
parcelRequire("lMTwl");
var $hV6x3 = parcelRequire("hV6x3");

var $g13tD = parcelRequire("g13tD");
var $0851bb1ff1a31448$export$4c5e47bb71c07b6a = function(dict) {
    return dict.ttRecord;
};
var $0851bb1ff1a31448$export$80bf595f9d9a1157 = function(dict) {
    return dict.tt;
};
var $0851bb1ff1a31448$export$242da53d3ad27a73 = function(dict) {
    return dict.notRecord;
};
var $0851bb1ff1a31448$export$6003a5f097c73977 = function(dict) {
    return dict.not;
};
var $0851bb1ff1a31448$export$30918bdfe7eba090 = function(dict) {
    return dict.impliesRecord;
};
var $0851bb1ff1a31448$export$6c53455e54f455ef = function(dict) {
    return dict.implies;
};
var $0851bb1ff1a31448$export$960158ea2ad21b8d = {
    ff: $ivFwO.unit,
    tt: $ivFwO.unit,
    implies: function(v) {
        return function(v1) {
            return $ivFwO.unit;
        };
    },
    conj: function(v) {
        return function(v1) {
            return $ivFwO.unit;
        };
    },
    disj: function(v) {
        return function(v1) {
            return $ivFwO.unit;
        };
    },
    not: function(v) {
        return $ivFwO.unit;
    }
};
var $0851bb1ff1a31448$export$456c60aba1aeaaa = {
    conjRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    disjRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    ffRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    impliesRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    notRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    ttRecord: function(v) {
        return function(v1) {
            return {};
        };
    }
};
var $0851bb1ff1a31448$export$7347fefc6a9ef6b6 = /* #__PURE__ */ function() {
    return {
        conj: function(v) {
            return function(v1) {
                return $g13tD.Proxy.value;
            };
        },
        disj: function(v) {
            return function(v1) {
                return $g13tD.Proxy.value;
            };
        },
        implies: function(v) {
            return function(v1) {
                return $g13tD.Proxy.value;
            };
        },
        ff: $g13tD.Proxy.value,
        not: function(v) {
            return $g13tD.Proxy.value;
        },
        tt: $g13tD.Proxy.value
    };
}();
var $0851bb1ff1a31448$export$1b03126bff237ceb = function(dict) {
    return dict.ffRecord;
};
var $0851bb1ff1a31448$export$f59495b1b7502b33 = function(dict) {
    return dict.ff;
};
var $0851bb1ff1a31448$export$84e5fab3d833d7a2 = function(dict) {
    return dict.disjRecord;
};
var $0851bb1ff1a31448$export$9bd7ee00e37438db = function(dict) {
    return dict.disj;
};
var $0851bb1ff1a31448$export$d7d9283ee84f4c3f = {
    ff: false,
    tt: true,
    implies: function(a) {
        return function(b) {
            return $0851bb1ff1a31448$export$9bd7ee00e37438db($0851bb1ff1a31448$export$d7d9283ee84f4c3f)($0851bb1ff1a31448$export$6003a5f097c73977($0851bb1ff1a31448$export$d7d9283ee84f4c3f)(a))(b);
        };
    },
    conj: $dXt3C.boolConj,
    disj: $dXt3C.boolDisj,
    not: $dXt3C.boolNot
};
var $0851bb1ff1a31448$export$49ae8d06200d7fce = function(dict) {
    return dict.conjRecord;
};
var $0851bb1ff1a31448$export$7f2b975cf624805f = function() {
    return function(dictHeytingAlgebraRecord) {
        return {
            ff: $0851bb1ff1a31448$export$1b03126bff237ceb(dictHeytingAlgebraRecord)($g13tD.Proxy.value)($g13tD.Proxy.value),
            tt: $0851bb1ff1a31448$export$4c5e47bb71c07b6a(dictHeytingAlgebraRecord)($g13tD.Proxy.value)($g13tD.Proxy.value),
            conj: $0851bb1ff1a31448$export$49ae8d06200d7fce(dictHeytingAlgebraRecord)($g13tD.Proxy.value),
            disj: $0851bb1ff1a31448$export$84e5fab3d833d7a2(dictHeytingAlgebraRecord)($g13tD.Proxy.value),
            implies: $0851bb1ff1a31448$export$30918bdfe7eba090(dictHeytingAlgebraRecord)($g13tD.Proxy.value),
            not: $0851bb1ff1a31448$export$242da53d3ad27a73(dictHeytingAlgebraRecord)($g13tD.Proxy.value)
        };
    };
};
var $0851bb1ff1a31448$export$fb254c661fe9c0db = function(dict) {
    return dict.conj;
};
var $0851bb1ff1a31448$export$e9ae480d80dfc592 = function(dictHeytingAlgebra) {
    var ff1 = $0851bb1ff1a31448$export$f59495b1b7502b33(dictHeytingAlgebra);
    var tt1 = $0851bb1ff1a31448$export$80bf595f9d9a1157(dictHeytingAlgebra);
    var implies1 = $0851bb1ff1a31448$export$6c53455e54f455ef(dictHeytingAlgebra);
    var conj1 = $0851bb1ff1a31448$export$fb254c661fe9c0db(dictHeytingAlgebra);
    var disj1 = $0851bb1ff1a31448$export$9bd7ee00e37438db(dictHeytingAlgebra);
    var not1 = $0851bb1ff1a31448$export$6003a5f097c73977(dictHeytingAlgebra);
    return {
        ff: function(v) {
            return ff1;
        },
        tt: function(v) {
            return tt1;
        },
        implies: function(f) {
            return function(g) {
                return function(a) {
                    return implies1(f(a))(g(a));
                };
            };
        },
        conj: function(f) {
            return function(g) {
                return function(a) {
                    return conj1(f(a))(g(a));
                };
            };
        },
        disj: function(f) {
            return function(g) {
                return function(a) {
                    return disj1(f(a))(g(a));
                };
            };
        },
        not: function(f) {
            return function(a) {
                return not1(f(a));
            };
        }
    };
};
var $0851bb1ff1a31448$export$8b20a52b1d1213a4 = function(dictIsSymbol) {
    var reflectSymbol = $3Xcli.reflectSymbol(dictIsSymbol);
    return function() {
        return function(dictHeytingAlgebraRecord) {
            var conjRecord1 = $0851bb1ff1a31448$export$49ae8d06200d7fce(dictHeytingAlgebraRecord);
            var disjRecord1 = $0851bb1ff1a31448$export$84e5fab3d833d7a2(dictHeytingAlgebraRecord);
            var impliesRecord1 = $0851bb1ff1a31448$export$30918bdfe7eba090(dictHeytingAlgebraRecord);
            var ffRecord1 = $0851bb1ff1a31448$export$1b03126bff237ceb(dictHeytingAlgebraRecord);
            var notRecord1 = $0851bb1ff1a31448$export$242da53d3ad27a73(dictHeytingAlgebraRecord);
            var ttRecord1 = $0851bb1ff1a31448$export$4c5e47bb71c07b6a(dictHeytingAlgebraRecord);
            return function(dictHeytingAlgebra) {
                var conj1 = $0851bb1ff1a31448$export$fb254c661fe9c0db(dictHeytingAlgebra);
                var disj1 = $0851bb1ff1a31448$export$9bd7ee00e37438db(dictHeytingAlgebra);
                var implies1 = $0851bb1ff1a31448$export$6c53455e54f455ef(dictHeytingAlgebra);
                var ff1 = $0851bb1ff1a31448$export$f59495b1b7502b33(dictHeytingAlgebra);
                var not1 = $0851bb1ff1a31448$export$6003a5f097c73977(dictHeytingAlgebra);
                var tt1 = $0851bb1ff1a31448$export$80bf595f9d9a1157(dictHeytingAlgebra);
                return {
                    conjRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = conjRecord1($g13tD.Proxy.value)(ra)(rb);
                                var key = reflectSymbol($g13tD.Proxy.value);
                                var insert = $hV6x3.unsafeSet(key);
                                var get = $hV6x3.unsafeGet(key);
                                return insert(conj1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    disjRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = disjRecord1($g13tD.Proxy.value)(ra)(rb);
                                var key = reflectSymbol($g13tD.Proxy.value);
                                var insert = $hV6x3.unsafeSet(key);
                                var get = $hV6x3.unsafeGet(key);
                                return insert(disj1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    impliesRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = impliesRecord1($g13tD.Proxy.value)(ra)(rb);
                                var key = reflectSymbol($g13tD.Proxy.value);
                                var insert = $hV6x3.unsafeSet(key);
                                var get = $hV6x3.unsafeGet(key);
                                return insert(implies1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    ffRecord: function(v) {
                        return function(row) {
                            var tail = ffRecord1($g13tD.Proxy.value)(row);
                            var key = reflectSymbol($g13tD.Proxy.value);
                            var insert = $hV6x3.unsafeSet(key);
                            return insert(ff1)(tail);
                        };
                    },
                    notRecord: function(v) {
                        return function(row) {
                            var tail = notRecord1($g13tD.Proxy.value)(row);
                            var key = reflectSymbol($g13tD.Proxy.value);
                            var insert = $hV6x3.unsafeSet(key);
                            var get = $hV6x3.unsafeGet(key);
                            return insert(not1(get(row)))(tail);
                        };
                    },
                    ttRecord: function(v) {
                        return function(row) {
                            var tail = ttRecord1($g13tD.Proxy.value)(row);
                            var key = reflectSymbol($g13tD.Proxy.value);
                            var insert = $hV6x3.unsafeSet(key);
                            return insert(tt1)(tail);
                        };
                    }
                };
            };
        };
    };
};

});
parcelRegister("dXt3C", function(module, exports) {

$parcel$export(module.exports, "boolConj", () => $a297533f5300b3dc$export$e5682d87e23bb875);
$parcel$export(module.exports, "boolDisj", () => $a297533f5300b3dc$export$4edd36328926db3d);
$parcel$export(module.exports, "boolNot", () => $a297533f5300b3dc$export$856531720ce57da6);
const $a297533f5300b3dc$export$e5682d87e23bb875 = function(b1) {
    return function(b2) {
        return b1 && b2;
    };
};
const $a297533f5300b3dc$export$4edd36328926db3d = function(b1) {
    return function(b2) {
        return b1 || b2;
    };
};
const $a297533f5300b3dc$export$856531720ce57da6 = function(b) {
    return !b;
};

});



parcelRegister("brrpF", function(module, exports) {

$parcel$export(module.exports, "zip", () => $85477afba1c0a604$export$8901015135f2fb22);
$parcel$export(module.exports, "updateAt", () => $85477afba1c0a604$export$b6d8713d53419d4c);
$parcel$export(module.exports, "unsafeIndex", () => $85477afba1c0a604$export$90bcd20c17ae578e);
$parcel$export(module.exports, "uncons", () => $85477afba1c0a604$export$b446f6baa3bb1430);
$parcel$export(module.exports, "toUnfoldable", () => $85477afba1c0a604$export$823be24f8766da23);
$parcel$export(module.exports, "take", () => $85477afba1c0a604$export$b7df5d561049483a);
$parcel$export(module.exports, "tail", () => $85477afba1c0a604$export$c01875f616615628);
$parcel$export(module.exports, "sortBy", () => $85477afba1c0a604$export$b035e44d7bb4278f);
$parcel$export(module.exports, "sortWith", () => $85477afba1c0a604$export$a9e7d1a6fdcfefde);
$parcel$export(module.exports, "null", () => $85477afba1c0a604$export$7b1b591b262c240);
$parcel$export(module.exports, "insertAt", () => $85477afba1c0a604$export$9f200c4466975173);
$parcel$export(module.exports, "index", () => $85477afba1c0a604$export$b610b8812bbcded9);
$parcel$export(module.exports, "head", () => $85477afba1c0a604$export$5fd5031fecdacec3);
$parcel$export(module.exports, "nub", () => $85477afba1c0a604$export$94f4066a75b10404);
$parcel$export(module.exports, "fromFoldable", () => $85477afba1c0a604$export$b7d5d9bb9ff52072);
$parcel$export(module.exports, "foldl", () => $85477afba1c0a604$export$50ae948ca12cdcbc);
$parcel$export(module.exports, "intersect", () => $85477afba1c0a604$export$1f4807a235930d45);
$parcel$export(module.exports, "elemIndex", () => $85477afba1c0a604$export$f444781b0adb7e4d);
$parcel$export(module.exports, "elem", () => $85477afba1c0a604$export$5bf96401662340b7);
$parcel$export(module.exports, "drop", () => $85477afba1c0a604$export$663103110d94aac9);
$parcel$export(module.exports, "deleteAt", () => $85477afba1c0a604$export$90f9093465da3136);
$parcel$export(module.exports, "deleteBy", () => $85477afba1c0a604$export$9ea2b6c3fae093d8);
$parcel$export(module.exports, "difference", () => $85477afba1c0a604$export$acaf96a27438246b);
$parcel$export(module.exports, "cons", () => $85477afba1c0a604$export$8327ebbef2a0ba76);
$parcel$export(module.exports, "mapMaybe", () => $85477afba1c0a604$export$e70771d2e7e590a);
$parcel$export(module.exports, "catMaybes", () => $85477afba1c0a604$export$986c2bbe7a34be0b);
$parcel$export(module.exports, "range", () => (parcelRequire("d3m1K")).range);
$parcel$export(module.exports, "replicate", () => (parcelRequire("d3m1K")).replicate);
$parcel$export(module.exports, "length", () => (parcelRequire("d3m1K")).length);
$parcel$export(module.exports, "concat", () => (parcelRequire("d3m1K")).concat);
$parcel$export(module.exports, "filter", () => (parcelRequire("d3m1K")).filter);
$parcel$export(module.exports, "any", () => (parcelRequire("d3m1K")).any);
$parcel$export(module.exports, "all", () => (parcelRequire("d3m1K")).all);
// Generated by purs version 0.15.16

var $d3m1K = parcelRequire("d3m1K");

var $56VjJ = parcelRequire("56VjJ");

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $26SV5 = parcelRequire("26SV5");

var $dxuBz = parcelRequire("dxuBz");

var $bcJ05 = parcelRequire("bcJ05");

var $k1We4 = parcelRequire("k1We4");
var $4rtOs = parcelRequire("4rtOs");

var $8cbRe = parcelRequire("8cbRe");
var $hnZPO = parcelRequire("hnZPO");

var $2uFbl = parcelRequire("2uFbl");

var $iQTlW = parcelRequire("iQTlW");

var $aJhEx = parcelRequire("aJhEx");

var $dNwPt = parcelRequire("dNwPt");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $d5vvq = parcelRequire("d5vvq");

var $9OOYG = parcelRequire("9OOYG");

var $7O0Q4 = parcelRequire("7O0Q4");

var $goKHx = parcelRequire("goKHx");
var $85477afba1c0a604$var$sequence = /* #__PURE__ */ $9OOYG.sequence($9OOYG.traversableArray);
var $85477afba1c0a604$var$traverse_ = /* #__PURE__ */ $dNwPt.traverse_($k1We4.applicativeST);
var $85477afba1c0a604$var$map = /* #__PURE__ */ $7FzSN.map($k1We4.functorST);
var $85477afba1c0a604$var$when = /* #__PURE__ */ $bQdkN.when($k1We4.applicativeST);
var $85477afba1c0a604$var$$$void = /* #__PURE__ */ $7FzSN.void($k1We4.functorST);
var $85477afba1c0a604$var$intercalate1 = /* #__PURE__ */ $dNwPt.intercalate($dNwPt.foldableArray);
var $85477afba1c0a604$var$apply = /* #__PURE__ */ $26ZCq.apply($h2xUu.applyMaybe);
var $85477afba1c0a604$var$map1 = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $85477afba1c0a604$var$map2 = /* #__PURE__ */ $7FzSN.map($7FzSN.functorArray);
var $85477afba1c0a604$var$fromJust = /* #__PURE__ */ $h2xUu.fromJust();
var $85477afba1c0a604$var$notEq = /* #__PURE__ */ $aJhEx.notEq($ibsD5.eqOrdering);
var $85477afba1c0a604$var$eq1 = /* #__PURE__ */ $aJhEx.eq($ibsD5.eqOrdering);
var $85477afba1c0a604$var$foldMap1 = /* #__PURE__ */ $dNwPt.foldMap($dNwPt.foldableArray);
var $85477afba1c0a604$var$fold1 = /* #__PURE__ */ $dNwPt.fold($dNwPt.foldableArray);
var $85477afba1c0a604$var$append = /* #__PURE__ */ $d5vvq.append($d5vvq.semigroupArray);
var $85477afba1c0a604$var$traverse = /* #__PURE__ */ $9OOYG.traverse($9OOYG.traversableArray);
var $85477afba1c0a604$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var sequence1 = $85477afba1c0a604$var$sequence(dictApplicative);
    return function(f) {
        return function(xs) {
            return function(ys) {
                return sequence1($d3m1K.zipWith(f)(xs)(ys));
            };
        };
    };
};
var $85477afba1c0a604$export$8901015135f2fb22 = /* #__PURE__ */ function() {
    return $d3m1K.zipWith($7O0Q4.Tuple.create);
}();
var $85477afba1c0a604$export$f2a09b3ef2c0e257 = function(dictFoldable) {
    var traverse_1 = $85477afba1c0a604$var$traverse_(dictFoldable);
    return function(us) {
        return function(xs) {
            return $8cbRe.withArray(function(res) {
                return traverse_1(function(v) {
                    return $hnZPO.poke(v.value0)(v.value1)(res);
                })(us);
            })(xs)();
        };
    };
};
var $85477afba1c0a604$export$b6d8713d53419d4c = /* #__PURE__ */ function() {
    return $d3m1K._updateAt($h2xUu.Just.create)($h2xUu.Nothing.value);
}();
var $85477afba1c0a604$export$90bcd20c17ae578e = function() {
    return $d3m1K.unsafeIndexImpl;
};
var $85477afba1c0a604$var$unsafeIndex1 = /* #__PURE__ */ $85477afba1c0a604$export$90bcd20c17ae578e();
var $85477afba1c0a604$export$b446f6baa3bb1430 = /* #__PURE__ */ function() {
    return $d3m1K.unconsImpl($jhsiw.const($h2xUu.Nothing.value))(function(x) {
        return function(xs) {
            return new $h2xUu.Just({
                head: x,
                tail: xs
            });
        };
    });
}();
var $85477afba1c0a604$export$823be24f8766da23 = function(dictUnfoldable) {
    var unfoldr = $goKHx.unfoldr(dictUnfoldable);
    return function(xs) {
        var len = $d3m1K.length(xs);
        var f = function(i) {
            if (i < len) return new $h2xUu.Just(new $7O0Q4.Tuple($85477afba1c0a604$var$unsafeIndex1(xs)(i), i + 1 | 0));
            if ($iQTlW.otherwise) return $h2xUu.Nothing.value;
            throw new Error("Failed pattern match at Data.Array (line 157, column 3 - line 159, column 26): " + [
                i.constructor.name
            ]);
        };
        return unfoldr(f)(0);
    };
};
var $85477afba1c0a604$export$b7df5d561049483a = function(n) {
    return function(xs) {
        var $148 = n < 1;
        if ($148) return [];
        return $d3m1K.slice(0)(n)(xs);
    };
};
var $85477afba1c0a604$export$c01875f616615628 = /* #__PURE__ */ function() {
    return $d3m1K.unconsImpl($jhsiw.const($h2xUu.Nothing.value))(function(v) {
        return function(xs) {
            return new $h2xUu.Just(xs);
        };
    });
}();
var $85477afba1c0a604$export$b0d75975ac0be0e1 = function(v) {
    return function(v1) {
        if (v <= 0) return {
            before: [],
            after: v1
        };
        return {
            before: $d3m1K.slice(0)(v)(v1),
            after: $d3m1K.slice(v)($d3m1K.length(v1))(v1)
        };
    };
};
var $85477afba1c0a604$export$b035e44d7bb4278f = function(comp) {
    return $d3m1K.sortByImpl(comp)(function(v) {
        if (v instanceof $ibsD5.GT) return 1;
        if (v instanceof $ibsD5.EQ) return 0;
        if (v instanceof $ibsD5.LT) return -1;
        throw new Error("Failed pattern match at Data.Array (line 870, column 31 - line 873, column 11): " + [
            v.constructor.name
        ]);
    });
};
var $85477afba1c0a604$export$a9e7d1a6fdcfefde = function(dictOrd) {
    var comparing = $gwBF5.comparing(dictOrd);
    return function(f) {
        return $85477afba1c0a604$export$b035e44d7bb4278f(comparing(f));
    };
};
var $85477afba1c0a604$var$sortWith1 = /* #__PURE__ */ $85477afba1c0a604$export$a9e7d1a6fdcfefde($gwBF5.ordInt);
var $85477afba1c0a604$export$97db5808d8f88186 = function(dictOrd) {
    var compare = $gwBF5.compare(dictOrd);
    return function(xs) {
        return $85477afba1c0a604$export$b035e44d7bb4278f(compare)(xs);
    };
};
var $85477afba1c0a604$export$c40cf5aab899f397 = function(xs) {
    return function(x) {
        return $8cbRe.withArray($8cbRe.push(x))(xs)();
    };
};
var $85477afba1c0a604$export$439306a4dcaafbb9 = function(a) {
    return [
        a
    ];
};
var $85477afba1c0a604$export$7b1b591b262c240 = function(xs) {
    return $d3m1K.length(xs) === 0;
};
var $85477afba1c0a604$export$45273896c792ff3b = function(eq2) {
    return function(xs) {
        return function __do() {
            var arr = $hnZPO.new();
            $4rtOs.foreach(xs)(function(x) {
                return function __do() {
                    var e = $85477afba1c0a604$var$map(function() {
                        var $182 = $d3m1K.any(function(v) {
                            return eq2(v)(x);
                        });
                        return function($183) {
                            return !$182($183);
                        };
                    }())($hnZPO.unsafeFreeze(arr))();
                    return $85477afba1c0a604$var$when(e)($85477afba1c0a604$var$$$void($8cbRe.push(x)(arr)))();
                };
            })();
            return $hnZPO.unsafeFreeze(arr)();
        }();
    };
};
var $85477afba1c0a604$export$edce5881c815871 = function(dictEq) {
    return $85477afba1c0a604$export$45273896c792ff3b($aJhEx.eq(dictEq));
};
var $85477afba1c0a604$export$7fd3d81fba5daa58 = function(dictFoldable) {
    var traverse_1 = $85477afba1c0a604$var$traverse_(dictFoldable);
    return function(is) {
        return function(f) {
            return function(xs) {
                return $8cbRe.withArray(function(res) {
                    return traverse_1(function(i) {
                        return $8cbRe.modify(i)(f)(res);
                    })(is);
                })(xs)();
            };
        };
    };
};
var $85477afba1c0a604$export$8f07ddce13659f50 = function(f) {
    return function(xs) {
        return $d3m1K.zipWith(f)($d3m1K.range(0)($d3m1K.length(xs) - 1 | 0))(xs);
    };
};
var $85477afba1c0a604$export$af200dcf8b7cb5de = function(a) {
    return function(arr) {
        var v = $d3m1K.length(arr);
        if (v < 2) return arr;
        if ($iQTlW.otherwise) return $8cbRe.run(function() {
            var unsafeGetElem = function(idx) {
                return $85477afba1c0a604$var$unsafeIndex1(arr)(idx);
            };
            return function __do() {
                var out = $hnZPO.new();
                $8cbRe.push(unsafeGetElem(0))(out)();
                $4rtOs.for(1)(v)(function(idx) {
                    return function __do() {
                        $8cbRe.push(a)(out)();
                        return $85477afba1c0a604$var$$$void($8cbRe.push(unsafeGetElem(idx))(out))();
                    };
                })();
                return out;
            };
        }());
        throw new Error("Failed pattern match at Data.Array (line 612, column 21 - line 621, column 19): " + [
            v.constructor.name
        ]);
    };
};
var $85477afba1c0a604$export$739ec22334c44788 = function(dictMonoid) {
    return $85477afba1c0a604$var$intercalate1(dictMonoid);
};
var $85477afba1c0a604$export$9f200c4466975173 = /* #__PURE__ */ function() {
    return $d3m1K._insertAt($h2xUu.Just.create)($h2xUu.Nothing.value);
}();
var $85477afba1c0a604$export$2cd8252107eb640b = function(xs) {
    if ($85477afba1c0a604$export$7b1b591b262c240(xs)) return $h2xUu.Nothing.value;
    if ($iQTlW.otherwise) return new $h2xUu.Just($d3m1K.slice(0)($d3m1K.length(xs) - 1 | 0)(xs));
    throw new Error("Failed pattern match at Data.Array (line 339, column 1 - line 339, column 45): " + [
        xs.constructor.name
    ]);
};
var $85477afba1c0a604$export$b610b8812bbcded9 = /* #__PURE__ */ function() {
    return $d3m1K.indexImpl($h2xUu.Just.create)($h2xUu.Nothing.value);
}();
var $85477afba1c0a604$export$4c7897fafd92b108 = function(xs) {
    return $85477afba1c0a604$export$b610b8812bbcded9(xs)($d3m1K.length(xs) - 1 | 0);
};
var $85477afba1c0a604$export$712962e076096ed4 = function(xs) {
    return $85477afba1c0a604$var$apply($85477afba1c0a604$var$map1(function(v) {
        return function(v1) {
            return {
                init: v,
                last: v1
            };
        };
    })($85477afba1c0a604$export$2cd8252107eb640b(xs)))($85477afba1c0a604$export$4c7897fafd92b108(xs));
};
var $85477afba1c0a604$export$cba09f9e3d3e58eb = function(i) {
    return function(f) {
        return function(xs) {
            var go = function(x) {
                return $85477afba1c0a604$export$b6d8713d53419d4c(i)(f(x))(xs);
            };
            return $h2xUu.maybe($h2xUu.Nothing.value)(go)($85477afba1c0a604$export$b610b8812bbcded9(xs)(i));
        };
    };
};
var $85477afba1c0a604$export$afc1bfabebaf28a2 = function(p) {
    return function(arr) {
        var go = function($copy_i) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(i) {
                var v = $85477afba1c0a604$export$b610b8812bbcded9(arr)(i);
                if (v instanceof $h2xUu.Just) {
                    var $155 = p(v.value0);
                    if ($155) {
                        $copy_i = i + 1 | 0;
                        return;
                    }
                    $tco_done = true;
                    return new $h2xUu.Just(i);
                }
                if (v instanceof $h2xUu.Nothing) {
                    $tco_done = true;
                    return $h2xUu.Nothing.value;
                }
                throw new Error("Failed pattern match at Data.Array (line 1005, column 5 - line 1007, column 25): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_i);
            return $tco_result;
        };
        var breakIndex = go(0);
        if (breakIndex instanceof $h2xUu.Just && breakIndex.value0 === 0) return {
            init: [],
            rest: arr
        };
        if (breakIndex instanceof $h2xUu.Just) return {
            init: $d3m1K.slice(0)(breakIndex.value0)(arr),
            rest: $d3m1K.slice(breakIndex.value0)($d3m1K.length(arr))(arr)
        };
        if (breakIndex instanceof $h2xUu.Nothing) return {
            init: arr,
            rest: []
        };
        throw new Error("Failed pattern match at Data.Array (line 992, column 3 - line 998, column 30): " + [
            breakIndex.constructor.name
        ]);
    };
};
var $85477afba1c0a604$export$9384c7afe4015e42 = function(p) {
    return function(xs) {
        return $85477afba1c0a604$export$afc1bfabebaf28a2(p)(xs).init;
    };
};
var $85477afba1c0a604$export$23c8d3f8757cab88 = function(xs) {
    return function __do() {
        var fsts = $hnZPO.new();
        var snds = $hnZPO.new();
        var iter = $2uFbl.iterator(function(v) {
            return $85477afba1c0a604$export$b610b8812bbcded9(xs)(v);
        })();
        $2uFbl.iterate(iter)(function(v) {
            return function __do() {
                $85477afba1c0a604$var$$$void($8cbRe.push(v.value0)(fsts))();
                return $85477afba1c0a604$var$$$void($8cbRe.push(v.value1)(snds))();
            };
        })();
        var fsts$prime = $hnZPO.unsafeFreeze(fsts)();
        var snds$prime = $hnZPO.unsafeFreeze(snds)();
        return new $7O0Q4.Tuple(fsts$prime, snds$prime);
    }();
};
var $85477afba1c0a604$export$5fd5031fecdacec3 = function(xs) {
    return $85477afba1c0a604$export$b610b8812bbcded9(xs)(0);
};
var $85477afba1c0a604$export$18f77a3bafa759b9 = function(comp) {
    return function(xs) {
        var indexedAndSorted = $85477afba1c0a604$export$b035e44d7bb4278f(function(x) {
            return function(y) {
                return comp($7O0Q4.snd(x))($7O0Q4.snd(y));
            };
        })($85477afba1c0a604$export$8f07ddce13659f50($7O0Q4.Tuple.create)(xs));
        var v = $85477afba1c0a604$export$5fd5031fecdacec3(indexedAndSorted);
        if (v instanceof $h2xUu.Nothing) return [];
        if (v instanceof $h2xUu.Just) return $85477afba1c0a604$var$map2($7O0Q4.snd)($85477afba1c0a604$var$sortWith1($7O0Q4.fst)(function __do() {
            var result = $hnZPO.unsafeThaw($85477afba1c0a604$export$439306a4dcaafbb9(v.value0))();
            $4rtOs.foreach(indexedAndSorted)(function(v1) {
                return function __do() {
                    var lst = $85477afba1c0a604$var$map(function() {
                        var $184 = function($186) {
                            return $85477afba1c0a604$var$fromJust($85477afba1c0a604$export$4c7897fafd92b108($186));
                        };
                        return function($185) {
                            return $7O0Q4.snd($184($185));
                        };
                    }())($hnZPO.unsafeFreeze(result))();
                    return $85477afba1c0a604$var$when($85477afba1c0a604$var$notEq(comp(lst)(v1.value1))($ibsD5.EQ.value))($85477afba1c0a604$var$$$void($8cbRe.push(v1)(result)))();
                };
            })();
            return $hnZPO.unsafeFreeze(result)();
        }()));
        throw new Error("Failed pattern match at Data.Array (line 1085, column 17 - line 1093, column 29): " + [
            v.constructor.name
        ]);
    };
};
var $85477afba1c0a604$export$94f4066a75b10404 = function(dictOrd) {
    return $85477afba1c0a604$export$18f77a3bafa759b9($gwBF5.compare(dictOrd));
};
var $85477afba1c0a604$export$3f063810d7bf01bd = function(op) {
    return function(xs) {
        return function __do() {
            var result = $hnZPO.new();
            var iter = $2uFbl.iterator(function(v) {
                return $85477afba1c0a604$export$b610b8812bbcded9(xs)(v);
            })();
            $2uFbl.iterate(iter)(function(x) {
                return $85477afba1c0a604$var$$$void(function __do() {
                    var sub1 = $hnZPO.new();
                    $8cbRe.push(x)(sub1)();
                    $2uFbl.pushWhile(op(x))(iter)(sub1)();
                    var grp = $hnZPO.unsafeFreeze(sub1)();
                    return $8cbRe.push(grp)(result)();
                });
            })();
            return $hnZPO.unsafeFreeze(result)();
        }();
    };
};
var $85477afba1c0a604$export$1f7a5bf12caafbd = function(cmp) {
    var $187 = $85477afba1c0a604$export$3f063810d7bf01bd(function(x) {
        return function(y) {
            return $85477afba1c0a604$var$eq1(cmp(x)(y))($ibsD5.EQ.value);
        };
    });
    var $188 = $85477afba1c0a604$export$b035e44d7bb4278f(cmp);
    return function($189) {
        return $187($188($189));
    };
};
var $85477afba1c0a604$export$361434b95a7d965 = function(dictOrd) {
    return $85477afba1c0a604$export$1f7a5bf12caafbd($gwBF5.compare(dictOrd));
};
var $85477afba1c0a604$export$e5e25fbcc1f7affe = function(dictEq) {
    var eq2 = $aJhEx.eq(dictEq);
    return function(xs) {
        return $85477afba1c0a604$export$3f063810d7bf01bd(eq2)(xs);
    };
};
var $85477afba1c0a604$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    return $d3m1K.fromFoldableImpl($dNwPt.foldr(dictFoldable));
};
var $85477afba1c0a604$export$a11cb61c36c4a4cf = /* #__PURE__ */ $dNwPt.foldr($dNwPt.foldableArray);
var $85477afba1c0a604$export$50ae948ca12cdcbc = /* #__PURE__ */ $dNwPt.foldl($dNwPt.foldableArray);
var $85477afba1c0a604$export$9cb09a71b7d66923 = function(xs) {
    var buildNext = function(idx) {
        return $jhsiw.flip($85477afba1c0a604$export$50ae948ca12cdcbc)($h2xUu.Nothing.value)(function(acc) {
            return function(nextArr) {
                return $h2xUu.maybe(acc)(function(el) {
                    return new $h2xUu.Just($h2xUu.maybe([
                        el
                    ])($jhsiw.flip($85477afba1c0a604$export$c40cf5aab899f397)(el))(acc));
                })($85477afba1c0a604$export$b610b8812bbcded9(nextArr)(idx));
            };
        })(xs);
    };
    var go = function($copy_idx) {
        return function($copy_allArrays) {
            var $tco_var_idx = $copy_idx;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(idx, allArrays) {
                var v = buildNext(idx);
                if (v instanceof $h2xUu.Nothing) {
                    $tco_done = true;
                    return allArrays;
                }
                if (v instanceof $h2xUu.Just) {
                    $tco_var_idx = idx + 1 | 0;
                    $copy_allArrays = $85477afba1c0a604$export$c40cf5aab899f397(allArrays)(v.value0);
                    return;
                }
                throw new Error("Failed pattern match at Data.Array (line 816, column 22 - line 818, column 52): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_idx, $copy_allArrays);
            return $tco_result;
        };
    };
    return go(0)([]);
};
var $85477afba1c0a604$export$61b0588efceffce4 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var pure1 = $bQdkN.pure(Monad0.Applicative0());
    var bind1 = $cADnC.bind(Monad0.Bind1());
    var tailRecM2 = $bcJ05.tailRecM2(dictMonadRec);
    return function(f) {
        return function(b) {
            return function(array) {
                var go = function(res) {
                    return function(i) {
                        if (i >= $d3m1K.length(array)) return pure1(new $bcJ05.Done(res));
                        if ($iQTlW.otherwise) return bind1(f(res)($85477afba1c0a604$var$unsafeIndex1(array)(i)))(function(res$prime) {
                            return pure1(new $bcJ05.Loop({
                                a: res$prime,
                                b: i + 1 | 0
                            }));
                        });
                        throw new Error("Failed pattern match at Data.Array (line 1304, column 3 - line 1308, column 42): " + [
                            res.constructor.name,
                            i.constructor.name
                        ]);
                    };
                };
                return tailRecM2(go)(b)(0);
            };
        };
    };
};
var $85477afba1c0a604$export$b66cdc0497d8a99a = function(dictMonoid) {
    return $85477afba1c0a604$var$foldMap1(dictMonoid);
};
var $85477afba1c0a604$export$7a067f9280ad8af0 = function(dictMonad) {
    var pure1 = $bQdkN.pure(dictMonad.Applicative0());
    var bind1 = $cADnC.bind(dictMonad.Bind1());
    return function(f) {
        return function(b) {
            return $d3m1K.unconsImpl(function(v) {
                return pure1(b);
            })(function(a) {
                return function(as) {
                    return bind1(f(b)(a))(function(b$prime) {
                        return $85477afba1c0a604$export$7a067f9280ad8af0(dictMonad)(f)(b$prime)(as);
                    });
                };
            });
        };
    };
};
var $85477afba1c0a604$export$93e2b83da34ff82a = function(dictMonoid) {
    return $85477afba1c0a604$var$fold1(dictMonoid);
};
var $85477afba1c0a604$export$23e5dcedfce4509c = /* #__PURE__ */ function() {
    return $d3m1K.findMapImpl($h2xUu.Nothing.value)($h2xUu.isJust);
}();
var $85477afba1c0a604$export$8855a8be7bd3e9f8 = /* #__PURE__ */ function() {
    return $d3m1K.findLastIndexImpl($h2xUu.Just.create)($h2xUu.Nothing.value);
}();
var $85477afba1c0a604$export$b8bc901090d2b1d4 = function(cmp) {
    return function(x) {
        return function(ys) {
            var i = $h2xUu.maybe(0)(function(v) {
                return v + 1 | 0;
            })($85477afba1c0a604$export$8855a8be7bd3e9f8(function(y) {
                return $85477afba1c0a604$var$eq1(cmp(x)(y))($ibsD5.GT.value);
            })(ys));
            return $85477afba1c0a604$var$fromJust($85477afba1c0a604$export$9f200c4466975173(i)(x)(ys));
        };
    };
};
var $85477afba1c0a604$export$21a5ca8aa77d35ff = function(dictOrd) {
    return $85477afba1c0a604$export$b8bc901090d2b1d4($gwBF5.compare(dictOrd));
};
var $85477afba1c0a604$export$de3a4d4a0d731119 = /* #__PURE__ */ function() {
    return $d3m1K.findIndexImpl($h2xUu.Just.create)($h2xUu.Nothing.value);
}();
var $85477afba1c0a604$export$f161f39e9c06ab2d = function(eq2) {
    return function(xs) {
        return function(ys) {
            return $d3m1K.filter(function(x) {
                return $h2xUu.isJust($85477afba1c0a604$export$de3a4d4a0d731119(eq2(x))(ys));
            })(xs);
        };
    };
};
var $85477afba1c0a604$export$1f4807a235930d45 = function(dictEq) {
    return $85477afba1c0a604$export$f161f39e9c06ab2d($aJhEx.eq(dictEq));
};
var $85477afba1c0a604$export$71aa6c912b956294 = function(f) {
    return function(xs) {
        return $85477afba1c0a604$var$map1($85477afba1c0a604$var$unsafeIndex1(xs))($85477afba1c0a604$export$de3a4d4a0d731119(f)(xs));
    };
};
var $85477afba1c0a604$export$c19d79386f4ed99a = function(dictEq) {
    var eq2 = $aJhEx.eq(dictEq);
    return function(x) {
        return $85477afba1c0a604$export$8855a8be7bd3e9f8(function(v) {
            return eq2(v)(x);
        });
    };
};
var $85477afba1c0a604$export$f444781b0adb7e4d = function(dictEq) {
    var eq2 = $aJhEx.eq(dictEq);
    return function(x) {
        return $85477afba1c0a604$export$de3a4d4a0d731119(function(v) {
            return eq2(v)(x);
        });
    };
};
var $85477afba1c0a604$export$63faa62a0284a4a6 = function(dictEq) {
    var elemIndex1 = $85477afba1c0a604$export$f444781b0adb7e4d(dictEq);
    return function(a) {
        return function(arr) {
            return $h2xUu.isNothing(elemIndex1(a)(arr));
        };
    };
};
var $85477afba1c0a604$export$5bf96401662340b7 = function(dictEq) {
    var elemIndex1 = $85477afba1c0a604$export$f444781b0adb7e4d(dictEq);
    return function(a) {
        return function(arr) {
            return $h2xUu.isJust(elemIndex1(a)(arr));
        };
    };
};
var $85477afba1c0a604$export$533af5c8cd6afa16 = function(p) {
    return function(xs) {
        return $85477afba1c0a604$export$afc1bfabebaf28a2(p)(xs).rest;
    };
};
var $85477afba1c0a604$export$2b3b686e33c80c56 = function(n) {
    return function(xs) {
        return $85477afba1c0a604$export$b7df5d561049483a($d3m1K.length(xs) - n | 0)(xs);
    };
};
var $85477afba1c0a604$export$663103110d94aac9 = function(n) {
    return function(xs) {
        var $172 = n < 1;
        if ($172) return xs;
        return $d3m1K.slice(n)($d3m1K.length(xs))(xs);
    };
};
var $85477afba1c0a604$export$9100289823a975b0 = function(n) {
    return function(xs) {
        return $85477afba1c0a604$export$663103110d94aac9($d3m1K.length(xs) - n | 0)(xs);
    };
};
var $85477afba1c0a604$export$90f9093465da3136 = /* #__PURE__ */ function() {
    return $d3m1K._deleteAt($h2xUu.Just.create)($h2xUu.Nothing.value);
}();
var $85477afba1c0a604$export$9ea2b6c3fae093d8 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2.length === 0) return [];
            return $h2xUu.maybe(v2)(function(i) {
                return $85477afba1c0a604$var$fromJust($85477afba1c0a604$export$90f9093465da3136(i)(v2));
            })($85477afba1c0a604$export$de3a4d4a0d731119(v(v1))(v2));
        };
    };
};
var $85477afba1c0a604$export$ef1d06dc4d91d507 = function(eq2) {
    return function(xs) {
        return function(ys) {
            return $85477afba1c0a604$var$append(xs)($85477afba1c0a604$export$50ae948ca12cdcbc($jhsiw.flip($85477afba1c0a604$export$9ea2b6c3fae093d8(eq2)))($85477afba1c0a604$export$45273896c792ff3b(eq2)(ys))(xs));
        };
    };
};
var $85477afba1c0a604$export$971dd5b0dfd021b6 = function(dictEq) {
    return $85477afba1c0a604$export$ef1d06dc4d91d507($aJhEx.eq(dictEq));
};
var $85477afba1c0a604$export$1822828d790e23ee = function(dictEq) {
    return $85477afba1c0a604$export$9ea2b6c3fae093d8($aJhEx.eq(dictEq));
};
var $85477afba1c0a604$export$acaf96a27438246b = function(dictEq) {
    return $85477afba1c0a604$export$a11cb61c36c4a4cf($85477afba1c0a604$export$1822828d790e23ee(dictEq));
};
var $85477afba1c0a604$export$8327ebbef2a0ba76 = function(x) {
    return function(xs) {
        return $85477afba1c0a604$var$append([
            x
        ])(xs);
    };
};
var $85477afba1c0a604$export$ad14ef4001db2bcd = function(dictAlternative) {
    var apply1 = $26ZCq.apply(dictAlternative.Applicative0().Apply0());
    var map3 = $7FzSN.map(dictAlternative.Plus1().Alt0().Functor0());
    return function(dictLazy) {
        var defer = $dxuBz.defer(dictLazy);
        return function(v) {
            return apply1(map3($85477afba1c0a604$export$8327ebbef2a0ba76)(v))(defer(function(v1) {
                return $85477afba1c0a604$export$14badfee79ea396f(dictAlternative)(dictLazy)(v);
            }));
        };
    };
};
var $85477afba1c0a604$export$14badfee79ea396f = function(dictAlternative) {
    var alt = $56VjJ.alt(dictAlternative.Plus1().Alt0());
    var pure1 = $bQdkN.pure(dictAlternative.Applicative0());
    return function(dictLazy) {
        return function(v) {
            return alt($85477afba1c0a604$export$ad14ef4001db2bcd(dictAlternative)(dictLazy)(v))(pure1([]));
        };
    };
};
var $85477afba1c0a604$export$c28c8388be0ab31a = /* #__PURE__ */ $jhsiw.flip(/* #__PURE__ */ $cADnC.bind($cADnC.bindArray));
var $85477afba1c0a604$export$e70771d2e7e590a = function(f) {
    return $85477afba1c0a604$export$c28c8388be0ab31a(function() {
        var $190 = $h2xUu.maybe([])($85477afba1c0a604$export$439306a4dcaafbb9);
        return function($191) {
            return $190(f($191));
        };
    }());
};
var $85477afba1c0a604$export$e6e803076c284bc5 = function(dictApplicative) {
    var traverse1 = $85477afba1c0a604$var$traverse(dictApplicative);
    var map3 = $7FzSN.map(dictApplicative.Apply0().Functor0());
    return function(p) {
        var $192 = map3($85477afba1c0a604$export$e70771d2e7e590a(function(v) {
            if (v.value1) return new $h2xUu.Just(v.value0);
            return $h2xUu.Nothing.value;
        }));
        var $193 = traverse1(function(x) {
            return map3($7O0Q4.Tuple.create(x))(p(x));
        });
        return function($194) {
            return $192($193($194));
        };
    };
};
var $85477afba1c0a604$export$986c2bbe7a34be0b = /* #__PURE__ */ $85477afba1c0a604$export$e70771d2e7e590a(/* #__PURE__ */ $26SV5.identity($26SV5.categoryFn));
var $85477afba1c0a604$export$2dd9d44f93be5e22 = function(i) {
    return function(f) {
        return function(xs) {
            var go = function(x) {
                var v = f(x);
                if (v instanceof $h2xUu.Nothing) return $85477afba1c0a604$export$90f9093465da3136(i)(xs);
                if (v instanceof $h2xUu.Just) return $85477afba1c0a604$export$b6d8713d53419d4c(i)(v.value0)(xs);
                throw new Error("Failed pattern match at Data.Array (line 590, column 10 - line 592, column 32): " + [
                    v.constructor.name
                ]);
            };
            return $h2xUu.maybe($h2xUu.Nothing.value)(go)($85477afba1c0a604$export$b610b8812bbcded9(xs)(i));
        };
    };
};

});
parcelRegister("d3m1K", function(module, exports) {

$parcel$export(module.exports, "range", () => $980ca44ac1ebe528$export$d02631cccf789723);
$parcel$export(module.exports, "replicate", () => $980ca44ac1ebe528$export$606959e7ccb797f0);
$parcel$export(module.exports, "fromFoldableImpl", () => $980ca44ac1ebe528$export$7de5ece11b723a44);
$parcel$export(module.exports, "length", () => $980ca44ac1ebe528$export$f24224f1c91d8156);
$parcel$export(module.exports, "unconsImpl", () => $980ca44ac1ebe528$export$99063656965a82f5);
$parcel$export(module.exports, "indexImpl", () => $980ca44ac1ebe528$export$fe8606c16d7ceed6);
$parcel$export(module.exports, "findMapImpl", () => $980ca44ac1ebe528$export$7ad327e9a65b0147);
$parcel$export(module.exports, "findIndexImpl", () => $980ca44ac1ebe528$export$885b84ba169666c7);
$parcel$export(module.exports, "findLastIndexImpl", () => $980ca44ac1ebe528$export$32bcb9f71841245e);
$parcel$export(module.exports, "_insertAt", () => $980ca44ac1ebe528$export$d553b0efc2008003);
$parcel$export(module.exports, "_deleteAt", () => $980ca44ac1ebe528$export$e83371a4d1b4407c);
$parcel$export(module.exports, "_updateAt", () => $980ca44ac1ebe528$export$4bc13c05b5f586d5);
$parcel$export(module.exports, "concat", () => $980ca44ac1ebe528$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "filter", () => $980ca44ac1ebe528$export$3dea766d36a8935f);
$parcel$export(module.exports, "sortByImpl", () => $980ca44ac1ebe528$export$ea0922e78a1b008a);
$parcel$export(module.exports, "slice", () => $980ca44ac1ebe528$export$58adb3bec8346d0f);
$parcel$export(module.exports, "zipWith", () => $980ca44ac1ebe528$export$b634740ce272acb5);
$parcel$export(module.exports, "any", () => $980ca44ac1ebe528$export$4154a199d7d90455);
$parcel$export(module.exports, "all", () => $980ca44ac1ebe528$export$84bf76cd7afc7469);
$parcel$export(module.exports, "unsafeIndexImpl", () => $980ca44ac1ebe528$export$4459d383cf3fd31d);
//------------------------------------------------------------------------------
// Array creation --------------------------------------------------------------
//------------------------------------------------------------------------------
const $980ca44ac1ebe528$export$d02631cccf789723 = function(start) {
    return function(end) {
        var step = start > end ? -1 : 1;
        var result = new Array(step * (end - start) + 1);
        var i = start, n = 0;
        while(i !== end){
            result[n++] = i;
            i += step;
        }
        result[n] = i;
        return result;
    };
};
var $980ca44ac1ebe528$var$replicateFill = function(count) {
    return function(value) {
        if (count < 1) return [];
        var result = new Array(count);
        return result.fill(value);
    };
};
var $980ca44ac1ebe528$var$replicatePolyfill = function(count) {
    return function(value) {
        var result = [];
        var n = 0;
        for(var i = 0; i < count; i++)result[n++] = value;
        return result;
    };
};
const $980ca44ac1ebe528$export$606959e7ccb797f0 = typeof Array.prototype.fill === "function" ? $980ca44ac1ebe528$var$replicateFill : $980ca44ac1ebe528$var$replicatePolyfill;
const $980ca44ac1ebe528$export$7de5ece11b723a44 = function() {
    function Cons(head, tail) {
        this.head = head;
        this.tail = tail;
    }
    var emptyList = {};
    function curryCons(head) {
        return function(tail) {
            return new Cons(head, tail);
        };
    }
    function listToArray(list) {
        var result = [];
        var count = 0;
        var xs = list;
        while(xs !== emptyList){
            result[count++] = xs.head;
            xs = xs.tail;
        }
        return result;
    }
    return function(foldr) {
        return function(xs) {
            return listToArray(foldr(curryCons)(emptyList)(xs));
        };
    };
}();
const $980ca44ac1ebe528$export$f24224f1c91d8156 = function(xs) {
    return xs.length;
};
const $980ca44ac1ebe528$export$99063656965a82f5 = function(empty) {
    return function(next) {
        return function(xs) {
            return xs.length === 0 ? empty({}) : next(xs[0])(xs.slice(1));
        };
    };
};
const $980ca44ac1ebe528$export$fe8606c16d7ceed6 = function(just) {
    return function(nothing) {
        return function(xs) {
            return function(i) {
                return i < 0 || i >= xs.length ? nothing : just(xs[i]);
            };
        };
    };
};
const $980ca44ac1ebe528$export$7ad327e9a65b0147 = function(nothing) {
    return function(isJust) {
        return function(f) {
            return function(xs) {
                for(var i = 0; i < xs.length; i++){
                    var result = f(xs[i]);
                    if (isJust(result)) return result;
                }
                return nothing;
            };
        };
    };
};
const $980ca44ac1ebe528$export$885b84ba169666c7 = function(just) {
    return function(nothing) {
        return function(f) {
            return function(xs) {
                for(var i = 0, l = xs.length; i < l; i++){
                    if (f(xs[i])) return just(i);
                }
                return nothing;
            };
        };
    };
};
const $980ca44ac1ebe528$export$32bcb9f71841245e = function(just) {
    return function(nothing) {
        return function(f) {
            return function(xs) {
                for(var i = xs.length - 1; i >= 0; i--){
                    if (f(xs[i])) return just(i);
                }
                return nothing;
            };
        };
    };
};
const $980ca44ac1ebe528$export$d553b0efc2008003 = function(just) {
    return function(nothing) {
        return function(i) {
            return function(a) {
                return function(l) {
                    if (i < 0 || i > l.length) return nothing;
                    var l1 = l.slice();
                    l1.splice(i, 0, a);
                    return just(l1);
                };
            };
        };
    };
};
const $980ca44ac1ebe528$export$e83371a4d1b4407c = function(just) {
    return function(nothing) {
        return function(i) {
            return function(l) {
                if (i < 0 || i >= l.length) return nothing;
                var l1 = l.slice();
                l1.splice(i, 1);
                return just(l1);
            };
        };
    };
};
const $980ca44ac1ebe528$export$4bc13c05b5f586d5 = function(just) {
    return function(nothing) {
        return function(i) {
            return function(a) {
                return function(l) {
                    if (i < 0 || i >= l.length) return nothing;
                    var l1 = l.slice();
                    l1[i] = a;
                    return just(l1);
                };
            };
        };
    };
};
const $980ca44ac1ebe528$export$66c1ae025e96b4bc = function(l) {
    return l.slice().reverse();
};
const $980ca44ac1ebe528$export$ee1b3e54f0441b22 = function(xss) {
    if (xss.length <= 10000) // This method is faster, but it crashes on big arrays.
    // So we use it when can and fallback to simple variant otherwise.
    return Array.prototype.concat.apply([], xss);
    var result = [];
    for(var i = 0, l = xss.length; i < l; i++){
        var xs = xss[i];
        for(var j = 0, m = xs.length; j < m; j++)result.push(xs[j]);
    }
    return result;
};
const $980ca44ac1ebe528$export$3dea766d36a8935f = function(f) {
    return function(xs) {
        return xs.filter(f);
    };
};
const $980ca44ac1ebe528$export$b29f828819edca8d = function(f) {
    return function(xs) {
        var yes = [];
        var no = [];
        for(var i = 0; i < xs.length; i++){
            var x = xs[i];
            if (f(x)) yes.push(x);
            else no.push(x);
        }
        return {
            yes: yes,
            no: no
        };
    };
};
const $980ca44ac1ebe528$export$65f513eaf3c582b8 = function(f) {
    return function(b) {
        return function(xs) {
            var len = xs.length;
            var acc = b;
            var out = new Array(len);
            for(var i = 0; i < len; i++){
                acc = f(acc)(xs[i]);
                out[i] = acc;
            }
            return out;
        };
    };
};
const $980ca44ac1ebe528$export$64df51ac031d4ad2 = function(f) {
    return function(b) {
        return function(xs) {
            var len = xs.length;
            var acc = b;
            var out = new Array(len);
            for(var i = len - 1; i >= 0; i--){
                acc = f(xs[i])(acc);
                out[i] = acc;
            }
            return out;
        };
    };
};
const $980ca44ac1ebe528$export$ea0922e78a1b008a = function() {
    function mergeFromTo(compare, fromOrdering, xs1, xs2, from, to) {
        var mid;
        var i;
        var j;
        var k;
        var x;
        var y;
        var c;
        mid = from + (to - from >> 1);
        if (mid - from > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, from, mid);
        if (to - mid > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, mid, to);
        i = from;
        j = mid;
        k = from;
        while(i < mid && j < to){
            x = xs2[i];
            y = xs2[j];
            c = fromOrdering(compare(x)(y));
            if (c > 0) {
                xs1[k++] = y;
                ++j;
            } else {
                xs1[k++] = x;
                ++i;
            }
        }
        while(i < mid)xs1[k++] = xs2[i++];
        while(j < to)xs1[k++] = xs2[j++];
    }
    return function(compare) {
        return function(fromOrdering) {
            return function(xs) {
                var out;
                if (xs.length < 2) return xs;
                out = xs.slice(0);
                mergeFromTo(compare, fromOrdering, out, xs.slice(0), 0, xs.length);
                return out;
            };
        };
    };
}();
const $980ca44ac1ebe528$export$58adb3bec8346d0f = function(s) {
    return function(e) {
        return function(l) {
            return l.slice(s, e);
        };
    };
};
const $980ca44ac1ebe528$export$b634740ce272acb5 = function(f) {
    return function(xs) {
        return function(ys) {
            var l = xs.length < ys.length ? xs.length : ys.length;
            var result = new Array(l);
            for(var i = 0; i < l; i++)result[i] = f(xs[i])(ys[i]);
            return result;
        };
    };
};
const $980ca44ac1ebe528$export$4154a199d7d90455 = function(p) {
    return function(xs) {
        var len = xs.length;
        for(var i = 0; i < len; i++){
            if (p(xs[i])) return true;
        }
        return false;
    };
};
const $980ca44ac1ebe528$export$84bf76cd7afc7469 = function(p) {
    return function(xs) {
        var len = xs.length;
        for(var i = 0; i < len; i++){
            if (!p(xs[i])) return false;
        }
        return true;
    };
};
const $980ca44ac1ebe528$export$4459d383cf3fd31d = function(xs) {
    return function(n) {
        return xs[n];
    };
};

});

parcelRegister("bcJ05", function(module, exports) {

$parcel$export(module.exports, "Loop", () => $8283b8dc33fdce74$export$550acbd06a1f5a6a);
$parcel$export(module.exports, "Done", () => $8283b8dc33fdce74$export$7fe28cb29e71bf10);
$parcel$export(module.exports, "tailRecM", () => $8283b8dc33fdce74$export$c025cfd4cc93300b);
$parcel$export(module.exports, "tailRecM2", () => $8283b8dc33fdce74$export$9056a6bb308e8c79);
$parcel$export(module.exports, "monadRecMaybe", () => $8283b8dc33fdce74$export$6a06149683d26749);
$parcel$export(module.exports, "monadRecEffect", () => $8283b8dc33fdce74$export$c2472dc015e90d28);
$parcel$export(module.exports, "bifunctorStep", () => $8283b8dc33fdce74$export$61e43214bca7f031);
// Generated by purs version 0.15.16

var $cADnC = parcelRequire("cADnC");

var $kkdfo = parcelRequire("kkdfo");

var $beQI1 = parcelRequire("beQI1");

var $7FzSN = parcelRequire("7FzSN");

var $8pkky = parcelRequire("8pkky");

var $h2xUu = parcelRequire("h2xUu");

var $3aOYV = parcelRequire("3aOYV");

var $d5vvq = parcelRequire("d5vvq");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");

var $1rTTn = parcelRequire("1rTTn");

var $7fHqi = parcelRequire("7fHqi");
var $lpYuB = parcelRequire("lpYuB");
var $8283b8dc33fdce74$var$bindFlipped = /* #__PURE__ */ $cADnC.bindFlipped($1rTTn.bindEffect);
var $8283b8dc33fdce74$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $8283b8dc33fdce74$export$550acbd06a1f5a6a = /* #__PURE__ */ function() {
    function Loop(value0) {
        this.value0 = value0;
    }
    Loop.create = function(value0) {
        return new Loop(value0);
    };
    return Loop;
}();
var $8283b8dc33fdce74$export$7fe28cb29e71bf10 = /* #__PURE__ */ function() {
    function Done(value0) {
        this.value0 = value0;
    }
    Done.create = function(value0) {
        return new Done(value0);
    };
    return Done;
}();
var $8283b8dc33fdce74$export$c025cfd4cc93300b = function(dict) {
    return dict.tailRecM;
};
var $8283b8dc33fdce74$export$9056a6bb308e8c79 = function(dictMonadRec) {
    var tailRecM1 = $8283b8dc33fdce74$export$c025cfd4cc93300b(dictMonadRec);
    return function(f) {
        return function(a) {
            return function(b) {
                return tailRecM1(function(o) {
                    return f(o.a)(o.b);
                })({
                    a: a,
                    b: b
                });
            };
        };
    };
};
var $8283b8dc33fdce74$export$db5fda1cbdfd94f2 = function(dictMonadRec) {
    var tailRecM1 = $8283b8dc33fdce74$export$c025cfd4cc93300b(dictMonadRec);
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return tailRecM1(function(o) {
                        return f(o.a)(o.b)(o.c);
                    })({
                        a: a,
                        b: b,
                        c: c
                    });
                };
            };
        };
    };
};
var $8283b8dc33fdce74$export$f216db41e265325c = function(dictMonadRec) {
    var tailRecM1 = $8283b8dc33fdce74$export$c025cfd4cc93300b(dictMonadRec);
    var mapFlipped = $7FzSN.mapFlipped(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
    return function(m) {
        return tailRecM1(function(v) {
            return mapFlipped(m)(function(v1) {
                if (v1 instanceof $h2xUu.Nothing) return new $8283b8dc33fdce74$export$550acbd06a1f5a6a($ivFwO.unit);
                if (v1 instanceof $h2xUu.Just) return new $8283b8dc33fdce74$export$7fe28cb29e71bf10(v1.value0);
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 179, column 43 - line 181, column 19): " + [
                    v1.constructor.name
                ]);
            });
        })($ivFwO.unit);
    };
};
var $8283b8dc33fdce74$export$4f7c5e075dda46f7 = function(dictMonoid) {
    var append = $d5vvq.append(dictMonoid.Semigroup0());
    var mempty = $3aOYV.mempty(dictMonoid);
    return function(dictMonadRec) {
        var tailRecM1 = $8283b8dc33fdce74$export$c025cfd4cc93300b(dictMonadRec);
        var mapFlipped = $7FzSN.mapFlipped(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
        return function(m) {
            return tailRecM1(function(v) {
                return mapFlipped(m)(function(v1) {
                    if (v1 instanceof $h2xUu.Nothing) return new $8283b8dc33fdce74$export$7fe28cb29e71bf10(v);
                    if (v1 instanceof $h2xUu.Just) return new $8283b8dc33fdce74$export$550acbd06a1f5a6a(append(v)(v1.value0));
                    throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 172, column 45 - line 174, column 26): " + [
                        v1.constructor.name
                    ]);
                });
            })(mempty);
        };
    };
};
var $8283b8dc33fdce74$export$2e586eaa876dd2fd = function(f) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $8283b8dc33fdce74$export$550acbd06a1f5a6a) {
                $copy_v = f(v.value0);
                return;
            }
            if (v instanceof $8283b8dc33fdce74$export$7fe28cb29e71bf10) {
                $tco_done = true;
                return v.value0;
            }
            throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 103, column 3 - line 103, column 25): " + [
                v.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return function($85) {
        return go(f($85));
    };
};
var $8283b8dc33fdce74$export$1a33088d59e37d84 = function(f) {
    return function(a) {
        return function(b) {
            return $8283b8dc33fdce74$export$2e586eaa876dd2fd(function(o) {
                return f(o.a)(o.b);
            })({
                a: a,
                b: b
            });
        };
    };
};
var $8283b8dc33fdce74$export$6866e5a95a71aa68 = function(f) {
    return function(a) {
        return function(b) {
            return function(c) {
                return $8283b8dc33fdce74$export$2e586eaa876dd2fd(function(o) {
                    return f(o.a)(o.b)(o.c);
                })({
                    a: a,
                    b: b,
                    c: c
                });
            };
        };
    };
};
var $8283b8dc33fdce74$export$6a06149683d26749 = {
    tailRecM: function(f) {
        return function(a0) {
            var g = function(v) {
                if (v instanceof $h2xUu.Nothing) return new $8283b8dc33fdce74$export$7fe28cb29e71bf10($h2xUu.Nothing.value);
                if (v instanceof $h2xUu.Just && v.value0 instanceof $8283b8dc33fdce74$export$550acbd06a1f5a6a) return new $8283b8dc33fdce74$export$550acbd06a1f5a6a(f(v.value0.value0));
                if (v instanceof $h2xUu.Just && v.value0 instanceof $8283b8dc33fdce74$export$7fe28cb29e71bf10) return new $8283b8dc33fdce74$export$7fe28cb29e71bf10(new $h2xUu.Just(v.value0.value0));
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 153, column 7 - line 153, column 31): " + [
                    v.constructor.name
                ]);
            };
            return $8283b8dc33fdce74$export$2e586eaa876dd2fd(g)(f(a0));
        };
    },
    Monad0: function() {
        return $h2xUu.monadMaybe;
    }
};
var $8283b8dc33fdce74$export$ef692454cdd8c2ba = {
    tailRecM: function(f) {
        var runIdentity = function(v) {
            return v;
        };
        var $86 = $8283b8dc33fdce74$export$2e586eaa876dd2fd(function($88) {
            return runIdentity(f($88));
        });
        return function($87) {
            return $8pkky.Identity($86($87));
        };
    },
    Monad0: function() {
        return $8pkky.monadIdentity;
    }
};
var $8283b8dc33fdce74$export$6871d929a8e135b0 = {
    tailRecM: function(f) {
        return function(a0) {
            return function(e) {
                return $8283b8dc33fdce74$export$2e586eaa876dd2fd(function(a) {
                    return f(a)(e);
                })(a0);
            };
        };
    },
    Monad0: function() {
        return $kkdfo.monadFn;
    }
};
var $8283b8dc33fdce74$export$ddd28c989be5e46c = {
    tailRecM: function(f) {
        return function(a0) {
            var g = function(v) {
                if (v instanceof $beQI1.Left) return new $8283b8dc33fdce74$export$7fe28cb29e71bf10(new $beQI1.Left(v.value0));
                if (v instanceof $beQI1.Right && v.value0 instanceof $8283b8dc33fdce74$export$550acbd06a1f5a6a) return new $8283b8dc33fdce74$export$550acbd06a1f5a6a(f(v.value0.value0));
                if (v instanceof $beQI1.Right && v.value0 instanceof $8283b8dc33fdce74$export$7fe28cb29e71bf10) return new $8283b8dc33fdce74$export$7fe28cb29e71bf10(new $beQI1.Right(v.value0.value0));
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 145, column 7 - line 145, column 33): " + [
                    v.constructor.name
                ]);
            };
            return $8283b8dc33fdce74$export$2e586eaa876dd2fd(g)(f(a0));
        };
    },
    Monad0: function() {
        return $beQI1.monadEither;
    }
};
var $8283b8dc33fdce74$export$c2472dc015e90d28 = {
    tailRecM: function(f) {
        return function(a) {
            var fromDone = function(v) {
                if (v instanceof $8283b8dc33fdce74$export$7fe28cb29e71bf10) return v.value0;
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 137, column 30 - line 137, column 44): " + [
                    v.constructor.name
                ]);
            };
            return function __do() {
                var r = $8283b8dc33fdce74$var$bindFlipped($7fHqi.new)(f(a))();
                (function() {
                    while(!function __do() {
                        var v = $lpYuB.read(r)();
                        if (v instanceof $8283b8dc33fdce74$export$550acbd06a1f5a6a) {
                            var e = f(v.value0)();
                            $lpYuB.write(e)(r)();
                            return false;
                        }
                        if (v instanceof $8283b8dc33fdce74$export$7fe28cb29e71bf10) return true;
                        throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 128, column 22 - line 133, column 28): " + [
                            v.constructor.name
                        ]);
                    }());
                    return {};
                })();
                return $8283b8dc33fdce74$var$map(fromDone)($lpYuB.read(r))();
            };
        };
    },
    Monad0: function() {
        return $1rTTn.monadEffect;
    }
};
var $8283b8dc33fdce74$export$432fdf8e79663288 = function(a) {
    return function(b) {
        return function(c) {
            return new $8283b8dc33fdce74$export$550acbd06a1f5a6a({
                a: a,
                b: b,
                c: c
            });
        };
    };
};
var $8283b8dc33fdce74$export$e10d15f285e25594 = function(a) {
    return function(b) {
        return new $8283b8dc33fdce74$export$550acbd06a1f5a6a({
            a: a,
            b: b
        });
    };
};
var $8283b8dc33fdce74$export$ff1ade7cb067ac12 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $8283b8dc33fdce74$export$550acbd06a1f5a6a) return new $8283b8dc33fdce74$export$550acbd06a1f5a6a(m.value0);
            if (m instanceof $8283b8dc33fdce74$export$7fe28cb29e71bf10) return new $8283b8dc33fdce74$export$7fe28cb29e71bf10(f(m.value0));
            throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $8283b8dc33fdce74$export$116a0f7f2303acd8 = function(dictMonadRec) {
    var tailRecM1 = $8283b8dc33fdce74$export$c025cfd4cc93300b(dictMonadRec);
    var voidRight = $7FzSN.voidRight(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
    return function(ma) {
        return tailRecM1(function(u) {
            return voidRight(new $8283b8dc33fdce74$export$550acbd06a1f5a6a(u))(ma);
        })($ivFwO.unit);
    };
};
var $8283b8dc33fdce74$export$61e43214bca7f031 = {
    bimap: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $8283b8dc33fdce74$export$550acbd06a1f5a6a) return new $8283b8dc33fdce74$export$550acbd06a1f5a6a(v(v2.value0));
                if (v2 instanceof $8283b8dc33fdce74$export$7fe28cb29e71bf10) return new $8283b8dc33fdce74$export$7fe28cb29e71bf10(v1(v2.value0));
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 33, column 1 - line 35, column 34): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    }
};

});
parcelRegister("8pkky", function(module, exports) {

$parcel$export(module.exports, "Identity", () => $61f06dbe1b4a068f$export$544bf02140fa9a77);
$parcel$export(module.exports, "functorIdentity", () => $61f06dbe1b4a068f$export$dc85e8383eafbd81);
$parcel$export(module.exports, "monadIdentity", () => $61f06dbe1b4a068f$export$9a2f2fd6148bc6d0);
// Generated by purs version 0.15.16

var $aJhEx = parcelRequire("aJhEx");

var $7nwca = parcelRequire("7nwca");

var $gwBF5 = parcelRequire("gwBF5");

var $2XxiF = parcelRequire("2XxiF");
var $61f06dbe1b4a068f$export$544bf02140fa9a77 = function(x) {
    return x;
};
var $61f06dbe1b4a068f$export$7af8a265c45f06a6 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(v) {
            return "(Identity " + (show(v) + ")");
        }
    };
};
var $61f06dbe1b4a068f$export$de6e130f3067e173 = function(dictSemiring) {
    return dictSemiring;
};
var $61f06dbe1b4a068f$export$fbd9f08ec652d5d9 = function(dictSemigroup) {
    return dictSemigroup;
};
var $61f06dbe1b4a068f$export$7f1a4089c064b339 = function(dictRing) {
    return dictRing;
};
var $61f06dbe1b4a068f$export$af307155aba4d997 = function(dictOrd) {
    return dictOrd;
};
var $61f06dbe1b4a068f$export$4e4e6c89b10840f9 = {
    Coercible0: function() {
        return undefined;
    }
};
var $61f06dbe1b4a068f$export$2f07791950174d24 = function(dictMonoid) {
    return dictMonoid;
};
var $61f06dbe1b4a068f$export$c7656c1a42d43140 = function(dictLazy) {
    return dictLazy;
};
var $61f06dbe1b4a068f$export$7e3f9626786077f7 = function(dictHeytingAlgebra) {
    return dictHeytingAlgebra;
};
var $61f06dbe1b4a068f$export$dc85e8383eafbd81 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $61f06dbe1b4a068f$export$ace4d1c3770c9591 = {
    imap: /* #__PURE__ */ $7nwca.imapF($61f06dbe1b4a068f$export$dc85e8383eafbd81)
};
var $61f06dbe1b4a068f$export$a04fa6f5a41919d9 = {
    extend: function(f) {
        return function(m) {
            return f(m);
        };
    },
    Functor0: function() {
        return $61f06dbe1b4a068f$export$dc85e8383eafbd81;
    }
};
var $61f06dbe1b4a068f$export$4d1b13d40da4cff7 = function(dictEuclideanRing) {
    return dictEuclideanRing;
};
var $61f06dbe1b4a068f$export$b3449ff235884fd4 = function(dictEq) {
    return dictEq;
};
var $61f06dbe1b4a068f$export$43b3c8db16b4e7b8 = {
    eq1: function(dictEq) {
        return $aJhEx.eq($61f06dbe1b4a068f$export$b3449ff235884fd4(dictEq));
    }
};
var $61f06dbe1b4a068f$export$982c033a83dfd7d3 = {
    compare1: function(dictOrd) {
        return $gwBF5.compare($61f06dbe1b4a068f$export$af307155aba4d997(dictOrd));
    },
    Eq10: function() {
        return $61f06dbe1b4a068f$export$43b3c8db16b4e7b8;
    }
};
var $61f06dbe1b4a068f$export$aac6efd7b2eac4c4 = {
    extract: function(v) {
        return v;
    },
    Extend0: function() {
        return $61f06dbe1b4a068f$export$a04fa6f5a41919d9;
    }
};
var $61f06dbe1b4a068f$export$133f9093a008dc4d = function(dictCommutativeRing) {
    return dictCommutativeRing;
};
var $61f06dbe1b4a068f$export$5be407eed81cb759 = function(dictBounded) {
    return dictBounded;
};
var $61f06dbe1b4a068f$export$c3b024d9c40a32df = function(dictBooleanAlgebra) {
    return dictBooleanAlgebra;
};
var $61f06dbe1b4a068f$export$c7d2c62721e92954 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $61f06dbe1b4a068f$export$dc85e8383eafbd81;
    }
};
var $61f06dbe1b4a068f$export$91e759983456b85e = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $61f06dbe1b4a068f$export$c7d2c62721e92954;
    }
};
var $61f06dbe1b4a068f$export$fd3b2458e55fc503 = {
    pure: $61f06dbe1b4a068f$export$544bf02140fa9a77,
    Apply0: function() {
        return $61f06dbe1b4a068f$export$c7d2c62721e92954;
    }
};
var $61f06dbe1b4a068f$export$9a2f2fd6148bc6d0 = {
    Applicative0: function() {
        return $61f06dbe1b4a068f$export$fd3b2458e55fc503;
    },
    Bind1: function() {
        return $61f06dbe1b4a068f$export$91e759983456b85e;
    }
};
var $61f06dbe1b4a068f$export$1cd7ff14f6a7fcef = {
    alt: function(x) {
        return function(v) {
            return x;
        };
    },
    Functor0: function() {
        return $61f06dbe1b4a068f$export$dc85e8383eafbd81;
    }
};

});

parcelRegister("7fHqi", function(module, exports) {

$parcel$export(module.exports, "new", () => $547b9e1021866246$export$b8cb59497041ffe4);
$parcel$export(module.exports, "modify$prime", () => $547b9e1021866246$export$4d5401161a900ce1);
$parcel$export(module.exports, "modify", () => $547b9e1021866246$export$3ff57735a52b8713);
$parcel$export(module.exports, "modify_", () => $547b9e1021866246$export$45b91115a89d6020);
$parcel$export(module.exports, "read", () => (parcelRequire("lpYuB")).read);
$parcel$export(module.exports, "write", () => (parcelRequire("lpYuB")).write);
// Generated by purs version 0.15.16

var $lpYuB = parcelRequire("lpYuB");

var $7FzSN = parcelRequire("7FzSN");

var $1rTTn = parcelRequire("1rTTn");
var $547b9e1021866246$var$$$void = /* #__PURE__ */ $7FzSN.void($1rTTn.functorEffect);
var $547b9e1021866246$export$b8cb59497041ffe4 = $lpYuB._new;
var $547b9e1021866246$export$4d5401161a900ce1 = $lpYuB.modifyImpl;
var $547b9e1021866246$export$3ff57735a52b8713 = function(f) {
    return $547b9e1021866246$export$4d5401161a900ce1(function(s) {
        var s$prime = f(s);
        return {
            state: s$prime,
            value: s$prime
        };
    });
};
var $547b9e1021866246$export$45b91115a89d6020 = function(f) {
    return function(s) {
        return $547b9e1021866246$var$$$void($547b9e1021866246$export$3ff57735a52b8713(f)(s));
    };
};

});
parcelRegister("lpYuB", function(module, exports) {

$parcel$export(module.exports, "_new", () => $f97adb55e1bfdc1c$export$339fb7f00efd6941);
$parcel$export(module.exports, "read", () => $f97adb55e1bfdc1c$export$aafa59e2e03f2942);
$parcel$export(module.exports, "modifyImpl", () => $f97adb55e1bfdc1c$export$cc2488c59b3f757);
$parcel$export(module.exports, "write", () => $f97adb55e1bfdc1c$export$68d8715fc104d294);
const $f97adb55e1bfdc1c$export$339fb7f00efd6941 = function(val) {
    return function() {
        return {
            value: val
        };
    };
};
const $f97adb55e1bfdc1c$export$d23276e97b1411ef = function(f) {
    return function() {
        var ref = {
            value: null
        };
        ref.value = f(ref);
        return ref;
    };
};
const $f97adb55e1bfdc1c$export$aafa59e2e03f2942 = function(ref) {
    return function() {
        return ref.value;
    };
};
const $f97adb55e1bfdc1c$export$cc2488c59b3f757 = function(f) {
    return function(ref) {
        return function() {
            var t = f(ref.value);
            ref.value = t.state;
            return t.value;
        };
    };
};
const $f97adb55e1bfdc1c$export$68d8715fc104d294 = function(val) {
    return function(ref) {
        return function() {
            ref.value = val;
        };
    };
};

});



parcelRegister("k1We4", function(module, exports) {

$parcel$export(module.exports, "modify", () => $e951111d118006e5$export$3ff57735a52b8713);
$parcel$export(module.exports, "functorST", () => $e951111d118006e5$export$a47991927f51461e);
$parcel$export(module.exports, "monadST", () => $e951111d118006e5$export$962073314682c2c);
$parcel$export(module.exports, "applicativeST", () => $e951111d118006e5$export$603d84e49041d7b2);
$parcel$export(module.exports, "bindST", () => $e951111d118006e5$export$14049c9ff5b55fb3);
$parcel$export(module.exports, "monadRecST", () => $e951111d118006e5$export$24025a1415d0847d);
$parcel$export(module.exports, "for", () => (parcelRequire("4rtOs")).for);
$parcel$export(module.exports, "foreach", () => (parcelRequire("4rtOs")).foreach);
$parcel$export(module.exports, "new", () => (parcelRequire("4rtOs")).new);
$parcel$export(module.exports, "read", () => (parcelRequire("4rtOs")).read);
$parcel$export(module.exports, "write", () => (parcelRequire("4rtOs")).write);
// Generated by purs version 0.15.16

var $4rtOs = parcelRequire("4rtOs");

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $kkdfo = parcelRequire("kkdfo");

var $bcJ05 = parcelRequire("bcJ05");

var $7FzSN = parcelRequire("7FzSN");

var $3aOYV = parcelRequire("3aOYV");

var $d5vvq = parcelRequire("d5vvq");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
var $e951111d118006e5$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $e951111d118006e5$export$4d5401161a900ce1 = $4rtOs.modifyImpl;
var $e951111d118006e5$export$3ff57735a52b8713 = function(f) {
    return $e951111d118006e5$export$4d5401161a900ce1(function(s) {
        var s$prime = f(s);
        return {
            state: s$prime,
            value: s$prime
        };
    });
};
var $e951111d118006e5$export$a47991927f51461e = {
    map: $4rtOs.map_
};
var $e951111d118006e5$var$map = /* #__PURE__ */ $7FzSN.map($e951111d118006e5$export$a47991927f51461e);
var $e951111d118006e5$var$$$void = /* #__PURE__ */ $7FzSN.void($e951111d118006e5$export$a47991927f51461e);
var $e951111d118006e5$export$962073314682c2c = {
    Applicative0: function() {
        return $e951111d118006e5$export$603d84e49041d7b2;
    },
    Bind1: function() {
        return $e951111d118006e5$export$14049c9ff5b55fb3;
    }
};
var $e951111d118006e5$export$14049c9ff5b55fb3 = {
    bind: $4rtOs.bind_,
    Apply0: function() {
        return $e951111d118006e5$var$$lazy_applyST(0);
    }
};
var $e951111d118006e5$export$603d84e49041d7b2 = {
    pure: $4rtOs.pure_,
    Apply0: function() {
        return $e951111d118006e5$var$$lazy_applyST(0);
    }
};
var $e951111d118006e5$var$$lazy_applyST = /* #__PURE__ */ $e951111d118006e5$var$$runtime_lazy("applyST", "Control.Monad.ST.Internal", function() {
    return {
        apply: $kkdfo.ap($e951111d118006e5$export$962073314682c2c),
        Functor0: function() {
            return $e951111d118006e5$export$a47991927f51461e;
        }
    };
});
var $e951111d118006e5$export$65915895b3a8faeb = /* #__PURE__ */ $e951111d118006e5$var$$lazy_applyST(47);
var $e951111d118006e5$var$lift2 = /* #__PURE__ */ $26ZCq.lift2($e951111d118006e5$export$65915895b3a8faeb);
var $e951111d118006e5$var$bind = /* #__PURE__ */ $cADnC.bind($e951111d118006e5$export$14049c9ff5b55fb3);
var $e951111d118006e5$var$bindFlipped = /* #__PURE__ */ $cADnC.bindFlipped($e951111d118006e5$export$14049c9ff5b55fb3);
var $e951111d118006e5$var$discard = /* #__PURE__ */ $cADnC.discard($cADnC.discardUnit)($e951111d118006e5$export$14049c9ff5b55fb3);
var $e951111d118006e5$var$pure = /* #__PURE__ */ $bQdkN.pure($e951111d118006e5$export$603d84e49041d7b2);
var $e951111d118006e5$export$56941e1c622ade00 = function(dictSemigroup) {
    return {
        append: $e951111d118006e5$var$lift2($d5vvq.append(dictSemigroup))
    };
};
var $e951111d118006e5$export$24025a1415d0847d = {
    tailRecM: function(f) {
        return function(a) {
            var isLooping = function(v) {
                if (v instanceof $bcJ05.Loop) return true;
                return false;
            };
            var fromDone = function(v) {
                if (v instanceof $bcJ05.Done) return v.value0;
                throw new Error("Failed pattern match at Control.Monad.ST.Internal (line 70, column 32 - line 70, column 46): " + [
                    v.constructor.name
                ]);
            };
            return $e951111d118006e5$var$bind($e951111d118006e5$var$bindFlipped($4rtOs.new)(f(a)))(function(r) {
                return $e951111d118006e5$var$discard($4rtOs.while($e951111d118006e5$var$map(isLooping)($4rtOs.read(r)))($e951111d118006e5$var$bind($4rtOs.read(r))(function(v) {
                    if (v instanceof $bcJ05.Loop) return $e951111d118006e5$var$bind(f(v.value0))(function(e) {
                        return $e951111d118006e5$var$$$void($4rtOs.write(e)(r));
                    });
                    if (v instanceof $bcJ05.Done) return $e951111d118006e5$var$pure($ivFwO.unit);
                    throw new Error("Failed pattern match at Control.Monad.ST.Internal (line 62, column 18 - line 66, column 28): " + [
                        v.constructor.name
                    ]);
                })))(function() {
                    return $e951111d118006e5$var$map(fromDone)($4rtOs.read(r));
                });
            });
        };
    },
    Monad0: function() {
        return $e951111d118006e5$export$962073314682c2c;
    }
};
var $e951111d118006e5$export$85c55a7e282bbb67 = function(dictMonoid) {
    var semigroupST1 = $e951111d118006e5$export$56941e1c622ade00(dictMonoid.Semigroup0());
    return {
        mempty: $e951111d118006e5$var$pure($3aOYV.mempty(dictMonoid)),
        Semigroup0: function() {
            return semigroupST1;
        }
    };
};

});
parcelRegister("4rtOs", function(module, exports) {

$parcel$export(module.exports, "map_", () => $33c0cf4449e95190$export$aca8cce159e578de);
$parcel$export(module.exports, "pure_", () => $33c0cf4449e95190$export$3bbfc465dcacc7f4);
$parcel$export(module.exports, "bind_", () => $33c0cf4449e95190$export$b25ab69b10c0d17b);
$parcel$export(module.exports, "while", () => $33c0cf4449e95190$export$f021a974ad8da35c);
$parcel$export(module.exports, "for", () => $33c0cf4449e95190$export$f89de2e5bf57e5e6);
$parcel$export(module.exports, "foreach", () => $33c0cf4449e95190$export$8802485f9deae94f);
$parcel$export(module.exports, "new", () => $33c0cf4449e95190$export$b8cb59497041ffe4);
$parcel$export(module.exports, "read", () => $33c0cf4449e95190$export$aafa59e2e03f2942);
$parcel$export(module.exports, "modifyImpl", () => $33c0cf4449e95190$export$cc2488c59b3f757);
$parcel$export(module.exports, "write", () => $33c0cf4449e95190$export$68d8715fc104d294);
const $33c0cf4449e95190$export$aca8cce159e578de = function(f) {
    return function(a) {
        return function() {
            return f(a());
        };
    };
};
const $33c0cf4449e95190$export$3bbfc465dcacc7f4 = function(a) {
    return function() {
        return a;
    };
};
const $33c0cf4449e95190$export$b25ab69b10c0d17b = function(a) {
    return function(f) {
        return function() {
            return f(a())();
        };
    };
};
const $33c0cf4449e95190$export$889ea624f2cb2c57 = function(f) {
    return f();
};
function $33c0cf4449e95190$export$f021a974ad8da35c(f) {
    return function(a) {
        return function() {
            while(f())a();
        };
    };
}
function $33c0cf4449e95190$export$f89de2e5bf57e5e6(lo) {
    return function(hi) {
        return function(f) {
            return function() {
                for(var i = lo; i < hi; i++)f(i)();
            };
        };
    };
}
const $33c0cf4449e95190$export$8802485f9deae94f = function(as) {
    return function(f) {
        return function() {
            for(var i = 0, l = as.length; i < l; i++)f(as[i])();
        };
    };
};
function $33c0cf4449e95190$export$b8cb59497041ffe4(val) {
    return function() {
        return {
            value: val
        };
    };
}
const $33c0cf4449e95190$export$aafa59e2e03f2942 = function(ref) {
    return function() {
        return ref.value;
    };
};
const $33c0cf4449e95190$export$cc2488c59b3f757 = function(f) {
    return function(ref) {
        return function() {
            var t = f(ref.value);
            ref.value = t.state;
            return t.value;
        };
    };
};
const $33c0cf4449e95190$export$68d8715fc104d294 = function(a) {
    return function(ref) {
        return function() {
            return ref.value = a; // eslint-disable-line no-return-assign
        };
    };
};

});


parcelRegister("8cbRe", function(module, exports) {

$parcel$export(module.exports, "withArray", () => $5f78a4601c2db2d8$export$fd51609fe570ea92);
$parcel$export(module.exports, "run", () => $5f78a4601c2db2d8$export$889ea624f2cb2c57);
$parcel$export(module.exports, "push", () => $5f78a4601c2db2d8$export$4cbf152802aa238);
$parcel$export(module.exports, "modify", () => $5f78a4601c2db2d8$export$3ff57735a52b8713);
$parcel$export(module.exports, "new", () => (parcelRequire("hnZPO")).new);
$parcel$export(module.exports, "poke", () => (parcelRequire("hnZPO")).poke);
$parcel$export(module.exports, "unsafeFreeze", () => (parcelRequire("hnZPO")).unsafeFreeze);
$parcel$export(module.exports, "unsafeThaw", () => (parcelRequire("hnZPO")).unsafeThaw);
// Generated by purs version 0.15.16

var $hnZPO = parcelRequire("hnZPO");

var $cADnC = parcelRequire("cADnC");

var $k1We4 = parcelRequire("k1We4");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");
var $5f78a4601c2db2d8$var$bind = /* #__PURE__ */ $cADnC.bind($k1We4.bindST);
var $5f78a4601c2db2d8$export$fd51609fe570ea92 = function(f) {
    return function(xs) {
        return function __do() {
            var result = $hnZPO.thaw(xs)();
            f(result)();
            return $hnZPO.unsafeFreeze(result)();
        };
    };
};
var $5f78a4601c2db2d8$export$37cdb546b806ae87 = function(a) {
    return $hnZPO.unshiftAll([
        a
    ]);
};
var $5f78a4601c2db2d8$export$b035e44d7bb4278f = function(comp) {
    return $hnZPO.sortByImpl(comp)(function(v) {
        if (v instanceof $ibsD5.GT) return 1;
        if (v instanceof $ibsD5.EQ) return 0;
        if (v instanceof $ibsD5.LT) return -1;
        throw new Error("Failed pattern match at Data.Array.ST (line 108, column 31 - line 111, column 11): " + [
            v.constructor.name
        ]);
    });
};
var $5f78a4601c2db2d8$export$a9e7d1a6fdcfefde = function(dictOrd) {
    var comparing = $gwBF5.comparing(dictOrd);
    return function(f) {
        return $5f78a4601c2db2d8$export$b035e44d7bb4278f(comparing(f));
    };
};
var $5f78a4601c2db2d8$export$97db5808d8f88186 = function(dictOrd) {
    return $5f78a4601c2db2d8$export$b035e44d7bb4278f($gwBF5.compare(dictOrd));
};
var $5f78a4601c2db2d8$export$fba63a578e423eb = /* #__PURE__ */ function() {
    return $hnZPO.shiftImpl($h2xUu.Just.create)($h2xUu.Nothing.value);
}();
var $5f78a4601c2db2d8$export$889ea624f2cb2c57 = function(st) {
    return $5f78a4601c2db2d8$var$bind(st)($hnZPO.unsafeFreeze)();
};
var $5f78a4601c2db2d8$export$4cbf152802aa238 = function(a) {
    return $hnZPO.pushAll([
        a
    ]);
};
var $5f78a4601c2db2d8$export$3e41007ebfff0e64 = /* #__PURE__ */ function() {
    return $hnZPO.popImpl($h2xUu.Just.create)($h2xUu.Nothing.value);
}();
var $5f78a4601c2db2d8$export$4d3fb11e950abb9e = /* #__PURE__ */ function() {
    return $hnZPO.peekImpl($h2xUu.Just.create)($h2xUu.Nothing.value);
}();
var $5f78a4601c2db2d8$export$3ff57735a52b8713 = function(i) {
    return function(f) {
        return function(xs) {
            return function __do() {
                var entry = $5f78a4601c2db2d8$export$4d3fb11e950abb9e(i)(xs)();
                if (entry instanceof $h2xUu.Just) return $hnZPO.poke(i)(f(entry.value0))(xs)();
                if (entry instanceof $h2xUu.Nothing) return false;
                throw new Error("Failed pattern match at Data.Array.ST (line 193, column 3 - line 195, column 26): " + [
                    entry.constructor.name
                ]);
            };
        };
    };
};

});
parcelRegister("hnZPO", function(module, exports) {

$parcel$export(module.exports, "new", () => $ca848cbb4881a73e$export$b8cb59497041ffe4);
$parcel$export(module.exports, "peekImpl", () => $ca848cbb4881a73e$export$6dc5f95d8548a16a);
$parcel$export(module.exports, "poke", () => $ca848cbb4881a73e$export$dc13bdd74c909d26);
$parcel$export(module.exports, "popImpl", () => $ca848cbb4881a73e$export$636ddc1660dd1285);
$parcel$export(module.exports, "pushAll", () => $ca848cbb4881a73e$export$907644183e99da16);
$parcel$export(module.exports, "shiftImpl", () => $ca848cbb4881a73e$export$8a1b3b221575bba8);
$parcel$export(module.exports, "unshiftAll", () => $ca848cbb4881a73e$export$8ff712f7409e81c7);
$parcel$export(module.exports, "unsafeFreeze", () => $ca848cbb4881a73e$export$7c850c5af9b9983e);
$parcel$export(module.exports, "unsafeThaw", () => $ca848cbb4881a73e$export$cc9b8725eef9c137);
$parcel$export(module.exports, "thaw", () => $ca848cbb4881a73e$export$80340c06f76ce783);
$parcel$export(module.exports, "sortByImpl", () => $ca848cbb4881a73e$export$ea0922e78a1b008a);
function $ca848cbb4881a73e$export$b8cb59497041ffe4() {
    return [];
}
const $ca848cbb4881a73e$export$6dc5f95d8548a16a = function(just) {
    return function(nothing) {
        return function(i) {
            return function(xs) {
                return function() {
                    return i >= 0 && i < xs.length ? just(xs[i]) : nothing;
                };
            };
        };
    };
};
const $ca848cbb4881a73e$export$dc13bdd74c909d26 = function(i) {
    return function(a) {
        return function(xs) {
            return function() {
                var ret = i >= 0 && i < xs.length;
                if (ret) xs[i] = a;
                return ret;
            };
        };
    };
};
const $ca848cbb4881a73e$export$636ddc1660dd1285 = function(just) {
    return function(nothing) {
        return function(xs) {
            return function() {
                return xs.length > 0 ? just(xs.pop()) : nothing;
            };
        };
    };
};
const $ca848cbb4881a73e$export$907644183e99da16 = function(as) {
    return function(xs) {
        return function() {
            return xs.push.apply(xs, as);
        };
    };
};
const $ca848cbb4881a73e$export$8a1b3b221575bba8 = function(just) {
    return function(nothing) {
        return function(xs) {
            return function() {
                return xs.length > 0 ? just(xs.shift()) : nothing;
            };
        };
    };
};
const $ca848cbb4881a73e$export$8ff712f7409e81c7 = function(as) {
    return function(xs) {
        return function() {
            return xs.unshift.apply(xs, as);
        };
    };
};
const $ca848cbb4881a73e$export$869882364835d202 = function(i) {
    return function(howMany) {
        return function(bs) {
            return function(xs) {
                return function() {
                    return xs.splice.apply(xs, [
                        i,
                        howMany
                    ].concat(bs));
                };
            };
        };
    };
};
const $ca848cbb4881a73e$export$7c850c5af9b9983e = function(xs) {
    return function() {
        return xs;
    };
};
const $ca848cbb4881a73e$export$cc9b8725eef9c137 = function(xs) {
    return function() {
        return xs;
    };
};
function $ca848cbb4881a73e$var$copyImpl(xs) {
    return function() {
        return xs.slice();
    };
}
const $ca848cbb4881a73e$export$792f3d81ea979f55 = $ca848cbb4881a73e$var$copyImpl;
const $ca848cbb4881a73e$export$80340c06f76ce783 = $ca848cbb4881a73e$var$copyImpl;
const $ca848cbb4881a73e$export$ea0922e78a1b008a = function() {
    function mergeFromTo(compare, fromOrdering, xs1, xs2, from, to) {
        var mid;
        var i;
        var j;
        var k;
        var x;
        var y;
        var c;
        mid = from + (to - from >> 1);
        if (mid - from > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, from, mid);
        if (to - mid > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, mid, to);
        i = from;
        j = mid;
        k = from;
        while(i < mid && j < to){
            x = xs2[i];
            y = xs2[j];
            c = fromOrdering(compare(x)(y));
            if (c > 0) {
                xs1[k++] = y;
                ++j;
            } else {
                xs1[k++] = x;
                ++i;
            }
        }
        while(i < mid)xs1[k++] = xs2[i++];
        while(j < to)xs1[k++] = xs2[j++];
    }
    return function(compare) {
        return function(fromOrdering) {
            return function(xs) {
                return function() {
                    if (xs.length < 2) return xs;
                    mergeFromTo(compare, fromOrdering, xs, xs.slice(0), 0, xs.length);
                    return xs;
                };
            };
        };
    };
}();
const $ca848cbb4881a73e$export$a8793e37025aca3d = function(xs) {
    return function() {
        var n = xs.length;
        var as = new Array(n);
        for(var i = 0; i < n; i++)as[i] = {
            value: xs[i],
            index: i
        };
        return as;
    };
};

});


parcelRegister("2uFbl", function(module, exports) {

$parcel$export(module.exports, "pushWhile", () => $1d0e53f878733234$export$f458d78453dee163);
$parcel$export(module.exports, "iterator", () => $1d0e53f878733234$export$6f58e2338da23f4d);
$parcel$export(module.exports, "iterate", () => $1d0e53f878733234$export$c1a059043cc9c119);
// Generated by purs version 0.15.16

var $k1We4 = parcelRequire("k1We4");
var $4rtOs = parcelRequire("4rtOs");

var $8cbRe = parcelRequire("8cbRe");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $IhyKA = parcelRequire("IhyKA");

var $h2xUu = parcelRequire("h2xUu");
var $1d0e53f878733234$var$map = /* #__PURE__ */ $7FzSN.map($k1We4.functorST);
var $1d0e53f878733234$var$not = /* #__PURE__ */ $IhyKA.not($IhyKA.heytingAlgebraBoolean);
var $1d0e53f878733234$var$$$void = /* #__PURE__ */ $7FzSN.void($k1We4.functorST);
var $1d0e53f878733234$var$Iterator = /* #__PURE__ */ function() {
    function Iterator(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Iterator.create = function(value0) {
        return function(value1) {
            return new Iterator(value0, value1);
        };
    };
    return Iterator;
}();
var $1d0e53f878733234$export$4d3fb11e950abb9e = function(v) {
    return function __do() {
        var i = $4rtOs.read(v.value1)();
        return v.value0(i);
    };
};
var $1d0e53f878733234$export$48cfd1e771a65c4f = function(v) {
    return function __do() {
        var i = $4rtOs.read(v.value1)();
        $k1We4.modify(function(v1) {
            return v1 + 1 | 0;
        })(v.value1)();
        return v.value0(i);
    };
};
var $1d0e53f878733234$export$f458d78453dee163 = function(p) {
    return function(iter) {
        return function(array) {
            return function __do() {
                var $$break = $4rtOs.new(false)();
                while($1d0e53f878733234$var$map($1d0e53f878733234$var$not)($4rtOs.read($$break))())(function __do() {
                    var mx = $1d0e53f878733234$export$4d3fb11e950abb9e(iter)();
                    if (mx instanceof $h2xUu.Just && p(mx.value0)) {
                        $8cbRe.push(mx.value0)(array)();
                        return $1d0e53f878733234$var$$$void($1d0e53f878733234$export$48cfd1e771a65c4f(iter))();
                    }
                    return $1d0e53f878733234$var$$$void($4rtOs.write(true)($$break))();
                })();
                return {};
            };
        };
    };
};
var $1d0e53f878733234$export$907644183e99da16 = /* #__PURE__ */ $1d0e53f878733234$export$f458d78453dee163(/* #__PURE__ */ $jhsiw.const(true));
var $1d0e53f878733234$export$6f58e2338da23f4d = function(f) {
    return $1d0e53f878733234$var$map($1d0e53f878733234$var$Iterator.create(f))($4rtOs.new(0));
};
var $1d0e53f878733234$export$c1a059043cc9c119 = function(iter) {
    return function(f) {
        return function __do() {
            var $$break = $4rtOs.new(false)();
            while($1d0e53f878733234$var$map($1d0e53f878733234$var$not)($4rtOs.read($$break))())(function __do() {
                var mx = $1d0e53f878733234$export$48cfd1e771a65c4f(iter)();
                if (mx instanceof $h2xUu.Just) return f(mx.value0)();
                if (mx instanceof $h2xUu.Nothing) return $1d0e53f878733234$var$$$void($4rtOs.write(true)($$break))();
                throw new Error("Failed pattern match at Data.Array.ST.Iterator (line 42, column 5 - line 44, column 47): " + [
                    mx.constructor.name
                ]);
            })();
            return {};
        };
    };
};
var $1d0e53f878733234$export$dc4133c4d1844d49 = /* #__PURE__ */ function() {
    var $20 = $1d0e53f878733234$var$map($h2xUu.isNothing);
    return function($21) {
        return $20($1d0e53f878733234$export$4d3fb11e950abb9e($21));
    };
}();

});

parcelRegister("dNwPt", function(module, exports) {

$parcel$export(module.exports, "foldr", () => $a0b95129332cc946$export$a11cb61c36c4a4cf);
$parcel$export(module.exports, "oneOfMap", () => $a0b95129332cc946$export$79f3cac53daaaae6);
$parcel$export(module.exports, "traverse_", () => $a0b95129332cc946$export$33f63ccdb08d8723);
$parcel$export(module.exports, "for_", () => $a0b95129332cc946$export$9747ee7caa0b40b1);
$parcel$export(module.exports, "foldl", () => $a0b95129332cc946$export$50ae948ca12cdcbc);
$parcel$export(module.exports, "intercalate", () => $a0b95129332cc946$export$739ec22334c44788);
$parcel$export(module.exports, "length", () => $a0b95129332cc946$export$f24224f1c91d8156);
$parcel$export(module.exports, "minimumBy", () => $a0b95129332cc946$export$b65392d958998255);
$parcel$export(module.exports, "foldableTuple", () => $a0b95129332cc946$export$ffb07d5442a5d6a6);
$parcel$export(module.exports, "foldableMultiplicative", () => $a0b95129332cc946$export$9519b6731ae6781c);
$parcel$export(module.exports, "foldableMaybe", () => $a0b95129332cc946$export$ff97dbee91e727b6);
$parcel$export(module.exports, "foldableIdentity", () => $a0b95129332cc946$export$3c076fb5bbc5428f);
$parcel$export(module.exports, "foldableEither", () => $a0b95129332cc946$export$6a194eaac00c1ff4);
$parcel$export(module.exports, "foldableDual", () => $a0b95129332cc946$export$1f8d30ddb0a4c229);
$parcel$export(module.exports, "foldableDisj", () => $a0b95129332cc946$export$fbf8f11f9a917de3);
$parcel$export(module.exports, "foldableConst", () => $a0b95129332cc946$export$6857d056e9f0762d);
$parcel$export(module.exports, "foldableConj", () => $a0b95129332cc946$export$b0c90191a04a5815);
$parcel$export(module.exports, "foldableAdditive", () => $a0b95129332cc946$export$a3b6f6613d3d5767);
$parcel$export(module.exports, "foldableArray", () => $a0b95129332cc946$export$e97014618a7eb593);
$parcel$export(module.exports, "foldMapDefaultL", () => $a0b95129332cc946$export$1131b47d09454899);
$parcel$export(module.exports, "foldMap", () => $a0b95129332cc946$export$b66cdc0497d8a99a);
$parcel$export(module.exports, "foldableApp", () => $a0b95129332cc946$export$1e1b0f55a49f1dc6);
$parcel$export(module.exports, "foldableCompose", () => $a0b95129332cc946$export$5677464b2ea4179d);
$parcel$export(module.exports, "foldableCoproduct", () => $a0b95129332cc946$export$5c9c2b827ab84341);
$parcel$export(module.exports, "foldableFirst", () => $a0b95129332cc946$export$f52a7d3e80f7fd5e);
$parcel$export(module.exports, "foldableLast", () => $a0b95129332cc946$export$d127e049f7f9d81c);
$parcel$export(module.exports, "foldableProduct", () => $a0b95129332cc946$export$a013322ac1f6d3aa);
$parcel$export(module.exports, "foldrDefault", () => $a0b95129332cc946$export$9b986141719153e);
$parcel$export(module.exports, "fold", () => $a0b95129332cc946$export$93e2b83da34ff82a);
$parcel$export(module.exports, "any", () => $a0b95129332cc946$export$4154a199d7d90455);
$parcel$export(module.exports, "all", () => $a0b95129332cc946$export$84bf76cd7afc7469);
// Generated by purs version 0.15.16

var $jemPf = parcelRequire("jemPf");

var $56VjJ = parcelRequire("56VjJ");

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $26SV5 = parcelRequire("26SV5");

var $j7FrY = parcelRequire("j7FrY");

var $beQI1 = parcelRequire("beQI1");

var $aJhEx = parcelRequire("aJhEx");

var $jhsiw = parcelRequire("jhsiw");

var $7Rccs = parcelRequire("7Rccs");

var $IhyKA = parcelRequire("IhyKA");

var $h2xUu = parcelRequire("h2xUu");

var $kYjFk = parcelRequire("kYjFk");

var $3aOYV = parcelRequire("3aOYV");

var $h73gt = parcelRequire("h73gt");

var $d4RtI = parcelRequire("d4RtI");

var $53NY2 = parcelRequire("53NY2");

var $ldkz2 = parcelRequire("ldkz2");

var $46y1S = parcelRequire("46y1S");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $d5vvq = parcelRequire("d5vvq");

var $iVjQa = parcelRequire("iVjQa");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
var $a0b95129332cc946$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $a0b95129332cc946$var$eq1 = /* #__PURE__ */ $aJhEx.eq($ibsD5.eqOrdering);
var $a0b95129332cc946$var$unwrap = /* #__PURE__ */ $46y1S.unwrap();
var $a0b95129332cc946$var$monoidEndo = /* #__PURE__ */ $ldkz2.monoidEndo($26SV5.categoryFn);
var $a0b95129332cc946$var$monoidDual = /* #__PURE__ */ $53NY2.monoidDual($a0b95129332cc946$var$monoidEndo);
var $a0b95129332cc946$var$alaF = /* #__PURE__ */ $46y1S.alaF()()()();
var $a0b95129332cc946$export$a11cb61c36c4a4cf = function(dict) {
    return dict.foldr;
};
var $a0b95129332cc946$export$f14ab6cb4b8e359c = function(dictFoldable) {
    var foldr2 = $a0b95129332cc946$export$a11cb61c36c4a4cf(dictFoldable);
    return function(idx) {
        var go = function(a) {
            return function(cursor) {
                if (cursor.elem instanceof $h2xUu.Just) return cursor;
                var $292 = cursor.pos === idx;
                if ($292) return {
                    elem: new $h2xUu.Just(a),
                    pos: cursor.pos
                };
                return {
                    pos: cursor.pos + 1 | 0,
                    elem: cursor.elem
                };
            };
        };
        var $451 = foldr2(go)({
            elem: $h2xUu.Nothing.value,
            pos: 0
        });
        return function($452) {
            return function(v) {
                return v.elem;
            }($451($452));
        };
    };
};
var $a0b95129332cc946$export$7b1b591b262c240 = function(dictFoldable) {
    return $a0b95129332cc946$export$a11cb61c36c4a4cf(dictFoldable)(function(v) {
        return function(v1) {
            return false;
        };
    })(true);
};
var $a0b95129332cc946$export$a9a18ae5ba42aeab = function(dictFoldable) {
    var foldr2 = $a0b95129332cc946$export$a11cb61c36c4a4cf(dictFoldable);
    return function(dictPlus) {
        return foldr2($56VjJ.alt(dictPlus.Alt0()))($j7FrY.empty(dictPlus));
    };
};
var $a0b95129332cc946$export$79f3cac53daaaae6 = function(dictFoldable) {
    var foldr2 = $a0b95129332cc946$export$a11cb61c36c4a4cf(dictFoldable);
    return function(dictPlus) {
        var alt = $56VjJ.alt(dictPlus.Alt0());
        var empty = $j7FrY.empty(dictPlus);
        return function(f) {
            return foldr2(function($453) {
                return alt(f($453));
            })(empty);
        };
    };
};
var $a0b95129332cc946$export$33f63ccdb08d8723 = function(dictApplicative) {
    var applySecond = $26ZCq.applySecond(dictApplicative.Apply0());
    var pure = $bQdkN.pure(dictApplicative);
    return function(dictFoldable) {
        var foldr2 = $a0b95129332cc946$export$a11cb61c36c4a4cf(dictFoldable);
        return function(f) {
            return foldr2(function($454) {
                return applySecond(f($454));
            })(pure($ivFwO.unit));
        };
    };
};
var $a0b95129332cc946$export$9747ee7caa0b40b1 = function(dictApplicative) {
    var traverse_1 = $a0b95129332cc946$export$33f63ccdb08d8723(dictApplicative);
    return function(dictFoldable) {
        return $jhsiw.flip(traverse_1(dictFoldable));
    };
};
var $a0b95129332cc946$export$4426b9bff8b7b6fb = function(dictApplicative) {
    var traverse_1 = $a0b95129332cc946$export$33f63ccdb08d8723(dictApplicative);
    return function(dictFoldable) {
        return traverse_1(dictFoldable)($a0b95129332cc946$var$identity);
    };
};
var $a0b95129332cc946$export$50ae948ca12cdcbc = function(dict) {
    return dict.foldl;
};
var $a0b95129332cc946$export$fe35754984712af1 = function(dictFoldable) {
    var foldl2 = $a0b95129332cc946$export$50ae948ca12cdcbc(dictFoldable);
    return function(idx) {
        var go = function(cursor) {
            return function(a) {
                if (cursor.elem instanceof $h2xUu.Just) return cursor;
                var $296 = cursor.pos === idx;
                if ($296) return {
                    elem: new $h2xUu.Just(a),
                    pos: cursor.pos
                };
                return {
                    pos: cursor.pos + 1 | 0,
                    elem: cursor.elem
                };
            };
        };
        var $455 = foldl2(go)({
            elem: $h2xUu.Nothing.value,
            pos: 0
        });
        return function($456) {
            return function(v) {
                return v.elem;
            }($455($456));
        };
    };
};
var $a0b95129332cc946$export$739ec22334c44788 = function(dictFoldable) {
    var foldl2 = $a0b95129332cc946$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictMonoid) {
        var append = $d5vvq.append(dictMonoid.Semigroup0());
        var mempty = $3aOYV.mempty(dictMonoid);
        return function(sep) {
            return function(xs) {
                var go = function(v) {
                    return function(v1) {
                        if (v.init) return {
                            init: false,
                            acc: v1
                        };
                        return {
                            init: false,
                            acc: append(v.acc)(append(sep)(v1))
                        };
                    };
                };
                return foldl2(go)({
                    init: true,
                    acc: mempty
                })(xs).acc;
            };
        };
    };
};
var $a0b95129332cc946$export$f24224f1c91d8156 = function(dictFoldable) {
    var foldl2 = $a0b95129332cc946$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictSemiring) {
        var add1 = $iVjQa.add(dictSemiring);
        var one = $iVjQa.one(dictSemiring);
        return foldl2(function(c) {
            return function(v) {
                return add1(one)(c);
            };
        })($iVjQa.zero(dictSemiring));
    };
};
var $a0b95129332cc946$export$c42fa06aba2a552c = function(dictFoldable) {
    var foldl2 = $a0b95129332cc946$export$50ae948ca12cdcbc(dictFoldable);
    return function(cmp) {
        var max$prime = function(v) {
            return function(v1) {
                if (v instanceof $h2xUu.Nothing) return new $h2xUu.Just(v1);
                if (v instanceof $h2xUu.Just) return new $h2xUu.Just(function() {
                    var $303 = $a0b95129332cc946$var$eq1(cmp(v.value0)(v1))($ibsD5.GT.value);
                    if ($303) return v.value0;
                    return v1;
                }());
                throw new Error("Failed pattern match at Data.Foldable (line 441, column 3 - line 441, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        return foldl2(max$prime)($h2xUu.Nothing.value);
    };
};
var $a0b95129332cc946$export$b25e0be55f42c9a = function(dictOrd) {
    var compare = $gwBF5.compare(dictOrd);
    return function(dictFoldable) {
        return $a0b95129332cc946$export$c42fa06aba2a552c(dictFoldable)(compare);
    };
};
var $a0b95129332cc946$export$b65392d958998255 = function(dictFoldable) {
    var foldl2 = $a0b95129332cc946$export$50ae948ca12cdcbc(dictFoldable);
    return function(cmp) {
        var min$prime = function(v) {
            return function(v1) {
                if (v instanceof $h2xUu.Nothing) return new $h2xUu.Just(v1);
                if (v instanceof $h2xUu.Just) return new $h2xUu.Just(function() {
                    var $307 = $a0b95129332cc946$var$eq1(cmp(v.value0)(v1))($ibsD5.LT.value);
                    if ($307) return v.value0;
                    return v1;
                }());
                throw new Error("Failed pattern match at Data.Foldable (line 454, column 3 - line 454, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        return foldl2(min$prime)($h2xUu.Nothing.value);
    };
};
var $a0b95129332cc946$export$916782c1f0ddb132 = function(dictOrd) {
    var compare = $gwBF5.compare(dictOrd);
    return function(dictFoldable) {
        return $a0b95129332cc946$export$b65392d958998255(dictFoldable)(compare);
    };
};
var $a0b95129332cc946$export$dbd0f18357df1ddd = function(dictFoldable) {
    var foldl2 = $a0b95129332cc946$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictSemiring) {
        return foldl2($iVjQa.mul(dictSemiring))($iVjQa.one(dictSemiring));
    };
};
var $a0b95129332cc946$export$8a63f25cc62965f1 = function(dictFoldable) {
    var foldl2 = $a0b95129332cc946$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictSemiring) {
        return foldl2($iVjQa.add(dictSemiring))($iVjQa.zero(dictSemiring));
    };
};
var $a0b95129332cc946$export$ffb07d5442a5d6a6 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v.value1)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v.value1);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v.value1);
            };
        };
    }
};
var $a0b95129332cc946$export$9519b6731ae6781c = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $a0b95129332cc946$export$ff97dbee91e727b6 = {
    foldr: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $h2xUu.Nothing) return v1;
                if (v2 instanceof $h2xUu.Just) return v(v2.value0)(v1);
                throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldl: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $h2xUu.Nothing) return v1;
                if (v2 instanceof $h2xUu.Just) return v(v1)(v2.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $3aOYV.mempty(dictMonoid);
        return function(v) {
            return function(v1) {
                if (v1 instanceof $h2xUu.Nothing) return mempty;
                if (v1 instanceof $h2xUu.Just) return v(v1.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    }
};
var $a0b95129332cc946$var$foldr1 = /* #__PURE__ */ $a0b95129332cc946$export$a11cb61c36c4a4cf($a0b95129332cc946$export$ff97dbee91e727b6);
var $a0b95129332cc946$var$foldl1 = /* #__PURE__ */ $a0b95129332cc946$export$50ae948ca12cdcbc($a0b95129332cc946$export$ff97dbee91e727b6);
var $a0b95129332cc946$export$3c076fb5bbc5428f = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $a0b95129332cc946$export$6a194eaac00c1ff4 = {
    foldr: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $beQI1.Left) return v1;
                if (v2 instanceof $beQI1.Right) return v(v2.value0)(v1);
                throw new Error("Failed pattern match at Data.Foldable (line 181, column 1 - line 187, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldl: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $beQI1.Left) return v1;
                if (v2 instanceof $beQI1.Right) return v(v1)(v2.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 181, column 1 - line 187, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $3aOYV.mempty(dictMonoid);
        return function(v) {
            return function(v1) {
                if (v1 instanceof $beQI1.Left) return mempty;
                if (v1 instanceof $beQI1.Right) return v(v1.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 181, column 1 - line 187, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    }
};
var $a0b95129332cc946$export$1f8d30ddb0a4c229 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $a0b95129332cc946$export$fbf8f11f9a917de3 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $a0b95129332cc946$export$6857d056e9f0762d = {
    foldr: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldl: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $3aOYV.mempty(dictMonoid);
        return function(v) {
            return function(v1) {
                return mempty;
            };
        };
    }
};
var $a0b95129332cc946$export$b0c90191a04a5815 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $a0b95129332cc946$export$a3b6f6613d3d5767 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $a0b95129332cc946$export$edac6f86a9ee0bec = function(dictFoldable) {
    var foldr2 = $a0b95129332cc946$export$a11cb61c36c4a4cf(dictFoldable);
    return function(dictMonoid) {
        var append = $d5vvq.append(dictMonoid.Semigroup0());
        var mempty = $3aOYV.mempty(dictMonoid);
        return function(f) {
            return foldr2(function(x) {
                return function(acc) {
                    return append(f(x))(acc);
                };
            })(mempty);
        };
    };
};
var $a0b95129332cc946$export$e97014618a7eb593 = {
    foldr: $jemPf.foldrArray,
    foldl: $jemPf.foldlArray,
    foldMap: function(dictMonoid) {
        return $a0b95129332cc946$export$edac6f86a9ee0bec($a0b95129332cc946$export$e97014618a7eb593)(dictMonoid);
    }
};
var $a0b95129332cc946$export$1131b47d09454899 = function(dictFoldable) {
    var foldl2 = $a0b95129332cc946$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictMonoid) {
        var append = $d5vvq.append(dictMonoid.Semigroup0());
        var mempty = $3aOYV.mempty(dictMonoid);
        return function(f) {
            return foldl2(function(acc) {
                return function(x) {
                    return append(acc)(f(x));
                };
            })(mempty);
        };
    };
};
var $a0b95129332cc946$export$b66cdc0497d8a99a = function(dict) {
    return dict.foldMap;
};
var $a0b95129332cc946$var$foldMap1 = /* #__PURE__ */ $a0b95129332cc946$export$b66cdc0497d8a99a($a0b95129332cc946$export$ff97dbee91e727b6);
var $a0b95129332cc946$export$1e1b0f55a49f1dc6 = function(dictFoldable) {
    var foldr2 = $a0b95129332cc946$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $a0b95129332cc946$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $a0b95129332cc946$export$b66cdc0497d8a99a(dictFoldable);
    return {
        foldr: function(f) {
            return function(i) {
                return function(v) {
                    return foldr2(f)(i)(v);
                };
            };
        },
        foldl: function(f) {
            return function(i) {
                return function(v) {
                    return foldl2(f)(i)(v);
                };
            };
        },
        foldMap: function(dictMonoid) {
            var foldMap3 = foldMap2(dictMonoid);
            return function(f) {
                return function(v) {
                    return foldMap3(f)(v);
                };
            };
        }
    };
};
var $a0b95129332cc946$export$5677464b2ea4179d = function(dictFoldable) {
    var foldr2 = $a0b95129332cc946$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $a0b95129332cc946$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $a0b95129332cc946$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictFoldable1) {
        var foldr3 = $a0b95129332cc946$export$a11cb61c36c4a4cf(dictFoldable1);
        var foldl3 = $a0b95129332cc946$export$50ae948ca12cdcbc(dictFoldable1);
        var foldMap3 = $a0b95129332cc946$export$b66cdc0497d8a99a(dictFoldable1);
        return {
            foldr: function(f) {
                return function(i) {
                    return function(v) {
                        return foldr2($jhsiw.flip(foldr3(f)))(i)(v);
                    };
                };
            },
            foldl: function(f) {
                return function(i) {
                    return function(v) {
                        return foldl2(foldl3(f))(i)(v);
                    };
                };
            },
            foldMap: function(dictMonoid) {
                var foldMap4 = foldMap2(dictMonoid);
                var foldMap5 = foldMap3(dictMonoid);
                return function(f) {
                    return function(v) {
                        return foldMap4(foldMap5(f))(v);
                    };
                };
            }
        };
    };
};
var $a0b95129332cc946$export$5c9c2b827ab84341 = function(dictFoldable) {
    var foldr2 = $a0b95129332cc946$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $a0b95129332cc946$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $a0b95129332cc946$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictFoldable1) {
        var foldr3 = $a0b95129332cc946$export$a11cb61c36c4a4cf(dictFoldable1);
        var foldl3 = $a0b95129332cc946$export$50ae948ca12cdcbc(dictFoldable1);
        var foldMap3 = $a0b95129332cc946$export$b66cdc0497d8a99a(dictFoldable1);
        return {
            foldr: function(f) {
                return function(z) {
                    return $7Rccs.coproduct(foldr2(f)(z))(foldr3(f)(z));
                };
            },
            foldl: function(f) {
                return function(z) {
                    return $7Rccs.coproduct(foldl2(f)(z))(foldl3(f)(z));
                };
            },
            foldMap: function(dictMonoid) {
                var foldMap4 = foldMap2(dictMonoid);
                var foldMap5 = foldMap3(dictMonoid);
                return function(f) {
                    return $7Rccs.coproduct(foldMap4(f))(foldMap5(f));
                };
            }
        };
    };
};
var $a0b95129332cc946$export$f52a7d3e80f7fd5e = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return $a0b95129332cc946$var$foldr1(f)(z)(v);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return $a0b95129332cc946$var$foldl1(f)(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap2 = $a0b95129332cc946$var$foldMap1(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMap2(f)(v);
            };
        };
    }
};
var $a0b95129332cc946$export$d127e049f7f9d81c = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return $a0b95129332cc946$var$foldr1(f)(z)(v);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return $a0b95129332cc946$var$foldl1(f)(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap2 = $a0b95129332cc946$var$foldMap1(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMap2(f)(v);
            };
        };
    }
};
var $a0b95129332cc946$export$a013322ac1f6d3aa = function(dictFoldable) {
    var foldr2 = $a0b95129332cc946$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $a0b95129332cc946$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $a0b95129332cc946$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictFoldable1) {
        var foldr3 = $a0b95129332cc946$export$a11cb61c36c4a4cf(dictFoldable1);
        var foldl3 = $a0b95129332cc946$export$50ae948ca12cdcbc(dictFoldable1);
        var foldMap3 = $a0b95129332cc946$export$b66cdc0497d8a99a(dictFoldable1);
        return {
            foldr: function(f) {
                return function(z) {
                    return function(v) {
                        return foldr2(f)(foldr3(f)(z)(v.value1))(v.value0);
                    };
                };
            },
            foldl: function(f) {
                return function(z) {
                    return function(v) {
                        return foldl3(f)(foldl2(f)(z)(v.value0))(v.value1);
                    };
                };
            },
            foldMap: function(dictMonoid) {
                var append = $d5vvq.append(dictMonoid.Semigroup0());
                var foldMap4 = foldMap2(dictMonoid);
                var foldMap5 = foldMap3(dictMonoid);
                return function(f) {
                    return function(v) {
                        return append(foldMap4(f)(v.value0))(foldMap5(f)(v.value1));
                    };
                };
            }
        };
    };
};
var $a0b95129332cc946$export$e623e8bf74059b22 = function(dictFoldable) {
    var foldMap2 = $a0b95129332cc946$export$b66cdc0497d8a99a(dictFoldable)($a0b95129332cc946$var$monoidDual);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $a0b95129332cc946$var$unwrap($a0b95129332cc946$var$unwrap(foldMap2(function() {
                    var $457 = $jhsiw.flip(c);
                    return function($458) {
                        return $53NY2.Dual($ldkz2.Endo($457($458)));
                    };
                }())(xs)))(u);
            };
        };
    };
};
var $a0b95129332cc946$export$9b986141719153e = function(dictFoldable) {
    var foldMap2 = $a0b95129332cc946$export$b66cdc0497d8a99a(dictFoldable)($a0b95129332cc946$var$monoidEndo);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $a0b95129332cc946$var$unwrap(foldMap2(function($459) {
                    return $ldkz2.Endo(c($459));
                })(xs))(u);
            };
        };
    };
};
var $a0b95129332cc946$export$dfc7155ac0343b8 = function(dictFoldable) {
    var foldMap2 = $a0b95129332cc946$export$b66cdc0497d8a99a(dictFoldable)($kYjFk.monoidFirst);
    return function(dictEq) {
        var eq2 = $aJhEx.eq(dictEq);
        return function(a) {
            var $460 = foldMap2(function(v) {
                var $444 = eq2(a)(v.value0);
                if ($444) return new $h2xUu.Just(v.value1);
                return $h2xUu.Nothing.value;
            });
            return function($461) {
                return $a0b95129332cc946$var$unwrap($460($461));
            };
        };
    };
};
var $a0b95129332cc946$export$7606e2cbf4afaea2 = function(dictFoldable) {
    var foldMap2 = $a0b95129332cc946$export$b66cdc0497d8a99a(dictFoldable)($a0b95129332cc946$var$monoidEndo);
    return function(dictSemigroup) {
        var append = $d5vvq.append(dictSemigroup);
        return function(d) {
            return function(t) {
                return function(f) {
                    var joined = function(a) {
                        return function(m) {
                            return append(d)(append(t(a))(m));
                        };
                    };
                    return $a0b95129332cc946$var$unwrap(foldMap2(joined)(f))(d);
                };
            };
        };
    };
};
var $a0b95129332cc946$export$5a27709e8737ce25 = function(dictFoldable) {
    var surroundMap1 = $a0b95129332cc946$export$7606e2cbf4afaea2(dictFoldable);
    return function(dictSemigroup) {
        var surroundMap2 = surroundMap1(dictSemigroup);
        return function(d) {
            return surroundMap2(d)($a0b95129332cc946$var$identity);
        };
    };
};
var $a0b95129332cc946$export$7a067f9280ad8af0 = function(dictFoldable) {
    var foldl2 = $a0b95129332cc946$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictMonad) {
        var bind = $cADnC.bind(dictMonad.Bind1());
        var pure = $bQdkN.pure(dictMonad.Applicative0());
        return function(f) {
            return function(b0) {
                return foldl2(function(b) {
                    return function(a) {
                        return bind(b)($jhsiw.flip(f)(a));
                    };
                })(pure(b0));
            };
        };
    };
};
var $a0b95129332cc946$export$93e2b83da34ff82a = function(dictFoldable) {
    var foldMap2 = $a0b95129332cc946$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictMonoid) {
        return foldMap2(dictMonoid)($a0b95129332cc946$var$identity);
    };
};
var $a0b95129332cc946$export$23e5dcedfce4509c = function(dictFoldable) {
    var foldl2 = $a0b95129332cc946$export$50ae948ca12cdcbc(dictFoldable);
    return function(p) {
        var go = function(v) {
            return function(v1) {
                if (v instanceof $h2xUu.Nothing) return p(v1);
                return v;
            };
        };
        return foldl2(go)($h2xUu.Nothing.value);
    };
};
var $a0b95129332cc946$export$71aa6c912b956294 = function(dictFoldable) {
    var foldl2 = $a0b95129332cc946$export$50ae948ca12cdcbc(dictFoldable);
    return function(p) {
        var go = function(v) {
            return function(v1) {
                if (v instanceof $h2xUu.Nothing && p(v1)) return new $h2xUu.Just(v1);
                return v;
            };
        };
        return foldl2(go)($h2xUu.Nothing.value);
    };
};
var $a0b95129332cc946$export$4154a199d7d90455 = function(dictFoldable) {
    var foldMap2 = $a0b95129332cc946$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictHeytingAlgebra) {
        return $a0b95129332cc946$var$alaF($d4RtI.Disj)(foldMap2($d4RtI.monoidDisj(dictHeytingAlgebra)));
    };
};
var $a0b95129332cc946$export$5bf96401662340b7 = function(dictFoldable) {
    var any1 = $a0b95129332cc946$export$4154a199d7d90455(dictFoldable)($IhyKA.heytingAlgebraBoolean);
    return function(dictEq) {
        var $462 = $aJhEx.eq(dictEq);
        return function($463) {
            return any1($462($463));
        };
    };
};
var $a0b95129332cc946$export$63faa62a0284a4a6 = function(dictFoldable) {
    var elem1 = $a0b95129332cc946$export$5bf96401662340b7(dictFoldable);
    return function(dictEq) {
        var elem2 = elem1(dictEq);
        return function(x) {
            var $464 = elem2(x);
            return function($465) {
                return !$464($465);
            };
        };
    };
};
var $a0b95129332cc946$export$252bb8b3bbdf6749 = function(dictFoldable) {
    var any1 = $a0b95129332cc946$export$4154a199d7d90455(dictFoldable);
    return function(dictHeytingAlgebra) {
        return any1(dictHeytingAlgebra)($a0b95129332cc946$var$identity);
    };
};
var $a0b95129332cc946$export$84bf76cd7afc7469 = function(dictFoldable) {
    var foldMap2 = $a0b95129332cc946$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictHeytingAlgebra) {
        return $a0b95129332cc946$var$alaF($h73gt.Conj)(foldMap2($h73gt.monoidConj(dictHeytingAlgebra)));
    };
};
var $a0b95129332cc946$export$21c0ac7fe1cef1b8 = function(dictFoldable) {
    var all1 = $a0b95129332cc946$export$84bf76cd7afc7469(dictFoldable);
    return function(dictHeytingAlgebra) {
        return all1(dictHeytingAlgebra)($a0b95129332cc946$var$identity);
    };
};

});
parcelRegister("jemPf", function(module, exports) {

$parcel$export(module.exports, "foldrArray", () => $e00107ce3a4d2f39$export$6332150c6d01d807);
$parcel$export(module.exports, "foldlArray", () => $e00107ce3a4d2f39$export$6b86e13802001a00);
const $e00107ce3a4d2f39$export$6332150c6d01d807 = function(f) {
    return function(init) {
        return function(xs) {
            var acc = init;
            var len = xs.length;
            for(var i = len - 1; i >= 0; i--)acc = f(xs[i])(acc);
            return acc;
        };
    };
};
const $e00107ce3a4d2f39$export$6b86e13802001a00 = function(f) {
    return function(init) {
        return function(xs) {
            var acc = init;
            var len = xs.length;
            for(var i = 0; i < len; i++)acc = f(acc)(xs[i]);
            return acc;
        };
    };
};

});

parcelRegister("j7FrY", function(module, exports) {

$parcel$export(module.exports, "plusArray", () => $debed2e90ede0c3c$export$b7c99dd4fc96d90e);
$parcel$export(module.exports, "empty", () => $debed2e90ede0c3c$export$6e22c362a0406a2c);
// Generated by purs version 0.15.16

var $56VjJ = parcelRequire("56VjJ");

var $7FzSN = parcelRequire("7FzSN");
var $debed2e90ede0c3c$export$b7c99dd4fc96d90e = {
    empty: [],
    Alt0: function() {
        return $56VjJ.altArray;
    }
};
var $debed2e90ede0c3c$export$6e22c362a0406a2c = function(dict) {
    return dict.empty;
};

});

parcelRegister("7Rccs", function(module, exports) {

$parcel$export(module.exports, "Coproduct", () => $5b86f24988bda1c6$export$a7f096464cca5f3a);
$parcel$export(module.exports, "functorCoproduct", () => $5b86f24988bda1c6$export$e192c0fa89a291cb);
$parcel$export(module.exports, "coproduct", () => $5b86f24988bda1c6$export$ab04af7daecb905f);
// Generated by purs version 0.15.16

var $49WxQ = parcelRequire("49WxQ");

var $eJa4O = parcelRequire("eJa4O");

var $5ZwWo = parcelRequire("5ZwWo");

var $beQI1 = parcelRequire("beQI1");

var $aJhEx = parcelRequire("aJhEx");

var $7FzSN = parcelRequire("7FzSN");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $2XxiF = parcelRequire("2XxiF");
var $5b86f24988bda1c6$var$bimap = /* #__PURE__ */ $5ZwWo.bimap($5ZwWo.bifunctorEither);
var $5b86f24988bda1c6$export$a7f096464cca5f3a = function(x) {
    return x;
};
var $5b86f24988bda1c6$export$593e0c14cbf7732e = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return function(dictShow1) {
        var show1 = $2XxiF.show(dictShow1);
        return {
            show: function(v) {
                if (v instanceof $beQI1.Left) return "(left " + (show(v.value0) + ")");
                if (v instanceof $beQI1.Right) return "(right " + (show1(v.value0) + ")");
                throw new Error("Failed pattern match at Data.Functor.Coproduct (line 63, column 1 - line 65, column 60): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $5b86f24988bda1c6$export$79ffe56a765070d2 = function(ga) {
    return new $beQI1.Right(ga);
};
var $5b86f24988bda1c6$export$7fc1e26c1ee5b3a4 = {
    Coercible0: function() {
        return undefined;
    }
};
var $5b86f24988bda1c6$export$eabcd2c8791e7bf4 = function(fa) {
    return new $beQI1.Left(fa);
};
var $5b86f24988bda1c6$export$e192c0fa89a291cb = function(dictFunctor) {
    var map = $7FzSN.map(dictFunctor);
    return function(dictFunctor1) {
        var map1 = $7FzSN.map(dictFunctor1);
        return {
            map: function(f) {
                return function(v) {
                    return $5b86f24988bda1c6$var$bimap(map(f))(map1(f))(v);
                };
            }
        };
    };
};
var $5b86f24988bda1c6$export$30aaa5110153edc1 = function(dictEq1) {
    var eq1 = $aJhEx.eq1(dictEq1);
    return function(dictEq11) {
        var eq11 = $aJhEx.eq1(dictEq11);
        return {
            eq1: function(dictEq) {
                var eq12 = eq1(dictEq);
                var eq13 = eq11(dictEq);
                return function(v) {
                    return function(v1) {
                        if (v instanceof $beQI1.Left && v1 instanceof $beQI1.Left) return eq12(v.value0)(v1.value0);
                        if (v instanceof $beQI1.Right && v1 instanceof $beQI1.Right) return eq13(v.value0)(v1.value0);
                        return false;
                    };
                };
            }
        };
    };
};
var $5b86f24988bda1c6$export$4f54a72d7417da7c = function(dictEq1) {
    var eq1Coproduct1 = $5b86f24988bda1c6$export$30aaa5110153edc1(dictEq1);
    return function(dictEq11) {
        var eq1 = $aJhEx.eq1(eq1Coproduct1(dictEq11));
        return function(dictEq) {
            return {
                eq: eq1(dictEq)
            };
        };
    };
};
var $5b86f24988bda1c6$export$ec3d1f0587fb15ed = function(dictOrd1) {
    var compare1 = $gwBF5.compare1(dictOrd1);
    var eq1Coproduct1 = $5b86f24988bda1c6$export$30aaa5110153edc1(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare11 = $gwBF5.compare1(dictOrd11);
        var eq1Coproduct2 = eq1Coproduct1(dictOrd11.Eq10());
        return {
            compare1: function(dictOrd) {
                var compare12 = compare1(dictOrd);
                var compare13 = compare11(dictOrd);
                return function(v) {
                    return function(v1) {
                        if (v instanceof $beQI1.Left && v1 instanceof $beQI1.Left) return compare12(v.value0)(v1.value0);
                        if (v instanceof $beQI1.Left) return $ibsD5.LT.value;
                        if (v1 instanceof $beQI1.Left) return $ibsD5.GT.value;
                        if (v instanceof $beQI1.Right && v1 instanceof $beQI1.Right) return compare13(v.value0)(v1.value0);
                        throw new Error("Failed pattern match at Data.Functor.Coproduct (line 57, column 5 - line 61, column 43): " + [
                            v.constructor.name,
                            v1.constructor.name
                        ]);
                    };
                };
            },
            Eq10: function() {
                return eq1Coproduct2;
            }
        };
    };
};
var $5b86f24988bda1c6$export$f437f5dfb3faee67 = function(dictOrd1) {
    var ord1Coproduct1 = $5b86f24988bda1c6$export$ec3d1f0587fb15ed(dictOrd1);
    var eqCoproduct1 = $5b86f24988bda1c6$export$4f54a72d7417da7c(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare1 = $gwBF5.compare1(ord1Coproduct1(dictOrd11));
        var eqCoproduct2 = eqCoproduct1(dictOrd11.Eq10());
        return function(dictOrd) {
            var eqCoproduct3 = eqCoproduct2(dictOrd.Eq0());
            return {
                compare: compare1(dictOrd),
                Eq0: function() {
                    return eqCoproduct3;
                }
            };
        };
    };
};
var $5b86f24988bda1c6$export$ab04af7daecb905f = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $beQI1.Left) return v(v2.value0);
            if (v2 instanceof $beQI1.Right) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Functor.Coproduct (line 27, column 1 - line 27, column 78): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $5b86f24988bda1c6$export$7ce1af5f45fd6777 = function(dictExtend) {
    var extend = $eJa4O.extend(dictExtend);
    var functorCoproduct1 = $5b86f24988bda1c6$export$e192c0fa89a291cb(dictExtend.Functor0());
    return function(dictExtend1) {
        var extend1 = $eJa4O.extend(dictExtend1);
        var functorCoproduct2 = functorCoproduct1(dictExtend1.Functor0());
        return {
            extend: function(f) {
                var $106 = $5b86f24988bda1c6$export$ab04af7daecb905f(function() {
                    var $108 = extend(function($110) {
                        return f($5b86f24988bda1c6$export$a7f096464cca5f3a($beQI1.Left.create($110)));
                    });
                    return function($109) {
                        return $beQI1.Left.create($108($109));
                    };
                }())(function() {
                    var $111 = extend1(function($113) {
                        return f($5b86f24988bda1c6$export$a7f096464cca5f3a($beQI1.Right.create($113)));
                    });
                    return function($112) {
                        return $beQI1.Right.create($111($112));
                    };
                }());
                return function($107) {
                    return $5b86f24988bda1c6$export$a7f096464cca5f3a($106($107));
                };
            },
            Functor0: function() {
                return functorCoproduct2;
            }
        };
    };
};
var $5b86f24988bda1c6$export$2f16914668ceb808 = function(dictComonad) {
    var extract = $49WxQ.extract(dictComonad);
    var extendCoproduct1 = $5b86f24988bda1c6$export$7ce1af5f45fd6777(dictComonad.Extend0());
    return function(dictComonad1) {
        var extendCoproduct2 = extendCoproduct1(dictComonad1.Extend0());
        return {
            extract: $5b86f24988bda1c6$export$ab04af7daecb905f(extract)($49WxQ.extract(dictComonad1)),
            Extend0: function() {
                return extendCoproduct2;
            }
        };
    };
};
var $5b86f24988bda1c6$export$c1a518500c2ed5de = function(natF) {
    return function(natG) {
        return function(v) {
            return $5b86f24988bda1c6$var$bimap(natF)(natG)(v);
        };
    };
};

});
parcelRegister("49WxQ", function(module, exports) {

$parcel$export(module.exports, "extract", () => $30756a8021801b33$export$f9380c9a627682d3);
// Generated by purs version 0.15.16

var $eJa4O = parcelRequire("eJa4O");

var $7FzSN = parcelRequire("7FzSN");
var $30756a8021801b33$export$f9380c9a627682d3 = function(dict) {
    return dict.extract;
};

});
parcelRegister("eJa4O", function(module, exports) {

$parcel$export(module.exports, "extend", () => $ab8d15ade666fb0c$export$8b58be045bf06082);
$parcel$export(module.exports, "composeCoKleisliFlipped", () => $ab8d15ade666fb0c$export$fbe89af2ce156300);
// Generated by purs version 0.15.16

var $9MFJK = parcelRequire("9MFJK");

var $26SV5 = parcelRequire("26SV5");

var $7FzSN = parcelRequire("7FzSN");

var $d5vvq = parcelRequire("d5vvq");
var $ab8d15ade666fb0c$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $ab8d15ade666fb0c$export$cd01f0fbd2ca8bd6 = function(dictSemigroup) {
    var append = $d5vvq.append(dictSemigroup);
    return {
        extend: function(f) {
            return function(g) {
                return function(w) {
                    return f(function(w$prime) {
                        return g(append(w)(w$prime));
                    });
                };
            };
        },
        Functor0: function() {
            return $7FzSN.functorFn;
        }
    };
};
var $ab8d15ade666fb0c$export$a321b0e45770af43 = {
    extend: $9MFJK.arrayExtend,
    Functor0: function() {
        return $7FzSN.functorArray;
    }
};
var $ab8d15ade666fb0c$export$8b58be045bf06082 = function(dict) {
    return dict.extend;
};
var $ab8d15ade666fb0c$export$285c6f9556cd75fc = function(dictExtend) {
    var extend1 = $ab8d15ade666fb0c$export$8b58be045bf06082(dictExtend);
    return function(w) {
        return function(f) {
            return extend1(f)(w);
        };
    };
};
var $ab8d15ade666fb0c$export$ecd5e8ace626722c = function(dictExtend) {
    return $ab8d15ade666fb0c$export$8b58be045bf06082(dictExtend)($ab8d15ade666fb0c$var$identity);
};
var $ab8d15ade666fb0c$export$fbe89af2ce156300 = function(dictExtend) {
    var extend1 = $ab8d15ade666fb0c$export$8b58be045bf06082(dictExtend);
    return function(f) {
        return function(g) {
            return function(w) {
                return f(extend1(g)(w));
            };
        };
    };
};
var $ab8d15ade666fb0c$export$a868f0c7fe15a03f = function(dictExtend) {
    var extend1 = $ab8d15ade666fb0c$export$8b58be045bf06082(dictExtend);
    return function(f) {
        return function(g) {
            return function(w) {
                return g(extend1(f)(w));
            };
        };
    };
};

});
parcelRegister("9MFJK", function(module, exports) {

$parcel$export(module.exports, "arrayExtend", () => $71f8f8d3e6bb501d$export$2ed6d41c398ed712);
const $71f8f8d3e6bb501d$export$2ed6d41c398ed712 = function(f) {
    return function(xs) {
        return xs.map(function(_, i, xs) {
            return f(xs.slice(i));
        });
    };
};

});



parcelRegister("5ZwWo", function(module, exports) {

$parcel$export(module.exports, "bimap", () => $45cc33a2a0c327c3$export$eb54baf0b342cb1d);
$parcel$export(module.exports, "lmap", () => $45cc33a2a0c327c3$export$2ad466be2e2b0196);
$parcel$export(module.exports, "rmap", () => $45cc33a2a0c327c3$export$6630987c9d273301);
$parcel$export(module.exports, "bifunctorTuple", () => $45cc33a2a0c327c3$export$34a2521cb7920188);
$parcel$export(module.exports, "bifunctorEither", () => $45cc33a2a0c327c3$export$9b66d4861c364eff);
// Generated by purs version 0.15.16

var $26SV5 = parcelRequire("26SV5");

var $beQI1 = parcelRequire("beQI1");

var $7O0Q4 = parcelRequire("7O0Q4");
var $45cc33a2a0c327c3$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $45cc33a2a0c327c3$export$eb54baf0b342cb1d = function(dict) {
    return dict.bimap;
};
var $45cc33a2a0c327c3$export$2ad466be2e2b0196 = function(dictBifunctor) {
    var bimap1 = $45cc33a2a0c327c3$export$eb54baf0b342cb1d(dictBifunctor);
    return function(f) {
        return bimap1(f)($45cc33a2a0c327c3$var$identity);
    };
};
var $45cc33a2a0c327c3$export$6630987c9d273301 = function(dictBifunctor) {
    return $45cc33a2a0c327c3$export$eb54baf0b342cb1d(dictBifunctor)($45cc33a2a0c327c3$var$identity);
};
var $45cc33a2a0c327c3$export$34a2521cb7920188 = {
    bimap: function(f) {
        return function(g) {
            return function(v) {
                return new $7O0Q4.Tuple(f(v.value0), g(v.value1));
            };
        };
    }
};
var $45cc33a2a0c327c3$export$9b66d4861c364eff = {
    bimap: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $beQI1.Left) return new $beQI1.Left(v(v2.value0));
                if (v2 instanceof $beQI1.Right) return new $beQI1.Right(v1(v2.value0));
                throw new Error("Failed pattern match at Data.Bifunctor (line 32, column 1 - line 34, column 36): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    }
};
var $45cc33a2a0c327c3$export$52f77c2cc8ef8f31 = {
    bimap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};

});


parcelRegister("kYjFk", function(module, exports) {

$parcel$export(module.exports, "First", () => $f448aa71443748c1$export$b25abba66f7be210);
$parcel$export(module.exports, "monoidFirst", () => $f448aa71443748c1$export$db2423f7434b7a30);
$parcel$export(module.exports, "functorFirst", () => $f448aa71443748c1$export$98d9d13e8b5bfe4d);
// Generated by purs version 0.15.16

var $h2xUu = parcelRequire("h2xUu");

var $3aOYV = parcelRequire("3aOYV");

var $d5vvq = parcelRequire("d5vvq");

var $2XxiF = parcelRequire("2XxiF");
var $f448aa71443748c1$export$b25abba66f7be210 = function(x) {
    return x;
};
var $f448aa71443748c1$export$20f833961f1940c8 = function(dictShow) {
    var show = $2XxiF.show($h2xUu.showMaybe(dictShow));
    return {
        show: function(v) {
            return "First (" + (show(v) + ")");
        }
    };
};
var $f448aa71443748c1$export$53ff158b23f5d382 = {
    append: function(v) {
        return function(v1) {
            if (v instanceof $h2xUu.Just) return v;
            return v1;
        };
    }
};
var $f448aa71443748c1$export$4d7d8eedf770f0 = function(dictOrd) {
    return $h2xUu.ordMaybe(dictOrd);
};
var $f448aa71443748c1$export$f6a5e365037ccf9a = $h2xUu.ord1Maybe;
var $f448aa71443748c1$export$130c32806db3fdc8 = {
    Coercible0: function() {
        return undefined;
    }
};
var $f448aa71443748c1$export$db2423f7434b7a30 = /* #__PURE__ */ function() {
    return {
        mempty: $h2xUu.Nothing.value,
        Semigroup0: function() {
            return $f448aa71443748c1$export$53ff158b23f5d382;
        }
    };
}();
var $f448aa71443748c1$export$e17b0506de713d2e = $h2xUu.monadMaybe;
var $f448aa71443748c1$export$6f62e1511455cb87 = $h2xUu.invariantMaybe;
var $f448aa71443748c1$export$98d9d13e8b5bfe4d = $h2xUu.functorMaybe;
var $f448aa71443748c1$export$590ee69b33ca98b4 = $h2xUu.extendMaybe;
var $f448aa71443748c1$export$8232f15b0b41395c = function(dictEq) {
    return $h2xUu.eqMaybe(dictEq);
};
var $f448aa71443748c1$export$1a969f11cd8a353e = $h2xUu.eq1Maybe;
var $f448aa71443748c1$export$315f32b6f78e2785 = function(dictBounded) {
    return $h2xUu.boundedMaybe(dictBounded);
};
var $f448aa71443748c1$export$456f8570baa6024f = $h2xUu.bindMaybe;
var $f448aa71443748c1$export$e48e2da4536c2eea = $h2xUu.applyMaybe;
var $f448aa71443748c1$export$178f5831973b2ff8 = $h2xUu.applicativeMaybe;
var $f448aa71443748c1$export$5cfe42f95bdf312b = {
    alt: /* #__PURE__ */ $d5vvq.append($f448aa71443748c1$export$53ff158b23f5d382),
    Functor0: function() {
        return $f448aa71443748c1$export$98d9d13e8b5bfe4d;
    }
};
var $f448aa71443748c1$export$e3c1997b7c0ee480 = {
    empty: /* #__PURE__ */ $3aOYV.mempty($f448aa71443748c1$export$db2423f7434b7a30),
    Alt0: function() {
        return $f448aa71443748c1$export$5cfe42f95bdf312b;
    }
};
var $f448aa71443748c1$export$92398121afed1258 = {
    Applicative0: function() {
        return $f448aa71443748c1$export$178f5831973b2ff8;
    },
    Plus1: function() {
        return $f448aa71443748c1$export$e3c1997b7c0ee480;
    }
};

});

parcelRegister("h73gt", function(module, exports) {

$parcel$export(module.exports, "Conj", () => $c7559f7130647a61$export$c688766eb4789b8c);
$parcel$export(module.exports, "monoidConj", () => $c7559f7130647a61$export$4f2b093ea8408d89);
$parcel$export(module.exports, "functorConj", () => $c7559f7130647a61$export$48b7cf0194537bca);
// Generated by purs version 0.15.16

var $aJhEx = parcelRequire("aJhEx");

var $IhyKA = parcelRequire("IhyKA");

var $gwBF5 = parcelRequire("gwBF5");

var $2XxiF = parcelRequire("2XxiF");
var $c7559f7130647a61$export$c688766eb4789b8c = function(x) {
    return x;
};
var $c7559f7130647a61$export$3e00b8f10f0f4e39 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(v) {
            return "(Conj " + (show(v) + ")");
        }
    };
};
var $c7559f7130647a61$export$b71164e0e6b84c70 = function(dictHeytingAlgebra) {
    var conj = $IhyKA.conj(dictHeytingAlgebra);
    var disj = $IhyKA.disj(dictHeytingAlgebra);
    return {
        zero: $IhyKA.tt(dictHeytingAlgebra),
        one: $IhyKA.ff(dictHeytingAlgebra),
        add: function(v) {
            return function(v1) {
                return conj(v)(v1);
            };
        },
        mul: function(v) {
            return function(v1) {
                return disj(v)(v1);
            };
        }
    };
};
var $c7559f7130647a61$export$91e0ef53a9c72523 = function(dictHeytingAlgebra) {
    var conj = $IhyKA.conj(dictHeytingAlgebra);
    return {
        append: function(v) {
            return function(v1) {
                return conj(v)(v1);
            };
        }
    };
};
var $c7559f7130647a61$export$74eade9f2b920d02 = function(dictOrd) {
    return dictOrd;
};
var $c7559f7130647a61$export$4f2b093ea8408d89 = function(dictHeytingAlgebra) {
    var semigroupConj1 = $c7559f7130647a61$export$91e0ef53a9c72523(dictHeytingAlgebra);
    return {
        mempty: $IhyKA.tt(dictHeytingAlgebra),
        Semigroup0: function() {
            return semigroupConj1;
        }
    };
};
var $c7559f7130647a61$export$48b7cf0194537bca = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $c7559f7130647a61$export$2d4ce045d5165d6f = function(dictEq) {
    return dictEq;
};
var $c7559f7130647a61$export$43823c09e8843bf5 = {
    eq1: function(dictEq) {
        return $aJhEx.eq($c7559f7130647a61$export$2d4ce045d5165d6f(dictEq));
    }
};
var $c7559f7130647a61$export$a6a01ce014de97e1 = {
    compare1: function(dictOrd) {
        return $gwBF5.compare($c7559f7130647a61$export$74eade9f2b920d02(dictOrd));
    },
    Eq10: function() {
        return $c7559f7130647a61$export$43823c09e8843bf5;
    }
};
var $c7559f7130647a61$export$a4102daba18ffc08 = function(dictBounded) {
    return dictBounded;
};
var $c7559f7130647a61$export$a163c218e9f2482b = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $c7559f7130647a61$export$48b7cf0194537bca;
    }
};
var $c7559f7130647a61$export$b79fdb9ffe29876e = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $c7559f7130647a61$export$a163c218e9f2482b;
    }
};
var $c7559f7130647a61$export$af9c11f53d676ebc = {
    pure: $c7559f7130647a61$export$c688766eb4789b8c,
    Apply0: function() {
        return $c7559f7130647a61$export$a163c218e9f2482b;
    }
};
var $c7559f7130647a61$export$7c7cf1e6ee225e25 = {
    Applicative0: function() {
        return $c7559f7130647a61$export$af9c11f53d676ebc;
    },
    Bind1: function() {
        return $c7559f7130647a61$export$b79fdb9ffe29876e;
    }
};

});

parcelRegister("d4RtI", function(module, exports) {

$parcel$export(module.exports, "Disj", () => $985521bce9ae057f$export$286e7113895e33ef);
$parcel$export(module.exports, "monoidDisj", () => $985521bce9ae057f$export$e1c73e5b30670500);
$parcel$export(module.exports, "functorDisj", () => $985521bce9ae057f$export$410cd7ab647069e5);
// Generated by purs version 0.15.16

var $aJhEx = parcelRequire("aJhEx");

var $IhyKA = parcelRequire("IhyKA");

var $gwBF5 = parcelRequire("gwBF5");

var $2XxiF = parcelRequire("2XxiF");
var $985521bce9ae057f$export$286e7113895e33ef = function(x) {
    return x;
};
var $985521bce9ae057f$export$84ed1543fc941c9a = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(v) {
            return "(Disj " + (show(v) + ")");
        }
    };
};
var $985521bce9ae057f$export$5b0a7c2f35d7a492 = function(dictHeytingAlgebra) {
    var disj = $IhyKA.disj(dictHeytingAlgebra);
    var conj = $IhyKA.conj(dictHeytingAlgebra);
    return {
        zero: $IhyKA.ff(dictHeytingAlgebra),
        one: $IhyKA.tt(dictHeytingAlgebra),
        add: function(v) {
            return function(v1) {
                return disj(v)(v1);
            };
        },
        mul: function(v) {
            return function(v1) {
                return conj(v)(v1);
            };
        }
    };
};
var $985521bce9ae057f$export$f23e3b19aa9e04ea = function(dictHeytingAlgebra) {
    var disj = $IhyKA.disj(dictHeytingAlgebra);
    return {
        append: function(v) {
            return function(v1) {
                return disj(v)(v1);
            };
        }
    };
};
var $985521bce9ae057f$export$5f1629868b2a8f7a = function(dictOrd) {
    return dictOrd;
};
var $985521bce9ae057f$export$e1c73e5b30670500 = function(dictHeytingAlgebra) {
    var semigroupDisj1 = $985521bce9ae057f$export$f23e3b19aa9e04ea(dictHeytingAlgebra);
    return {
        mempty: $IhyKA.ff(dictHeytingAlgebra),
        Semigroup0: function() {
            return semigroupDisj1;
        }
    };
};
var $985521bce9ae057f$export$410cd7ab647069e5 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $985521bce9ae057f$export$3f2868cf248cd7c5 = function(dictEq) {
    return dictEq;
};
var $985521bce9ae057f$export$8ab894b15d39baff = {
    eq1: function(dictEq) {
        return $aJhEx.eq($985521bce9ae057f$export$3f2868cf248cd7c5(dictEq));
    }
};
var $985521bce9ae057f$export$b2df6a05be54d5b7 = {
    compare1: function(dictOrd) {
        return $gwBF5.compare($985521bce9ae057f$export$5f1629868b2a8f7a(dictOrd));
    },
    Eq10: function() {
        return $985521bce9ae057f$export$8ab894b15d39baff;
    }
};
var $985521bce9ae057f$export$fcd058ea94ebee31 = function(dictBounded) {
    return dictBounded;
};
var $985521bce9ae057f$export$6e64deb0714631e6 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $985521bce9ae057f$export$410cd7ab647069e5;
    }
};
var $985521bce9ae057f$export$997bc439fd07ce0b = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $985521bce9ae057f$export$6e64deb0714631e6;
    }
};
var $985521bce9ae057f$export$a5d698d68d7ba6f5 = {
    pure: $985521bce9ae057f$export$286e7113895e33ef,
    Apply0: function() {
        return $985521bce9ae057f$export$6e64deb0714631e6;
    }
};
var $985521bce9ae057f$export$15ab4d3c125d7ac0 = {
    Applicative0: function() {
        return $985521bce9ae057f$export$a5d698d68d7ba6f5;
    },
    Bind1: function() {
        return $985521bce9ae057f$export$997bc439fd07ce0b;
    }
};

});

parcelRegister("53NY2", function(module, exports) {

$parcel$export(module.exports, "Dual", () => $3af3fe08d2af72c4$export$c26a72e8d91adeec);
$parcel$export(module.exports, "semigroupDual", () => $3af3fe08d2af72c4$export$dc7d4cd4865fc48);
$parcel$export(module.exports, "monoidDual", () => $3af3fe08d2af72c4$export$b54c1e48d4afa3cb);
$parcel$export(module.exports, "functorDual", () => $3af3fe08d2af72c4$export$916a3957c09e9ed5);
// Generated by purs version 0.15.16

var $aJhEx = parcelRequire("aJhEx");

var $3aOYV = parcelRequire("3aOYV");

var $gwBF5 = parcelRequire("gwBF5");

var $d5vvq = parcelRequire("d5vvq");

var $2XxiF = parcelRequire("2XxiF");
var $3af3fe08d2af72c4$export$c26a72e8d91adeec = function(x) {
    return x;
};
var $3af3fe08d2af72c4$export$367774d50e2e283e = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(v) {
            return "(Dual " + (show(v) + ")");
        }
    };
};
var $3af3fe08d2af72c4$export$dc7d4cd4865fc48 = function(dictSemigroup) {
    var append1 = $d5vvq.append(dictSemigroup);
    return {
        append: function(v) {
            return function(v1) {
                return append1(v1)(v);
            };
        }
    };
};
var $3af3fe08d2af72c4$export$baedc2c70a4ae2b1 = function(dictOrd) {
    return dictOrd;
};
var $3af3fe08d2af72c4$export$b54c1e48d4afa3cb = function(dictMonoid) {
    var semigroupDual1 = $3af3fe08d2af72c4$export$dc7d4cd4865fc48(dictMonoid.Semigroup0());
    return {
        mempty: $3aOYV.mempty(dictMonoid),
        Semigroup0: function() {
            return semigroupDual1;
        }
    };
};
var $3af3fe08d2af72c4$export$916a3957c09e9ed5 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $3af3fe08d2af72c4$export$2b6bf0b2b79b7623 = function(dictEq) {
    return dictEq;
};
var $3af3fe08d2af72c4$export$334c9b177d56941 = {
    eq1: function(dictEq) {
        return $aJhEx.eq($3af3fe08d2af72c4$export$2b6bf0b2b79b7623(dictEq));
    }
};
var $3af3fe08d2af72c4$export$f00e1ac1e19e7381 = {
    compare1: function(dictOrd) {
        return $gwBF5.compare($3af3fe08d2af72c4$export$baedc2c70a4ae2b1(dictOrd));
    },
    Eq10: function() {
        return $3af3fe08d2af72c4$export$334c9b177d56941;
    }
};
var $3af3fe08d2af72c4$export$5a3916bf05e599b0 = function(dictBounded) {
    return dictBounded;
};
var $3af3fe08d2af72c4$export$9e642462d19ab815 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $3af3fe08d2af72c4$export$916a3957c09e9ed5;
    }
};
var $3af3fe08d2af72c4$export$307a1784edb0cbc9 = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $3af3fe08d2af72c4$export$9e642462d19ab815;
    }
};
var $3af3fe08d2af72c4$export$f853c12137409deb = {
    pure: $3af3fe08d2af72c4$export$c26a72e8d91adeec,
    Apply0: function() {
        return $3af3fe08d2af72c4$export$9e642462d19ab815;
    }
};
var $3af3fe08d2af72c4$export$965738b694a4882b = {
    Applicative0: function() {
        return $3af3fe08d2af72c4$export$f853c12137409deb;
    },
    Bind1: function() {
        return $3af3fe08d2af72c4$export$307a1784edb0cbc9;
    }
};

});

parcelRegister("ldkz2", function(module, exports) {

$parcel$export(module.exports, "Endo", () => $f71ac38136d09e09$export$6aef3ff797629bec);
$parcel$export(module.exports, "monoidEndo", () => $f71ac38136d09e09$export$947ca1a8eed6111);
// Generated by purs version 0.15.16

var $26SV5 = parcelRequire("26SV5");

var $gZ030 = parcelRequire("gZ030");

var $2XxiF = parcelRequire("2XxiF");
var $f71ac38136d09e09$export$6aef3ff797629bec = function(x) {
    return x;
};
var $f71ac38136d09e09$export$e6887fe542fcbae3 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(v) {
            return "(Endo " + (show(v) + ")");
        }
    };
};
var $f71ac38136d09e09$export$5f7c224ff60452b9 = function(dictSemigroupoid) {
    var compose = $gZ030.compose(dictSemigroupoid);
    return {
        append: function(v) {
            return function(v1) {
                return compose(v)(v1);
            };
        }
    };
};
var $f71ac38136d09e09$export$5f95a5e6b940187f = function(dictOrd) {
    return dictOrd;
};
var $f71ac38136d09e09$export$947ca1a8eed6111 = function(dictCategory) {
    var semigroupEndo1 = $f71ac38136d09e09$export$5f7c224ff60452b9(dictCategory.Semigroupoid0());
    return {
        mempty: $26SV5.identity(dictCategory),
        Semigroup0: function() {
            return semigroupEndo1;
        }
    };
};
var $f71ac38136d09e09$export$ee65626e0479baec = function(dictEq) {
    return dictEq;
};
var $f71ac38136d09e09$export$35b120d2f621b3e2 = function(dictBounded) {
    return dictBounded;
};

});

parcelRegister("46y1S", function(module, exports) {

$parcel$export(module.exports, "wrap", () => $2fd21e7669180390$export$4997ffc0176396a6);
$parcel$export(module.exports, "unwrap", () => $2fd21e7669180390$export$debb760848ca95a);
$parcel$export(module.exports, "un", () => $2fd21e7669180390$export$a2a39c9747f0e54a);
$parcel$export(module.exports, "over", () => $2fd21e7669180390$export$fb4902fd9e525693);
$parcel$export(module.exports, "alaF", () => $2fd21e7669180390$export$b533eaec53aab18a);
$parcel$export(module.exports, "ala", () => $2fd21e7669180390$export$7317c19c5df48291);
// Generated by purs version 0.15.16

var $8ln3P = parcelRequire("8ln3P");
var $2fd21e7669180390$var$coerce = /* #__PURE__ */ $8ln3P.coerce();
var $2fd21e7669180390$export$4997ffc0176396a6 = function() {
    return $2fd21e7669180390$var$coerce;
};
var $2fd21e7669180390$var$wrap1 = /* #__PURE__ */ $2fd21e7669180390$export$4997ffc0176396a6();
var $2fd21e7669180390$export$debb760848ca95a = function() {
    return $2fd21e7669180390$var$coerce;
};
var $2fd21e7669180390$var$unwrap1 = /* #__PURE__ */ $2fd21e7669180390$export$debb760848ca95a();
var $2fd21e7669180390$export$5ac000a3404ef088 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $2fd21e7669180390$var$coerce;
                };
            };
        };
    };
};
var $2fd21e7669180390$export$18fe6ced65b9d3a7 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $2fd21e7669180390$var$coerce;
                };
            };
        };
    };
};
var $2fd21e7669180390$export$9824f93a497ba98e = function() {
    return function() {
        return function(v) {
            return $2fd21e7669180390$var$coerce;
        };
    };
};
var $2fd21e7669180390$export$3b98aa7d576b2b80 = function() {
    return function() {
        return function(v) {
            return $2fd21e7669180390$var$coerce;
        };
    };
};
var $2fd21e7669180390$export$a2a39c9747f0e54a = function() {
    return function(v) {
        return $2fd21e7669180390$var$unwrap1;
    };
};
var $2fd21e7669180390$export$df3f009e3d155b20 = function() {
    return function() {
        return function(v) {
            return $2fd21e7669180390$var$coerce;
        };
    };
};
var $2fd21e7669180390$export$f2787354896befb9 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $2fd21e7669180390$var$coerce;
                };
            };
        };
    };
};
var $2fd21e7669180390$export$d0d3897f12fa9d17 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $2fd21e7669180390$var$coerce;
                };
            };
        };
    };
};
var $2fd21e7669180390$export$e8dd23d7349f1a08 = function() {
    return function() {
        return function(v) {
            return $2fd21e7669180390$var$coerce;
        };
    };
};
var $2fd21e7669180390$export$fb4902fd9e525693 = function() {
    return function() {
        return function(v) {
            return $2fd21e7669180390$var$coerce;
        };
    };
};
var $2fd21e7669180390$export$cbef643c6d6f42c2 = {
    Coercible0: function() {
        return undefined;
    }
};
var $2fd21e7669180390$export$ccaccac244187f64 = {
    Coercible0: function() {
        return undefined;
    }
};
var $2fd21e7669180390$export$130c32806db3fdc8 = {
    Coercible0: function() {
        return undefined;
    }
};
var $2fd21e7669180390$export$bae63404e9252557 = {
    Coercible0: function() {
        return undefined;
    }
};
var $2fd21e7669180390$export$940059b52273aa56 = {
    Coercible0: function() {
        return undefined;
    }
};
var $2fd21e7669180390$export$b77ba17f6321a9fb = {
    Coercible0: function() {
        return undefined;
    }
};
var $2fd21e7669180390$export$59af3bbd6a00f6a9 = {
    Coercible0: function() {
        return undefined;
    }
};
var $2fd21e7669180390$export$78c87ff68dcb8da2 = {
    Coercible0: function() {
        return undefined;
    }
};
var $2fd21e7669180390$export$3ff57735a52b8713 = function() {
    return function(fn) {
        return function(t) {
            return $2fd21e7669180390$var$wrap1(fn($2fd21e7669180390$var$unwrap1(t)));
        };
    };
};
var $2fd21e7669180390$export$bb44f104e3c54dae = function() {
    return function() {
        return function(v) {
            return $2fd21e7669180390$var$coerce;
        };
    };
};
var $2fd21e7669180390$export$b533eaec53aab18a = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $2fd21e7669180390$var$coerce;
                };
            };
        };
    };
};
var $2fd21e7669180390$export$7317c19c5df48291 = function() {
    return function() {
        return function() {
            return function(v) {
                return function(f) {
                    return $2fd21e7669180390$var$coerce(f($2fd21e7669180390$var$wrap1));
                };
            };
        };
    };
};

});
parcelRegister("8ln3P", function(module, exports) {

$parcel$export(module.exports, "coerce", () => $61322c4d5a1369c8$export$8c14e57e778d3873);
// Generated by purs version 0.15.16
parcelRequire("k2DSm");
var $abEmB = parcelRequire("abEmB");
var $61322c4d5a1369c8$export$8c14e57e778d3873 = function() {
    return $abEmB.unsafeCoerce;
};

});
parcelRegister("k2DSm", function(module, exports) {

$parcel$export(module.exports, "unsafeCoerce", () => (parcelRequire("abEmB")).unsafeCoerce);
// Generated by purs version 0.15.16

var $abEmB = parcelRequire("abEmB");

});
parcelRegister("abEmB", function(module, exports) {

$parcel$export(module.exports, "unsafeCoerce", () => $76aa3dcf4adbbe77$export$401372c57776dc);
// module Unsafe.Coerce
const $76aa3dcf4adbbe77$export$401372c57776dc = function(x) {
    return x;
};

});





parcelRegister("9OOYG", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $726053b48c18a395$export$df3f009e3d155b20);
$parcel$export(module.exports, "traversableTuple", () => $726053b48c18a395$export$d35878ee42638401);
$parcel$export(module.exports, "traversableMultiplicative", () => $726053b48c18a395$export$b86a2d00788e21b6);
$parcel$export(module.exports, "traversableMaybe", () => $726053b48c18a395$export$80f6258c17467741);
$parcel$export(module.exports, "traversableIdentity", () => $726053b48c18a395$export$63e84f34fb558532);
$parcel$export(module.exports, "traversableEither", () => $726053b48c18a395$export$29eea1300519490d);
$parcel$export(module.exports, "traversableDual", () => $726053b48c18a395$export$54df524caf88dbea);
$parcel$export(module.exports, "traversableDisj", () => $726053b48c18a395$export$a73c18000a1a08d7);
$parcel$export(module.exports, "traversableConst", () => $726053b48c18a395$export$e6d8402c3fd7d14d);
$parcel$export(module.exports, "traversableConj", () => $726053b48c18a395$export$ecbf0d941e1ac029);
$parcel$export(module.exports, "traversableCompose", () => $726053b48c18a395$export$8c91a5391205dbe);
$parcel$export(module.exports, "traversableAdditive", () => $726053b48c18a395$export$617ac6e03fd9951c);
$parcel$export(module.exports, "sequenceDefault", () => $726053b48c18a395$export$417d88f64c497aed);
$parcel$export(module.exports, "traversableArray", () => $726053b48c18a395$export$9e4a28683e28e26a);
$parcel$export(module.exports, "sequence", () => $726053b48c18a395$export$49bb65c2ea163039);
$parcel$export(module.exports, "traversableApp", () => $726053b48c18a395$export$744e1c7707f1991f);
$parcel$export(module.exports, "traversableCoproduct", () => $726053b48c18a395$export$78124b32135c203a);
$parcel$export(module.exports, "traversableFirst", () => $726053b48c18a395$export$1cee23aad9b21cdc);
$parcel$export(module.exports, "traversableLast", () => $726053b48c18a395$export$f5923975fb28337f);
$parcel$export(module.exports, "traversableProduct", () => $726053b48c18a395$export$261d8d87b1749d17);
// Generated by purs version 0.15.16

var $5V8Nn = parcelRequire("5V8Nn");

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $26SV5 = parcelRequire("26SV5");

var $x1jCe = parcelRequire("x1jCe");

var $beQI1 = parcelRequire("beQI1");

var $dNwPt = parcelRequire("dNwPt");

var $7FzSN = parcelRequire("7FzSN");

var $8Gte6 = parcelRequire("8Gte6");

var $iMzH1 = parcelRequire("iMzH1");

var $7Rccs = parcelRequire("7Rccs");

var $6dOpK = parcelRequire("6dOpK");

var $8pkky = parcelRequire("8pkky");

var $h2xUu = parcelRequire("h2xUu");

var $kYjFk = parcelRequire("kYjFk");

var $kobBf = parcelRequire("kobBf");

var $6UiNT = parcelRequire("6UiNT");

var $h73gt = parcelRequire("h73gt");

var $d4RtI = parcelRequire("d4RtI");

var $53NY2 = parcelRequire("53NY2");

var $laciu = parcelRequire("laciu");
parcelRequire("lVswN");

var $dazHc = parcelRequire("dazHc");

var $7O0Q4 = parcelRequire("7O0Q4");
var $726053b48c18a395$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $726053b48c18a395$export$df3f009e3d155b20 = function(dict) {
    return dict.traverse;
};
var $726053b48c18a395$export$d35878ee42638401 = {
    traverse: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($7O0Q4.Tuple.create(v.value0))(f(v.value1));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($7O0Q4.Tuple.create(v.value0))(v.value1);
        };
    },
    Functor0: function() {
        return $7O0Q4.functorTuple;
    },
    Foldable1: function() {
        return $dNwPt.foldableTuple;
    }
};
var $726053b48c18a395$export$b86a2d00788e21b6 = {
    traverse: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($laciu.Multiplicative)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($laciu.Multiplicative)(v);
        };
    },
    Functor0: function() {
        return $laciu.functorMultiplicative;
    },
    Foldable1: function() {
        return $dNwPt.foldableMultiplicative;
    }
};
var $726053b48c18a395$export$80f6258c17467741 = {
    traverse: function(dictApplicative) {
        var pure = $bQdkN.pure(dictApplicative);
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $h2xUu.Nothing) return pure($h2xUu.Nothing.value);
                if (v1 instanceof $h2xUu.Just) return map($h2xUu.Just.create)(v(v1.value0));
                throw new Error("Failed pattern match at Data.Traversable (line 115, column 1 - line 119, column 33): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $bQdkN.pure(dictApplicative);
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            if (v instanceof $h2xUu.Nothing) return pure($h2xUu.Nothing.value);
            if (v instanceof $h2xUu.Just) return map($h2xUu.Just.create)(v.value0);
            throw new Error("Failed pattern match at Data.Traversable (line 115, column 1 - line 119, column 33): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $h2xUu.functorMaybe;
    },
    Foldable1: function() {
        return $dNwPt.foldableMaybe;
    }
};
var $726053b48c18a395$var$traverse1 = /* #__PURE__ */ $726053b48c18a395$export$df3f009e3d155b20($726053b48c18a395$export$80f6258c17467741);
var $726053b48c18a395$export$63e84f34fb558532 = {
    traverse: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($8pkky.Identity)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($8pkky.Identity)(v);
        };
    },
    Functor0: function() {
        return $8pkky.functorIdentity;
    },
    Foldable1: function() {
        return $dNwPt.foldableIdentity;
    }
};
var $726053b48c18a395$export$29eea1300519490d = {
    traverse: function(dictApplicative) {
        var pure = $bQdkN.pure(dictApplicative);
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $beQI1.Left) return pure(new $beQI1.Left(v1.value0));
                if (v1 instanceof $beQI1.Right) return map($beQI1.Right.create)(v(v1.value0));
                throw new Error("Failed pattern match at Data.Traversable (line 149, column 1 - line 153, column 36): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $bQdkN.pure(dictApplicative);
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            if (v instanceof $beQI1.Left) return pure(new $beQI1.Left(v.value0));
            if (v instanceof $beQI1.Right) return map($beQI1.Right.create)(v.value0);
            throw new Error("Failed pattern match at Data.Traversable (line 149, column 1 - line 153, column 36): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $beQI1.functorEither;
    },
    Foldable1: function() {
        return $dNwPt.foldableEither;
    }
};
var $726053b48c18a395$export$54df524caf88dbea = {
    traverse: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($53NY2.Dual)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($53NY2.Dual)(v);
        };
    },
    Functor0: function() {
        return $53NY2.functorDual;
    },
    Foldable1: function() {
        return $dNwPt.foldableDual;
    }
};
var $726053b48c18a395$export$a73c18000a1a08d7 = {
    traverse: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($d4RtI.Disj)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($d4RtI.Disj)(v);
        };
    },
    Functor0: function() {
        return $d4RtI.functorDisj;
    },
    Foldable1: function() {
        return $dNwPt.foldableDisj;
    }
};
var $726053b48c18a395$export$e6d8402c3fd7d14d = {
    traverse: function(dictApplicative) {
        var pure = $bQdkN.pure(dictApplicative);
        return function(v) {
            return function(v1) {
                return pure(v1);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $bQdkN.pure(dictApplicative);
        return function(v) {
            return pure(v);
        };
    },
    Functor0: function() {
        return $x1jCe.functorConst;
    },
    Foldable1: function() {
        return $dNwPt.foldableConst;
    }
};
var $726053b48c18a395$export$ecbf0d941e1ac029 = {
    traverse: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($h73gt.Conj)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($h73gt.Conj)(v);
        };
    },
    Functor0: function() {
        return $h73gt.functorConj;
    },
    Foldable1: function() {
        return $dNwPt.foldableConj;
    }
};
var $726053b48c18a395$export$8c91a5391205dbe = function(dictTraversable) {
    var traverse2 = $726053b48c18a395$export$df3f009e3d155b20(dictTraversable);
    var functorCompose = $iMzH1.functorCompose(dictTraversable.Functor0());
    var foldableCompose = $dNwPt.foldableCompose(dictTraversable.Foldable1());
    return function(dictTraversable1) {
        var traverse3 = $726053b48c18a395$export$df3f009e3d155b20(dictTraversable1);
        var functorCompose1 = functorCompose(dictTraversable1.Functor0());
        var foldableCompose1 = foldableCompose(dictTraversable1.Foldable1());
        return {
            traverse: function(dictApplicative) {
                var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
                var traverse4 = traverse2(dictApplicative);
                var traverse5 = traverse3(dictApplicative);
                return function(f) {
                    return function(v) {
                        return map($iMzH1.Compose)(traverse4(traverse5(f))(v));
                    };
                };
            },
            sequence: function(dictApplicative) {
                return $726053b48c18a395$export$df3f009e3d155b20($726053b48c18a395$export$8c91a5391205dbe(dictTraversable)(dictTraversable1))(dictApplicative)($726053b48c18a395$var$identity);
            },
            Functor0: function() {
                return functorCompose1;
            },
            Foldable1: function() {
                return foldableCompose1;
            }
        };
    };
};
var $726053b48c18a395$export$617ac6e03fd9951c = {
    traverse: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($6UiNT.Additive)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($6UiNT.Additive)(v);
        };
    },
    Functor0: function() {
        return $6UiNT.functorAdditive;
    },
    Foldable1: function() {
        return $dNwPt.foldableAdditive;
    }
};
var $726053b48c18a395$export$417d88f64c497aed = function(dictTraversable) {
    var traverse2 = $726053b48c18a395$export$df3f009e3d155b20(dictTraversable);
    return function(dictApplicative) {
        return traverse2(dictApplicative)($726053b48c18a395$var$identity);
    };
};
var $726053b48c18a395$export$9e4a28683e28e26a = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        return $5V8Nn.traverseArrayImpl($26ZCq.apply(Apply0))($7FzSN.map(Apply0.Functor0()))($bQdkN.pure(dictApplicative));
    },
    sequence: function(dictApplicative) {
        return $726053b48c18a395$export$417d88f64c497aed($726053b48c18a395$export$9e4a28683e28e26a)(dictApplicative);
    },
    Functor0: function() {
        return $7FzSN.functorArray;
    },
    Foldable1: function() {
        return $dNwPt.foldableArray;
    }
};
var $726053b48c18a395$export$49bb65c2ea163039 = function(dict) {
    return dict.sequence;
};
var $726053b48c18a395$var$sequence1 = /* #__PURE__ */ $726053b48c18a395$export$49bb65c2ea163039($726053b48c18a395$export$80f6258c17467741);
var $726053b48c18a395$export$744e1c7707f1991f = function(dictTraversable) {
    var traverse2 = $726053b48c18a395$export$df3f009e3d155b20(dictTraversable);
    var sequence2 = $726053b48c18a395$export$49bb65c2ea163039(dictTraversable);
    var functorApp = $8Gte6.functorApp(dictTraversable.Functor0());
    var foldableApp = $dNwPt.foldableApp(dictTraversable.Foldable1());
    return {
        traverse: function(dictApplicative) {
            var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
            var traverse3 = traverse2(dictApplicative);
            return function(f) {
                return function(v) {
                    return map($8Gte6.App)(traverse3(f)(v));
                };
            };
        },
        sequence: function(dictApplicative) {
            var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
            var sequence3 = sequence2(dictApplicative);
            return function(v) {
                return map($8Gte6.App)(sequence3(v));
            };
        },
        Functor0: function() {
            return functorApp;
        },
        Foldable1: function() {
            return foldableApp;
        }
    };
};
var $726053b48c18a395$export$78124b32135c203a = function(dictTraversable) {
    var traverse2 = $726053b48c18a395$export$df3f009e3d155b20(dictTraversable);
    var sequence2 = $726053b48c18a395$export$49bb65c2ea163039(dictTraversable);
    var functorCoproduct = $7Rccs.functorCoproduct(dictTraversable.Functor0());
    var foldableCoproduct = $dNwPt.foldableCoproduct(dictTraversable.Foldable1());
    return function(dictTraversable1) {
        var traverse3 = $726053b48c18a395$export$df3f009e3d155b20(dictTraversable1);
        var sequence3 = $726053b48c18a395$export$49bb65c2ea163039(dictTraversable1);
        var functorCoproduct1 = functorCoproduct(dictTraversable1.Functor0());
        var foldableCoproduct1 = foldableCoproduct(dictTraversable1.Foldable1());
        return {
            traverse: function(dictApplicative) {
                var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
                var traverse4 = traverse2(dictApplicative);
                var traverse5 = traverse3(dictApplicative);
                return function(f) {
                    return $7Rccs.coproduct(function() {
                        var $313 = map(function($316) {
                            return $7Rccs.Coproduct($beQI1.Left.create($316));
                        });
                        var $314 = traverse4(f);
                        return function($315) {
                            return $313($314($315));
                        };
                    }())(function() {
                        var $317 = map(function($320) {
                            return $7Rccs.Coproduct($beQI1.Right.create($320));
                        });
                        var $318 = traverse5(f);
                        return function($319) {
                            return $317($318($319));
                        };
                    }());
                };
            },
            sequence: function(dictApplicative) {
                var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
                return $7Rccs.coproduct(function() {
                    var $321 = map(function($324) {
                        return $7Rccs.Coproduct($beQI1.Left.create($324));
                    });
                    var $322 = sequence2(dictApplicative);
                    return function($323) {
                        return $321($322($323));
                    };
                }())(function() {
                    var $325 = map(function($328) {
                        return $7Rccs.Coproduct($beQI1.Right.create($328));
                    });
                    var $326 = sequence3(dictApplicative);
                    return function($327) {
                        return $325($326($327));
                    };
                }());
            },
            Functor0: function() {
                return functorCoproduct1;
            },
            Foldable1: function() {
                return foldableCoproduct1;
            }
        };
    };
};
var $726053b48c18a395$export$1cee23aad9b21cdc = {
    traverse: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        var traverse2 = $726053b48c18a395$var$traverse1(dictApplicative);
        return function(f) {
            return function(v) {
                return map($kYjFk.First)(traverse2(f)(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        var sequence2 = $726053b48c18a395$var$sequence1(dictApplicative);
        return function(v) {
            return map($kYjFk.First)(sequence2(v));
        };
    },
    Functor0: function() {
        return $kYjFk.functorFirst;
    },
    Foldable1: function() {
        return $dNwPt.foldableFirst;
    }
};
var $726053b48c18a395$export$f5923975fb28337f = {
    traverse: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        var traverse2 = $726053b48c18a395$var$traverse1(dictApplicative);
        return function(f) {
            return function(v) {
                return map($kobBf.Last)(traverse2(f)(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        var sequence2 = $726053b48c18a395$var$sequence1(dictApplicative);
        return function(v) {
            return map($kobBf.Last)(sequence2(v));
        };
    },
    Functor0: function() {
        return $kobBf.functorLast;
    },
    Foldable1: function() {
        return $dNwPt.foldableLast;
    }
};
var $726053b48c18a395$export$261d8d87b1749d17 = function(dictTraversable) {
    var traverse2 = $726053b48c18a395$export$df3f009e3d155b20(dictTraversable);
    var sequence2 = $726053b48c18a395$export$49bb65c2ea163039(dictTraversable);
    var functorProduct = $6dOpK.functorProduct(dictTraversable.Functor0());
    var foldableProduct = $dNwPt.foldableProduct(dictTraversable.Foldable1());
    return function(dictTraversable1) {
        var traverse3 = $726053b48c18a395$export$df3f009e3d155b20(dictTraversable1);
        var sequence3 = $726053b48c18a395$export$49bb65c2ea163039(dictTraversable1);
        var functorProduct1 = functorProduct(dictTraversable1.Functor0());
        var foldableProduct1 = foldableProduct(dictTraversable1.Foldable1());
        return {
            traverse: function(dictApplicative) {
                var lift2 = $26ZCq.lift2(dictApplicative.Apply0());
                var traverse4 = traverse2(dictApplicative);
                var traverse5 = traverse3(dictApplicative);
                return function(f) {
                    return function(v) {
                        return lift2($6dOpK.product)(traverse4(f)(v.value0))(traverse5(f)(v.value1));
                    };
                };
            },
            sequence: function(dictApplicative) {
                var lift2 = $26ZCq.lift2(dictApplicative.Apply0());
                var sequence4 = sequence2(dictApplicative);
                var sequence5 = sequence3(dictApplicative);
                return function(v) {
                    return lift2($6dOpK.product)(sequence4(v.value0))(sequence5(v.value1));
                };
            },
            Functor0: function() {
                return functorProduct1;
            },
            Foldable1: function() {
                return foldableProduct1;
            }
        };
    };
};
var $726053b48c18a395$export$d50a9c31d69ee13c = function(dictTraversable) {
    var sequence2 = $726053b48c18a395$export$49bb65c2ea163039(dictTraversable);
    var map = $7FzSN.map(dictTraversable.Functor0());
    return function(dictApplicative) {
        var sequence3 = sequence2(dictApplicative);
        return function(f) {
            return function(ta) {
                return sequence3(map(f)(ta));
            };
        };
    };
};
var $726053b48c18a395$export$d54b12b778292b35 = function(dictTraversable) {
    var traverse2 = $726053b48c18a395$export$df3f009e3d155b20(dictTraversable)($dazHc.applicativeStateR);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $dazHc.stateR(traverse2(function(a) {
                    return function(s) {
                        return f(s)(a);
                    };
                })(xs))(s0);
            };
        };
    };
};
var $726053b48c18a395$export$64df51ac031d4ad2 = function(dictTraversable) {
    var mapAccumR1 = $726053b48c18a395$export$d54b12b778292b35(dictTraversable);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumR1(function(b) {
                    return function(a) {
                        var b$prime = f(a)(b);
                        return {
                            accum: b$prime,
                            value: b$prime
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $726053b48c18a395$export$d5f444bb5e0f233 = function(dictTraversable) {
    var traverse2 = $726053b48c18a395$export$df3f009e3d155b20(dictTraversable)($dazHc.applicativeStateL);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $dazHc.stateL(traverse2(function(a) {
                    return function(s) {
                        return f(s)(a);
                    };
                })(xs))(s0);
            };
        };
    };
};
var $726053b48c18a395$export$65f513eaf3c582b8 = function(dictTraversable) {
    var mapAccumL1 = $726053b48c18a395$export$d5f444bb5e0f233(dictTraversable);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumL1(function(b) {
                    return function(a) {
                        var b$prime = f(b)(a);
                        return {
                            accum: b$prime,
                            value: b$prime
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $726053b48c18a395$export$f89de2e5bf57e5e6 = function(dictApplicative) {
    return function(dictTraversable) {
        var traverse2 = $726053b48c18a395$export$df3f009e3d155b20(dictTraversable)(dictApplicative);
        return function(x) {
            return function(f) {
                return traverse2(f)(x);
            };
        };
    };
};

});
parcelRegister("5V8Nn", function(module, exports) {

$parcel$export(module.exports, "traverseArrayImpl", () => $44f9193091459010$export$778bf95e3da1fa51);
// jshint maxparams: 3
const $44f9193091459010$export$778bf95e3da1fa51 = function() {
    function array1(a) {
        return [
            a
        ];
    }
    function array2(a) {
        return function(b) {
            return [
                a,
                b
            ];
        };
    }
    function array3(a) {
        return function(b) {
            return function(c) {
                return [
                    a,
                    b,
                    c
                ];
            };
        };
    }
    function concat2(xs) {
        return function(ys) {
            return xs.concat(ys);
        };
    }
    return function(apply) {
        return function(map) {
            return function(pure) {
                return function(f) {
                    return function(array) {
                        function go(bot, top) {
                            switch(top - bot){
                                case 0:
                                    return pure([]);
                                case 1:
                                    return map(array1)(f(array[bot]));
                                case 2:
                                    return apply(map(array2)(f(array[bot])))(f(array[bot + 1]));
                                case 3:
                                    return apply(apply(map(array3)(f(array[bot])))(f(array[bot + 1])))(f(array[bot + 2]));
                                default:
                                    // This slightly tricky pivot selection aims to produce two
                                    // even-length partitions where possible.
                                    var pivot = bot + Math.floor((top - bot) / 4) * 2;
                                    return apply(map(concat2)(go(bot, pivot)))(go(pivot, top));
                            }
                        }
                        return go(0, array.length);
                    };
                };
            };
        };
    };
}();

});

parcelRegister("x1jCe", function(module, exports) {

$parcel$export(module.exports, "Const", () => $06341a63b881fc1d$export$8ad5d15375e29446);
$parcel$export(module.exports, "functorConst", () => $06341a63b881fc1d$export$c03820c48bf31fc8);
$parcel$export(module.exports, "applicativeConst", () => $06341a63b881fc1d$export$38647a91a5af2717);
// Generated by purs version 0.15.16

var $aJhEx = parcelRequire("aJhEx");

var $7nwca = parcelRequire("7nwca");

var $3aOYV = parcelRequire("3aOYV");

var $gwBF5 = parcelRequire("gwBF5");

var $d5vvq = parcelRequire("d5vvq");

var $2XxiF = parcelRequire("2XxiF");
var $06341a63b881fc1d$export$8ad5d15375e29446 = function(x) {
    return x;
};
var $06341a63b881fc1d$export$698fc26f8c8bb631 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(v) {
            return "(Const " + (show(v) + ")");
        }
    };
};
var $06341a63b881fc1d$export$8e644eba3b05046b = function(dictSemiring) {
    return dictSemiring;
};
var $06341a63b881fc1d$export$8f2711bf2f3160c6 = {
    compose: function(v) {
        return function(v1) {
            return v1;
        };
    }
};
var $06341a63b881fc1d$export$6eaf1848e07ae857 = function(dictSemigroup) {
    return dictSemigroup;
};
var $06341a63b881fc1d$export$e21edfc60fb6207c = function(dictRing) {
    return dictRing;
};
var $06341a63b881fc1d$export$2dc639aba34e0026 = function(dictOrd) {
    return dictOrd;
};
var $06341a63b881fc1d$export$ea93befd55cd9816 = {
    Coercible0: function() {
        return undefined;
    }
};
var $06341a63b881fc1d$export$d484d0b1dc07b605 = function(dictMonoid) {
    return dictMonoid;
};
var $06341a63b881fc1d$export$208a79db5ecd5bbf = function(dictHeytingAlgebra) {
    return dictHeytingAlgebra;
};
var $06341a63b881fc1d$export$c03820c48bf31fc8 = {
    map: function(f) {
        return function(m) {
            return m;
        };
    }
};
var $06341a63b881fc1d$export$30c2a66ea46ad17b = {
    imap: /* #__PURE__ */ $7nwca.imapF($06341a63b881fc1d$export$c03820c48bf31fc8)
};
var $06341a63b881fc1d$export$aa81c0060845253 = function(dictEuclideanRing) {
    return dictEuclideanRing;
};
var $06341a63b881fc1d$export$1688a037b5b692da = function(dictEq) {
    return dictEq;
};
var $06341a63b881fc1d$export$bdb9acf61703c804 = function(dictEq) {
    var eq = $aJhEx.eq($06341a63b881fc1d$export$1688a037b5b692da(dictEq));
    return {
        eq1: function(dictEq1) {
            return eq;
        }
    };
};
var $06341a63b881fc1d$export$87702177ef8adff4 = function(dictOrd) {
    var compare = $gwBF5.compare($06341a63b881fc1d$export$2dc639aba34e0026(dictOrd));
    var eq1Const1 = $06341a63b881fc1d$export$bdb9acf61703c804(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return compare;
        },
        Eq10: function() {
            return eq1Const1;
        }
    };
};
var $06341a63b881fc1d$export$c708f2c7ab030e40 = function(dictCommutativeRing) {
    return dictCommutativeRing;
};
var $06341a63b881fc1d$export$9ca7ce64fd99d2e3 = function(dictBounded) {
    return dictBounded;
};
var $06341a63b881fc1d$export$b7df7e3b07273a9c = function(dictBooleanAlgebra) {
    return dictBooleanAlgebra;
};
var $06341a63b881fc1d$export$17ba89632b46bf87 = function(dictSemigroup) {
    var append1 = $d5vvq.append(dictSemigroup);
    return {
        apply: function(v) {
            return function(v1) {
                return append1(v)(v1);
            };
        },
        Functor0: function() {
            return $06341a63b881fc1d$export$c03820c48bf31fc8;
        }
    };
};
var $06341a63b881fc1d$export$38647a91a5af2717 = function(dictMonoid) {
    var mempty = $3aOYV.mempty(dictMonoid);
    var applyConst1 = $06341a63b881fc1d$export$17ba89632b46bf87(dictMonoid.Semigroup0());
    return {
        pure: function(v) {
            return mempty;
        },
        Apply0: function() {
            return applyConst1;
        }
    };
};

});

parcelRegister("8Gte6", function(module, exports) {

$parcel$export(module.exports, "App", () => $6528eac3e4eea57e$export$86fbec116b87613f);
$parcel$export(module.exports, "hoistLiftApp", () => $6528eac3e4eea57e$export$d26bca0552b37bb6);
$parcel$export(module.exports, "functorApp", () => $6528eac3e4eea57e$export$79ab389dc7ad1e04);
$parcel$export(module.exports, "eqApp", () => $6528eac3e4eea57e$export$ca57ebaecdc7d318);
$parcel$export(module.exports, "ordApp", () => $6528eac3e4eea57e$export$f5438903fac97fd7);
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $aJhEx = parcelRequire("aJhEx");

var $3aOYV = parcelRequire("3aOYV");

var $gwBF5 = parcelRequire("gwBF5");

var $d5vvq = parcelRequire("d5vvq");

var $2XxiF = parcelRequire("2XxiF");
parcelRequire("k2DSm");
var $abEmB = parcelRequire("abEmB");
var $6528eac3e4eea57e$export$86fbec116b87613f = function(x) {
    return x;
};
var $6528eac3e4eea57e$export$993a94e8f319ddca = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(v) {
            return "(App " + (show(v) + ")");
        }
    };
};
var $6528eac3e4eea57e$export$25412483a1d87cf9 = function(dictApply) {
    var lift2 = $26ZCq.lift2(dictApply);
    return function(dictSemigroup) {
        var append1 = $d5vvq.append(dictSemigroup);
        return {
            append: function(v) {
                return function(v1) {
                    return lift2(append1)(v)(v1);
                };
            }
        };
    };
};
var $6528eac3e4eea57e$export$ca15fc0ee645d5ca = function(dictPlus) {
    return dictPlus;
};
var $6528eac3e4eea57e$export$d6896dcb1200915c = {
    Coercible0: function() {
        return undefined;
    }
};
var $6528eac3e4eea57e$export$4d0b678caa24727 = function(dictApplicative) {
    var pure = $bQdkN.pure(dictApplicative);
    var semigroupApp1 = $6528eac3e4eea57e$export$25412483a1d87cf9(dictApplicative.Apply0());
    return function(dictMonoid) {
        var semigroupApp2 = semigroupApp1(dictMonoid.Semigroup0());
        return {
            mempty: pure($3aOYV.mempty(dictMonoid)),
            Semigroup0: function() {
                return semigroupApp2;
            }
        };
    };
};
var $6528eac3e4eea57e$export$5dee9c05ece04940 = function(dictMonadPlus) {
    return dictMonadPlus;
};
var $6528eac3e4eea57e$export$6a01a2292278ad36 = function(dictMonad) {
    return dictMonad;
};
var $6528eac3e4eea57e$export$aef3f1b3df1ccc91 = function(dictLazy) {
    return dictLazy;
};
var $6528eac3e4eea57e$export$74e988bb94b714ec = $abEmB.unsafeCoerce;
var $6528eac3e4eea57e$export$d26bca0552b37bb6 = $abEmB.unsafeCoerce;
var $6528eac3e4eea57e$export$e5247fd078351cb8 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $6528eac3e4eea57e$export$79ab389dc7ad1e04 = function(dictFunctor) {
    return dictFunctor;
};
var $6528eac3e4eea57e$export$4392ba23127b7f7e = function(dictExtend) {
    return dictExtend;
};
var $6528eac3e4eea57e$export$ca57ebaecdc7d318 = function(dictEq1) {
    var eq1 = $aJhEx.eq1(dictEq1);
    return function(dictEq) {
        var eq11 = eq1(dictEq);
        return {
            eq: function(x) {
                return function(y) {
                    return eq11(x)(y);
                };
            }
        };
    };
};
var $6528eac3e4eea57e$export$f5438903fac97fd7 = function(dictOrd1) {
    var compare1 = $gwBF5.compare1(dictOrd1);
    var eqApp1 = $6528eac3e4eea57e$export$ca57ebaecdc7d318(dictOrd1.Eq10());
    return function(dictOrd) {
        var compare11 = compare1(dictOrd);
        var eqApp2 = eqApp1(dictOrd.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    return compare11(x)(y);
                };
            },
            Eq0: function() {
                return eqApp2;
            }
        };
    };
};
var $6528eac3e4eea57e$export$878272f7ccf91d14 = function(dictEq1) {
    var eqApp1 = $6528eac3e4eea57e$export$ca57ebaecdc7d318(dictEq1);
    return {
        eq1: function(dictEq) {
            return $aJhEx.eq(eqApp1(dictEq));
        }
    };
};
var $6528eac3e4eea57e$export$594a740e645fec3d = function(dictOrd1) {
    var ordApp1 = $6528eac3e4eea57e$export$f5438903fac97fd7(dictOrd1);
    var eq1App1 = $6528eac3e4eea57e$export$878272f7ccf91d14(dictOrd1.Eq10());
    return {
        compare1: function(dictOrd) {
            return $gwBF5.compare(ordApp1(dictOrd));
        },
        Eq10: function() {
            return eq1App1;
        }
    };
};
var $6528eac3e4eea57e$export$7470af1a1433fe40 = function(dictComonad) {
    return dictComonad;
};
var $6528eac3e4eea57e$export$a9edb76092ee7d6f = function(dictBind) {
    return dictBind;
};
var $6528eac3e4eea57e$export$e73125860a07eff3 = function(dictApply) {
    return dictApply;
};
var $6528eac3e4eea57e$export$3550db4068efefdd = function(dictApplicative) {
    return dictApplicative;
};
var $6528eac3e4eea57e$export$afc0b729746e2971 = function(dictAlternative) {
    return dictAlternative;
};
var $6528eac3e4eea57e$export$69ee13496a90cde5 = function(dictAlt) {
    return dictAlt;
};

});

parcelRegister("iMzH1", function(module, exports) {

$parcel$export(module.exports, "Compose", () => $dac8658bbfb4a459$export$5a3a146e358e1bcf);
$parcel$export(module.exports, "functorCompose", () => $dac8658bbfb4a459$export$4e14cb014c72d19c);
$parcel$export(module.exports, "applicativeCompose", () => $dac8658bbfb4a459$export$ce6787b8eb4a9f48);
// Generated by purs version 0.15.16

var $56VjJ = parcelRequire("56VjJ");

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $j7FrY = parcelRequire("j7FrY");

var $aJhEx = parcelRequire("aJhEx");

var $7FzSN = parcelRequire("7FzSN");

var $8Gte6 = parcelRequire("8Gte6");

var $gwBF5 = parcelRequire("gwBF5");

var $2XxiF = parcelRequire("2XxiF");
var $dac8658bbfb4a459$export$5a3a146e358e1bcf = function(x) {
    return x;
};
var $dac8658bbfb4a459$export$48988665210796c9 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(v) {
            return "(Compose " + (show(v) + ")");
        }
    };
};
var $dac8658bbfb4a459$export$db82d32400573da6 = {
    Coercible0: function() {
        return undefined;
    }
};
var $dac8658bbfb4a459$export$4e14cb014c72d19c = function(dictFunctor) {
    var map = $7FzSN.map(dictFunctor);
    return function(dictFunctor1) {
        var map1 = $7FzSN.map(dictFunctor1);
        return {
            map: function(f) {
                return function(v) {
                    return map(map1(f))(v);
                };
            }
        };
    };
};
var $dac8658bbfb4a459$export$861bef6ec455b19c = function(dictEq1) {
    var eq1 = $aJhEx.eq1(dictEq1);
    return function(dictEq11) {
        var eqApp = $8Gte6.eqApp(dictEq11);
        return function(dictEq) {
            var eq11 = eq1(eqApp(dictEq));
            return {
                eq: function(v) {
                    return function(v1) {
                        return eq11($8Gte6.hoistLiftApp(v))($8Gte6.hoistLiftApp(v1));
                    };
                }
            };
        };
    };
};
var $dac8658bbfb4a459$export$71b54a761b111692 = function(dictOrd1) {
    var compare1 = $gwBF5.compare1(dictOrd1);
    var eqCompose1 = $dac8658bbfb4a459$export$861bef6ec455b19c(dictOrd1.Eq10());
    return function(dictOrd11) {
        var ordApp = $8Gte6.ordApp(dictOrd11);
        var eqCompose2 = eqCompose1(dictOrd11.Eq10());
        return function(dictOrd) {
            var compare11 = compare1(ordApp(dictOrd));
            var eqCompose3 = eqCompose2(dictOrd.Eq0());
            return {
                compare: function(v) {
                    return function(v1) {
                        return compare11($8Gte6.hoistLiftApp(v))($8Gte6.hoistLiftApp(v1));
                    };
                },
                Eq0: function() {
                    return eqCompose3;
                }
            };
        };
    };
};
var $dac8658bbfb4a459$export$cbe2b7f63279884c = function(dictEq1) {
    var eqCompose1 = $dac8658bbfb4a459$export$861bef6ec455b19c(dictEq1);
    return function(dictEq11) {
        var eqCompose2 = eqCompose1(dictEq11);
        return {
            eq1: function(dictEq) {
                return $aJhEx.eq(eqCompose2(dictEq));
            }
        };
    };
};
var $dac8658bbfb4a459$export$d435219eb92d4b50 = function(dictOrd1) {
    var ordCompose1 = $dac8658bbfb4a459$export$71b54a761b111692(dictOrd1);
    var eq1Compose1 = $dac8658bbfb4a459$export$cbe2b7f63279884c(dictOrd1.Eq10());
    return function(dictOrd11) {
        var ordCompose2 = ordCompose1(dictOrd11);
        var eq1Compose2 = eq1Compose1(dictOrd11.Eq10());
        return {
            compare1: function(dictOrd) {
                return $gwBF5.compare(ordCompose2(dictOrd));
            },
            Eq10: function() {
                return eq1Compose2;
            }
        };
    };
};
var $dac8658bbfb4a459$export$6ac747c53920df53 = function(dictFunctor) {
    var map = $7FzSN.map(dictFunctor);
    return function(natF) {
        return function(natG) {
            return function(v) {
                return natF(map(natG)(v));
            };
        };
    };
};
var $dac8658bbfb4a459$export$6b631277dc31d20d = function(dictApply) {
    var apply = $26ZCq.apply(dictApply);
    var Functor0 = dictApply.Functor0();
    var map = $7FzSN.map(Functor0);
    var functorCompose1 = $dac8658bbfb4a459$export$4e14cb014c72d19c(Functor0);
    return function(dictApply1) {
        var apply1 = $26ZCq.apply(dictApply1);
        var functorCompose2 = functorCompose1(dictApply1.Functor0());
        return {
            apply: function(v) {
                return function(v1) {
                    return apply(map(apply1)(v))(v1);
                };
            },
            Functor0: function() {
                return functorCompose2;
            }
        };
    };
};
var $dac8658bbfb4a459$export$ce6787b8eb4a9f48 = function(dictApplicative) {
    var pure = $bQdkN.pure(dictApplicative);
    var applyCompose1 = $dac8658bbfb4a459$export$6b631277dc31d20d(dictApplicative.Apply0());
    return function(dictApplicative1) {
        var applyCompose2 = applyCompose1(dictApplicative1.Apply0());
        return {
            pure: function() {
                var $112 = $bQdkN.pure(dictApplicative1);
                return function($113) {
                    return $dac8658bbfb4a459$export$5a3a146e358e1bcf(pure($112($113)));
                };
            }(),
            Apply0: function() {
                return applyCompose2;
            }
        };
    };
};
var $dac8658bbfb4a459$export$b9fb31044795461 = function(dictAlt) {
    var alt = $56VjJ.alt(dictAlt);
    var functorCompose1 = $dac8658bbfb4a459$export$4e14cb014c72d19c(dictAlt.Functor0());
    return function(dictFunctor) {
        var functorCompose2 = functorCompose1(dictFunctor);
        return {
            alt: function(v) {
                return function(v1) {
                    return alt(v)(v1);
                };
            },
            Functor0: function() {
                return functorCompose2;
            }
        };
    };
};
var $dac8658bbfb4a459$export$2f025d423e425357 = function(dictPlus) {
    var empty = $j7FrY.empty(dictPlus);
    var altCompose1 = $dac8658bbfb4a459$export$b9fb31044795461(dictPlus.Alt0());
    return function(dictFunctor) {
        var altCompose2 = altCompose1(dictFunctor);
        return {
            empty: empty,
            Alt0: function() {
                return altCompose2;
            }
        };
    };
};
var $dac8658bbfb4a459$export$3bf64fe887e680d3 = function(dictAlternative) {
    var applicativeCompose1 = $dac8658bbfb4a459$export$ce6787b8eb4a9f48(dictAlternative.Applicative0());
    var plusCompose1 = $dac8658bbfb4a459$export$2f025d423e425357(dictAlternative.Plus1());
    return function(dictApplicative) {
        var applicativeCompose2 = applicativeCompose1(dictApplicative);
        var plusCompose2 = plusCompose1(dictApplicative.Apply0().Functor0());
        return {
            Applicative0: function() {
                return applicativeCompose2;
            },
            Plus1: function() {
                return plusCompose2;
            }
        };
    };
};

});

parcelRegister("6dOpK", function(module, exports) {

$parcel$export(module.exports, "product", () => $487b102e47ad4962$export$dbd0f18357df1ddd);
$parcel$export(module.exports, "functorProduct", () => $487b102e47ad4962$export$e5b52224642d1f48);
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $5ZwWo = parcelRequire("5ZwWo");

var $aJhEx = parcelRequire("aJhEx");

var $7FzSN = parcelRequire("7FzSN");

var $46y1S = parcelRequire("46y1S");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $2XxiF = parcelRequire("2XxiF");

var $7O0Q4 = parcelRequire("7O0Q4");
var $487b102e47ad4962$var$bimap = /* #__PURE__ */ $5ZwWo.bimap($5ZwWo.bifunctorTuple);
var $487b102e47ad4962$var$unwrap = /* #__PURE__ */ $46y1S.unwrap();
var $487b102e47ad4962$export$264ad599d7cef668 = function(x) {
    return x;
};
var $487b102e47ad4962$export$821c121fea76e4f5 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return function(dictShow1) {
        var show1 = $2XxiF.show(dictShow1);
        return {
            show: function(v) {
                return "(product " + (show(v.value0) + (" " + (show1(v.value1) + ")")));
            }
        };
    };
};
var $487b102e47ad4962$export$dbd0f18357df1ddd = function(fa) {
    return function(ga) {
        return new $7O0Q4.Tuple(fa, ga);
    };
};
var $487b102e47ad4962$export$7ea85e95f1a9febc = {
    Coercible0: function() {
        return undefined;
    }
};
var $487b102e47ad4962$export$e5b52224642d1f48 = function(dictFunctor) {
    var map = $7FzSN.map(dictFunctor);
    return function(dictFunctor1) {
        var map1 = $7FzSN.map(dictFunctor1);
        return {
            map: function(f) {
                return function(v) {
                    return $487b102e47ad4962$var$bimap(map(f))(map1(f))(v);
                };
            }
        };
    };
};
var $487b102e47ad4962$export$df541bd41566d1a7 = function(dictEq1) {
    var eq1 = $aJhEx.eq1(dictEq1);
    return function(dictEq11) {
        var eq11 = $aJhEx.eq1(dictEq11);
        return {
            eq1: function(dictEq) {
                var eq12 = eq1(dictEq);
                var eq13 = eq11(dictEq);
                return function(v) {
                    return function(v1) {
                        return eq12(v.value0)(v1.value0) && eq13(v.value1)(v1.value1);
                    };
                };
            }
        };
    };
};
var $487b102e47ad4962$export$e82658b20fc49a26 = function(dictEq1) {
    var eq1Product1 = $487b102e47ad4962$export$df541bd41566d1a7(dictEq1);
    return function(dictEq11) {
        var eq1 = $aJhEx.eq1(eq1Product1(dictEq11));
        return function(dictEq) {
            return {
                eq: eq1(dictEq)
            };
        };
    };
};
var $487b102e47ad4962$export$b9dd7b4b85c7c1b7 = function(dictOrd1) {
    var compare1 = $gwBF5.compare1(dictOrd1);
    var eq1Product1 = $487b102e47ad4962$export$df541bd41566d1a7(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare11 = $gwBF5.compare1(dictOrd11);
        var eq1Product2 = eq1Product1(dictOrd11.Eq10());
        return {
            compare1: function(dictOrd) {
                var compare12 = compare1(dictOrd);
                var compare13 = compare11(dictOrd);
                return function(v) {
                    return function(v1) {
                        var v2 = compare12(v.value0)(v1.value0);
                        if (v2 instanceof $ibsD5.EQ) return compare13(v.value1)(v1.value1);
                        return v2;
                    };
                };
            },
            Eq10: function() {
                return eq1Product2;
            }
        };
    };
};
var $487b102e47ad4962$export$96856f3fc4c91454 = function(dictOrd1) {
    var ord1Product1 = $487b102e47ad4962$export$b9dd7b4b85c7c1b7(dictOrd1);
    var eqProduct1 = $487b102e47ad4962$export$e82658b20fc49a26(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare1 = $gwBF5.compare1(ord1Product1(dictOrd11));
        var eqProduct2 = eqProduct1(dictOrd11.Eq10());
        return function(dictOrd) {
            var eqProduct3 = eqProduct2(dictOrd.Eq0());
            return {
                compare: compare1(dictOrd),
                Eq0: function() {
                    return eqProduct3;
                }
            };
        };
    };
};
var $487b102e47ad4962$export$a3738445608c58d6 = function(natF) {
    return function(natG) {
        return function(v) {
            return $487b102e47ad4962$var$bimap(natF)(natG)(v);
        };
    };
};
var $487b102e47ad4962$export$893d0f454e6dfaee = function(dictApply) {
    var apply = $26ZCq.apply(dictApply);
    var functorProduct1 = $487b102e47ad4962$export$e5b52224642d1f48(dictApply.Functor0());
    return function(dictApply1) {
        var apply1 = $26ZCq.apply(dictApply1);
        var functorProduct2 = functorProduct1(dictApply1.Functor0());
        return {
            apply: function(v) {
                return function(v1) {
                    return $487b102e47ad4962$export$dbd0f18357df1ddd(apply(v.value0)(v1.value0))(apply1(v.value1)(v1.value1));
                };
            },
            Functor0: function() {
                return functorProduct2;
            }
        };
    };
};
var $487b102e47ad4962$export$5990c3ca6a566877 = function(dictBind) {
    var bind = $cADnC.bind(dictBind);
    var applyProduct1 = $487b102e47ad4962$export$893d0f454e6dfaee(dictBind.Apply0());
    return function(dictBind1) {
        var bind1 = $cADnC.bind(dictBind1);
        var applyProduct2 = applyProduct1(dictBind1.Apply0());
        return {
            bind: function(v) {
                return function(f) {
                    return $487b102e47ad4962$export$dbd0f18357df1ddd(bind(v.value0)(function($128) {
                        return $7O0Q4.fst($487b102e47ad4962$var$unwrap(f($128)));
                    }))(bind1(v.value1)(function($129) {
                        return $7O0Q4.snd($487b102e47ad4962$var$unwrap(f($129)));
                    }));
                };
            },
            Apply0: function() {
                return applyProduct2;
            }
        };
    };
};
var $487b102e47ad4962$export$2034ae3acf01a9af = function(dictApplicative) {
    var pure = $bQdkN.pure(dictApplicative);
    var applyProduct1 = $487b102e47ad4962$export$893d0f454e6dfaee(dictApplicative.Apply0());
    return function(dictApplicative1) {
        var pure1 = $bQdkN.pure(dictApplicative1);
        var applyProduct2 = applyProduct1(dictApplicative1.Apply0());
        return {
            pure: function(a) {
                return $487b102e47ad4962$export$dbd0f18357df1ddd(pure(a))(pure1(a));
            },
            Apply0: function() {
                return applyProduct2;
            }
        };
    };
};
var $487b102e47ad4962$export$2dfe129c60aea5cb = function(dictMonad) {
    var applicativeProduct1 = $487b102e47ad4962$export$2034ae3acf01a9af(dictMonad.Applicative0());
    var bindProduct1 = $487b102e47ad4962$export$5990c3ca6a566877(dictMonad.Bind1());
    return function(dictMonad1) {
        var applicativeProduct2 = applicativeProduct1(dictMonad1.Applicative0());
        var bindProduct2 = bindProduct1(dictMonad1.Bind1());
        return {
            Applicative0: function() {
                return applicativeProduct2;
            },
            Bind1: function() {
                return bindProduct2;
            }
        };
    };
};

});

parcelRegister("kobBf", function(module, exports) {

$parcel$export(module.exports, "Last", () => $ed7f0bff2b7d168c$export$bed9238d8933c9a8);
$parcel$export(module.exports, "functorLast", () => $ed7f0bff2b7d168c$export$74aba74241121413);
// Generated by purs version 0.15.16

var $h2xUu = parcelRequire("h2xUu");

var $3aOYV = parcelRequire("3aOYV");

var $d5vvq = parcelRequire("d5vvq");

var $2XxiF = parcelRequire("2XxiF");
var $ed7f0bff2b7d168c$export$bed9238d8933c9a8 = function(x) {
    return x;
};
var $ed7f0bff2b7d168c$export$1e0d830d3054d46d = function(dictShow) {
    var show = $2XxiF.show($h2xUu.showMaybe(dictShow));
    return {
        show: function(v) {
            return "(Last " + (show(v) + ")");
        }
    };
};
var $ed7f0bff2b7d168c$export$6d3c4648150c5bae = {
    append: function(v) {
        return function(v1) {
            if (v1 instanceof $h2xUu.Just) return v1;
            if (v1 instanceof $h2xUu.Nothing) return v;
            throw new Error("Failed pattern match at Data.Maybe.Last (line 54, column 1 - line 56, column 36): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $ed7f0bff2b7d168c$export$4ded69d4b0c99b7b = function(dictOrd) {
    return $h2xUu.ordMaybe(dictOrd);
};
var $ed7f0bff2b7d168c$export$64bd44ceff2f4638 = $h2xUu.ord1Maybe;
var $ed7f0bff2b7d168c$export$ccaccac244187f64 = {
    Coercible0: function() {
        return undefined;
    }
};
var $ed7f0bff2b7d168c$export$862bb074dbe2690f = /* #__PURE__ */ function() {
    return {
        mempty: $h2xUu.Nothing.value,
        Semigroup0: function() {
            return $ed7f0bff2b7d168c$export$6d3c4648150c5bae;
        }
    };
}();
var $ed7f0bff2b7d168c$export$25d122cd3cbaf721 = $h2xUu.monadMaybe;
var $ed7f0bff2b7d168c$export$21558e167578c47d = $h2xUu.invariantMaybe;
var $ed7f0bff2b7d168c$export$74aba74241121413 = $h2xUu.functorMaybe;
var $ed7f0bff2b7d168c$export$7f096d1e61d1725f = $h2xUu.extendMaybe;
var $ed7f0bff2b7d168c$export$4dd70ef4fbe4d1f3 = function(dictEq) {
    return $h2xUu.eqMaybe(dictEq);
};
var $ed7f0bff2b7d168c$export$634a54207b73ac14 = $h2xUu.eq1Maybe;
var $ed7f0bff2b7d168c$export$835f68c2f339b021 = function(dictBounded) {
    return $h2xUu.boundedMaybe(dictBounded);
};
var $ed7f0bff2b7d168c$export$f2b93d1f1ac78d51 = $h2xUu.bindMaybe;
var $ed7f0bff2b7d168c$export$dcd798c84777f95 = $h2xUu.applyMaybe;
var $ed7f0bff2b7d168c$export$5b4de68c5dd33934 = $h2xUu.applicativeMaybe;
var $ed7f0bff2b7d168c$export$a0374697fe7c8648 = {
    alt: /* #__PURE__ */ $d5vvq.append($ed7f0bff2b7d168c$export$6d3c4648150c5bae),
    Functor0: function() {
        return $ed7f0bff2b7d168c$export$74aba74241121413;
    }
};
var $ed7f0bff2b7d168c$export$1bb9770eb80691dd = {
    empty: /* #__PURE__ */ $3aOYV.mempty($ed7f0bff2b7d168c$export$862bb074dbe2690f),
    Alt0: function() {
        return $ed7f0bff2b7d168c$export$a0374697fe7c8648;
    }
};
var $ed7f0bff2b7d168c$export$bc87013f8f3da20e = {
    Applicative0: function() {
        return $ed7f0bff2b7d168c$export$5b4de68c5dd33934;
    },
    Plus1: function() {
        return $ed7f0bff2b7d168c$export$1bb9770eb80691dd;
    }
};

});

parcelRegister("6UiNT", function(module, exports) {

$parcel$export(module.exports, "Additive", () => $50768f12684b6136$export$14f8ce08180a98e1);
$parcel$export(module.exports, "functorAdditive", () => $50768f12684b6136$export$ba106ed6ee21ba26);
// Generated by purs version 0.15.16

var $aJhEx = parcelRequire("aJhEx");

var $gwBF5 = parcelRequire("gwBF5");

var $iVjQa = parcelRequire("iVjQa");

var $2XxiF = parcelRequire("2XxiF");
var $50768f12684b6136$export$14f8ce08180a98e1 = function(x) {
    return x;
};
var $50768f12684b6136$export$d0709814982cbf95 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(v) {
            return "(Additive " + (show(v) + ")");
        }
    };
};
var $50768f12684b6136$export$8adb2de2291fe34 = function(dictSemiring) {
    var add = $iVjQa.add(dictSemiring);
    return {
        append: function(v) {
            return function(v1) {
                return add(v)(v1);
            };
        }
    };
};
var $50768f12684b6136$export$45e15fb7ca2189d8 = function(dictOrd) {
    return dictOrd;
};
var $50768f12684b6136$export$c38b62d29991685f = function(dictSemiring) {
    var semigroupAdditive1 = $50768f12684b6136$export$8adb2de2291fe34(dictSemiring);
    return {
        mempty: $iVjQa.zero(dictSemiring),
        Semigroup0: function() {
            return semigroupAdditive1;
        }
    };
};
var $50768f12684b6136$export$ba106ed6ee21ba26 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $50768f12684b6136$export$7e0cae55dbdaa6a6 = function(dictEq) {
    return dictEq;
};
var $50768f12684b6136$export$3bc4d3e676a5f3ba = {
    eq1: function(dictEq) {
        return $aJhEx.eq($50768f12684b6136$export$7e0cae55dbdaa6a6(dictEq));
    }
};
var $50768f12684b6136$export$bf0109c88461ccc9 = {
    compare1: function(dictOrd) {
        return $gwBF5.compare($50768f12684b6136$export$45e15fb7ca2189d8(dictOrd));
    },
    Eq10: function() {
        return $50768f12684b6136$export$3bc4d3e676a5f3ba;
    }
};
var $50768f12684b6136$export$ac1ed4a2f2107898 = function(dictBounded) {
    return dictBounded;
};
var $50768f12684b6136$export$9ed13d4e91f74d66 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $50768f12684b6136$export$ba106ed6ee21ba26;
    }
};
var $50768f12684b6136$export$3c0293aa90d839fe = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $50768f12684b6136$export$9ed13d4e91f74d66;
    }
};
var $50768f12684b6136$export$3f78fbeb96209a2 = {
    pure: $50768f12684b6136$export$14f8ce08180a98e1,
    Apply0: function() {
        return $50768f12684b6136$export$9ed13d4e91f74d66;
    }
};
var $50768f12684b6136$export$50439d128d692efb = {
    Applicative0: function() {
        return $50768f12684b6136$export$3f78fbeb96209a2;
    },
    Bind1: function() {
        return $50768f12684b6136$export$3c0293aa90d839fe;
    }
};

});

parcelRegister("laciu", function(module, exports) {

$parcel$export(module.exports, "Multiplicative", () => $f6841223bf5172f2$export$d0198c9c86fc2be1);
$parcel$export(module.exports, "functorMultiplicative", () => $f6841223bf5172f2$export$fb489b392661d391);
// Generated by purs version 0.15.16

var $aJhEx = parcelRequire("aJhEx");

var $gwBF5 = parcelRequire("gwBF5");

var $iVjQa = parcelRequire("iVjQa");

var $2XxiF = parcelRequire("2XxiF");
var $f6841223bf5172f2$export$d0198c9c86fc2be1 = function(x) {
    return x;
};
var $f6841223bf5172f2$export$27987c20bfe6da1c = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(v) {
            return "(Multiplicative " + (show(v) + ")");
        }
    };
};
var $f6841223bf5172f2$export$879165283e0876da = function(dictSemiring) {
    var mul = $iVjQa.mul(dictSemiring);
    return {
        append: function(v) {
            return function(v1) {
                return mul(v)(v1);
            };
        }
    };
};
var $f6841223bf5172f2$export$a745aa1873a0c2a6 = function(dictOrd) {
    return dictOrd;
};
var $f6841223bf5172f2$export$b1fd47ce92821578 = function(dictSemiring) {
    var semigroupMultiplicative1 = $f6841223bf5172f2$export$879165283e0876da(dictSemiring);
    return {
        mempty: $iVjQa.one(dictSemiring),
        Semigroup0: function() {
            return semigroupMultiplicative1;
        }
    };
};
var $f6841223bf5172f2$export$fb489b392661d391 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $f6841223bf5172f2$export$d7079d8ae90b8bb4 = function(dictEq) {
    return dictEq;
};
var $f6841223bf5172f2$export$989c1e5544f0c166 = {
    eq1: function(dictEq) {
        return $aJhEx.eq($f6841223bf5172f2$export$d7079d8ae90b8bb4(dictEq));
    }
};
var $f6841223bf5172f2$export$fecaa24314ae6d78 = {
    compare1: function(dictOrd) {
        return $gwBF5.compare($f6841223bf5172f2$export$a745aa1873a0c2a6(dictOrd));
    },
    Eq10: function() {
        return $f6841223bf5172f2$export$989c1e5544f0c166;
    }
};
var $f6841223bf5172f2$export$bbf6fde3198eeb4e = function(dictBounded) {
    return dictBounded;
};
var $f6841223bf5172f2$export$4270b48d12c8e2c9 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $f6841223bf5172f2$export$fb489b392661d391;
    }
};
var $f6841223bf5172f2$export$b787e2c352a5d886 = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $f6841223bf5172f2$export$4270b48d12c8e2c9;
    }
};
var $f6841223bf5172f2$export$98fc700c14e70ff0 = {
    pure: $f6841223bf5172f2$export$d0198c9c86fc2be1,
    Apply0: function() {
        return $f6841223bf5172f2$export$4270b48d12c8e2c9;
    }
};
var $f6841223bf5172f2$export$8980d206f063bc12 = {
    Applicative0: function() {
        return $f6841223bf5172f2$export$98fc700c14e70ff0;
    },
    Bind1: function() {
        return $f6841223bf5172f2$export$b787e2c352a5d886;
    }
};

});

parcelRegister("lVswN", function(module, exports) {
// Generated by purs version 0.15.16

});

parcelRegister("dazHc", function(module, exports) {

$parcel$export(module.exports, "stateR", () => $9967e5fb3b1e1f85$export$8c9fed8401f25951);
$parcel$export(module.exports, "stateL", () => $9967e5fb3b1e1f85$export$25c41c6231a79e25);
$parcel$export(module.exports, "applicativeStateR", () => $9967e5fb3b1e1f85$export$c4ee441de2fba0d9);
$parcel$export(module.exports, "applicativeStateL", () => $9967e5fb3b1e1f85$export$9fd2229713491b84);
// Generated by purs version 0.15.16
var $9967e5fb3b1e1f85$export$e55c55b7b44ad601 = function(x) {
    return x;
};
var $9967e5fb3b1e1f85$export$28dda4bfb631a565 = function(x) {
    return x;
};
var $9967e5fb3b1e1f85$export$8c9fed8401f25951 = function(v) {
    return v;
};
var $9967e5fb3b1e1f85$export$25c41c6231a79e25 = function(v) {
    return v;
};
var $9967e5fb3b1e1f85$export$c9b79b3c57c3d6cd = {
    map: function(f) {
        return function(k) {
            return function(s) {
                var v = $9967e5fb3b1e1f85$export$8c9fed8401f25951(k)(s);
                return {
                    accum: v.accum,
                    value: f(v.value)
                };
            };
        };
    }
};
var $9967e5fb3b1e1f85$export$b9d5be898ea82056 = {
    map: function(f) {
        return function(k) {
            return function(s) {
                var v = $9967e5fb3b1e1f85$export$25c41c6231a79e25(k)(s);
                return {
                    accum: v.accum,
                    value: f(v.value)
                };
            };
        };
    }
};
var $9967e5fb3b1e1f85$export$68347817ab3710ea = {
    apply: function(f) {
        return function(x) {
            return function(s) {
                var v = $9967e5fb3b1e1f85$export$8c9fed8401f25951(x)(s);
                var v1 = $9967e5fb3b1e1f85$export$8c9fed8401f25951(f)(v.accum);
                return {
                    accum: v1.accum,
                    value: v1.value(v.value)
                };
            };
        };
    },
    Functor0: function() {
        return $9967e5fb3b1e1f85$export$c9b79b3c57c3d6cd;
    }
};
var $9967e5fb3b1e1f85$export$d997dc0aadd0b300 = {
    apply: function(f) {
        return function(x) {
            return function(s) {
                var v = $9967e5fb3b1e1f85$export$25c41c6231a79e25(f)(s);
                var v1 = $9967e5fb3b1e1f85$export$25c41c6231a79e25(x)(v.accum);
                return {
                    accum: v1.accum,
                    value: v.value(v1.value)
                };
            };
        };
    },
    Functor0: function() {
        return $9967e5fb3b1e1f85$export$b9d5be898ea82056;
    }
};
var $9967e5fb3b1e1f85$export$c4ee441de2fba0d9 = {
    pure: function(a) {
        return function(s) {
            return {
                accum: s,
                value: a
            };
        };
    },
    Apply0: function() {
        return $9967e5fb3b1e1f85$export$68347817ab3710ea;
    }
};
var $9967e5fb3b1e1f85$export$9fd2229713491b84 = {
    pure: function(a) {
        return function(s) {
            return {
                accum: s,
                value: a
            };
        };
    },
    Apply0: function() {
        return $9967e5fb3b1e1f85$export$d997dc0aadd0b300;
    }
};

});


parcelRegister("goKHx", function(module, exports) {

$parcel$export(module.exports, "unfoldr", () => $bf031d1a192d742b$export$df2b8ee1690308ae);
$parcel$export(module.exports, "unfoldableArray", () => $bf031d1a192d742b$export$2b90ca20b4b58da5);
$parcel$export(module.exports, "replicate", () => $bf031d1a192d742b$export$606959e7ccb797f0);
$parcel$export(module.exports, "none", () => $bf031d1a192d742b$export$f883a24d5edde77c);
// Generated by purs version 0.15.16

var $5Cgs0 = parcelRequire("5Cgs0");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $9OOYG = parcelRequire("9OOYG");

var $7O0Q4 = parcelRequire("7O0Q4");

var $N3bwb = parcelRequire("N3bwb");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
var $bf031d1a192d742b$var$map = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $bf031d1a192d742b$var$fromJust = /* #__PURE__ */ $h2xUu.fromJust();
var $bf031d1a192d742b$export$df2b8ee1690308ae = function(dict) {
    return dict.unfoldr;
};
var $bf031d1a192d742b$export$b5169c61b27df85a = {
    unfoldr: function(f) {
        return function(b) {
            return $bf031d1a192d742b$var$map($7O0Q4.fst)(f(b));
        };
    },
    Unfoldable10: function() {
        return $N3bwb.unfoldable1Maybe;
    }
};
var $bf031d1a192d742b$export$2b90ca20b4b58da5 = {
    unfoldr: /* #__PURE__ */ $5Cgs0.unfoldrArrayImpl($h2xUu.isNothing)($bf031d1a192d742b$var$fromJust)($7O0Q4.fst)($7O0Q4.snd),
    Unfoldable10: function() {
        return $N3bwb.unfoldable1Array;
    }
};
var $bf031d1a192d742b$export$606959e7ccb797f0 = function(dictUnfoldable) {
    var unfoldr1 = $bf031d1a192d742b$export$df2b8ee1690308ae(dictUnfoldable);
    return function(n) {
        return function(v) {
            var step = function(i) {
                var $17 = i <= 0;
                if ($17) return $h2xUu.Nothing.value;
                return new $h2xUu.Just(new $7O0Q4.Tuple(v, i - 1 | 0));
            };
            return unfoldr1(step)(n);
        };
    };
};
var $bf031d1a192d742b$export$1e1bbcb33c108a24 = function(dictApplicative) {
    return function(dictUnfoldable) {
        var replicate1 = $bf031d1a192d742b$export$606959e7ccb797f0(dictUnfoldable);
        return function(dictTraversable) {
            var sequence = $9OOYG.sequence(dictTraversable)(dictApplicative);
            return function(n) {
                return function(m) {
                    return sequence(replicate1(n)(m));
                };
            };
        };
    };
};
var $bf031d1a192d742b$export$f883a24d5edde77c = function(dictUnfoldable) {
    return $bf031d1a192d742b$export$df2b8ee1690308ae(dictUnfoldable)($jhsiw.const($h2xUu.Nothing.value))($ivFwO.unit);
};
var $bf031d1a192d742b$export$43db023a260c5e9f = function(dictUnfoldable) {
    return $bf031d1a192d742b$export$df2b8ee1690308ae(dictUnfoldable)(function(b) {
        return $bf031d1a192d742b$var$map($jhsiw.flip($7O0Q4.Tuple.create)($h2xUu.Nothing.value))(b);
    });
};

});
parcelRegister("5Cgs0", function(module, exports) {

$parcel$export(module.exports, "unfoldrArrayImpl", () => $416d4321700d9abd$export$6368c6d238d348f0);
const $416d4321700d9abd$export$6368c6d238d348f0 = function(isNothing) {
    return function(fromJust) {
        return function(fst) {
            return function(snd) {
                return function(f) {
                    return function(b) {
                        var result = [];
                        var value = b;
                        while(true){
                            var maybe = f(value);
                            if (isNothing(maybe)) return result;
                            var tuple = fromJust(maybe);
                            result.push(fst(tuple));
                            value = snd(tuple);
                        }
                    };
                };
            };
        };
    };
};

});

parcelRegister("N3bwb", function(module, exports) {

$parcel$export(module.exports, "unfoldr1", () => $09370c25eb6d9d22$export$158c052536266a97);
$parcel$export(module.exports, "unfoldable1Maybe", () => $09370c25eb6d9d22$export$b5ac0a9881e433c3);
$parcel$export(module.exports, "unfoldable1Array", () => $09370c25eb6d9d22$export$587ba9a9bf3cf8b4);
$parcel$export(module.exports, "singleton", () => $09370c25eb6d9d22$export$439306a4dcaafbb9);
// Generated by purs version 0.15.16

var $7JJQH = parcelRequire("7JJQH");

var $iQTlW = parcelRequire("iQTlW");

var $h2xUu = parcelRequire("h2xUu");

var $6ywL5 = parcelRequire("6ywL5");

var $7O0Q4 = parcelRequire("7O0Q4");
var $09370c25eb6d9d22$var$fromJust = /* #__PURE__ */ $h2xUu.fromJust();
var $09370c25eb6d9d22$export$158c052536266a97 = function(dict) {
    return dict.unfoldr1;
};
var $09370c25eb6d9d22$export$b5ac0a9881e433c3 = {
    unfoldr1: function(f) {
        return function(b) {
            return new $h2xUu.Just($7O0Q4.fst(f(b)));
        };
    }
};
var $09370c25eb6d9d22$export$587ba9a9bf3cf8b4 = {
    unfoldr1: /* #__PURE__ */ $7JJQH.unfoldr1ArrayImpl($h2xUu.isNothing)($09370c25eb6d9d22$var$fromJust)($7O0Q4.fst)($7O0Q4.snd)
};
var $09370c25eb6d9d22$export$dcb5d70039e504cd = function(dictUnfoldable1) {
    var unfoldr11 = $09370c25eb6d9d22$export$158c052536266a97(dictUnfoldable1);
    return function(n) {
        return function(v) {
            var step = function(i) {
                if (i <= 0) return new $7O0Q4.Tuple(v, $h2xUu.Nothing.value);
                if ($iQTlW.otherwise) return new $7O0Q4.Tuple(v, new $h2xUu.Just(i - 1 | 0));
                throw new Error("Failed pattern match at Data.Unfoldable1 (line 68, column 5 - line 68, column 39): " + [
                    i.constructor.name
                ]);
            };
            return unfoldr11(step)(n - 1 | 0);
        };
    };
};
var $09370c25eb6d9d22$export$d2a13fab7d8f2b56 = function(dictApply) {
    return function(dictUnfoldable1) {
        var replicate11 = $09370c25eb6d9d22$export$dcb5d70039e504cd(dictUnfoldable1);
        return function(dictTraversable1) {
            var sequence1 = $6ywL5.sequence1(dictTraversable1)(dictApply);
            return function(n) {
                return function(m) {
                    return sequence1(replicate11(n)(m));
                };
            };
        };
    };
};
var $09370c25eb6d9d22$export$439306a4dcaafbb9 = function(dictUnfoldable1) {
    return $09370c25eb6d9d22$export$dcb5d70039e504cd(dictUnfoldable1)(1);
};
var $09370c25eb6d9d22$export$d02631cccf789723 = function(dictUnfoldable1) {
    var unfoldr11 = $09370c25eb6d9d22$export$158c052536266a97(dictUnfoldable1);
    return function(start) {
        return function(end) {
            var go = function(delta) {
                return function(i) {
                    var i$prime = i + delta | 0;
                    return new $7O0Q4.Tuple(i, function() {
                        var $25 = i === end;
                        if ($25) return $h2xUu.Nothing.value;
                        return new $h2xUu.Just(i$prime);
                    }());
                };
            };
            var delta = function() {
                var $26 = end >= start;
                if ($26) return 1;
                return -1;
            }();
            return unfoldr11(go(delta))(start);
        };
    };
};
var $09370c25eb6d9d22$export$f1977d76a1a6e399 = function(dictUnfoldable1) {
    var unfoldr11 = $09370c25eb6d9d22$export$158c052536266a97(dictUnfoldable1);
    return function(n) {
        return function(f) {
            return function(s) {
                var go = function(v) {
                    return new $7O0Q4.Tuple(v.value0, function() {
                        var $28 = v.value1 > 0;
                        if ($28) return new $h2xUu.Just(new $7O0Q4.Tuple(f(v.value0), v.value1 - 1 | 0));
                        return $h2xUu.Nothing.value;
                    }());
                };
                return unfoldr11(go)(new $7O0Q4.Tuple(s, n - 1 | 0));
            };
        };
    };
};

});
parcelRegister("7JJQH", function(module, exports) {

$parcel$export(module.exports, "unfoldr1ArrayImpl", () => $5a204d0aa4d36328$export$e3753a19e82ccedc);
const $5a204d0aa4d36328$export$e3753a19e82ccedc = function(isNothing) {
    return function(fromJust) {
        return function(fst) {
            return function(snd) {
                return function(f) {
                    return function(b) {
                        var result = [];
                        var value = b;
                        while(true){
                            var tuple = f(value);
                            result.push(fst(tuple));
                            var maybe = snd(tuple);
                            if (isNothing(maybe)) return result;
                            value = fromJust(maybe);
                        }
                    };
                };
            };
        };
    };
};

});

parcelRegister("6ywL5", function(module, exports) {

$parcel$export(module.exports, "traverse1", () => $4c5f543936d3c7d7$export$d2990bb35e0a3e00);
$parcel$export(module.exports, "sequence1", () => $4c5f543936d3c7d7$export$6deffb29affc84c6);
// Generated by purs version 0.15.16

var $26SV5 = parcelRequire("26SV5");

var $7FzSN = parcelRequire("7FzSN");

var $8pkky = parcelRequire("8pkky");

var $53NY2 = parcelRequire("53NY2");

var $laciu = parcelRequire("laciu");

var $kAvps = parcelRequire("kAvps");

var $9OOYG = parcelRequire("9OOYG");

var $7O0Q4 = parcelRequire("7O0Q4");
var $4c5f543936d3c7d7$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $4c5f543936d3c7d7$export$d2990bb35e0a3e00 = function(dict) {
    return dict.traverse1;
};
var $4c5f543936d3c7d7$export$d35878ee42638401 = {
    traverse1: function(dictApply) {
        var map = $7FzSN.map(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($7O0Q4.Tuple.create(v.value0))(f(v.value1));
            };
        };
    },
    sequence1: function(dictApply) {
        var map = $7FzSN.map(dictApply.Functor0());
        return function(v) {
            return map($7O0Q4.Tuple.create(v.value0))(v.value1);
        };
    },
    Foldable10: function() {
        return $kAvps.foldableTuple;
    },
    Traversable1: function() {
        return $9OOYG.traversableTuple;
    }
};
var $4c5f543936d3c7d7$export$63e84f34fb558532 = {
    traverse1: function(dictApply) {
        var map = $7FzSN.map(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($8pkky.Identity)(f(v));
            };
        };
    },
    sequence1: function(dictApply) {
        var map = $7FzSN.map(dictApply.Functor0());
        return function(v) {
            return map($8pkky.Identity)(v);
        };
    },
    Foldable10: function() {
        return $kAvps.foldableIdentity;
    },
    Traversable1: function() {
        return $9OOYG.traversableIdentity;
    }
};
var $4c5f543936d3c7d7$export$c8ca5446ba1698 = function(dictTraversable1) {
    var traverse11 = $4c5f543936d3c7d7$export$d2990bb35e0a3e00(dictTraversable1);
    return function(dictApply) {
        return traverse11(dictApply)($4c5f543936d3c7d7$var$identity);
    };
};
var $4c5f543936d3c7d7$export$54df524caf88dbea = {
    traverse1: function(dictApply) {
        var map = $7FzSN.map(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($53NY2.Dual)(f(v));
            };
        };
    },
    sequence1: function(dictApply) {
        return $4c5f543936d3c7d7$export$c8ca5446ba1698($4c5f543936d3c7d7$export$54df524caf88dbea)(dictApply);
    },
    Foldable10: function() {
        return $kAvps.foldableDual;
    },
    Traversable1: function() {
        return $9OOYG.traversableDual;
    }
};
var $4c5f543936d3c7d7$export$b86a2d00788e21b6 = {
    traverse1: function(dictApply) {
        var map = $7FzSN.map(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($laciu.Multiplicative)(f(v));
            };
        };
    },
    sequence1: function(dictApply) {
        return $4c5f543936d3c7d7$export$c8ca5446ba1698($4c5f543936d3c7d7$export$b86a2d00788e21b6)(dictApply);
    },
    Foldable10: function() {
        return $kAvps.foldableMultiplicative;
    },
    Traversable1: function() {
        return $9OOYG.traversableMultiplicative;
    }
};
var $4c5f543936d3c7d7$export$6deffb29affc84c6 = function(dict) {
    return dict.sequence1;
};
var $4c5f543936d3c7d7$export$61888596d46ec879 = function(dictTraversable1) {
    var sequence11 = $4c5f543936d3c7d7$export$6deffb29affc84c6(dictTraversable1);
    var map = $7FzSN.map(dictTraversable1.Traversable1().Functor0());
    return function(dictApply) {
        var sequence12 = sequence11(dictApply);
        return function(f) {
            return function(ta) {
                return sequence12(map(f)(ta));
            };
        };
    };
};

});
parcelRegister("kAvps", function(module, exports) {

$parcel$export(module.exports, "foldl1", () => $efcf88c268cedcce$export$eb5e1ef4ea2eca3d);
$parcel$export(module.exports, "foldableTuple", () => $efcf88c268cedcce$export$ffb07d5442a5d6a6);
$parcel$export(module.exports, "foldableMultiplicative", () => $efcf88c268cedcce$export$9519b6731ae6781c);
$parcel$export(module.exports, "foldableIdentity", () => $efcf88c268cedcce$export$3c076fb5bbc5428f);
$parcel$export(module.exports, "foldableDual", () => $efcf88c268cedcce$export$1f8d30ddb0a4c229);
$parcel$export(module.exports, "foldMap1", () => $efcf88c268cedcce$export$b50c31bb8aebd2a7);
$parcel$export(module.exports, "foldl1Default", () => $efcf88c268cedcce$export$8dd52a2a23ae4dc4);
$parcel$export(module.exports, "foldr1Default", () => $efcf88c268cedcce$export$8af34898c082e678);
// Generated by purs version 0.15.16

var $26ZCq = parcelRequire("26ZCq");

var $26SV5 = parcelRequire("26SV5");

var $aJhEx = parcelRequire("aJhEx");

var $dNwPt = parcelRequire("dNwPt");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $53NY2 = parcelRequire("53NY2");

var $46y1S = parcelRequire("46y1S");

var $dItH9 = parcelRequire("dItH9");

var $3w7Wm = parcelRequire("3w7Wm");

var $ibsD5 = parcelRequire("ibsD5");

var $d5vvq = parcelRequire("d5vvq");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
var $efcf88c268cedcce$var$eq = /* #__PURE__ */ $aJhEx.eq($ibsD5.eqOrdering);
var $efcf88c268cedcce$var$alaF = /* #__PURE__ */ $46y1S.alaF()()()();
var $efcf88c268cedcce$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $efcf88c268cedcce$var$ala = /* #__PURE__ */ $46y1S.ala()()();
var $efcf88c268cedcce$var$JoinWith = function(x) {
    return x;
};
var $efcf88c268cedcce$var$FoldRight1 = /* #__PURE__ */ function() {
    function FoldRight1(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    FoldRight1.create = function(value0) {
        return function(value1) {
            return new FoldRight1(value0, value1);
        };
    };
    return FoldRight1;
}();
var $efcf88c268cedcce$var$Act = function(x) {
    return x;
};
var $efcf88c268cedcce$var$semigroupJoinWith = function(dictSemigroup) {
    var append = $d5vvq.append(dictSemigroup);
    return {
        append: function(v) {
            return function(v1) {
                return function(j) {
                    return append(v(j))(append(j)(v1(j)));
                };
            };
        }
    };
};
var $efcf88c268cedcce$var$semigroupAct = function(dictApply) {
    var applySecond = $26ZCq.applySecond(dictApply);
    return {
        append: function(v) {
            return function(v1) {
                return applySecond(v)(v1);
            };
        }
    };
};
var $efcf88c268cedcce$var$runFoldRight1 = function(v) {
    return v.value0(v.value1);
};
var $efcf88c268cedcce$var$mkFoldRight1 = /* #__PURE__ */ function() {
    return $efcf88c268cedcce$var$FoldRight1.create($jhsiw.const);
}();
var $efcf88c268cedcce$var$joinee = function(v) {
    return v;
};
var $efcf88c268cedcce$var$getAct = function(v) {
    return v;
};
var $efcf88c268cedcce$export$c8b99533c112636f = function(dict) {
    return dict.foldr1;
};
var $efcf88c268cedcce$export$eb5e1ef4ea2eca3d = function(dict) {
    return dict.foldl1;
};
var $efcf88c268cedcce$export$c42fa06aba2a552c = function(dictFoldable1) {
    var foldl11 = $efcf88c268cedcce$export$eb5e1ef4ea2eca3d(dictFoldable1);
    return function(cmp) {
        return foldl11(function(x) {
            return function(y) {
                var $120 = $efcf88c268cedcce$var$eq(cmp(x)(y))($ibsD5.GT.value);
                if ($120) return x;
                return y;
            };
        });
    };
};
var $efcf88c268cedcce$export$b65392d958998255 = function(dictFoldable1) {
    var foldl11 = $efcf88c268cedcce$export$eb5e1ef4ea2eca3d(dictFoldable1);
    return function(cmp) {
        return foldl11(function(x) {
            return function(y) {
                var $121 = $efcf88c268cedcce$var$eq(cmp(x)(y))($ibsD5.LT.value);
                if ($121) return x;
                return y;
            };
        });
    };
};
var $efcf88c268cedcce$export$ffb07d5442a5d6a6 = {
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v.value1);
            };
        };
    },
    foldr1: function(v) {
        return function(v1) {
            return v1.value1;
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1.value1;
        };
    },
    Foldable0: function() {
        return $dNwPt.foldableTuple;
    }
};
var $efcf88c268cedcce$export$9519b6731ae6781c = {
    foldr1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    },
    Foldable0: function() {
        return $dNwPt.foldableMultiplicative;
    }
};
var $efcf88c268cedcce$export$3c076fb5bbc5428f = {
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldr1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    Foldable0: function() {
        return $dNwPt.foldableIdentity;
    }
};
var $efcf88c268cedcce$export$1f8d30ddb0a4c229 = {
    foldr1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    },
    Foldable0: function() {
        return $dNwPt.foldableDual;
    }
};
var $efcf88c268cedcce$var$foldRight1Semigroup = {
    append: function(v) {
        return function(v1) {
            return new $efcf88c268cedcce$var$FoldRight1(function(a) {
                return function(f) {
                    return v.value0(f(v.value1)(v1.value0(a)(f)))(f);
                };
            }, v1.value1);
        };
    }
};
var $efcf88c268cedcce$var$semigroupDual = /* #__PURE__ */ $53NY2.semigroupDual($efcf88c268cedcce$var$foldRight1Semigroup);
var $efcf88c268cedcce$export$4a5b2f24b03cc38b = function(dictFoldable1) {
    var foldr11 = $efcf88c268cedcce$export$c8b99533c112636f(dictFoldable1);
    return function(dictFunctor) {
        var map = $7FzSN.map(dictFunctor);
        return function(dictSemigroup) {
            var append = $d5vvq.append(dictSemigroup);
            return function(f) {
                var $159 = foldr11(append);
                var $160 = map(f);
                return function($161) {
                    return $159($160($161));
                };
            };
        };
    };
};
var $efcf88c268cedcce$export$3341743d361f5644 = function(dictFoldable1) {
    var foldl11 = $efcf88c268cedcce$export$eb5e1ef4ea2eca3d(dictFoldable1);
    return function(dictFunctor) {
        var map = $7FzSN.map(dictFunctor);
        return function(dictSemigroup) {
            var append = $d5vvq.append(dictSemigroup);
            return function(f) {
                var $162 = foldl11(append);
                var $163 = map(f);
                return function($164) {
                    return $162($163($164));
                };
            };
        };
    };
};
var $efcf88c268cedcce$export$b50c31bb8aebd2a7 = function(dict) {
    return dict.foldMap1;
};
var $efcf88c268cedcce$export$8dd52a2a23ae4dc4 = function(dictFoldable1) {
    var $165 = $jhsiw.flip(function() {
        var $167 = $efcf88c268cedcce$var$alaF($53NY2.Dual)($efcf88c268cedcce$export$b50c31bb8aebd2a7(dictFoldable1)($efcf88c268cedcce$var$semigroupDual))($efcf88c268cedcce$var$mkFoldRight1);
        return function($168) {
            return $efcf88c268cedcce$var$runFoldRight1($167($168));
        };
    }());
    return function($166) {
        return $165($jhsiw.flip($166));
    };
};
var $efcf88c268cedcce$export$8af34898c082e678 = function(dictFoldable1) {
    return $jhsiw.flip(function() {
        var $169 = $efcf88c268cedcce$export$b50c31bb8aebd2a7(dictFoldable1)($efcf88c268cedcce$var$foldRight1Semigroup)($efcf88c268cedcce$var$mkFoldRight1);
        return function($170) {
            return $efcf88c268cedcce$var$runFoldRight1($169($170));
        };
    }());
};
var $efcf88c268cedcce$export$a91e4d9c87e70eae = function(dictFoldable1) {
    var foldMap11 = $efcf88c268cedcce$export$b50c31bb8aebd2a7(dictFoldable1);
    return function(dictSemigroup) {
        var foldMap12 = foldMap11($efcf88c268cedcce$var$semigroupJoinWith(dictSemigroup));
        return function(j) {
            return function(f) {
                return function(foldable) {
                    return $efcf88c268cedcce$var$joinee(foldMap12(function($171) {
                        return $efcf88c268cedcce$var$JoinWith($jhsiw.const(f($171)));
                    })(foldable))(j);
                };
            };
        };
    };
};
var $efcf88c268cedcce$export$739ec22334c44788 = function(dictFoldable1) {
    var intercalateMap1 = $efcf88c268cedcce$export$a91e4d9c87e70eae(dictFoldable1);
    return function(dictSemigroup) {
        return $jhsiw.flip(intercalateMap1(dictSemigroup))($efcf88c268cedcce$var$identity);
    };
};
var $efcf88c268cedcce$export$b25e0be55f42c9a = function(dictOrd) {
    var semigroupMax = $dItH9.semigroupMax(dictOrd);
    return function(dictFoldable1) {
        return $efcf88c268cedcce$var$ala($dItH9.Max)($efcf88c268cedcce$export$b50c31bb8aebd2a7(dictFoldable1)(semigroupMax));
    };
};
var $efcf88c268cedcce$export$916782c1f0ddb132 = function(dictOrd) {
    var semigroupMin = $3w7Wm.semigroupMin(dictOrd);
    return function(dictFoldable1) {
        return $efcf88c268cedcce$var$ala($3w7Wm.Min)($efcf88c268cedcce$export$b50c31bb8aebd2a7(dictFoldable1)(semigroupMin));
    };
};
var $efcf88c268cedcce$export$4d892265b7b103bf = function(dictFoldable1) {
    var foldMap11 = $efcf88c268cedcce$export$b50c31bb8aebd2a7(dictFoldable1);
    return function(dictApply) {
        var voidRight = $7FzSN.voidRight(dictApply.Functor0());
        var foldMap12 = foldMap11($efcf88c268cedcce$var$semigroupAct(dictApply));
        return function(f) {
            return function(t) {
                return voidRight($ivFwO.unit)($efcf88c268cedcce$var$getAct(foldMap12(function($172) {
                    return $efcf88c268cedcce$var$Act(f($172));
                })(t)));
            };
        };
    };
};
var $efcf88c268cedcce$export$f339179a581d1957 = function(dictFoldable1) {
    var traverse1_1 = $efcf88c268cedcce$export$4d892265b7b103bf(dictFoldable1);
    return function(dictApply) {
        return $jhsiw.flip(traverse1_1(dictApply));
    };
};
var $efcf88c268cedcce$export$1e2962bbf3c67125 = function(dictFoldable1) {
    var traverse1_1 = $efcf88c268cedcce$export$4d892265b7b103bf(dictFoldable1);
    return function(dictApply) {
        return traverse1_1(dictApply)($efcf88c268cedcce$var$identity);
    };
};
var $efcf88c268cedcce$export$2e430a6d03f6ee23 = function(dictFoldable1) {
    var foldMap11 = $efcf88c268cedcce$export$b50c31bb8aebd2a7(dictFoldable1);
    return function(dictSemigroup) {
        return foldMap11(dictSemigroup)($efcf88c268cedcce$var$identity);
    };
};

});
parcelRegister("dItH9", function(module, exports) {

$parcel$export(module.exports, "Max", () => $9fc66b366478fbb1$export$d36c09e5d02927e7);
$parcel$export(module.exports, "semigroupMax", () => $9fc66b366478fbb1$export$a132d56c46b55689);
// Generated by purs version 0.15.16

var $8zsOy = parcelRequire("8zsOy");

var $gwBF5 = parcelRequire("gwBF5");

var $2XxiF = parcelRequire("2XxiF");
var $9fc66b366478fbb1$export$d36c09e5d02927e7 = function(x) {
    return x;
};
var $9fc66b366478fbb1$export$cbb92fe0a8d77a01 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(v) {
            return "(Max " + (show(v) + ")");
        }
    };
};
var $9fc66b366478fbb1$export$a132d56c46b55689 = function(dictOrd) {
    var max = $gwBF5.max(dictOrd);
    return {
        append: function(v) {
            return function(v1) {
                return max(v)(v1);
            };
        }
    };
};
var $9fc66b366478fbb1$export$1c8bde74ed3994f3 = {
    Coercible0: function() {
        return undefined;
    }
};
var $9fc66b366478fbb1$export$1f74115b8967ed30 = function(dictBounded) {
    var semigroupMax1 = $9fc66b366478fbb1$export$a132d56c46b55689(dictBounded.Ord0());
    return {
        mempty: $8zsOy.bottom(dictBounded),
        Semigroup0: function() {
            return semigroupMax1;
        }
    };
};
var $9fc66b366478fbb1$export$2d291ba9538dc344 = function(dictEq) {
    return dictEq;
};
var $9fc66b366478fbb1$export$9193f18dc6b98d96 = function(dictOrd) {
    var compare = $gwBF5.compare(dictOrd);
    var eqMax1 = $9fc66b366478fbb1$export$2d291ba9538dc344(dictOrd.Eq0());
    return {
        compare: function(v) {
            return function(v1) {
                return compare(v)(v1);
            };
        },
        Eq0: function() {
            return eqMax1;
        }
    };
};

});

parcelRegister("3w7Wm", function(module, exports) {

$parcel$export(module.exports, "Min", () => $28fa850c5cb54389$export$dfed19fabc75a31d);
$parcel$export(module.exports, "semigroupMin", () => $28fa850c5cb54389$export$7a307765ab1cd61e);
// Generated by purs version 0.15.16

var $8zsOy = parcelRequire("8zsOy");

var $gwBF5 = parcelRequire("gwBF5");

var $2XxiF = parcelRequire("2XxiF");
var $28fa850c5cb54389$export$dfed19fabc75a31d = function(x) {
    return x;
};
var $28fa850c5cb54389$export$7b461170c443f592 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(v) {
            return "(Min " + (show(v) + ")");
        }
    };
};
var $28fa850c5cb54389$export$7a307765ab1cd61e = function(dictOrd) {
    var min = $gwBF5.min(dictOrd);
    return {
        append: function(v) {
            return function(v1) {
                return min(v)(v1);
            };
        }
    };
};
var $28fa850c5cb54389$export$1aba8bd40545d1a0 = {
    Coercible0: function() {
        return undefined;
    }
};
var $28fa850c5cb54389$export$6c7bc156e3eb9786 = function(dictBounded) {
    var semigroupMin1 = $28fa850c5cb54389$export$7a307765ab1cd61e(dictBounded.Ord0());
    return {
        mempty: $8zsOy.top(dictBounded),
        Semigroup0: function() {
            return semigroupMin1;
        }
    };
};
var $28fa850c5cb54389$export$aa006854d430a332 = function(dictEq) {
    return dictEq;
};
var $28fa850c5cb54389$export$ea9a45890a65660 = function(dictOrd) {
    var compare = $gwBF5.compare(dictOrd);
    var eqMin1 = $28fa850c5cb54389$export$aa006854d430a332(dictOrd.Eq0());
    return {
        compare: function(v) {
            return function(v1) {
                return compare(v)(v1);
            };
        },
        Eq0: function() {
            return eqMin1;
        }
    };
};

});






parcelRegister("dIXGo", function(module, exports) {

$parcel$export(module.exports, "toEnum", () => $9fddae29bdd2c226$export$45328c01562fb205);
$parcel$export(module.exports, "succ", () => $9fddae29bdd2c226$export$61d85e1612867711);
$parcel$export(module.exports, "pred", () => $9fddae29bdd2c226$export$c238ae40a8cccc17);
$parcel$export(module.exports, "fromEnum", () => $9fddae29bdd2c226$export$b385cb642735011f);
$parcel$export(module.exports, "toEnumWithDefaults", () => $9fddae29bdd2c226$export$1e2c188a485bdeae);
$parcel$export(module.exports, "defaultSucc", () => $9fddae29bdd2c226$export$11e799785deb08e4);
$parcel$export(module.exports, "defaultPred", () => $9fddae29bdd2c226$export$dc42af8461b24233);
$parcel$export(module.exports, "boundedEnumChar", () => $9fddae29bdd2c226$export$be1f07c3580164c);
// Generated by purs version 0.15.16

var $5PTul = parcelRequire("5PTul");

var $NWXZ5 = parcelRequire("NWXZ5");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $iQTlW = parcelRequire("iQTlW");

var $8zsOy = parcelRequire("8zsOy");

var $beQI1 = parcelRequire("beQI1");

var $aJhEx = parcelRequire("aJhEx");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $2XxiF = parcelRequire("2XxiF");

var $7O0Q4 = parcelRequire("7O0Q4");

var $goKHx = parcelRequire("goKHx");

var $N3bwb = parcelRequire("N3bwb");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
var $9fddae29bdd2c226$var$apply = /* #__PURE__ */ $26ZCq.apply($26ZCq.applyFn);
var $9fddae29bdd2c226$var$show = /* #__PURE__ */ $2XxiF.show($2XxiF.showInt);
var $9fddae29bdd2c226$var$map = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $9fddae29bdd2c226$var$top = /* #__PURE__ */ $8zsOy.top($8zsOy.boundedInt);
var $9fddae29bdd2c226$var$bottom = /* #__PURE__ */ $8zsOy.bottom($8zsOy.boundedInt);
var $9fddae29bdd2c226$var$bind = /* #__PURE__ */ $cADnC.bind($h2xUu.bindMaybe);
var $9fddae29bdd2c226$var$voidLeft = /* #__PURE__ */ $7FzSN.voidLeft($h2xUu.functorMaybe);
var $9fddae29bdd2c226$var$guard = /* #__PURE__ */ $NWXZ5.guard($h2xUu.alternativeMaybe);
var $9fddae29bdd2c226$var$fromJust = /* #__PURE__ */ $h2xUu.fromJust();
var $9fddae29bdd2c226$var$bottom1 = /* #__PURE__ */ $8zsOy.bottom($8zsOy.boundedChar);
var $9fddae29bdd2c226$var$top1 = /* #__PURE__ */ $8zsOy.top($8zsOy.boundedChar);
var $9fddae29bdd2c226$export$a3fdfde49d86b899 = function(x) {
    return x;
};
var $9fddae29bdd2c226$export$45328c01562fb205 = function(dict) {
    return dict.toEnum;
};
var $9fddae29bdd2c226$export$61d85e1612867711 = function(dict) {
    return dict.succ;
};
var $9fddae29bdd2c226$export$f55455e25c350f35 = function(dictEnum) {
    var succ1 = $9fddae29bdd2c226$export$61d85e1612867711(dictEnum);
    return function(dictUnfoldable1) {
        return $N3bwb.unfoldr1(dictUnfoldable1)($9fddae29bdd2c226$var$apply($7O0Q4.Tuple.create)(succ1));
    };
};
var $9fddae29bdd2c226$export$3d0bc2efe492e4f7 = {
    show: function(v) {
        return "(Cardinality " + ($9fddae29bdd2c226$var$show(v) + ")");
    }
};
var $9fddae29bdd2c226$export$c238ae40a8cccc17 = function(dict) {
    return dict.pred;
};
var $9fddae29bdd2c226$export$68d5f1a472f8251a = $gwBF5.ordInt;
var $9fddae29bdd2c226$export$d3d8047a35329ac2 = {
    Coercible0: function() {
        return undefined;
    }
};
var $9fddae29bdd2c226$export$b385cb642735011f = function(dict) {
    return dict.fromEnum;
};
var $9fddae29bdd2c226$export$1e2c188a485bdeae = function(dictBoundedEnum) {
    var toEnum1 = $9fddae29bdd2c226$export$45328c01562fb205(dictBoundedEnum);
    var fromEnum1 = $9fddae29bdd2c226$export$b385cb642735011f(dictBoundedEnum);
    var bottom2 = $8zsOy.bottom(dictBoundedEnum.Bounded0());
    return function(low) {
        return function(high) {
            return function(x) {
                var v = toEnum1(x);
                if (v instanceof $h2xUu.Just) return v.value0;
                if (v instanceof $h2xUu.Nothing) {
                    var $140 = x < fromEnum1(bottom2);
                    if ($140) return low;
                    return high;
                }
                throw new Error("Failed pattern match at Data.Enum (line 158, column 33 - line 160, column 62): " + [
                    v.constructor.name
                ]);
            };
        };
    };
};
var $9fddae29bdd2c226$export$63b732e1f89f043e = $aJhEx.eqInt;
var $9fddae29bdd2c226$export$c0a99362196d7617 = /* #__PURE__ */ function() {
    return {
        succ: $jhsiw.const($h2xUu.Nothing.value),
        pred: $jhsiw.const($h2xUu.Nothing.value),
        Ord0: function() {
            return $gwBF5.ordUnit;
        }
    };
}();
var $9fddae29bdd2c226$export$51ea709069e9f759 = function(dictEnum) {
    var succ1 = $9fddae29bdd2c226$export$61d85e1612867711(dictEnum);
    var pred1 = $9fddae29bdd2c226$export$c238ae40a8cccc17(dictEnum);
    var ordTuple = $7O0Q4.ordTuple(dictEnum.Ord0());
    return function(dictBoundedEnum) {
        var Bounded0 = dictBoundedEnum.Bounded0();
        var bottom2 = $8zsOy.bottom(Bounded0);
        var Enum1 = dictBoundedEnum.Enum1();
        var succ2 = $9fddae29bdd2c226$export$61d85e1612867711(Enum1);
        var top2 = $8zsOy.top(Bounded0);
        var pred2 = $9fddae29bdd2c226$export$c238ae40a8cccc17(Enum1);
        var ordTuple1 = ordTuple(Enum1.Ord0());
        return {
            succ: function(v) {
                return $h2xUu.maybe($9fddae29bdd2c226$var$map($jhsiw.flip($7O0Q4.Tuple.create)(bottom2))(succ1(v.value0)))(function() {
                    var $183 = $7O0Q4.Tuple.create(v.value0);
                    return function($184) {
                        return $h2xUu.Just.create($183($184));
                    };
                }())(succ2(v.value1));
            },
            pred: function(v) {
                return $h2xUu.maybe($9fddae29bdd2c226$var$map($jhsiw.flip($7O0Q4.Tuple.create)(top2))(pred1(v.value0)))(function() {
                    var $185 = $7O0Q4.Tuple.create(v.value0);
                    return function($186) {
                        return $h2xUu.Just.create($185($186));
                    };
                }())(pred2(v.value1));
            },
            Ord0: function() {
                return ordTuple1;
            }
        };
    };
};
var $9fddae29bdd2c226$export$94be50e509bf721a = {
    succ: function(v) {
        if (v instanceof $ibsD5.LT) return new $h2xUu.Just($ibsD5.EQ.value);
        if (v instanceof $ibsD5.EQ) return new $h2xUu.Just($ibsD5.GT.value);
        if (v instanceof $ibsD5.GT) return $h2xUu.Nothing.value;
        throw new Error("Failed pattern match at Data.Enum (line 72, column 1 - line 78, column 20): " + [
            v.constructor.name
        ]);
    },
    pred: function(v) {
        if (v instanceof $ibsD5.LT) return $h2xUu.Nothing.value;
        if (v instanceof $ibsD5.EQ) return new $h2xUu.Just($ibsD5.LT.value);
        if (v instanceof $ibsD5.GT) return new $h2xUu.Just($ibsD5.EQ.value);
        throw new Error("Failed pattern match at Data.Enum (line 72, column 1 - line 78, column 20): " + [
            v.constructor.name
        ]);
    },
    Ord0: function() {
        return $gwBF5.ordOrdering;
    }
};
var $9fddae29bdd2c226$export$4d9047d2b06c2498 = function(dictBoundedEnum) {
    var bottom2 = $8zsOy.bottom(dictBoundedEnum.Bounded0());
    var Enum1 = dictBoundedEnum.Enum1();
    var succ1 = $9fddae29bdd2c226$export$61d85e1612867711(Enum1);
    var pred1 = $9fddae29bdd2c226$export$c238ae40a8cccc17(Enum1);
    var ordMaybe = $h2xUu.ordMaybe(Enum1.Ord0());
    return {
        succ: function(v) {
            if (v instanceof $h2xUu.Nothing) return new $h2xUu.Just(new $h2xUu.Just(bottom2));
            if (v instanceof $h2xUu.Just) return $9fddae29bdd2c226$var$map($h2xUu.Just.create)(succ1(v.value0));
            throw new Error("Failed pattern match at Data.Enum (line 80, column 1 - line 84, column 32): " + [
                v.constructor.name
            ]);
        },
        pred: function(v) {
            if (v instanceof $h2xUu.Nothing) return $h2xUu.Nothing.value;
            if (v instanceof $h2xUu.Just) return new $h2xUu.Just(pred1(v.value0));
            throw new Error("Failed pattern match at Data.Enum (line 80, column 1 - line 84, column 32): " + [
                v.constructor.name
            ]);
        },
        Ord0: function() {
            return ordMaybe;
        }
    };
};
var $9fddae29bdd2c226$export$f8cd1ff55b5d915b = {
    succ: function(n) {
        var $153 = n < $9fddae29bdd2c226$var$top;
        if ($153) return new $h2xUu.Just(n + 1 | 0);
        return $h2xUu.Nothing.value;
    },
    pred: function(n) {
        var $154 = n > $9fddae29bdd2c226$var$bottom;
        if ($154) return new $h2xUu.Just(n - 1 | 0);
        return $h2xUu.Nothing.value;
    },
    Ord0: function() {
        return $gwBF5.ordInt;
    }
};
var $9fddae29bdd2c226$export$51bf4ec4e9fd2fba = function(dictEnum) {
    var Ord0 = dictEnum.Ord0();
    var eq1 = $aJhEx.eq(Ord0.Eq0());
    var lessThan1 = $gwBF5.lessThan(Ord0);
    var succ1 = $9fddae29bdd2c226$export$61d85e1612867711(dictEnum);
    var lessThanOrEq1 = $gwBF5.lessThanOrEq(Ord0);
    var pred1 = $9fddae29bdd2c226$export$c238ae40a8cccc17(dictEnum);
    var greaterThanOrEq1 = $gwBF5.greaterThanOrEq(Ord0);
    return function(dictUnfoldable1) {
        var singleton = $N3bwb.singleton(dictUnfoldable1);
        var unfoldr1 = $N3bwb.unfoldr1(dictUnfoldable1);
        var go = function(step) {
            return function(op) {
                return function(to) {
                    return function(a) {
                        return new $7O0Q4.Tuple(a, $9fddae29bdd2c226$var$bind(step(a))(function(a$prime) {
                            return $9fddae29bdd2c226$var$voidLeft($9fddae29bdd2c226$var$guard(op(a$prime)(to)))(a$prime);
                        }));
                    };
                };
            };
        };
        return function(v) {
            return function(v1) {
                if (eq1(v)(v1)) return singleton(v);
                if (lessThan1(v)(v1)) return unfoldr1(go(succ1)(lessThanOrEq1)(v1))(v);
                if ($iQTlW.otherwise) return unfoldr1(go(pred1)(greaterThanOrEq1)(v1))(v);
                throw new Error("Failed pattern match at Data.Enum (line 186, column 14 - line 190, column 51): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    };
};
var $9fddae29bdd2c226$export$c023000aca534be0 = function(dictUnfoldable) {
    var unfoldr = $goKHx.unfoldr(dictUnfoldable);
    return function(dictFunctor) {
        var map1 = $7FzSN.map(dictFunctor);
        return function(dictBoundedEnum) {
            var fromEnum1 = $9fddae29bdd2c226$export$b385cb642735011f(dictBoundedEnum);
            var toEnum1 = $9fddae29bdd2c226$export$45328c01562fb205(dictBoundedEnum);
            var go = function(step) {
                return function(to) {
                    return function(e) {
                        if (e <= to) return new $h2xUu.Just(new $7O0Q4.Tuple(e, e + step | 0));
                        if ($iQTlW.otherwise) return $h2xUu.Nothing.value;
                        throw new Error("Failed pattern match at Data.Enum (line 217, column 5 - line 219, column 28): " + [
                            step.constructor.name,
                            to.constructor.name,
                            e.constructor.name
                        ]);
                    };
                };
            };
            return function(a) {
                return function(b) {
                    return function(c) {
                        var c$prime = fromEnum1(c);
                        var b$prime = fromEnum1(b);
                        var a$prime = fromEnum1(a);
                        return map1(function($187) {
                            return $9fddae29bdd2c226$var$fromJust(toEnum1($187));
                        })(unfoldr(go(b$prime - a$prime | 0)(c$prime))(a$prime));
                    };
                };
            };
        };
    };
};
var $9fddae29bdd2c226$export$3733bec825dc17c = function(dictBoundedEnum) {
    var Enum1 = dictBoundedEnum.Enum1();
    var succ1 = $9fddae29bdd2c226$export$61d85e1612867711(Enum1);
    var pred1 = $9fddae29bdd2c226$export$c238ae40a8cccc17(Enum1);
    var top2 = $8zsOy.top(dictBoundedEnum.Bounded0());
    var ordEither = $beQI1.ordEither(Enum1.Ord0());
    return function(dictBoundedEnum1) {
        var bottom2 = $8zsOy.bottom(dictBoundedEnum1.Bounded0());
        var Enum11 = dictBoundedEnum1.Enum1();
        var succ2 = $9fddae29bdd2c226$export$61d85e1612867711(Enum11);
        var pred2 = $9fddae29bdd2c226$export$c238ae40a8cccc17(Enum11);
        var ordEither1 = ordEither(Enum11.Ord0());
        return {
            succ: function(v) {
                if (v instanceof $beQI1.Left) return $h2xUu.maybe(new $h2xUu.Just(new $beQI1.Right(bottom2)))(function($188) {
                    return $h2xUu.Just.create($beQI1.Left.create($188));
                })(succ1(v.value0));
                if (v instanceof $beQI1.Right) return $h2xUu.maybe($h2xUu.Nothing.value)(function($189) {
                    return $h2xUu.Just.create($beQI1.Right.create($189));
                })(succ2(v.value0));
                throw new Error("Failed pattern match at Data.Enum (line 86, column 1 - line 90, column 69): " + [
                    v.constructor.name
                ]);
            },
            pred: function(v) {
                if (v instanceof $beQI1.Left) return $h2xUu.maybe($h2xUu.Nothing.value)(function($190) {
                    return $h2xUu.Just.create($beQI1.Left.create($190));
                })(pred1(v.value0));
                if (v instanceof $beQI1.Right) return $h2xUu.maybe(new $h2xUu.Just(new $beQI1.Left(top2)))(function($191) {
                    return $h2xUu.Just.create($beQI1.Right.create($191));
                })(pred2(v.value0));
                throw new Error("Failed pattern match at Data.Enum (line 86, column 1 - line 90, column 69): " + [
                    v.constructor.name
                ]);
            },
            Ord0: function() {
                return ordEither1;
            }
        };
    };
};
var $9fddae29bdd2c226$export$6670eb63482acbe8 = {
    succ: function(v) {
        if (!v) return new $h2xUu.Just(true);
        return $h2xUu.Nothing.value;
    },
    pred: function(v) {
        if (v) return new $h2xUu.Just(false);
        return $h2xUu.Nothing.value;
    },
    Ord0: function() {
        return $gwBF5.ordBoolean;
    }
};
var $9fddae29bdd2c226$export$ab0f40ba1313e2bb = function(dictEnum) {
    var pred1 = $9fddae29bdd2c226$export$c238ae40a8cccc17(dictEnum);
    return function(dictUnfoldable1) {
        return $N3bwb.unfoldr1(dictUnfoldable1)($9fddae29bdd2c226$var$apply($7O0Q4.Tuple.create)(pred1));
    };
};
var $9fddae29bdd2c226$var$diag = function(a) {
    return new $7O0Q4.Tuple(a, a);
};
var $9fddae29bdd2c226$export$c0c53cc9a0565905 = function(dictEnum) {
    var pred1 = $9fddae29bdd2c226$export$c238ae40a8cccc17(dictEnum);
    return function(dictUnfoldable) {
        return $goKHx.unfoldr(dictUnfoldable)(function() {
            var $192 = $9fddae29bdd2c226$var$map($9fddae29bdd2c226$var$diag);
            return function($193) {
                return $192(pred1($193));
            };
        }());
    };
};
var $9fddae29bdd2c226$export$556edd6c9fb1e655 = function(dictEnum) {
    var succ1 = $9fddae29bdd2c226$export$61d85e1612867711(dictEnum);
    return function(dictUnfoldable) {
        return $goKHx.unfoldr(dictUnfoldable)(function() {
            var $194 = $9fddae29bdd2c226$var$map($9fddae29bdd2c226$var$diag);
            return function($195) {
                return $194(succ1($195));
            };
        }());
    };
};
var $9fddae29bdd2c226$export$9263b51426343c61 = function(dictBounded) {
    var bottom2 = $8zsOy.bottom(dictBounded);
    return function(dictEnum) {
        var succ1 = $9fddae29bdd2c226$export$61d85e1612867711(dictEnum);
        return function(i$prime) {
            var go = function($copy_i) {
                return function($copy_x) {
                    var $tco_var_i = $copy_i;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(i, x) {
                        var $168 = i === 0;
                        if ($168) {
                            $tco_done = true;
                            return new $h2xUu.Just(x);
                        }
                        var v = succ1(x);
                        if (v instanceof $h2xUu.Just) {
                            $tco_var_i = i - 1 | 0;
                            $copy_x = v.value0;
                            return;
                        }
                        if (v instanceof $h2xUu.Nothing) {
                            $tco_done = true;
                            return $h2xUu.Nothing.value;
                        }
                        throw new Error("Failed pattern match at Data.Enum (line 296, column 12 - line 298, column 33): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_x);
                    return $tco_result;
                };
            };
            var $171 = i$prime < 0;
            if ($171) return $h2xUu.Nothing.value;
            return go(i$prime)(bottom2);
        };
    };
};
var $9fddae29bdd2c226$export$11e799785deb08e4 = function(toEnum$prime) {
    return function(fromEnum$prime) {
        return function(a) {
            return toEnum$prime(fromEnum$prime(a) + 1 | 0);
        };
    };
};
var $9fddae29bdd2c226$export$dc42af8461b24233 = function(toEnum$prime) {
    return function(fromEnum$prime) {
        return function(a) {
            return toEnum$prime(fromEnum$prime(a) - 1 | 0);
        };
    };
};
var $9fddae29bdd2c226$export$21fa49008ecbb00a = function(dictEnum) {
    var pred1 = $9fddae29bdd2c226$export$c238ae40a8cccc17(dictEnum);
    var go = function($copy_i) {
        return function($copy_x) {
            var $tco_var_i = $copy_i;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(i, x) {
                var v = pred1(x);
                if (v instanceof $h2xUu.Just) {
                    $tco_var_i = i + 1 | 0;
                    $copy_x = v.value0;
                    return;
                }
                if (v instanceof $h2xUu.Nothing) {
                    $tco_done = true;
                    return i;
                }
                throw new Error("Failed pattern match at Data.Enum (line 309, column 5 - line 311, column 19): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_x);
            return $tco_result;
        };
    };
    return go(0);
};
var $9fddae29bdd2c226$export$18eeb03d5b80a339 = function(dictBounded) {
    var bottom2 = $8zsOy.bottom(dictBounded);
    return function(dictEnum) {
        var succ1 = $9fddae29bdd2c226$export$61d85e1612867711(dictEnum);
        var go = function($copy_i) {
            return function($copy_x) {
                var $tco_var_i = $copy_i;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(i, x) {
                    var v = succ1(x);
                    if (v instanceof $h2xUu.Just) {
                        $tco_var_i = i + 1 | 0;
                        $copy_x = v.value0;
                        return;
                    }
                    if (v instanceof $h2xUu.Nothing) {
                        $tco_done = true;
                        return i;
                    }
                    throw new Error("Failed pattern match at Data.Enum (line 276, column 5 - line 278, column 19): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_x);
                return $tco_result;
            };
        };
        return go(1)(bottom2);
    };
};
var $9fddae29bdd2c226$var$charToEnum = function(v) {
    if (v >= $5PTul.toCharCode($9fddae29bdd2c226$var$bottom1) && v <= $5PTul.toCharCode($9fddae29bdd2c226$var$top1)) return new $h2xUu.Just($5PTul.fromCharCode(v));
    return $h2xUu.Nothing.value;
};
var $9fddae29bdd2c226$export$8ff57056df5ff58e = {
    succ: /* #__PURE__ */ $9fddae29bdd2c226$export$11e799785deb08e4($9fddae29bdd2c226$var$charToEnum)($5PTul.toCharCode),
    pred: /* #__PURE__ */ $9fddae29bdd2c226$export$dc42af8461b24233($9fddae29bdd2c226$var$charToEnum)($5PTul.toCharCode),
    Ord0: function() {
        return $gwBF5.ordChar;
    }
};
var $9fddae29bdd2c226$export$9e9949f96c411257 = function(dict) {
    return dict.cardinality;
};
var $9fddae29bdd2c226$export$670c12fc7b01c16 = {
    cardinality: 1,
    toEnum: function(v) {
        if (v === 0) return new $h2xUu.Just($ivFwO.unit);
        return $h2xUu.Nothing.value;
    },
    fromEnum: /* #__PURE__ */ $jhsiw.const(0),
    Bounded0: function() {
        return $8zsOy.boundedUnit;
    },
    Enum1: function() {
        return $9fddae29bdd2c226$export$c0a99362196d7617;
    }
};
var $9fddae29bdd2c226$export$fe7add2041208ec9 = {
    cardinality: 3,
    toEnum: function(v) {
        if (v === 0) return new $h2xUu.Just($ibsD5.LT.value);
        if (v === 1) return new $h2xUu.Just($ibsD5.EQ.value);
        if (v === 2) return new $h2xUu.Just($ibsD5.GT.value);
        return $h2xUu.Nothing.value;
    },
    fromEnum: function(v) {
        if (v instanceof $ibsD5.LT) return 0;
        if (v instanceof $ibsD5.EQ) return 1;
        if (v instanceof $ibsD5.GT) return 2;
        throw new Error("Failed pattern match at Data.Enum (line 137, column 1 - line 145, column 18): " + [
            v.constructor.name
        ]);
    },
    Bounded0: function() {
        return $8zsOy.boundedOrdering;
    },
    Enum1: function() {
        return $9fddae29bdd2c226$export$94be50e509bf721a;
    }
};
var $9fddae29bdd2c226$export$be1f07c3580164c = /* #__PURE__ */ function() {
    return {
        cardinality: $5PTul.toCharCode($9fddae29bdd2c226$var$top1) - $5PTul.toCharCode($9fddae29bdd2c226$var$bottom1) | 0,
        toEnum: $9fddae29bdd2c226$var$charToEnum,
        fromEnum: $5PTul.toCharCode,
        Bounded0: function() {
            return $8zsOy.boundedChar;
        },
        Enum1: function() {
            return $9fddae29bdd2c226$export$8ff57056df5ff58e;
        }
    };
}();
var $9fddae29bdd2c226$export$3d0fa7de09d15272 = {
    cardinality: 2,
    toEnum: function(v) {
        if (v === 0) return new $h2xUu.Just(false);
        if (v === 1) return new $h2xUu.Just(true);
        return $h2xUu.Nothing.value;
    },
    fromEnum: function(v) {
        if (!v) return 0;
        if (v) return 1;
        throw new Error("Failed pattern match at Data.Enum (line 118, column 1 - line 124, column 20): " + [
            v.constructor.name
        ]);
    },
    Bounded0: function() {
        return $8zsOy.boundedBoolean;
    },
    Enum1: function() {
        return $9fddae29bdd2c226$export$6670eb63482acbe8;
    }
};

});
parcelRegister("5PTul", function(module, exports) {

$parcel$export(module.exports, "toCharCode", () => $43fcc2053abc98ee$export$d90166409dd04e85);
$parcel$export(module.exports, "fromCharCode", () => $43fcc2053abc98ee$export$30216c0101da0ee0);
function $43fcc2053abc98ee$export$d90166409dd04e85(c) {
    return c.charCodeAt(0);
}
function $43fcc2053abc98ee$export$30216c0101da0ee0(c) {
    return String.fromCharCode(c);
}

});

parcelRegister("NWXZ5", function(module, exports) {

$parcel$export(module.exports, "guard", () => $0962513be852be8b$export$864d727b48066337);
// Generated by purs version 0.15.16

var $56VjJ = parcelRequire("56VjJ");

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $j7FrY = parcelRequire("j7FrY");

var $7FzSN = parcelRequire("7FzSN");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
var $0962513be852be8b$export$864d727b48066337 = function(dictAlternative) {
    var pure = $bQdkN.pure(dictAlternative.Applicative0());
    var empty = $j7FrY.empty(dictAlternative.Plus1());
    return function(v) {
        if (v) return pure($ivFwO.unit);
        if (!v) return empty;
        throw new Error("Failed pattern match at Control.Alternative (line 48, column 1 - line 48, column 54): " + [
            v.constructor.name
        ]);
    };
};
var $0962513be852be8b$export$5e87c78e215371ee = {
    Applicative0: function() {
        return $bQdkN.applicativeArray;
    },
    Plus1: function() {
        return $j7FrY.plusArray;
    }
};

});


parcelRegister("hCjGZ", function(module, exports) {

$parcel$export(module.exports, "hexadecimal", () => $cd3542c6d70d10f9$export$9c12a48020146abe);
$parcel$export(module.exports, "fromNumber", () => $cd3542c6d70d10f9$export$7bbb4164c9a77bc2);
$parcel$export(module.exports, "floor", () => $cd3542c6d70d10f9$export$a3fe094919f356fd);
$parcel$export(module.exports, "toNumber", () => (parcelRequire("dbLcE")).toNumber);
$parcel$export(module.exports, "toStringAs", () => (parcelRequire("dbLcE")).toStringAs);
$parcel$export(module.exports, "quot", () => (parcelRequire("dbLcE")).quot);
// Generated by purs version 0.15.16

var $dbLcE = parcelRequire("dbLcE");

var $26SV5 = parcelRequire("26SV5");

var $iQTlW = parcelRequire("iQTlW");

var $8zsOy = parcelRequire("8zsOy");

var $aJhEx = parcelRequire("aJhEx");

var $h2xUu = parcelRequire("h2xUu");
parcelRequire("kBxBi");
var $heEVZ = parcelRequire("heEVZ");

var $ibsD5 = parcelRequire("ibsD5");

var $iVjQa = parcelRequire("iVjQa");
var $cd3542c6d70d10f9$var$top = /* #__PURE__ */ $8zsOy.top($8zsOy.boundedInt);
var $cd3542c6d70d10f9$var$bottom = /* #__PURE__ */ $8zsOy.bottom($8zsOy.boundedInt);
var $cd3542c6d70d10f9$var$Radix = function(x) {
    return x;
};
var $cd3542c6d70d10f9$export$33ca3b017f2e3089 = /* #__PURE__ */ function() {
    function Even() {}
    Even.value = new Even();
    return Even;
}();
var $cd3542c6d70d10f9$export$6bbc73627dceae86 = /* #__PURE__ */ function() {
    function Odd() {}
    Odd.value = new Odd();
    return Odd;
}();
var $cd3542c6d70d10f9$export$9f422d81718beff7 = {
    show: function(v) {
        if (v instanceof $cd3542c6d70d10f9$export$33ca3b017f2e3089) return "Even";
        if (v instanceof $cd3542c6d70d10f9$export$6bbc73627dceae86) return "Odd";
        throw new Error("Failed pattern match at Data.Int (line 117, column 1 - line 119, column 19): " + [
            v.constructor.name
        ]);
    }
};
var $cd3542c6d70d10f9$export$1db3e511bfb04803 = function(n) {
    if (n >= 2 && n <= 36) return new $h2xUu.Just(n);
    if ($iQTlW.otherwise) return $h2xUu.Nothing.value;
    throw new Error("Failed pattern match at Data.Int (line 198, column 1 - line 198, column 28): " + [
        n.constructor.name
    ]);
};
var $cd3542c6d70d10f9$export$74b48c691cc42eb1 = function(x) {
    return (x & 1) !== 0;
};
var $cd3542c6d70d10f9$export$90d8fbb029b06afc = 8;
var $cd3542c6d70d10f9$export$9c12a48020146abe = 16;
var $cd3542c6d70d10f9$export$d7a050b0311540b9 = /* #__PURE__ */ function() {
    return $dbLcE.fromStringAsImpl($h2xUu.Just.create)($h2xUu.Nothing.value);
}();
var $cd3542c6d70d10f9$export$3004f64547af360e = /* #__PURE__ */ $cd3542c6d70d10f9$export$d7a050b0311540b9(10);
var $cd3542c6d70d10f9$export$7bbb4164c9a77bc2 = /* #__PURE__ */ function() {
    return $dbLcE.fromNumberImpl($h2xUu.Just.create)($h2xUu.Nothing.value);
}();
var $cd3542c6d70d10f9$var$unsafeClamp = function(x) {
    if (!$heEVZ.isFinite(x)) return 0;
    if (x >= $dbLcE.toNumber($cd3542c6d70d10f9$var$top)) return $cd3542c6d70d10f9$var$top;
    if (x <= $dbLcE.toNumber($cd3542c6d70d10f9$var$bottom)) return $cd3542c6d70d10f9$var$bottom;
    if ($iQTlW.otherwise) return $h2xUu.fromMaybe(0)($cd3542c6d70d10f9$export$7bbb4164c9a77bc2(x));
    throw new Error("Failed pattern match at Data.Int (line 72, column 1 - line 72, column 29): " + [
        x.constructor.name
    ]);
};
var $cd3542c6d70d10f9$export$2077e0241d6afd3c = function($37) {
    return $cd3542c6d70d10f9$var$unsafeClamp($heEVZ.round($37));
};
var $cd3542c6d70d10f9$export$1fe87bd59b089f0 = function($38) {
    return $cd3542c6d70d10f9$var$unsafeClamp($heEVZ.trunc($38));
};
var $cd3542c6d70d10f9$export$a3fe094919f356fd = function($39) {
    return $cd3542c6d70d10f9$var$unsafeClamp($heEVZ.floor($39));
};
var $cd3542c6d70d10f9$export$df5fefc55a4eba3c = function(x) {
    return (x & 1) === 0;
};
var $cd3542c6d70d10f9$export$efe353078db02e10 = function(n) {
    var $28 = $cd3542c6d70d10f9$export$df5fefc55a4eba3c(n);
    if ($28) return $cd3542c6d70d10f9$export$33ca3b017f2e3089.value;
    return $cd3542c6d70d10f9$export$6bbc73627dceae86.value;
};
var $cd3542c6d70d10f9$export$8424267183f54e9d = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $cd3542c6d70d10f9$export$33ca3b017f2e3089 && y instanceof $cd3542c6d70d10f9$export$33ca3b017f2e3089) return true;
            if (x instanceof $cd3542c6d70d10f9$export$6bbc73627dceae86 && y instanceof $cd3542c6d70d10f9$export$6bbc73627dceae86) return true;
            return false;
        };
    }
};
var $cd3542c6d70d10f9$var$eq1 = /* #__PURE__ */ $aJhEx.eq($cd3542c6d70d10f9$export$8424267183f54e9d);
var $cd3542c6d70d10f9$export$8b12bf30fdd3264f = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $cd3542c6d70d10f9$export$33ca3b017f2e3089 && y instanceof $cd3542c6d70d10f9$export$33ca3b017f2e3089) return $ibsD5.EQ.value;
            if (x instanceof $cd3542c6d70d10f9$export$33ca3b017f2e3089) return $ibsD5.LT.value;
            if (y instanceof $cd3542c6d70d10f9$export$33ca3b017f2e3089) return $ibsD5.GT.value;
            if (x instanceof $cd3542c6d70d10f9$export$6bbc73627dceae86 && y instanceof $cd3542c6d70d10f9$export$6bbc73627dceae86) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at Data.Int (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $cd3542c6d70d10f9$export$8424267183f54e9d;
    }
};
var $cd3542c6d70d10f9$export$39d55cbe74216cbe = /* #__PURE__ */ function() {
    return {
        zero: $cd3542c6d70d10f9$export$33ca3b017f2e3089.value,
        add: function(x) {
            return function(y) {
                var $33 = $cd3542c6d70d10f9$var$eq1(x)(y);
                if ($33) return $cd3542c6d70d10f9$export$33ca3b017f2e3089.value;
                return $cd3542c6d70d10f9$export$6bbc73627dceae86.value;
            };
        },
        one: $cd3542c6d70d10f9$export$6bbc73627dceae86.value,
        mul: function(v) {
            return function(v1) {
                if (v instanceof $cd3542c6d70d10f9$export$6bbc73627dceae86 && v1 instanceof $cd3542c6d70d10f9$export$6bbc73627dceae86) return $cd3542c6d70d10f9$export$6bbc73627dceae86.value;
                return $cd3542c6d70d10f9$export$33ca3b017f2e3089.value;
            };
        }
    };
}();
var $cd3542c6d70d10f9$export$e741c28ebd8a3552 = {
    sub: /* #__PURE__ */ $iVjQa.add($cd3542c6d70d10f9$export$39d55cbe74216cbe),
    Semiring0: function() {
        return $cd3542c6d70d10f9$export$39d55cbe74216cbe;
    }
};
var $cd3542c6d70d10f9$export$5bd06fe87b344eef = {
    recip: /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn),
    Ring0: function() {
        return $cd3542c6d70d10f9$export$e741c28ebd8a3552;
    }
};
var $cd3542c6d70d10f9$export$78a48a3d1e5dbe89 = 10;
var $cd3542c6d70d10f9$export$cf50720682a32a87 = {
    Ring0: function() {
        return $cd3542c6d70d10f9$export$e741c28ebd8a3552;
    }
};
var $cd3542c6d70d10f9$export$965db879d0c14bc1 = {
    degree: function(v) {
        if (v instanceof $cd3542c6d70d10f9$export$33ca3b017f2e3089) return 0;
        if (v instanceof $cd3542c6d70d10f9$export$6bbc73627dceae86) return 1;
        throw new Error("Failed pattern match at Data.Int (line 137, column 1 - line 141, column 17): " + [
            v.constructor.name
        ]);
    },
    div: function(x) {
        return function(v) {
            return x;
        };
    },
    mod: function(v) {
        return function(v1) {
            return $cd3542c6d70d10f9$export$33ca3b017f2e3089.value;
        };
    },
    CommutativeRing0: function() {
        return $cd3542c6d70d10f9$export$cf50720682a32a87;
    }
};
var $cd3542c6d70d10f9$export$803ce6b71a0a94b2 = function($40) {
    return $cd3542c6d70d10f9$var$unsafeClamp($heEVZ.ceil($40));
};
var $cd3542c6d70d10f9$export$fc5d11f6ca2bf4fc = /* #__PURE__ */ function() {
    return {
        bottom: $cd3542c6d70d10f9$export$33ca3b017f2e3089.value,
        top: $cd3542c6d70d10f9$export$6bbc73627dceae86.value,
        Ord0: function() {
            return $cd3542c6d70d10f9$export$8b12bf30fdd3264f;
        }
    };
}();
var $cd3542c6d70d10f9$export$33902b7329277358 = 2;
var $cd3542c6d70d10f9$export$95b61e7c39ae893a = 36;

});
parcelRegister("dbLcE", function(module, exports) {

$parcel$export(module.exports, "fromNumberImpl", () => $99a0eafcc8d1fb51$export$5b3229f64c38e483);
$parcel$export(module.exports, "toNumber", () => $99a0eafcc8d1fb51$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "fromStringAsImpl", () => $99a0eafcc8d1fb51$export$221b4f162df9878c);
$parcel$export(module.exports, "toStringAs", () => $99a0eafcc8d1fb51$export$f601457c5ee3082f);
$parcel$export(module.exports, "quot", () => $99a0eafcc8d1fb51$export$dcbbe75d5a67af21);
const $99a0eafcc8d1fb51$export$5b3229f64c38e483 = function(just) {
    return function(nothing) {
        return function(n) {
            /* jshint bitwise: false */ return (n | 0) === n ? just(n) : nothing;
        };
    };
};
const $99a0eafcc8d1fb51$export$a0a81dc3380ce7d3 = function(n) {
    return n;
};
const $99a0eafcc8d1fb51$export$221b4f162df9878c = function(just) {
    return function(nothing) {
        return function(radix) {
            var digits;
            if (radix < 11) digits = "[0-" + (radix - 1).toString() + "]";
            else if (radix === 11) digits = "[0-9a]";
            else digits = "[0-9a-" + String.fromCharCode(86 + radix) + "]";
            var pattern = new RegExp("^[\\+\\-]?" + digits + "+$", "i");
            return function(s) {
                /* jshint bitwise: false */ if (pattern.test(s)) {
                    var i = parseInt(s, radix);
                    return (i | 0) === i ? just(i) : nothing;
                } else return nothing;
            };
        };
    };
};
const $99a0eafcc8d1fb51$export$f601457c5ee3082f = function(radix) {
    return function(i) {
        return i.toString(radix);
    };
};
const $99a0eafcc8d1fb51$export$dcbbe75d5a67af21 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x / y | 0;
    };
};
const $99a0eafcc8d1fb51$export$fb1897a40d146f7f = function(x) {
    return function(y) {
        return x % y;
    };
};
const $99a0eafcc8d1fb51$export$9c297f60e22e3389 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return Math.pow(x, y) | 0;
    };
};

});

parcelRegister("kBxBi", function(module, exports) {

$parcel$export(module.exports, "isFinite", () => (parcelRequire("heEVZ")).isFinite);
$parcel$export(module.exports, "ceil", () => (parcelRequire("heEVZ")).ceil);
$parcel$export(module.exports, "floor", () => (parcelRequire("heEVZ")).floor);
$parcel$export(module.exports, "round", () => (parcelRequire("heEVZ")).round);
$parcel$export(module.exports, "trunc", () => (parcelRequire("heEVZ")).trunc);
// Generated by purs version 0.15.16

var $heEVZ = parcelRequire("heEVZ");

var $h2xUu = parcelRequire("h2xUu");
var $f00153b507096586$export$a4b4b4d4d776fe92 = 6.283185307179586;
var $f00153b507096586$export$2fa35f36c870f3b7 = 1.4142135623730951;
var $f00153b507096586$export$9eaf1e6179158e34 = 0.7071067811865476;
var $f00153b507096586$export$18c7bea995a110f = 3.141592653589793;
var $f00153b507096586$export$4d03748825f009b9 = 1.4426950408889634;
var $f00153b507096586$export$4ca92b5d1d793bd5 = 0.4342944819032518;
var $f00153b507096586$export$27692bafabcf0fdc = 0.6931471805599453;
var $f00153b507096586$export$e1abf6863d05a89e = 2.302585092994046;
var $f00153b507096586$export$3004f64547af360e = function(str) {
    return $heEVZ.fromStringImpl(str, $heEVZ.isFinite, $h2xUu.Just.create, $h2xUu.Nothing.value);
};
var $f00153b507096586$export$f1e1789686576879 = 2.718281828459045;

});
parcelRegister("heEVZ", function(module, exports) {

$parcel$export(module.exports, "isFinite", () => $c8c37f2d1ee12464$export$65f0b13f2f82375a);
$parcel$export(module.exports, "fromStringImpl", () => $c8c37f2d1ee12464$export$3ffe08ccbe76f69e);
$parcel$export(module.exports, "ceil", () => $c8c37f2d1ee12464$export$803ce6b71a0a94b2);
$parcel$export(module.exports, "floor", () => $c8c37f2d1ee12464$export$a3fe094919f356fd);
$parcel$export(module.exports, "round", () => $c8c37f2d1ee12464$export$2077e0241d6afd3c);
$parcel$export(module.exports, "trunc", () => $c8c37f2d1ee12464$export$1fe87bd59b089f0);
/* globals exports */ const $c8c37f2d1ee12464$export$9e06de0973666692 = NaN;
const $c8c37f2d1ee12464$export$c9f5652083b8129d = isNaN;
const $c8c37f2d1ee12464$export$a0978488bc4efbee = Infinity;
const $c8c37f2d1ee12464$export$65f0b13f2f82375a = isFinite;
function $c8c37f2d1ee12464$export$3ffe08ccbe76f69e(str, isFinite1, just, nothing) {
    var num = parseFloat(str);
    if (isFinite1(num)) return just(num);
    else return nothing;
}
const $c8c37f2d1ee12464$export$2335f513bbd82c6d = Math.abs;
const $c8c37f2d1ee12464$export$fd6306be3fde5b04 = Math.acos;
const $c8c37f2d1ee12464$export$41726bdb1fc63f = Math.asin;
const $c8c37f2d1ee12464$export$628dc4eed22b0fbd = Math.atan;
const $c8c37f2d1ee12464$export$b8b770ee6a0d9760 = function(y) {
    return function(x) {
        return Math.atan2(y, x);
    };
};
const $c8c37f2d1ee12464$export$803ce6b71a0a94b2 = Math.ceil;
const $c8c37f2d1ee12464$export$50d414a77b60d802 = Math.cos;
const $c8c37f2d1ee12464$export$b310ec824aaee37f = Math.exp;
const $c8c37f2d1ee12464$export$a3fe094919f356fd = Math.floor;
const $c8c37f2d1ee12464$export$bef1f36f5486a6a3 = Math.log;
const $c8c37f2d1ee12464$export$8960430cfd85939f = function(n1) {
    return function(n2) {
        return Math.max(n1, n2);
    };
};
const $c8c37f2d1ee12464$export$96ec731ed4dcb222 = function(n1) {
    return function(n2) {
        return Math.min(n1, n2);
    };
};
const $c8c37f2d1ee12464$export$9c297f60e22e3389 = function(n) {
    return function(p) {
        return Math.pow(n, p);
    };
};
const $c8c37f2d1ee12464$export$159037f780d3415c = function(n) {
    return function(m) {
        return n % m;
    };
};
const $c8c37f2d1ee12464$export$2077e0241d6afd3c = Math.round;
const $c8c37f2d1ee12464$export$c5552dfdbc7cec71 = Math.sign ? Math.sign : function(x) {
    return x === 0 || x !== x ? x : x < 0 ? -1 : 1;
};
const $c8c37f2d1ee12464$export$5de3937cb4b592ed = Math.sin;
const $c8c37f2d1ee12464$export$eba8049fb5020b81 = Math.sqrt;
const $c8c37f2d1ee12464$export$fcdd3b0b3246a325 = Math.tan;
const $c8c37f2d1ee12464$export$1fe87bd59b089f0 = Math.trunc ? Math.trunc : function(x) {
    return x < 0 ? Math.ceil(x) : Math.floor(x);
};

});



parcelRegister("4Fu8m", function(module, exports) {

$parcel$export(module.exports, "toChar", () => $36625dbcd893582a$export$bafb3da1554990db);
$parcel$export(module.exports, "lastIndexOf$prime", () => $36625dbcd893582a$export$9dc3eed83bb14216);
$parcel$export(module.exports, "lastIndexOf", () => $36625dbcd893582a$export$557cfb7ed375eeb7);
$parcel$export(module.exports, "indexOf", () => $36625dbcd893582a$export$305f7d4e9d4624f2);
$parcel$export(module.exports, "charAt", () => $36625dbcd893582a$export$bbcf894add1d392c);
$parcel$export(module.exports, "singleton", () => (parcelRequire("f2i2N")).singleton);
$parcel$export(module.exports, "fromCharArray", () => (parcelRequire("f2i2N")).fromCharArray);
$parcel$export(module.exports, "toCharArray", () => (parcelRequire("f2i2N")).toCharArray);
$parcel$export(module.exports, "length", () => (parcelRequire("f2i2N")).length);
$parcel$export(module.exports, "take", () => (parcelRequire("f2i2N")).take);
$parcel$export(module.exports, "drop", () => (parcelRequire("f2i2N")).drop);
// Generated by purs version 0.15.16

var $f2i2N = parcelRequire("f2i2N");

var $h2xUu = parcelRequire("h2xUu");
parcelRequire("d4c0k");
var $4pzyG = parcelRequire("4pzyG");
var $36625dbcd893582a$export$b446f6baa3bb1430 = function(v) {
    if (v === "") return $h2xUu.Nothing.value;
    return new $h2xUu.Just({
        head: $4pzyG.charAt(0)(v),
        tail: $f2i2N.drop(1)(v)
    });
};
var $36625dbcd893582a$export$bafb3da1554990db = /* #__PURE__ */ function() {
    return $f2i2N._toChar($h2xUu.Just.create)($h2xUu.Nothing.value);
}();
var $36625dbcd893582a$export$9384c7afe4015e42 = function(p) {
    return function(s) {
        return $f2i2N.take($f2i2N.countPrefix(p)(s))(s);
    };
};
var $36625dbcd893582a$export$1bbc425ddca7f2c6 = function(i) {
    return function(s) {
        return $f2i2N.drop($f2i2N.length(s) - i | 0)(s);
    };
};
var $36625dbcd893582a$export$cc5663efaab5bcf6 = function(v) {
    return function(str) {
        var v1 = $f2i2N.splitAt($f2i2N.length(str) - $f2i2N.length(v) | 0)(str);
        var $14 = v1.after === v;
        if ($14) return new $h2xUu.Just(v1.before);
        return $h2xUu.Nothing.value;
    };
};
var $36625dbcd893582a$export$71c2a1babd78d286 = function(v) {
    return function(str) {
        var v1 = $f2i2N.splitAt($f2i2N.length(v))(str);
        var $20 = v1.before === v;
        if ($20) return new $h2xUu.Just(v1.after);
        return $h2xUu.Nothing.value;
    };
};
var $36625dbcd893582a$export$9dc3eed83bb14216 = /* #__PURE__ */ function() {
    return $f2i2N._lastIndexOfStartingAt($h2xUu.Just.create)($h2xUu.Nothing.value);
}();
var $36625dbcd893582a$export$557cfb7ed375eeb7 = /* #__PURE__ */ function() {
    return $f2i2N._lastIndexOf($h2xUu.Just.create)($h2xUu.Nothing.value);
}();
var $36625dbcd893582a$export$7f0e23922170149a = /* #__PURE__ */ function() {
    return $f2i2N._indexOfStartingAt($h2xUu.Just.create)($h2xUu.Nothing.value);
}();
var $36625dbcd893582a$export$305f7d4e9d4624f2 = /* #__PURE__ */ function() {
    return $f2i2N._indexOf($h2xUu.Just.create)($h2xUu.Nothing.value);
}();
var $36625dbcd893582a$export$533af5c8cd6afa16 = function(p) {
    return function(s) {
        return $f2i2N.drop($f2i2N.countPrefix(p)(s))(s);
    };
};
var $36625dbcd893582a$export$6ba801e3e123536e = function(i) {
    return function(s) {
        return $f2i2N.take($f2i2N.length(s) - i | 0)(s);
    };
};
var $36625dbcd893582a$export$2344b14b097df817 = function(pat) {
    var $23 = $36625dbcd893582a$export$305f7d4e9d4624f2(pat);
    return function($24) {
        return $h2xUu.isJust($23($24));
    };
};
var $36625dbcd893582a$export$bbcf894add1d392c = /* #__PURE__ */ function() {
    return $f2i2N._charAt($h2xUu.Just.create)($h2xUu.Nothing.value);
}();

});
parcelRegister("f2i2N", function(module, exports) {

$parcel$export(module.exports, "fromCharArray", () => $af250a1511e077bf$export$709e3b51bf2e2249);
$parcel$export(module.exports, "toCharArray", () => $af250a1511e077bf$export$f718f38b069557c4);
$parcel$export(module.exports, "singleton", () => $af250a1511e077bf$export$439306a4dcaafbb9);
$parcel$export(module.exports, "_charAt", () => $af250a1511e077bf$export$f23b62aaf3f3dcce);
$parcel$export(module.exports, "_toChar", () => $af250a1511e077bf$export$dc80a44c5e0495a);
$parcel$export(module.exports, "length", () => $af250a1511e077bf$export$f24224f1c91d8156);
$parcel$export(module.exports, "countPrefix", () => $af250a1511e077bf$export$29a68f758c141c85);
$parcel$export(module.exports, "_indexOf", () => $af250a1511e077bf$export$7e78e83ef6946ae3);
$parcel$export(module.exports, "_indexOfStartingAt", () => $af250a1511e077bf$export$dbaa25b6da818165);
$parcel$export(module.exports, "_lastIndexOf", () => $af250a1511e077bf$export$a83518545dfc0fc1);
$parcel$export(module.exports, "_lastIndexOfStartingAt", () => $af250a1511e077bf$export$12738dfb878f3de0);
$parcel$export(module.exports, "take", () => $af250a1511e077bf$export$b7df5d561049483a);
$parcel$export(module.exports, "drop", () => $af250a1511e077bf$export$663103110d94aac9);
$parcel$export(module.exports, "splitAt", () => $af250a1511e077bf$export$b0d75975ac0be0e1);
const $af250a1511e077bf$export$709e3b51bf2e2249 = function(a) {
    return a.join("");
};
const $af250a1511e077bf$export$f718f38b069557c4 = function(s) {
    return s.split("");
};
const $af250a1511e077bf$export$439306a4dcaafbb9 = function(c) {
    return c;
};
const $af250a1511e077bf$export$f23b62aaf3f3dcce = function(just) {
    return function(nothing) {
        return function(i) {
            return function(s) {
                return i >= 0 && i < s.length ? just(s.charAt(i)) : nothing;
            };
        };
    };
};
const $af250a1511e077bf$export$dc80a44c5e0495a = function(just) {
    return function(nothing) {
        return function(s) {
            return s.length === 1 ? just(s) : nothing;
        };
    };
};
const $af250a1511e077bf$export$f24224f1c91d8156 = function(s) {
    return s.length;
};
const $af250a1511e077bf$export$29a68f758c141c85 = function(p) {
    return function(s) {
        var i = 0;
        while(i < s.length && p(s.charAt(i)))i++;
        return i;
    };
};
const $af250a1511e077bf$export$7e78e83ef6946ae3 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(s) {
                var i = s.indexOf(x);
                return i === -1 ? nothing : just(i);
            };
        };
    };
};
const $af250a1511e077bf$export$dbaa25b6da818165 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(startAt) {
                return function(s) {
                    if (startAt < 0 || startAt > s.length) return nothing;
                    var i = s.indexOf(x, startAt);
                    return i === -1 ? nothing : just(i);
                };
            };
        };
    };
};
const $af250a1511e077bf$export$a83518545dfc0fc1 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(s) {
                var i = s.lastIndexOf(x);
                return i === -1 ? nothing : just(i);
            };
        };
    };
};
const $af250a1511e077bf$export$12738dfb878f3de0 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(startAt) {
                return function(s) {
                    var i = s.lastIndexOf(x, startAt);
                    return i === -1 ? nothing : just(i);
                };
            };
        };
    };
};
const $af250a1511e077bf$export$b7df5d561049483a = function(n) {
    return function(s) {
        return s.substr(0, n);
    };
};
const $af250a1511e077bf$export$663103110d94aac9 = function(n) {
    return function(s) {
        return s.substring(n);
    };
};
const $af250a1511e077bf$export$58adb3bec8346d0f = function(b) {
    return function(e) {
        return function(s) {
            return s.slice(b, e);
        };
    };
};
const $af250a1511e077bf$export$b0d75975ac0be0e1 = function(i) {
    return function(s) {
        return {
            before: s.substring(0, i),
            after: s.substring(i)
        };
    };
};

});

parcelRegister("d4c0k", function(module, exports) {

$parcel$export(module.exports, "charAt", () => (parcelRequire("4pzyG")).charAt);
// Generated by purs version 0.15.16

var $4pzyG = parcelRequire("4pzyG");

});
parcelRegister("4pzyG", function(module, exports) {

$parcel$export(module.exports, "charAt", () => $33651463a4429909$export$bbcf894add1d392c);
const $33651463a4429909$export$bbcf894add1d392c = function(i) {
    return function(s) {
        if (i >= 0 && i < s.length) return s.charAt(i);
        throw new Error("Data.String.Unsafe.charAt: Invalid index.");
    };
};
const $33651463a4429909$export$eba6f6f03b0a92e7 = function(s) {
    if (s.length === 1) return s.charAt(0);
    throw new Error("Data.String.Unsafe.char: Expected string of length 1.");
};

});



parcelRegister("d8ahy", function(module, exports) {

$parcel$export(module.exports, "split", () => (parcelRequire("3BU4Z")).split);
$parcel$export(module.exports, "toLower", () => (parcelRequire("3BU4Z")).toLower);
$parcel$export(module.exports, "toUpper", () => (parcelRequire("3BU4Z")).toUpper);
$parcel$export(module.exports, "joinWith", () => (parcelRequire("3BU4Z")).joinWith);
// Generated by purs version 0.15.16

var $3BU4Z = parcelRequire("3BU4Z");

var $ibsD5 = parcelRequire("ibsD5");
var $98f3ff88829806c5$export$7b1b591b262c240 = function(s) {
    return s === "";
};
var $98f3ff88829806c5$export$35652c12e6caefdf = /* #__PURE__ */ function() {
    return $3BU4Z._localeCompare($ibsD5.LT.value)($ibsD5.EQ.value)($ibsD5.GT.value);
}();

});
parcelRegister("3BU4Z", function(module, exports) {

$parcel$export(module.exports, "_localeCompare", () => $2a1053ff2e6c7f23$export$3ece336175b57f19);
$parcel$export(module.exports, "split", () => $2a1053ff2e6c7f23$export$65980d18b75784e2);
$parcel$export(module.exports, "toLower", () => $2a1053ff2e6c7f23$export$b1ceac3893cbda6b);
$parcel$export(module.exports, "toUpper", () => $2a1053ff2e6c7f23$export$43df7fc17cca38a4);
$parcel$export(module.exports, "joinWith", () => $2a1053ff2e6c7f23$export$ec1dc8fbeea3467e);
const $2a1053ff2e6c7f23$export$3ece336175b57f19 = function(lt) {
    return function(eq) {
        return function(gt) {
            return function(s1) {
                return function(s2) {
                    var result = s1.localeCompare(s2);
                    return result < 0 ? lt : result > 0 ? gt : eq;
                };
            };
        };
    };
};
const $2a1053ff2e6c7f23$export$77ad94ebf1c2b9ed = function(s1) {
    return function(s2) {
        return function(s3) {
            return s3.replace(s1, s2);
        };
    };
};
const $2a1053ff2e6c7f23$export$b8b3234b4edfc4c2 = function(s1) {
    return function(s2) {
        return function(s3) {
            return s3.replace(new RegExp(s1.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"), "g"), s2); // eslint-disable-line no-useless-escape
        };
    };
};
const $2a1053ff2e6c7f23$export$65980d18b75784e2 = function(sep) {
    return function(s) {
        return s.split(sep);
    };
};
const $2a1053ff2e6c7f23$export$b1ceac3893cbda6b = function(s) {
    return s.toLowerCase();
};
const $2a1053ff2e6c7f23$export$43df7fc17cca38a4 = function(s) {
    return s.toUpperCase();
};
const $2a1053ff2e6c7f23$export$87c2784dc9fc4ab = function(s) {
    return s.trim();
};
const $2a1053ff2e6c7f23$export$ec1dc8fbeea3467e = function(s) {
    return function(xs) {
        return xs.join(s);
    };
};

});


parcelRegister("lqv9L", function(module, exports) {

$parcel$export(module.exports, "unsafeCrashWith", () => $f99431b919b164e1$export$51b220bae4359b72);
// Generated by purs version 0.15.16

var $h6pzw = parcelRequire("h6pzw");

var $bN6ax = parcelRequire("bN6ax");
var $f99431b919b164e1$var$crashWith = /* #__PURE__ */ $bN6ax.crashWith();
var $f99431b919b164e1$export$cb50937af21de128 = $h6pzw._unsafePartial;
var $f99431b919b164e1$export$51b220bae4359b72 = function(msg) {
    return $f99431b919b164e1$export$cb50937af21de128(function() {
        return $f99431b919b164e1$var$crashWith(msg);
    });
};

});
parcelRegister("h6pzw", function(module, exports) {

$parcel$export(module.exports, "_unsafePartial", () => $c736d53eafaf6387$export$3e8f060a4c73ba81);
// module Partial.Unsafe
const $c736d53eafaf6387$export$3e8f060a4c73ba81 = function(f) {
    return f();
};

});

parcelRegister("bN6ax", function(module, exports) {

$parcel$export(module.exports, "crashWith", () => $89590e574b24655a$export$ddf616d7646fcc8e);
// Generated by purs version 0.15.16

var $j0kgQ = parcelRequire("j0kgQ");
var $89590e574b24655a$export$ddf616d7646fcc8e = function() {
    return $j0kgQ._crashWith;
};
var $89590e574b24655a$var$crashWith1 = /* #__PURE__ */ $89590e574b24655a$export$ddf616d7646fcc8e();
var $89590e574b24655a$export$dcc9d38dbc7992eb = function() {
    return $89590e574b24655a$var$crashWith1("Partial.crash: partial function");
};

});
parcelRegister("j0kgQ", function(module, exports) {

$parcel$export(module.exports, "_crashWith", () => $dd5dbdc0ceec542e$export$b479f9f69f916b6a);
// module Partial
const $dd5dbdc0ceec542e$export$b479f9f69f916b6a = function(msg) {
    throw new Error(msg);
};

});



parcelRegister("3gIn7", function(module, exports) {

$parcel$export(module.exports, "showLazy", () => $2615491202fc3b5a$export$bb0ce398898c1c48);
$parcel$export(module.exports, "functorLazy", () => $2615491202fc3b5a$export$3780b8670d5f24f8);
$parcel$export(module.exports, "eqLazy", () => $2615491202fc3b5a$export$1c9d1a32b20e91d5);
$parcel$export(module.exports, "ordLazy", () => $2615491202fc3b5a$export$cbabaf21b7e8b5db);
$parcel$export(module.exports, "eq1Lazy", () => $2615491202fc3b5a$export$4fb3dc255b34fa12);
$parcel$export(module.exports, "ord1Lazy", () => $2615491202fc3b5a$export$d65b504a31b57308);
$parcel$export(module.exports, "applyLazy", () => $2615491202fc3b5a$export$c3ec2aebe6109e81);
$parcel$export(module.exports, "applicativeLazy", () => $2615491202fc3b5a$export$28587442a46d4141);
$parcel$export(module.exports, "defer", () => (parcelRequire("hQCDc")).defer);
$parcel$export(module.exports, "force", () => (parcelRequire("hQCDc")).force);
// Generated by purs version 0.15.16

var $hQCDc = parcelRequire("hQCDc");

var $26ZCq = parcelRequire("26ZCq");

var $8zsOy = parcelRequire("8zsOy");

var $aJhEx = parcelRequire("aJhEx");

var $8tuSi = parcelRequire("8tuSi");

var $dNwPt = parcelRequire("dNwPt");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $7nwca = parcelRequire("7nwca");

var $IhyKA = parcelRequire("IhyKA");

var $3aOYV = parcelRequire("3aOYV");

var $gwBF5 = parcelRequire("gwBF5");

var $aop8q = parcelRequire("aop8q");

var $d5vvq = parcelRequire("d5vvq");

var $iVjQa = parcelRequire("iVjQa");

var $2XxiF = parcelRequire("2XxiF");

var $9OOYG = parcelRequire("9OOYG");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
var $2615491202fc3b5a$export$bb0ce398898c1c48 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(x) {
            return "(defer \\_ -> " + (show($hQCDc.force(x)) + ")");
        }
    };
};
var $2615491202fc3b5a$export$a23c81c7931f53a = function(dictSemiring) {
    var add = $iVjQa.add(dictSemiring);
    var zero = $iVjQa.zero(dictSemiring);
    var mul = $iVjQa.mul(dictSemiring);
    var one = $iVjQa.one(dictSemiring);
    return {
        add: function(a) {
            return function(b) {
                return $hQCDc.defer(function(v) {
                    return add($hQCDc.force(a))($hQCDc.force(b));
                });
            };
        },
        zero: $hQCDc.defer(function(v) {
            return zero;
        }),
        mul: function(a) {
            return function(b) {
                return $hQCDc.defer(function(v) {
                    return mul($hQCDc.force(a))($hQCDc.force(b));
                });
            };
        },
        one: $hQCDc.defer(function(v) {
            return one;
        })
    };
};
var $2615491202fc3b5a$export$8400f884b0cf16b1 = function(dictSemigroup) {
    var append1 = $d5vvq.append(dictSemigroup);
    return {
        append: function(a) {
            return function(b) {
                return $hQCDc.defer(function(v) {
                    return append1($hQCDc.force(a))($hQCDc.force(b));
                });
            };
        }
    };
};
var $2615491202fc3b5a$export$6dfc43186b725e5c = function(dictRing) {
    var sub = $aop8q.sub(dictRing);
    var semiringLazy1 = $2615491202fc3b5a$export$a23c81c7931f53a(dictRing.Semiring0());
    return {
        sub: function(a) {
            return function(b) {
                return $hQCDc.defer(function(v) {
                    return sub($hQCDc.force(a))($hQCDc.force(b));
                });
            };
        },
        Semiring0: function() {
            return semiringLazy1;
        }
    };
};
var $2615491202fc3b5a$export$fe3e07ed2de45f8f = function(dictMonoid) {
    var mempty = $3aOYV.mempty(dictMonoid);
    var semigroupLazy1 = $2615491202fc3b5a$export$8400f884b0cf16b1(dictMonoid.Semigroup0());
    return {
        mempty: $hQCDc.defer(function(v) {
            return mempty;
        }),
        Semigroup0: function() {
            return semigroupLazy1;
        }
    };
};
var $2615491202fc3b5a$export$56fd27feb83d90f5 = {
    defer: function(f) {
        return $hQCDc.defer(function(v) {
            return $hQCDc.force(f($ivFwO.unit));
        });
    }
};
var $2615491202fc3b5a$export$3780b8670d5f24f8 = {
    map: function(f) {
        return function(l) {
            return $hQCDc.defer(function(v) {
                return f($hQCDc.force(l));
            });
        };
    }
};
var $2615491202fc3b5a$var$map = /* #__PURE__ */ $7FzSN.map($2615491202fc3b5a$export$3780b8670d5f24f8);
var $2615491202fc3b5a$export$8f588843775274ce = {
    mapWithIndex: function(f) {
        return $2615491202fc3b5a$var$map(f($ivFwO.unit));
    },
    Functor0: function() {
        return $2615491202fc3b5a$export$3780b8670d5f24f8;
    }
};
var $2615491202fc3b5a$export$3bd0a60cfec06f1a = {
    imap: /* #__PURE__ */ $7nwca.imapF($2615491202fc3b5a$export$3780b8670d5f24f8)
};
var $2615491202fc3b5a$export$6ad686e404b9cd02 = {
    foldr: function(f) {
        return function(z) {
            return function(l) {
                return f($hQCDc.force(l))(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(l) {
                return f(z)($hQCDc.force(l));
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(l) {
                return f($hQCDc.force(l));
            };
        };
    }
};
var $2615491202fc3b5a$var$foldr = /* #__PURE__ */ $dNwPt.foldr($2615491202fc3b5a$export$6ad686e404b9cd02);
var $2615491202fc3b5a$var$foldl = /* #__PURE__ */ $dNwPt.foldl($2615491202fc3b5a$export$6ad686e404b9cd02);
var $2615491202fc3b5a$var$foldMap = /* #__PURE__ */ $dNwPt.foldMap($2615491202fc3b5a$export$6ad686e404b9cd02);
var $2615491202fc3b5a$export$c99a011ac0d986c7 = {
    foldrWithIndex: function(f) {
        return $2615491202fc3b5a$var$foldr(f($ivFwO.unit));
    },
    foldlWithIndex: function(f) {
        return $2615491202fc3b5a$var$foldl(f($ivFwO.unit));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap1 = $2615491202fc3b5a$var$foldMap(dictMonoid);
        return function(f) {
            return foldMap1(f($ivFwO.unit));
        };
    },
    Foldable0: function() {
        return $2615491202fc3b5a$export$6ad686e404b9cd02;
    }
};
var $2615491202fc3b5a$export$d75b77350c4c9111 = {
    traverse: function(dictApplicative) {
        var map1 = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(l) {
                return map1(function($103) {
                    return $hQCDc.defer($jhsiw.const($103));
                })(f($hQCDc.force(l)));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map1 = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(l) {
            return map1(function($104) {
                return $hQCDc.defer($jhsiw.const($104));
            })($hQCDc.force(l));
        };
    },
    Functor0: function() {
        return $2615491202fc3b5a$export$3780b8670d5f24f8;
    },
    Foldable1: function() {
        return $2615491202fc3b5a$export$6ad686e404b9cd02;
    }
};
var $2615491202fc3b5a$var$traverse = /* #__PURE__ */ $9OOYG.traverse($2615491202fc3b5a$export$d75b77350c4c9111);
var $2615491202fc3b5a$export$1c9f73288a97bff6 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse1 = $2615491202fc3b5a$var$traverse(dictApplicative);
        return function(f) {
            return traverse1(f($ivFwO.unit));
        };
    },
    FunctorWithIndex0: function() {
        return $2615491202fc3b5a$export$8f588843775274ce;
    },
    FoldableWithIndex1: function() {
        return $2615491202fc3b5a$export$c99a011ac0d986c7;
    },
    Traversable2: function() {
        return $2615491202fc3b5a$export$d75b77350c4c9111;
    }
};
var $2615491202fc3b5a$export$8d84e581926eaeba = {
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(l) {
                return f($hQCDc.force(l));
            };
        };
    },
    foldr1: function(v) {
        return function(l) {
            return $hQCDc.force(l);
        };
    },
    foldl1: function(v) {
        return function(l) {
            return $hQCDc.force(l);
        };
    },
    Foldable0: function() {
        return $2615491202fc3b5a$export$6ad686e404b9cd02;
    }
};
var $2615491202fc3b5a$export$316fa2792966d831 = {
    traverse1: function(dictApply) {
        var map1 = $7FzSN.map(dictApply.Functor0());
        return function(f) {
            return function(l) {
                return map1(function($105) {
                    return $hQCDc.defer($jhsiw.const($105));
                })(f($hQCDc.force(l)));
            };
        };
    },
    sequence1: function(dictApply) {
        var map1 = $7FzSN.map(dictApply.Functor0());
        return function(l) {
            return map1(function($106) {
                return $hQCDc.defer($jhsiw.const($106));
            })($hQCDc.force(l));
        };
    },
    Foldable10: function() {
        return $2615491202fc3b5a$export$8d84e581926eaeba;
    },
    Traversable1: function() {
        return $2615491202fc3b5a$export$d75b77350c4c9111;
    }
};
var $2615491202fc3b5a$export$5db1a0137683eb80 = {
    extend: function(f) {
        return function(x) {
            return $hQCDc.defer(function(v) {
                return f(x);
            });
        };
    },
    Functor0: function() {
        return $2615491202fc3b5a$export$3780b8670d5f24f8;
    }
};
var $2615491202fc3b5a$export$1c9d1a32b20e91d5 = function(dictEq) {
    var eq = $aJhEx.eq(dictEq);
    return {
        eq: function(x) {
            return function(y) {
                return eq($hQCDc.force(x))($hQCDc.force(y));
            };
        }
    };
};
var $2615491202fc3b5a$export$cbabaf21b7e8b5db = function(dictOrd) {
    var compare = $gwBF5.compare(dictOrd);
    var eqLazy1 = $2615491202fc3b5a$export$1c9d1a32b20e91d5(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                return compare($hQCDc.force(x))($hQCDc.force(y));
            };
        },
        Eq0: function() {
            return eqLazy1;
        }
    };
};
var $2615491202fc3b5a$export$4fb3dc255b34fa12 = {
    eq1: function(dictEq) {
        return $aJhEx.eq($2615491202fc3b5a$export$1c9d1a32b20e91d5(dictEq));
    }
};
var $2615491202fc3b5a$export$d65b504a31b57308 = {
    compare1: function(dictOrd) {
        return $gwBF5.compare($2615491202fc3b5a$export$cbabaf21b7e8b5db(dictOrd));
    },
    Eq10: function() {
        return $2615491202fc3b5a$export$4fb3dc255b34fa12;
    }
};
var $2615491202fc3b5a$export$544fccaec3eca1d4 = {
    extract: $hQCDc.force,
    Extend0: function() {
        return $2615491202fc3b5a$export$5db1a0137683eb80;
    }
};
var $2615491202fc3b5a$export$b0aa908a8262dbd4 = function(dictCommutativeRing) {
    var ringLazy1 = $2615491202fc3b5a$export$6dfc43186b725e5c(dictCommutativeRing.Ring0());
    return {
        Ring0: function() {
            return ringLazy1;
        }
    };
};
var $2615491202fc3b5a$export$d150da49d30e2076 = function(dictEuclideanRing) {
    var div = $8tuSi.div(dictEuclideanRing);
    var mod = $8tuSi.mod(dictEuclideanRing);
    var commutativeRingLazy1 = $2615491202fc3b5a$export$b0aa908a8262dbd4(dictEuclideanRing.CommutativeRing0());
    return {
        degree: function() {
            var $107 = $8tuSi.degree(dictEuclideanRing);
            return function($108) {
                return $107($hQCDc.force($108));
            };
        }(),
        div: function(a) {
            return function(b) {
                return $hQCDc.defer(function(v) {
                    return div($hQCDc.force(a))($hQCDc.force(b));
                });
            };
        },
        mod: function(a) {
            return function(b) {
                return $hQCDc.defer(function(v) {
                    return mod($hQCDc.force(a))($hQCDc.force(b));
                });
            };
        },
        CommutativeRing0: function() {
            return commutativeRingLazy1;
        }
    };
};
var $2615491202fc3b5a$export$aabc837ad904b190 = function(dictBounded) {
    var top = $8zsOy.top(dictBounded);
    var bottom = $8zsOy.bottom(dictBounded);
    var ordLazy1 = $2615491202fc3b5a$export$cbabaf21b7e8b5db(dictBounded.Ord0());
    return {
        top: $hQCDc.defer(function(v) {
            return top;
        }),
        bottom: $hQCDc.defer(function(v) {
            return bottom;
        }),
        Ord0: function() {
            return ordLazy1;
        }
    };
};
var $2615491202fc3b5a$export$c3ec2aebe6109e81 = {
    apply: function(f) {
        return function(x) {
            return $hQCDc.defer(function(v) {
                return $hQCDc.force(f)($hQCDc.force(x));
            });
        };
    },
    Functor0: function() {
        return $2615491202fc3b5a$export$3780b8670d5f24f8;
    }
};
var $2615491202fc3b5a$var$apply = /* #__PURE__ */ $26ZCq.apply($2615491202fc3b5a$export$c3ec2aebe6109e81);
var $2615491202fc3b5a$export$e1a4485e8a67faf2 = {
    bind: function(l) {
        return function(f) {
            return $hQCDc.defer(function(v) {
                return $hQCDc.force(f($hQCDc.force(l)));
            });
        };
    },
    Apply0: function() {
        return $2615491202fc3b5a$export$c3ec2aebe6109e81;
    }
};
var $2615491202fc3b5a$export$89956d4f263e939b = function(dictHeytingAlgebra) {
    var ff = $IhyKA.ff(dictHeytingAlgebra);
    var tt = $IhyKA.tt(dictHeytingAlgebra);
    var implies = $IhyKA.implies(dictHeytingAlgebra);
    var conj = $IhyKA.conj(dictHeytingAlgebra);
    var disj = $IhyKA.disj(dictHeytingAlgebra);
    var not = $IhyKA.not(dictHeytingAlgebra);
    return {
        ff: $hQCDc.defer(function(v) {
            return ff;
        }),
        tt: $hQCDc.defer(function(v) {
            return tt;
        }),
        implies: function(a) {
            return function(b) {
                return $2615491202fc3b5a$var$apply($2615491202fc3b5a$var$map(implies)(a))(b);
            };
        },
        conj: function(a) {
            return function(b) {
                return $2615491202fc3b5a$var$apply($2615491202fc3b5a$var$map(conj)(a))(b);
            };
        },
        disj: function(a) {
            return function(b) {
                return $2615491202fc3b5a$var$apply($2615491202fc3b5a$var$map(disj)(a))(b);
            };
        },
        not: function(a) {
            return $2615491202fc3b5a$var$map(not)(a);
        }
    };
};
var $2615491202fc3b5a$export$27ff7cba27a505be = function(dictBooleanAlgebra) {
    var heytingAlgebraLazy1 = $2615491202fc3b5a$export$89956d4f263e939b(dictBooleanAlgebra.HeytingAlgebra0());
    return {
        HeytingAlgebra0: function() {
            return heytingAlgebraLazy1;
        }
    };
};
var $2615491202fc3b5a$export$28587442a46d4141 = {
    pure: function(a) {
        return $hQCDc.defer(function(v) {
            return a;
        });
    },
    Apply0: function() {
        return $2615491202fc3b5a$export$c3ec2aebe6109e81;
    }
};
var $2615491202fc3b5a$export$cfa2e2b570f2d5d3 = {
    Applicative0: function() {
        return $2615491202fc3b5a$export$28587442a46d4141;
    },
    Bind1: function() {
        return $2615491202fc3b5a$export$e1a4485e8a67faf2;
    }
};

});
parcelRegister("hQCDc", function(module, exports) {

$parcel$export(module.exports, "defer", () => $cfe542594b516e84$export$260e5c0943f31606);
$parcel$export(module.exports, "force", () => $cfe542594b516e84$export$4d82290515cd0ddb);
const $cfe542594b516e84$export$260e5c0943f31606 = function(thunk) {
    var v = null;
    return function() {
        if (thunk === undefined) return v;
        v = thunk();
        thunk = undefined; // eslint-disable-line no-param-reassign
        return v;
    };
};
const $cfe542594b516e84$export$4d82290515cd0ddb = function(l) {
    return l();
};

});


parcelRegister("5krR0", function(module, exports) {

$parcel$export(module.exports, "updateAt", () => $3e146d399ce3c178$export$b6d8713d53419d4c);
$parcel$export(module.exports, "uncons", () => $3e146d399ce3c178$export$b446f6baa3bb1430);
$parcel$export(module.exports, "toUnfoldable", () => $3e146d399ce3c178$export$823be24f8766da23);
$parcel$export(module.exports, "span", () => $3e146d399ce3c178$export$afc1bfabebaf28a2);
$parcel$export(module.exports, "snoc", () => $3e146d399ce3c178$export$c40cf5aab899f397);
$parcel$export(module.exports, "sortBy", () => $3e146d399ce3c178$export$b035e44d7bb4278f);
$parcel$export(module.exports, "reverse", () => $3e146d399ce3c178$export$66c1ae025e96b4bc);
$parcel$export(module.exports, "take", () => $3e146d399ce3c178$export$b7df5d561049483a);
$parcel$export(module.exports, "takeWhile", () => $3e146d399ce3c178$export$9384c7afe4015e42);
$parcel$export(module.exports, "unsnoc", () => $3e146d399ce3c178$export$712962e076096ed4);
$parcel$export(module.exports, "zipWith", () => $3e146d399ce3c178$export$b634740ce272acb5);
$parcel$export(module.exports, "zip", () => $3e146d399ce3c178$export$8901015135f2fb22);
$parcel$export(module.exports, "partition", () => $3e146d399ce3c178$export$b29f828819edca8d);
$parcel$export(module.exports, "null", () => $3e146d399ce3c178$export$7b1b591b262c240);
$parcel$export(module.exports, "nubBy", () => $3e146d399ce3c178$export$18f77a3bafa759b9);
$parcel$export(module.exports, "nub", () => $3e146d399ce3c178$export$94f4066a75b10404);
$parcel$export(module.exports, "mapMaybe", () => $3e146d399ce3c178$export$e70771d2e7e590a);
$parcel$export(module.exports, "length", () => $3e146d399ce3c178$export$f24224f1c91d8156);
$parcel$export(module.exports, "last", () => $3e146d399ce3c178$export$4c7897fafd92b108);
$parcel$export(module.exports, "insertAt", () => $3e146d399ce3c178$export$9f200c4466975173);
$parcel$export(module.exports, "init", () => $3e146d399ce3c178$export$2cd8252107eb640b);
$parcel$export(module.exports, "index", () => $3e146d399ce3c178$export$b610b8812bbcded9);
$parcel$export(module.exports, "groupBy", () => $3e146d399ce3c178$export$3f063810d7bf01bd);
$parcel$export(module.exports, "groupAllBy", () => $3e146d399ce3c178$export$1f7a5bf12caafbd);
$parcel$export(module.exports, "group", () => $3e146d399ce3c178$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "groupAll", () => $3e146d399ce3c178$export$361434b95a7d965);
$parcel$export(module.exports, "fromFoldable", () => $3e146d399ce3c178$export$b7d5d9bb9ff52072);
$parcel$export(module.exports, "foldM", () => $3e146d399ce3c178$export$7a067f9280ad8af0);
$parcel$export(module.exports, "findIndex", () => $3e146d399ce3c178$export$de3a4d4a0d731119);
$parcel$export(module.exports, "findLastIndex", () => $3e146d399ce3c178$export$8855a8be7bd3e9f8);
$parcel$export(module.exports, "filterM", () => $3e146d399ce3c178$export$20098ecb074a31e6);
$parcel$export(module.exports, "filter", () => $3e146d399ce3c178$export$3dea766d36a8935f);
$parcel$export(module.exports, "intersectBy", () => $3e146d399ce3c178$export$f161f39e9c06ab2d);
$parcel$export(module.exports, "intersect", () => $3e146d399ce3c178$export$1f4807a235930d45);
$parcel$export(module.exports, "nubByEq", () => $3e146d399ce3c178$export$45273896c792ff3b);
$parcel$export(module.exports, "nubEq", () => $3e146d399ce3c178$export$edce5881c815871);
$parcel$export(module.exports, "dropWhile", () => $3e146d399ce3c178$export$533af5c8cd6afa16);
$parcel$export(module.exports, "drop", () => $3e146d399ce3c178$export$663103110d94aac9);
$parcel$export(module.exports, "unionBy", () => $3e146d399ce3c178$export$ef1d06dc4d91d507);
$parcel$export(module.exports, "union", () => $3e146d399ce3c178$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "catMaybes", () => $3e146d399ce3c178$export$986c2bbe7a34be0b);
$parcel$export(module.exports, "modifyAt", () => $3e146d399ce3c178$export$cba09f9e3d3e58eb);
// Generated by purs version 0.15.16

var $56VjJ = parcelRequire("56VjJ");

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $26SV5 = parcelRequire("26SV5");

var $dxuBz = parcelRequire("dxuBz");

var $bcJ05 = parcelRequire("bcJ05");

var $5ZwWo = parcelRequire("5ZwWo");

var $iQTlW = parcelRequire("iQTlW");

var $aJhEx = parcelRequire("aJhEx");

var $dNwPt = parcelRequire("dNwPt");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $IhyKA = parcelRequire("IhyKA");

var $RL9Ix = parcelRequire("RL9Ix");

var $fZenR = parcelRequire("fZenR");

var $h2xUu = parcelRequire("h2xUu");

var $9aSRU = parcelRequire("9aSRU");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $d5vvq = parcelRequire("d5vvq");

var $2XxiF = parcelRequire("2XxiF");

var $9OOYG = parcelRequire("9OOYG");

var $7O0Q4 = parcelRequire("7O0Q4");

var $goKHx = parcelRequire("goKHx");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
var $3e146d399ce3c178$var$map = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $3e146d399ce3c178$var$foldr = /* #__PURE__ */ $dNwPt.foldr($fZenR.foldableList);
var $3e146d399ce3c178$var$tailRecM2 = /* #__PURE__ */ $bcJ05.tailRecM2($bcJ05.monadRecMaybe);
var $3e146d399ce3c178$var$eq = /* #__PURE__ */ $aJhEx.eq($ibsD5.eqOrdering);
var $3e146d399ce3c178$var$notEq = /* #__PURE__ */ $aJhEx.notEq($ibsD5.eqOrdering);
var $3e146d399ce3c178$var$sequence = /* #__PURE__ */ $9OOYG.sequence($fZenR.traversableList);
var $3e146d399ce3c178$var$bimap = /* #__PURE__ */ $5ZwWo.bimap($bcJ05.bifunctorStep);
var $3e146d399ce3c178$var$foldl = /* #__PURE__ */ $dNwPt.foldl($fZenR.foldableList);
var $3e146d399ce3c178$var$any = /* #__PURE__ */ $dNwPt.any($fZenR.foldableList)($IhyKA.heytingAlgebraBoolean);
var $3e146d399ce3c178$var$append1 = /* #__PURE__ */ $d5vvq.append($fZenR.semigroupList);
var $3e146d399ce3c178$var$bind = /* #__PURE__ */ $cADnC.bind($fZenR.bindList);
var $3e146d399ce3c178$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $3e146d399ce3c178$export$47606a6ae3eaed8e = function(x) {
    return x;
};
var $3e146d399ce3c178$export$b6d8713d53419d4c = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0 && v2 instanceof $fZenR.Cons) return new $h2xUu.Just(new $fZenR.Cons(v1, v2.value1));
            if (v2 instanceof $fZenR.Cons) return $3e146d399ce3c178$var$map(function(v3) {
                return new $fZenR.Cons(v2.value0, v3);
            })($3e146d399ce3c178$export$b6d8713d53419d4c(v - 1 | 0)(v1)(v2.value1));
            return $h2xUu.Nothing.value;
        };
    };
};
var $3e146d399ce3c178$export$23c8d3f8757cab88 = /* #__PURE__ */ function() {
    return $3e146d399ce3c178$var$foldr(function(v) {
        return function(v1) {
            return new $7O0Q4.Tuple(new $fZenR.Cons(v.value0, v1.value0), new $fZenR.Cons(v.value1, v1.value1));
        };
    })(new $7O0Q4.Tuple($fZenR.Nil.value, $fZenR.Nil.value));
}();
var $3e146d399ce3c178$export$b446f6baa3bb1430 = function(v) {
    if (v instanceof $fZenR.Nil) return $h2xUu.Nothing.value;
    if (v instanceof $fZenR.Cons) return new $h2xUu.Just({
        head: v.value0,
        tail: v.value1
    });
    throw new Error("Failed pattern match at Data.List (line 259, column 1 - line 259, column 66): " + [
        v.constructor.name
    ]);
};
var $3e146d399ce3c178$export$823be24f8766da23 = function(dictUnfoldable) {
    return $goKHx.unfoldr(dictUnfoldable)(function(xs) {
        return $3e146d399ce3c178$var$map(function(rec) {
            return new $7O0Q4.Tuple(rec.head, rec.tail);
        })($3e146d399ce3c178$export$b446f6baa3bb1430(xs));
    });
};
var $3e146d399ce3c178$export$c01875f616615628 = function(v) {
    if (v instanceof $fZenR.Nil) return $h2xUu.Nothing.value;
    if (v instanceof $fZenR.Cons) return new $h2xUu.Just(v.value1);
    throw new Error("Failed pattern match at Data.List (line 245, column 1 - line 245, column 43): " + [
        v.constructor.name
    ]);
};
var $3e146d399ce3c178$export$71c2a1babd78d286 = function(dictEq) {
    var eq2 = $aJhEx.eq(dictEq);
    return function(v) {
        return function(s) {
            var go = function(prefix) {
                return function(input) {
                    if (prefix instanceof $fZenR.Cons && input instanceof $fZenR.Cons && eq2(prefix.value0)(input.value0)) return new $h2xUu.Just(new $bcJ05.Loop({
                        a: prefix.value1,
                        b: input.value1
                    }));
                    if (prefix instanceof $fZenR.Nil) return new $h2xUu.Just(new $bcJ05.Done(input));
                    return $h2xUu.Nothing.value;
                };
            };
            return $3e146d399ce3c178$var$tailRecM2(go)(v)(s);
        };
    };
};
var $3e146d399ce3c178$export$afc1bfabebaf28a2 = function(v) {
    return function(v1) {
        if (v1 instanceof $fZenR.Cons && v(v1.value0)) {
            var v2 = $3e146d399ce3c178$export$afc1bfabebaf28a2(v)(v1.value1);
            return {
                init: new $fZenR.Cons(v1.value0, v2.init),
                rest: v2.rest
            };
        }
        return {
            init: $fZenR.Nil.value,
            rest: v1
        };
    };
};
var $3e146d399ce3c178$export$c40cf5aab899f397 = function(xs) {
    return function(x) {
        return $3e146d399ce3c178$var$foldr($fZenR.Cons.create)(new $fZenR.Cons(x, $fZenR.Nil.value))(xs);
    };
};
var $3e146d399ce3c178$export$439306a4dcaafbb9 = function(a) {
    return new $fZenR.Cons(a, $fZenR.Nil.value);
};
var $3e146d399ce3c178$export$b035e44d7bb4278f = function(cmp) {
    var merge = function(v) {
        return function(v1) {
            if (v instanceof $fZenR.Cons && v1 instanceof $fZenR.Cons) {
                if ($3e146d399ce3c178$var$eq(cmp(v.value0)(v1.value0))($ibsD5.GT.value)) return new $fZenR.Cons(v1.value0, merge(v)(v1.value1));
                if ($iQTlW.otherwise) return new $fZenR.Cons(v.value0, merge(v.value1)(v1));
            }
            if (v instanceof $fZenR.Nil) return v1;
            if (v1 instanceof $fZenR.Nil) return v;
            throw new Error("Failed pattern match at Data.List (line 466, column 3 - line 466, column 38): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
    var mergePairs = function(v) {
        if (v instanceof $fZenR.Cons && v.value1 instanceof $fZenR.Cons) return new $fZenR.Cons(merge(v.value0)(v.value1.value0), mergePairs(v.value1.value1));
        return v;
    };
    var mergeAll = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $fZenR.Cons && v.value1 instanceof $fZenR.Nil) {
                $tco_done = true;
                return v.value0;
            }
            $copy_v = mergePairs(v);
            return;
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    var sequences = function(v) {
        if (v instanceof $fZenR.Cons && v.value1 instanceof $fZenR.Cons) {
            if ($3e146d399ce3c178$var$eq(cmp(v.value0)(v.value1.value0))($ibsD5.GT.value)) return descending(v.value1.value0)($3e146d399ce3c178$export$439306a4dcaafbb9(v.value0))(v.value1.value1);
            if ($iQTlW.otherwise) return ascending(v.value1.value0)(function(v1) {
                return new $fZenR.Cons(v.value0, v1);
            })(v.value1.value1);
        }
        return $3e146d399ce3c178$export$439306a4dcaafbb9(v);
    };
    var descending = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done1 = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v2 instanceof $fZenR.Cons && $3e146d399ce3c178$var$eq(cmp(v)(v2.value0))($ibsD5.GT.value)) {
                        $tco_var_v = v2.value0;
                        $tco_var_v1 = new $fZenR.Cons(v, v1);
                        $copy_v2 = v2.value1;
                        return;
                    }
                    $tco_done1 = true;
                    return new $fZenR.Cons(new $fZenR.Cons(v, v1), sequences(v2));
                }
                while(!$tco_done1)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    var ascending = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done2 = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v2 instanceof $fZenR.Cons && $3e146d399ce3c178$var$notEq(cmp(v)(v2.value0))($ibsD5.GT.value)) {
                        $tco_var_v = v2.value0;
                        $tco_var_v1 = function(ys) {
                            return v1(new $fZenR.Cons(v, ys));
                        };
                        $copy_v2 = v2.value1;
                        return;
                    }
                    $tco_done2 = true;
                    return new $fZenR.Cons(v1($3e146d399ce3c178$export$439306a4dcaafbb9(v)), sequences(v2));
                }
                while(!$tco_done2)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    return function($444) {
        return mergeAll(sequences($444));
    };
};
var $3e146d399ce3c178$export$97db5808d8f88186 = function(dictOrd) {
    var compare = $gwBF5.compare(dictOrd);
    return function(xs) {
        return $3e146d399ce3c178$export$b035e44d7bb4278f(compare)(xs);
    };
};
var $3e146d399ce3c178$var$tails = function(v) {
    if (v instanceof $fZenR.Nil) return $3e146d399ce3c178$export$439306a4dcaafbb9($fZenR.Nil.value);
    if (v instanceof $fZenR.Cons) return new $fZenR.Cons(v, $3e146d399ce3c178$var$tails(v.value1));
    throw new Error("Failed pattern match at Data.List (line 641, column 1 - line 641, column 43): " + [
        v.constructor.name
    ]);
};
var $3e146d399ce3c178$export$b5c655b9d1f9203e = function(dictShow) {
    var show = $2XxiF.show($fZenR.showList(dictShow));
    return {
        show: function(v) {
            return "(Pattern " + (show(v) + ")");
        }
    };
};
var $3e146d399ce3c178$export$66c1ae025e96b4bc = /* #__PURE__ */ function() {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $fZenR.Nil) {
                    $tco_done = true;
                    return v;
                }
                if (v1 instanceof $fZenR.Cons) {
                    $tco_var_v = new $fZenR.Cons(v1.value0, v);
                    $copy_v1 = v1.value1;
                    return;
                }
                throw new Error("Failed pattern match at Data.List (line 368, column 3 - line 368, column 19): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($fZenR.Nil.value);
}();
var $3e146d399ce3c178$export$b7df5d561049483a = /* #__PURE__ */ function() {
    var go = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v1 < 1) {
                        $tco_done = true;
                        return $3e146d399ce3c178$export$66c1ae025e96b4bc(v);
                    }
                    if (v2 instanceof $fZenR.Nil) {
                        $tco_done = true;
                        return $3e146d399ce3c178$export$66c1ae025e96b4bc(v);
                    }
                    if (v2 instanceof $fZenR.Cons) {
                        $tco_var_v = new $fZenR.Cons(v2.value0, v);
                        $tco_var_v1 = v1 - 1 | 0;
                        $copy_v2 = v2.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List (line 513, column 3 - line 513, column 35): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    return go($fZenR.Nil.value);
}();
var $3e146d399ce3c178$export$9384c7afe4015e42 = function(p) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $fZenR.Cons && p(v1.value0)) {
                    $tco_var_v = new $fZenR.Cons(v1.value0, v);
                    $copy_v1 = v1.value1;
                    return;
                }
                $tco_done = true;
                return $3e146d399ce3c178$export$66c1ae025e96b4bc(v);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($fZenR.Nil.value);
};
var $3e146d399ce3c178$export$712962e076096ed4 = function(lst) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v instanceof $fZenR.Nil) {
                    $tco_done = true;
                    return $h2xUu.Nothing.value;
                }
                if (v instanceof $fZenR.Cons && v.value1 instanceof $fZenR.Nil) {
                    $tco_done = true;
                    return new $h2xUu.Just({
                        revInit: v1,
                        last: v.value0
                    });
                }
                if (v instanceof $fZenR.Cons) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $fZenR.Cons(v.value0, v1);
                    return;
                }
                throw new Error("Failed pattern match at Data.List (line 270, column 3 - line 270, column 21): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return $3e146d399ce3c178$var$map(function(h) {
        return {
            init: $3e146d399ce3c178$export$66c1ae025e96b4bc(h.revInit),
            last: h.last
        };
    })(go(lst)($fZenR.Nil.value));
};
var $3e146d399ce3c178$export$b634740ce272acb5 = function(f) {
    return function(xs) {
        return function(ys) {
            var go = function($copy_v) {
                return function($copy_v1) {
                    return function($copy_v2) {
                        var $tco_var_v = $copy_v;
                        var $tco_var_v1 = $copy_v1;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1, v2) {
                            if (v instanceof $fZenR.Nil) {
                                $tco_done = true;
                                return v2;
                            }
                            if (v1 instanceof $fZenR.Nil) {
                                $tco_done = true;
                                return v2;
                            }
                            if (v instanceof $fZenR.Cons && v1 instanceof $fZenR.Cons) {
                                $tco_var_v = v.value1;
                                $tco_var_v1 = v1.value1;
                                $copy_v2 = new $fZenR.Cons(f(v.value0)(v1.value0), v2);
                                return;
                            }
                            throw new Error("Failed pattern match at Data.List (line 779, column 3 - line 779, column 21): " + [
                                v.constructor.name,
                                v1.constructor.name,
                                v2.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                        return $tco_result;
                    };
                };
            };
            return $3e146d399ce3c178$export$66c1ae025e96b4bc(go(xs)(ys)($fZenR.Nil.value));
        };
    };
};
var $3e146d399ce3c178$export$8901015135f2fb22 = /* #__PURE__ */ function() {
    return $3e146d399ce3c178$export$b634740ce272acb5($7O0Q4.Tuple.create);
}();
var $3e146d399ce3c178$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var sequence1 = $3e146d399ce3c178$var$sequence(dictApplicative);
    return function(f) {
        return function(xs) {
            return function(ys) {
                return sequence1($3e146d399ce3c178$export$b634740ce272acb5(f)(xs)(ys));
            };
        };
    };
};
var $3e146d399ce3c178$export$d02631cccf789723 = function(start) {
    return function(end) {
        if (start === end) return $3e146d399ce3c178$export$439306a4dcaafbb9(start);
        if ($iQTlW.otherwise) {
            var go = function($copy_s) {
                return function($copy_e) {
                    return function($copy_step) {
                        return function($copy_rest) {
                            var $tco_var_s = $copy_s;
                            var $tco_var_e = $copy_e;
                            var $tco_var_step = $copy_step;
                            var $tco_done = false;
                            var $tco_result;
                            function $tco_loop(s, e, step, rest) {
                                if (s === e) {
                                    $tco_done = true;
                                    return new $fZenR.Cons(s, rest);
                                }
                                if ($iQTlW.otherwise) {
                                    $tco_var_s = s + step | 0;
                                    $tco_var_e = e;
                                    $tco_var_step = step;
                                    $copy_rest = new $fZenR.Cons(s, rest);
                                    return;
                                }
                                throw new Error("Failed pattern match at Data.List (line 148, column 3 - line 149, column 65): " + [
                                    s.constructor.name,
                                    e.constructor.name,
                                    step.constructor.name,
                                    rest.constructor.name
                                ]);
                            }
                            while(!$tco_done)$tco_result = $tco_loop($tco_var_s, $tco_var_e, $tco_var_step, $copy_rest);
                            return $tco_result;
                        };
                    };
                };
            };
            return go(end)(start)(function() {
                var $325 = start > end;
                if ($325) return 1;
                return -1;
            }())($fZenR.Nil.value);
        }
        throw new Error("Failed pattern match at Data.List (line 144, column 1 - line 144, column 32): " + [
            start.constructor.name,
            end.constructor.name
        ]);
    };
};
var $3e146d399ce3c178$export$b29f828819edca8d = function(p) {
    return function(xs) {
        var select = function(x) {
            return function(v) {
                var $328 = p(x);
                if ($328) return {
                    no: v.no,
                    yes: new $fZenR.Cons(x, v.yes)
                };
                return {
                    no: new $fZenR.Cons(x, v.no),
                    yes: v.yes
                };
            };
        };
        return $3e146d399ce3c178$var$foldr(select)({
            no: $fZenR.Nil.value,
            yes: $fZenR.Nil.value
        })(xs);
    };
};
var $3e146d399ce3c178$export$7b1b591b262c240 = function(v) {
    if (v instanceof $fZenR.Nil) return true;
    return false;
};
var $3e146d399ce3c178$export$18f77a3bafa759b9 = function(p) {
    var go = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v2 instanceof $fZenR.Nil) {
                        $tco_done = true;
                        return v1;
                    }
                    if (v2 instanceof $fZenR.Cons) {
                        var v3 = $RL9Ix.insertAndLookupBy(p)(v2.value0)(v);
                        if (v3.found) {
                            $tco_var_v = v3.result;
                            $tco_var_v1 = v1;
                            $copy_v2 = v2.value1;
                            return;
                        }
                        $tco_var_v = v3.result;
                        $tco_var_v1 = new $fZenR.Cons(v2.value0, v1);
                        $copy_v2 = v2.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List (line 673, column 5 - line 673, column 23): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    var $445 = go($RL9Ix.emptySet)($fZenR.Nil.value);
    return function($446) {
        return $3e146d399ce3c178$export$66c1ae025e96b4bc($445($446));
    };
};
var $3e146d399ce3c178$export$94f4066a75b10404 = function(dictOrd) {
    return $3e146d399ce3c178$export$18f77a3bafa759b9($gwBF5.compare(dictOrd));
};
var $3e146d399ce3c178$export$86c9b635481112b7 = {
    Coercible0: function() {
        return undefined;
    }
};
var $3e146d399ce3c178$export$e70771d2e7e590a = function(f) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $fZenR.Nil) {
                    $tco_done = true;
                    return $3e146d399ce3c178$export$66c1ae025e96b4bc(v);
                }
                if (v1 instanceof $fZenR.Cons) {
                    var v2 = f(v1.value0);
                    if (v2 instanceof $h2xUu.Nothing) {
                        $tco_var_v = v;
                        $copy_v1 = v1.value1;
                        return;
                    }
                    if (v2 instanceof $h2xUu.Just) {
                        $tco_var_v = new $fZenR.Cons(v2.value0, v);
                        $copy_v1 = v1.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List (line 419, column 5 - line 421, column 32): " + [
                        v2.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.List (line 417, column 3 - line 417, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($fZenR.Nil.value);
};
var $3e146d399ce3c178$export$17771a97d85ba7eb = function(dictMonadRec) {
    var bind1 = $cADnC.bind(dictMonadRec.Monad0().Bind1());
    var tailRecM = $bcJ05.tailRecM(dictMonadRec);
    return function(dictAlternative) {
        var Alt0 = dictAlternative.Plus1().Alt0();
        var alt = $56VjJ.alt(Alt0);
        var map1 = $7FzSN.map(Alt0.Functor0());
        var pure = $bQdkN.pure(dictAlternative.Applicative0());
        return function(p) {
            var go = function(acc) {
                return bind1(alt(map1($bcJ05.Loop.create)(p))(pure(new $bcJ05.Done($ivFwO.unit))))(function(aa) {
                    return pure($3e146d399ce3c178$var$bimap(function(v) {
                        return new $fZenR.Cons(v, acc);
                    })(function(v) {
                        return $3e146d399ce3c178$export$66c1ae025e96b4bc(acc);
                    })(aa));
                });
            };
            return tailRecM(go)($fZenR.Nil.value);
        };
    };
};
var $3e146d399ce3c178$export$934820ddadec516f = function(dictMonadRec) {
    var manyRec1 = $3e146d399ce3c178$export$17771a97d85ba7eb(dictMonadRec);
    return function(dictAlternative) {
        var apply = $26ZCq.apply(dictAlternative.Applicative0().Apply0());
        var map1 = $7FzSN.map(dictAlternative.Plus1().Alt0().Functor0());
        var manyRec2 = manyRec1(dictAlternative);
        return function(v) {
            return apply(map1($fZenR.Cons.create)(v))(manyRec2(v));
        };
    };
};
var $3e146d399ce3c178$export$ad14ef4001db2bcd = function(dictAlternative) {
    var apply = $26ZCq.apply(dictAlternative.Applicative0().Apply0());
    var map1 = $7FzSN.map(dictAlternative.Plus1().Alt0().Functor0());
    return function(dictLazy) {
        var defer = $dxuBz.defer(dictLazy);
        return function(v) {
            return apply(map1($fZenR.Cons.create)(v))(defer(function(v1) {
                return $3e146d399ce3c178$export$14badfee79ea396f(dictAlternative)(dictLazy)(v);
            }));
        };
    };
};
var $3e146d399ce3c178$export$14badfee79ea396f = function(dictAlternative) {
    var alt = $56VjJ.alt(dictAlternative.Plus1().Alt0());
    var pure = $bQdkN.pure(dictAlternative.Applicative0());
    return function(dictLazy) {
        return function(v) {
            return alt($3e146d399ce3c178$export$ad14ef4001db2bcd(dictAlternative)(dictLazy)(v))(pure($fZenR.Nil.value));
        };
    };
};
var $3e146d399ce3c178$export$f24224f1c91d8156 = /* #__PURE__ */ $3e146d399ce3c178$var$foldl(function(acc) {
    return function(v) {
        return acc + 1 | 0;
    };
})(0);
var $3e146d399ce3c178$export$4c7897fafd92b108 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v instanceof $fZenR.Cons && v.value1 instanceof $fZenR.Nil) {
            $tco_done = true;
            return new $h2xUu.Just(v.value0);
        }
        if (v instanceof $fZenR.Cons) {
            $copy_v = v.value1;
            return;
        }
        $tco_done = true;
        return $h2xUu.Nothing.value;
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $3e146d399ce3c178$export$b8bc901090d2b1d4 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $fZenR.Nil) return $3e146d399ce3c178$export$439306a4dcaafbb9(v1);
            if (v2 instanceof $fZenR.Cons) {
                var v3 = v(v1)(v2.value0);
                if (v3 instanceof $ibsD5.GT) return new $fZenR.Cons(v2.value0, $3e146d399ce3c178$export$b8bc901090d2b1d4(v)(v1)(v2.value1));
                return new $fZenR.Cons(v1, v2);
            }
            throw new Error("Failed pattern match at Data.List (line 216, column 1 - line 216, column 68): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $3e146d399ce3c178$export$9f200c4466975173 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0) return new $h2xUu.Just(new $fZenR.Cons(v1, v2));
            if (v2 instanceof $fZenR.Cons) return $3e146d399ce3c178$var$map(function(v3) {
                return new $fZenR.Cons(v2.value0, v3);
            })($3e146d399ce3c178$export$9f200c4466975173(v - 1 | 0)(v1)(v2.value1));
            return $h2xUu.Nothing.value;
        };
    };
};
var $3e146d399ce3c178$export$21a5ca8aa77d35ff = function(dictOrd) {
    return $3e146d399ce3c178$export$b8bc901090d2b1d4($gwBF5.compare(dictOrd));
};
var $3e146d399ce3c178$export$2cd8252107eb640b = function(lst) {
    return $3e146d399ce3c178$var$map(function(v) {
        return v.init;
    })($3e146d399ce3c178$export$712962e076096ed4(lst));
};
var $3e146d399ce3c178$export$b610b8812bbcded9 = function($copy_v) {
    return function($copy_v1) {
        var $tco_var_v = $copy_v;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v, v1) {
            if (v instanceof $fZenR.Nil) {
                $tco_done = true;
                return $h2xUu.Nothing.value;
            }
            if (v instanceof $fZenR.Cons && v1 === 0) {
                $tco_done = true;
                return new $h2xUu.Just(v.value0);
            }
            if (v instanceof $fZenR.Cons) {
                $tco_var_v = v.value1;
                $copy_v1 = v1 - 1 | 0;
                return;
            }
            throw new Error("Failed pattern match at Data.List (line 281, column 1 - line 281, column 44): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
        return $tco_result;
    };
};
var $3e146d399ce3c178$export$5fd5031fecdacec3 = function(v) {
    if (v instanceof $fZenR.Nil) return $h2xUu.Nothing.value;
    if (v instanceof $fZenR.Cons) return new $h2xUu.Just(v.value0);
    throw new Error("Failed pattern match at Data.List (line 230, column 1 - line 230, column 22): " + [
        v.constructor.name
    ]);
};
var $3e146d399ce3c178$export$9cb09a71b7d66923 = function(v) {
    if (v instanceof $fZenR.Nil) return $fZenR.Nil.value;
    if (v instanceof $fZenR.Cons && v.value0 instanceof $fZenR.Nil) return $3e146d399ce3c178$export$9cb09a71b7d66923(v.value1);
    if (v instanceof $fZenR.Cons && v.value0 instanceof $fZenR.Cons) return new $fZenR.Cons(new $fZenR.Cons(v.value0.value0, $3e146d399ce3c178$export$e70771d2e7e590a($3e146d399ce3c178$export$5fd5031fecdacec3)(v.value1)), $3e146d399ce3c178$export$9cb09a71b7d66923(new $fZenR.Cons(v.value0.value1, $3e146d399ce3c178$export$e70771d2e7e590a($3e146d399ce3c178$export$c01875f616615628)(v.value1))));
    throw new Error("Failed pattern match at Data.List (line 813, column 1 - line 813, column 54): " + [
        v.constructor.name
    ]);
};
var $3e146d399ce3c178$export$3f063810d7bf01bd = function(v) {
    return function(v1) {
        if (v1 instanceof $fZenR.Nil) return $fZenR.Nil.value;
        if (v1 instanceof $fZenR.Cons) {
            var v2 = $3e146d399ce3c178$export$afc1bfabebaf28a2(v(v1.value0))(v1.value1);
            return new $fZenR.Cons(new $9aSRU.NonEmpty(v1.value0, v2.init), $3e146d399ce3c178$export$3f063810d7bf01bd(v)(v2.rest));
        }
        throw new Error("Failed pattern match at Data.List (line 609, column 1 - line 609, column 80): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $3e146d399ce3c178$export$1f7a5bf12caafbd = function(p) {
    var $447 = $3e146d399ce3c178$export$3f063810d7bf01bd(function(x) {
        return function(y) {
            return $3e146d399ce3c178$var$eq(p(x)(y))($ibsD5.EQ.value);
        };
    });
    var $448 = $3e146d399ce3c178$export$b035e44d7bb4278f(p);
    return function($449) {
        return $447($448($449));
    };
};
var $3e146d399ce3c178$export$e5e25fbcc1f7affe = function(dictEq) {
    return $3e146d399ce3c178$export$3f063810d7bf01bd($aJhEx.eq(dictEq));
};
var $3e146d399ce3c178$export$361434b95a7d965 = function(dictOrd) {
    var $450 = $3e146d399ce3c178$export$e5e25fbcc1f7affe(dictOrd.Eq0());
    var $451 = $3e146d399ce3c178$export$97db5808d8f88186(dictOrd);
    return function($452) {
        return $450($451($452));
    };
};
var $3e146d399ce3c178$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    return $dNwPt.foldr(dictFoldable)($fZenR.Cons.create)($fZenR.Nil.value);
};
var $3e146d399ce3c178$export$7a067f9280ad8af0 = function(dictMonad) {
    var pure = $bQdkN.pure(dictMonad.Applicative0());
    var bind1 = $cADnC.bind(dictMonad.Bind1());
    return function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $fZenR.Nil) return pure(v1);
                if (v2 instanceof $fZenR.Cons) return bind1(v(v1)(v2.value0))(function(b$prime) {
                    return $3e146d399ce3c178$export$7a067f9280ad8af0(dictMonad)(v)(b$prime)(v2.value1);
                });
                throw new Error("Failed pattern match at Data.List (line 824, column 1 - line 824, column 72): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    };
};
var $3e146d399ce3c178$export$de3a4d4a0d731119 = function(fn) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $fZenR.Cons) {
                    if (fn(v1.value0)) {
                        $tco_done = true;
                        return new $h2xUu.Just(v);
                    }
                    if ($iQTlW.otherwise) {
                        $tco_var_v = v + 1 | 0;
                        $copy_v1 = v1.value1;
                        return;
                    }
                }
                if (v1 instanceof $fZenR.Nil) {
                    $tco_done = true;
                    return $h2xUu.Nothing.value;
                }
                throw new Error("Failed pattern match at Data.List (line 301, column 3 - line 301, column 35): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go(0);
};
var $3e146d399ce3c178$export$8855a8be7bd3e9f8 = function(fn) {
    return function(xs) {
        return $3e146d399ce3c178$var$map(function(v) {
            return ($3e146d399ce3c178$export$f24224f1c91d8156(xs) - 1 | 0) - v | 0;
        })($3e146d399ce3c178$export$de3a4d4a0d731119(fn)($3e146d399ce3c178$export$66c1ae025e96b4bc(xs)));
    };
};
var $3e146d399ce3c178$export$20098ecb074a31e6 = function(dictMonad) {
    var pure = $bQdkN.pure(dictMonad.Applicative0());
    var bind1 = $cADnC.bind(dictMonad.Bind1());
    return function(v) {
        return function(v1) {
            if (v1 instanceof $fZenR.Nil) return pure($fZenR.Nil.value);
            if (v1 instanceof $fZenR.Cons) return bind1(v(v1.value0))(function(b) {
                return bind1($3e146d399ce3c178$export$20098ecb074a31e6(dictMonad)(v)(v1.value1))(function(xs$prime) {
                    return pure(function() {
                        if (b) return new $fZenR.Cons(v1.value0, xs$prime);
                        return xs$prime;
                    }());
                });
            });
            throw new Error("Failed pattern match at Data.List (line 403, column 1 - line 403, column 75): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $3e146d399ce3c178$export$3dea766d36a8935f = function(p) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $fZenR.Nil) {
                    $tco_done = true;
                    return $3e146d399ce3c178$export$66c1ae025e96b4bc(v);
                }
                if (v1 instanceof $fZenR.Cons) {
                    if (p(v1.value0)) {
                        $tco_var_v = new $fZenR.Cons(v1.value0, v);
                        $copy_v1 = v1.value1;
                        return;
                    }
                    if ($iQTlW.otherwise) {
                        $tco_var_v = v;
                        $copy_v1 = v1.value1;
                        return;
                    }
                }
                throw new Error("Failed pattern match at Data.List (line 390, column 3 - line 390, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($fZenR.Nil.value);
};
var $3e146d399ce3c178$export$f161f39e9c06ab2d = function(v) {
    return function(v1) {
        return function(v2) {
            if (v1 instanceof $fZenR.Nil) return $fZenR.Nil.value;
            if (v2 instanceof $fZenR.Nil) return $fZenR.Nil.value;
            return $3e146d399ce3c178$export$3dea766d36a8935f(function(x) {
                return $3e146d399ce3c178$var$any(v(x))(v2);
            })(v1);
        };
    };
};
var $3e146d399ce3c178$export$1f4807a235930d45 = function(dictEq) {
    return $3e146d399ce3c178$export$f161f39e9c06ab2d($aJhEx.eq(dictEq));
};
var $3e146d399ce3c178$export$45273896c792ff3b = function(v) {
    return function(v1) {
        if (v1 instanceof $fZenR.Nil) return $fZenR.Nil.value;
        if (v1 instanceof $fZenR.Cons) return new $fZenR.Cons(v1.value0, $3e146d399ce3c178$export$45273896c792ff3b(v)($3e146d399ce3c178$export$3dea766d36a8935f(function(y) {
            return !v(v1.value0)(y);
        })(v1.value1)));
        throw new Error("Failed pattern match at Data.List (line 705, column 1 - line 705, column 61): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $3e146d399ce3c178$export$edce5881c815871 = function(dictEq) {
    return $3e146d399ce3c178$export$45273896c792ff3b($aJhEx.eq(dictEq));
};
var $3e146d399ce3c178$export$3c57592525e2b27e = function(dictEq) {
    var eq2 = $aJhEx.eq($fZenR.eqList(dictEq));
    return {
        eq: function(x) {
            return function(y) {
                return eq2(x)(y);
            };
        }
    };
};
var $3e146d399ce3c178$export$21c206d752eba296 = function(dictOrd) {
    var compare = $gwBF5.compare($fZenR.ordList(dictOrd));
    var eqPattern1 = $3e146d399ce3c178$export$3c57592525e2b27e(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                return compare(x)(y);
            };
        },
        Eq0: function() {
            return eqPattern1;
        }
    };
};
var $3e146d399ce3c178$export$c19d79386f4ed99a = function(dictEq) {
    var eq2 = $aJhEx.eq(dictEq);
    return function(x) {
        return $3e146d399ce3c178$export$8855a8be7bd3e9f8(function(v) {
            return eq2(v)(x);
        });
    };
};
var $3e146d399ce3c178$export$f444781b0adb7e4d = function(dictEq) {
    var eq2 = $aJhEx.eq(dictEq);
    return function(x) {
        return $3e146d399ce3c178$export$de3a4d4a0d731119(function(v) {
            return eq2(v)(x);
        });
    };
};
var $3e146d399ce3c178$export$533af5c8cd6afa16 = function(p) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $fZenR.Cons && p(v.value0)) {
                $copy_v = v.value1;
                return;
            }
            $tco_done = true;
            return v;
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return go;
};
var $3e146d399ce3c178$export$2b3b686e33c80c56 = function(n) {
    return function(xs) {
        return $3e146d399ce3c178$export$b7df5d561049483a($3e146d399ce3c178$export$f24224f1c91d8156(xs) - n | 0)(xs);
    };
};
var $3e146d399ce3c178$export$663103110d94aac9 = function($copy_v) {
    return function($copy_v1) {
        var $tco_var_v = $copy_v;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v, v1) {
            if (v < 1) {
                $tco_done = true;
                return v1;
            }
            if (v1 instanceof $fZenR.Nil) {
                $tco_done = true;
                return $fZenR.Nil.value;
            }
            if (v1 instanceof $fZenR.Cons) {
                $tco_var_v = v - 1 | 0;
                $copy_v1 = v1.value1;
                return;
            }
            throw new Error("Failed pattern match at Data.List (line 536, column 1 - line 536, column 42): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
        return $tco_result;
    };
};
var $3e146d399ce3c178$export$58adb3bec8346d0f = function(start) {
    return function(end) {
        return function(xs) {
            return $3e146d399ce3c178$export$b7df5d561049483a(end - start | 0)($3e146d399ce3c178$export$663103110d94aac9(start)(xs));
        };
    };
};
var $3e146d399ce3c178$export$9100289823a975b0 = function(n) {
    return function(xs) {
        return $3e146d399ce3c178$export$663103110d94aac9($3e146d399ce3c178$export$f24224f1c91d8156(xs) - n | 0)(xs);
    };
};
var $3e146d399ce3c178$export$9ea2b6c3fae093d8 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $fZenR.Nil) return $fZenR.Nil.value;
            if (v2 instanceof $fZenR.Cons && v(v1)(v2.value0)) return v2.value1;
            if (v2 instanceof $fZenR.Cons) return new $fZenR.Cons(v2.value0, $3e146d399ce3c178$export$9ea2b6c3fae093d8(v)(v1)(v2.value1));
            throw new Error("Failed pattern match at Data.List (line 732, column 1 - line 732, column 67): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $3e146d399ce3c178$export$ef1d06dc4d91d507 = function(eq2) {
    return function(xs) {
        return function(ys) {
            return $3e146d399ce3c178$var$append1(xs)($3e146d399ce3c178$var$foldl($jhsiw.flip($3e146d399ce3c178$export$9ea2b6c3fae093d8(eq2)))($3e146d399ce3c178$export$45273896c792ff3b(eq2)(ys))(xs));
        };
    };
};
var $3e146d399ce3c178$export$971dd5b0dfd021b6 = function(dictEq) {
    return $3e146d399ce3c178$export$ef1d06dc4d91d507($aJhEx.eq(dictEq));
};
var $3e146d399ce3c178$export$90f9093465da3136 = function(v) {
    return function(v1) {
        if (v === 0 && v1 instanceof $fZenR.Cons) return new $h2xUu.Just(v1.value1);
        if (v1 instanceof $fZenR.Cons) return $3e146d399ce3c178$var$map(function(v2) {
            return new $fZenR.Cons(v1.value0, v2);
        })($3e146d399ce3c178$export$90f9093465da3136(v - 1 | 0)(v1.value1));
        return $h2xUu.Nothing.value;
    };
};
var $3e146d399ce3c178$export$1822828d790e23ee = function(dictEq) {
    return $3e146d399ce3c178$export$9ea2b6c3fae093d8($aJhEx.eq(dictEq));
};
var $3e146d399ce3c178$export$acaf96a27438246b = function(dictEq) {
    return $3e146d399ce3c178$var$foldl($jhsiw.flip($3e146d399ce3c178$export$1822828d790e23ee(dictEq)));
};
var $3e146d399ce3c178$export$c28c8388be0ab31a = /* #__PURE__ */ $jhsiw.flip($3e146d399ce3c178$var$bind);
var $3e146d399ce3c178$export$ee1b3e54f0441b22 = function(v) {
    return $3e146d399ce3c178$var$bind(v)($3e146d399ce3c178$var$identity);
};
var $3e146d399ce3c178$export$986c2bbe7a34be0b = /* #__PURE__ */ $3e146d399ce3c178$export$e70771d2e7e590a($3e146d399ce3c178$var$identity);
var $3e146d399ce3c178$export$2dd9d44f93be5e22 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0 && v2 instanceof $fZenR.Cons) return new $h2xUu.Just(function() {
                var v3 = v1(v2.value0);
                if (v3 instanceof $h2xUu.Nothing) return v2.value1;
                if (v3 instanceof $h2xUu.Just) return new $fZenR.Cons(v3.value0, v2.value1);
                throw new Error("Failed pattern match at Data.List (line 352, column 3 - line 354, column 23): " + [
                    v3.constructor.name
                ]);
            }());
            if (v2 instanceof $fZenR.Cons) return $3e146d399ce3c178$var$map(function(v3) {
                return new $fZenR.Cons(v2.value0, v3);
            })($3e146d399ce3c178$export$2dd9d44f93be5e22(v - 1 | 0)(v1)(v2.value1));
            return $h2xUu.Nothing.value;
        };
    };
};
var $3e146d399ce3c178$export$cba09f9e3d3e58eb = function(n) {
    return function(f) {
        return $3e146d399ce3c178$export$2dd9d44f93be5e22(n)(function($453) {
            return $h2xUu.Just.create(f($453));
        });
    };
};

});
parcelRegister("RL9Ix", function(module, exports) {

$parcel$export(module.exports, "insertAndLookupBy", () => $0a19877f67740a14$export$b5a179e49e0f2907);
$parcel$export(module.exports, "emptySet", () => $0a19877f67740a14$export$4e5bc754a9c955a);
// Generated by purs version 0.15.16

var $fZenR = parcelRequire("fZenR");

var $ibsD5 = parcelRequire("ibsD5");
var $0a19877f67740a14$var$Leaf = /* #__PURE__ */ function() {
    function Leaf() {}
    Leaf.value = new Leaf();
    return Leaf;
}();
var $0a19877f67740a14$var$Two = /* #__PURE__ */ function() {
    function Two(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Two.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Two(value0, value1, value2);
            };
        };
    };
    return Two;
}();
var $0a19877f67740a14$var$Three = /* #__PURE__ */ function() {
    function Three(value0, value1, value2, value3, value4) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
    }
    Three.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return function(value4) {
                        return new Three(value0, value1, value2, value3, value4);
                    };
                };
            };
        };
    };
    return Three;
}();
var $0a19877f67740a14$var$TwoLeft = /* #__PURE__ */ function() {
    function TwoLeft(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    TwoLeft.create = function(value0) {
        return function(value1) {
            return new TwoLeft(value0, value1);
        };
    };
    return TwoLeft;
}();
var $0a19877f67740a14$var$TwoRight = /* #__PURE__ */ function() {
    function TwoRight(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    TwoRight.create = function(value0) {
        return function(value1) {
            return new TwoRight(value0, value1);
        };
    };
    return TwoRight;
}();
var $0a19877f67740a14$var$ThreeLeft = /* #__PURE__ */ function() {
    function ThreeLeft(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    ThreeLeft.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new ThreeLeft(value0, value1, value2, value3);
                };
            };
        };
    };
    return ThreeLeft;
}();
var $0a19877f67740a14$var$ThreeMiddle = /* #__PURE__ */ function() {
    function ThreeMiddle(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    ThreeMiddle.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new ThreeMiddle(value0, value1, value2, value3);
                };
            };
        };
    };
    return ThreeMiddle;
}();
var $0a19877f67740a14$var$ThreeRight = /* #__PURE__ */ function() {
    function ThreeRight(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    ThreeRight.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new ThreeRight(value0, value1, value2, value3);
                };
            };
        };
    };
    return ThreeRight;
}();
var $0a19877f67740a14$var$KickUp = /* #__PURE__ */ function() {
    function KickUp(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    KickUp.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new KickUp(value0, value1, value2);
            };
        };
    };
    return KickUp;
}();
var $0a19877f67740a14$var$fromZipper = function($copy_v) {
    return function($copy_v1) {
        var $tco_var_v = $copy_v;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v, v1) {
            if (v instanceof $fZenR.Nil) {
                $tco_done = true;
                return v1;
            }
            if (v instanceof $fZenR.Cons) {
                if (v.value0 instanceof $0a19877f67740a14$var$TwoLeft) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $0a19877f67740a14$var$Two(v1, v.value0.value0, v.value0.value1);
                    return;
                }
                if (v.value0 instanceof $0a19877f67740a14$var$TwoRight) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $0a19877f67740a14$var$Two(v.value0.value0, v.value0.value1, v1);
                    return;
                }
                if (v.value0 instanceof $0a19877f67740a14$var$ThreeLeft) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $0a19877f67740a14$var$Three(v1, v.value0.value0, v.value0.value1, v.value0.value2, v.value0.value3);
                    return;
                }
                if (v.value0 instanceof $0a19877f67740a14$var$ThreeMiddle) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $0a19877f67740a14$var$Three(v.value0.value0, v.value0.value1, v1, v.value0.value2, v.value0.value3);
                    return;
                }
                if (v.value0 instanceof $0a19877f67740a14$var$ThreeRight) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $0a19877f67740a14$var$Three(v.value0.value0, v.value0.value1, v.value0.value2, v.value0.value3, v1);
                    return;
                }
                throw new Error("Failed pattern match at Data.List.Internal (line 25, column 3 - line 30, column 76): " + [
                    v.value0.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.List.Internal (line 22, column 1 - line 22, column 63): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
        return $tco_result;
    };
};
var $0a19877f67740a14$export$b5a179e49e0f2907 = function(comp) {
    return function(k) {
        return function(orig) {
            var up = function($copy_v) {
                return function($copy_v1) {
                    var $tco_var_v = $copy_v;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(v, v1) {
                        if (v instanceof $fZenR.Nil) {
                            $tco_done = true;
                            return new $0a19877f67740a14$var$Two(v1.value0, v1.value1, v1.value2);
                        }
                        if (v instanceof $fZenR.Cons) {
                            if (v.value0 instanceof $0a19877f67740a14$var$TwoLeft) {
                                $tco_done = true;
                                return $0a19877f67740a14$var$fromZipper(v.value1)(new $0a19877f67740a14$var$Three(v1.value0, v1.value1, v1.value2, v.value0.value0, v.value0.value1));
                            }
                            if (v.value0 instanceof $0a19877f67740a14$var$TwoRight) {
                                $tco_done = true;
                                return $0a19877f67740a14$var$fromZipper(v.value1)(new $0a19877f67740a14$var$Three(v.value0.value0, v.value0.value1, v1.value0, v1.value1, v1.value2));
                            }
                            if (v.value0 instanceof $0a19877f67740a14$var$ThreeLeft) {
                                $tco_var_v = v.value1;
                                $copy_v1 = new $0a19877f67740a14$var$KickUp(new $0a19877f67740a14$var$Two(v1.value0, v1.value1, v1.value2), v.value0.value0, new $0a19877f67740a14$var$Two(v.value0.value1, v.value0.value2, v.value0.value3));
                                return;
                            }
                            if (v.value0 instanceof $0a19877f67740a14$var$ThreeMiddle) {
                                $tco_var_v = v.value1;
                                $copy_v1 = new $0a19877f67740a14$var$KickUp(new $0a19877f67740a14$var$Two(v.value0.value0, v.value0.value1, v1.value0), v1.value1, new $0a19877f67740a14$var$Two(v1.value2, v.value0.value2, v.value0.value3));
                                return;
                            }
                            if (v.value0 instanceof $0a19877f67740a14$var$ThreeRight) {
                                $tco_var_v = v.value1;
                                $copy_v1 = new $0a19877f67740a14$var$KickUp(new $0a19877f67740a14$var$Two(v.value0.value0, v.value0.value1, v.value0.value2), v.value0.value3, new $0a19877f67740a14$var$Two(v1.value0, v1.value1, v1.value2));
                                return;
                            }
                            throw new Error("Failed pattern match at Data.List.Internal (line 58, column 5 - line 63, column 90): " + [
                                v.value0.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        throw new Error("Failed pattern match at Data.List.Internal (line 55, column 3 - line 55, column 50): " + [
                            v.constructor.name,
                            v1.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                    return $tco_result;
                };
            };
            var down = function($copy_v) {
                return function($copy_v1) {
                    var $tco_var_v = $copy_v;
                    var $tco_done1 = false;
                    var $tco_result;
                    function $tco_loop(v, v1) {
                        if (v1 instanceof $0a19877f67740a14$var$Leaf) {
                            $tco_done1 = true;
                            return {
                                found: false,
                                result: up(v)(new $0a19877f67740a14$var$KickUp($0a19877f67740a14$var$Leaf.value, k, $0a19877f67740a14$var$Leaf.value))
                            };
                        }
                        if (v1 instanceof $0a19877f67740a14$var$Two) {
                            var v2 = comp(k)(v1.value1);
                            if (v2 instanceof $ibsD5.EQ) {
                                $tco_done1 = true;
                                return {
                                    found: true,
                                    result: orig
                                };
                            }
                            if (v2 instanceof $ibsD5.LT) {
                                $tco_var_v = new $fZenR.Cons(new $0a19877f67740a14$var$TwoLeft(v1.value1, v1.value2), v);
                                $copy_v1 = v1.value0;
                                return;
                            }
                            $tco_var_v = new $fZenR.Cons(new $0a19877f67740a14$var$TwoRight(v1.value0, v1.value1), v);
                            $copy_v1 = v1.value2;
                            return;
                        }
                        if (v1 instanceof $0a19877f67740a14$var$Three) {
                            var v2 = comp(k)(v1.value1);
                            if (v2 instanceof $ibsD5.EQ) {
                                $tco_done1 = true;
                                return {
                                    found: true,
                                    result: orig
                                };
                            }
                            var v3 = comp(k)(v1.value3);
                            if (v3 instanceof $ibsD5.EQ) {
                                $tco_done1 = true;
                                return {
                                    found: true,
                                    result: orig
                                };
                            }
                            if (v2 instanceof $ibsD5.LT) {
                                $tco_var_v = new $fZenR.Cons(new $0a19877f67740a14$var$ThreeLeft(v1.value1, v1.value2, v1.value3, v1.value4), v);
                                $copy_v1 = v1.value0;
                                return;
                            }
                            if (v2 instanceof $ibsD5.GT && v3 instanceof $ibsD5.LT) {
                                $tco_var_v = new $fZenR.Cons(new $0a19877f67740a14$var$ThreeMiddle(v1.value0, v1.value1, v1.value3, v1.value4), v);
                                $copy_v1 = v1.value2;
                                return;
                            }
                            $tco_var_v = new $fZenR.Cons(new $0a19877f67740a14$var$ThreeRight(v1.value0, v1.value1, v1.value2, v1.value3), v);
                            $copy_v1 = v1.value4;
                            return;
                        }
                        throw new Error("Failed pattern match at Data.List.Internal (line 38, column 3 - line 38, column 81): " + [
                            v.constructor.name,
                            v1.constructor.name
                        ]);
                    }
                    while(!$tco_done1)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                    return $tco_result;
                };
            };
            return down($fZenR.Nil.value)(orig);
        };
    };
};
var $0a19877f67740a14$export$4e5bc754a9c955a = /* #__PURE__ */ function() {
    return $0a19877f67740a14$var$Leaf.value;
}();

});
parcelRegister("fZenR", function(module, exports) {

$parcel$export(module.exports, "Nil", () => $ba37b5ddee8fdfb0$export$c1bed610ade55e1c);
$parcel$export(module.exports, "Cons", () => $ba37b5ddee8fdfb0$export$74c44e616647f5c0);
$parcel$export(module.exports, "NonEmptyList", () => $ba37b5ddee8fdfb0$export$ab241a3582569781);
$parcel$export(module.exports, "functorList", () => $ba37b5ddee8fdfb0$export$40b9e4330ffd17e3);
$parcel$export(module.exports, "functorNonEmptyList", () => $ba37b5ddee8fdfb0$export$3c979cc7d75b024c);
$parcel$export(module.exports, "foldableList", () => $ba37b5ddee8fdfb0$export$92659ee1fc91a075);
$parcel$export(module.exports, "semigroupList", () => $ba37b5ddee8fdfb0$export$11cb7909a85856b);
$parcel$export(module.exports, "showList", () => $ba37b5ddee8fdfb0$export$36831384a74c4427);
$parcel$export(module.exports, "traversableList", () => $ba37b5ddee8fdfb0$export$99c2ce29c0ead637);
$parcel$export(module.exports, "unfoldableList", () => $ba37b5ddee8fdfb0$export$1d41caf0a0a6a680);
$parcel$export(module.exports, "eqList", () => $ba37b5ddee8fdfb0$export$1ae88a7f3c5f59ef);
$parcel$export(module.exports, "ordList", () => $ba37b5ddee8fdfb0$export$86359cd4476084f8);
$parcel$export(module.exports, "bindList", () => $ba37b5ddee8fdfb0$export$497dcf96eb2383ec);
$parcel$export(module.exports, "bindNonEmptyList", () => $ba37b5ddee8fdfb0$export$12e3398ee6f4a417);
$parcel$export(module.exports, "applicativeList", () => $ba37b5ddee8fdfb0$export$25cda6d3e08b28fe);
$parcel$export(module.exports, "plusList", () => $ba37b5ddee8fdfb0$export$55d622505c452dcb);
$parcel$export(module.exports, "traversable1NonEmptyList", () => $ba37b5ddee8fdfb0$export$fac1bbd0707bc766);
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $26SV5 = parcelRequire("26SV5");

var $aJhEx = parcelRequire("aJhEx");

var $dNwPt = parcelRequire("dNwPt");

var $7vxKS = parcelRequire("7vxKS");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $lzCaM = parcelRequire("lzCaM");

var $h2xUu = parcelRequire("h2xUu");

var $3aOYV = parcelRequire("3aOYV");

var $9aSRU = parcelRequire("9aSRU");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $d5vvq = parcelRequire("d5vvq");

var $6ywL5 = parcelRequire("6ywL5");

var $iVjQa = parcelRequire("iVjQa");

var $2XxiF = parcelRequire("2XxiF");

var $9OOYG = parcelRequire("9OOYG");

var $bijFl = parcelRequire("bijFl");

var $7O0Q4 = parcelRequire("7O0Q4");
var $ba37b5ddee8fdfb0$var$add = /* #__PURE__ */ $iVjQa.add($iVjQa.semiringInt);
var $ba37b5ddee8fdfb0$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $ba37b5ddee8fdfb0$export$c1bed610ade55e1c = /* #__PURE__ */ function() {
    function Nil() {}
    Nil.value = new Nil();
    return Nil;
}();
var $ba37b5ddee8fdfb0$export$74c44e616647f5c0 = /* #__PURE__ */ function() {
    function Cons(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Cons.create = function(value0) {
        return function(value1) {
            return new Cons(value0, value1);
        };
    };
    return Cons;
}();
var $ba37b5ddee8fdfb0$export$ab241a3582569781 = function(x) {
    return x;
};
var $ba37b5ddee8fdfb0$export$effcdbd76139450 = function(v) {
    return new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(v.value0, v.value1);
};
var $ba37b5ddee8fdfb0$export$e1330f0deced5836 = {
    Coercible0: function() {
        return undefined;
    }
};
var $ba37b5ddee8fdfb0$export$4fa915e2865b1814 = function(a) {
    return function(v) {
        return new $9aSRU.NonEmpty(a, new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(v.value0, v.value1));
    };
};
var $ba37b5ddee8fdfb0$var$listMap = function(f) {
    var chunkedRevMap = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0 && v1.value1 instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0 && v1.value1.value1 instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0) {
                    $tco_var_v = new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(v1, v);
                    $copy_v1 = v1.value1.value1.value1;
                    return;
                }
                var unrolledMap = function(v2) {
                    if (v2 instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0 && v2.value1 instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0 && v2.value1.value1 instanceof $ba37b5ddee8fdfb0$export$c1bed610ade55e1c) return new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(f(v2.value0), new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(f(v2.value1.value0), $ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value));
                    if (v2 instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0 && v2.value1 instanceof $ba37b5ddee8fdfb0$export$c1bed610ade55e1c) return new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(f(v2.value0), $ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value);
                    return $ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value;
                };
                var reverseUnrolledMap = function($copy_v2) {
                    return function($copy_v3) {
                        var $tco_var_v2 = $copy_v2;
                        var $tco_done1 = false;
                        var $tco_result;
                        function $tco_loop(v2, v3) {
                            if (v2 instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0 && v2.value0 instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0 && v2.value0.value1 instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0 && v2.value0.value1.value1 instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0) {
                                $tco_var_v2 = v2.value1;
                                $copy_v3 = new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(f(v2.value0.value0), new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(f(v2.value0.value1.value0), new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(f(v2.value0.value1.value1.value0), v3)));
                                return;
                            }
                            $tco_done1 = true;
                            return v3;
                        }
                        while(!$tco_done1)$tco_result = $tco_loop($tco_var_v2, $copy_v3);
                        return $tco_result;
                    };
                };
                $tco_done = true;
                return reverseUnrolledMap(v)(unrolledMap(v1));
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return chunkedRevMap($ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value);
};
var $ba37b5ddee8fdfb0$export$40b9e4330ffd17e3 = {
    map: $ba37b5ddee8fdfb0$var$listMap
};
var $ba37b5ddee8fdfb0$var$map = /* #__PURE__ */ $7FzSN.map($ba37b5ddee8fdfb0$export$40b9e4330ffd17e3);
var $ba37b5ddee8fdfb0$export$3c979cc7d75b024c = /* #__PURE__ */ $9aSRU.functorNonEmpty($ba37b5ddee8fdfb0$export$40b9e4330ffd17e3);
var $ba37b5ddee8fdfb0$export$92659ee1fc91a075 = {
    foldr: function(f) {
        return function(b) {
            var rev = function() {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        var $tco_var_v = $copy_v;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1) {
                            if (v1 instanceof $ba37b5ddee8fdfb0$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return v;
                            }
                            if (v1 instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0) {
                                $tco_var_v = new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(v1.value0, v);
                                $copy_v1 = v1.value1;
                                return;
                            }
                            throw new Error("Failed pattern match at Data.List.Types (line 107, column 7 - line 107, column 23): " + [
                                v.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                        return $tco_result;
                    };
                };
                return go($ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value);
            }();
            var $284 = $dNwPt.foldl($ba37b5ddee8fdfb0$export$92659ee1fc91a075)($jhsiw.flip(f))(b);
            return function($285) {
                return $284(rev($285));
            };
        };
    },
    foldl: function(f) {
        var go = function($copy_b) {
            return function($copy_v) {
                var $tco_var_b = $copy_b;
                var $tco_done1 = false;
                var $tco_result;
                function $tco_loop(b, v) {
                    if (v instanceof $ba37b5ddee8fdfb0$export$c1bed610ade55e1c) {
                        $tco_done1 = true;
                        return b;
                    }
                    if (v instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0) {
                        $tco_var_b = f(b)(v.value0);
                        $copy_v = v.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List.Types (line 111, column 12 - line 113, column 30): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done1)$tco_result = $tco_loop($tco_var_b, $copy_v);
                return $tco_result;
            };
        };
        return go;
    },
    foldMap: function(dictMonoid) {
        var append2 = $d5vvq.append(dictMonoid.Semigroup0());
        var mempty = $3aOYV.mempty(dictMonoid);
        return function(f) {
            return $dNwPt.foldl($ba37b5ddee8fdfb0$export$92659ee1fc91a075)(function(acc) {
                var $286 = append2(acc);
                return function($287) {
                    return $286(f($287));
                };
            })(mempty);
        };
    }
};
var $ba37b5ddee8fdfb0$var$foldl = /* #__PURE__ */ $dNwPt.foldl($ba37b5ddee8fdfb0$export$92659ee1fc91a075);
var $ba37b5ddee8fdfb0$var$foldr = /* #__PURE__ */ $dNwPt.foldr($ba37b5ddee8fdfb0$export$92659ee1fc91a075);
var $ba37b5ddee8fdfb0$var$intercalate = /* #__PURE__ */ $dNwPt.intercalate($ba37b5ddee8fdfb0$export$92659ee1fc91a075)($3aOYV.monoidString);
var $ba37b5ddee8fdfb0$export$604c31769a93bbe0 = /* #__PURE__ */ $9aSRU.foldableNonEmpty($ba37b5ddee8fdfb0$export$92659ee1fc91a075);
var $ba37b5ddee8fdfb0$export$465bfc9894c20a50 = {
    foldrWithIndex: function(f) {
        return function(b) {
            return function(xs) {
                var v = function() {
                    var rev = $ba37b5ddee8fdfb0$var$foldl(function(v1) {
                        return function(a) {
                            return new $7O0Q4.Tuple(v1.value0 + 1 | 0, new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(a, v1.value1));
                        };
                    });
                    return rev(new $7O0Q4.Tuple(0, $ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value))(xs);
                }();
                return $7O0Q4.snd($ba37b5ddee8fdfb0$var$foldl(function(v1) {
                    return function(a) {
                        return new $7O0Q4.Tuple(v1.value0 - 1 | 0, f(v1.value0 - 1 | 0)(a)(v1.value1));
                    };
                })(new $7O0Q4.Tuple(v.value0, b))(v.value1));
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(acc) {
            var $288 = $ba37b5ddee8fdfb0$var$foldl(function(v) {
                return function(a) {
                    return new $7O0Q4.Tuple(v.value0 + 1 | 0, f(v.value0)(v.value1)(a));
                };
            })(new $7O0Q4.Tuple(0, acc));
            return function($289) {
                return $7O0Q4.snd($288($289));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var append2 = $d5vvq.append(dictMonoid.Semigroup0());
        var mempty = $3aOYV.mempty(dictMonoid);
        return function(f) {
            return $7vxKS.foldlWithIndex($ba37b5ddee8fdfb0$export$465bfc9894c20a50)(function(i) {
                return function(acc) {
                    var $290 = append2(acc);
                    var $291 = f(i);
                    return function($292) {
                        return $290($291($292));
                    };
                };
            })(mempty);
        };
    },
    Foldable0: function() {
        return $ba37b5ddee8fdfb0$export$92659ee1fc91a075;
    }
};
var $ba37b5ddee8fdfb0$var$foldableWithIndexNonEmpty = /* #__PURE__ */ $9aSRU.foldableWithIndexNonEmpty($ba37b5ddee8fdfb0$export$465bfc9894c20a50);
var $ba37b5ddee8fdfb0$var$foldMapWithIndex = /* #__PURE__ */ $7vxKS.foldMapWithIndex($ba37b5ddee8fdfb0$var$foldableWithIndexNonEmpty);
var $ba37b5ddee8fdfb0$var$foldlWithIndex = /* #__PURE__ */ $7vxKS.foldlWithIndex($ba37b5ddee8fdfb0$var$foldableWithIndexNonEmpty);
var $ba37b5ddee8fdfb0$var$foldrWithIndex = /* #__PURE__ */ $7vxKS.foldrWithIndex($ba37b5ddee8fdfb0$var$foldableWithIndexNonEmpty);
var $ba37b5ddee8fdfb0$var$foldrWithIndex1 = /* #__PURE__ */ $7vxKS.foldrWithIndex($ba37b5ddee8fdfb0$export$465bfc9894c20a50);
var $ba37b5ddee8fdfb0$var$foldlWithIndex1 = /* #__PURE__ */ $7vxKS.foldlWithIndex($ba37b5ddee8fdfb0$export$465bfc9894c20a50);
var $ba37b5ddee8fdfb0$export$181d5b43cf38a79a = {
    foldMapWithIndex: function(dictMonoid) {
        var foldMapWithIndex1 = $ba37b5ddee8fdfb0$var$foldMapWithIndex(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMapWithIndex1(function() {
                    var $293 = $h2xUu.maybe(0)($ba37b5ddee8fdfb0$var$add(1));
                    return function($294) {
                        return f($293($294));
                    };
                }())(v);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(b) {
            return function(v) {
                return $ba37b5ddee8fdfb0$var$foldlWithIndex(function() {
                    var $295 = $h2xUu.maybe(0)($ba37b5ddee8fdfb0$var$add(1));
                    return function($296) {
                        return f($295($296));
                    };
                }())(b)(v);
            };
        };
    },
    foldrWithIndex: function(f) {
        return function(b) {
            return function(v) {
                return $ba37b5ddee8fdfb0$var$foldrWithIndex(function() {
                    var $297 = $h2xUu.maybe(0)($ba37b5ddee8fdfb0$var$add(1));
                    return function($298) {
                        return f($297($298));
                    };
                }())(b)(v);
            };
        };
    },
    Foldable0: function() {
        return $ba37b5ddee8fdfb0$export$604c31769a93bbe0;
    }
};
var $ba37b5ddee8fdfb0$export$3951fb12c9649f2b = {
    mapWithIndex: function(f) {
        return $ba37b5ddee8fdfb0$var$foldrWithIndex1(function(i) {
            return function(x) {
                return function(acc) {
                    return new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(f(i)(x), acc);
                };
            };
        })($ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value);
    },
    Functor0: function() {
        return $ba37b5ddee8fdfb0$export$40b9e4330ffd17e3;
    }
};
var $ba37b5ddee8fdfb0$var$mapWithIndex = /* #__PURE__ */ $lzCaM.mapWithIndex(/* #__PURE__ */ $9aSRU.functorWithIndex($ba37b5ddee8fdfb0$export$3951fb12c9649f2b));
var $ba37b5ddee8fdfb0$export$116ff457f4ca2f6a = {
    mapWithIndex: function(fn) {
        return function(v) {
            return $ba37b5ddee8fdfb0$var$mapWithIndex(function() {
                var $299 = $h2xUu.maybe(0)($ba37b5ddee8fdfb0$var$add(1));
                return function($300) {
                    return fn($299($300));
                };
            }())(v);
        };
    },
    Functor0: function() {
        return $ba37b5ddee8fdfb0$export$3c979cc7d75b024c;
    }
};
var $ba37b5ddee8fdfb0$export$11cb7909a85856b = {
    append: function(xs) {
        return function(ys) {
            return $ba37b5ddee8fdfb0$var$foldr($ba37b5ddee8fdfb0$export$74c44e616647f5c0.create)(ys)(xs);
        };
    }
};
var $ba37b5ddee8fdfb0$var$append1 = /* #__PURE__ */ $d5vvq.append($ba37b5ddee8fdfb0$export$11cb7909a85856b);
var $ba37b5ddee8fdfb0$export$14584e231e9c63ca = /* #__PURE__ */ function() {
    return {
        mempty: $ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value,
        Semigroup0: function() {
            return $ba37b5ddee8fdfb0$export$11cb7909a85856b;
        }
    };
}();
var $ba37b5ddee8fdfb0$export$a8cfc3dfdfca72cf = {
    append: function(v) {
        return function(as$prime) {
            return new $9aSRU.NonEmpty(v.value0, $ba37b5ddee8fdfb0$var$append1(v.value1)($ba37b5ddee8fdfb0$export$effcdbd76139450(as$prime)));
        };
    }
};
var $ba37b5ddee8fdfb0$export$36831384a74c4427 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(v) {
            if (v instanceof $ba37b5ddee8fdfb0$export$c1bed610ade55e1c) return "Nil";
            return "(" + ($ba37b5ddee8fdfb0$var$intercalate(" : ")($ba37b5ddee8fdfb0$var$map(show)(v)) + " : Nil)");
        }
    };
};
var $ba37b5ddee8fdfb0$export$3a5290e21dfc0ad7 = function(dictShow) {
    var show = $2XxiF.show($9aSRU.showNonEmpty(dictShow)($ba37b5ddee8fdfb0$export$36831384a74c4427(dictShow)));
    return {
        show: function(v) {
            return "(NonEmptyList " + (show(v) + ")");
        }
    };
};
var $ba37b5ddee8fdfb0$export$99c2ce29c0ead637 = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var map1 = $7FzSN.map(Apply0.Functor0());
        var lift2 = $26ZCq.lift2(Apply0);
        var pure1 = $bQdkN.pure(dictApplicative);
        return function(f) {
            var $301 = map1($ba37b5ddee8fdfb0$var$foldl($jhsiw.flip($ba37b5ddee8fdfb0$export$74c44e616647f5c0.create))($ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value));
            var $302 = $ba37b5ddee8fdfb0$var$foldl(function(acc) {
                var $304 = lift2($jhsiw.flip($ba37b5ddee8fdfb0$export$74c44e616647f5c0.create))(acc);
                return function($305) {
                    return $304(f($305));
                };
            })(pure1($ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value));
            return function($303) {
                return $301($302($303));
            };
        };
    },
    sequence: function(dictApplicative) {
        return $9OOYG.traverse($ba37b5ddee8fdfb0$export$99c2ce29c0ead637)(dictApplicative)($ba37b5ddee8fdfb0$var$identity);
    },
    Functor0: function() {
        return $ba37b5ddee8fdfb0$export$40b9e4330ffd17e3;
    },
    Foldable1: function() {
        return $ba37b5ddee8fdfb0$export$92659ee1fc91a075;
    }
};
var $ba37b5ddee8fdfb0$export$d0a0d45336d2d3e3 = /* #__PURE__ */ $9aSRU.traversableNonEmpty($ba37b5ddee8fdfb0$export$99c2ce29c0ead637);
var $ba37b5ddee8fdfb0$export$aed77e3b7bbfc02d = {
    traverseWithIndex: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var map1 = $7FzSN.map(Apply0.Functor0());
        var lift2 = $26ZCq.lift2(Apply0);
        var pure1 = $bQdkN.pure(dictApplicative);
        return function(f) {
            var rev = $ba37b5ddee8fdfb0$var$foldl($jhsiw.flip($ba37b5ddee8fdfb0$export$74c44e616647f5c0.create))($ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value);
            var $306 = map1(rev);
            var $307 = $ba37b5ddee8fdfb0$var$foldlWithIndex1(function(i) {
                return function(acc) {
                    var $309 = lift2($jhsiw.flip($ba37b5ddee8fdfb0$export$74c44e616647f5c0.create))(acc);
                    var $310 = f(i);
                    return function($311) {
                        return $309($310($311));
                    };
                };
            })(pure1($ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value));
            return function($308) {
                return $306($307($308));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $ba37b5ddee8fdfb0$export$3951fb12c9649f2b;
    },
    FoldableWithIndex1: function() {
        return $ba37b5ddee8fdfb0$export$465bfc9894c20a50;
    },
    Traversable2: function() {
        return $ba37b5ddee8fdfb0$export$99c2ce29c0ead637;
    }
};
var $ba37b5ddee8fdfb0$var$traverseWithIndex = /* #__PURE__ */ $bijFl.traverseWithIndex(/* #__PURE__ */ $9aSRU.traversableWithIndexNonEmpty($ba37b5ddee8fdfb0$export$aed77e3b7bbfc02d));
var $ba37b5ddee8fdfb0$export$29974dc3d1d7196b = {
    traverseWithIndex: function(dictApplicative) {
        var map1 = $7FzSN.map(dictApplicative.Apply0().Functor0());
        var traverseWithIndex1 = $ba37b5ddee8fdfb0$var$traverseWithIndex(dictApplicative);
        return function(f) {
            return function(v) {
                return map1($ba37b5ddee8fdfb0$export$ab241a3582569781)(traverseWithIndex1(function() {
                    var $312 = $h2xUu.maybe(0)($ba37b5ddee8fdfb0$var$add(1));
                    return function($313) {
                        return f($312($313));
                    };
                }())(v));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $ba37b5ddee8fdfb0$export$116ff457f4ca2f6a;
    },
    FoldableWithIndex1: function() {
        return $ba37b5ddee8fdfb0$export$181d5b43cf38a79a;
    },
    Traversable2: function() {
        return $ba37b5ddee8fdfb0$export$d0a0d45336d2d3e3;
    }
};
var $ba37b5ddee8fdfb0$export$c7fe2ca4bf0cb8df = {
    unfoldr1: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v.value1 instanceof $h2xUu.Just) {
                            $tco_var_source = v.value1.value0;
                            $copy_memo = new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(v.value0, memo);
                            return;
                        }
                        if (v.value1 instanceof $h2xUu.Nothing) {
                            $tco_done = true;
                            return $ba37b5ddee8fdfb0$var$foldl($jhsiw.flip($ba37b5ddee8fdfb0$export$74c44e616647f5c0.create))($ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value)(new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(v.value0, memo));
                        }
                        throw new Error("Failed pattern match at Data.List.Types (line 135, column 22 - line 137, column 61): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value);
        };
    }
};
var $ba37b5ddee8fdfb0$export$1d41caf0a0a6a680 = {
    unfoldr: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v instanceof $h2xUu.Nothing) {
                            $tco_done = true;
                            return $ba37b5ddee8fdfb0$var$foldl($jhsiw.flip($ba37b5ddee8fdfb0$export$74c44e616647f5c0.create))($ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value)(memo);
                        }
                        if (v instanceof $h2xUu.Just) {
                            $tco_var_source = v.value0.value1;
                            $copy_memo = new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(v.value0.value0, memo);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.List.Types (line 142, column 22 - line 144, column 52): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value);
        };
    },
    Unfoldable10: function() {
        return $ba37b5ddee8fdfb0$export$c7fe2ca4bf0cb8df;
    }
};
var $ba37b5ddee8fdfb0$export$6907256bb4275b5b = /* #__PURE__ */ $9aSRU.unfoldable1NonEmpty($ba37b5ddee8fdfb0$export$1d41caf0a0a6a680);
var $ba37b5ddee8fdfb0$export$b16c60cd2a91c938 = /* #__PURE__ */ $9aSRU.foldable1NonEmpty($ba37b5ddee8fdfb0$export$92659ee1fc91a075);
var $ba37b5ddee8fdfb0$export$44a6d15320cfc4c5 = {
    extend: function(f) {
        return function(v) {
            var go = function(a) {
                return function(v1) {
                    return {
                        val: new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(f(new $9aSRU.NonEmpty(a, v1.acc)), v1.val),
                        acc: new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(a, v1.acc)
                    };
                };
            };
            return new $9aSRU.NonEmpty(f(v), $ba37b5ddee8fdfb0$var$foldr(go)({
                val: $ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value,
                acc: $ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value
            })(v.value1).val);
        };
    },
    Functor0: function() {
        return $ba37b5ddee8fdfb0$export$3c979cc7d75b024c;
    }
};
var $ba37b5ddee8fdfb0$export$a2b02e086d468c06 = {
    extend: function(v) {
        return function(v1) {
            if (v1 instanceof $ba37b5ddee8fdfb0$export$c1bed610ade55e1c) return $ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value;
            if (v1 instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0) {
                var go = function(a$prime) {
                    return function(v2) {
                        var acc$prime = new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(a$prime, v2.acc);
                        return {
                            val: new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(v(acc$prime), v2.val),
                            acc: acc$prime
                        };
                    };
                };
                return new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(v(v1), $ba37b5ddee8fdfb0$var$foldr(go)({
                    val: $ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value,
                    acc: $ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value
                })(v1.value1).val);
            }
            throw new Error("Failed pattern match at Data.List.Types (line 180, column 1 - line 187, column 42): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $ba37b5ddee8fdfb0$export$40b9e4330ffd17e3;
    }
};
var $ba37b5ddee8fdfb0$export$b7e705972f3b8317 = {
    eq1: function(dictEq) {
        var eq = $aJhEx.eq(dictEq);
        return function(xs) {
            return function(ys) {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        return function($copy_v2) {
                            var $tco_var_v = $copy_v;
                            var $tco_var_v1 = $copy_v1;
                            var $tco_done = false;
                            var $tco_result;
                            function $tco_loop(v, v1, v2) {
                                if (!v2) {
                                    $tco_done = true;
                                    return false;
                                }
                                if (v instanceof $ba37b5ddee8fdfb0$export$c1bed610ade55e1c && v1 instanceof $ba37b5ddee8fdfb0$export$c1bed610ade55e1c) {
                                    $tco_done = true;
                                    return v2;
                                }
                                if (v instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0 && v1 instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0) {
                                    $tco_var_v = v.value1;
                                    $tco_var_v1 = v1.value1;
                                    $copy_v2 = v2 && eq(v1.value0)(v.value0);
                                    return;
                                }
                                $tco_done = true;
                                return false;
                            }
                            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                            return $tco_result;
                        };
                    };
                };
                return go(xs)(ys)(true);
            };
        };
    }
};
var $ba37b5ddee8fdfb0$var$eq1 = /* #__PURE__ */ $aJhEx.eq1($ba37b5ddee8fdfb0$export$b7e705972f3b8317);
var $ba37b5ddee8fdfb0$var$eqNonEmpty = /* #__PURE__ */ $9aSRU.eqNonEmpty($ba37b5ddee8fdfb0$export$b7e705972f3b8317);
var $ba37b5ddee8fdfb0$export$80901a10e94c964a = /* #__PURE__ */ $9aSRU.eq1NonEmpty($ba37b5ddee8fdfb0$export$b7e705972f3b8317);
var $ba37b5ddee8fdfb0$export$1ae88a7f3c5f59ef = function(dictEq) {
    return {
        eq: $ba37b5ddee8fdfb0$var$eq1(dictEq)
    };
};
var $ba37b5ddee8fdfb0$export$25985b0447eac39b = function(dictEq) {
    return $ba37b5ddee8fdfb0$var$eqNonEmpty(dictEq);
};
var $ba37b5ddee8fdfb0$export$a37dd417b96243af = {
    compare1: function(dictOrd) {
        var compare = $gwBF5.compare(dictOrd);
        return function(xs) {
            return function(ys) {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        var $tco_var_v = $copy_v;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1) {
                            if (v instanceof $ba37b5ddee8fdfb0$export$c1bed610ade55e1c && v1 instanceof $ba37b5ddee8fdfb0$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $ibsD5.EQ.value;
                            }
                            if (v instanceof $ba37b5ddee8fdfb0$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $ibsD5.LT.value;
                            }
                            if (v1 instanceof $ba37b5ddee8fdfb0$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $ibsD5.GT.value;
                            }
                            if (v instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0 && v1 instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0) {
                                var v2 = compare(v.value0)(v1.value0);
                                if (v2 instanceof $ibsD5.EQ) {
                                    $tco_var_v = v.value1;
                                    $copy_v1 = v1.value1;
                                    return;
                                }
                                $tco_done = true;
                                return v2;
                            }
                            throw new Error("Failed pattern match at Data.List.Types (line 60, column 5 - line 60, column 20): " + [
                                v.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                        return $tco_result;
                    };
                };
                return go(xs)(ys);
            };
        };
    },
    Eq10: function() {
        return $ba37b5ddee8fdfb0$export$b7e705972f3b8317;
    }
};
var $ba37b5ddee8fdfb0$var$compare1 = /* #__PURE__ */ $gwBF5.compare1($ba37b5ddee8fdfb0$export$a37dd417b96243af);
var $ba37b5ddee8fdfb0$var$ordNonEmpty = /* #__PURE__ */ $9aSRU.ordNonEmpty($ba37b5ddee8fdfb0$export$a37dd417b96243af);
var $ba37b5ddee8fdfb0$export$bf20701e75931fe8 = /* #__PURE__ */ $9aSRU.ord1NonEmpty($ba37b5ddee8fdfb0$export$a37dd417b96243af);
var $ba37b5ddee8fdfb0$export$86359cd4476084f8 = function(dictOrd) {
    var eqList1 = $ba37b5ddee8fdfb0$export$1ae88a7f3c5f59ef(dictOrd.Eq0());
    return {
        compare: $ba37b5ddee8fdfb0$var$compare1(dictOrd),
        Eq0: function() {
            return eqList1;
        }
    };
};
var $ba37b5ddee8fdfb0$export$783a13ebf5a1203d = function(dictOrd) {
    return $ba37b5ddee8fdfb0$var$ordNonEmpty(dictOrd);
};
var $ba37b5ddee8fdfb0$export$7bc4d4de9c57db1f = {
    extract: function(v) {
        return v.value0;
    },
    Extend0: function() {
        return $ba37b5ddee8fdfb0$export$44a6d15320cfc4c5;
    }
};
var $ba37b5ddee8fdfb0$export$7e49f2fa1ca16fbc = {
    apply: function(v) {
        return function(v1) {
            if (v instanceof $ba37b5ddee8fdfb0$export$c1bed610ade55e1c) return $ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value;
            if (v instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0) return $ba37b5ddee8fdfb0$var$append1($ba37b5ddee8fdfb0$var$map(v.value0)(v1))($26ZCq.apply($ba37b5ddee8fdfb0$export$7e49f2fa1ca16fbc)(v.value1)(v1));
            throw new Error("Failed pattern match at Data.List.Types (line 157, column 1 - line 159, column 48): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $ba37b5ddee8fdfb0$export$40b9e4330ffd17e3;
    }
};
var $ba37b5ddee8fdfb0$var$apply = /* #__PURE__ */ $26ZCq.apply($ba37b5ddee8fdfb0$export$7e49f2fa1ca16fbc);
var $ba37b5ddee8fdfb0$export$18f1a42667f2921e = {
    apply: function(v) {
        return function(v1) {
            return new $9aSRU.NonEmpty(v.value0(v1.value0), $ba37b5ddee8fdfb0$var$append1($ba37b5ddee8fdfb0$var$apply(v.value1)(new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(v1.value0, $ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value)))($ba37b5ddee8fdfb0$var$apply(new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(v.value0, v.value1))(v1.value1)));
        };
    },
    Functor0: function() {
        return $ba37b5ddee8fdfb0$export$3c979cc7d75b024c;
    }
};
var $ba37b5ddee8fdfb0$export$497dcf96eb2383ec = {
    bind: function(v) {
        return function(v1) {
            if (v instanceof $ba37b5ddee8fdfb0$export$c1bed610ade55e1c) return $ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value;
            if (v instanceof $ba37b5ddee8fdfb0$export$74c44e616647f5c0) return $ba37b5ddee8fdfb0$var$append1(v1(v.value0))($cADnC.bind($ba37b5ddee8fdfb0$export$497dcf96eb2383ec)(v.value1)(v1));
            throw new Error("Failed pattern match at Data.List.Types (line 164, column 1 - line 166, column 37): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Apply0: function() {
        return $ba37b5ddee8fdfb0$export$7e49f2fa1ca16fbc;
    }
};
var $ba37b5ddee8fdfb0$var$bind = /* #__PURE__ */ $cADnC.bind($ba37b5ddee8fdfb0$export$497dcf96eb2383ec);
var $ba37b5ddee8fdfb0$export$12e3398ee6f4a417 = {
    bind: function(v) {
        return function(f) {
            var v1 = f(v.value0);
            return new $9aSRU.NonEmpty(v1.value0, $ba37b5ddee8fdfb0$var$append1(v1.value1)($ba37b5ddee8fdfb0$var$bind(v.value1)(function($314) {
                return $ba37b5ddee8fdfb0$export$effcdbd76139450(f($314));
            })));
        };
    },
    Apply0: function() {
        return $ba37b5ddee8fdfb0$export$18f1a42667f2921e;
    }
};
var $ba37b5ddee8fdfb0$export$25cda6d3e08b28fe = {
    pure: function(a) {
        return new $ba37b5ddee8fdfb0$export$74c44e616647f5c0(a, $ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value);
    },
    Apply0: function() {
        return $ba37b5ddee8fdfb0$export$7e49f2fa1ca16fbc;
    }
};
var $ba37b5ddee8fdfb0$export$7c78e86b21f51881 = {
    Applicative0: function() {
        return $ba37b5ddee8fdfb0$export$25cda6d3e08b28fe;
    },
    Bind1: function() {
        return $ba37b5ddee8fdfb0$export$497dcf96eb2383ec;
    }
};
var $ba37b5ddee8fdfb0$export$852a754cd45a1ed = {
    alt: /* #__PURE__ */ $d5vvq.append($ba37b5ddee8fdfb0$export$a8cfc3dfdfca72cf),
    Functor0: function() {
        return $ba37b5ddee8fdfb0$export$3c979cc7d75b024c;
    }
};
var $ba37b5ddee8fdfb0$export$97980ce7ea95015b = {
    alt: $ba37b5ddee8fdfb0$var$append1,
    Functor0: function() {
        return $ba37b5ddee8fdfb0$export$40b9e4330ffd17e3;
    }
};
var $ba37b5ddee8fdfb0$export$55d622505c452dcb = /* #__PURE__ */ function() {
    return {
        empty: $ba37b5ddee8fdfb0$export$c1bed610ade55e1c.value,
        Alt0: function() {
            return $ba37b5ddee8fdfb0$export$97980ce7ea95015b;
        }
    };
}();
var $ba37b5ddee8fdfb0$export$503ce72759d93980 = {
    Applicative0: function() {
        return $ba37b5ddee8fdfb0$export$25cda6d3e08b28fe;
    },
    Plus1: function() {
        return $ba37b5ddee8fdfb0$export$55d622505c452dcb;
    }
};
var $ba37b5ddee8fdfb0$export$9ea554ee3c75e458 = {
    Monad0: function() {
        return $ba37b5ddee8fdfb0$export$7c78e86b21f51881;
    },
    Alternative1: function() {
        return $ba37b5ddee8fdfb0$export$503ce72759d93980;
    }
};
var $ba37b5ddee8fdfb0$export$e5d0ed5dac805e10 = {
    pure: /* #__PURE__ */ function() {
        var $315 = $9aSRU.singleton($ba37b5ddee8fdfb0$export$55d622505c452dcb);
        return function($316) {
            return $ba37b5ddee8fdfb0$export$ab241a3582569781($315($316));
        };
    }(),
    Apply0: function() {
        return $ba37b5ddee8fdfb0$export$18f1a42667f2921e;
    }
};
var $ba37b5ddee8fdfb0$var$pure = /* #__PURE__ */ $bQdkN.pure($ba37b5ddee8fdfb0$export$e5d0ed5dac805e10);
var $ba37b5ddee8fdfb0$export$f444cc7484072e62 = {
    Applicative0: function() {
        return $ba37b5ddee8fdfb0$export$e5d0ed5dac805e10;
    },
    Bind1: function() {
        return $ba37b5ddee8fdfb0$export$12e3398ee6f4a417;
    }
};
var $ba37b5ddee8fdfb0$export$fac1bbd0707bc766 = {
    traverse1: function(dictApply) {
        var Functor0 = dictApply.Functor0();
        var mapFlipped = $7FzSN.mapFlipped(Functor0);
        var lift2 = $26ZCq.lift2(dictApply);
        var map1 = $7FzSN.map(Functor0);
        return function(f) {
            return function(v) {
                return mapFlipped($ba37b5ddee8fdfb0$var$foldl(function(acc) {
                    var $317 = lift2($jhsiw.flip($ba37b5ddee8fdfb0$export$4fa915e2865b1814))(acc);
                    return function($318) {
                        return $317(f($318));
                    };
                })(map1($ba37b5ddee8fdfb0$var$pure)(f(v.value0)))(v.value1))(function(v1) {
                    return $ba37b5ddee8fdfb0$var$foldl($jhsiw.flip($ba37b5ddee8fdfb0$export$4fa915e2865b1814))($ba37b5ddee8fdfb0$var$pure(v1.value0))(v1.value1);
                });
            };
        };
    },
    sequence1: function(dictApply) {
        return $6ywL5.traverse1($ba37b5ddee8fdfb0$export$fac1bbd0707bc766)(dictApply)($ba37b5ddee8fdfb0$var$identity);
    },
    Foldable10: function() {
        return $ba37b5ddee8fdfb0$export$b16c60cd2a91c938;
    },
    Traversable1: function() {
        return $ba37b5ddee8fdfb0$export$d0a0d45336d2d3e3;
    }
};

});
parcelRegister("7vxKS", function(module, exports) {

$parcel$export(module.exports, "foldrWithIndex", () => $57759cb27ff64fd1$export$d859ed9adfa064ca);
$parcel$export(module.exports, "forWithIndex_", () => $57759cb27ff64fd1$export$f441c83f81b7710f);
$parcel$export(module.exports, "foldlWithIndex", () => $57759cb27ff64fd1$export$2d70b9efb960f478);
$parcel$export(module.exports, "foldableWithIndexTuple", () => $57759cb27ff64fd1$export$a0208fa03195d5a3);
$parcel$export(module.exports, "foldableWithIndexMultiplicative", () => $57759cb27ff64fd1$export$e07746a44d4d0673);
$parcel$export(module.exports, "foldableWithIndexMaybe", () => $57759cb27ff64fd1$export$db675654cef60b9a);
$parcel$export(module.exports, "foldableWithIndexLast", () => $57759cb27ff64fd1$export$3a92905df29453fa);
$parcel$export(module.exports, "foldableWithIndexIdentity", () => $57759cb27ff64fd1$export$92c42163dd2c46ce);
$parcel$export(module.exports, "foldableWithIndexFirst", () => $57759cb27ff64fd1$export$328d1f7f0045c999);
$parcel$export(module.exports, "foldableWithIndexEither", () => $57759cb27ff64fd1$export$617fc130b23797ca);
$parcel$export(module.exports, "foldableWithIndexDual", () => $57759cb27ff64fd1$export$dc8026a24f95d0a9);
$parcel$export(module.exports, "foldableWithIndexDisj", () => $57759cb27ff64fd1$export$a77c731c3b37cfd);
$parcel$export(module.exports, "foldableWithIndexConst", () => $57759cb27ff64fd1$export$1add8b24fb58b747);
$parcel$export(module.exports, "foldableWithIndexConj", () => $57759cb27ff64fd1$export$707470fe74326665);
$parcel$export(module.exports, "foldableWithIndexAdditive", () => $57759cb27ff64fd1$export$f9ed9b5a8131479e);
$parcel$export(module.exports, "foldableWithIndexArray", () => $57759cb27ff64fd1$export$e728f47f20b1eb28);
$parcel$export(module.exports, "foldMapWithIndex", () => $57759cb27ff64fd1$export$18153bb1181268e5);
$parcel$export(module.exports, "foldableWithIndexApp", () => $57759cb27ff64fd1$export$ca1485f10f9ca9ee);
$parcel$export(module.exports, "foldableWithIndexCompose", () => $57759cb27ff64fd1$export$ed9dddd4d2a66e4d);
$parcel$export(module.exports, "foldableWithIndexCoproduct", () => $57759cb27ff64fd1$export$c8998bd70c04c75d);
$parcel$export(module.exports, "foldableWithIndexProduct", () => $57759cb27ff64fd1$export$e0fd1e7d0cab0fb2);
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $26SV5 = parcelRequire("26SV5");

var $beQI1 = parcelRequire("beQI1");

var $dNwPt = parcelRequire("dNwPt");

var $jhsiw = parcelRequire("jhsiw");

var $7Rccs = parcelRequire("7Rccs");

var $lzCaM = parcelRequire("lzCaM");

var $h2xUu = parcelRequire("h2xUu");

var $3aOYV = parcelRequire("3aOYV");

var $h73gt = parcelRequire("h73gt");

var $d4RtI = parcelRequire("d4RtI");

var $53NY2 = parcelRequire("53NY2");

var $ldkz2 = parcelRequire("ldkz2");

var $46y1S = parcelRequire("46y1S");

var $d5vvq = parcelRequire("d5vvq");

var $7O0Q4 = parcelRequire("7O0Q4");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
var $57759cb27ff64fd1$var$foldr = /* #__PURE__ */ $dNwPt.foldr($dNwPt.foldableMultiplicative);
var $57759cb27ff64fd1$var$foldl = /* #__PURE__ */ $dNwPt.foldl($dNwPt.foldableMultiplicative);
var $57759cb27ff64fd1$var$foldMap = /* #__PURE__ */ $dNwPt.foldMap($dNwPt.foldableMultiplicative);
var $57759cb27ff64fd1$var$foldr1 = /* #__PURE__ */ $dNwPt.foldr($dNwPt.foldableMaybe);
var $57759cb27ff64fd1$var$foldl1 = /* #__PURE__ */ $dNwPt.foldl($dNwPt.foldableMaybe);
var $57759cb27ff64fd1$var$foldMap1 = /* #__PURE__ */ $dNwPt.foldMap($dNwPt.foldableMaybe);
var $57759cb27ff64fd1$var$foldr2 = /* #__PURE__ */ $dNwPt.foldr($dNwPt.foldableLast);
var $57759cb27ff64fd1$var$foldl2 = /* #__PURE__ */ $dNwPt.foldl($dNwPt.foldableLast);
var $57759cb27ff64fd1$var$foldMap2 = /* #__PURE__ */ $dNwPt.foldMap($dNwPt.foldableLast);
var $57759cb27ff64fd1$var$foldr3 = /* #__PURE__ */ $dNwPt.foldr($dNwPt.foldableFirst);
var $57759cb27ff64fd1$var$foldl3 = /* #__PURE__ */ $dNwPt.foldl($dNwPt.foldableFirst);
var $57759cb27ff64fd1$var$foldMap3 = /* #__PURE__ */ $dNwPt.foldMap($dNwPt.foldableFirst);
var $57759cb27ff64fd1$var$foldr4 = /* #__PURE__ */ $dNwPt.foldr($dNwPt.foldableDual);
var $57759cb27ff64fd1$var$foldl4 = /* #__PURE__ */ $dNwPt.foldl($dNwPt.foldableDual);
var $57759cb27ff64fd1$var$foldMap4 = /* #__PURE__ */ $dNwPt.foldMap($dNwPt.foldableDual);
var $57759cb27ff64fd1$var$foldr5 = /* #__PURE__ */ $dNwPt.foldr($dNwPt.foldableDisj);
var $57759cb27ff64fd1$var$foldl5 = /* #__PURE__ */ $dNwPt.foldl($dNwPt.foldableDisj);
var $57759cb27ff64fd1$var$foldMap5 = /* #__PURE__ */ $dNwPt.foldMap($dNwPt.foldableDisj);
var $57759cb27ff64fd1$var$foldr6 = /* #__PURE__ */ $dNwPt.foldr($dNwPt.foldableConj);
var $57759cb27ff64fd1$var$foldl6 = /* #__PURE__ */ $dNwPt.foldl($dNwPt.foldableConj);
var $57759cb27ff64fd1$var$foldMap6 = /* #__PURE__ */ $dNwPt.foldMap($dNwPt.foldableConj);
var $57759cb27ff64fd1$var$foldr7 = /* #__PURE__ */ $dNwPt.foldr($dNwPt.foldableAdditive);
var $57759cb27ff64fd1$var$foldl7 = /* #__PURE__ */ $dNwPt.foldl($dNwPt.foldableAdditive);
var $57759cb27ff64fd1$var$foldMap7 = /* #__PURE__ */ $dNwPt.foldMap($dNwPt.foldableAdditive);
var $57759cb27ff64fd1$var$foldr8 = /* #__PURE__ */ $dNwPt.foldr($dNwPt.foldableArray);
var $57759cb27ff64fd1$var$mapWithIndex = /* #__PURE__ */ $lzCaM.mapWithIndex($lzCaM.functorWithIndexArray);
var $57759cb27ff64fd1$var$foldl8 = /* #__PURE__ */ $dNwPt.foldl($dNwPt.foldableArray);
var $57759cb27ff64fd1$var$unwrap = /* #__PURE__ */ $46y1S.unwrap();
var $57759cb27ff64fd1$var$monoidEndo = /* #__PURE__ */ $ldkz2.monoidEndo($26SV5.categoryFn);
var $57759cb27ff64fd1$var$monoidDual = /* #__PURE__ */ $53NY2.monoidDual($57759cb27ff64fd1$var$monoidEndo);
var $57759cb27ff64fd1$export$d859ed9adfa064ca = function(dict) {
    return dict.foldrWithIndex;
};
var $57759cb27ff64fd1$export$d13ff16378fefe83 = function(dictApplicative) {
    var applySecond = $26ZCq.applySecond(dictApplicative.Apply0());
    var pure = $bQdkN.pure(dictApplicative);
    return function(dictFoldableWithIndex) {
        var foldrWithIndex1 = $57759cb27ff64fd1$export$d859ed9adfa064ca(dictFoldableWithIndex);
        return function(f) {
            return foldrWithIndex1(function(i) {
                var $289 = f(i);
                return function($290) {
                    return applySecond($289($290));
                };
            })(pure($ivFwO.unit));
        };
    };
};
var $57759cb27ff64fd1$export$f441c83f81b7710f = function(dictApplicative) {
    var traverseWithIndex_1 = $57759cb27ff64fd1$export$d13ff16378fefe83(dictApplicative);
    return function(dictFoldableWithIndex) {
        return $jhsiw.flip(traverseWithIndex_1(dictFoldableWithIndex));
    };
};
var $57759cb27ff64fd1$export$9b986141719153e = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $57759cb27ff64fd1$export$d859ed9adfa064ca(dictFoldableWithIndex);
    return function(f) {
        return foldrWithIndex1($jhsiw.const(f));
    };
};
var $57759cb27ff64fd1$export$2d70b9efb960f478 = function(dict) {
    return dict.foldlWithIndex;
};
var $57759cb27ff64fd1$export$e623e8bf74059b22 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $57759cb27ff64fd1$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(f) {
        return foldlWithIndex1($jhsiw.const(f));
    };
};
var $57759cb27ff64fd1$export$a0208fa03195d5a3 = {
    foldrWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($ivFwO.unit)(v.value1)(z);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($ivFwO.unit)(z)(v.value1);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f($ivFwO.unit)(v.value1);
            };
        };
    },
    Foldable0: function() {
        return $dNwPt.foldableTuple;
    }
};
var $57759cb27ff64fd1$export$e07746a44d4d0673 = {
    foldrWithIndex: function(f) {
        return $57759cb27ff64fd1$var$foldr(f($ivFwO.unit));
    },
    foldlWithIndex: function(f) {
        return $57759cb27ff64fd1$var$foldl(f($ivFwO.unit));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $57759cb27ff64fd1$var$foldMap(dictMonoid);
        return function(f) {
            return foldMap8(f($ivFwO.unit));
        };
    },
    Foldable0: function() {
        return $dNwPt.foldableMultiplicative;
    }
};
var $57759cb27ff64fd1$export$db675654cef60b9a = {
    foldrWithIndex: function(f) {
        return $57759cb27ff64fd1$var$foldr1(f($ivFwO.unit));
    },
    foldlWithIndex: function(f) {
        return $57759cb27ff64fd1$var$foldl1(f($ivFwO.unit));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $57759cb27ff64fd1$var$foldMap1(dictMonoid);
        return function(f) {
            return foldMap8(f($ivFwO.unit));
        };
    },
    Foldable0: function() {
        return $dNwPt.foldableMaybe;
    }
};
var $57759cb27ff64fd1$export$3a92905df29453fa = {
    foldrWithIndex: function(f) {
        return $57759cb27ff64fd1$var$foldr2(f($ivFwO.unit));
    },
    foldlWithIndex: function(f) {
        return $57759cb27ff64fd1$var$foldl2(f($ivFwO.unit));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $57759cb27ff64fd1$var$foldMap2(dictMonoid);
        return function(f) {
            return foldMap8(f($ivFwO.unit));
        };
    },
    Foldable0: function() {
        return $dNwPt.foldableLast;
    }
};
var $57759cb27ff64fd1$export$92c42163dd2c46ce = {
    foldrWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($ivFwO.unit)(v)(z);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($ivFwO.unit)(z)(v);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f($ivFwO.unit)(v);
            };
        };
    },
    Foldable0: function() {
        return $dNwPt.foldableIdentity;
    }
};
var $57759cb27ff64fd1$export$328d1f7f0045c999 = {
    foldrWithIndex: function(f) {
        return $57759cb27ff64fd1$var$foldr3(f($ivFwO.unit));
    },
    foldlWithIndex: function(f) {
        return $57759cb27ff64fd1$var$foldl3(f($ivFwO.unit));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $57759cb27ff64fd1$var$foldMap3(dictMonoid);
        return function(f) {
            return foldMap8(f($ivFwO.unit));
        };
    },
    Foldable0: function() {
        return $dNwPt.foldableFirst;
    }
};
var $57759cb27ff64fd1$export$617fc130b23797ca = {
    foldrWithIndex: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $beQI1.Left) return v1;
                if (v2 instanceof $beQI1.Right) return v($ivFwO.unit)(v2.value0)(v1);
                throw new Error("Failed pattern match at Data.FoldableWithIndex (line 164, column 1 - line 170, column 42): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldlWithIndex: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $beQI1.Left) return v1;
                if (v2 instanceof $beQI1.Right) return v($ivFwO.unit)(v1)(v2.value0);
                throw new Error("Failed pattern match at Data.FoldableWithIndex (line 164, column 1 - line 170, column 42): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var mempty = $3aOYV.mempty(dictMonoid);
        return function(v) {
            return function(v1) {
                if (v1 instanceof $beQI1.Left) return mempty;
                if (v1 instanceof $beQI1.Right) return v($ivFwO.unit)(v1.value0);
                throw new Error("Failed pattern match at Data.FoldableWithIndex (line 164, column 1 - line 170, column 42): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    Foldable0: function() {
        return $dNwPt.foldableEither;
    }
};
var $57759cb27ff64fd1$export$dc8026a24f95d0a9 = {
    foldrWithIndex: function(f) {
        return $57759cb27ff64fd1$var$foldr4(f($ivFwO.unit));
    },
    foldlWithIndex: function(f) {
        return $57759cb27ff64fd1$var$foldl4(f($ivFwO.unit));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $57759cb27ff64fd1$var$foldMap4(dictMonoid);
        return function(f) {
            return foldMap8(f($ivFwO.unit));
        };
    },
    Foldable0: function() {
        return $dNwPt.foldableDual;
    }
};
var $57759cb27ff64fd1$export$a77c731c3b37cfd = {
    foldrWithIndex: function(f) {
        return $57759cb27ff64fd1$var$foldr5(f($ivFwO.unit));
    },
    foldlWithIndex: function(f) {
        return $57759cb27ff64fd1$var$foldl5(f($ivFwO.unit));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $57759cb27ff64fd1$var$foldMap5(dictMonoid);
        return function(f) {
            return foldMap8(f($ivFwO.unit));
        };
    },
    Foldable0: function() {
        return $dNwPt.foldableDisj;
    }
};
var $57759cb27ff64fd1$export$1add8b24fb58b747 = {
    foldrWithIndex: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldlWithIndex: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var mempty = $3aOYV.mempty(dictMonoid);
        return function(v) {
            return function(v1) {
                return mempty;
            };
        };
    },
    Foldable0: function() {
        return $dNwPt.foldableConst;
    }
};
var $57759cb27ff64fd1$export$707470fe74326665 = {
    foldrWithIndex: function(f) {
        return $57759cb27ff64fd1$var$foldr6(f($ivFwO.unit));
    },
    foldlWithIndex: function(f) {
        return $57759cb27ff64fd1$var$foldl6(f($ivFwO.unit));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $57759cb27ff64fd1$var$foldMap6(dictMonoid);
        return function(f) {
            return foldMap8(f($ivFwO.unit));
        };
    },
    Foldable0: function() {
        return $dNwPt.foldableConj;
    }
};
var $57759cb27ff64fd1$export$f9ed9b5a8131479e = {
    foldrWithIndex: function(f) {
        return $57759cb27ff64fd1$var$foldr7(f($ivFwO.unit));
    },
    foldlWithIndex: function(f) {
        return $57759cb27ff64fd1$var$foldl7(f($ivFwO.unit));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $57759cb27ff64fd1$var$foldMap7(dictMonoid);
        return function(f) {
            return foldMap8(f($ivFwO.unit));
        };
    },
    Foldable0: function() {
        return $dNwPt.foldableAdditive;
    }
};
var $57759cb27ff64fd1$export$ca16238ae0303ef0 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $57759cb27ff64fd1$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(dictMonad) {
        var bind = $cADnC.bind(dictMonad.Bind1());
        var pure = $bQdkN.pure(dictMonad.Applicative0());
        return function(f) {
            return function(a0) {
                return foldlWithIndex1(function(i) {
                    return function(ma) {
                        return function(b) {
                            return bind(ma)($jhsiw.flip(f(i))(b));
                        };
                    };
                })(pure(a0));
            };
        };
    };
};
var $57759cb27ff64fd1$export$998b3d14abdd8136 = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $57759cb27ff64fd1$export$d859ed9adfa064ca(dictFoldableWithIndex);
    return function(dictMonoid) {
        var append = $d5vvq.append(dictMonoid.Semigroup0());
        var mempty = $3aOYV.mempty(dictMonoid);
        return function(f) {
            return foldrWithIndex1(function(i) {
                return function(x) {
                    return function(acc) {
                        return append(f(i)(x))(acc);
                    };
                };
            })(mempty);
        };
    };
};
var $57759cb27ff64fd1$export$e728f47f20b1eb28 = {
    foldrWithIndex: function(f) {
        return function(z) {
            var $291 = $57759cb27ff64fd1$var$foldr8(function(v) {
                return function(y) {
                    return f(v.value0)(v.value1)(y);
                };
            })(z);
            var $292 = $57759cb27ff64fd1$var$mapWithIndex($7O0Q4.Tuple.create);
            return function($293) {
                return $291($292($293));
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            var $294 = $57759cb27ff64fd1$var$foldl8(function(y) {
                return function(v) {
                    return f(v.value0)(y)(v.value1);
                };
            })(z);
            var $295 = $57759cb27ff64fd1$var$mapWithIndex($7O0Q4.Tuple.create);
            return function($296) {
                return $294($295($296));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return $57759cb27ff64fd1$export$998b3d14abdd8136($57759cb27ff64fd1$export$e728f47f20b1eb28)(dictMonoid);
    },
    Foldable0: function() {
        return $dNwPt.foldableArray;
    }
};
var $57759cb27ff64fd1$export$d58f3ffea0efd404 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $57759cb27ff64fd1$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(dictMonoid) {
        var append = $d5vvq.append(dictMonoid.Semigroup0());
        var mempty = $3aOYV.mempty(dictMonoid);
        return function(f) {
            return foldlWithIndex1(function(i) {
                return function(acc) {
                    return function(x) {
                        return append(acc)(f(i)(x));
                    };
                };
            })(mempty);
        };
    };
};
var $57759cb27ff64fd1$export$18153bb1181268e5 = function(dict) {
    return dict.foldMapWithIndex;
};
var $57759cb27ff64fd1$export$ca1485f10f9ca9ee = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $57759cb27ff64fd1$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $57759cb27ff64fd1$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $57759cb27ff64fd1$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableApp = $dNwPt.foldableApp(dictFoldableWithIndex.Foldable0());
    return {
        foldrWithIndex: function(f) {
            return function(z) {
                return function(v) {
                    return foldrWithIndex1(f)(z)(v);
                };
            };
        },
        foldlWithIndex: function(f) {
            return function(z) {
                return function(v) {
                    return foldlWithIndex1(f)(z)(v);
                };
            };
        },
        foldMapWithIndex: function(dictMonoid) {
            var foldMapWithIndex2 = foldMapWithIndex1(dictMonoid);
            return function(f) {
                return function(v) {
                    return foldMapWithIndex2(f)(v);
                };
            };
        },
        Foldable0: function() {
            return foldableApp;
        }
    };
};
var $57759cb27ff64fd1$export$ed9dddd4d2a66e4d = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $57759cb27ff64fd1$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $57759cb27ff64fd1$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $57759cb27ff64fd1$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableCompose = $dNwPt.foldableCompose(dictFoldableWithIndex.Foldable0());
    return function(dictFoldableWithIndex1) {
        var foldrWithIndex2 = $57759cb27ff64fd1$export$d859ed9adfa064ca(dictFoldableWithIndex1);
        var foldlWithIndex2 = $57759cb27ff64fd1$export$2d70b9efb960f478(dictFoldableWithIndex1);
        var foldMapWithIndex2 = $57759cb27ff64fd1$export$18153bb1181268e5(dictFoldableWithIndex1);
        var foldableCompose1 = foldableCompose(dictFoldableWithIndex1.Foldable0());
        return {
            foldrWithIndex: function(f) {
                return function(i) {
                    return function(v) {
                        return foldrWithIndex1(function(a) {
                            return $jhsiw.flip(foldrWithIndex2($7O0Q4.curry(f)(a)));
                        })(i)(v);
                    };
                };
            },
            foldlWithIndex: function(f) {
                return function(i) {
                    return function(v) {
                        return foldlWithIndex1(function() {
                            var $297 = $7O0Q4.curry(f);
                            return function($298) {
                                return foldlWithIndex2($297($298));
                            };
                        }())(i)(v);
                    };
                };
            },
            foldMapWithIndex: function(dictMonoid) {
                var foldMapWithIndex3 = foldMapWithIndex1(dictMonoid);
                var foldMapWithIndex4 = foldMapWithIndex2(dictMonoid);
                return function(f) {
                    return function(v) {
                        return foldMapWithIndex3(function() {
                            var $299 = $7O0Q4.curry(f);
                            return function($300) {
                                return foldMapWithIndex4($299($300));
                            };
                        }())(v);
                    };
                };
            },
            Foldable0: function() {
                return foldableCompose1;
            }
        };
    };
};
var $57759cb27ff64fd1$export$c8998bd70c04c75d = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $57759cb27ff64fd1$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $57759cb27ff64fd1$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $57759cb27ff64fd1$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableCoproduct = $dNwPt.foldableCoproduct(dictFoldableWithIndex.Foldable0());
    return function(dictFoldableWithIndex1) {
        var foldrWithIndex2 = $57759cb27ff64fd1$export$d859ed9adfa064ca(dictFoldableWithIndex1);
        var foldlWithIndex2 = $57759cb27ff64fd1$export$2d70b9efb960f478(dictFoldableWithIndex1);
        var foldMapWithIndex2 = $57759cb27ff64fd1$export$18153bb1181268e5(dictFoldableWithIndex1);
        var foldableCoproduct1 = foldableCoproduct(dictFoldableWithIndex1.Foldable0());
        return {
            foldrWithIndex: function(f) {
                return function(z) {
                    return $7Rccs.coproduct(foldrWithIndex1(function($301) {
                        return f($beQI1.Left.create($301));
                    })(z))(foldrWithIndex2(function($302) {
                        return f($beQI1.Right.create($302));
                    })(z));
                };
            },
            foldlWithIndex: function(f) {
                return function(z) {
                    return $7Rccs.coproduct(foldlWithIndex1(function($303) {
                        return f($beQI1.Left.create($303));
                    })(z))(foldlWithIndex2(function($304) {
                        return f($beQI1.Right.create($304));
                    })(z));
                };
            },
            foldMapWithIndex: function(dictMonoid) {
                var foldMapWithIndex3 = foldMapWithIndex1(dictMonoid);
                var foldMapWithIndex4 = foldMapWithIndex2(dictMonoid);
                return function(f) {
                    return $7Rccs.coproduct(foldMapWithIndex3(function($305) {
                        return f($beQI1.Left.create($305));
                    }))(foldMapWithIndex4(function($306) {
                        return f($beQI1.Right.create($306));
                    }));
                };
            },
            Foldable0: function() {
                return foldableCoproduct1;
            }
        };
    };
};
var $57759cb27ff64fd1$export$e0fd1e7d0cab0fb2 = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $57759cb27ff64fd1$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $57759cb27ff64fd1$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $57759cb27ff64fd1$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableProduct = $dNwPt.foldableProduct(dictFoldableWithIndex.Foldable0());
    return function(dictFoldableWithIndex1) {
        var foldrWithIndex2 = $57759cb27ff64fd1$export$d859ed9adfa064ca(dictFoldableWithIndex1);
        var foldlWithIndex2 = $57759cb27ff64fd1$export$2d70b9efb960f478(dictFoldableWithIndex1);
        var foldMapWithIndex2 = $57759cb27ff64fd1$export$18153bb1181268e5(dictFoldableWithIndex1);
        var foldableProduct1 = foldableProduct(dictFoldableWithIndex1.Foldable0());
        return {
            foldrWithIndex: function(f) {
                return function(z) {
                    return function(v) {
                        return foldrWithIndex1(function($307) {
                            return f($beQI1.Left.create($307));
                        })(foldrWithIndex2(function($308) {
                            return f($beQI1.Right.create($308));
                        })(z)(v.value1))(v.value0);
                    };
                };
            },
            foldlWithIndex: function(f) {
                return function(z) {
                    return function(v) {
                        return foldlWithIndex2(function($309) {
                            return f($beQI1.Right.create($309));
                        })(foldlWithIndex1(function($310) {
                            return f($beQI1.Left.create($310));
                        })(z)(v.value0))(v.value1);
                    };
                };
            },
            foldMapWithIndex: function(dictMonoid) {
                var append = $d5vvq.append(dictMonoid.Semigroup0());
                var foldMapWithIndex3 = foldMapWithIndex1(dictMonoid);
                var foldMapWithIndex4 = foldMapWithIndex2(dictMonoid);
                return function(f) {
                    return function(v) {
                        return append(foldMapWithIndex3(function($311) {
                            return f($beQI1.Left.create($311));
                        })(v.value0))(foldMapWithIndex4(function($312) {
                            return f($beQI1.Right.create($312));
                        })(v.value1));
                    };
                };
            },
            Foldable0: function() {
                return foldableProduct1;
            }
        };
    };
};
var $57759cb27ff64fd1$export$a2a2be54aa786fa = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $57759cb27ff64fd1$export$18153bb1181268e5(dictFoldableWithIndex)($57759cb27ff64fd1$var$monoidDual);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $57759cb27ff64fd1$var$unwrap($57759cb27ff64fd1$var$unwrap(foldMapWithIndex1(function(i) {
                    var $313 = $jhsiw.flip(c(i));
                    return function($314) {
                        return $53NY2.Dual($ldkz2.Endo($313($314)));
                    };
                })(xs)))(u);
            };
        };
    };
};
var $57759cb27ff64fd1$export$f48decfd8b6d8740 = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $57759cb27ff64fd1$export$18153bb1181268e5(dictFoldableWithIndex)($57759cb27ff64fd1$var$monoidEndo);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $57759cb27ff64fd1$var$unwrap(foldMapWithIndex1(function(i) {
                    var $315 = c(i);
                    return function($316) {
                        return $ldkz2.Endo($315($316));
                    };
                })(xs))(u);
            };
        };
    };
};
var $57759cb27ff64fd1$export$9f81331332e444a = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $57759cb27ff64fd1$export$18153bb1181268e5(dictFoldableWithIndex)($57759cb27ff64fd1$var$monoidEndo);
    return function(dictSemigroup) {
        var append = $d5vvq.append(dictSemigroup);
        return function(d) {
            return function(t) {
                return function(f) {
                    var joined = function(i) {
                        return function(a) {
                            return function(m) {
                                return append(d)(append(t(i)(a))(m));
                            };
                        };
                    };
                    return $57759cb27ff64fd1$var$unwrap(foldMapWithIndex1(joined)(f))(d);
                };
            };
        };
    };
};
var $57759cb27ff64fd1$export$222b6fd2bc53ca7a = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $57759cb27ff64fd1$export$18153bb1181268e5(dictFoldableWithIndex);
    return function(dictMonoid) {
        var foldMapWithIndex2 = foldMapWithIndex1(dictMonoid);
        return function(f) {
            return foldMapWithIndex2($jhsiw.const(f));
        };
    };
};
var $57759cb27ff64fd1$export$d803998e74b07aa8 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $57759cb27ff64fd1$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(p) {
        var go = function(v) {
            return function(v1) {
                return function(v2) {
                    if (v1 instanceof $h2xUu.Nothing && p(v)(v2)) return new $h2xUu.Just({
                        index: v,
                        value: v2
                    });
                    return v1;
                };
            };
        };
        return foldlWithIndex1(go)($h2xUu.Nothing.value);
    };
};
var $57759cb27ff64fd1$export$c34ce7d3b9a0e = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $57759cb27ff64fd1$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(f) {
        var go = function(v) {
            return function(v1) {
                return function(v2) {
                    if (v1 instanceof $h2xUu.Nothing) return f(v)(v2);
                    return v1;
                };
            };
        };
        return foldlWithIndex1(go)($h2xUu.Nothing.value);
    };
};
var $57759cb27ff64fd1$export$6d3978b14e304a71 = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $57759cb27ff64fd1$export$18153bb1181268e5(dictFoldableWithIndex);
    return function(dictHeytingAlgebra) {
        var foldMapWithIndex2 = foldMapWithIndex1($d4RtI.monoidDisj(dictHeytingAlgebra));
        return function(t) {
            var $317 = foldMapWithIndex2(function(i) {
                var $319 = t(i);
                return function($320) {
                    return $d4RtI.Disj($319($320));
                };
            });
            return function($318) {
                return $57759cb27ff64fd1$var$unwrap($317($318));
            };
        };
    };
};
var $57759cb27ff64fd1$export$5dc11e929c02e763 = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $57759cb27ff64fd1$export$18153bb1181268e5(dictFoldableWithIndex);
    return function(dictHeytingAlgebra) {
        var foldMapWithIndex2 = foldMapWithIndex1($h73gt.monoidConj(dictHeytingAlgebra));
        return function(t) {
            var $321 = foldMapWithIndex2(function(i) {
                var $323 = t(i);
                return function($324) {
                    return $h73gt.Conj($323($324));
                };
            });
            return function($322) {
                return $57759cb27ff64fd1$var$unwrap($321($322));
            };
        };
    };
};

});
parcelRegister("lzCaM", function(module, exports) {

$parcel$export(module.exports, "mapWithIndex", () => $fb4a7a376cccf791$export$8f07ddce13659f50);
$parcel$export(module.exports, "functorWithIndexTuple", () => $fb4a7a376cccf791$export$98b99a3e5a5c2768);
$parcel$export(module.exports, "functorWithIndexProduct", () => $fb4a7a376cccf791$export$341bcd9812b20e54);
$parcel$export(module.exports, "functorWithIndexMultiplicative", () => $fb4a7a376cccf791$export$3f7256b7802d7d35);
$parcel$export(module.exports, "functorWithIndexMaybe", () => $fb4a7a376cccf791$export$ff6e9b408c0f1d0a);
$parcel$export(module.exports, "functorWithIndexLast", () => $fb4a7a376cccf791$export$67874b1834c6566b);
$parcel$export(module.exports, "functorWithIndexIdentity", () => $fb4a7a376cccf791$export$26258e29c904633d);
$parcel$export(module.exports, "functorWithIndexFirst", () => $fb4a7a376cccf791$export$707dfb58df7f6e4f);
$parcel$export(module.exports, "functorWithIndexEither", () => $fb4a7a376cccf791$export$381e44b6c18f93d6);
$parcel$export(module.exports, "functorWithIndexDual", () => $fb4a7a376cccf791$export$50b3765d14980fc);
$parcel$export(module.exports, "functorWithIndexDisj", () => $fb4a7a376cccf791$export$b6070cf53db1d339);
$parcel$export(module.exports, "functorWithIndexCoproduct", () => $fb4a7a376cccf791$export$6f7aa172554aa552);
$parcel$export(module.exports, "functorWithIndexConst", () => $fb4a7a376cccf791$export$dba6a24121753c2b);
$parcel$export(module.exports, "functorWithIndexConj", () => $fb4a7a376cccf791$export$8ba1941ba7d99c6);
$parcel$export(module.exports, "functorWithIndexCompose", () => $fb4a7a376cccf791$export$7935f2d7643e66ce);
$parcel$export(module.exports, "functorWithIndexArray", () => $fb4a7a376cccf791$export$f10d51ea0aa3da42);
$parcel$export(module.exports, "functorWithIndexApp", () => $fb4a7a376cccf791$export$ffe1008ccae78edc);
$parcel$export(module.exports, "functorWithIndexAdditive", () => $fb4a7a376cccf791$export$eee3f4036a1ebada);
// Generated by purs version 0.15.16

var $fBu4b = parcelRequire("fBu4b");

var $5ZwWo = parcelRequire("5ZwWo");

var $x1jCe = parcelRequire("x1jCe");

var $beQI1 = parcelRequire("beQI1");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $8Gte6 = parcelRequire("8Gte6");

var $iMzH1 = parcelRequire("iMzH1");

var $7Rccs = parcelRequire("7Rccs");

var $6dOpK = parcelRequire("6dOpK");

var $8pkky = parcelRequire("8pkky");

var $h2xUu = parcelRequire("h2xUu");

var $kYjFk = parcelRequire("kYjFk");

var $kobBf = parcelRequire("kobBf");

var $6UiNT = parcelRequire("6UiNT");

var $h73gt = parcelRequire("h73gt");

var $d4RtI = parcelRequire("d4RtI");

var $53NY2 = parcelRequire("53NY2");

var $laciu = parcelRequire("laciu");

var $7O0Q4 = parcelRequire("7O0Q4");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
var $fb4a7a376cccf791$var$map = /* #__PURE__ */ $7FzSN.map($7O0Q4.functorTuple);
var $fb4a7a376cccf791$var$bimap = /* #__PURE__ */ $5ZwWo.bimap($5ZwWo.bifunctorTuple);
var $fb4a7a376cccf791$var$map1 = /* #__PURE__ */ $7FzSN.map($laciu.functorMultiplicative);
var $fb4a7a376cccf791$var$map2 = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $fb4a7a376cccf791$var$map3 = /* #__PURE__ */ $7FzSN.map($kobBf.functorLast);
var $fb4a7a376cccf791$var$map4 = /* #__PURE__ */ $7FzSN.map($kYjFk.functorFirst);
var $fb4a7a376cccf791$var$map5 = /* #__PURE__ */ $7FzSN.map($beQI1.functorEither);
var $fb4a7a376cccf791$var$map6 = /* #__PURE__ */ $7FzSN.map($53NY2.functorDual);
var $fb4a7a376cccf791$var$map7 = /* #__PURE__ */ $7FzSN.map($d4RtI.functorDisj);
var $fb4a7a376cccf791$var$bimap1 = /* #__PURE__ */ $5ZwWo.bimap($5ZwWo.bifunctorEither);
var $fb4a7a376cccf791$var$map8 = /* #__PURE__ */ $7FzSN.map($h73gt.functorConj);
var $fb4a7a376cccf791$var$map9 = /* #__PURE__ */ $7FzSN.map($6UiNT.functorAdditive);
var $fb4a7a376cccf791$export$8f07ddce13659f50 = function(dict) {
    return dict.mapWithIndex;
};
var $fb4a7a376cccf791$export$6942612de3ba9e09 = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $fb4a7a376cccf791$export$8f07ddce13659f50(dictFunctorWithIndex);
    return function(f) {
        return mapWithIndex1($jhsiw.const(f));
    };
};
var $fb4a7a376cccf791$export$98b99a3e5a5c2768 = {
    mapWithIndex: function(f) {
        return $fb4a7a376cccf791$var$map(f($ivFwO.unit));
    },
    Functor0: function() {
        return $7O0Q4.functorTuple;
    }
};
var $fb4a7a376cccf791$export$341bcd9812b20e54 = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $fb4a7a376cccf791$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorProduct = $6dOpK.functorProduct(dictFunctorWithIndex.Functor0());
    return function(dictFunctorWithIndex1) {
        var mapWithIndex2 = $fb4a7a376cccf791$export$8f07ddce13659f50(dictFunctorWithIndex1);
        var functorProduct1 = functorProduct(dictFunctorWithIndex1.Functor0());
        return {
            mapWithIndex: function(f) {
                return function(v) {
                    return $fb4a7a376cccf791$var$bimap(mapWithIndex1(function($63) {
                        return f($beQI1.Left.create($63));
                    }))(mapWithIndex2(function($64) {
                        return f($beQI1.Right.create($64));
                    }))(v);
                };
            },
            Functor0: function() {
                return functorProduct1;
            }
        };
    };
};
var $fb4a7a376cccf791$export$3f7256b7802d7d35 = {
    mapWithIndex: function(f) {
        return $fb4a7a376cccf791$var$map1(f($ivFwO.unit));
    },
    Functor0: function() {
        return $laciu.functorMultiplicative;
    }
};
var $fb4a7a376cccf791$export$ff6e9b408c0f1d0a = {
    mapWithIndex: function(f) {
        return $fb4a7a376cccf791$var$map2(f($ivFwO.unit));
    },
    Functor0: function() {
        return $h2xUu.functorMaybe;
    }
};
var $fb4a7a376cccf791$export$67874b1834c6566b = {
    mapWithIndex: function(f) {
        return $fb4a7a376cccf791$var$map3(f($ivFwO.unit));
    },
    Functor0: function() {
        return $kobBf.functorLast;
    }
};
var $fb4a7a376cccf791$export$26258e29c904633d = {
    mapWithIndex: function(f) {
        return function(v) {
            return f($ivFwO.unit)(v);
        };
    },
    Functor0: function() {
        return $8pkky.functorIdentity;
    }
};
var $fb4a7a376cccf791$export$707dfb58df7f6e4f = {
    mapWithIndex: function(f) {
        return $fb4a7a376cccf791$var$map4(f($ivFwO.unit));
    },
    Functor0: function() {
        return $kYjFk.functorFirst;
    }
};
var $fb4a7a376cccf791$export$381e44b6c18f93d6 = {
    mapWithIndex: function(f) {
        return $fb4a7a376cccf791$var$map5(f($ivFwO.unit));
    },
    Functor0: function() {
        return $beQI1.functorEither;
    }
};
var $fb4a7a376cccf791$export$50b3765d14980fc = {
    mapWithIndex: function(f) {
        return $fb4a7a376cccf791$var$map6(f($ivFwO.unit));
    },
    Functor0: function() {
        return $53NY2.functorDual;
    }
};
var $fb4a7a376cccf791$export$b6070cf53db1d339 = {
    mapWithIndex: function(f) {
        return $fb4a7a376cccf791$var$map7(f($ivFwO.unit));
    },
    Functor0: function() {
        return $d4RtI.functorDisj;
    }
};
var $fb4a7a376cccf791$export$6f7aa172554aa552 = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $fb4a7a376cccf791$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorCoproduct = $7Rccs.functorCoproduct(dictFunctorWithIndex.Functor0());
    return function(dictFunctorWithIndex1) {
        var mapWithIndex2 = $fb4a7a376cccf791$export$8f07ddce13659f50(dictFunctorWithIndex1);
        var functorCoproduct1 = functorCoproduct(dictFunctorWithIndex1.Functor0());
        return {
            mapWithIndex: function(f) {
                return function(v) {
                    return $fb4a7a376cccf791$var$bimap1(mapWithIndex1(function($65) {
                        return f($beQI1.Left.create($65));
                    }))(mapWithIndex2(function($66) {
                        return f($beQI1.Right.create($66));
                    }))(v);
                };
            },
            Functor0: function() {
                return functorCoproduct1;
            }
        };
    };
};
var $fb4a7a376cccf791$export$dba6a24121753c2b = {
    mapWithIndex: function(v) {
        return function(v1) {
            return v1;
        };
    },
    Functor0: function() {
        return $x1jCe.functorConst;
    }
};
var $fb4a7a376cccf791$export$8ba1941ba7d99c6 = {
    mapWithIndex: function(f) {
        return $fb4a7a376cccf791$var$map8(f($ivFwO.unit));
    },
    Functor0: function() {
        return $h73gt.functorConj;
    }
};
var $fb4a7a376cccf791$export$7935f2d7643e66ce = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $fb4a7a376cccf791$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorCompose = $iMzH1.functorCompose(dictFunctorWithIndex.Functor0());
    return function(dictFunctorWithIndex1) {
        var mapWithIndex2 = $fb4a7a376cccf791$export$8f07ddce13659f50(dictFunctorWithIndex1);
        var functorCompose1 = functorCompose(dictFunctorWithIndex1.Functor0());
        return {
            mapWithIndex: function(f) {
                return function(v) {
                    return mapWithIndex1(function() {
                        var $67 = $7O0Q4.curry(f);
                        return function($68) {
                            return mapWithIndex2($67($68));
                        };
                    }())(v);
                };
            },
            Functor0: function() {
                return functorCompose1;
            }
        };
    };
};
var $fb4a7a376cccf791$export$f10d51ea0aa3da42 = {
    mapWithIndex: $fBu4b.mapWithIndexArray,
    Functor0: function() {
        return $7FzSN.functorArray;
    }
};
var $fb4a7a376cccf791$export$ffe1008ccae78edc = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $fb4a7a376cccf791$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorApp = $8Gte6.functorApp(dictFunctorWithIndex.Functor0());
    return {
        mapWithIndex: function(f) {
            return function(v) {
                return mapWithIndex1(f)(v);
            };
        },
        Functor0: function() {
            return functorApp;
        }
    };
};
var $fb4a7a376cccf791$export$eee3f4036a1ebada = {
    mapWithIndex: function(f) {
        return $fb4a7a376cccf791$var$map9(f($ivFwO.unit));
    },
    Functor0: function() {
        return $6UiNT.functorAdditive;
    }
};

});
parcelRegister("fBu4b", function(module, exports) {

$parcel$export(module.exports, "mapWithIndexArray", () => $b5c1a24ccbd58e25$export$e1e714991b6c2aba);
const $b5c1a24ccbd58e25$export$e1e714991b6c2aba = function(f) {
    return function(xs) {
        var l = xs.length;
        var result = Array(l);
        for(var i = 0; i < l; i++)result[i] = f(i)(xs[i]);
        return result;
    };
};

});



parcelRegister("9aSRU", function(module, exports) {

$parcel$export(module.exports, "NonEmpty", () => $6adf9bf222ae175d$export$d8deaab87a4e223a);
$parcel$export(module.exports, "unfoldable1NonEmpty", () => $6adf9bf222ae175d$export$3d29df45c3f8cf54);
$parcel$export(module.exports, "singleton", () => $6adf9bf222ae175d$export$439306a4dcaafbb9);
$parcel$export(module.exports, "showNonEmpty", () => $6adf9bf222ae175d$export$ffafc93d2cc87798);
$parcel$export(module.exports, "head", () => $6adf9bf222ae175d$export$5fd5031fecdacec3);
$parcel$export(module.exports, "functorNonEmpty", () => $6adf9bf222ae175d$export$a6ffbf6bde05f5c0);
$parcel$export(module.exports, "functorWithIndex", () => $6adf9bf222ae175d$export$cdee60b0fe4303fd);
$parcel$export(module.exports, "foldableNonEmpty", () => $6adf9bf222ae175d$export$20ebd08132411556);
$parcel$export(module.exports, "foldableWithIndexNonEmpty", () => $6adf9bf222ae175d$export$9a79a74e355c28b1);
$parcel$export(module.exports, "traversableNonEmpty", () => $6adf9bf222ae175d$export$dbb721137b3f0cf6);
$parcel$export(module.exports, "traversableWithIndexNonEmpty", () => $6adf9bf222ae175d$export$6e693a2e8188a772);
$parcel$export(module.exports, "foldable1NonEmpty", () => $6adf9bf222ae175d$export$ca19152d833c8d01);
$parcel$export(module.exports, "eqNonEmpty", () => $6adf9bf222ae175d$export$460809894af54b0a);
$parcel$export(module.exports, "ordNonEmpty", () => $6adf9bf222ae175d$export$ec32b9103f985218);
$parcel$export(module.exports, "eq1NonEmpty", () => $6adf9bf222ae175d$export$6a8b366193197b51);
$parcel$export(module.exports, "ord1NonEmpty", () => $6adf9bf222ae175d$export$de0dd6c052e29447);
// Generated by purs version 0.15.16

var $56VjJ = parcelRequire("56VjJ");

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $j7FrY = parcelRequire("j7FrY");

var $aJhEx = parcelRequire("aJhEx");

var $dNwPt = parcelRequire("dNwPt");

var $7vxKS = parcelRequire("7vxKS");

var $7FzSN = parcelRequire("7FzSN");

var $lzCaM = parcelRequire("lzCaM");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $d5vvq = parcelRequire("d5vvq");

var $kAvps = parcelRequire("kAvps");

var $2XxiF = parcelRequire("2XxiF");

var $9OOYG = parcelRequire("9OOYG");

var $bijFl = parcelRequire("bijFl");

var $7O0Q4 = parcelRequire("7O0Q4");

var $goKHx = parcelRequire("goKHx");
var $6adf9bf222ae175d$var$map = /* #__PURE__ */ $7FzSN.map($7O0Q4.functorTuple);
var $6adf9bf222ae175d$var$map1 = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $6adf9bf222ae175d$export$d8deaab87a4e223a = /* #__PURE__ */ function() {
    function NonEmpty(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    NonEmpty.create = function(value0) {
        return function(value1) {
            return new NonEmpty(value0, value1);
        };
    };
    return NonEmpty;
}();
var $6adf9bf222ae175d$export$3d29df45c3f8cf54 = function(dictUnfoldable) {
    var unfoldr = $goKHx.unfoldr(dictUnfoldable);
    return {
        unfoldr1: function(f) {
            return function(b) {
                return $7O0Q4.uncurry($6adf9bf222ae175d$export$d8deaab87a4e223a.create)($6adf9bf222ae175d$var$map(unfoldr($6adf9bf222ae175d$var$map1(f)))(f(b)));
            };
        }
    };
};
var $6adf9bf222ae175d$export$c01875f616615628 = function(v) {
    return v.value1;
};
var $6adf9bf222ae175d$export$439306a4dcaafbb9 = function(dictPlus) {
    var empty = $j7FrY.empty(dictPlus);
    return function(a) {
        return new $6adf9bf222ae175d$export$d8deaab87a4e223a(a, empty);
    };
};
var $6adf9bf222ae175d$export$ffafc93d2cc87798 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return function(dictShow1) {
        var show1 = $2XxiF.show(dictShow1);
        return {
            show: function(v) {
                return "(NonEmpty " + (show(v.value0) + (" " + (show1(v.value1) + ")")));
            }
        };
    };
};
var $6adf9bf222ae175d$export$d0a7bd743ccb8d67 = function(dictApplicative) {
    var pure = $bQdkN.pure(dictApplicative);
    return function(dictSemigroup) {
        var append1 = $d5vvq.append(dictSemigroup);
        return {
            append: function(v) {
                return function(v1) {
                    return new $6adf9bf222ae175d$export$d8deaab87a4e223a(v.value0, append1(v.value1)(append1(pure(v1.value0))(v1.value1)));
                };
            }
        };
    };
};
var $6adf9bf222ae175d$export$a9a18ae5ba42aeab = function(dictAlternative) {
    var alt = $56VjJ.alt(dictAlternative.Plus1().Alt0());
    var pure = $bQdkN.pure(dictAlternative.Applicative0());
    return function(v) {
        return alt(pure(v.value0))(v.value1);
    };
};
var $6adf9bf222ae175d$export$5fd5031fecdacec3 = function(v) {
    return v.value0;
};
var $6adf9bf222ae175d$export$a6ffbf6bde05f5c0 = function(dictFunctor) {
    var map2 = $7FzSN.map(dictFunctor);
    return {
        map: function(f) {
            return function(m) {
                return new $6adf9bf222ae175d$export$d8deaab87a4e223a(f(m.value0), map2(f)(m.value1));
            };
        }
    };
};
var $6adf9bf222ae175d$export$cdee60b0fe4303fd = function(dictFunctorWithIndex) {
    var mapWithIndex = $lzCaM.mapWithIndex(dictFunctorWithIndex);
    var functorNonEmpty1 = $6adf9bf222ae175d$export$a6ffbf6bde05f5c0(dictFunctorWithIndex.Functor0());
    return {
        mapWithIndex: function(f) {
            return function(v) {
                return new $6adf9bf222ae175d$export$d8deaab87a4e223a(f($h2xUu.Nothing.value)(v.value0), mapWithIndex(function($245) {
                    return f($h2xUu.Just.create($245));
                })(v.value1));
            };
        },
        Functor0: function() {
            return functorNonEmpty1;
        }
    };
};
var $6adf9bf222ae175d$export$1d4c49925323035a = function(f) {
    return function(v) {
        return f(v.value0)(v.value1);
    };
};
var $6adf9bf222ae175d$export$20ebd08132411556 = function(dictFoldable) {
    var foldMap = $dNwPt.foldMap(dictFoldable);
    var foldl = $dNwPt.foldl(dictFoldable);
    var foldr = $dNwPt.foldr(dictFoldable);
    return {
        foldMap: function(dictMonoid) {
            var append1 = $d5vvq.append(dictMonoid.Semigroup0());
            var foldMap1 = foldMap(dictMonoid);
            return function(f) {
                return function(v) {
                    return append1(f(v.value0))(foldMap1(f)(v.value1));
                };
            };
        },
        foldl: function(f) {
            return function(b) {
                return function(v) {
                    return foldl(f)(f(b)(v.value0))(v.value1);
                };
            };
        },
        foldr: function(f) {
            return function(b) {
                return function(v) {
                    return f(v.value0)(foldr(f)(b)(v.value1));
                };
            };
        }
    };
};
var $6adf9bf222ae175d$export$9a79a74e355c28b1 = function(dictFoldableWithIndex) {
    var foldMapWithIndex = $7vxKS.foldMapWithIndex(dictFoldableWithIndex);
    var foldlWithIndex = $7vxKS.foldlWithIndex(dictFoldableWithIndex);
    var foldrWithIndex = $7vxKS.foldrWithIndex(dictFoldableWithIndex);
    var foldableNonEmpty1 = $6adf9bf222ae175d$export$20ebd08132411556(dictFoldableWithIndex.Foldable0());
    return {
        foldMapWithIndex: function(dictMonoid) {
            var append1 = $d5vvq.append(dictMonoid.Semigroup0());
            var foldMapWithIndex1 = foldMapWithIndex(dictMonoid);
            return function(f) {
                return function(v) {
                    return append1(f($h2xUu.Nothing.value)(v.value0))(foldMapWithIndex1(function($246) {
                        return f($h2xUu.Just.create($246));
                    })(v.value1));
                };
            };
        },
        foldlWithIndex: function(f) {
            return function(b) {
                return function(v) {
                    return foldlWithIndex(function($247) {
                        return f($h2xUu.Just.create($247));
                    })(f($h2xUu.Nothing.value)(b)(v.value0))(v.value1);
                };
            };
        },
        foldrWithIndex: function(f) {
            return function(b) {
                return function(v) {
                    return f($h2xUu.Nothing.value)(v.value0)(foldrWithIndex(function($248) {
                        return f($h2xUu.Just.create($248));
                    })(b)(v.value1));
                };
            };
        },
        Foldable0: function() {
            return foldableNonEmpty1;
        }
    };
};
var $6adf9bf222ae175d$export$dbb721137b3f0cf6 = function(dictTraversable) {
    var sequence = $9OOYG.sequence(dictTraversable);
    var traverse = $9OOYG.traverse(dictTraversable);
    var functorNonEmpty1 = $6adf9bf222ae175d$export$a6ffbf6bde05f5c0(dictTraversable.Functor0());
    var foldableNonEmpty1 = $6adf9bf222ae175d$export$20ebd08132411556(dictTraversable.Foldable1());
    return {
        sequence: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $26ZCq.apply(Apply0);
            var map2 = $7FzSN.map(Apply0.Functor0());
            var sequence1 = sequence(dictApplicative);
            return function(v) {
                return apply(map2($6adf9bf222ae175d$export$d8deaab87a4e223a.create)(v.value0))(sequence1(v.value1));
            };
        },
        traverse: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $26ZCq.apply(Apply0);
            var map2 = $7FzSN.map(Apply0.Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                return function(v) {
                    return apply(map2($6adf9bf222ae175d$export$d8deaab87a4e223a.create)(f(v.value0)))(traverse1(f)(v.value1));
                };
            };
        },
        Functor0: function() {
            return functorNonEmpty1;
        },
        Foldable1: function() {
            return foldableNonEmpty1;
        }
    };
};
var $6adf9bf222ae175d$export$6e693a2e8188a772 = function(dictTraversableWithIndex) {
    var traverseWithIndex = $bijFl.traverseWithIndex(dictTraversableWithIndex);
    var functorWithIndex1 = $6adf9bf222ae175d$export$cdee60b0fe4303fd(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexNonEmpty1 = $6adf9bf222ae175d$export$9a79a74e355c28b1(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableNonEmpty1 = $6adf9bf222ae175d$export$dbb721137b3f0cf6(dictTraversableWithIndex.Traversable2());
    return {
        traverseWithIndex: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $26ZCq.apply(Apply0);
            var map2 = $7FzSN.map(Apply0.Functor0());
            var traverseWithIndex1 = traverseWithIndex(dictApplicative);
            return function(f) {
                return function(v) {
                    return apply(map2($6adf9bf222ae175d$export$d8deaab87a4e223a.create)(f($h2xUu.Nothing.value)(v.value0)))(traverseWithIndex1(function($249) {
                        return f($h2xUu.Just.create($249));
                    })(v.value1));
                };
            };
        },
        FunctorWithIndex0: function() {
            return functorWithIndex1;
        },
        FoldableWithIndex1: function() {
            return foldableWithIndexNonEmpty1;
        },
        Traversable2: function() {
            return traversableNonEmpty1;
        }
    };
};
var $6adf9bf222ae175d$export$ca19152d833c8d01 = function(dictFoldable) {
    var foldl = $dNwPt.foldl(dictFoldable);
    var foldr = $dNwPt.foldr(dictFoldable);
    var foldableNonEmpty1 = $6adf9bf222ae175d$export$20ebd08132411556(dictFoldable);
    return {
        foldMap1: function(dictSemigroup) {
            var append1 = $d5vvq.append(dictSemigroup);
            return function(f) {
                return function(v) {
                    return foldl(function(s) {
                        return function(a1) {
                            return append1(s)(f(a1));
                        };
                    })(f(v.value0))(v.value1);
                };
            };
        },
        foldr1: function(f) {
            return function(v) {
                return $h2xUu.maybe(v.value0)(f(v.value0))(foldr(function(a1) {
                    var $250 = $h2xUu.maybe(a1)(f(a1));
                    return function($251) {
                        return $h2xUu.Just.create($250($251));
                    };
                })($h2xUu.Nothing.value)(v.value1));
            };
        },
        foldl1: function(f) {
            return function(v) {
                return foldl(f)(v.value0)(v.value1);
            };
        },
        Foldable0: function() {
            return foldableNonEmpty1;
        }
    };
};
var $6adf9bf222ae175d$export$eb5e1ef4ea2eca3d = function(dictFoldable) {
    return $kAvps.foldl1($6adf9bf222ae175d$export$ca19152d833c8d01(dictFoldable));
};
var $6adf9bf222ae175d$export$460809894af54b0a = function(dictEq1) {
    var eq1 = $aJhEx.eq1(dictEq1);
    return function(dictEq) {
        var eq = $aJhEx.eq(dictEq);
        var eq11 = eq1(dictEq);
        return {
            eq: function(x) {
                return function(y) {
                    return eq(x.value0)(y.value0) && eq11(x.value1)(y.value1);
                };
            }
        };
    };
};
var $6adf9bf222ae175d$export$ec32b9103f985218 = function(dictOrd1) {
    var compare1 = $gwBF5.compare1(dictOrd1);
    var eqNonEmpty1 = $6adf9bf222ae175d$export$460809894af54b0a(dictOrd1.Eq10());
    return function(dictOrd) {
        var compare = $gwBF5.compare(dictOrd);
        var compare11 = compare1(dictOrd);
        var eqNonEmpty2 = eqNonEmpty1(dictOrd.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    var v = compare(x.value0)(y.value0);
                    if (v instanceof $ibsD5.LT) return $ibsD5.LT.value;
                    if (v instanceof $ibsD5.GT) return $ibsD5.GT.value;
                    return compare11(x.value1)(y.value1);
                };
            },
            Eq0: function() {
                return eqNonEmpty2;
            }
        };
    };
};
var $6adf9bf222ae175d$export$6a8b366193197b51 = function(dictEq1) {
    var eqNonEmpty1 = $6adf9bf222ae175d$export$460809894af54b0a(dictEq1);
    return {
        eq1: function(dictEq) {
            return $aJhEx.eq(eqNonEmpty1(dictEq));
        }
    };
};
var $6adf9bf222ae175d$export$de0dd6c052e29447 = function(dictOrd1) {
    var ordNonEmpty1 = $6adf9bf222ae175d$export$ec32b9103f985218(dictOrd1);
    var eq1NonEmpty1 = $6adf9bf222ae175d$export$6a8b366193197b51(dictOrd1.Eq10());
    return {
        compare1: function(dictOrd) {
            return $gwBF5.compare(ordNonEmpty1(dictOrd));
        },
        Eq10: function() {
            return eq1NonEmpty1;
        }
    };
};

});
parcelRegister("bijFl", function(module, exports) {

$parcel$export(module.exports, "traverseWithIndex", () => $8390a1654efaef4c$export$955fdc0d24efa249);
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $beQI1 = parcelRequire("beQI1");

var $7vxKS = parcelRequire("7vxKS");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $8Gte6 = parcelRequire("8Gte6");

var $iMzH1 = parcelRequire("iMzH1");

var $7Rccs = parcelRequire("7Rccs");

var $6dOpK = parcelRequire("6dOpK");

var $lzCaM = parcelRequire("lzCaM");

var $8pkky = parcelRequire("8pkky");

var $9OOYG = parcelRequire("9OOYG");
parcelRequire("lVswN");

var $dazHc = parcelRequire("dazHc");

var $7O0Q4 = parcelRequire("7O0Q4");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
var $8390a1654efaef4c$var$traverse = /* #__PURE__ */ $9OOYG.traverse($9OOYG.traversableMultiplicative);
var $8390a1654efaef4c$var$traverse1 = /* #__PURE__ */ $9OOYG.traverse($9OOYG.traversableMaybe);
var $8390a1654efaef4c$var$traverse2 = /* #__PURE__ */ $9OOYG.traverse($9OOYG.traversableLast);
var $8390a1654efaef4c$var$traverse3 = /* #__PURE__ */ $9OOYG.traverse($9OOYG.traversableFirst);
var $8390a1654efaef4c$var$traverse4 = /* #__PURE__ */ $9OOYG.traverse($9OOYG.traversableDual);
var $8390a1654efaef4c$var$traverse5 = /* #__PURE__ */ $9OOYG.traverse($9OOYG.traversableDisj);
var $8390a1654efaef4c$var$traverse6 = /* #__PURE__ */ $9OOYG.traverse($9OOYG.traversableConj);
var $8390a1654efaef4c$var$traverse7 = /* #__PURE__ */ $9OOYG.traverse($9OOYG.traversableAdditive);
var $8390a1654efaef4c$export$37034f8d74d84f8b = function(dictTraversableWithIndex) {
    var sequence = $9OOYG.sequence(dictTraversableWithIndex.Traversable2());
    var mapWithIndex = $lzCaM.mapWithIndex(dictTraversableWithIndex.FunctorWithIndex0());
    return function(dictApplicative) {
        var sequence1 = sequence(dictApplicative);
        return function(f) {
            var $174 = mapWithIndex(f);
            return function($175) {
                return sequence1($174($175));
            };
        };
    };
};
var $8390a1654efaef4c$export$955fdc0d24efa249 = function(dict) {
    return dict.traverseWithIndex;
};
var $8390a1654efaef4c$export$d50a9c31d69ee13c = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $8390a1654efaef4c$export$955fdc0d24efa249(dictTraversableWithIndex);
    return function(dictApplicative) {
        var traverseWithIndex2 = traverseWithIndex1(dictApplicative);
        return function(f) {
            return traverseWithIndex2($jhsiw.const(f));
        };
    };
};
var $8390a1654efaef4c$export$649571d878667376 = {
    traverseWithIndex: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($7O0Q4.Tuple.create(v.value0))(f($ivFwO.unit)(v.value1));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $lzCaM.functorWithIndexTuple;
    },
    FoldableWithIndex1: function() {
        return $7vxKS.foldableWithIndexTuple;
    },
    Traversable2: function() {
        return $9OOYG.traversableTuple;
    }
};
var $8390a1654efaef4c$export$f5fab9ea43775499 = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $8390a1654efaef4c$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexProduct = $lzCaM.functorWithIndexProduct(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexProduct = $7vxKS.foldableWithIndexProduct(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableProduct = $9OOYG.traversableProduct(dictTraversableWithIndex.Traversable2());
    return function(dictTraversableWithIndex1) {
        var traverseWithIndex2 = $8390a1654efaef4c$export$955fdc0d24efa249(dictTraversableWithIndex1);
        var functorWithIndexProduct1 = functorWithIndexProduct(dictTraversableWithIndex1.FunctorWithIndex0());
        var foldableWithIndexProduct1 = foldableWithIndexProduct(dictTraversableWithIndex1.FoldableWithIndex1());
        var traversableProduct1 = traversableProduct(dictTraversableWithIndex1.Traversable2());
        return {
            traverseWithIndex: function(dictApplicative) {
                var lift2 = $26ZCq.lift2(dictApplicative.Apply0());
                var traverseWithIndex3 = traverseWithIndex1(dictApplicative);
                var traverseWithIndex4 = traverseWithIndex2(dictApplicative);
                return function(f) {
                    return function(v) {
                        return lift2($6dOpK.product)(traverseWithIndex3(function($176) {
                            return f($beQI1.Left.create($176));
                        })(v.value0))(traverseWithIndex4(function($177) {
                            return f($beQI1.Right.create($177));
                        })(v.value1));
                    };
                };
            },
            FunctorWithIndex0: function() {
                return functorWithIndexProduct1;
            },
            FoldableWithIndex1: function() {
                return foldableWithIndexProduct1;
            },
            Traversable2: function() {
                return traversableProduct1;
            }
        };
    };
};
var $8390a1654efaef4c$export$340ca064331c9524 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $8390a1654efaef4c$var$traverse(dictApplicative);
        return function(f) {
            return traverse8(f($ivFwO.unit));
        };
    },
    FunctorWithIndex0: function() {
        return $lzCaM.functorWithIndexMultiplicative;
    },
    FoldableWithIndex1: function() {
        return $7vxKS.foldableWithIndexMultiplicative;
    },
    Traversable2: function() {
        return $9OOYG.traversableMultiplicative;
    }
};
var $8390a1654efaef4c$export$971c834447f08858 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $8390a1654efaef4c$var$traverse1(dictApplicative);
        return function(f) {
            return traverse8(f($ivFwO.unit));
        };
    },
    FunctorWithIndex0: function() {
        return $lzCaM.functorWithIndexMaybe;
    },
    FoldableWithIndex1: function() {
        return $7vxKS.foldableWithIndexMaybe;
    },
    Traversable2: function() {
        return $9OOYG.traversableMaybe;
    }
};
var $8390a1654efaef4c$export$82bf3aff27014955 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $8390a1654efaef4c$var$traverse2(dictApplicative);
        return function(f) {
            return traverse8(f($ivFwO.unit));
        };
    },
    FunctorWithIndex0: function() {
        return $lzCaM.functorWithIndexLast;
    },
    FoldableWithIndex1: function() {
        return $7vxKS.foldableWithIndexLast;
    },
    Traversable2: function() {
        return $9OOYG.traversableLast;
    }
};
var $8390a1654efaef4c$export$e4fe4683618a40ff = {
    traverseWithIndex: function(dictApplicative) {
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($8pkky.Identity)(f($ivFwO.unit)(v));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $lzCaM.functorWithIndexIdentity;
    },
    FoldableWithIndex1: function() {
        return $7vxKS.foldableWithIndexIdentity;
    },
    Traversable2: function() {
        return $9OOYG.traversableIdentity;
    }
};
var $8390a1654efaef4c$export$c0565467517236ee = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $8390a1654efaef4c$var$traverse3(dictApplicative);
        return function(f) {
            return traverse8(f($ivFwO.unit));
        };
    },
    FunctorWithIndex0: function() {
        return $lzCaM.functorWithIndexFirst;
    },
    FoldableWithIndex1: function() {
        return $7vxKS.foldableWithIndexFirst;
    },
    Traversable2: function() {
        return $9OOYG.traversableFirst;
    }
};
var $8390a1654efaef4c$export$c5842444d22f461a = {
    traverseWithIndex: function(dictApplicative) {
        var pure = $bQdkN.pure(dictApplicative);
        var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $beQI1.Left) return pure(new $beQI1.Left(v1.value0));
                if (v1 instanceof $beQI1.Right) return map($beQI1.Right.create)(v($ivFwO.unit)(v1.value0));
                throw new Error("Failed pattern match at Data.TraversableWithIndex (line 95, column 1 - line 97, column 53): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    FunctorWithIndex0: function() {
        return $lzCaM.functorWithIndexEither;
    },
    FoldableWithIndex1: function() {
        return $7vxKS.foldableWithIndexEither;
    },
    Traversable2: function() {
        return $9OOYG.traversableEither;
    }
};
var $8390a1654efaef4c$export$f81f0b3aaf5918a5 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $8390a1654efaef4c$var$traverse4(dictApplicative);
        return function(f) {
            return traverse8(f($ivFwO.unit));
        };
    },
    FunctorWithIndex0: function() {
        return $lzCaM.functorWithIndexDual;
    },
    FoldableWithIndex1: function() {
        return $7vxKS.foldableWithIndexDual;
    },
    Traversable2: function() {
        return $9OOYG.traversableDual;
    }
};
var $8390a1654efaef4c$export$298c1e0a7ee97588 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $8390a1654efaef4c$var$traverse5(dictApplicative);
        return function(f) {
            return traverse8(f($ivFwO.unit));
        };
    },
    FunctorWithIndex0: function() {
        return $lzCaM.functorWithIndexDisj;
    },
    FoldableWithIndex1: function() {
        return $7vxKS.foldableWithIndexDisj;
    },
    Traversable2: function() {
        return $9OOYG.traversableDisj;
    }
};
var $8390a1654efaef4c$export$fad1c006f410e5e2 = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $8390a1654efaef4c$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexCoproduct = $lzCaM.functorWithIndexCoproduct(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexCoproduct = $7vxKS.foldableWithIndexCoproduct(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableCoproduct = $9OOYG.traversableCoproduct(dictTraversableWithIndex.Traversable2());
    return function(dictTraversableWithIndex1) {
        var traverseWithIndex2 = $8390a1654efaef4c$export$955fdc0d24efa249(dictTraversableWithIndex1);
        var functorWithIndexCoproduct1 = functorWithIndexCoproduct(dictTraversableWithIndex1.FunctorWithIndex0());
        var foldableWithIndexCoproduct1 = foldableWithIndexCoproduct(dictTraversableWithIndex1.FoldableWithIndex1());
        var traversableCoproduct1 = traversableCoproduct(dictTraversableWithIndex1.Traversable2());
        return {
            traverseWithIndex: function(dictApplicative) {
                var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
                var traverseWithIndex3 = traverseWithIndex1(dictApplicative);
                var traverseWithIndex4 = traverseWithIndex2(dictApplicative);
                return function(f) {
                    return $7Rccs.coproduct(function() {
                        var $178 = map(function($181) {
                            return $7Rccs.Coproduct($beQI1.Left.create($181));
                        });
                        var $179 = traverseWithIndex3(function($182) {
                            return f($beQI1.Left.create($182));
                        });
                        return function($180) {
                            return $178($179($180));
                        };
                    }())(function() {
                        var $183 = map(function($186) {
                            return $7Rccs.Coproduct($beQI1.Right.create($186));
                        });
                        var $184 = traverseWithIndex4(function($187) {
                            return f($beQI1.Right.create($187));
                        });
                        return function($185) {
                            return $183($184($185));
                        };
                    }());
                };
            },
            FunctorWithIndex0: function() {
                return functorWithIndexCoproduct1;
            },
            FoldableWithIndex1: function() {
                return foldableWithIndexCoproduct1;
            },
            Traversable2: function() {
                return traversableCoproduct1;
            }
        };
    };
};
var $8390a1654efaef4c$export$8270215089848547 = {
    traverseWithIndex: function(dictApplicative) {
        var pure = $bQdkN.pure(dictApplicative);
        return function(v) {
            return function(v1) {
                return pure(v1);
            };
        };
    },
    FunctorWithIndex0: function() {
        return $lzCaM.functorWithIndexConst;
    },
    FoldableWithIndex1: function() {
        return $7vxKS.foldableWithIndexConst;
    },
    Traversable2: function() {
        return $9OOYG.traversableConst;
    }
};
var $8390a1654efaef4c$export$b78ffb8a06781844 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $8390a1654efaef4c$var$traverse6(dictApplicative);
        return function(f) {
            return traverse8(f($ivFwO.unit));
        };
    },
    FunctorWithIndex0: function() {
        return $lzCaM.functorWithIndexConj;
    },
    FoldableWithIndex1: function() {
        return $7vxKS.foldableWithIndexConj;
    },
    Traversable2: function() {
        return $9OOYG.traversableConj;
    }
};
var $8390a1654efaef4c$export$e1331c7aac1da04e = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $8390a1654efaef4c$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexCompose = $lzCaM.functorWithIndexCompose(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexCompose = $7vxKS.foldableWithIndexCompose(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableCompose = $9OOYG.traversableCompose(dictTraversableWithIndex.Traversable2());
    return function(dictTraversableWithIndex1) {
        var traverseWithIndex2 = $8390a1654efaef4c$export$955fdc0d24efa249(dictTraversableWithIndex1);
        var functorWithIndexCompose1 = functorWithIndexCompose(dictTraversableWithIndex1.FunctorWithIndex0());
        var foldableWithIndexCompose1 = foldableWithIndexCompose(dictTraversableWithIndex1.FoldableWithIndex1());
        var traversableCompose1 = traversableCompose(dictTraversableWithIndex1.Traversable2());
        return {
            traverseWithIndex: function(dictApplicative) {
                var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
                var traverseWithIndex3 = traverseWithIndex1(dictApplicative);
                var traverseWithIndex4 = traverseWithIndex2(dictApplicative);
                return function(f) {
                    return function(v) {
                        return map($iMzH1.Compose)(traverseWithIndex3(function() {
                            var $188 = $7O0Q4.curry(f);
                            return function($189) {
                                return traverseWithIndex4($188($189));
                            };
                        }())(v));
                    };
                };
            },
            FunctorWithIndex0: function() {
                return functorWithIndexCompose1;
            },
            FoldableWithIndex1: function() {
                return foldableWithIndexCompose1;
            },
            Traversable2: function() {
                return traversableCompose1;
            }
        };
    };
};
var $8390a1654efaef4c$export$96888504550934b5 = {
    traverseWithIndex: function(dictApplicative) {
        return $8390a1654efaef4c$export$37034f8d74d84f8b($8390a1654efaef4c$export$96888504550934b5)(dictApplicative);
    },
    FunctorWithIndex0: function() {
        return $lzCaM.functorWithIndexArray;
    },
    FoldableWithIndex1: function() {
        return $7vxKS.foldableWithIndexArray;
    },
    Traversable2: function() {
        return $9OOYG.traversableArray;
    }
};
var $8390a1654efaef4c$export$fc84432b7fe0f34e = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $8390a1654efaef4c$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexApp = $lzCaM.functorWithIndexApp(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexApp = $7vxKS.foldableWithIndexApp(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableApp = $9OOYG.traversableApp(dictTraversableWithIndex.Traversable2());
    return {
        traverseWithIndex: function(dictApplicative) {
            var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
            var traverseWithIndex2 = traverseWithIndex1(dictApplicative);
            return function(f) {
                return function(v) {
                    return map($8Gte6.App)(traverseWithIndex2(f)(v));
                };
            };
        },
        FunctorWithIndex0: function() {
            return functorWithIndexApp;
        },
        FoldableWithIndex1: function() {
            return foldableWithIndexApp;
        },
        Traversable2: function() {
            return traversableApp;
        }
    };
};
var $8390a1654efaef4c$export$3d12857a1613dde6 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $8390a1654efaef4c$var$traverse7(dictApplicative);
        return function(f) {
            return traverse8(f($ivFwO.unit));
        };
    },
    FunctorWithIndex0: function() {
        return $lzCaM.functorWithIndexAdditive;
    },
    FoldableWithIndex1: function() {
        return $7vxKS.foldableWithIndexAdditive;
    },
    Traversable2: function() {
        return $9OOYG.traversableAdditive;
    }
};
var $8390a1654efaef4c$export$34e92304ce7da557 = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $8390a1654efaef4c$export$955fdc0d24efa249(dictTraversableWithIndex)($dazHc.applicativeStateR);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $dazHc.stateR(traverseWithIndex1(function(i) {
                    return function(a) {
                        return function(s) {
                            return f(i)(s)(a);
                        };
                    };
                })(xs))(s0);
            };
        };
    };
};
var $8390a1654efaef4c$export$6062de19d97bcfe7 = function(dictTraversableWithIndex) {
    var mapAccumRWithIndex1 = $8390a1654efaef4c$export$34e92304ce7da557(dictTraversableWithIndex);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumRWithIndex1(function(i) {
                    return function(b) {
                        return function(a) {
                            var b$prime = f(i)(a)(b);
                            return {
                                accum: b$prime,
                                value: b$prime
                            };
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $8390a1654efaef4c$export$2594b6cb66070a = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $8390a1654efaef4c$export$955fdc0d24efa249(dictTraversableWithIndex)($dazHc.applicativeStateL);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $dazHc.stateL(traverseWithIndex1(function(i) {
                    return function(a) {
                        return function(s) {
                            return f(i)(s)(a);
                        };
                    };
                })(xs))(s0);
            };
        };
    };
};
var $8390a1654efaef4c$export$2aa973d5e57cdb6b = function(dictTraversableWithIndex) {
    var mapAccumLWithIndex1 = $8390a1654efaef4c$export$2594b6cb66070a(dictTraversableWithIndex);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumLWithIndex1(function(i) {
                    return function(b) {
                        return function(a) {
                            var b$prime = f(i)(b)(a);
                            return {
                                accum: b$prime,
                                value: b$prime
                            };
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $8390a1654efaef4c$export$363f6bf7e04ec632 = function(dictApplicative) {
    return function(dictTraversableWithIndex) {
        return $jhsiw.flip($8390a1654efaef4c$export$955fdc0d24efa249(dictTraversableWithIndex)(dictApplicative));
    };
};

});





parcelRegister("aHmxC", function(module, exports) {

$parcel$export(module.exports, "size", () => $7c9f67bc53be8927$export$346677f925de839c);
$parcel$export(module.exports, "singleton", () => $7c9f67bc53be8927$export$439306a4dcaafbb9);
$parcel$export(module.exports, "showMap", () => $7c9f67bc53be8927$export$c448526daa762015);
$parcel$export(module.exports, "lookup", () => $7c9f67bc53be8927$export$dfc7155ac0343b8);
$parcel$export(module.exports, "member", () => $7c9f67bc53be8927$export$6a0d13241802fe80);
$parcel$export(module.exports, "isEmpty", () => $7c9f67bc53be8927$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "functorMap", () => $7c9f67bc53be8927$export$3930f636962ed944);
$parcel$export(module.exports, "functorWithIndexMap", () => $7c9f67bc53be8927$export$d7c684e0b3e84e77);
$parcel$export(module.exports, "insert", () => $7c9f67bc53be8927$export$21a5ca8aa77d35ff);
$parcel$export(module.exports, "pop", () => $7c9f67bc53be8927$export$3e41007ebfff0e64);
$parcel$export(module.exports, "foldableMap", () => $7c9f67bc53be8927$export$4295a0c2ad7aa544);
$parcel$export(module.exports, "foldableWithIndexMap", () => $7c9f67bc53be8927$export$91e1c50dfb7225a6);
$parcel$export(module.exports, "keys", () => $7c9f67bc53be8927$export$ed97f33186d4b816);
$parcel$export(module.exports, "traversableMap", () => $7c9f67bc53be8927$export$78146089411e393d);
$parcel$export(module.exports, "traversableWithIndexMap", () => $7c9f67bc53be8927$export$8999febf5cd85b5c);
$parcel$export(module.exports, "values", () => $7c9f67bc53be8927$export$68c286be0e7e55b7);
$parcel$export(module.exports, "foldSubmap", () => $7c9f67bc53be8927$export$3f9a381f67a51fcd);
$parcel$export(module.exports, "findMin", () => $7c9f67bc53be8927$export$3c39a95b7a4d5e28);
$parcel$export(module.exports, "findMax", () => $7c9f67bc53be8927$export$35f577b3da447d17);
$parcel$export(module.exports, "eqMap", () => $7c9f67bc53be8927$export$85aac4508ff70b8);
$parcel$export(module.exports, "ordMap", () => $7c9f67bc53be8927$export$3d0d4caf881d6855);
$parcel$export(module.exports, "eq1Map", () => $7c9f67bc53be8927$export$e321b34a2787dc8d);
$parcel$export(module.exports, "ord1Map", () => $7c9f67bc53be8927$export$e2f3c1862bab1bff);
$parcel$export(module.exports, "empty", () => $7c9f67bc53be8927$export$6e22c362a0406a2c);
$parcel$export(module.exports, "fromFoldable", () => $7c9f67bc53be8927$export$b7d5d9bb9ff52072);
$parcel$export(module.exports, "filterWithKey", () => $7c9f67bc53be8927$export$d7a60370122a9ab0);
$parcel$export(module.exports, "filter", () => $7c9f67bc53be8927$export$3dea766d36a8935f);
$parcel$export(module.exports, "delete", () => $7c9f67bc53be8927$export$1822828d790e23ee);
$parcel$export(module.exports, "checkValid", () => $7c9f67bc53be8927$export$6583e3e95cb5e9d1);
$parcel$export(module.exports, "applyMap", () => $7c9f67bc53be8927$export$8952a3dc6f3cd264);
$parcel$export(module.exports, "bindMap", () => $7c9f67bc53be8927$export$886591aa0ffe34d5);
$parcel$export(module.exports, "alter", () => $7c9f67bc53be8927$export$22a7378e1d3307a4);
$parcel$export(module.exports, "insertWith", () => $7c9f67bc53be8927$export$435aa68287e449bf);
$parcel$export(module.exports, "unionWith", () => $7c9f67bc53be8927$export$ed1b4f34a0e8b0cc);
$parcel$export(module.exports, "union", () => $7c9f67bc53be8927$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "altMap", () => $7c9f67bc53be8927$export$9030392ec4d635ff);
$parcel$export(module.exports, "plusMap", () => $7c9f67bc53be8927$export$4c085c510196daa3);
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $26SV5 = parcelRequire("26SV5");

var $aJhEx = parcelRequire("aJhEx");

var $dNwPt = parcelRequire("dNwPt");

var $7vxKS = parcelRequire("7vxKS");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $lzCaM = parcelRequire("lzCaM");

var $IhyKA = parcelRequire("IhyKA");

var $5krR0 = parcelRequire("5krR0");

var $6j2dz = parcelRequire("6j2dz");

var $3g1lG = parcelRequire("3g1lG");

var $fZenR = parcelRequire("fZenR");

var $h2xUu = parcelRequire("h2xUu");

var $3aOYV = parcelRequire("3aOYV");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $d5vvq = parcelRequire("d5vvq");

var $2XxiF = parcelRequire("2XxiF");

var $9OOYG = parcelRequire("9OOYG");

var $bijFl = parcelRequire("bijFl");

var $7O0Q4 = parcelRequire("7O0Q4");

var $goKHx = parcelRequire("goKHx");

var $lqv9L = parcelRequire("lqv9L");
var $7c9f67bc53be8927$var$all = /* #__PURE__ */ $dNwPt.all($3g1lG.foldableList)($IhyKA.heytingAlgebraBoolean);
var $7c9f67bc53be8927$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $7c9f67bc53be8927$var$foldl = /* #__PURE__ */ $dNwPt.foldl($fZenR.foldableList);
var $7c9f67bc53be8927$var$pure = /* #__PURE__ */ $bQdkN.pure($fZenR.applicativeList);
var $7c9f67bc53be8927$var$map = /* #__PURE__ */ $7FzSN.map($fZenR.functorList);
var $7c9f67bc53be8927$var$append1 = /* #__PURE__ */ $d5vvq.append($fZenR.semigroupList);
var $7c9f67bc53be8927$var$nub = /* #__PURE__ */ $5krR0.nub($gwBF5.ordInt);
var $7c9f67bc53be8927$export$3024f3bfb62054a3 = /* #__PURE__ */ function() {
    function Leaf() {}
    Leaf.value = new Leaf();
    return Leaf;
}();
var $7c9f67bc53be8927$export$9276dd97bf62cc8d = /* #__PURE__ */ function() {
    function Two(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Two.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Two(value0, value1, value2, value3);
                };
            };
        };
    };
    return Two;
}();
var $7c9f67bc53be8927$export$eadfa7aed248243e = /* #__PURE__ */ function() {
    function Three(value0, value1, value2, value3, value4, value5, value6) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
        this.value6 = value6;
    }
    Three.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return function(value4) {
                        return function(value5) {
                            return function(value6) {
                                return new Three(value0, value1, value2, value3, value4, value5, value6);
                            };
                        };
                    };
                };
            };
        };
    };
    return Three;
}();
var $7c9f67bc53be8927$var$TwoLeft = /* #__PURE__ */ function() {
    function TwoLeft(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    TwoLeft.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new TwoLeft(value0, value1, value2);
            };
        };
    };
    return TwoLeft;
}();
var $7c9f67bc53be8927$var$TwoRight = /* #__PURE__ */ function() {
    function TwoRight(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    TwoRight.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new TwoRight(value0, value1, value2);
            };
        };
    };
    return TwoRight;
}();
var $7c9f67bc53be8927$var$ThreeLeft = /* #__PURE__ */ function() {
    function ThreeLeft(value0, value1, value2, value3, value4, value5) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
    }
    ThreeLeft.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return function(value4) {
                        return function(value5) {
                            return new ThreeLeft(value0, value1, value2, value3, value4, value5);
                        };
                    };
                };
            };
        };
    };
    return ThreeLeft;
}();
var $7c9f67bc53be8927$var$ThreeMiddle = /* #__PURE__ */ function() {
    function ThreeMiddle(value0, value1, value2, value3, value4, value5) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
    }
    ThreeMiddle.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return function(value4) {
                        return function(value5) {
                            return new ThreeMiddle(value0, value1, value2, value3, value4, value5);
                        };
                    };
                };
            };
        };
    };
    return ThreeMiddle;
}();
var $7c9f67bc53be8927$var$ThreeRight = /* #__PURE__ */ function() {
    function ThreeRight(value0, value1, value2, value3, value4, value5) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
    }
    ThreeRight.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return function(value4) {
                        return function(value5) {
                            return new ThreeRight(value0, value1, value2, value3, value4, value5);
                        };
                    };
                };
            };
        };
    };
    return ThreeRight;
}();
var $7c9f67bc53be8927$var$KickUp = /* #__PURE__ */ function() {
    function KickUp(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    KickUp.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new KickUp(value0, value1, value2, value3);
                };
            };
        };
    };
    return KickUp;
}();
var $7c9f67bc53be8927$export$346677f925de839c = function(v) {
    if (v instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return 0;
    if (v instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) return (1 + $7c9f67bc53be8927$export$346677f925de839c(v.value0) | 0) + $7c9f67bc53be8927$export$346677f925de839c(v.value3) | 0;
    if (v instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) return ((2 + $7c9f67bc53be8927$export$346677f925de839c(v.value0) | 0) + $7c9f67bc53be8927$export$346677f925de839c(v.value3) | 0) + $7c9f67bc53be8927$export$346677f925de839c(v.value6) | 0;
    throw new Error("Failed pattern match at Data.Map.Internal (line 705, column 1 - line 705, column 35): " + [
        v.constructor.name
    ]);
};
var $7c9f67bc53be8927$export$439306a4dcaafbb9 = function(k) {
    return function(v) {
        return new $7c9f67bc53be8927$export$9276dd97bf62cc8d($7c9f67bc53be8927$export$3024f3bfb62054a3.value, k, v, $7c9f67bc53be8927$export$3024f3bfb62054a3.value);
    };
};
var $7c9f67bc53be8927$export$823be24f8766da23 = function(dictUnfoldable) {
    var unfoldr = $goKHx.unfoldr(dictUnfoldable);
    return function(m) {
        var go = function($copy_v) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v) {
                if (v instanceof $fZenR.Nil) {
                    $tco_done = true;
                    return $h2xUu.Nothing.value;
                }
                if (v instanceof $fZenR.Cons) {
                    if (v.value0 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) {
                        $copy_v = v.value1;
                        return;
                    }
                    if (v.value0 instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d && v.value0.value0 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3 && v.value0.value3 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) {
                        $tco_done = true;
                        return new $h2xUu.Just(new $7O0Q4.Tuple(new $7O0Q4.Tuple(v.value0.value1, v.value0.value2), v.value1));
                    }
                    if (v.value0 instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d && v.value0.value0 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) {
                        $tco_done = true;
                        return new $h2xUu.Just(new $7O0Q4.Tuple(new $7O0Q4.Tuple(v.value0.value1, v.value0.value2), new $fZenR.Cons(v.value0.value3, v.value1)));
                    }
                    if (v.value0 instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                        $copy_v = new $fZenR.Cons(v.value0.value0, new $fZenR.Cons($7c9f67bc53be8927$export$439306a4dcaafbb9(v.value0.value1)(v.value0.value2), new $fZenR.Cons(v.value0.value3, v.value1)));
                        return;
                    }
                    if (v.value0 instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                        $copy_v = new $fZenR.Cons(v.value0.value0, new $fZenR.Cons($7c9f67bc53be8927$export$439306a4dcaafbb9(v.value0.value1)(v.value0.value2), new $fZenR.Cons(v.value0.value3, new $fZenR.Cons($7c9f67bc53be8927$export$439306a4dcaafbb9(v.value0.value4)(v.value0.value5), new $fZenR.Cons(v.value0.value6, v.value1)))));
                        return;
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 624, column 18 - line 633, column 71): " + [
                        v.value0.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 623, column 3 - line 623, column 19): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_v);
            return $tco_result;
        };
        return unfoldr(go)(new $fZenR.Cons(m, $fZenR.Nil.value));
    };
};
var $7c9f67bc53be8927$var$toUnfoldable1 = /* #__PURE__ */ $7c9f67bc53be8927$export$823be24f8766da23($3g1lG.unfoldableList);
var $7c9f67bc53be8927$var$toUnfoldable2 = /* #__PURE__ */ $7c9f67bc53be8927$export$823be24f8766da23($fZenR.unfoldableList);
var $7c9f67bc53be8927$var$toAscArray = /* #__PURE__ */ $7c9f67bc53be8927$export$823be24f8766da23($goKHx.unfoldableArray);
var $7c9f67bc53be8927$export$4e1300b52a76ba3a = function(dictUnfoldable) {
    var unfoldr = $goKHx.unfoldr(dictUnfoldable);
    return function(m) {
        var go = function($copy_v) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v) {
                if (v instanceof $fZenR.Nil) {
                    $tco_done = true;
                    return $h2xUu.Nothing.value;
                }
                if (v instanceof $fZenR.Cons) {
                    if (v.value0 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) {
                        $copy_v = v.value1;
                        return;
                    }
                    if (v.value0 instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                        $tco_done = true;
                        return new $h2xUu.Just(new $7O0Q4.Tuple(new $7O0Q4.Tuple(v.value0.value1, v.value0.value2), new $fZenR.Cons(v.value0.value0, new $fZenR.Cons(v.value0.value3, v.value1))));
                    }
                    if (v.value0 instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                        $tco_done = true;
                        return new $h2xUu.Just(new $7O0Q4.Tuple(new $7O0Q4.Tuple(v.value0.value1, v.value0.value2), new $fZenR.Cons($7c9f67bc53be8927$export$439306a4dcaafbb9(v.value0.value4)(v.value0.value5), new $fZenR.Cons(v.value0.value0, new $fZenR.Cons(v.value0.value3, new $fZenR.Cons(v.value0.value6, v.value1))))));
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 645, column 18 - line 650, column 77): " + [
                        v.value0.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 644, column 3 - line 644, column 19): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_v);
            return $tco_result;
        };
        return unfoldr(go)(new $fZenR.Cons(m, $fZenR.Nil.value));
    };
};
var $7c9f67bc53be8927$export$b072eafdc1d506c3 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return function(dictShow1) {
        var show1 = $2XxiF.show(dictShow1);
        return function(v) {
            if (v instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return "Leaf";
            if (v instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) return "Two (" + ($7c9f67bc53be8927$export$b072eafdc1d506c3(dictShow)(dictShow1)(v.value0) + (") (" + (show(v.value1) + (") (" + (show1(v.value2) + (") (" + ($7c9f67bc53be8927$export$b072eafdc1d506c3(dictShow)(dictShow1)(v.value3) + ")")))))));
            if (v instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) return "Three (" + ($7c9f67bc53be8927$export$b072eafdc1d506c3(dictShow)(dictShow1)(v.value0) + (") (" + (show(v.value1) + (") (" + (show1(v.value2) + (") (" + ($7c9f67bc53be8927$export$b072eafdc1d506c3(dictShow)(dictShow1)(v.value3) + (") (" + (show(v.value4) + (") (" + (show1(v.value5) + (") (" + ($7c9f67bc53be8927$export$b072eafdc1d506c3(dictShow)(dictShow1)(v.value6) + ")")))))))))))));
            throw new Error("Failed pattern match at Data.Map.Internal (line 194, column 1 - line 194, column 62): " + [
                v.constructor.name
            ]);
        };
    };
};
var $7c9f67bc53be8927$export$c448526daa762015 = function(dictShow) {
    var showTuple = $7O0Q4.showTuple(dictShow);
    return function(dictShow1) {
        var show = $2XxiF.show($2XxiF.showArray(showTuple(dictShow1)));
        return {
            show: function(m) {
                return "(fromFoldable " + (show($7c9f67bc53be8927$var$toAscArray(m)) + ")");
            }
        };
    };
};
var $7c9f67bc53be8927$export$6c45e13560e32a55 = function(dictOrd) {
    var compare = $gwBF5.compare(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return $h2xUu.Nothing.value;
            if (v instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                var v2 = compare(k)(v.value1);
                if (v2 instanceof $ibsD5.EQ) return new $h2xUu.Just({
                    key: v.value1,
                    value: v.value2
                });
                if (v2 instanceof $ibsD5.GT) return new $h2xUu.Just($h2xUu.fromMaybe({
                    key: v.value1,
                    value: v.value2
                })(go(v.value3)));
                if (v2 instanceof $ibsD5.LT) return go(v.value0);
                throw new Error("Failed pattern match at Data.Map.Internal (line 266, column 33 - line 269, column 20): " + [
                    v2.constructor.name
                ]);
            }
            if (v instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                var v3 = compare(k)(v.value4);
                if (v3 instanceof $ibsD5.EQ) return new $h2xUu.Just({
                    key: v.value4,
                    value: v.value5
                });
                if (v3 instanceof $ibsD5.GT) return new $h2xUu.Just($h2xUu.fromMaybe({
                    key: v.value4,
                    value: v.value5
                })(go(v.value6)));
                if (v3 instanceof $ibsD5.LT) return go(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(v.value0, v.value1, v.value2, v.value3));
                throw new Error("Failed pattern match at Data.Map.Internal (line 270, column 45 - line 273, column 36): " + [
                    v3.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 265, column 5 - line 265, column 22): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $7c9f67bc53be8927$export$7b26f9c4323be72 = function(dictOrd) {
    var compare = $gwBF5.compare(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return $h2xUu.Nothing.value;
            if (v instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                var v2 = compare(k)(v.value1);
                if (v2 instanceof $ibsD5.EQ) return new $h2xUu.Just({
                    key: v.value1,
                    value: v.value2
                });
                if (v2 instanceof $ibsD5.LT) return new $h2xUu.Just($h2xUu.fromMaybe({
                    key: v.value1,
                    value: v.value2
                })(go(v.value0)));
                if (v2 instanceof $ibsD5.GT) return go(v.value3);
                throw new Error("Failed pattern match at Data.Map.Internal (line 300, column 33 - line 303, column 21): " + [
                    v2.constructor.name
                ]);
            }
            if (v instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                var v3 = compare(k)(v.value1);
                if (v3 instanceof $ibsD5.EQ) return new $h2xUu.Just({
                    key: v.value1,
                    value: v.value2
                });
                if (v3 instanceof $ibsD5.LT) return new $h2xUu.Just($h2xUu.fromMaybe({
                    key: v.value1,
                    value: v.value2
                })(go(v.value0)));
                if (v3 instanceof $ibsD5.GT) return go(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(v.value3, v.value4, v.value5, v.value6));
                throw new Error("Failed pattern match at Data.Map.Internal (line 304, column 45 - line 307, column 37): " + [
                    v3.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 299, column 5 - line 299, column 22): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $7c9f67bc53be8927$export$dfc7155ac0343b8 = function(dictOrd) {
    var compare = $gwBF5.compare(dictOrd);
    return function(k) {
        var go = function($copy_v) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v) {
                if (v instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return $h2xUu.Nothing.value;
                }
                if (v instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                    var v2 = compare(k)(v.value1);
                    if (v2 instanceof $ibsD5.EQ) {
                        $tco_done = true;
                        return new $h2xUu.Just(v.value2);
                    }
                    if (v2 instanceof $ibsD5.LT) {
                        $copy_v = v.value0;
                        return;
                    }
                    $copy_v = v.value3;
                    return;
                }
                if (v instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                    var v3 = compare(k)(v.value1);
                    if (v3 instanceof $ibsD5.EQ) {
                        $tco_done = true;
                        return new $h2xUu.Just(v.value2);
                    }
                    var v4 = compare(k)(v.value4);
                    if (v4 instanceof $ibsD5.EQ) {
                        $tco_done = true;
                        return new $h2xUu.Just(v.value5);
                    }
                    if (v3 instanceof $ibsD5.LT) {
                        $copy_v = v.value0;
                        return;
                    }
                    if (v4 instanceof $ibsD5.GT) {
                        $copy_v = v.value6;
                        return;
                    }
                    $copy_v = v.value3;
                    return;
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 241, column 5 - line 241, column 22): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_v);
            return $tco_result;
        };
        return go;
    };
};
var $7c9f67bc53be8927$export$6a0d13241802fe80 = function(dictOrd) {
    var lookup1 = $7c9f67bc53be8927$export$dfc7155ac0343b8(dictOrd);
    return function(k) {
        return function(m) {
            return $h2xUu.isJust(lookup1(k)(m));
        };
    };
};
var $7c9f67bc53be8927$export$35d0420a84c5d3ae = function(dictOrd) {
    var lookup1 = $7c9f67bc53be8927$export$dfc7155ac0343b8(dictOrd);
    return function(dictEq) {
        var eq1 = $aJhEx.eq($h2xUu.eqMaybe(dictEq));
        return function(m1) {
            return function(m2) {
                var f = function(v) {
                    return eq1(lookup1(v.value0)(m2))(new $h2xUu.Just(v.value1));
                };
                return $7c9f67bc53be8927$var$all(f)($7c9f67bc53be8927$var$toUnfoldable1(m1));
            };
        };
    };
};
var $7c9f67bc53be8927$export$dd1bc94b04021eeb = function(v) {
    if (v instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return true;
    return false;
};
var $7c9f67bc53be8927$export$3930f636962ed944 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return $7c9f67bc53be8927$export$3024f3bfb62054a3.value;
            if (v1 instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) return new $7c9f67bc53be8927$export$9276dd97bf62cc8d($7FzSN.map($7c9f67bc53be8927$export$3930f636962ed944)(v)(v1.value0), v1.value1, v(v1.value2), $7FzSN.map($7c9f67bc53be8927$export$3930f636962ed944)(v)(v1.value3));
            if (v1 instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) return new $7c9f67bc53be8927$export$eadfa7aed248243e($7FzSN.map($7c9f67bc53be8927$export$3930f636962ed944)(v)(v1.value0), v1.value1, v(v1.value2), $7FzSN.map($7c9f67bc53be8927$export$3930f636962ed944)(v)(v1.value3), v1.value4, v(v1.value5), $7FzSN.map($7c9f67bc53be8927$export$3930f636962ed944)(v)(v1.value6));
            throw new Error("Failed pattern match at Data.Map.Internal (line 116, column 1 - line 119, column 110): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $7c9f67bc53be8927$export$d7c684e0b3e84e77 = {
    mapWithIndex: function(v) {
        return function(v1) {
            if (v1 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return $7c9f67bc53be8927$export$3024f3bfb62054a3.value;
            if (v1 instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) return new $7c9f67bc53be8927$export$9276dd97bf62cc8d($lzCaM.mapWithIndex($7c9f67bc53be8927$export$d7c684e0b3e84e77)(v)(v1.value0), v1.value1, v(v1.value1)(v1.value2), $lzCaM.mapWithIndex($7c9f67bc53be8927$export$d7c684e0b3e84e77)(v)(v1.value3));
            if (v1 instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) return new $7c9f67bc53be8927$export$eadfa7aed248243e($lzCaM.mapWithIndex($7c9f67bc53be8927$export$d7c684e0b3e84e77)(v)(v1.value0), v1.value1, v(v1.value1)(v1.value2), $lzCaM.mapWithIndex($7c9f67bc53be8927$export$d7c684e0b3e84e77)(v)(v1.value3), v1.value4, v(v1.value4)(v1.value5), $lzCaM.mapWithIndex($7c9f67bc53be8927$export$d7c684e0b3e84e77)(v)(v1.value6));
            throw new Error("Failed pattern match at Data.Map.Internal (line 121, column 1 - line 124, column 152): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $7c9f67bc53be8927$export$3930f636962ed944;
    }
};
var $7c9f67bc53be8927$var$fromZipper = function($copy_dictOrd) {
    return function($copy_v) {
        return function($copy_v1) {
            var $tco_var_dictOrd = $copy_dictOrd;
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(dictOrd, v, v1) {
                if (v instanceof $fZenR.Nil) {
                    $tco_done = true;
                    return v1;
                }
                if (v instanceof $fZenR.Cons) {
                    if (v.value0 instanceof $7c9f67bc53be8927$var$TwoLeft) {
                        $tco_var_dictOrd = dictOrd;
                        $tco_var_v = v.value1;
                        $copy_v1 = new $7c9f67bc53be8927$export$9276dd97bf62cc8d(v1, v.value0.value0, v.value0.value1, v.value0.value2);
                        return;
                    }
                    if (v.value0 instanceof $7c9f67bc53be8927$var$TwoRight) {
                        $tco_var_dictOrd = dictOrd;
                        $tco_var_v = v.value1;
                        $copy_v1 = new $7c9f67bc53be8927$export$9276dd97bf62cc8d(v.value0.value0, v.value0.value1, v.value0.value2, v1);
                        return;
                    }
                    if (v.value0 instanceof $7c9f67bc53be8927$var$ThreeLeft) {
                        $tco_var_dictOrd = dictOrd;
                        $tco_var_v = v.value1;
                        $copy_v1 = new $7c9f67bc53be8927$export$eadfa7aed248243e(v1, v.value0.value0, v.value0.value1, v.value0.value2, v.value0.value3, v.value0.value4, v.value0.value5);
                        return;
                    }
                    if (v.value0 instanceof $7c9f67bc53be8927$var$ThreeMiddle) {
                        $tco_var_dictOrd = dictOrd;
                        $tco_var_v = v.value1;
                        $copy_v1 = new $7c9f67bc53be8927$export$eadfa7aed248243e(v.value0.value0, v.value0.value1, v.value0.value2, v1, v.value0.value3, v.value0.value4, v.value0.value5);
                        return;
                    }
                    if (v.value0 instanceof $7c9f67bc53be8927$var$ThreeRight) {
                        $tco_var_dictOrd = dictOrd;
                        $tco_var_v = v.value1;
                        $copy_v1 = new $7c9f67bc53be8927$export$eadfa7aed248243e(v.value0.value0, v.value0.value1, v.value0.value2, v.value0.value3, v.value0.value4, v.value0.value5, v1);
                        return;
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 462, column 3 - line 467, column 88): " + [
                        v.value0.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 459, column 1 - line 459, column 80): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_dictOrd, $tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
};
var $7c9f67bc53be8927$export$21a5ca8aa77d35ff = function(dictOrd) {
    var fromZipper1 = $7c9f67bc53be8927$var$fromZipper(dictOrd);
    var compare = $gwBF5.compare(dictOrd);
    return function(k) {
        return function(v) {
            var up = function($copy_v1) {
                return function($copy_v2) {
                    var $tco_var_v1 = $copy_v1;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(v1, v2) {
                        if (v1 instanceof $fZenR.Nil) {
                            $tco_done = true;
                            return new $7c9f67bc53be8927$export$9276dd97bf62cc8d(v2.value0, v2.value1, v2.value2, v2.value3);
                        }
                        if (v1 instanceof $fZenR.Cons) {
                            if (v1.value0 instanceof $7c9f67bc53be8927$var$TwoLeft) {
                                $tco_done = true;
                                return fromZipper1(v1.value1)(new $7c9f67bc53be8927$export$eadfa7aed248243e(v2.value0, v2.value1, v2.value2, v2.value3, v1.value0.value0, v1.value0.value1, v1.value0.value2));
                            }
                            if (v1.value0 instanceof $7c9f67bc53be8927$var$TwoRight) {
                                $tco_done = true;
                                return fromZipper1(v1.value1)(new $7c9f67bc53be8927$export$eadfa7aed248243e(v1.value0.value0, v1.value0.value1, v1.value0.value2, v2.value0, v2.value1, v2.value2, v2.value3));
                            }
                            if (v1.value0 instanceof $7c9f67bc53be8927$var$ThreeLeft) {
                                $tco_var_v1 = v1.value1;
                                $copy_v2 = new $7c9f67bc53be8927$var$KickUp(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(v2.value0, v2.value1, v2.value2, v2.value3), v1.value0.value0, v1.value0.value1, new $7c9f67bc53be8927$export$9276dd97bf62cc8d(v1.value0.value2, v1.value0.value3, v1.value0.value4, v1.value0.value5));
                                return;
                            }
                            if (v1.value0 instanceof $7c9f67bc53be8927$var$ThreeMiddle) {
                                $tco_var_v1 = v1.value1;
                                $copy_v2 = new $7c9f67bc53be8927$var$KickUp(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(v1.value0.value0, v1.value0.value1, v1.value0.value2, v2.value0), v2.value1, v2.value2, new $7c9f67bc53be8927$export$9276dd97bf62cc8d(v2.value3, v1.value0.value3, v1.value0.value4, v1.value0.value5));
                                return;
                            }
                            if (v1.value0 instanceof $7c9f67bc53be8927$var$ThreeRight) {
                                $tco_var_v1 = v1.value1;
                                $copy_v2 = new $7c9f67bc53be8927$var$KickUp(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(v1.value0.value0, v1.value0.value1, v1.value0.value2, v1.value0.value3), v1.value0.value4, v1.value0.value5, new $7c9f67bc53be8927$export$9276dd97bf62cc8d(v2.value0, v2.value1, v2.value2, v2.value3));
                                return;
                            }
                            throw new Error("Failed pattern match at Data.Map.Internal (line 498, column 5 - line 503, column 108): " + [
                                v1.value0.constructor.name,
                                v2.constructor.name
                            ]);
                        }
                        throw new Error("Failed pattern match at Data.Map.Internal (line 495, column 3 - line 495, column 56): " + [
                            v1.constructor.name,
                            v2.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_v1, $copy_v2);
                    return $tco_result;
                };
            };
            var down = function($copy_v1) {
                return function($copy_v2) {
                    var $tco_var_v1 = $copy_v1;
                    var $tco_done1 = false;
                    var $tco_result;
                    function $tco_loop(v1, v2) {
                        if (v2 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) {
                            $tco_done1 = true;
                            return up(v1)(new $7c9f67bc53be8927$var$KickUp($7c9f67bc53be8927$export$3024f3bfb62054a3.value, k, v, $7c9f67bc53be8927$export$3024f3bfb62054a3.value));
                        }
                        if (v2 instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                            var v3 = compare(k)(v2.value1);
                            if (v3 instanceof $ibsD5.EQ) {
                                $tco_done1 = true;
                                return fromZipper1(v1)(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(v2.value0, k, v, v2.value3));
                            }
                            if (v3 instanceof $ibsD5.LT) {
                                $tco_var_v1 = new $fZenR.Cons(new $7c9f67bc53be8927$var$TwoLeft(v2.value1, v2.value2, v2.value3), v1);
                                $copy_v2 = v2.value0;
                                return;
                            }
                            $tco_var_v1 = new $fZenR.Cons(new $7c9f67bc53be8927$var$TwoRight(v2.value0, v2.value1, v2.value2), v1);
                            $copy_v2 = v2.value3;
                            return;
                        }
                        if (v2 instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                            var v3 = compare(k)(v2.value1);
                            if (v3 instanceof $ibsD5.EQ) {
                                $tco_done1 = true;
                                return fromZipper1(v1)(new $7c9f67bc53be8927$export$eadfa7aed248243e(v2.value0, k, v, v2.value3, v2.value4, v2.value5, v2.value6));
                            }
                            var v4 = compare(k)(v2.value4);
                            if (v4 instanceof $ibsD5.EQ) {
                                $tco_done1 = true;
                                return fromZipper1(v1)(new $7c9f67bc53be8927$export$eadfa7aed248243e(v2.value0, v2.value1, v2.value2, v2.value3, k, v, v2.value6));
                            }
                            if (v3 instanceof $ibsD5.LT) {
                                $tco_var_v1 = new $fZenR.Cons(new $7c9f67bc53be8927$var$ThreeLeft(v2.value1, v2.value2, v2.value3, v2.value4, v2.value5, v2.value6), v1);
                                $copy_v2 = v2.value0;
                                return;
                            }
                            if (v3 instanceof $ibsD5.GT && v4 instanceof $ibsD5.LT) {
                                $tco_var_v1 = new $fZenR.Cons(new $7c9f67bc53be8927$var$ThreeMiddle(v2.value0, v2.value1, v2.value2, v2.value4, v2.value5, v2.value6), v1);
                                $copy_v2 = v2.value3;
                                return;
                            }
                            $tco_var_v1 = new $fZenR.Cons(new $7c9f67bc53be8927$var$ThreeRight(v2.value0, v2.value1, v2.value2, v2.value3, v2.value4, v2.value5), v1);
                            $copy_v2 = v2.value6;
                            return;
                        }
                        throw new Error("Failed pattern match at Data.Map.Internal (line 478, column 3 - line 478, column 55): " + [
                            v1.constructor.name,
                            v2.constructor.name
                        ]);
                    }
                    while(!$tco_done1)$tco_result = $tco_loop($tco_var_v1, $copy_v2);
                    return $tco_result;
                };
            };
            return down($fZenR.Nil.value);
        };
    };
};
var $7c9f67bc53be8927$export$3e41007ebfff0e64 = function(dictOrd) {
    var fromZipper1 = $7c9f67bc53be8927$var$fromZipper(dictOrd);
    var compare = $gwBF5.compare(dictOrd);
    return function(k) {
        var up = function($copy_ctxs) {
            return function($copy_tree) {
                var $tco_var_ctxs = $copy_ctxs;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(ctxs, tree) {
                    if (ctxs instanceof $fZenR.Nil) {
                        $tco_done = true;
                        return tree;
                    }
                    if (ctxs instanceof $fZenR.Cons) {
                        if (ctxs.value0 instanceof $7c9f67bc53be8927$var$TwoLeft && ctxs.value0.value2 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3 && tree instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) {
                            $tco_done = true;
                            return fromZipper1(ctxs.value1)(new $7c9f67bc53be8927$export$9276dd97bf62cc8d($7c9f67bc53be8927$export$3024f3bfb62054a3.value, ctxs.value0.value0, ctxs.value0.value1, $7c9f67bc53be8927$export$3024f3bfb62054a3.value));
                        }
                        if (ctxs.value0 instanceof $7c9f67bc53be8927$var$TwoRight && ctxs.value0.value0 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3 && tree instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) {
                            $tco_done = true;
                            return fromZipper1(ctxs.value1)(new $7c9f67bc53be8927$export$9276dd97bf62cc8d($7c9f67bc53be8927$export$3024f3bfb62054a3.value, ctxs.value0.value1, ctxs.value0.value2, $7c9f67bc53be8927$export$3024f3bfb62054a3.value));
                        }
                        if (ctxs.value0 instanceof $7c9f67bc53be8927$var$TwoLeft && ctxs.value0.value2 instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                            $tco_var_ctxs = ctxs.value1;
                            $copy_tree = new $7c9f67bc53be8927$export$eadfa7aed248243e(tree, ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2.value0, ctxs.value0.value2.value1, ctxs.value0.value2.value2, ctxs.value0.value2.value3);
                            return;
                        }
                        if (ctxs.value0 instanceof $7c9f67bc53be8927$var$TwoRight && ctxs.value0.value0 instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                            $tco_var_ctxs = ctxs.value1;
                            $copy_tree = new $7c9f67bc53be8927$export$eadfa7aed248243e(ctxs.value0.value0.value0, ctxs.value0.value0.value1, ctxs.value0.value0.value2, ctxs.value0.value0.value3, ctxs.value0.value1, ctxs.value0.value2, tree);
                            return;
                        }
                        if (ctxs.value0 instanceof $7c9f67bc53be8927$var$TwoLeft && ctxs.value0.value2 instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                            $tco_done = true;
                            return fromZipper1(ctxs.value1)(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(tree, ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2.value0), ctxs.value0.value2.value1, ctxs.value0.value2.value2, new $7c9f67bc53be8927$export$9276dd97bf62cc8d(ctxs.value0.value2.value3, ctxs.value0.value2.value4, ctxs.value0.value2.value5, ctxs.value0.value2.value6)));
                        }
                        if (ctxs.value0 instanceof $7c9f67bc53be8927$var$TwoRight && ctxs.value0.value0 instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                            $tco_done = true;
                            return fromZipper1(ctxs.value1)(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(ctxs.value0.value0.value0, ctxs.value0.value0.value1, ctxs.value0.value0.value2, ctxs.value0.value0.value3), ctxs.value0.value0.value4, ctxs.value0.value0.value5, new $7c9f67bc53be8927$export$9276dd97bf62cc8d(ctxs.value0.value0.value6, ctxs.value0.value1, ctxs.value0.value2, tree)));
                        }
                        if (ctxs.value0 instanceof $7c9f67bc53be8927$var$ThreeLeft && ctxs.value0.value2 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3 && ctxs.value0.value5 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3 && tree instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) {
                            $tco_done = true;
                            return fromZipper1(ctxs.value1)(new $7c9f67bc53be8927$export$eadfa7aed248243e($7c9f67bc53be8927$export$3024f3bfb62054a3.value, ctxs.value0.value0, ctxs.value0.value1, $7c9f67bc53be8927$export$3024f3bfb62054a3.value, ctxs.value0.value3, ctxs.value0.value4, $7c9f67bc53be8927$export$3024f3bfb62054a3.value));
                        }
                        if (ctxs.value0 instanceof $7c9f67bc53be8927$var$ThreeMiddle && ctxs.value0.value0 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3 && ctxs.value0.value5 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3 && tree instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) {
                            $tco_done = true;
                            return fromZipper1(ctxs.value1)(new $7c9f67bc53be8927$export$eadfa7aed248243e($7c9f67bc53be8927$export$3024f3bfb62054a3.value, ctxs.value0.value1, ctxs.value0.value2, $7c9f67bc53be8927$export$3024f3bfb62054a3.value, ctxs.value0.value3, ctxs.value0.value4, $7c9f67bc53be8927$export$3024f3bfb62054a3.value));
                        }
                        if (ctxs.value0 instanceof $7c9f67bc53be8927$var$ThreeRight && ctxs.value0.value0 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3 && ctxs.value0.value3 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3 && tree instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) {
                            $tco_done = true;
                            return fromZipper1(ctxs.value1)(new $7c9f67bc53be8927$export$eadfa7aed248243e($7c9f67bc53be8927$export$3024f3bfb62054a3.value, ctxs.value0.value1, ctxs.value0.value2, $7c9f67bc53be8927$export$3024f3bfb62054a3.value, ctxs.value0.value4, ctxs.value0.value5, $7c9f67bc53be8927$export$3024f3bfb62054a3.value));
                        }
                        if (ctxs.value0 instanceof $7c9f67bc53be8927$var$ThreeLeft && ctxs.value0.value2 instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                            $tco_done = true;
                            return fromZipper1(ctxs.value1)(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(new $7c9f67bc53be8927$export$eadfa7aed248243e(tree, ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2.value0, ctxs.value0.value2.value1, ctxs.value0.value2.value2, ctxs.value0.value2.value3), ctxs.value0.value3, ctxs.value0.value4, ctxs.value0.value5));
                        }
                        if (ctxs.value0 instanceof $7c9f67bc53be8927$var$ThreeMiddle && ctxs.value0.value0 instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                            $tco_done = true;
                            return fromZipper1(ctxs.value1)(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(new $7c9f67bc53be8927$export$eadfa7aed248243e(ctxs.value0.value0.value0, ctxs.value0.value0.value1, ctxs.value0.value0.value2, ctxs.value0.value0.value3, ctxs.value0.value1, ctxs.value0.value2, tree), ctxs.value0.value3, ctxs.value0.value4, ctxs.value0.value5));
                        }
                        if (ctxs.value0 instanceof $7c9f67bc53be8927$var$ThreeMiddle && ctxs.value0.value5 instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                            $tco_done = true;
                            return fromZipper1(ctxs.value1)(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2, new $7c9f67bc53be8927$export$eadfa7aed248243e(tree, ctxs.value0.value3, ctxs.value0.value4, ctxs.value0.value5.value0, ctxs.value0.value5.value1, ctxs.value0.value5.value2, ctxs.value0.value5.value3)));
                        }
                        if (ctxs.value0 instanceof $7c9f67bc53be8927$var$ThreeRight && ctxs.value0.value3 instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                            $tco_done = true;
                            return fromZipper1(ctxs.value1)(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2, new $7c9f67bc53be8927$export$eadfa7aed248243e(ctxs.value0.value3.value0, ctxs.value0.value3.value1, ctxs.value0.value3.value2, ctxs.value0.value3.value3, ctxs.value0.value4, ctxs.value0.value5, tree)));
                        }
                        if (ctxs.value0 instanceof $7c9f67bc53be8927$var$ThreeLeft && ctxs.value0.value2 instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                            $tco_done = true;
                            return fromZipper1(ctxs.value1)(new $7c9f67bc53be8927$export$eadfa7aed248243e(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(tree, ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2.value0), ctxs.value0.value2.value1, ctxs.value0.value2.value2, new $7c9f67bc53be8927$export$9276dd97bf62cc8d(ctxs.value0.value2.value3, ctxs.value0.value2.value4, ctxs.value0.value2.value5, ctxs.value0.value2.value6), ctxs.value0.value3, ctxs.value0.value4, ctxs.value0.value5));
                        }
                        if (ctxs.value0 instanceof $7c9f67bc53be8927$var$ThreeMiddle && ctxs.value0.value0 instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                            $tco_done = true;
                            return fromZipper1(ctxs.value1)(new $7c9f67bc53be8927$export$eadfa7aed248243e(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(ctxs.value0.value0.value0, ctxs.value0.value0.value1, ctxs.value0.value0.value2, ctxs.value0.value0.value3), ctxs.value0.value0.value4, ctxs.value0.value0.value5, new $7c9f67bc53be8927$export$9276dd97bf62cc8d(ctxs.value0.value0.value6, ctxs.value0.value1, ctxs.value0.value2, tree), ctxs.value0.value3, ctxs.value0.value4, ctxs.value0.value5));
                        }
                        if (ctxs.value0 instanceof $7c9f67bc53be8927$var$ThreeMiddle && ctxs.value0.value5 instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                            $tco_done = true;
                            return fromZipper1(ctxs.value1)(new $7c9f67bc53be8927$export$eadfa7aed248243e(ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2, new $7c9f67bc53be8927$export$9276dd97bf62cc8d(tree, ctxs.value0.value3, ctxs.value0.value4, ctxs.value0.value5.value0), ctxs.value0.value5.value1, ctxs.value0.value5.value2, new $7c9f67bc53be8927$export$9276dd97bf62cc8d(ctxs.value0.value5.value3, ctxs.value0.value5.value4, ctxs.value0.value5.value5, ctxs.value0.value5.value6)));
                        }
                        if (ctxs.value0 instanceof $7c9f67bc53be8927$var$ThreeRight && ctxs.value0.value3 instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                            $tco_done = true;
                            return fromZipper1(ctxs.value1)(new $7c9f67bc53be8927$export$eadfa7aed248243e(ctxs.value0.value0, ctxs.value0.value1, ctxs.value0.value2, new $7c9f67bc53be8927$export$9276dd97bf62cc8d(ctxs.value0.value3.value0, ctxs.value0.value3.value1, ctxs.value0.value3.value2, ctxs.value0.value3.value3), ctxs.value0.value3.value4, ctxs.value0.value3.value5, new $7c9f67bc53be8927$export$9276dd97bf62cc8d(ctxs.value0.value3.value6, ctxs.value0.value4, ctxs.value0.value5, tree)));
                        }
                        $tco_done = true;
                        return $lqv9L.unsafeCrashWith("The impossible happened in partial function `up`.");
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 552, column 5 - line 573, column 86): " + [
                        ctxs.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_ctxs, $copy_tree);
                return $tco_result;
            };
        };
        var removeMaxNode = function($copy_ctx) {
            return function($copy_m) {
                var $tco_var_ctx = $copy_ctx;
                var $tco_done1 = false;
                var $tco_result;
                function $tco_loop(ctx, m) {
                    if (m instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d && m.value0 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3 && m.value3 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) {
                        $tco_done1 = true;
                        return up(ctx)($7c9f67bc53be8927$export$3024f3bfb62054a3.value);
                    }
                    if (m instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                        $tco_var_ctx = new $fZenR.Cons(new $7c9f67bc53be8927$var$TwoRight(m.value0, m.value1, m.value2), ctx);
                        $copy_m = m.value3;
                        return;
                    }
                    if (m instanceof $7c9f67bc53be8927$export$eadfa7aed248243e && m.value0 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3 && m.value3 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3 && m.value6 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) {
                        $tco_done1 = true;
                        return up(new $fZenR.Cons(new $7c9f67bc53be8927$var$TwoRight($7c9f67bc53be8927$export$3024f3bfb62054a3.value, m.value1, m.value2), ctx))($7c9f67bc53be8927$export$3024f3bfb62054a3.value);
                    }
                    if (m instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                        $tco_var_ctx = new $fZenR.Cons(new $7c9f67bc53be8927$var$ThreeRight(m.value0, m.value1, m.value2, m.value3, m.value4, m.value5), ctx);
                        $copy_m = m.value6;
                        return;
                    }
                    $tco_done1 = true;
                    return $lqv9L.unsafeCrashWith("The impossible happened in partial function `removeMaxNode`.");
                }
                while(!$tco_done1)$tco_result = $tco_loop($tco_var_ctx, $copy_m);
                return $tco_result;
            };
        };
        var maxNode = function($copy_m) {
            var $tco_done2 = false;
            var $tco_result;
            function $tco_loop(m) {
                if (m instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d && m.value3 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) {
                    $tco_done2 = true;
                    return {
                        key: m.value1,
                        value: m.value2
                    };
                }
                if (m instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                    $copy_m = m.value3;
                    return;
                }
                if (m instanceof $7c9f67bc53be8927$export$eadfa7aed248243e && m.value6 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) {
                    $tco_done2 = true;
                    return {
                        key: m.value4,
                        value: m.value5
                    };
                }
                if (m instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                    $copy_m = m.value6;
                    return;
                }
                $tco_done2 = true;
                return $lqv9L.unsafeCrashWith("The impossible happened in partial function `maxNode`.");
            }
            while(!$tco_done2)$tco_result = $tco_loop($copy_m);
            return $tco_result;
        };
        var down = function($copy_ctx) {
            return function($copy_m) {
                var $tco_var_ctx = $copy_ctx;
                var $tco_done3 = false;
                var $tco_result;
                function $tco_loop(ctx, m) {
                    if (m instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) {
                        $tco_done3 = true;
                        return $h2xUu.Nothing.value;
                    }
                    if (m instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                        var v = compare(k)(m.value1);
                        if (m.value3 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3 && v instanceof $ibsD5.EQ) {
                            $tco_done3 = true;
                            return new $h2xUu.Just(new $7O0Q4.Tuple(m.value2, up(ctx)($7c9f67bc53be8927$export$3024f3bfb62054a3.value)));
                        }
                        if (v instanceof $ibsD5.EQ) {
                            var max = maxNode(m.value0);
                            $tco_done3 = true;
                            return new $h2xUu.Just(new $7O0Q4.Tuple(m.value2, removeMaxNode(new $fZenR.Cons(new $7c9f67bc53be8927$var$TwoLeft(max.key, max.value, m.value3), ctx))(m.value0)));
                        }
                        if (v instanceof $ibsD5.LT) {
                            $tco_var_ctx = new $fZenR.Cons(new $7c9f67bc53be8927$var$TwoLeft(m.value1, m.value2, m.value3), ctx);
                            $copy_m = m.value0;
                            return;
                        }
                        $tco_var_ctx = new $fZenR.Cons(new $7c9f67bc53be8927$var$TwoRight(m.value0, m.value1, m.value2), ctx);
                        $copy_m = m.value3;
                        return;
                    }
                    if (m instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                        var leaves = function() {
                            if (m.value0 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3 && m.value3 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3 && m.value6 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return true;
                            return false;
                        }();
                        var v = compare(k)(m.value4);
                        var v3 = compare(k)(m.value1);
                        if (leaves && v3 instanceof $ibsD5.EQ) {
                            $tco_done3 = true;
                            return new $h2xUu.Just(new $7O0Q4.Tuple(m.value2, fromZipper1(ctx)(new $7c9f67bc53be8927$export$9276dd97bf62cc8d($7c9f67bc53be8927$export$3024f3bfb62054a3.value, m.value4, m.value5, $7c9f67bc53be8927$export$3024f3bfb62054a3.value))));
                        }
                        if (leaves && v instanceof $ibsD5.EQ) {
                            $tco_done3 = true;
                            return new $h2xUu.Just(new $7O0Q4.Tuple(m.value5, fromZipper1(ctx)(new $7c9f67bc53be8927$export$9276dd97bf62cc8d($7c9f67bc53be8927$export$3024f3bfb62054a3.value, m.value1, m.value2, $7c9f67bc53be8927$export$3024f3bfb62054a3.value))));
                        }
                        if (v3 instanceof $ibsD5.EQ) {
                            var max = maxNode(m.value0);
                            $tco_done3 = true;
                            return new $h2xUu.Just(new $7O0Q4.Tuple(m.value2, removeMaxNode(new $fZenR.Cons(new $7c9f67bc53be8927$var$ThreeLeft(max.key, max.value, m.value3, m.value4, m.value5, m.value6), ctx))(m.value0)));
                        }
                        if (v instanceof $ibsD5.EQ) {
                            var max = maxNode(m.value3);
                            $tco_done3 = true;
                            return new $h2xUu.Just(new $7O0Q4.Tuple(m.value5, removeMaxNode(new $fZenR.Cons(new $7c9f67bc53be8927$var$ThreeMiddle(m.value0, m.value1, m.value2, max.key, max.value, m.value6), ctx))(m.value3)));
                        }
                        if (v3 instanceof $ibsD5.LT) {
                            $tco_var_ctx = new $fZenR.Cons(new $7c9f67bc53be8927$var$ThreeLeft(m.value1, m.value2, m.value3, m.value4, m.value5, m.value6), ctx);
                            $copy_m = m.value0;
                            return;
                        }
                        if (v3 instanceof $ibsD5.GT && v instanceof $ibsD5.LT) {
                            $tco_var_ctx = new $fZenR.Cons(new $7c9f67bc53be8927$var$ThreeMiddle(m.value0, m.value1, m.value2, m.value4, m.value5, m.value6), ctx);
                            $copy_m = m.value3;
                            return;
                        }
                        $tco_var_ctx = new $fZenR.Cons(new $7c9f67bc53be8927$var$ThreeRight(m.value0, m.value1, m.value2, m.value3, m.value4, m.value5), ctx);
                        $copy_m = m.value6;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 525, column 16 - line 548, column 80): " + [
                        m.constructor.name
                    ]);
                }
                while(!$tco_done3)$tco_result = $tco_loop($tco_var_ctx, $copy_m);
                return $tco_result;
            };
        };
        return down($fZenR.Nil.value);
    };
};
var $7c9f67bc53be8927$export$4295a0c2ad7aa544 = {
    foldr: function(f) {
        return function(z) {
            return function(m) {
                if (m instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return z;
                if (m instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) return $dNwPt.foldr($7c9f67bc53be8927$export$4295a0c2ad7aa544)(f)(f(m.value2)($dNwPt.foldr($7c9f67bc53be8927$export$4295a0c2ad7aa544)(f)(z)(m.value3)))(m.value0);
                if (m instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) return $dNwPt.foldr($7c9f67bc53be8927$export$4295a0c2ad7aa544)(f)(f(m.value2)($dNwPt.foldr($7c9f67bc53be8927$export$4295a0c2ad7aa544)(f)(f(m.value5)($dNwPt.foldr($7c9f67bc53be8927$export$4295a0c2ad7aa544)(f)(z)(m.value6)))(m.value3)))(m.value0);
                throw new Error("Failed pattern match at Data.Map.Internal (line 133, column 17 - line 136, column 85): " + [
                    m.constructor.name
                ]);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(m) {
                if (m instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return z;
                if (m instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) return $dNwPt.foldl($7c9f67bc53be8927$export$4295a0c2ad7aa544)(f)(f($dNwPt.foldl($7c9f67bc53be8927$export$4295a0c2ad7aa544)(f)(z)(m.value0))(m.value2))(m.value3);
                if (m instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) return $dNwPt.foldl($7c9f67bc53be8927$export$4295a0c2ad7aa544)(f)(f($dNwPt.foldl($7c9f67bc53be8927$export$4295a0c2ad7aa544)(f)(f($dNwPt.foldl($7c9f67bc53be8927$export$4295a0c2ad7aa544)(f)(z)(m.value0))(m.value2))(m.value3))(m.value5))(m.value6);
                throw new Error("Failed pattern match at Data.Map.Internal (line 137, column 17 - line 140, column 85): " + [
                    m.constructor.name
                ]);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $3aOYV.mempty(dictMonoid);
        var append2 = $d5vvq.append(dictMonoid.Semigroup0());
        return function(f) {
            return function(m) {
                if (m instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return mempty;
                if (m instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) return append2($dNwPt.foldMap($7c9f67bc53be8927$export$4295a0c2ad7aa544)(dictMonoid)(f)(m.value0))(append2(f(m.value2))($dNwPt.foldMap($7c9f67bc53be8927$export$4295a0c2ad7aa544)(dictMonoid)(f)(m.value3)));
                if (m instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) return append2($dNwPt.foldMap($7c9f67bc53be8927$export$4295a0c2ad7aa544)(dictMonoid)(f)(m.value0))(append2(f(m.value2))(append2($dNwPt.foldMap($7c9f67bc53be8927$export$4295a0c2ad7aa544)(dictMonoid)(f)(m.value3))(append2(f(m.value5))($dNwPt.foldMap($7c9f67bc53be8927$export$4295a0c2ad7aa544)(dictMonoid)(f)(m.value6)))));
                throw new Error("Failed pattern match at Data.Map.Internal (line 141, column 17 - line 144, column 93): " + [
                    m.constructor.name
                ]);
            };
        };
    }
};
var $7c9f67bc53be8927$export$91e1c50dfb7225a6 = {
    foldrWithIndex: function(f) {
        return function(z) {
            return function(m) {
                if (m instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return z;
                if (m instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) return $7vxKS.foldrWithIndex($7c9f67bc53be8927$export$91e1c50dfb7225a6)(f)(f(m.value1)(m.value2)($7vxKS.foldrWithIndex($7c9f67bc53be8927$export$91e1c50dfb7225a6)(f)(z)(m.value3)))(m.value0);
                if (m instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) return $7vxKS.foldrWithIndex($7c9f67bc53be8927$export$91e1c50dfb7225a6)(f)(f(m.value1)(m.value2)($7vxKS.foldrWithIndex($7c9f67bc53be8927$export$91e1c50dfb7225a6)(f)(f(m.value4)(m.value5)($7vxKS.foldrWithIndex($7c9f67bc53be8927$export$91e1c50dfb7225a6)(f)(z)(m.value6)))(m.value3)))(m.value0);
                throw new Error("Failed pattern match at Data.Map.Internal (line 147, column 26 - line 150, column 120): " + [
                    m.constructor.name
                ]);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            return function(m) {
                if (m instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return z;
                if (m instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) return $7vxKS.foldlWithIndex($7c9f67bc53be8927$export$91e1c50dfb7225a6)(f)(f(m.value1)($7vxKS.foldlWithIndex($7c9f67bc53be8927$export$91e1c50dfb7225a6)(f)(z)(m.value0))(m.value2))(m.value3);
                if (m instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) return $7vxKS.foldlWithIndex($7c9f67bc53be8927$export$91e1c50dfb7225a6)(f)(f(m.value4)($7vxKS.foldlWithIndex($7c9f67bc53be8927$export$91e1c50dfb7225a6)(f)(f(m.value1)($7vxKS.foldlWithIndex($7c9f67bc53be8927$export$91e1c50dfb7225a6)(f)(z)(m.value0))(m.value2))(m.value3))(m.value5))(m.value6);
                throw new Error("Failed pattern match at Data.Map.Internal (line 151, column 26 - line 154, column 120): " + [
                    m.constructor.name
                ]);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var mempty = $3aOYV.mempty(dictMonoid);
        var append2 = $d5vvq.append(dictMonoid.Semigroup0());
        return function(f) {
            return function(m) {
                if (m instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return mempty;
                if (m instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) return append2($7vxKS.foldMapWithIndex($7c9f67bc53be8927$export$91e1c50dfb7225a6)(dictMonoid)(f)(m.value0))(append2(f(m.value1)(m.value2))($7vxKS.foldMapWithIndex($7c9f67bc53be8927$export$91e1c50dfb7225a6)(dictMonoid)(f)(m.value3)));
                if (m instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) return append2($7vxKS.foldMapWithIndex($7c9f67bc53be8927$export$91e1c50dfb7225a6)(dictMonoid)(f)(m.value0))(append2(f(m.value1)(m.value2))(append2($7vxKS.foldMapWithIndex($7c9f67bc53be8927$export$91e1c50dfb7225a6)(dictMonoid)(f)(m.value3))(append2(f(m.value4)(m.value5))($7vxKS.foldMapWithIndex($7c9f67bc53be8927$export$91e1c50dfb7225a6)(dictMonoid)(f)(m.value6)))));
                throw new Error("Failed pattern match at Data.Map.Internal (line 155, column 26 - line 158, column 128): " + [
                    m.constructor.name
                ]);
            };
        };
    },
    Foldable0: function() {
        return $7c9f67bc53be8927$export$4295a0c2ad7aa544;
    }
};
var $7c9f67bc53be8927$var$foldrWithIndex = /* #__PURE__ */ $7vxKS.foldrWithIndex($7c9f67bc53be8927$export$91e1c50dfb7225a6);
var $7c9f67bc53be8927$var$foldlWithIndex = /* #__PURE__ */ $7vxKS.foldlWithIndex($7c9f67bc53be8927$export$91e1c50dfb7225a6);
var $7c9f67bc53be8927$export$ed97f33186d4b816 = /* #__PURE__ */ function() {
    return $7c9f67bc53be8927$var$foldrWithIndex(function(k) {
        return function(v) {
            return function(acc) {
                return new $fZenR.Cons(k, acc);
            };
        };
    })($fZenR.Nil.value);
}();
var $7c9f67bc53be8927$export$78146089411e393d = {
    traverse: function(dictApplicative) {
        var pure1 = $bQdkN.pure(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $26ZCq.apply(Apply0);
        var map1 = $7FzSN.map(Apply0.Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return pure1($7c9f67bc53be8927$export$3024f3bfb62054a3.value);
                if (v1 instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) return apply(apply(apply(map1($7c9f67bc53be8927$export$9276dd97bf62cc8d.create)($9OOYG.traverse($7c9f67bc53be8927$export$78146089411e393d)(dictApplicative)(v)(v1.value0)))(pure1(v1.value1)))(v(v1.value2)))($9OOYG.traverse($7c9f67bc53be8927$export$78146089411e393d)(dictApplicative)(v)(v1.value3));
                if (v1 instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) return apply(apply(apply(apply(apply(apply(map1($7c9f67bc53be8927$export$eadfa7aed248243e.create)($9OOYG.traverse($7c9f67bc53be8927$export$78146089411e393d)(dictApplicative)(v)(v1.value0)))(pure1(v1.value1)))(v(v1.value2)))($9OOYG.traverse($7c9f67bc53be8927$export$78146089411e393d)(dictApplicative)(v)(v1.value3)))(pure1(v1.value4)))(v(v1.value5)))($9OOYG.traverse($7c9f67bc53be8927$export$78146089411e393d)(dictApplicative)(v)(v1.value6));
                throw new Error("Failed pattern match at Data.Map.Internal (line 160, column 1 - line 175, column 31): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        return $9OOYG.traverse($7c9f67bc53be8927$export$78146089411e393d)(dictApplicative)($7c9f67bc53be8927$var$identity);
    },
    Functor0: function() {
        return $7c9f67bc53be8927$export$3930f636962ed944;
    },
    Foldable1: function() {
        return $7c9f67bc53be8927$export$4295a0c2ad7aa544;
    }
};
var $7c9f67bc53be8927$export$8999febf5cd85b5c = {
    traverseWithIndex: function(dictApplicative) {
        var pure1 = $bQdkN.pure(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $26ZCq.apply(Apply0);
        var map1 = $7FzSN.map(Apply0.Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return pure1($7c9f67bc53be8927$export$3024f3bfb62054a3.value);
                if (v1 instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) return apply(apply(apply(map1($7c9f67bc53be8927$export$9276dd97bf62cc8d.create)($bijFl.traverseWithIndex($7c9f67bc53be8927$export$8999febf5cd85b5c)(dictApplicative)(v)(v1.value0)))(pure1(v1.value1)))(v(v1.value1)(v1.value2)))($bijFl.traverseWithIndex($7c9f67bc53be8927$export$8999febf5cd85b5c)(dictApplicative)(v)(v1.value3));
                if (v1 instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) return apply(apply(apply(apply(apply(apply(map1($7c9f67bc53be8927$export$eadfa7aed248243e.create)($bijFl.traverseWithIndex($7c9f67bc53be8927$export$8999febf5cd85b5c)(dictApplicative)(v)(v1.value0)))(pure1(v1.value1)))(v(v1.value1)(v1.value2)))($bijFl.traverseWithIndex($7c9f67bc53be8927$export$8999febf5cd85b5c)(dictApplicative)(v)(v1.value3)))(pure1(v1.value4)))(v(v1.value4)(v1.value5)))($bijFl.traverseWithIndex($7c9f67bc53be8927$export$8999febf5cd85b5c)(dictApplicative)(v)(v1.value6));
                throw new Error("Failed pattern match at Data.Map.Internal (line 177, column 1 - line 191, column 40): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    FunctorWithIndex0: function() {
        return $7c9f67bc53be8927$export$d7c684e0b3e84e77;
    },
    FoldableWithIndex1: function() {
        return $7c9f67bc53be8927$export$91e1c50dfb7225a6;
    },
    Traversable2: function() {
        return $7c9f67bc53be8927$export$78146089411e393d;
    }
};
var $7c9f67bc53be8927$export$68c286be0e7e55b7 = /* #__PURE__ */ function() {
    return $dNwPt.foldr($7c9f67bc53be8927$export$4295a0c2ad7aa544)($fZenR.Cons.create)($fZenR.Nil.value);
}();
var $7c9f67bc53be8927$var$foldSubmapBy = function(dictOrd) {
    var lessThan = $gwBF5.lessThan(dictOrd);
    var greaterThan = $gwBF5.greaterThan(dictOrd);
    var lessThanOrEq = $gwBF5.lessThanOrEq(dictOrd);
    return function(appendFn) {
        return function(memptyValue) {
            return function(kmin) {
                return function(kmax) {
                    return function(f) {
                        var tooSmall = function() {
                            if (kmin instanceof $h2xUu.Just) return function(k) {
                                return lessThan(k)(kmin.value0);
                            };
                            if (kmin instanceof $h2xUu.Nothing) return $jhsiw.const(false);
                            throw new Error("Failed pattern match at Data.Map.Internal (line 363, column 7 - line 367, column 22): " + [
                                kmin.constructor.name
                            ]);
                        }();
                        var tooLarge = function() {
                            if (kmax instanceof $h2xUu.Just) return function(k) {
                                return greaterThan(k)(kmax.value0);
                            };
                            if (kmax instanceof $h2xUu.Nothing) return $jhsiw.const(false);
                            throw new Error("Failed pattern match at Data.Map.Internal (line 370, column 7 - line 374, column 22): " + [
                                kmax.constructor.name
                            ]);
                        }();
                        var inBounds = function() {
                            if (kmin instanceof $h2xUu.Just && kmax instanceof $h2xUu.Just) return function(k) {
                                return lessThanOrEq(kmin.value0)(k) && lessThanOrEq(k)(kmax.value0);
                            };
                            if (kmin instanceof $h2xUu.Just && kmax instanceof $h2xUu.Nothing) return function(k) {
                                return lessThanOrEq(kmin.value0)(k);
                            };
                            if (kmin instanceof $h2xUu.Nothing && kmax instanceof $h2xUu.Just) return function(k) {
                                return lessThanOrEq(k)(kmax.value0);
                            };
                            if (kmin instanceof $h2xUu.Nothing && kmax instanceof $h2xUu.Nothing) return $jhsiw.const(true);
                            throw new Error("Failed pattern match at Data.Map.Internal (line 377, column 7 - line 385, column 21): " + [
                                kmin.constructor.name,
                                kmax.constructor.name
                            ]);
                        }();
                        var go = function(v) {
                            if (v instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return memptyValue;
                            if (v instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) return appendFn(appendFn(function() {
                                var $819 = tooSmall(v.value1);
                                if ($819) return memptyValue;
                                return go(v.value0);
                            }())(function() {
                                var $820 = inBounds(v.value1);
                                if ($820) return f(v.value1)(v.value2);
                                return memptyValue;
                            }()))(function() {
                                var $821 = tooLarge(v.value1);
                                if ($821) return memptyValue;
                                return go(v.value3);
                            }());
                            if (v instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) return appendFn(appendFn(appendFn(appendFn(function() {
                                var $826 = tooSmall(v.value1);
                                if ($826) return memptyValue;
                                return go(v.value0);
                            }())(function() {
                                var $827 = inBounds(v.value1);
                                if ($827) return f(v.value1)(v.value2);
                                return memptyValue;
                            }()))(function() {
                                var $828 = tooSmall(v.value4) || tooLarge(v.value1);
                                if ($828) return memptyValue;
                                return go(v.value3);
                            }()))(function() {
                                var $829 = inBounds(v.value4);
                                if ($829) return f(v.value4)(v.value5);
                                return memptyValue;
                            }()))(function() {
                                var $830 = tooLarge(v.value4);
                                if ($830) return memptyValue;
                                return go(v.value6);
                            }());
                            throw new Error("Failed pattern match at Data.Map.Internal (line 403, column 10 - line 415, column 67): " + [
                                v.constructor.name
                            ]);
                        };
                        return go;
                    };
                };
            };
        };
    };
};
var $7c9f67bc53be8927$export$3f9a381f67a51fcd = function(dictOrd) {
    var foldSubmapBy1 = $7c9f67bc53be8927$var$foldSubmapBy(dictOrd);
    return function(dictMonoid) {
        return foldSubmapBy1($d5vvq.append(dictMonoid.Semigroup0()))($3aOYV.mempty(dictMonoid));
    };
};
var $7c9f67bc53be8927$export$3c39a95b7a4d5e28 = /* #__PURE__ */ function() {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return v;
                }
                if (v1 instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                    $tco_var_v = new $h2xUu.Just({
                        key: v1.value1,
                        value: v1.value2
                    });
                    $copy_v1 = v1.value0;
                    return;
                }
                if (v1 instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                    $tco_var_v = new $h2xUu.Just({
                        key: v1.value1,
                        value: v1.value2
                    });
                    $copy_v1 = v1.value0;
                    return;
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 338, column 5 - line 338, column 22): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($h2xUu.Nothing.value);
}();
var $7c9f67bc53be8927$export$211c88c643c40f46 = function(dictOrd) {
    var compare = $gwBF5.compare(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return $h2xUu.Nothing.value;
            if (v instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                var v2 = compare(k)(v.value1);
                if (v2 instanceof $ibsD5.EQ) return $7c9f67bc53be8927$export$3c39a95b7a4d5e28(v.value3);
                if (v2 instanceof $ibsD5.LT) return new $h2xUu.Just($h2xUu.fromMaybe({
                    key: v.value1,
                    value: v.value2
                })(go(v.value0)));
                if (v2 instanceof $ibsD5.GT) return go(v.value3);
                throw new Error("Failed pattern match at Data.Map.Internal (line 317, column 33 - line 320, column 21): " + [
                    v2.constructor.name
                ]);
            }
            if (v instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                var v3 = compare(k)(v.value1);
                if (v3 instanceof $ibsD5.EQ) return $7c9f67bc53be8927$export$3c39a95b7a4d5e28(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(v.value3, v.value4, v.value5, v.value6));
                if (v3 instanceof $ibsD5.LT) return new $h2xUu.Just($h2xUu.fromMaybe({
                    key: v.value1,
                    value: v.value2
                })(go(v.value0)));
                if (v3 instanceof $ibsD5.GT) return go(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(v.value3, v.value4, v.value5, v.value6));
                throw new Error("Failed pattern match at Data.Map.Internal (line 321, column 45 - line 324, column 37): " + [
                    v3.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 316, column 5 - line 316, column 22): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $7c9f67bc53be8927$export$35f577b3da447d17 = /* #__PURE__ */ function() {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return v;
                }
                if (v1 instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                    $tco_var_v = new $h2xUu.Just({
                        key: v1.value1,
                        value: v1.value2
                    });
                    $copy_v1 = v1.value3;
                    return;
                }
                if (v1 instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                    $tco_var_v = new $h2xUu.Just({
                        key: v1.value4,
                        value: v1.value5
                    });
                    $copy_v1 = v1.value6;
                    return;
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 330, column 5 - line 330, column 22): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($h2xUu.Nothing.value);
}();
var $7c9f67bc53be8927$export$9318a1f920537b0d = function(dictOrd) {
    var compare = $gwBF5.compare(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return $h2xUu.Nothing.value;
            if (v instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) {
                var v2 = compare(k)(v.value1);
                if (v2 instanceof $ibsD5.EQ) return $7c9f67bc53be8927$export$35f577b3da447d17(v.value0);
                if (v2 instanceof $ibsD5.GT) return new $h2xUu.Just($h2xUu.fromMaybe({
                    key: v.value1,
                    value: v.value2
                })(go(v.value3)));
                if (v2 instanceof $ibsD5.LT) return go(v.value0);
                throw new Error("Failed pattern match at Data.Map.Internal (line 283, column 33 - line 286, column 20): " + [
                    v2.constructor.name
                ]);
            }
            if (v instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) {
                var v3 = compare(k)(v.value4);
                if (v3 instanceof $ibsD5.EQ) return $7c9f67bc53be8927$export$35f577b3da447d17(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(v.value0, v.value1, v.value2, v.value3));
                if (v3 instanceof $ibsD5.GT) return new $h2xUu.Just($h2xUu.fromMaybe({
                    key: v.value4,
                    value: v.value5
                })(go(v.value6)));
                if (v3 instanceof $ibsD5.LT) return go(new $7c9f67bc53be8927$export$9276dd97bf62cc8d(v.value0, v.value1, v.value2, v.value3));
                throw new Error("Failed pattern match at Data.Map.Internal (line 287, column 45 - line 290, column 36): " + [
                    v3.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 282, column 5 - line 282, column 22): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $7c9f67bc53be8927$export$85aac4508ff70b8 = function(dictEq) {
    var eqTuple = $7O0Q4.eqTuple(dictEq);
    return function(dictEq1) {
        var eq1 = $aJhEx.eq($aJhEx.eqArray(eqTuple(dictEq1)));
        return {
            eq: function(m1) {
                return function(m2) {
                    return eq1($7c9f67bc53be8927$var$toAscArray(m1))($7c9f67bc53be8927$var$toAscArray(m2));
                };
            }
        };
    };
};
var $7c9f67bc53be8927$export$3d0d4caf881d6855 = function(dictOrd) {
    var ordTuple = $7O0Q4.ordTuple(dictOrd);
    var eqMap1 = $7c9f67bc53be8927$export$85aac4508ff70b8(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare = $gwBF5.compare($gwBF5.ordArray(ordTuple(dictOrd1)));
        var eqMap2 = eqMap1(dictOrd1.Eq0());
        return {
            compare: function(m1) {
                return function(m2) {
                    return compare($7c9f67bc53be8927$var$toAscArray(m1))($7c9f67bc53be8927$var$toAscArray(m2));
                };
            },
            Eq0: function() {
                return eqMap2;
            }
        };
    };
};
var $7c9f67bc53be8927$export$e321b34a2787dc8d = function(dictEq) {
    var eqMap1 = $7c9f67bc53be8927$export$85aac4508ff70b8(dictEq);
    return {
        eq1: function(dictEq1) {
            return $aJhEx.eq(eqMap1(dictEq1));
        }
    };
};
var $7c9f67bc53be8927$export$e2f3c1862bab1bff = function(dictOrd) {
    var ordMap1 = $7c9f67bc53be8927$export$3d0d4caf881d6855(dictOrd);
    var eq1Map1 = $7c9f67bc53be8927$export$e321b34a2787dc8d(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return $gwBF5.compare(ordMap1(dictOrd1));
        },
        Eq10: function() {
            return eq1Map1;
        }
    };
};
var $7c9f67bc53be8927$export$6e22c362a0406a2c = /* #__PURE__ */ function() {
    return $7c9f67bc53be8927$export$3024f3bfb62054a3.value;
}();
var $7c9f67bc53be8927$export$b7d5d9bb9ff52072 = function(dictOrd) {
    var insert1 = $7c9f67bc53be8927$export$21a5ca8aa77d35ff(dictOrd);
    return function(dictFoldable) {
        return $dNwPt.foldl(dictFoldable)(function(m) {
            return function(v) {
                return insert1(v.value0)(v.value1)(m);
            };
        })($7c9f67bc53be8927$export$6e22c362a0406a2c);
    };
};
var $7c9f67bc53be8927$export$d7a60370122a9ab0 = function(dictOrd) {
    var fromFoldable1 = $7c9f67bc53be8927$export$b7d5d9bb9ff52072(dictOrd)($3g1lG.foldableList);
    return function(predicate) {
        var $927 = $6j2dz.filter($7O0Q4.uncurry(predicate));
        return function($928) {
            return fromFoldable1($927($7c9f67bc53be8927$var$toUnfoldable1($928)));
        };
    };
};
var $7c9f67bc53be8927$export$3dea766d36a8935f = function(dictOrd) {
    var filterWithKey1 = $7c9f67bc53be8927$export$d7a60370122a9ab0(dictOrd);
    return function(predicate) {
        return filterWithKey1($jhsiw.const(predicate));
    };
};
var $7c9f67bc53be8927$export$151f9a87a7fd5652 = function(dictOrd) {
    var filterWithKey1 = $7c9f67bc53be8927$export$d7a60370122a9ab0(dictOrd);
    return function(predicate) {
        return filterWithKey1(function($929) {
            return $jhsiw.const(predicate($929));
        });
    };
};
var $7c9f67bc53be8927$export$78cfe3464e7eb77b = function(dictOrd) {
    var insert1 = $7c9f67bc53be8927$export$21a5ca8aa77d35ff(dictOrd);
    return function(dictFoldableWithIndex) {
        return $7vxKS.foldlWithIndex(dictFoldableWithIndex)(function(k) {
            return function(m) {
                return function(v) {
                    return insert1(k)(v)(m);
                };
            };
        })($7c9f67bc53be8927$export$6e22c362a0406a2c);
    };
};
var $7c9f67bc53be8927$export$a6c74cde0675b326 = function(dictOrd) {
    var compare = $gwBF5.compare(dictOrd);
    var insert1 = $7c9f67bc53be8927$export$21a5ca8aa77d35ff(dictOrd);
    return function(f) {
        return function(m1) {
            return function(m2) {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        return function($copy_v2) {
                            var $tco_var_v = $copy_v;
                            var $tco_var_v1 = $copy_v1;
                            var $tco_done = false;
                            var $tco_result;
                            function $tco_loop(v, v1, v2) {
                                if (v instanceof $fZenR.Nil) {
                                    $tco_done = true;
                                    return v2;
                                }
                                if (v1 instanceof $fZenR.Nil) {
                                    $tco_done = true;
                                    return v2;
                                }
                                if (v instanceof $fZenR.Cons && v1 instanceof $fZenR.Cons) {
                                    var v3 = compare(v.value0.value0)(v1.value0.value0);
                                    if (v3 instanceof $ibsD5.LT) {
                                        $tco_var_v = v.value1;
                                        $tco_var_v1 = v1;
                                        $copy_v2 = v2;
                                        return;
                                    }
                                    if (v3 instanceof $ibsD5.EQ) {
                                        $tco_var_v = v.value1;
                                        $tco_var_v1 = v1.value1;
                                        $copy_v2 = insert1(v.value0.value0)(f(v.value0.value1)(v1.value0.value1))(v2);
                                        return;
                                    }
                                    if (v3 instanceof $ibsD5.GT) {
                                        $tco_var_v = v;
                                        $tco_var_v1 = v1.value1;
                                        $copy_v2 = v2;
                                        return;
                                    }
                                    throw new Error("Failed pattern match at Data.Map.Internal (line 684, column 5 - line 687, column 27): " + [
                                        v3.constructor.name
                                    ]);
                                }
                                throw new Error("Failed pattern match at Data.Map.Internal (line 681, column 3 - line 681, column 17): " + [
                                    v.constructor.name,
                                    v1.constructor.name,
                                    v2.constructor.name
                                ]);
                            }
                            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                            return $tco_result;
                        };
                    };
                };
                return go($7c9f67bc53be8927$var$toUnfoldable2(m1))($7c9f67bc53be8927$var$toUnfoldable2(m2))($7c9f67bc53be8927$export$6e22c362a0406a2c);
            };
        };
    };
};
var $7c9f67bc53be8927$export$bc86dfbf7795668c = function(dictOrd) {
    return $7c9f67bc53be8927$export$a6c74cde0675b326(dictOrd)($jhsiw.const);
};
var $7c9f67bc53be8927$export$6be5ce76a5140a15 = function(dictOrd) {
    var insert1 = $7c9f67bc53be8927$export$21a5ca8aa77d35ff(dictOrd);
    return function(f) {
        return $7c9f67bc53be8927$var$foldrWithIndex(function(k) {
            return function(a) {
                return function(acc) {
                    return $h2xUu.maybe(acc)(function(b) {
                        return insert1(k)(b)(acc);
                    })(f(k)(a));
                };
            };
        })($7c9f67bc53be8927$export$6e22c362a0406a2c);
    };
};
var $7c9f67bc53be8927$export$e70771d2e7e590a = function(dictOrd) {
    var $930 = $7c9f67bc53be8927$export$6be5ce76a5140a15(dictOrd);
    return function($931) {
        return $930($jhsiw.const($931));
    };
};
var $7c9f67bc53be8927$export$1822828d790e23ee = function(dictOrd) {
    var pop1 = $7c9f67bc53be8927$export$3e41007ebfff0e64(dictOrd);
    return function(k) {
        return function(m) {
            return $h2xUu.maybe(m)($7O0Q4.snd)(pop1(k)(m));
        };
    };
};
var $7c9f67bc53be8927$export$acaf96a27438246b = function(dictOrd) {
    var delete1 = $7c9f67bc53be8927$export$1822828d790e23ee(dictOrd);
    return function(m1) {
        return function(m2) {
            return $7c9f67bc53be8927$var$foldl($jhsiw.flip(delete1))(m1)($7c9f67bc53be8927$export$ed97f33186d4b816(m2));
        };
    };
};
var $7c9f67bc53be8927$export$6583e3e95cb5e9d1 = function(tree) {
    var allHeights = function(v) {
        if (v instanceof $7c9f67bc53be8927$export$3024f3bfb62054a3) return $7c9f67bc53be8927$var$pure(0);
        if (v instanceof $7c9f67bc53be8927$export$9276dd97bf62cc8d) return $7c9f67bc53be8927$var$map(function(n) {
            return n + 1 | 0;
        })($7c9f67bc53be8927$var$append1(allHeights(v.value0))(allHeights(v.value3)));
        if (v instanceof $7c9f67bc53be8927$export$eadfa7aed248243e) return $7c9f67bc53be8927$var$map(function(n) {
            return n + 1 | 0;
        })($7c9f67bc53be8927$var$append1(allHeights(v.value0))($7c9f67bc53be8927$var$append1(allHeights(v.value3))(allHeights(v.value6))));
        throw new Error("Failed pattern match at Data.Map.Internal (line 229, column 3 - line 229, column 36): " + [
            v.constructor.name
        ]);
    };
    return $5krR0.length($7c9f67bc53be8927$var$nub(allHeights(tree))) === 1;
};
var $7c9f67bc53be8927$export$986c2bbe7a34be0b = function(dictOrd) {
    return $7c9f67bc53be8927$export$e70771d2e7e590a(dictOrd)($7c9f67bc53be8927$var$identity);
};
var $7c9f67bc53be8927$export$8952a3dc6f3cd264 = function(dictOrd) {
    return {
        apply: $7c9f67bc53be8927$export$a6c74cde0675b326(dictOrd)($7c9f67bc53be8927$var$identity),
        Functor0: function() {
            return $7c9f67bc53be8927$export$3930f636962ed944;
        }
    };
};
var $7c9f67bc53be8927$export$886591aa0ffe34d5 = function(dictOrd) {
    var mapMaybeWithKey1 = $7c9f67bc53be8927$export$6be5ce76a5140a15(dictOrd);
    var lookup1 = $7c9f67bc53be8927$export$dfc7155ac0343b8(dictOrd);
    var applyMap1 = $7c9f67bc53be8927$export$8952a3dc6f3cd264(dictOrd);
    return {
        bind: function(m) {
            return function(f) {
                return mapMaybeWithKey1(function(k) {
                    var $932 = lookup1(k);
                    return function($933) {
                        return $932(f($933));
                    };
                })(m);
            };
        },
        Apply0: function() {
            return applyMap1;
        }
    };
};
var $7c9f67bc53be8927$export$22a7378e1d3307a4 = function(dictOrd) {
    var lookup1 = $7c9f67bc53be8927$export$dfc7155ac0343b8(dictOrd);
    var delete1 = $7c9f67bc53be8927$export$1822828d790e23ee(dictOrd);
    var insert1 = $7c9f67bc53be8927$export$21a5ca8aa77d35ff(dictOrd);
    return function(f) {
        return function(k) {
            return function(m) {
                var v = f(lookup1(k)(m));
                if (v instanceof $h2xUu.Nothing) return delete1(k)(m);
                if (v instanceof $h2xUu.Just) return insert1(k)(v.value0)(m);
                throw new Error("Failed pattern match at Data.Map.Internal (line 596, column 15 - line 598, column 25): " + [
                    v.constructor.name
                ]);
            };
        };
    };
};
var $7c9f67bc53be8927$export$690be49d504fc7f = function(dictOrd) {
    var alter1 = $7c9f67bc53be8927$export$22a7378e1d3307a4(dictOrd);
    return function(dictFoldable) {
        var foldl1 = $dNwPt.foldl(dictFoldable);
        return function(f) {
            var combine = function(v) {
                return function(v1) {
                    if (v1 instanceof $h2xUu.Just) return new $h2xUu.Just(f(v)(v1.value0));
                    if (v1 instanceof $h2xUu.Nothing) return new $h2xUu.Just(v);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 613, column 3 - line 613, column 38): " + [
                        v.constructor.name,
                        v1.constructor.name
                    ]);
                };
            };
            return foldl1(function(m) {
                return function(v) {
                    return alter1(combine(v.value1))(v.value0)(m);
                };
            })($7c9f67bc53be8927$export$6e22c362a0406a2c);
        };
    };
};
var $7c9f67bc53be8927$export$435aa68287e449bf = function(dictOrd) {
    var alter1 = $7c9f67bc53be8927$export$22a7378e1d3307a4(dictOrd);
    return function(f) {
        return function(k) {
            return function(v) {
                return alter1(function() {
                    var $934 = $h2xUu.maybe(v)($jhsiw.flip(f)(v));
                    return function($935) {
                        return $h2xUu.Just.create($934($935));
                    };
                }())(k);
            };
        };
    };
};
var $7c9f67bc53be8927$export$ed1b4f34a0e8b0cc = function(dictOrd) {
    var alter1 = $7c9f67bc53be8927$export$22a7378e1d3307a4(dictOrd);
    return function(f) {
        return function(m1) {
            return function(m2) {
                var go = function(k) {
                    return function(m) {
                        return function(v) {
                            return alter1(function() {
                                var $936 = $h2xUu.maybe(v)(f(v));
                                return function($937) {
                                    return $h2xUu.Just.create($936($937));
                                };
                            }())(k)(m);
                        };
                    };
                };
                return $7c9f67bc53be8927$var$foldlWithIndex(go)(m2)(m1);
            };
        };
    };
};
var $7c9f67bc53be8927$export$12ebb66e272c23f3 = function() {
    return function(dictOrd) {
        var unionWith1 = $7c9f67bc53be8927$export$ed1b4f34a0e8b0cc(dictOrd);
        return function(dictSemigroup) {
            var append2 = $d5vvq.append(dictSemigroup);
            return {
                append: function(l) {
                    return function(r) {
                        return unionWith1(append2)(l)(r);
                    };
                }
            };
        };
    };
};
var $7c9f67bc53be8927$var$semigroupMap1 = /* #__PURE__ */ $7c9f67bc53be8927$export$12ebb66e272c23f3();
var $7c9f67bc53be8927$export$546d2468bc9efbc6 = function() {
    return function(dictOrd) {
        var semigroupMap2 = $7c9f67bc53be8927$var$semigroupMap1(dictOrd);
        return function(dictSemigroup) {
            var semigroupMap3 = semigroupMap2(dictSemigroup);
            return {
                mempty: $7c9f67bc53be8927$export$6e22c362a0406a2c,
                Semigroup0: function() {
                    return semigroupMap3;
                }
            };
        };
    };
};
var $7c9f67bc53be8927$export$971dd5b0dfd021b6 = function(dictOrd) {
    return $7c9f67bc53be8927$export$ed1b4f34a0e8b0cc(dictOrd)($jhsiw.const);
};
var $7c9f67bc53be8927$export$d6b4f308683e59db = function(dictOrd) {
    var foldSubmapBy1 = $7c9f67bc53be8927$var$foldSubmapBy(dictOrd);
    var union1 = $7c9f67bc53be8927$export$971dd5b0dfd021b6(dictOrd);
    return function(kmin) {
        return function(kmax) {
            return foldSubmapBy1(union1)($7c9f67bc53be8927$export$6e22c362a0406a2c)(kmin)(kmax)($7c9f67bc53be8927$export$439306a4dcaafbb9);
        };
    };
};
var $7c9f67bc53be8927$export$30b2db2f7030f6cf = function(dictOrd) {
    var union1 = $7c9f67bc53be8927$export$971dd5b0dfd021b6(dictOrd);
    return function(dictFoldable) {
        return $dNwPt.foldl(dictFoldable)(union1)($7c9f67bc53be8927$export$6e22c362a0406a2c);
    };
};
var $7c9f67bc53be8927$export$722fbec263ad908a = function(dictOrd) {
    var alter1 = $7c9f67bc53be8927$export$22a7378e1d3307a4(dictOrd);
    return function(f) {
        return function(k) {
            return function(m) {
                return alter1($h2xUu.maybe($h2xUu.Nothing.value)(f))(k)(m);
            };
        };
    };
};
var $7c9f67bc53be8927$export$9030392ec4d635ff = function(dictOrd) {
    return {
        alt: $7c9f67bc53be8927$export$971dd5b0dfd021b6(dictOrd),
        Functor0: function() {
            return $7c9f67bc53be8927$export$3930f636962ed944;
        }
    };
};
var $7c9f67bc53be8927$export$4c085c510196daa3 = function(dictOrd) {
    var altMap1 = $7c9f67bc53be8927$export$9030392ec4d635ff(dictOrd);
    return {
        empty: $7c9f67bc53be8927$export$6e22c362a0406a2c,
        Alt0: function() {
            return altMap1;
        }
    };
};

});
parcelRegister("6j2dz", function(module, exports) {

$parcel$export(module.exports, "filter", () => $49763cd834e0c6bd$export$3dea766d36a8935f);
// Generated by purs version 0.15.16

var $56VjJ = parcelRequire("56VjJ");

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $26SV5 = parcelRequire("26SV5");

var $dxuBz = parcelRequire("dxuBz");

var $bcJ05 = parcelRequire("bcJ05");

var $iQTlW = parcelRequire("iQTlW");

var $aJhEx = parcelRequire("aJhEx");

var $dNwPt = parcelRequire("dNwPt");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $IhyKA = parcelRequire("IhyKA");

var $3gIn7 = parcelRequire("3gIn7");
var $hQCDc = parcelRequire("hQCDc");

var $RL9Ix = parcelRequire("RL9Ix");

var $3g1lG = parcelRequire("3g1lG");

var $h2xUu = parcelRequire("h2xUu");

var $46y1S = parcelRequire("46y1S");

var $9aSRU = parcelRequire("9aSRU");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $d5vvq = parcelRequire("d5vvq");

var $2XxiF = parcelRequire("2XxiF");

var $9OOYG = parcelRequire("9OOYG");

var $7O0Q4 = parcelRequire("7O0Q4");

var $goKHx = parcelRequire("goKHx");
var $49763cd834e0c6bd$var$apply = /* #__PURE__ */ $26ZCq.apply($3gIn7.applyLazy);
var $49763cd834e0c6bd$var$map = /* #__PURE__ */ $7FzSN.map($3gIn7.functorLazy);
var $49763cd834e0c6bd$var$unwrap = /* #__PURE__ */ $46y1S.unwrap();
var $49763cd834e0c6bd$var$sequence = /* #__PURE__ */ $9OOYG.sequence($3g1lG.traversableList);
var $49763cd834e0c6bd$var$foldr = /* #__PURE__ */ $dNwPt.foldr($3g1lG.foldableList);
var $49763cd834e0c6bd$var$map1 = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $49763cd834e0c6bd$var$tailRecM2 = /* #__PURE__ */ $bcJ05.tailRecM2($bcJ05.monadRecMaybe);
var $49763cd834e0c6bd$var$defer = /* #__PURE__ */ $dxuBz.defer($3g1lG.lazyList);
var $49763cd834e0c6bd$var$foldl = /* #__PURE__ */ $dNwPt.foldl($3g1lG.foldableList);
var $49763cd834e0c6bd$var$fix = /* #__PURE__ */ $dxuBz.fix($3g1lG.lazyList);
var $49763cd834e0c6bd$var$unfoldr = /* #__PURE__ */ $goKHx.unfoldr($3g1lG.unfoldableList);
var $49763cd834e0c6bd$var$map2 = /* #__PURE__ */ $7FzSN.map($3g1lG.functorList);
var $49763cd834e0c6bd$var$bind = /* #__PURE__ */ $cADnC.bind($h2xUu.bindMaybe);
var $49763cd834e0c6bd$var$pure = /* #__PURE__ */ $bQdkN.pure($h2xUu.applicativeMaybe);
var $49763cd834e0c6bd$var$any = /* #__PURE__ */ $dNwPt.any($3g1lG.foldableList)($IhyKA.heytingAlgebraBoolean);
var $49763cd834e0c6bd$var$append1 = /* #__PURE__ */ $d5vvq.append($3g1lG.semigroupList);
var $49763cd834e0c6bd$var$bind1 = /* #__PURE__ */ $cADnC.bind($3g1lG.bindList);
var $49763cd834e0c6bd$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $49763cd834e0c6bd$export$47606a6ae3eaed8e = function(x) {
    return x;
};
var $49763cd834e0c6bd$export$b634740ce272acb5 = function(f) {
    return function(xs) {
        return function(ys) {
            var go = function(v) {
                return function(v1) {
                    if (v instanceof $3g1lG.Nil) return $3g1lG.Nil.value;
                    if (v1 instanceof $3g1lG.Nil) return $3g1lG.Nil.value;
                    if (v instanceof $3g1lG.Cons && v1 instanceof $3g1lG.Cons) return new $3g1lG.Cons(f(v.value0)(v1.value0), $49763cd834e0c6bd$export$b634740ce272acb5(f)(v.value1)(v1.value1));
                    throw new Error("Failed pattern match at Data.List.Lazy (line 705, column 3 - line 705, column 35): " + [
                        v.constructor.name,
                        v1.constructor.name
                    ]);
                };
            };
            return $49763cd834e0c6bd$var$apply($49763cd834e0c6bd$var$map(go)($49763cd834e0c6bd$var$unwrap(xs)))($49763cd834e0c6bd$var$unwrap(ys));
        };
    };
};
var $49763cd834e0c6bd$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var sequence1 = $49763cd834e0c6bd$var$sequence(dictApplicative);
    return function(f) {
        return function(xs) {
            return function(ys) {
                return sequence1($49763cd834e0c6bd$export$b634740ce272acb5(f)(xs)(ys));
            };
        };
    };
};
var $49763cd834e0c6bd$export$8901015135f2fb22 = /* #__PURE__ */ function() {
    return $49763cd834e0c6bd$export$b634740ce272acb5($7O0Q4.Tuple.create);
}();
var $49763cd834e0c6bd$export$b6d8713d53419d4c = function(n) {
    return function(x) {
        return function(xs) {
            var go = function(v) {
                return function(v1) {
                    if (v1 instanceof $3g1lG.Nil) return $3g1lG.Nil.value;
                    if (v === 0 && v1 instanceof $3g1lG.Cons) return new $3g1lG.Cons(x, v1.value1);
                    if (v1 instanceof $3g1lG.Cons) return new $3g1lG.Cons(v1.value0, $49763cd834e0c6bd$export$b6d8713d53419d4c(v - 1 | 0)(x)(v1.value1));
                    throw new Error("Failed pattern match at Data.List.Lazy (line 361, column 3 - line 361, column 17): " + [
                        v.constructor.name,
                        v1.constructor.name
                    ]);
                };
            };
            return $49763cd834e0c6bd$var$map(go(n))($49763cd834e0c6bd$var$unwrap(xs));
        };
    };
};
var $49763cd834e0c6bd$export$23c8d3f8757cab88 = /* #__PURE__ */ function() {
    return $49763cd834e0c6bd$var$foldr(function(v) {
        return function(v1) {
            return new $7O0Q4.Tuple($3g1lG.cons(v.value0)(v1.value0), $3g1lG.cons(v.value1)(v1.value1));
        };
    })(new $7O0Q4.Tuple($3g1lG.nil, $3g1lG.nil));
}();
var $49763cd834e0c6bd$export$b446f6baa3bb1430 = function(xs) {
    var v = $3g1lG.step(xs);
    if (v instanceof $3g1lG.Nil) return $h2xUu.Nothing.value;
    if (v instanceof $3g1lG.Cons) return new $h2xUu.Just({
        head: v.value0,
        tail: v.value1
    });
    throw new Error("Failed pattern match at Data.List.Lazy (line 288, column 13 - line 290, column 44): " + [
        v.constructor.name
    ]);
};
var $49763cd834e0c6bd$export$823be24f8766da23 = function(dictUnfoldable) {
    return $goKHx.unfoldr(dictUnfoldable)(function(xs) {
        return $49763cd834e0c6bd$var$map1(function(rec) {
            return new $7O0Q4.Tuple(rec.head, rec.tail);
        })($49763cd834e0c6bd$export$b446f6baa3bb1430(xs));
    });
};
var $49763cd834e0c6bd$export$9384c7afe4015e42 = function(p) {
    var go = function(v) {
        if (v instanceof $3g1lG.Cons && p(v.value0)) return new $3g1lG.Cons(v.value0, $49763cd834e0c6bd$export$9384c7afe4015e42(p)(v.value1));
        return $3g1lG.Nil.value;
    };
    var $331 = $49763cd834e0c6bd$var$map(go);
    return function($332) {
        return $3g1lG.List($331($49763cd834e0c6bd$var$unwrap($332)));
    };
};
var $49763cd834e0c6bd$export$b7df5d561049483a = function(n) {
    var go = function(v) {
        return function(v1) {
            if (v1 instanceof $3g1lG.Nil) return $3g1lG.Nil.value;
            if (v1 instanceof $3g1lG.Cons) return new $3g1lG.Cons(v1.value0, $49763cd834e0c6bd$export$b7df5d561049483a(v - 1 | 0)(v1.value1));
            throw new Error("Failed pattern match at Data.List.Lazy (line 505, column 3 - line 505, column 32): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
    var $202 = n <= 0;
    if ($202) return $jhsiw.const($3g1lG.nil);
    var $333 = $49763cd834e0c6bd$var$map(go(n));
    return function($334) {
        return $3g1lG.List($333($49763cd834e0c6bd$var$unwrap($334)));
    };
};
var $49763cd834e0c6bd$export$c01875f616615628 = function(xs) {
    return $49763cd834e0c6bd$var$map1(function(v) {
        return v.tail;
    })($49763cd834e0c6bd$export$b446f6baa3bb1430(xs));
};
var $49763cd834e0c6bd$export$71c2a1babd78d286 = function(dictEq) {
    var eq = $aJhEx.eq(dictEq);
    return function(v) {
        return function(s) {
            var go = function(prefix) {
                return function(input) {
                    var v1 = $3g1lG.step(prefix);
                    if (v1 instanceof $3g1lG.Nil) return new $h2xUu.Just(new $bcJ05.Done(input));
                    if (v1 instanceof $3g1lG.Cons) {
                        var v2 = $3g1lG.step(input);
                        if (v2 instanceof $3g1lG.Cons && eq(v1.value0)(v2.value0)) return new $h2xUu.Just(new $bcJ05.Loop({
                            a: v1.value1,
                            b: v2.value1
                        }));
                        return $h2xUu.Nothing.value;
                    }
                    throw new Error("Failed pattern match at Data.List.Lazy (line 487, column 21 - line 491, column 19): " + [
                        v1.constructor.name
                    ]);
                };
            };
            return $49763cd834e0c6bd$var$tailRecM2(go)(v)(s);
        };
    };
};
var $49763cd834e0c6bd$export$afc1bfabebaf28a2 = function(p) {
    return function(xs) {
        var v = $49763cd834e0c6bd$export$b446f6baa3bb1430(xs);
        if (v instanceof $h2xUu.Just && p(v.value0.head)) {
            var v1 = $49763cd834e0c6bd$export$afc1bfabebaf28a2(p)(v.value0.tail);
            return {
                init: $3g1lG.cons(v.value0.head)(v1.init),
                rest: v1.rest
            };
        }
        return {
            init: $3g1lG.nil,
            rest: xs
        };
    };
};
var $49763cd834e0c6bd$export$c40cf5aab899f397 = function(xs) {
    return function(x) {
        return $49763cd834e0c6bd$var$foldr($3g1lG.cons)($3g1lG.cons(x)($3g1lG.nil))(xs);
    };
};
var $49763cd834e0c6bd$export$439306a4dcaafbb9 = function(a) {
    return $3g1lG.cons(a)($3g1lG.nil);
};
var $49763cd834e0c6bd$export$b5c655b9d1f9203e = function(dictShow) {
    var show = $2XxiF.show($3g1lG.showList(dictShow));
    return {
        show: function(v) {
            return "(Pattern " + (show(v) + ")");
        }
    };
};
var $49763cd834e0c6bd$export$951e420fdeef37cd = function(f) {
    return function(acc) {
        return function(xs) {
            var go = function(v) {
                if (v instanceof $3g1lG.Nil) return $3g1lG.Nil.value;
                if (v instanceof $3g1lG.Cons) {
                    var acc$prime = f(acc)(v.value0);
                    return new $3g1lG.Cons(acc$prime, $49763cd834e0c6bd$export$951e420fdeef37cd(f)(acc$prime)(v.value1));
                }
                throw new Error("Failed pattern match at Data.List.Lazy (line 776, column 5 - line 776, column 27): " + [
                    v.constructor.name
                ]);
            };
            return $49763cd834e0c6bd$var$map(go)($49763cd834e0c6bd$var$unwrap(xs));
        };
    };
};
var $49763cd834e0c6bd$export$66c1ae025e96b4bc = function(xs) {
    return $49763cd834e0c6bd$var$defer(function(v) {
        return $49763cd834e0c6bd$var$foldl($jhsiw.flip($3g1lG.cons))($3g1lG.nil)(xs);
    });
};
var $49763cd834e0c6bd$export$f1fa93b59bdd728d = function(dictMonad) {
    var pure1 = $bQdkN.pure(dictMonad.Applicative0());
    var bind2 = $cADnC.bind(dictMonad.Bind1());
    return function(n) {
        return function(m) {
            if (n < 1) return pure1($3g1lG.nil);
            if ($iQTlW.otherwise) return bind2(m)(function(a) {
                return bind2($49763cd834e0c6bd$export$f1fa93b59bdd728d(dictMonad)(n - 1 | 0)(m))(function(as) {
                    return pure1($3g1lG.cons(a)(as));
                });
            });
            throw new Error("Failed pattern match at Data.List.Lazy (line 164, column 1 - line 164, column 62): " + [
                n.constructor.name,
                m.constructor.name
            ]);
        };
    };
};
var $49763cd834e0c6bd$export$76d90c956114f2c2 = function(x) {
    return $49763cd834e0c6bd$var$fix(function(xs) {
        return $3g1lG.cons(x)(xs);
    });
};
var $49763cd834e0c6bd$export$606959e7ccb797f0 = function(i) {
    return function(xs) {
        return $49763cd834e0c6bd$export$b7df5d561049483a(i)($49763cd834e0c6bd$export$76d90c956114f2c2(xs));
    };
};
var $49763cd834e0c6bd$export$d02631cccf789723 = function(start) {
    return function(end) {
        if (start > end) {
            var g = function(x) {
                if (x >= end) return new $h2xUu.Just(new $7O0Q4.Tuple(x, x - 1 | 0));
                if ($iQTlW.otherwise) return $h2xUu.Nothing.value;
                throw new Error("Failed pattern match at Data.List.Lazy (line 151, column 13 - line 152, column 38): " + [
                    x.constructor.name
                ]);
            };
            return $49763cd834e0c6bd$var$unfoldr(g)(start);
        }
        if ($iQTlW.otherwise) {
            var f = function(x) {
                if (x <= end) return new $h2xUu.Just(new $7O0Q4.Tuple(x, x + 1 | 0));
                if ($iQTlW.otherwise) return $h2xUu.Nothing.value;
                throw new Error("Failed pattern match at Data.List.Lazy (line 156, column 5 - line 157, column 30): " + [
                    x.constructor.name
                ]);
            };
            return $49763cd834e0c6bd$var$unfoldr(f)(start);
        }
        throw new Error("Failed pattern match at Data.List.Lazy (line 148, column 1 - line 148, column 32): " + [
            start.constructor.name,
            end.constructor.name
        ]);
    };
};
var $49763cd834e0c6bd$export$b29f828819edca8d = function(f) {
    var go = function(x) {
        return function(v) {
            var $230 = f(x);
            if ($230) return {
                yes: $3g1lG.cons(x)(v.yes),
                no: v.no
            };
            return {
                yes: v.yes,
                no: $3g1lG.cons(x)(v.no)
            };
        };
    };
    return $49763cd834e0c6bd$var$foldr(go)({
        yes: $3g1lG.nil,
        no: $3g1lG.nil
    });
};
var $49763cd834e0c6bd$export$7b1b591b262c240 = function($335) {
    return $h2xUu.isNothing($49763cd834e0c6bd$export$b446f6baa3bb1430($335));
};
var $49763cd834e0c6bd$export$18f77a3bafa759b9 = function(p) {
    var goStep = function(v) {
        return function(v1) {
            if (v1 instanceof $3g1lG.Nil) return $3g1lG.Nil.value;
            if (v1 instanceof $3g1lG.Cons) {
                var v2 = $RL9Ix.insertAndLookupBy(p)(v1.value0)(v);
                if (v2.found) return $3g1lG.step(go(v2.result)(v1.value1));
                return new $3g1lG.Cons(v1.value0, go(v2.result)(v1.value1));
            }
            throw new Error("Failed pattern match at Data.List.Lazy (line 613, column 5 - line 613, column 23): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
    var go = function(s) {
        return function(v) {
            return $49763cd834e0c6bd$var$map(goStep(s))(v);
        };
    };
    return go($RL9Ix.emptySet);
};
var $49763cd834e0c6bd$export$94f4066a75b10404 = function(dictOrd) {
    return $49763cd834e0c6bd$export$18f77a3bafa759b9($gwBF5.compare(dictOrd));
};
var $49763cd834e0c6bd$export$86c9b635481112b7 = {
    Coercible0: function() {
        return undefined;
    }
};
var $49763cd834e0c6bd$export$e70771d2e7e590a = function(f) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $3g1lG.Nil) {
                $tco_done = true;
                return $3g1lG.Nil.value;
            }
            if (v instanceof $3g1lG.Cons) {
                var v1 = f(v.value0);
                if (v1 instanceof $h2xUu.Nothing) {
                    $copy_v = $3g1lG.step(v.value1);
                    return;
                }
                if (v1 instanceof $h2xUu.Just) {
                    $tco_done = true;
                    return new $3g1lG.Cons(v1.value0, $49763cd834e0c6bd$export$e70771d2e7e590a(f)(v.value1));
                }
                throw new Error("Failed pattern match at Data.List.Lazy (line 448, column 5 - line 450, column 39): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.List.Lazy (line 446, column 3 - line 446, column 15): " + [
                v.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    var $336 = $49763cd834e0c6bd$var$map(go);
    return function($337) {
        return $3g1lG.List($336($49763cd834e0c6bd$var$unwrap($337)));
    };
};
var $49763cd834e0c6bd$export$ad14ef4001db2bcd = function(dictAlternative) {
    var apply1 = $26ZCq.apply(dictAlternative.Applicative0().Apply0());
    var map3 = $7FzSN.map(dictAlternative.Plus1().Alt0().Functor0());
    return function(dictLazy) {
        var defer1 = $dxuBz.defer(dictLazy);
        return function(v) {
            return apply1(map3($3g1lG.cons)(v))(defer1(function(v1) {
                return $49763cd834e0c6bd$export$14badfee79ea396f(dictAlternative)(dictLazy)(v);
            }));
        };
    };
};
var $49763cd834e0c6bd$export$14badfee79ea396f = function(dictAlternative) {
    var alt = $56VjJ.alt(dictAlternative.Plus1().Alt0());
    var pure1 = $bQdkN.pure(dictAlternative.Applicative0());
    return function(dictLazy) {
        return function(v) {
            return alt($49763cd834e0c6bd$export$ad14ef4001db2bcd(dictAlternative)(dictLazy)(v))(pure1($3g1lG.nil));
        };
    };
};
var $49763cd834e0c6bd$export$f24224f1c91d8156 = /* #__PURE__ */ $49763cd834e0c6bd$var$foldl(function(l) {
    return function(v) {
        return l + 1 | 0;
    };
})(0);
var $49763cd834e0c6bd$export$4c7897fafd92b108 = /* #__PURE__ */ function() {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $3g1lG.Cons) {
                if ($49763cd834e0c6bd$export$7b1b591b262c240(v.value1)) {
                    $tco_done = true;
                    return new $h2xUu.Just(v.value0);
                }
                if ($iQTlW.otherwise) {
                    $copy_v = $3g1lG.step(v.value1);
                    return;
                }
            }
            $tco_done = true;
            return $h2xUu.Nothing.value;
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return function($338) {
        return go($3g1lG.step($338));
    };
}();
var $49763cd834e0c6bd$export$c1a059043cc9c119 = function(f) {
    return function(x) {
        return $49763cd834e0c6bd$var$fix(function(xs) {
            return $3g1lG.cons(x)($49763cd834e0c6bd$var$map2(f)(xs));
        });
    };
};
var $49763cd834e0c6bd$export$9f200c4466975173 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0) return $3g1lG.cons(v1)(v2);
            var go = function(v3) {
                if (v3 instanceof $3g1lG.Nil) return new $3g1lG.Cons(v1, $3g1lG.nil);
                if (v3 instanceof $3g1lG.Cons) return new $3g1lG.Cons(v3.value0, $49763cd834e0c6bd$export$9f200c4466975173(v - 1 | 0)(v1)(v3.value1));
                throw new Error("Failed pattern match at Data.List.Lazy (line 340, column 3 - line 340, column 22): " + [
                    v3.constructor.name
                ]);
            };
            return $49763cd834e0c6bd$var$map(go)($49763cd834e0c6bd$var$unwrap(v2));
        };
    };
};
var $49763cd834e0c6bd$export$2cd8252107eb640b = /* #__PURE__ */ function() {
    var go = function(v) {
        if (v instanceof $3g1lG.Cons) {
            if ($49763cd834e0c6bd$export$7b1b591b262c240(v.value1)) return new $h2xUu.Just($3g1lG.nil);
            if ($iQTlW.otherwise) return $49763cd834e0c6bd$var$map1($3g1lG.cons(v.value0))(go($3g1lG.step(v.value1)));
        }
        return $h2xUu.Nothing.value;
    };
    return function($339) {
        return go($3g1lG.step($339));
    };
}();
var $49763cd834e0c6bd$export$b610b8812bbcded9 = function(xs) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v instanceof $3g1lG.Nil) {
                    $tco_done = true;
                    return $h2xUu.Nothing.value;
                }
                if (v instanceof $3g1lG.Cons && v1 === 0) {
                    $tco_done = true;
                    return new $h2xUu.Just(v.value0);
                }
                if (v instanceof $3g1lG.Cons) {
                    $tco_var_v = $3g1lG.step(v.value1);
                    $copy_v1 = v1 - 1 | 0;
                    return;
                }
                throw new Error("Failed pattern match at Data.List.Lazy (line 302, column 3 - line 302, column 21): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($3g1lG.step(xs));
};
var $49763cd834e0c6bd$export$5fd5031fecdacec3 = function(xs) {
    return $49763cd834e0c6bd$var$map1(function(v) {
        return v.head;
    })($49763cd834e0c6bd$export$b446f6baa3bb1430(xs));
};
var $49763cd834e0c6bd$export$9cb09a71b7d66923 = function(xs) {
    var v = $49763cd834e0c6bd$export$b446f6baa3bb1430(xs);
    if (v instanceof $h2xUu.Nothing) return xs;
    if (v instanceof $h2xUu.Just) {
        var v1 = $49763cd834e0c6bd$export$b446f6baa3bb1430(v.value0.head);
        if (v1 instanceof $h2xUu.Nothing) return $49763cd834e0c6bd$export$9cb09a71b7d66923(v.value0.tail);
        if (v1 instanceof $h2xUu.Just) return $3g1lG.cons($3g1lG.cons(v1.value0.head)($49763cd834e0c6bd$export$e70771d2e7e590a($49763cd834e0c6bd$export$5fd5031fecdacec3)(v.value0.tail)))($49763cd834e0c6bd$export$9cb09a71b7d66923($3g1lG.cons(v1.value0.tail)($49763cd834e0c6bd$export$e70771d2e7e590a($49763cd834e0c6bd$export$c01875f616615628)(v.value0.tail))));
        throw new Error("Failed pattern match at Data.List.Lazy (line 746, column 7 - line 750, column 72): " + [
            v1.constructor.name
        ]);
    }
    throw new Error("Failed pattern match at Data.List.Lazy (line 742, column 3 - line 750, column 72): " + [
        v.constructor.name
    ]);
};
var $49763cd834e0c6bd$export$3f063810d7bf01bd = function(eq) {
    var go = function(v) {
        if (v instanceof $3g1lG.Nil) return $3g1lG.Nil.value;
        if (v instanceof $3g1lG.Cons) {
            var v1 = $49763cd834e0c6bd$export$afc1bfabebaf28a2(eq(v.value0))(v.value1);
            return new $3g1lG.Cons($hQCDc.defer(function(v2) {
                return new $9aSRU.NonEmpty(v.value0, v1.init);
            }), $49763cd834e0c6bd$export$3f063810d7bf01bd(eq)(v1.rest));
        }
        throw new Error("Failed pattern match at Data.List.Lazy (line 576, column 3 - line 576, column 15): " + [
            v.constructor.name
        ]);
    };
    var $340 = $49763cd834e0c6bd$var$map(go);
    return function($341) {
        return $3g1lG.List($340($49763cd834e0c6bd$var$unwrap($341)));
    };
};
var $49763cd834e0c6bd$export$e5e25fbcc1f7affe = function(dictEq) {
    return $49763cd834e0c6bd$export$3f063810d7bf01bd($aJhEx.eq(dictEq));
};
var $49763cd834e0c6bd$var$fromStep = /* #__PURE__ */ function() {
    var $342 = $bQdkN.pure($3gIn7.applicativeLazy);
    return function($343) {
        return $3g1lG.List($342($343));
    };
}();
var $49763cd834e0c6bd$export$b8bc901090d2b1d4 = function(cmp) {
    return function(x) {
        return function(xs) {
            var go = function(v) {
                if (v instanceof $3g1lG.Nil) return new $3g1lG.Cons(x, $3g1lG.nil);
                if (v instanceof $3g1lG.Cons) {
                    var v1 = cmp(x)(v.value0);
                    if (v1 instanceof $ibsD5.GT) return new $3g1lG.Cons(v.value0, $49763cd834e0c6bd$export$b8bc901090d2b1d4(cmp)(x)(v.value1));
                    return new $3g1lG.Cons(x, $49763cd834e0c6bd$var$fromStep(v));
                }
                throw new Error("Failed pattern match at Data.List.Lazy (line 238, column 3 - line 238, column 22): " + [
                    v.constructor.name
                ]);
            };
            return $49763cd834e0c6bd$var$map(go)($49763cd834e0c6bd$var$unwrap(xs));
        };
    };
};
var $49763cd834e0c6bd$export$21a5ca8aa77d35ff = function(dictOrd) {
    return $49763cd834e0c6bd$export$b8bc901090d2b1d4($gwBF5.compare(dictOrd));
};
var $49763cd834e0c6bd$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    return $dNwPt.foldr(dictFoldable)($3g1lG.cons)($3g1lG.nil);
};
var $49763cd834e0c6bd$export$a6d4c5c719005a90 = function(dictLazy) {
    var defer1 = $dxuBz.defer(dictLazy);
    return function(op) {
        return function(z) {
            var go = function(xs) {
                var v = $3g1lG.step(xs);
                if (v instanceof $3g1lG.Cons) return defer1(function(v1) {
                    return op(v.value0)(go(v.value1));
                });
                if (v instanceof $3g1lG.Nil) return z;
                throw new Error("Failed pattern match at Data.List.Lazy (line 768, column 13 - line 770, column 15): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    };
};
var $49763cd834e0c6bd$export$7a067f9280ad8af0 = function(dictMonad) {
    var pure1 = $bQdkN.pure(dictMonad.Applicative0());
    var bind2 = $cADnC.bind(dictMonad.Bind1());
    return function(f) {
        return function(b) {
            return function(xs) {
                var v = $49763cd834e0c6bd$export$b446f6baa3bb1430(xs);
                if (v instanceof $h2xUu.Nothing) return pure1(b);
                if (v instanceof $h2xUu.Just) return bind2(f(b)(v.value0.head))(function(b$prime) {
                    return $49763cd834e0c6bd$export$7a067f9280ad8af0(dictMonad)(f)(b$prime)(v.value0.tail);
                });
                throw new Error("Failed pattern match at Data.List.Lazy (line 759, column 5 - line 762, column 54): " + [
                    v.constructor.name
                ]);
            };
        };
    };
};
var $49763cd834e0c6bd$export$de3a4d4a0d731119 = function(fn) {
    var go = function(n) {
        return function(list) {
            return $49763cd834e0c6bd$var$bind($49763cd834e0c6bd$export$b446f6baa3bb1430(list))(function(o) {
                var $291 = fn(o.head);
                if ($291) return $49763cd834e0c6bd$var$pure(n);
                return go(n + 1 | 0)(o.tail);
            });
        };
    };
    return go(0);
};
var $49763cd834e0c6bd$export$8855a8be7bd3e9f8 = function(fn) {
    return function(xs) {
        return $49763cd834e0c6bd$var$map1(function(v) {
            return ($49763cd834e0c6bd$export$f24224f1c91d8156(xs) - 1 | 0) - v | 0;
        })($49763cd834e0c6bd$export$de3a4d4a0d731119(fn)($49763cd834e0c6bd$export$66c1ae025e96b4bc(xs)));
    };
};
var $49763cd834e0c6bd$export$20098ecb074a31e6 = function(dictMonad) {
    var pure1 = $bQdkN.pure(dictMonad.Applicative0());
    var bind2 = $cADnC.bind(dictMonad.Bind1());
    return function(p) {
        return function(list) {
            var v = $49763cd834e0c6bd$export$b446f6baa3bb1430(list);
            if (v instanceof $h2xUu.Nothing) return pure1($3g1lG.nil);
            if (v instanceof $h2xUu.Just) return bind2(p(v.value0.head))(function(b) {
                return bind2($49763cd834e0c6bd$export$20098ecb074a31e6(dictMonad)(p)(v.value0.tail))(function(xs$prime) {
                    return pure1(function() {
                        if (b) return $3g1lG.cons(v.value0.head)(xs$prime);
                        return xs$prime;
                    }());
                });
            });
            throw new Error("Failed pattern match at Data.List.Lazy (line 431, column 5 - line 436, column 48): " + [
                v.constructor.name
            ]);
        };
    };
};
var $49763cd834e0c6bd$export$3dea766d36a8935f = function(p) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $3g1lG.Nil) {
                $tco_done = true;
                return $3g1lG.Nil.value;
            }
            if (v instanceof $3g1lG.Cons) {
                if (p(v.value0)) {
                    $tco_done = true;
                    return new $3g1lG.Cons(v.value0, $49763cd834e0c6bd$export$3dea766d36a8935f(p)(v.value1));
                }
                if ($iQTlW.otherwise) {
                    $copy_v = $3g1lG.step(v.value1);
                    return;
                }
            }
            throw new Error("Failed pattern match at Data.List.Lazy (line 416, column 3 - line 416, column 15): " + [
                v.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    var $344 = $49763cd834e0c6bd$var$map(go);
    return function($345) {
        return $3g1lG.List($344($49763cd834e0c6bd$var$unwrap($345)));
    };
};
var $49763cd834e0c6bd$export$f161f39e9c06ab2d = function(eq) {
    return function(xs) {
        return function(ys) {
            return $49763cd834e0c6bd$export$3dea766d36a8935f(function(x) {
                return $49763cd834e0c6bd$var$any(eq(x))(ys);
            })(xs);
        };
    };
};
var $49763cd834e0c6bd$export$1f4807a235930d45 = function(dictEq) {
    return $49763cd834e0c6bd$export$f161f39e9c06ab2d($aJhEx.eq(dictEq));
};
var $49763cd834e0c6bd$export$45273896c792ff3b = function(eq) {
    var go = function(v) {
        if (v instanceof $3g1lG.Nil) return $3g1lG.Nil.value;
        if (v instanceof $3g1lG.Cons) return new $3g1lG.Cons(v.value0, $49763cd834e0c6bd$export$45273896c792ff3b(eq)($49763cd834e0c6bd$export$3dea766d36a8935f(function(y) {
            return !eq(v.value0)(y);
        })(v.value1)));
        throw new Error("Failed pattern match at Data.List.Lazy (line 633, column 3 - line 633, column 15): " + [
            v.constructor.name
        ]);
    };
    var $346 = $49763cd834e0c6bd$var$map(go);
    return function($347) {
        return $3g1lG.List($346($49763cd834e0c6bd$var$unwrap($347)));
    };
};
var $49763cd834e0c6bd$export$edce5881c815871 = function(dictEq) {
    return $49763cd834e0c6bd$export$45273896c792ff3b($aJhEx.eq(dictEq));
};
var $49763cd834e0c6bd$export$3c57592525e2b27e = function(dictEq) {
    var eq = $aJhEx.eq($3g1lG.eqList(dictEq));
    return {
        eq: function(x) {
            return function(y) {
                return eq(x)(y);
            };
        }
    };
};
var $49763cd834e0c6bd$export$21c206d752eba296 = function(dictOrd) {
    var compare = $gwBF5.compare($3g1lG.ordList(dictOrd));
    var eqPattern1 = $49763cd834e0c6bd$export$3c57592525e2b27e(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                return compare(x)(y);
            };
        },
        Eq0: function() {
            return eqPattern1;
        }
    };
};
var $49763cd834e0c6bd$export$c19d79386f4ed99a = function(dictEq) {
    var eq = $aJhEx.eq(dictEq);
    return function(x) {
        return $49763cd834e0c6bd$export$8855a8be7bd3e9f8(function(v) {
            return eq(v)(x);
        });
    };
};
var $49763cd834e0c6bd$export$f444781b0adb7e4d = function(dictEq) {
    var eq = $aJhEx.eq(dictEq);
    return function(x) {
        return $49763cd834e0c6bd$export$de3a4d4a0d731119(function(v) {
            return eq(v)(x);
        });
    };
};
var $49763cd834e0c6bd$export$533af5c8cd6afa16 = function(p) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $3g1lG.Cons && p(v.value0)) {
                $copy_v = $3g1lG.step(v.value1);
                return;
            }
            $tco_done = true;
            return $49763cd834e0c6bd$var$fromStep(v);
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return function($348) {
        return go($3g1lG.step($348));
    };
};
var $49763cd834e0c6bd$export$663103110d94aac9 = function(n) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v === 0) {
                    $tco_done = true;
                    return v1;
                }
                if (v1 instanceof $3g1lG.Nil) {
                    $tco_done = true;
                    return $3g1lG.Nil.value;
                }
                if (v1 instanceof $3g1lG.Cons) {
                    $tco_var_v = v - 1 | 0;
                    $copy_v1 = $3g1lG.step(v1.value1);
                    return;
                }
                throw new Error("Failed pattern match at Data.List.Lazy (line 524, column 3 - line 524, column 15): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    var $349 = $49763cd834e0c6bd$var$map(go(n));
    return function($350) {
        return $3g1lG.List($349($49763cd834e0c6bd$var$unwrap($350)));
    };
};
var $49763cd834e0c6bd$export$58adb3bec8346d0f = function(start) {
    return function(end) {
        return function(xs) {
            return $49763cd834e0c6bd$export$b7df5d561049483a(end - start | 0)($49763cd834e0c6bd$export$663103110d94aac9(start)(xs));
        };
    };
};
var $49763cd834e0c6bd$export$9ea2b6c3fae093d8 = function(eq) {
    return function(x) {
        return function(xs) {
            var go = function(v) {
                if (v instanceof $3g1lG.Nil) return $3g1lG.Nil.value;
                if (v instanceof $3g1lG.Cons) {
                    if (eq(x)(v.value0)) return $3g1lG.step(v.value1);
                    if ($iQTlW.otherwise) return new $3g1lG.Cons(v.value0, $49763cd834e0c6bd$export$9ea2b6c3fae093d8(eq)(x)(v.value1));
                }
                throw new Error("Failed pattern match at Data.List.Lazy (line 662, column 3 - line 662, column 15): " + [
                    v.constructor.name
                ]);
            };
            return $49763cd834e0c6bd$var$map(go)($49763cd834e0c6bd$var$unwrap(xs));
        };
    };
};
var $49763cd834e0c6bd$export$ef1d06dc4d91d507 = function(eq) {
    return function(xs) {
        return function(ys) {
            return $49763cd834e0c6bd$var$append1(xs)($49763cd834e0c6bd$var$foldl($jhsiw.flip($49763cd834e0c6bd$export$9ea2b6c3fae093d8(eq)))($49763cd834e0c6bd$export$45273896c792ff3b(eq)(ys))(xs));
        };
    };
};
var $49763cd834e0c6bd$export$971dd5b0dfd021b6 = function(dictEq) {
    return $49763cd834e0c6bd$export$ef1d06dc4d91d507($aJhEx.eq(dictEq));
};
var $49763cd834e0c6bd$export$90f9093465da3136 = function(n) {
    return function(xs) {
        var go = function(v) {
            return function(v1) {
                if (v1 instanceof $3g1lG.Nil) return $3g1lG.Nil.value;
                if (v === 0 && v1 instanceof $3g1lG.Cons) return $3g1lG.step(v1.value1);
                if (v1 instanceof $3g1lG.Cons) return new $3g1lG.Cons(v1.value0, $49763cd834e0c6bd$export$90f9093465da3136(v - 1 | 0)(v1.value1));
                throw new Error("Failed pattern match at Data.List.Lazy (line 350, column 3 - line 350, column 17): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        return $49763cd834e0c6bd$var$map(go(n))($49763cd834e0c6bd$var$unwrap(xs));
    };
};
var $49763cd834e0c6bd$export$1822828d790e23ee = function(dictEq) {
    return $49763cd834e0c6bd$export$9ea2b6c3fae093d8($aJhEx.eq(dictEq));
};
var $49763cd834e0c6bd$export$acaf96a27438246b = function(dictEq) {
    return $49763cd834e0c6bd$var$foldl($jhsiw.flip($49763cd834e0c6bd$export$1822828d790e23ee(dictEq)));
};
var $49763cd834e0c6bd$export$c04a9f24a4230e1f = function(xs) {
    return $49763cd834e0c6bd$var$fix(function(ys) {
        return $49763cd834e0c6bd$var$append1(xs)(ys);
    });
};
var $49763cd834e0c6bd$export$c28c8388be0ab31a = /* #__PURE__ */ $jhsiw.flip($49763cd834e0c6bd$var$bind1);
var $49763cd834e0c6bd$export$ee1b3e54f0441b22 = function(v) {
    return $49763cd834e0c6bd$var$bind1(v)($49763cd834e0c6bd$var$identity);
};
var $49763cd834e0c6bd$export$986c2bbe7a34be0b = /* #__PURE__ */ $49763cd834e0c6bd$export$e70771d2e7e590a($49763cd834e0c6bd$var$identity);
var $49763cd834e0c6bd$export$2dd9d44f93be5e22 = function(n) {
    return function(f) {
        return function(xs) {
            var go = function(v) {
                return function(v1) {
                    if (v1 instanceof $3g1lG.Nil) return $3g1lG.Nil.value;
                    if (v === 0 && v1 instanceof $3g1lG.Cons) {
                        var v2 = f(v1.value0);
                        if (v2 instanceof $h2xUu.Nothing) return $3g1lG.step(v1.value1);
                        if (v2 instanceof $h2xUu.Just) return new $3g1lG.Cons(v2.value0, v1.value1);
                        throw new Error("Failed pattern match at Data.List.Lazy (line 382, column 22 - line 384, column 26): " + [
                            v2.constructor.name
                        ]);
                    }
                    if (v1 instanceof $3g1lG.Cons) return new $3g1lG.Cons(v1.value0, $49763cd834e0c6bd$export$2dd9d44f93be5e22(v - 1 | 0)(f)(v1.value1));
                    throw new Error("Failed pattern match at Data.List.Lazy (line 381, column 3 - line 381, column 17): " + [
                        v.constructor.name,
                        v1.constructor.name
                    ]);
                };
            };
            return $49763cd834e0c6bd$var$map(go(n))($49763cd834e0c6bd$var$unwrap(xs));
        };
    };
};
var $49763cd834e0c6bd$export$cba09f9e3d3e58eb = function(n) {
    return function(f) {
        return $49763cd834e0c6bd$export$2dd9d44f93be5e22(n)(function($351) {
            return $h2xUu.Just.create(f($351));
        });
    };
};

});
parcelRegister("3g1lG", function(module, exports) {

$parcel$export(module.exports, "List", () => $25f3e9876a698166$export$54c2e3dc7acea9f5);
$parcel$export(module.exports, "Nil", () => $25f3e9876a698166$export$c1bed610ade55e1c);
$parcel$export(module.exports, "Cons", () => $25f3e9876a698166$export$74c44e616647f5c0);
$parcel$export(module.exports, "nil", () => $25f3e9876a698166$export$f2c4f74e8fe88e34);
$parcel$export(module.exports, "step", () => $25f3e9876a698166$export$35d34bc0ed591a92);
$parcel$export(module.exports, "semigroupList", () => $25f3e9876a698166$export$11cb7909a85856b);
$parcel$export(module.exports, "lazyList", () => $25f3e9876a698166$export$b4de83846969a6e1);
$parcel$export(module.exports, "functorList", () => $25f3e9876a698166$export$40b9e4330ffd17e3);
$parcel$export(module.exports, "eqList", () => $25f3e9876a698166$export$1ae88a7f3c5f59ef);
$parcel$export(module.exports, "ordList", () => $25f3e9876a698166$export$86359cd4476084f8);
$parcel$export(module.exports, "cons", () => $25f3e9876a698166$export$8327ebbef2a0ba76);
$parcel$export(module.exports, "foldableList", () => $25f3e9876a698166$export$92659ee1fc91a075);
$parcel$export(module.exports, "showList", () => $25f3e9876a698166$export$36831384a74c4427);
$parcel$export(module.exports, "traversableList", () => $25f3e9876a698166$export$99c2ce29c0ead637);
$parcel$export(module.exports, "unfoldableList", () => $25f3e9876a698166$export$1d41caf0a0a6a680);
$parcel$export(module.exports, "bindList", () => $25f3e9876a698166$export$497dcf96eb2383ec);
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $26SV5 = parcelRequire("26SV5");

var $dxuBz = parcelRequire("dxuBz");

var $kkdfo = parcelRequire("kkdfo");

var $aJhEx = parcelRequire("aJhEx");

var $dNwPt = parcelRequire("dNwPt");

var $7vxKS = parcelRequire("7vxKS");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $lzCaM = parcelRequire("lzCaM");
parcelRequire("3gIn7");
var $hQCDc = parcelRequire("hQCDc");
var $3gIn7 = parcelRequire("3gIn7");

var $h2xUu = parcelRequire("h2xUu");

var $3aOYV = parcelRequire("3aOYV");

var $46y1S = parcelRequire("46y1S");

var $9aSRU = parcelRequire("9aSRU");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $d5vvq = parcelRequire("d5vvq");

var $iVjQa = parcelRequire("iVjQa");

var $2XxiF = parcelRequire("2XxiF");

var $9OOYG = parcelRequire("9OOYG");

var $bijFl = parcelRequire("bijFl");

var $7O0Q4 = parcelRequire("7O0Q4");

var $N3bwb = parcelRequire("N3bwb");
var $25f3e9876a698166$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $25f3e9876a698166$var$unwrap = /* #__PURE__ */ $46y1S.unwrap();
var $25f3e9876a698166$var$map = /* #__PURE__ */ $7FzSN.map($3gIn7.functorLazy);
var $25f3e9876a698166$var$eq1 = /* #__PURE__ */ $aJhEx.eq1($3gIn7.eq1Lazy);
var $25f3e9876a698166$var$compare1 = /* #__PURE__ */ $gwBF5.compare1($3gIn7.ord1Lazy);
var $25f3e9876a698166$var$add = /* #__PURE__ */ $iVjQa.add($iVjQa.semiringInt);
var $25f3e9876a698166$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $25f3e9876a698166$export$54c2e3dc7acea9f5 = function(x) {
    return x;
};
var $25f3e9876a698166$export$c1bed610ade55e1c = /* #__PURE__ */ function() {
    function Nil() {}
    Nil.value = new Nil();
    return Nil;
}();
var $25f3e9876a698166$export$74c44e616647f5c0 = /* #__PURE__ */ function() {
    function Cons(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Cons.create = function(value0) {
        return function(value1) {
            return new Cons(value0, value1);
        };
    };
    return Cons;
}();
var $25f3e9876a698166$export$ab241a3582569781 = function(x) {
    return x;
};
var $25f3e9876a698166$export$f2c4f74e8fe88e34 = /* #__PURE__ */ $hQCDc.defer(function(v) {
    return $25f3e9876a698166$export$c1bed610ade55e1c.value;
});
var $25f3e9876a698166$export$e1330f0deced5836 = {
    Coercible0: function() {
        return undefined;
    }
};
var $25f3e9876a698166$export$d7c6954d7d62822f = {
    Coercible0: function() {
        return undefined;
    }
};
var $25f3e9876a698166$export$35d34bc0ed591a92 = function($319) {
    return $hQCDc.force($25f3e9876a698166$var$unwrap($319));
};
var $25f3e9876a698166$export$11cb7909a85856b = {
    append: function(xs) {
        return function(ys) {
            var go = function(v) {
                if (v instanceof $25f3e9876a698166$export$c1bed610ade55e1c) return $25f3e9876a698166$export$35d34bc0ed591a92(ys);
                if (v instanceof $25f3e9876a698166$export$74c44e616647f5c0) return new $25f3e9876a698166$export$74c44e616647f5c0(v.value0, $d5vvq.append($25f3e9876a698166$export$11cb7909a85856b)(v.value1)(ys));
                throw new Error("Failed pattern match at Data.List.Lazy.Types (line 103, column 5 - line 103, column 21): " + [
                    v.constructor.name
                ]);
            };
            return $25f3e9876a698166$var$map(go)($25f3e9876a698166$var$unwrap(xs));
        };
    }
};
var $25f3e9876a698166$var$append1 = /* #__PURE__ */ $d5vvq.append($25f3e9876a698166$export$11cb7909a85856b);
var $25f3e9876a698166$export$14584e231e9c63ca = {
    mempty: $25f3e9876a698166$export$f2c4f74e8fe88e34,
    Semigroup0: function() {
        return $25f3e9876a698166$export$11cb7909a85856b;
    }
};
var $25f3e9876a698166$export$b4de83846969a6e1 = {
    defer: function(f) {
        return $hQCDc.defer(function($320) {
            return $25f3e9876a698166$export$35d34bc0ed591a92(f($320));
        });
    }
};
var $25f3e9876a698166$var$defer = /* #__PURE__ */ $dxuBz.defer($25f3e9876a698166$export$b4de83846969a6e1);
var $25f3e9876a698166$export$40b9e4330ffd17e3 = {
    map: function(f) {
        return function(xs) {
            var go = function(v) {
                if (v instanceof $25f3e9876a698166$export$c1bed610ade55e1c) return $25f3e9876a698166$export$c1bed610ade55e1c.value;
                if (v instanceof $25f3e9876a698166$export$74c44e616647f5c0) return new $25f3e9876a698166$export$74c44e616647f5c0(f(v.value0), $7FzSN.map($25f3e9876a698166$export$40b9e4330ffd17e3)(f)(v.value1));
                throw new Error("Failed pattern match at Data.List.Lazy.Types (line 112, column 5 - line 112, column 17): " + [
                    v.constructor.name
                ]);
            };
            return $25f3e9876a698166$var$map(go)($25f3e9876a698166$var$unwrap(xs));
        };
    }
};
var $25f3e9876a698166$var$map1 = /* #__PURE__ */ $7FzSN.map(/* #__PURE__ */ $9aSRU.functorNonEmpty($25f3e9876a698166$export$40b9e4330ffd17e3));
var $25f3e9876a698166$export$3c979cc7d75b024c = {
    map: function(f) {
        return function(v) {
            return $25f3e9876a698166$var$map($25f3e9876a698166$var$map1(f))(v);
        };
    }
};
var $25f3e9876a698166$export$b7e705972f3b8317 = {
    eq1: function(dictEq) {
        var eq = $aJhEx.eq(dictEq);
        return function(xs) {
            return function(ys) {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        var $tco_var_v = $copy_v;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1) {
                            if (v instanceof $25f3e9876a698166$export$c1bed610ade55e1c && v1 instanceof $25f3e9876a698166$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return true;
                            }
                            if (v instanceof $25f3e9876a698166$export$74c44e616647f5c0 && v1 instanceof $25f3e9876a698166$export$74c44e616647f5c0 && eq(v.value0)(v1.value0)) {
                                $tco_var_v = $25f3e9876a698166$export$35d34bc0ed591a92(v.value1);
                                $copy_v1 = $25f3e9876a698166$export$35d34bc0ed591a92(v1.value1);
                                return;
                            }
                            $tco_done = true;
                            return false;
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                        return $tco_result;
                    };
                };
                return go($25f3e9876a698166$export$35d34bc0ed591a92(xs))($25f3e9876a698166$export$35d34bc0ed591a92(ys));
            };
        };
    }
};
var $25f3e9876a698166$var$eqNonEmpty = /* #__PURE__ */ $9aSRU.eqNonEmpty($25f3e9876a698166$export$b7e705972f3b8317);
var $25f3e9876a698166$var$eq11 = /* #__PURE__ */ $aJhEx.eq1($25f3e9876a698166$export$b7e705972f3b8317);
var $25f3e9876a698166$export$80901a10e94c964a = {
    eq1: function(dictEq) {
        var eq12 = $25f3e9876a698166$var$eq1($25f3e9876a698166$var$eqNonEmpty(dictEq));
        return function(v) {
            return function(v1) {
                return eq12(v)(v1);
            };
        };
    }
};
var $25f3e9876a698166$export$1ae88a7f3c5f59ef = function(dictEq) {
    return {
        eq: $25f3e9876a698166$var$eq11(dictEq)
    };
};
var $25f3e9876a698166$export$25985b0447eac39b = function(dictEq) {
    return $3gIn7.eqLazy($25f3e9876a698166$var$eqNonEmpty(dictEq));
};
var $25f3e9876a698166$export$a37dd417b96243af = {
    compare1: function(dictOrd) {
        var compare = $gwBF5.compare(dictOrd);
        return function(xs) {
            return function(ys) {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        var $tco_var_v = $copy_v;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1) {
                            if (v instanceof $25f3e9876a698166$export$c1bed610ade55e1c && v1 instanceof $25f3e9876a698166$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $ibsD5.EQ.value;
                            }
                            if (v instanceof $25f3e9876a698166$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $ibsD5.LT.value;
                            }
                            if (v1 instanceof $25f3e9876a698166$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $ibsD5.GT.value;
                            }
                            if (v instanceof $25f3e9876a698166$export$74c44e616647f5c0 && v1 instanceof $25f3e9876a698166$export$74c44e616647f5c0) {
                                var v2 = compare(v.value0)(v1.value0);
                                if (v2 instanceof $ibsD5.EQ) {
                                    $tco_var_v = $25f3e9876a698166$export$35d34bc0ed591a92(v.value1);
                                    $copy_v1 = $25f3e9876a698166$export$35d34bc0ed591a92(v1.value1);
                                    return;
                                }
                                $tco_done = true;
                                return v2;
                            }
                            throw new Error("Failed pattern match at Data.List.Lazy.Types (line 89, column 5 - line 89, column 20): " + [
                                v.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                        return $tco_result;
                    };
                };
                return go($25f3e9876a698166$export$35d34bc0ed591a92(xs))($25f3e9876a698166$export$35d34bc0ed591a92(ys));
            };
        };
    },
    Eq10: function() {
        return $25f3e9876a698166$export$b7e705972f3b8317;
    }
};
var $25f3e9876a698166$var$ordNonEmpty = /* #__PURE__ */ $9aSRU.ordNonEmpty($25f3e9876a698166$export$a37dd417b96243af);
var $25f3e9876a698166$var$compare11 = /* #__PURE__ */ $gwBF5.compare1($25f3e9876a698166$export$a37dd417b96243af);
var $25f3e9876a698166$export$bf20701e75931fe8 = {
    compare1: function(dictOrd) {
        var compare12 = $25f3e9876a698166$var$compare1($25f3e9876a698166$var$ordNonEmpty(dictOrd));
        return function(v) {
            return function(v1) {
                return compare12(v)(v1);
            };
        };
    },
    Eq10: function() {
        return $25f3e9876a698166$export$80901a10e94c964a;
    }
};
var $25f3e9876a698166$export$86359cd4476084f8 = function(dictOrd) {
    var eqList1 = $25f3e9876a698166$export$1ae88a7f3c5f59ef(dictOrd.Eq0());
    return {
        compare: $25f3e9876a698166$var$compare11(dictOrd),
        Eq0: function() {
            return eqList1;
        }
    };
};
var $25f3e9876a698166$export$783a13ebf5a1203d = function(dictOrd) {
    return $3gIn7.ordLazy($25f3e9876a698166$var$ordNonEmpty(dictOrd));
};
var $25f3e9876a698166$export$8327ebbef2a0ba76 = function(x) {
    return function(xs) {
        return $hQCDc.defer(function(v) {
            return new $25f3e9876a698166$export$74c44e616647f5c0(x, xs);
        });
    };
};
var $25f3e9876a698166$export$92659ee1fc91a075 = {
    foldr: function(op) {
        return function(z) {
            return function(xs) {
                var rev = $dNwPt.foldl($25f3e9876a698166$export$92659ee1fc91a075)($jhsiw.flip($25f3e9876a698166$export$8327ebbef2a0ba76))($25f3e9876a698166$export$f2c4f74e8fe88e34);
                return $dNwPt.foldl($25f3e9876a698166$export$92659ee1fc91a075)($jhsiw.flip(op))(z)(rev(xs));
            };
        };
    },
    foldl: function(op) {
        var go = function($copy_b) {
            return function($copy_xs) {
                var $tco_var_b = $copy_b;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(b, xs) {
                    var v = $25f3e9876a698166$export$35d34bc0ed591a92(xs);
                    if (v instanceof $25f3e9876a698166$export$c1bed610ade55e1c) {
                        $tco_done = true;
                        return b;
                    }
                    if (v instanceof $25f3e9876a698166$export$74c44e616647f5c0) {
                        $tco_var_b = op(b)(v.value0);
                        $copy_xs = v.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List.Lazy.Types (line 127, column 7 - line 129, column 40): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_b, $copy_xs);
                return $tco_result;
            };
        };
        return go;
    },
    foldMap: function(dictMonoid) {
        var append2 = $d5vvq.append(dictMonoid.Semigroup0());
        var mempty = $3aOYV.mempty(dictMonoid);
        return function(f) {
            return $dNwPt.foldl($25f3e9876a698166$export$92659ee1fc91a075)(function(b) {
                return function(a) {
                    return append2(b)(f(a));
                };
            })(mempty);
        };
    }
};
var $25f3e9876a698166$var$foldr = /* #__PURE__ */ $dNwPt.foldr($25f3e9876a698166$export$92659ee1fc91a075);
var $25f3e9876a698166$var$foldableNonEmpty = /* #__PURE__ */ $9aSRU.foldableNonEmpty($25f3e9876a698166$export$92659ee1fc91a075);
var $25f3e9876a698166$var$foldr1 = /* #__PURE__ */ $dNwPt.foldr($25f3e9876a698166$var$foldableNonEmpty);
var $25f3e9876a698166$var$foldl = /* #__PURE__ */ $dNwPt.foldl($25f3e9876a698166$var$foldableNonEmpty);
var $25f3e9876a698166$var$foldMap = /* #__PURE__ */ $dNwPt.foldMap($25f3e9876a698166$var$foldableNonEmpty);
var $25f3e9876a698166$var$foldl1 = /* #__PURE__ */ $dNwPt.foldl($25f3e9876a698166$export$92659ee1fc91a075);
var $25f3e9876a698166$export$a2b02e086d468c06 = {
    extend: function(f) {
        return function(l) {
            var go = function(a) {
                return function(v) {
                    var acc$prime = $25f3e9876a698166$export$8327ebbef2a0ba76(a)(v.acc);
                    return {
                        val: $25f3e9876a698166$export$8327ebbef2a0ba76(f(acc$prime))(v.val),
                        acc: acc$prime
                    };
                };
            };
            var v = $25f3e9876a698166$export$35d34bc0ed591a92(l);
            if (v instanceof $25f3e9876a698166$export$c1bed610ade55e1c) return $25f3e9876a698166$export$f2c4f74e8fe88e34;
            if (v instanceof $25f3e9876a698166$export$74c44e616647f5c0) return $25f3e9876a698166$export$8327ebbef2a0ba76(f(l))($25f3e9876a698166$var$foldr(go)({
                val: $25f3e9876a698166$export$f2c4f74e8fe88e34,
                acc: $25f3e9876a698166$export$f2c4f74e8fe88e34
            })(v.value1).val);
            throw new Error("Failed pattern match at Data.List.Lazy.Types (line 197, column 5 - line 200, column 55): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $25f3e9876a698166$export$40b9e4330ffd17e3;
    }
};
var $25f3e9876a698166$export$44a6d15320cfc4c5 = {
    extend: function(f) {
        return function(v) {
            var go = function(a) {
                return function(v1) {
                    return {
                        val: $25f3e9876a698166$export$8327ebbef2a0ba76(f($hQCDc.defer(function(v2) {
                            return new $9aSRU.NonEmpty(a, v1.acc);
                        })))(v1.val),
                        acc: $25f3e9876a698166$export$8327ebbef2a0ba76(a)(v1.acc)
                    };
                };
            };
            var v1 = $hQCDc.force(v);
            return $hQCDc.defer(function(v2) {
                return new $9aSRU.NonEmpty(f(v), $25f3e9876a698166$var$foldr(go)({
                    val: $25f3e9876a698166$export$f2c4f74e8fe88e34,
                    acc: $25f3e9876a698166$export$f2c4f74e8fe88e34
                })(v1.value1).val);
            });
        };
    },
    Functor0: function() {
        return $25f3e9876a698166$export$3c979cc7d75b024c;
    }
};
var $25f3e9876a698166$export$604c31769a93bbe0 = {
    foldr: function(f) {
        return function(b) {
            return function(v) {
                return $25f3e9876a698166$var$foldr1(f)(b)($hQCDc.force(v));
            };
        };
    },
    foldl: function(f) {
        return function(b) {
            return function(v) {
                return $25f3e9876a698166$var$foldl(f)(b)($hQCDc.force(v));
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap1 = $25f3e9876a698166$var$foldMap(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMap1(f)($hQCDc.force(v));
            };
        };
    }
};
var $25f3e9876a698166$export$36831384a74c4427 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(xs) {
            return "(fromFoldable [" + (function() {
                var v = $25f3e9876a698166$export$35d34bc0ed591a92(xs);
                if (v instanceof $25f3e9876a698166$export$c1bed610ade55e1c) return "";
                if (v instanceof $25f3e9876a698166$export$74c44e616647f5c0) return show(v.value0) + $25f3e9876a698166$var$foldl1(function(shown) {
                    return function(x$prime) {
                        return shown + ("," + show(x$prime));
                    };
                })("")(v.value1);
                throw new Error("Failed pattern match at Data.List.Lazy.Types (line 66, column 13 - line 69, column 78): " + [
                    v.constructor.name
                ]);
            }() + "])");
        }
    };
};
var $25f3e9876a698166$export$3a5290e21dfc0ad7 = function(dictShow) {
    var show = $2XxiF.show($3gIn7.showLazy($9aSRU.showNonEmpty(dictShow)($25f3e9876a698166$export$36831384a74c4427(dictShow))));
    return {
        show: function(v) {
            return "(NonEmptyList " + (show(v) + ")");
        }
    };
};
var $25f3e9876a698166$export$17f3d25eed773ff1 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    var show1 = $2XxiF.show($25f3e9876a698166$export$36831384a74c4427(dictShow));
    return {
        show: function(v) {
            if (v instanceof $25f3e9876a698166$export$c1bed610ade55e1c) return "Nil";
            if (v instanceof $25f3e9876a698166$export$74c44e616647f5c0) return "(" + (show(v.value0) + (" : " + (show1(v.value1) + ")")));
            throw new Error("Failed pattern match at Data.List.Lazy.Types (line 36, column 1 - line 38, column 62): " + [
                v.constructor.name
            ]);
        }
    };
};
var $25f3e9876a698166$export$465bfc9894c20a50 = {
    foldrWithIndex: function(f) {
        return function(b) {
            return function(xs) {
                var v = function() {
                    var rev = $25f3e9876a698166$var$foldl1(function(v1) {
                        return function(a) {
                            return new $7O0Q4.Tuple(v1.value0 + 1 | 0, $25f3e9876a698166$export$8327ebbef2a0ba76(a)(v1.value1));
                        };
                    });
                    return rev(new $7O0Q4.Tuple(0, $25f3e9876a698166$export$f2c4f74e8fe88e34))(xs);
                }();
                return $7O0Q4.snd($25f3e9876a698166$var$foldl1(function(v1) {
                    return function(a) {
                        return new $7O0Q4.Tuple(v1.value0 - 1 | 0, f(v1.value0 - 1 | 0)(a)(v1.value1));
                    };
                })(new $7O0Q4.Tuple(v.value0, b))(v.value1));
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(acc) {
            var $321 = $25f3e9876a698166$var$foldl1(function(v) {
                return function(a) {
                    return new $7O0Q4.Tuple(v.value0 + 1 | 0, f(v.value0)(v.value1)(a));
                };
            })(new $7O0Q4.Tuple(0, acc));
            return function($322) {
                return $7O0Q4.snd($321($322));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var append2 = $d5vvq.append(dictMonoid.Semigroup0());
        var mempty = $3aOYV.mempty(dictMonoid);
        return function(f) {
            return $7vxKS.foldlWithIndex($25f3e9876a698166$export$465bfc9894c20a50)(function(i) {
                return function(acc) {
                    var $323 = append2(acc);
                    var $324 = f(i);
                    return function($325) {
                        return $323($324($325));
                    };
                };
            })(mempty);
        };
    },
    Foldable0: function() {
        return $25f3e9876a698166$export$92659ee1fc91a075;
    }
};
var $25f3e9876a698166$var$foldableWithIndexNonEmpty = /* #__PURE__ */ $9aSRU.foldableWithIndexNonEmpty($25f3e9876a698166$export$465bfc9894c20a50);
var $25f3e9876a698166$var$foldMapWithIndex = /* #__PURE__ */ $7vxKS.foldMapWithIndex($25f3e9876a698166$var$foldableWithIndexNonEmpty);
var $25f3e9876a698166$var$foldlWithIndex = /* #__PURE__ */ $7vxKS.foldlWithIndex($25f3e9876a698166$var$foldableWithIndexNonEmpty);
var $25f3e9876a698166$var$foldrWithIndex = /* #__PURE__ */ $7vxKS.foldrWithIndex($25f3e9876a698166$var$foldableWithIndexNonEmpty);
var $25f3e9876a698166$var$foldrWithIndex1 = /* #__PURE__ */ $7vxKS.foldrWithIndex($25f3e9876a698166$export$465bfc9894c20a50);
var $25f3e9876a698166$export$181d5b43cf38a79a = {
    foldMapWithIndex: function(dictMonoid) {
        var foldMapWithIndex1 = $25f3e9876a698166$var$foldMapWithIndex(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMapWithIndex1(function() {
                    var $326 = $h2xUu.maybe(0)($25f3e9876a698166$var$add(1));
                    return function($327) {
                        return f($326($327));
                    };
                }())($hQCDc.force(v));
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(b) {
            return function(v) {
                return $25f3e9876a698166$var$foldlWithIndex(function() {
                    var $328 = $h2xUu.maybe(0)($25f3e9876a698166$var$add(1));
                    return function($329) {
                        return f($328($329));
                    };
                }())(b)($hQCDc.force(v));
            };
        };
    },
    foldrWithIndex: function(f) {
        return function(b) {
            return function(v) {
                return $25f3e9876a698166$var$foldrWithIndex(function() {
                    var $330 = $h2xUu.maybe(0)($25f3e9876a698166$var$add(1));
                    return function($331) {
                        return f($330($331));
                    };
                }())(b)($hQCDc.force(v));
            };
        };
    },
    Foldable0: function() {
        return $25f3e9876a698166$export$604c31769a93bbe0;
    }
};
var $25f3e9876a698166$export$3951fb12c9649f2b = {
    mapWithIndex: function(f) {
        return $25f3e9876a698166$var$foldrWithIndex1(function(i) {
            return function(x) {
                return function(acc) {
                    return $25f3e9876a698166$export$8327ebbef2a0ba76(f(i)(x))(acc);
                };
            };
        })($25f3e9876a698166$export$f2c4f74e8fe88e34);
    },
    Functor0: function() {
        return $25f3e9876a698166$export$40b9e4330ffd17e3;
    }
};
var $25f3e9876a698166$var$mapWithIndex = /* #__PURE__ */ $lzCaM.mapWithIndex(/* #__PURE__ */ $9aSRU.functorWithIndex($25f3e9876a698166$export$3951fb12c9649f2b));
var $25f3e9876a698166$export$116ff457f4ca2f6a = {
    mapWithIndex: function(f) {
        return function(v) {
            return $hQCDc.defer(function(v1) {
                return $25f3e9876a698166$var$mapWithIndex(function() {
                    var $332 = $h2xUu.maybe(0)($25f3e9876a698166$var$add(1));
                    return function($333) {
                        return f($332($333));
                    };
                }())($hQCDc.force(v));
            });
        };
    },
    Functor0: function() {
        return $25f3e9876a698166$export$3c979cc7d75b024c;
    }
};
var $25f3e9876a698166$export$effcdbd76139450 = function(v) {
    return $25f3e9876a698166$var$defer(function(v1) {
        var v2 = $hQCDc.force(v);
        return $25f3e9876a698166$export$8327ebbef2a0ba76(v2.value0)(v2.value1);
    });
};
var $25f3e9876a698166$export$a8cfc3dfdfca72cf = {
    append: function(v) {
        return function(as$prime) {
            var v1 = $hQCDc.force(v);
            return $hQCDc.defer(function(v2) {
                return new $9aSRU.NonEmpty(v1.value0, $25f3e9876a698166$var$append1(v1.value1)($25f3e9876a698166$export$effcdbd76139450(as$prime)));
            });
        };
    }
};
var $25f3e9876a698166$export$99c2ce29c0ead637 = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply1 = $26ZCq.apply(Apply0);
        var map2 = $7FzSN.map(Apply0.Functor0());
        var pure = $bQdkN.pure(dictApplicative);
        return function(f) {
            return $25f3e9876a698166$var$foldr(function(a) {
                return function(b) {
                    return apply1(map2($25f3e9876a698166$export$8327ebbef2a0ba76)(f(a)))(b);
                };
            })(pure($25f3e9876a698166$export$f2c4f74e8fe88e34));
        };
    },
    sequence: function(dictApplicative) {
        return $9OOYG.traverse($25f3e9876a698166$export$99c2ce29c0ead637)(dictApplicative)($25f3e9876a698166$var$identity);
    },
    Functor0: function() {
        return $25f3e9876a698166$export$40b9e4330ffd17e3;
    },
    Foldable1: function() {
        return $25f3e9876a698166$export$92659ee1fc91a075;
    }
};
var $25f3e9876a698166$var$traversableNonEmpty = /* #__PURE__ */ $9aSRU.traversableNonEmpty($25f3e9876a698166$export$99c2ce29c0ead637);
var $25f3e9876a698166$var$traverse = /* #__PURE__ */ $9OOYG.traverse($25f3e9876a698166$var$traversableNonEmpty);
var $25f3e9876a698166$var$sequence = /* #__PURE__ */ $9OOYG.sequence($25f3e9876a698166$var$traversableNonEmpty);
var $25f3e9876a698166$export$d0a0d45336d2d3e3 = {
    traverse: function(dictApplicative) {
        var map2 = $7FzSN.map(dictApplicative.Apply0().Functor0());
        var traverse1 = $25f3e9876a698166$var$traverse(dictApplicative);
        return function(f) {
            return function(v) {
                return map2(function(xxs) {
                    return $hQCDc.defer(function(v1) {
                        return xxs;
                    });
                })(traverse1(f)($hQCDc.force(v)));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map2 = $7FzSN.map(dictApplicative.Apply0().Functor0());
        var sequence1 = $25f3e9876a698166$var$sequence(dictApplicative);
        return function(v) {
            return map2(function(xxs) {
                return $hQCDc.defer(function(v1) {
                    return xxs;
                });
            })(sequence1($hQCDc.force(v)));
        };
    },
    Functor0: function() {
        return $25f3e9876a698166$export$3c979cc7d75b024c;
    },
    Foldable1: function() {
        return $25f3e9876a698166$export$604c31769a93bbe0;
    }
};
var $25f3e9876a698166$export$aed77e3b7bbfc02d = {
    traverseWithIndex: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply1 = $26ZCq.apply(Apply0);
        var map2 = $7FzSN.map(Apply0.Functor0());
        var pure = $bQdkN.pure(dictApplicative);
        return function(f) {
            return $25f3e9876a698166$var$foldrWithIndex1(function(i) {
                return function(a) {
                    return function(b) {
                        return apply1(map2($25f3e9876a698166$export$8327ebbef2a0ba76)(f(i)(a)))(b);
                    };
                };
            })(pure($25f3e9876a698166$export$f2c4f74e8fe88e34));
        };
    },
    FunctorWithIndex0: function() {
        return $25f3e9876a698166$export$3951fb12c9649f2b;
    },
    FoldableWithIndex1: function() {
        return $25f3e9876a698166$export$465bfc9894c20a50;
    },
    Traversable2: function() {
        return $25f3e9876a698166$export$99c2ce29c0ead637;
    }
};
var $25f3e9876a698166$var$traverseWithIndex = /* #__PURE__ */ $bijFl.traverseWithIndex(/* #__PURE__ */ $9aSRU.traversableWithIndexNonEmpty($25f3e9876a698166$export$aed77e3b7bbfc02d));
var $25f3e9876a698166$export$29974dc3d1d7196b = {
    traverseWithIndex: function(dictApplicative) {
        var map2 = $7FzSN.map(dictApplicative.Apply0().Functor0());
        var traverseWithIndex1 = $25f3e9876a698166$var$traverseWithIndex(dictApplicative);
        return function(f) {
            return function(v) {
                return map2(function(xxs) {
                    return $hQCDc.defer(function(v1) {
                        return xxs;
                    });
                })(traverseWithIndex1(function() {
                    var $334 = $h2xUu.maybe(0)($25f3e9876a698166$var$add(1));
                    return function($335) {
                        return f($334($335));
                    };
                }())($hQCDc.force(v)));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $25f3e9876a698166$export$116ff457f4ca2f6a;
    },
    FoldableWithIndex1: function() {
        return $25f3e9876a698166$export$181d5b43cf38a79a;
    },
    Traversable2: function() {
        return $25f3e9876a698166$export$d0a0d45336d2d3e3;
    }
};
var $25f3e9876a698166$export$c7fe2ca4bf0cb8df = {
    unfoldr1: /* #__PURE__ */ function() {
        var go = function(f) {
            return function(b) {
                return $25f3e9876a698166$var$defer(function(v) {
                    var v1 = f(b);
                    if (v1.value1 instanceof $h2xUu.Just) return $25f3e9876a698166$export$8327ebbef2a0ba76(v1.value0)(go(f)(v1.value1.value0));
                    if (v1.value1 instanceof $h2xUu.Nothing) return $25f3e9876a698166$export$8327ebbef2a0ba76(v1.value0)($25f3e9876a698166$export$f2c4f74e8fe88e34);
                    throw new Error("Failed pattern match at Data.List.Lazy.Types (line 151, column 28 - line 153, column 33): " + [
                        v1.constructor.name
                    ]);
                });
            };
        };
        return go;
    }()
};
var $25f3e9876a698166$export$1d41caf0a0a6a680 = {
    unfoldr: /* #__PURE__ */ function() {
        var go = function(f) {
            return function(b) {
                return $25f3e9876a698166$var$defer(function(v) {
                    var v1 = f(b);
                    if (v1 instanceof $h2xUu.Nothing) return $25f3e9876a698166$export$f2c4f74e8fe88e34;
                    if (v1 instanceof $h2xUu.Just) return $25f3e9876a698166$export$8327ebbef2a0ba76(v1.value0.value0)(go(f)(v1.value0.value1));
                    throw new Error("Failed pattern match at Data.List.Lazy.Types (line 157, column 28 - line 159, column 39): " + [
                        v1.constructor.name
                    ]);
                });
            };
        };
        return go;
    }(),
    Unfoldable10: function() {
        return $25f3e9876a698166$export$c7fe2ca4bf0cb8df;
    }
};
var $25f3e9876a698166$var$unfoldr1 = /* #__PURE__ */ $N3bwb.unfoldr1(/* #__PURE__ */ $9aSRU.unfoldable1NonEmpty($25f3e9876a698166$export$1d41caf0a0a6a680));
var $25f3e9876a698166$export$6907256bb4275b5b = {
    unfoldr1: function(f) {
        return function(b) {
            return $hQCDc.defer(function(v) {
                return $25f3e9876a698166$var$unfoldr1(f)(b);
            });
        };
    }
};
var $25f3e9876a698166$export$7bc4d4de9c57db1f = {
    extract: function(v) {
        return $9aSRU.head($hQCDc.force(v));
    },
    Extend0: function() {
        return $25f3e9876a698166$export$44a6d15320cfc4c5;
    }
};
var $25f3e9876a698166$export$7c78e86b21f51881 = {
    Applicative0: function() {
        return $25f3e9876a698166$export$25cda6d3e08b28fe;
    },
    Bind1: function() {
        return $25f3e9876a698166$export$497dcf96eb2383ec;
    }
};
var $25f3e9876a698166$export$497dcf96eb2383ec = {
    bind: function(xs) {
        return function(f) {
            var go = function(v) {
                if (v instanceof $25f3e9876a698166$export$c1bed610ade55e1c) return $25f3e9876a698166$export$c1bed610ade55e1c.value;
                if (v instanceof $25f3e9876a698166$export$74c44e616647f5c0) return $25f3e9876a698166$export$35d34bc0ed591a92($25f3e9876a698166$var$append1(f(v.value0))($cADnC.bind($25f3e9876a698166$export$497dcf96eb2383ec)(v.value1)(f)));
                throw new Error("Failed pattern match at Data.List.Lazy.Types (line 180, column 5 - line 180, column 17): " + [
                    v.constructor.name
                ]);
            };
            return $25f3e9876a698166$var$map(go)($25f3e9876a698166$var$unwrap(xs));
        };
    },
    Apply0: function() {
        return $25f3e9876a698166$var$$lazy_applyList(0);
    }
};
var $25f3e9876a698166$export$25cda6d3e08b28fe = {
    pure: function(a) {
        return $25f3e9876a698166$export$8327ebbef2a0ba76(a)($25f3e9876a698166$export$f2c4f74e8fe88e34);
    },
    Apply0: function() {
        return $25f3e9876a698166$var$$lazy_applyList(0);
    }
};
var $25f3e9876a698166$var$$lazy_applyList = /* #__PURE__ */ $25f3e9876a698166$var$$runtime_lazy("applyList", "Data.List.Lazy.Types", function() {
    return {
        apply: $kkdfo.ap($25f3e9876a698166$export$7c78e86b21f51881),
        Functor0: function() {
            return $25f3e9876a698166$export$40b9e4330ffd17e3;
        }
    };
});
var $25f3e9876a698166$export$7e49f2fa1ca16fbc = /* #__PURE__ */ $25f3e9876a698166$var$$lazy_applyList(171);
var $25f3e9876a698166$var$apply = /* #__PURE__ */ $26ZCq.apply($25f3e9876a698166$export$7e49f2fa1ca16fbc);
var $25f3e9876a698166$var$bind = /* #__PURE__ */ $cADnC.bind($25f3e9876a698166$export$497dcf96eb2383ec);
var $25f3e9876a698166$export$18f1a42667f2921e = {
    apply: function(v) {
        return function(v1) {
            var v2 = $hQCDc.force(v1);
            var v3 = $hQCDc.force(v);
            return $hQCDc.defer(function(v4) {
                return new $9aSRU.NonEmpty(v3.value0(v2.value0), $25f3e9876a698166$var$append1($25f3e9876a698166$var$apply(v3.value1)($25f3e9876a698166$export$8327ebbef2a0ba76(v2.value0)($25f3e9876a698166$export$f2c4f74e8fe88e34)))($25f3e9876a698166$var$apply($25f3e9876a698166$export$8327ebbef2a0ba76(v3.value0)(v3.value1))(v2.value1)));
            });
        };
    },
    Functor0: function() {
        return $25f3e9876a698166$export$3c979cc7d75b024c;
    }
};
var $25f3e9876a698166$export$12e3398ee6f4a417 = {
    bind: function(v) {
        return function(f) {
            var v1 = $hQCDc.force(v);
            var v2 = $hQCDc.force($25f3e9876a698166$var$unwrap(f(v1.value0)));
            return $hQCDc.defer(function(v3) {
                return new $9aSRU.NonEmpty(v2.value0, $25f3e9876a698166$var$append1(v2.value1)($25f3e9876a698166$var$bind(v1.value1)(function($336) {
                    return $25f3e9876a698166$export$effcdbd76139450(f($336));
                })));
            });
        };
    },
    Apply0: function() {
        return $25f3e9876a698166$export$18f1a42667f2921e;
    }
};
var $25f3e9876a698166$export$852a754cd45a1ed = {
    alt: /* #__PURE__ */ $d5vvq.append($25f3e9876a698166$export$a8cfc3dfdfca72cf),
    Functor0: function() {
        return $25f3e9876a698166$export$3c979cc7d75b024c;
    }
};
var $25f3e9876a698166$export$97980ce7ea95015b = {
    alt: $25f3e9876a698166$var$append1,
    Functor0: function() {
        return $25f3e9876a698166$export$40b9e4330ffd17e3;
    }
};
var $25f3e9876a698166$export$55d622505c452dcb = {
    empty: $25f3e9876a698166$export$f2c4f74e8fe88e34,
    Alt0: function() {
        return $25f3e9876a698166$export$97980ce7ea95015b;
    }
};
var $25f3e9876a698166$var$singleton = /* #__PURE__ */ $9aSRU.singleton($25f3e9876a698166$export$55d622505c452dcb);
var $25f3e9876a698166$export$503ce72759d93980 = {
    Applicative0: function() {
        return $25f3e9876a698166$export$25cda6d3e08b28fe;
    },
    Plus1: function() {
        return $25f3e9876a698166$export$55d622505c452dcb;
    }
};
var $25f3e9876a698166$export$9ea554ee3c75e458 = {
    Monad0: function() {
        return $25f3e9876a698166$export$7c78e86b21f51881;
    },
    Alternative1: function() {
        return $25f3e9876a698166$export$503ce72759d93980;
    }
};
var $25f3e9876a698166$export$e5d0ed5dac805e10 = {
    pure: function(a) {
        return $hQCDc.defer(function(v) {
            return $25f3e9876a698166$var$singleton(a);
        });
    },
    Apply0: function() {
        return $25f3e9876a698166$export$18f1a42667f2921e;
    }
};
var $25f3e9876a698166$export$f444cc7484072e62 = {
    Applicative0: function() {
        return $25f3e9876a698166$export$e5d0ed5dac805e10;
    },
    Bind1: function() {
        return $25f3e9876a698166$export$12e3398ee6f4a417;
    }
};

});



parcelRegister("bqDN9", function(module, exports) {

$parcel$export(module.exports, "length", () => $8520fd3b91c2956e$export$f24224f1c91d8156);
$parcel$export(module.exports, "splitAt", () => $8520fd3b91c2956e$export$b0d75975ac0be0e1);
// Generated by purs version 0.15.16

var $iMNoE = parcelRequire("iMNoE");
parcelRequire("brrpF");
var $d3m1K = parcelRequire("d3m1K");

var $iQTlW = parcelRequire("iQTlW");

var $8zsOy = parcelRequire("8zsOy");

var $dIXGo = parcelRequire("dIXGo");

var $8tuSi = parcelRequire("8tuSi");

var $7FzSN = parcelRequire("7FzSN");

var $hCjGZ = parcelRequire("hCjGZ");
var $dbLcE = parcelRequire("dbLcE");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");
parcelRequire("4Fu8m");
var $f2i2N = parcelRequire("f2i2N");
var $4Fu8m = parcelRequire("4Fu8m");
parcelRequire("d8ahy");
var $3BU4Z = parcelRequire("3BU4Z");
parcelRequire("d4c0k");
var $4pzyG = parcelRequire("4pzyG");

var $7O0Q4 = parcelRequire("7O0Q4");

var $goKHx = parcelRequire("goKHx");
var $8520fd3b91c2956e$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $8520fd3b91c2956e$var$fromEnum = /* #__PURE__ */ $dIXGo.fromEnum($dIXGo.boundedEnumChar);
var $8520fd3b91c2956e$var$map = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $8520fd3b91c2956e$var$unfoldr = /* #__PURE__ */ $goKHx.unfoldr($goKHx.unfoldableArray);
var $8520fd3b91c2956e$var$div = /* #__PURE__ */ $8tuSi.div($8tuSi.euclideanRingInt);
var $8520fd3b91c2956e$var$mod = /* #__PURE__ */ $8tuSi.mod($8tuSi.euclideanRingInt);
var $8520fd3b91c2956e$var$compare = /* #__PURE__ */ $gwBF5.compare($gwBF5.ordInt);
var $8520fd3b91c2956e$var$CodePoint = function(x) {
    return x;
};
var $8520fd3b91c2956e$var$unsurrogate = function(lead) {
    return function(trail) {
        return (((lead - 55296 | 0) * 1024 | 0) + (trail - 56320 | 0) | 0) + 65536 | 0;
    };
};
var $8520fd3b91c2956e$export$1e278a1fb25ff338 = {
    show: function(v) {
        return "(CodePoint 0x" + ($3BU4Z.toUpper($dbLcE.toStringAs($hCjGZ.hexadecimal)(v)) + ")");
    }
};
var $8520fd3b91c2956e$var$isTrail = function(cu) {
    return 56320 <= cu && cu <= 57343;
};
var $8520fd3b91c2956e$var$isLead = function(cu) {
    return 55296 <= cu && cu <= 56319;
};
var $8520fd3b91c2956e$export$b446f6baa3bb1430 = function(s) {
    var v = $f2i2N.length(s);
    if (v === 0) return $h2xUu.Nothing.value;
    if (v === 1) return new $h2xUu.Just({
        head: $8520fd3b91c2956e$var$fromEnum($4pzyG.charAt(0)(s)),
        tail: ""
    });
    var cu1 = $8520fd3b91c2956e$var$fromEnum($4pzyG.charAt(1)(s));
    var cu0 = $8520fd3b91c2956e$var$fromEnum($4pzyG.charAt(0)(s));
    var $43 = $8520fd3b91c2956e$var$isLead(cu0) && $8520fd3b91c2956e$var$isTrail(cu1);
    if ($43) return new $h2xUu.Just({
        head: $8520fd3b91c2956e$var$unsurrogate(cu0)(cu1),
        tail: $f2i2N.drop(2)(s)
    });
    return new $h2xUu.Just({
        head: cu0,
        tail: $f2i2N.drop(1)(s)
    });
};
var $8520fd3b91c2956e$var$unconsButWithTuple = function(s) {
    return $8520fd3b91c2956e$var$map(function(v) {
        return new $7O0Q4.Tuple(v.head, v.tail);
    })($8520fd3b91c2956e$export$b446f6baa3bb1430(s));
};
var $8520fd3b91c2956e$var$toCodePointArrayFallback = function(s) {
    return $8520fd3b91c2956e$var$unfoldr($8520fd3b91c2956e$var$unconsButWithTuple)(s);
};
var $8520fd3b91c2956e$var$unsafeCodePointAt0Fallback = function(s) {
    var cu0 = $8520fd3b91c2956e$var$fromEnum($4pzyG.charAt(0)(s));
    var $47 = $8520fd3b91c2956e$var$isLead(cu0) && $f2i2N.length(s) > 1;
    if ($47) {
        var cu1 = $8520fd3b91c2956e$var$fromEnum($4pzyG.charAt(1)(s));
        var $48 = $8520fd3b91c2956e$var$isTrail(cu1);
        if ($48) return $8520fd3b91c2956e$var$unsurrogate(cu0)(cu1);
        return cu0;
    }
    return cu0;
};
var $8520fd3b91c2956e$var$unsafeCodePointAt0 = /* #__PURE__ */ $iMNoE._unsafeCodePointAt0($8520fd3b91c2956e$var$unsafeCodePointAt0Fallback);
var $8520fd3b91c2956e$export$50a427d3c041e0d2 = /* #__PURE__ */ $iMNoE._toCodePointArray($8520fd3b91c2956e$var$toCodePointArrayFallback)($8520fd3b91c2956e$var$unsafeCodePointAt0);
var $8520fd3b91c2956e$export$f24224f1c91d8156 = function($74) {
    return $d3m1K.length($8520fd3b91c2956e$export$50a427d3c041e0d2($74));
};
var $8520fd3b91c2956e$export$557cfb7ed375eeb7 = function(p) {
    return function(s) {
        return $8520fd3b91c2956e$var$map(function(i) {
            return $8520fd3b91c2956e$export$f24224f1c91d8156($f2i2N.take(i)(s));
        })($4Fu8m.lastIndexOf(p)(s));
    };
};
var $8520fd3b91c2956e$export$305f7d4e9d4624f2 = function(p) {
    return function(s) {
        return $8520fd3b91c2956e$var$map(function(i) {
            return $8520fd3b91c2956e$export$f24224f1c91d8156($f2i2N.take(i)(s));
        })($4Fu8m.indexOf(p)(s));
    };
};
var $8520fd3b91c2956e$var$fromCharCode = /* #__PURE__ */ function() {
    var $75 = $dIXGo.toEnumWithDefaults($dIXGo.boundedEnumChar)($8zsOy.bottom($8zsOy.boundedChar))($8zsOy.top($8zsOy.boundedChar));
    return function($76) {
        return $f2i2N.singleton($75($76));
    };
}();
var $8520fd3b91c2956e$var$singletonFallback = function(v) {
    if (v <= 65535) return $8520fd3b91c2956e$var$fromCharCode(v);
    var lead = $8520fd3b91c2956e$var$div(v - 65536 | 0)(1024) + 55296 | 0;
    var trail = $8520fd3b91c2956e$var$mod(v - 65536 | 0)(1024) + 56320 | 0;
    return $8520fd3b91c2956e$var$fromCharCode(lead) + $8520fd3b91c2956e$var$fromCharCode(trail);
};
var $8520fd3b91c2956e$export$6fadda5ad927586c = /* #__PURE__ */ $iMNoE._fromCodePointArray($8520fd3b91c2956e$var$singletonFallback);
var $8520fd3b91c2956e$export$439306a4dcaafbb9 = /* #__PURE__ */ $iMNoE._singleton($8520fd3b91c2956e$var$singletonFallback);
var $8520fd3b91c2956e$var$takeFallback = function(v) {
    return function(v1) {
        if (v < 1) return "";
        var v2 = $8520fd3b91c2956e$export$b446f6baa3bb1430(v1);
        if (v2 instanceof $h2xUu.Just) return $8520fd3b91c2956e$export$439306a4dcaafbb9(v2.value0.head) + $8520fd3b91c2956e$var$takeFallback(v - 1 | 0)(v2.value0.tail);
        return v1;
    };
};
var $8520fd3b91c2956e$export$b7df5d561049483a = /* #__PURE__ */ $iMNoE._take($8520fd3b91c2956e$var$takeFallback);
var $8520fd3b91c2956e$export$9dc3eed83bb14216 = function(p) {
    return function(i) {
        return function(s) {
            var i$prime = $f2i2N.length($8520fd3b91c2956e$export$b7df5d561049483a(i)(s));
            return $8520fd3b91c2956e$var$map(function(k) {
                return $8520fd3b91c2956e$export$f24224f1c91d8156($f2i2N.take(k)(s));
            })($4Fu8m.lastIndexOf$prime(p)(i$prime)(s));
        };
    };
};
var $8520fd3b91c2956e$export$b0d75975ac0be0e1 = function(i) {
    return function(s) {
        var before = $8520fd3b91c2956e$export$b7df5d561049483a(i)(s);
        return {
            before: before,
            after: $f2i2N.drop($f2i2N.length(before))(s)
        };
    };
};
var $8520fd3b91c2956e$export$e200a5917becef04 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $8520fd3b91c2956e$export$b08a820ff2b5847d = {
    compare: function(x) {
        return function(y) {
            return $8520fd3b91c2956e$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $8520fd3b91c2956e$export$e200a5917becef04;
    }
};
var $8520fd3b91c2956e$export$663103110d94aac9 = function(n) {
    return function(s) {
        return $f2i2N.drop($f2i2N.length($8520fd3b91c2956e$export$b7df5d561049483a(n)(s)))(s);
    };
};
var $8520fd3b91c2956e$export$7f0e23922170149a = function(p) {
    return function(i) {
        return function(s) {
            var s$prime = $8520fd3b91c2956e$export$663103110d94aac9(i)(s);
            return $8520fd3b91c2956e$var$map(function(k) {
                return i + $8520fd3b91c2956e$export$f24224f1c91d8156($f2i2N.take(k)(s$prime)) | 0;
            })($4Fu8m.indexOf(p)(s$prime));
        };
    };
};
var $8520fd3b91c2956e$var$countTail = function($copy_p) {
    return function($copy_s) {
        return function($copy_accum) {
            var $tco_var_p = $copy_p;
            var $tco_var_s = $copy_s;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(p, s, accum) {
                var v = $8520fd3b91c2956e$export$b446f6baa3bb1430(s);
                if (v instanceof $h2xUu.Just) {
                    var $61 = p(v.value0.head);
                    if ($61) {
                        $tco_var_p = p;
                        $tco_var_s = v.value0.tail;
                        $copy_accum = accum + 1 | 0;
                        return;
                    }
                    $tco_done = true;
                    return accum;
                }
                $tco_done = true;
                return accum;
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_p, $tco_var_s, $copy_accum);
            return $tco_result;
        };
    };
};
var $8520fd3b91c2956e$var$countFallback = function(p) {
    return function(s) {
        return $8520fd3b91c2956e$var$countTail(p)(s)(0);
    };
};
var $8520fd3b91c2956e$export$29a68f758c141c85 = /* #__PURE__ */ $iMNoE._countPrefix($8520fd3b91c2956e$var$countFallback)($8520fd3b91c2956e$var$unsafeCodePointAt0);
var $8520fd3b91c2956e$export$533af5c8cd6afa16 = function(p) {
    return function(s) {
        return $8520fd3b91c2956e$export$663103110d94aac9($8520fd3b91c2956e$export$29a68f758c141c85(p)(s))(s);
    };
};
var $8520fd3b91c2956e$export$9384c7afe4015e42 = function(p) {
    return function(s) {
        return $8520fd3b91c2956e$export$b7df5d561049483a($8520fd3b91c2956e$export$29a68f758c141c85(p)(s))(s);
    };
};
var $8520fd3b91c2956e$export$dd1029f96c3dd62a = function($77) {
    return $8520fd3b91c2956e$var$CodePoint($8520fd3b91c2956e$var$fromEnum($77));
};
var $8520fd3b91c2956e$var$codePointAtFallback = function($copy_n) {
    return function($copy_s) {
        var $tco_var_n = $copy_n;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(n, s) {
            var v = $8520fd3b91c2956e$export$b446f6baa3bb1430(s);
            if (v instanceof $h2xUu.Just) {
                var $66 = n === 0;
                if ($66) {
                    $tco_done = true;
                    return new $h2xUu.Just(v.value0.head);
                }
                $tco_var_n = n - 1 | 0;
                $copy_s = v.value0.tail;
                return;
            }
            $tco_done = true;
            return $h2xUu.Nothing.value;
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_n, $copy_s);
        return $tco_result;
    };
};
var $8520fd3b91c2956e$export$42977f40461e1360 = function(v) {
    return function(v1) {
        if (v < 0) return $h2xUu.Nothing.value;
        if (v === 0 && v1 === "") return $h2xUu.Nothing.value;
        if (v === 0) return new $h2xUu.Just($8520fd3b91c2956e$var$unsafeCodePointAt0(v1));
        return $iMNoE._codePointAt($8520fd3b91c2956e$var$codePointAtFallback)($h2xUu.Just.create)($h2xUu.Nothing.value)($8520fd3b91c2956e$var$unsafeCodePointAt0)(v)(v1);
    };
};
var $8520fd3b91c2956e$export$1c2b30ab4636bf91 = {
    bottom: 0,
    top: 1114111,
    Ord0: function() {
        return $8520fd3b91c2956e$export$b08a820ff2b5847d;
    }
};
var $8520fd3b91c2956e$export$2a3400c6862992c1 = /* #__PURE__ */ function() {
    return {
        cardinality: 1114112,
        fromEnum: function(v) {
            return v;
        },
        toEnum: function(n) {
            if (n >= 0 && n <= 1114111) return new $h2xUu.Just(n);
            if ($iQTlW.otherwise) return $h2xUu.Nothing.value;
            throw new Error("Failed pattern match at Data.String.CodePoints (line 63, column 1 - line 68, column 26): " + [
                n.constructor.name
            ]);
        },
        Bounded0: function() {
            return $8520fd3b91c2956e$export$1c2b30ab4636bf91;
        },
        Enum1: function() {
            return $8520fd3b91c2956e$var$$lazy_enumCodePoint(0);
        }
    };
}();
var $8520fd3b91c2956e$var$$lazy_enumCodePoint = /* #__PURE__ */ $8520fd3b91c2956e$var$$runtime_lazy("enumCodePoint", "Data.String.CodePoints", function() {
    return {
        succ: $dIXGo.defaultSucc($dIXGo.toEnum($8520fd3b91c2956e$export$2a3400c6862992c1))($dIXGo.fromEnum($8520fd3b91c2956e$export$2a3400c6862992c1)),
        pred: $dIXGo.defaultPred($dIXGo.toEnum($8520fd3b91c2956e$export$2a3400c6862992c1))($dIXGo.fromEnum($8520fd3b91c2956e$export$2a3400c6862992c1)),
        Ord0: function() {
            return $8520fd3b91c2956e$export$b08a820ff2b5847d;
        }
    };
});
var $8520fd3b91c2956e$export$4bc346dd2fb559f7 = /* #__PURE__ */ $8520fd3b91c2956e$var$$lazy_enumCodePoint(59);

});
parcelRegister("iMNoE", function(module, exports) {

$parcel$export(module.exports, "_unsafeCodePointAt0", () => $dad306d660a82371$export$81daff3801c9c982);
$parcel$export(module.exports, "_codePointAt", () => $dad306d660a82371$export$5f0398d7608003c3);
$parcel$export(module.exports, "_countPrefix", () => $dad306d660a82371$export$2964bc4d0a1ede06);
$parcel$export(module.exports, "_fromCodePointArray", () => $dad306d660a82371$export$c41b441de25e3d55);
$parcel$export(module.exports, "_singleton", () => $dad306d660a82371$export$ecb7b38eca4fe9ff);
$parcel$export(module.exports, "_take", () => $dad306d660a82371$export$6d9af221d75dd06f);
$parcel$export(module.exports, "_toCodePointArray", () => $dad306d660a82371$export$c61d72f8b05641be);
/* global Symbol */ var $dad306d660a82371$var$hasArrayFrom = typeof Array.from === "function";
var $dad306d660a82371$var$hasStringIterator = typeof Symbol !== "undefined" && Symbol != null && typeof Symbol.iterator !== "undefined" && typeof String.prototype[Symbol.iterator] === "function";
var $dad306d660a82371$var$hasFromCodePoint = typeof String.prototype.fromCodePoint === "function";
var $dad306d660a82371$var$hasCodePointAt = typeof String.prototype.codePointAt === "function";
const $dad306d660a82371$export$81daff3801c9c982 = function(fallback) {
    return $dad306d660a82371$var$hasCodePointAt ? function(str) {
        return str.codePointAt(0);
    } : fallback;
};
const $dad306d660a82371$export$5f0398d7608003c3 = function(fallback) {
    return function(Just) {
        return function(Nothing) {
            return function(unsafeCodePointAt0) {
                return function(index) {
                    return function(str) {
                        var length = str.length;
                        if (index < 0 || index >= length) return Nothing;
                        if ($dad306d660a82371$var$hasStringIterator) {
                            var iter = str[Symbol.iterator]();
                            for(var i = index;; --i){
                                var o = iter.next();
                                if (o.done) return Nothing;
                                if (i === 0) return Just(unsafeCodePointAt0(o.value));
                            }
                        }
                        return fallback(index)(str);
                    };
                };
            };
        };
    };
};
const $dad306d660a82371$export$2964bc4d0a1ede06 = function(fallback) {
    return function(unsafeCodePointAt0) {
        if ($dad306d660a82371$var$hasStringIterator) return function(pred) {
            return function(str) {
                var iter = str[Symbol.iterator]();
                for(var cpCount = 0;; ++cpCount){
                    var o = iter.next();
                    if (o.done) return cpCount;
                    var cp = unsafeCodePointAt0(o.value);
                    if (!pred(cp)) return cpCount;
                }
            };
        };
        return fallback;
    };
};
const $dad306d660a82371$export$c41b441de25e3d55 = function(singleton) {
    return $dad306d660a82371$var$hasFromCodePoint ? function(cps) {
        // Function.prototype.apply will fail for very large second parameters,
        // so we don't use it for arrays with 10,000 or more entries.
        if (cps.length < 10e3) return String.fromCodePoint.apply(String, cps);
        return cps.map(singleton).join("");
    } : function(cps) {
        return cps.map(singleton).join("");
    };
};
const $dad306d660a82371$export$ecb7b38eca4fe9ff = function(fallback) {
    return $dad306d660a82371$var$hasFromCodePoint ? String.fromCodePoint : fallback;
};
const $dad306d660a82371$export$6d9af221d75dd06f = function(fallback) {
    return function(n) {
        if ($dad306d660a82371$var$hasStringIterator) return function(str) {
            var accum = "";
            var iter = str[Symbol.iterator]();
            for(var i = 0; i < n; ++i){
                var o = iter.next();
                if (o.done) return accum;
                accum += o.value;
            }
            return accum;
        };
        return fallback(n);
    };
};
const $dad306d660a82371$export$c61d72f8b05641be = function(fallback) {
    return function(unsafeCodePointAt0) {
        if ($dad306d660a82371$var$hasArrayFrom) return function(str) {
            return Array.from(str, unsafeCodePointAt0);
        };
        return fallback;
    };
};

});


parcelRegister("dL9YA", function(module, exports) {

$parcel$export(module.exports, "Sudoku", () => $a047673ba2224bb5$export$7fee7173fdfff4cd);
$parcel$export(module.exports, "Wordoku", () => $a047673ba2224bb5$export$cee6468a4ef73d35);
$parcel$export(module.exports, "Colorku", () => $a047673ba2224bb5$export$f4781b4d4a3d30a0);
$parcel$export(module.exports, "Beginner", () => $a047673ba2224bb5$export$54612ed9b67ee185);
$parcel$export(module.exports, "Casual", () => $a047673ba2224bb5$export$233a667e66f9c670);
$parcel$export(module.exports, "Tricky", () => $a047673ba2224bb5$export$e88ce1d42803a076);
$parcel$export(module.exports, "Difficult", () => $a047673ba2224bb5$export$7b540ff00e6e4e);
$parcel$export(module.exports, "Challenge", () => $a047673ba2224bb5$export$a50dcf13e7b62e9d);
$parcel$export(module.exports, "valuesEq", () => $a047673ba2224bb5$export$51afe6326e8576b7);
$parcel$export(module.exports, "valuesEnum", () => $a047673ba2224bb5$export$fb5b2b74f1c4e3ad);
$parcel$export(module.exports, "showValues", () => $a047673ba2224bb5$export$eca7eb7e54c0a6d9);
$parcel$export(module.exports, "showDifficulty", () => $a047673ba2224bb5$export$c83253a07f19a21e);
$parcel$export(module.exports, "numChars", () => $a047673ba2224bb5$export$25e5bd68f75a9738);
$parcel$export(module.exports, "difficultyEq", () => $a047673ba2224bb5$export$8beaaf9daf83670f);
$parcel$export(module.exports, "difficultyEnum", () => $a047673ba2224bb5$export$8fa750b48e620e01);
$parcel$export(module.exports, "generateSudoku", () => $a047673ba2224bb5$export$16a0abb3798cc10f);
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $cADnC = parcelRequire("cADnC");

var $brrpF = parcelRequire("brrpF");
var $d3m1K = parcelRequire("d3m1K");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $ibsD5 = parcelRequire("ibsD5");

var $1rTTn = parcelRequire("1rTTn");

var $aJZEv = parcelRequire("aJZEv");

var $41p0v = parcelRequire("41p0v");

var $lM1z4 = parcelRequire("lM1z4");

var $624no = parcelRequire("624no");

var $ekupQ = parcelRequire("ekupQ");

var $jy1cE = parcelRequire("jy1cE");
var $a047673ba2224bb5$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $a047673ba2224bb5$var$pure = /* #__PURE__ */ $bQdkN.pure($1rTTn.applicativeEffect);
var $a047673ba2224bb5$var$bind = /* #__PURE__ */ $cADnC.bind($h2xUu.bindMaybe);
var $a047673ba2224bb5$var$bindFlipped = /* #__PURE__ */ $cADnC.bindFlipped($1rTTn.bindEffect);
var $a047673ba2224bb5$var$bindFlipped1 = /* #__PURE__ */ $cADnC.bindFlipped($h2xUu.bindMaybe);
var $a047673ba2224bb5$export$7fee7173fdfff4cd = /* #__PURE__ */ function() {
    function Sudoku() {}
    Sudoku.value = new Sudoku();
    return Sudoku;
}();
var $a047673ba2224bb5$export$cee6468a4ef73d35 = /* #__PURE__ */ function() {
    function Wordoku() {}
    Wordoku.value = new Wordoku();
    return Wordoku;
}();
var $a047673ba2224bb5$export$f4781b4d4a3d30a0 = /* #__PURE__ */ function() {
    function Colorku() {}
    Colorku.value = new Colorku();
    return Colorku;
}();
var $a047673ba2224bb5$export$54612ed9b67ee185 = /* #__PURE__ */ function() {
    function Beginner() {}
    Beginner.value = new Beginner();
    return Beginner;
}();
var $a047673ba2224bb5$export$233a667e66f9c670 = /* #__PURE__ */ function() {
    function Casual() {}
    Casual.value = new Casual();
    return Casual;
}();
var $a047673ba2224bb5$export$e88ce1d42803a076 = /* #__PURE__ */ function() {
    function Tricky() {}
    Tricky.value = new Tricky();
    return Tricky;
}();
var $a047673ba2224bb5$export$7b540ff00e6e4e = /* #__PURE__ */ function() {
    function Difficult() {}
    Difficult.value = new Difficult();
    return Difficult;
}();
var $a047673ba2224bb5$export$a50dcf13e7b62e9d = /* #__PURE__ */ function() {
    function Challenge() {}
    Challenge.value = new Challenge();
    return Challenge;
}();
var $a047673ba2224bb5$export$51afe6326e8576b7 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $a047673ba2224bb5$export$7fee7173fdfff4cd && y instanceof $a047673ba2224bb5$export$7fee7173fdfff4cd) return true;
            if (x instanceof $a047673ba2224bb5$export$cee6468a4ef73d35 && y instanceof $a047673ba2224bb5$export$cee6468a4ef73d35) return true;
            if (x instanceof $a047673ba2224bb5$export$f4781b4d4a3d30a0 && y instanceof $a047673ba2224bb5$export$f4781b4d4a3d30a0) return true;
            return false;
        };
    }
};
var $a047673ba2224bb5$export$bcba493788a5d5ff = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $a047673ba2224bb5$export$7fee7173fdfff4cd && y instanceof $a047673ba2224bb5$export$7fee7173fdfff4cd) return $ibsD5.EQ.value;
            if (x instanceof $a047673ba2224bb5$export$7fee7173fdfff4cd) return $ibsD5.LT.value;
            if (y instanceof $a047673ba2224bb5$export$7fee7173fdfff4cd) return $ibsD5.GT.value;
            if (x instanceof $a047673ba2224bb5$export$cee6468a4ef73d35 && y instanceof $a047673ba2224bb5$export$cee6468a4ef73d35) return $ibsD5.EQ.value;
            if (x instanceof $a047673ba2224bb5$export$cee6468a4ef73d35) return $ibsD5.LT.value;
            if (y instanceof $a047673ba2224bb5$export$cee6468a4ef73d35) return $ibsD5.GT.value;
            if (x instanceof $a047673ba2224bb5$export$f4781b4d4a3d30a0 && y instanceof $a047673ba2224bb5$export$f4781b4d4a3d30a0) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $a047673ba2224bb5$export$51afe6326e8576b7;
    }
};
var $a047673ba2224bb5$export$fb5b2b74f1c4e3ad = {
    succ: function(v) {
        if (v instanceof $a047673ba2224bb5$export$7fee7173fdfff4cd) return new $h2xUu.Just($a047673ba2224bb5$export$cee6468a4ef73d35.value);
        if (v instanceof $a047673ba2224bb5$export$cee6468a4ef73d35) return new $h2xUu.Just($a047673ba2224bb5$export$f4781b4d4a3d30a0.value);
        if (v instanceof $a047673ba2224bb5$export$f4781b4d4a3d30a0) return $h2xUu.Nothing.value;
        throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 26, column 1 - line 32, column 30): " + [
            v.constructor.name
        ]);
    },
    pred: function(v) {
        if (v instanceof $a047673ba2224bb5$export$7fee7173fdfff4cd) return $h2xUu.Nothing.value;
        if (v instanceof $a047673ba2224bb5$export$cee6468a4ef73d35) return new $h2xUu.Just($a047673ba2224bb5$export$7fee7173fdfff4cd.value);
        if (v instanceof $a047673ba2224bb5$export$f4781b4d4a3d30a0) return new $h2xUu.Just($a047673ba2224bb5$export$cee6468a4ef73d35.value);
        throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 26, column 1 - line 32, column 30): " + [
            v.constructor.name
        ]);
    },
    Ord0: function() {
        return $a047673ba2224bb5$export$bcba493788a5d5ff;
    }
};
var $a047673ba2224bb5$export$eca7eb7e54c0a6d9 = {
    show: function(v) {
        if (v instanceof $a047673ba2224bb5$export$7fee7173fdfff4cd) return "Sudoku";
        if (v instanceof $a047673ba2224bb5$export$cee6468a4ef73d35) return "Wordoku";
        if (v instanceof $a047673ba2224bb5$export$f4781b4d4a3d30a0) return "Colorku";
        throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 34, column 1 - line 37, column 27): " + [
            v.constructor.name
        ]);
    }
};
var $a047673ba2224bb5$export$c83253a07f19a21e = {
    show: function(v) {
        if (v instanceof $a047673ba2224bb5$export$54612ed9b67ee185) return "Beginner";
        if (v instanceof $a047673ba2224bb5$export$233a667e66f9c670) return "Casual";
        if (v instanceof $a047673ba2224bb5$export$e88ce1d42803a076) return "Tricky";
        if (v instanceof $a047673ba2224bb5$export$7b540ff00e6e4e) return "Difficult";
        if (v instanceof $a047673ba2224bb5$export$a50dcf13e7b62e9d) return "Challenge";
        throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 55, column 1 - line 60, column 31): " + [
            v.constructor.name
        ]);
    }
};
var $a047673ba2224bb5$export$1218f3820e9208c0 = function(v) {
    return $a047673ba2224bb5$var$map(function() {
        var $56 = $h2xUu.fromMaybe("");
        var $57 = $brrpF.index($jy1cE.wordlist);
        return function($58) {
            return $56($57($58));
        };
    }())($aJZEv.randomInt(0)($d3m1K.length($jy1cE.wordlist) - 1 | 0));
};
var $a047673ba2224bb5$export$25e5bd68f75a9738 = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
];
var $a047673ba2224bb5$export$8beaaf9daf83670f = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $a047673ba2224bb5$export$54612ed9b67ee185 && y instanceof $a047673ba2224bb5$export$54612ed9b67ee185) return true;
            if (x instanceof $a047673ba2224bb5$export$233a667e66f9c670 && y instanceof $a047673ba2224bb5$export$233a667e66f9c670) return true;
            if (x instanceof $a047673ba2224bb5$export$e88ce1d42803a076 && y instanceof $a047673ba2224bb5$export$e88ce1d42803a076) return true;
            if (x instanceof $a047673ba2224bb5$export$7b540ff00e6e4e && y instanceof $a047673ba2224bb5$export$7b540ff00e6e4e) return true;
            if (x instanceof $a047673ba2224bb5$export$a50dcf13e7b62e9d && y instanceof $a047673ba2224bb5$export$a50dcf13e7b62e9d) return true;
            return false;
        };
    }
};
var $a047673ba2224bb5$export$bde90409a348d5f5 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $a047673ba2224bb5$export$54612ed9b67ee185 && y instanceof $a047673ba2224bb5$export$54612ed9b67ee185) return $ibsD5.EQ.value;
            if (x instanceof $a047673ba2224bb5$export$54612ed9b67ee185) return $ibsD5.LT.value;
            if (y instanceof $a047673ba2224bb5$export$54612ed9b67ee185) return $ibsD5.GT.value;
            if (x instanceof $a047673ba2224bb5$export$233a667e66f9c670 && y instanceof $a047673ba2224bb5$export$233a667e66f9c670) return $ibsD5.EQ.value;
            if (x instanceof $a047673ba2224bb5$export$233a667e66f9c670) return $ibsD5.LT.value;
            if (y instanceof $a047673ba2224bb5$export$233a667e66f9c670) return $ibsD5.GT.value;
            if (x instanceof $a047673ba2224bb5$export$e88ce1d42803a076 && y instanceof $a047673ba2224bb5$export$e88ce1d42803a076) return $ibsD5.EQ.value;
            if (x instanceof $a047673ba2224bb5$export$e88ce1d42803a076) return $ibsD5.LT.value;
            if (y instanceof $a047673ba2224bb5$export$e88ce1d42803a076) return $ibsD5.GT.value;
            if (x instanceof $a047673ba2224bb5$export$7b540ff00e6e4e && y instanceof $a047673ba2224bb5$export$7b540ff00e6e4e) return $ibsD5.EQ.value;
            if (x instanceof $a047673ba2224bb5$export$7b540ff00e6e4e) return $ibsD5.LT.value;
            if (y instanceof $a047673ba2224bb5$export$7b540ff00e6e4e) return $ibsD5.GT.value;
            if (x instanceof $a047673ba2224bb5$export$a50dcf13e7b62e9d && y instanceof $a047673ba2224bb5$export$a50dcf13e7b62e9d) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $a047673ba2224bb5$export$8beaaf9daf83670f;
    }
};
var $a047673ba2224bb5$export$8fa750b48e620e01 = {
    succ: function(v) {
        if (v instanceof $a047673ba2224bb5$export$54612ed9b67ee185) return new $h2xUu.Just($a047673ba2224bb5$export$233a667e66f9c670.value);
        if (v instanceof $a047673ba2224bb5$export$233a667e66f9c670) return new $h2xUu.Just($a047673ba2224bb5$export$e88ce1d42803a076.value);
        if (v instanceof $a047673ba2224bb5$export$e88ce1d42803a076) return new $h2xUu.Just($a047673ba2224bb5$export$7b540ff00e6e4e.value);
        if (v instanceof $a047673ba2224bb5$export$7b540ff00e6e4e) return new $h2xUu.Just($a047673ba2224bb5$export$a50dcf13e7b62e9d.value);
        if (v instanceof $a047673ba2224bb5$export$a50dcf13e7b62e9d) return $h2xUu.Nothing.value;
        throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 43, column 1 - line 53, column 34): " + [
            v.constructor.name
        ]);
    },
    pred: function(v) {
        if (v instanceof $a047673ba2224bb5$export$54612ed9b67ee185) return $h2xUu.Nothing.value;
        if (v instanceof $a047673ba2224bb5$export$233a667e66f9c670) return new $h2xUu.Just($a047673ba2224bb5$export$54612ed9b67ee185.value);
        if (v instanceof $a047673ba2224bb5$export$e88ce1d42803a076) return new $h2xUu.Just($a047673ba2224bb5$export$233a667e66f9c670.value);
        if (v instanceof $a047673ba2224bb5$export$7b540ff00e6e4e) return new $h2xUu.Just($a047673ba2224bb5$export$e88ce1d42803a076.value);
        if (v instanceof $a047673ba2224bb5$export$a50dcf13e7b62e9d) return new $h2xUu.Just($a047673ba2224bb5$export$7b540ff00e6e4e.value);
        throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 43, column 1 - line 53, column 34): " + [
            v.constructor.name
        ]);
    },
    Ord0: function() {
        return $a047673ba2224bb5$export$bde90409a348d5f5;
    }
};
var $a047673ba2224bb5$export$d6f7dafca0a6dfe9 = function(v) {
    return function(v1) {
        if (v1 instanceof $a047673ba2224bb5$export$54612ed9b67ee185) return 40;
        if (v1 instanceof $a047673ba2224bb5$export$233a667e66f9c670) return 34;
        if (v1 instanceof $a047673ba2224bb5$export$e88ce1d42803a076) return 30;
        if (v1 instanceof $a047673ba2224bb5$export$7b540ff00e6e4e) return 26;
        if (v instanceof $41p0v.UniqueDiagonal && v1 instanceof $a047673ba2224bb5$export$a50dcf13e7b62e9d) return 22;
        if (v instanceof $41p0v.Standard && v1 instanceof $a047673ba2224bb5$export$a50dcf13e7b62e9d) return 24;
        throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 100, column 1 - line 100, column 40): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $a047673ba2224bb5$export$16a0abb3798cc10f = function(restrictDiag) {
    return function(difficulty) {
        var toStringOrLoop = function(v) {
            if (v instanceof $h2xUu.Nothing) return $a047673ba2224bb5$export$16a0abb3798cc10f(restrictDiag)(difficulty);
            if (v instanceof $h2xUu.Just) return $a047673ba2224bb5$var$pure($lM1z4.gridString($624no.sudokuKey)(v.value0));
            throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 86, column 3 - line 86, column 48): " + [
                v.constructor.name
            ]);
        };
        var removeAt = function(idx) {
            return function(grid) {
                return $lM1z4.replace2D(idx)(new $41p0v.Possible($41p0v.allValues))(grid);
            };
        };
        var reduceBy = function(count) {
            return function(idxs) {
                return function(grid) {
                    var $48 = count <= 0;
                    if ($48) return new $h2xUu.Just(grid);
                    return $a047673ba2224bb5$var$bind($brrpF.uncons(idxs))(function(v) {
                        var nextGrid = removeAt(v.head)(grid);
                        var v1 = $ekupQ.solveUnique(restrictDiag)(nextGrid);
                        if (v1 instanceof $41p0v.Unique) {
                            var v2 = reduceBy(count - 1 | 0)(v.tail)(nextGrid);
                            if (v2 instanceof $h2xUu.Nothing) return reduceBy(count)(v.tail)(grid);
                            if (v2 instanceof $h2xUu.Just) return new $h2xUu.Just(v2.value0);
                            throw new Error("Failed pattern match at Sudoku.Internal.Generator (line 78, column 11 - line 80, column 37): " + [
                                v2.constructor.name
                            ]);
                        }
                        return reduceBy(count)(v.tail)(grid);
                    });
                };
            };
        };
        return $a047673ba2224bb5$var$bindFlipped(toStringOrLoop)(function __do() {
            var shuffled = $41p0v.randomArray($41p0v.allValues)();
            var emptyGrid = $lM1z4.emptyGridWith(shuffled);
            var mFilled = $ekupQ.solve(restrictDiag)(emptyGrid);
            var randIdxs = $41p0v.randomArray($d3m1K.range(0)(80))();
            return $a047673ba2224bb5$var$bindFlipped1(reduceBy(81 - $a047673ba2224bb5$export$d6f7dafca0a6dfe9(restrictDiag)(difficulty) | 0)(randIdxs))(mFilled);
        });
    };
};

});
parcelRegister("aJZEv", function(module, exports) {

$parcel$export(module.exports, "randomInt", () => $7d1dee37ee00cecb$export$3c5f89dae98e900b);
// Generated by purs version 0.15.16

var $fxWbN = parcelRequire("fxWbN");

var $7FzSN = parcelRequire("7FzSN");

var $hCjGZ = parcelRequire("hCjGZ");
var $dbLcE = parcelRequire("dbLcE");

var $1rTTn = parcelRequire("1rTTn");
var $7d1dee37ee00cecb$export$5c61011b8a176cb5 = function(min) {
    return function(max) {
        return function __do() {
            var n = $fxWbN.random();
            return n * (max - min) + min;
        };
    };
};
var $7d1dee37ee00cecb$export$3c5f89dae98e900b = function(low) {
    return function(high) {
        return function __do() {
            var n = $fxWbN.random();
            var asNumber = ($dbLcE.toNumber(high) - $dbLcE.toNumber(low) + 1) * n + $dbLcE.toNumber(low);
            return $hCjGZ.floor(asNumber);
        };
    };
};
var $7d1dee37ee00cecb$export$b3b584c8d6ffe165 = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect)(function(v) {
    return v < 0.5;
})($fxWbN.random);

});
parcelRegister("fxWbN", function(module, exports) {

$parcel$export(module.exports, "random", () => $b517133e8b6ca487$export$4385e60b38654f68);
const $b517133e8b6ca487$export$4385e60b38654f68 = Math.random;

});


parcelRegister("41p0v", function(module, exports) {

$parcel$export(module.exports, "Standard", () => $2edaa75788d2b028$export$d5a1f56087d42b19);
$parcel$export(module.exports, "UniqueDiagonal", () => $2edaa75788d2b028$export$9f64ad4387712eb1);
$parcel$export(module.exports, "Tuple3", () => $2edaa75788d2b028$export$82dc29c19cc50d89);
$parcel$export(module.exports, "NoSolution", () => $2edaa75788d2b028$export$893673f0dd009d3);
$parcel$export(module.exports, "Unique", () => $2edaa75788d2b028$export$8e3adf126971a183);
$parcel$export(module.exports, "NotUnique", () => $2edaa75788d2b028$export$eee85644b4921d28);
$parcel$export(module.exports, "Fixed", () => $2edaa75788d2b028$export$13475bbd2a37a9b4);
$parcel$export(module.exports, "Possible", () => $2edaa75788d2b028$export$f8b00adb3272ca6);
$parcel$export(module.exports, "transpose", () => $2edaa75788d2b028$export$9cb09a71b7d66923);
$parcel$export(module.exports, "replaceAt", () => $2edaa75788d2b028$export$224e3b7078227b8a);
$parcel$export(module.exports, "randomArray", () => $2edaa75788d2b028$export$9bcb57a486df0ae9);
$parcel$export(module.exports, "on", () => $2edaa75788d2b028$export$af631764ddc44097);
$parcel$export(module.exports, "isUnique", () => $2edaa75788d2b028$export$bb807e921d36aa98);
$parcel$export(module.exports, "index2D", () => $2edaa75788d2b028$export$8b633acbde1156e3);
$parcel$export(module.exports, "functorSearchResult", () => $2edaa75788d2b028$export$348af39216c9f47a);
$parcel$export(module.exports, "eqValue", () => $2edaa75788d2b028$export$7e7ad869a5fd5749);
$parcel$export(module.exports, "ordValue", () => $2edaa75788d2b028$export$98c58b176174c8b0);
$parcel$export(module.exports, "emptySudoku", () => $2edaa75788d2b028$export$f6d442a523699f3f);
$parcel$export(module.exports, "diagonalString", () => $2edaa75788d2b028$export$9ca0dfbaffefb65);
$parcel$export(module.exports, "chunksOf", () => $2edaa75788d2b028$export$2f0184d5df52135f);
$parcel$export(module.exports, "cellEq", () => $2edaa75788d2b028$export$278abc255fec8194);
$parcel$export(module.exports, "allValues", () => $2edaa75788d2b028$export$31b2a2dc1e09954b);
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $cADnC = parcelRequire("cADnC");

var $brrpF = parcelRequire("brrpF");
var $d3m1K = parcelRequire("d3m1K");

var $beQI1 = parcelRequire("beQI1");

var $aJhEx = parcelRequire("aJhEx");

var $8tuSi = parcelRequire("8tuSi");

var $dNwPt = parcelRequire("dNwPt");

var $7FzSN = parcelRequire("7FzSN");
parcelRequire("hCjGZ");
var $dbLcE = parcelRequire("dbLcE");

var $bXKNp = parcelRequire("bXKNp");

var $aHmxC = parcelRequire("aHmxC");

var $h2xUu = parcelRequire("h2xUu");

var $ibsD5 = parcelRequire("ibsD5");

var $5mbCO = parcelRequire("5mbCO");

var $2XxiF = parcelRequire("2XxiF");
parcelRequire("4Fu8m");
var $f2i2N = parcelRequire("f2i2N");

var $7O0Q4 = parcelRequire("7O0Q4");

var $goKHx = parcelRequire("goKHx");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");

var $1rTTn = parcelRequire("1rTTn");

var $aJZEv = parcelRequire("aJZEv");
var $2edaa75788d2b028$var$fromFoldable = /* #__PURE__ */ $brrpF.fromFoldable($5mbCO.foldableSet);
var $2edaa75788d2b028$var$foldl = /* #__PURE__ */ $dNwPt.foldl($dNwPt.foldableArray);
var $2edaa75788d2b028$var$bind = /* #__PURE__ */ $cADnC.bind($h2xUu.bindMaybe);
var $2edaa75788d2b028$var$pure = /* #__PURE__ */ $bQdkN.pure($1rTTn.applicativeEffect);
var $2edaa75788d2b028$var$pure1 = /* #__PURE__ */ $bQdkN.pure($h2xUu.applicativeMaybe);
var $2edaa75788d2b028$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $2edaa75788d2b028$var$map1 = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $2edaa75788d2b028$var$mod = /* #__PURE__ */ $8tuSi.mod($8tuSi.euclideanRingInt);
var $2edaa75788d2b028$var$bindFlipped = /* #__PURE__ */ $cADnC.bindFlipped($h2xUu.bindMaybe);
var $2edaa75788d2b028$var$map2 = /* #__PURE__ */ $7FzSN.map($7FzSN.functorArray);
var $2edaa75788d2b028$var$elem = /* #__PURE__ */ $brrpF.elem($aJhEx.eqInt);
var $2edaa75788d2b028$var$pure2 = /* #__PURE__ */ $bQdkN.pure($bQdkN.applicativeArray);
var $2edaa75788d2b028$export$d5a1f56087d42b19 = /* #__PURE__ */ function() {
    function Standard() {}
    Standard.value = new Standard();
    return Standard;
}();
var $2edaa75788d2b028$export$9f64ad4387712eb1 = /* #__PURE__ */ function() {
    function UniqueDiagonal() {}
    UniqueDiagonal.value = new UniqueDiagonal();
    return UniqueDiagonal;
}();
var $2edaa75788d2b028$export$a213bbf7b9eeb22d = /* #__PURE__ */ function() {
    function V1() {}
    V1.value = new V1();
    return V1;
}();
var $2edaa75788d2b028$export$9b589fb896e0ad32 = /* #__PURE__ */ function() {
    function V2() {}
    V2.value = new V2();
    return V2;
}();
var $2edaa75788d2b028$export$d2aa6c54a5925f01 = /* #__PURE__ */ function() {
    function V3() {}
    V3.value = new V3();
    return V3;
}();
var $2edaa75788d2b028$export$2bd315ece9f68967 = /* #__PURE__ */ function() {
    function V4() {}
    V4.value = new V4();
    return V4;
}();
var $2edaa75788d2b028$export$effc3c8ae6441444 = /* #__PURE__ */ function() {
    function V5() {}
    V5.value = new V5();
    return V5;
}();
var $2edaa75788d2b028$export$2aa60b097ad4229c = /* #__PURE__ */ function() {
    function V6() {}
    V6.value = new V6();
    return V6;
}();
var $2edaa75788d2b028$export$6367b715712a3d57 = /* #__PURE__ */ function() {
    function V7() {}
    V7.value = new V7();
    return V7;
}();
var $2edaa75788d2b028$export$cdc54b025c52768 = /* #__PURE__ */ function() {
    function V8() {}
    V8.value = new V8();
    return V8;
}();
var $2edaa75788d2b028$export$22b8a75286fdebd6 = /* #__PURE__ */ function() {
    function V9() {}
    V9.value = new V9();
    return V9;
}();
var $2edaa75788d2b028$export$82dc29c19cc50d89 = /* #__PURE__ */ function() {
    function Tuple3(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Tuple3.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Tuple3(value0, value1, value2);
            };
        };
    };
    return Tuple3;
}();
var $2edaa75788d2b028$export$893673f0dd009d3 = /* #__PURE__ */ function() {
    function NoSolution() {}
    NoSolution.value = new NoSolution();
    return NoSolution;
}();
var $2edaa75788d2b028$export$8e3adf126971a183 = /* #__PURE__ */ function() {
    function Unique(value0) {
        this.value0 = value0;
    }
    Unique.create = function(value0) {
        return new Unique(value0);
    };
    return Unique;
}();
var $2edaa75788d2b028$export$eee85644b4921d28 = /* #__PURE__ */ function() {
    function NotUnique(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    NotUnique.create = function(value0) {
        return function(value1) {
            return new NotUnique(value0, value1);
        };
    };
    return NotUnique;
}();
var $2edaa75788d2b028$export$13475bbd2a37a9b4 = /* #__PURE__ */ function() {
    function Fixed(value0) {
        this.value0 = value0;
    }
    Fixed.create = function(value0) {
        return new Fixed(value0);
    };
    return Fixed;
}();
var $2edaa75788d2b028$export$f8b00adb3272ca6 = /* #__PURE__ */ function() {
    function Possible(value0) {
        this.value0 = value0;
    }
    Possible.create = function(value0) {
        return new Possible(value0);
    };
    return Possible;
}();
var $2edaa75788d2b028$export$a3c629e5d025ffc1 = function(f) {
    return function(as) {
        return function(bs) {
            return function(cs) {
                var v = new $2edaa75788d2b028$export$82dc29c19cc50d89($brrpF.uncons(as), $brrpF.uncons(bs), $brrpF.uncons(cs));
                if (v.value0 instanceof $h2xUu.Just && v.value1 instanceof $h2xUu.Just && v.value2 instanceof $h2xUu.Just) return $brrpF.cons(f(v.value0.value0.head)(v.value1.value0.head)(v.value2.value0.head))($2edaa75788d2b028$export$a3c629e5d025ffc1(f)(v.value0.value0.tail)(v.value1.value0.tail)(v.value2.value0.tail));
                return [];
            };
        };
    };
};
var $2edaa75788d2b028$export$7a5d5c156e7dc406 = function(dictEq) {
    return function(dictOrd) {
        var insert = $aHmxC.insert(dictOrd);
        return function(xs) {
            return $2edaa75788d2b028$var$fromFoldable($bXKNp.keys($2edaa75788d2b028$var$foldl(function(m) {
                return function(x) {
                    return insert(x)($ivFwO.unit)(m);
                };
            })($aHmxC.empty)(xs)));
        };
    };
};
var $2edaa75788d2b028$export$9cb09a71b7d66923 = function(l) {
    var v = $brrpF.uncons(l);
    if (v instanceof $h2xUu.Nothing) return [];
    if (v instanceof $h2xUu.Just) {
        var v1 = $brrpF.uncons(v.value0.head);
        if (v1 instanceof $h2xUu.Nothing) return $2edaa75788d2b028$export$9cb09a71b7d66923(v.value0.tail);
        if (v1 instanceof $h2xUu.Just) return $brrpF.cons($brrpF.cons(v1.value0.head)($brrpF.mapMaybe($brrpF.head)(v.value0.tail)))($2edaa75788d2b028$export$9cb09a71b7d66923($brrpF.cons(v1.value0.tail)($brrpF.mapMaybe($brrpF.tail)(v.value0.tail))));
        throw new Error("Failed pattern match at Sudoku.Internal (line 117, column 35 - line 122, column 62): " + [
            v1.constructor.name
        ]);
    }
    throw new Error("Failed pattern match at Sudoku.Internal (line 115, column 15 - line 122, column 62): " + [
        v.constructor.name
    ]);
};
var $2edaa75788d2b028$export$9acca84ac9c59e6b = function(v) {
    return function(v1) {
        if (v instanceof $h2xUu.Nothing) return new $beQI1.Left(v1);
        if (v instanceof $h2xUu.Just) return new $beQI1.Right(v.value0);
        throw new Error("Failed pattern match at Sudoku.Internal (line 133, column 1 - line 133, column 46): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $2edaa75788d2b028$export$9a0ad8278be5188d = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(v) {
            if (v instanceof $2edaa75788d2b028$export$893673f0dd009d3) return "NoSolution";
            if (v instanceof $2edaa75788d2b028$export$8e3adf126971a183) return "(Unique " + (show(v.value0) + ")");
            if (v instanceof $2edaa75788d2b028$export$eee85644b4921d28) return "(Unique " + (show(v.value0) + (" " + (show(v.value1) + " )")));
            throw new Error("Failed pattern match at Sudoku.Internal (line 46, column 1 - line 49, column 81): " + [
                v.constructor.name
            ]);
        }
    };
};
var $2edaa75788d2b028$export$224e3b7078227b8a = function(idx) {
    return function(f) {
        return function(xs) {
            return $h2xUu.fromMaybe(xs)($2edaa75788d2b028$var$bind($brrpF.index(xs)(idx))(function(x) {
                return $2edaa75788d2b028$var$bind($brrpF.deleteAt(idx)(xs))(function(xs$prime) {
                    return $brrpF.insertAt(idx)(f(x))(xs$prime);
                });
            }));
        };
    };
};
var $2edaa75788d2b028$export$9bcb57a486df0ae9 = function(input) {
    return function __do() {
        var k = $aJZEv.randomInt(0)($d3m1K.length(input) - 1 | 0)();
        return $h2xUu.fromMaybe($2edaa75788d2b028$var$pure([]))($2edaa75788d2b028$var$bind($brrpF.index(input)(k))(function(v) {
            return $2edaa75788d2b028$var$bind($brrpF.deleteAt(k)(input))(function(arr) {
                return $2edaa75788d2b028$var$pure1($2edaa75788d2b028$var$map($brrpF.cons(v))($2edaa75788d2b028$export$9bcb57a486df0ae9(arr)));
            });
        }))();
    };
};
var $2edaa75788d2b028$export$af631764ddc44097 = function(g) {
    return function(f) {
        return function(x) {
            return function(y) {
                return g(f(x))(f(y));
            };
        };
    };
};
var $2edaa75788d2b028$export$c3f2182113fa6151 = function(dictEq) {
    return function(dictOrd) {
        var lookup = $aHmxC.lookup(dictOrd);
        var insert = $aHmxC.insert(dictOrd);
        return function(arr) {
            return function(seen) {
                var f = function(x) {
                    var $83 = $h2xUu.isJust(lookup(x.head)(seen));
                    if ($83) return false;
                    return $2edaa75788d2b028$export$c3f2182113fa6151(dictEq)(dictOrd)(x.tail)(insert(x.head)($ivFwO.unit)(seen));
                };
                return $h2xUu.fromMaybe(true)($2edaa75788d2b028$var$map1(f)($brrpF.uncons(arr)));
            };
        };
    };
};
var $2edaa75788d2b028$export$bb807e921d36aa98 = function(dictEq) {
    var isUnique$prime1 = $2edaa75788d2b028$export$c3f2182113fa6151(dictEq);
    return function(dictOrd) {
        var isUnique$prime2 = isUnique$prime1(dictOrd);
        return function(l) {
            return isUnique$prime2(l)($aHmxC.empty);
        };
    };
};
var $2edaa75788d2b028$export$8b633acbde1156e3 = function(arr) {
    return function(i) {
        var v = new $7O0Q4.Tuple($dbLcE.quot(i)(9), $2edaa75788d2b028$var$mod(i)(9));
        return $2edaa75788d2b028$var$bindFlipped(function(arr$prime) {
            return $brrpF.index(arr$prime)(v.value0);
        })($brrpF.index(arr)(v.value1));
    };
};
var $2edaa75788d2b028$export$348af39216c9f47a = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $2edaa75788d2b028$export$893673f0dd009d3) return $2edaa75788d2b028$export$893673f0dd009d3.value;
            if (v1 instanceof $2edaa75788d2b028$export$8e3adf126971a183) return new $2edaa75788d2b028$export$8e3adf126971a183(v(v1.value0));
            if (v1 instanceof $2edaa75788d2b028$export$eee85644b4921d28) return new $2edaa75788d2b028$export$eee85644b4921d28(v(v1.value0), v(v1.value1));
            throw new Error("Failed pattern match at Sudoku.Internal (line 51, column 1 - line 54, column 48): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $2edaa75788d2b028$export$7e7ad869a5fd5749 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $2edaa75788d2b028$export$a213bbf7b9eeb22d && y instanceof $2edaa75788d2b028$export$a213bbf7b9eeb22d) return true;
            if (x instanceof $2edaa75788d2b028$export$9b589fb896e0ad32 && y instanceof $2edaa75788d2b028$export$9b589fb896e0ad32) return true;
            if (x instanceof $2edaa75788d2b028$export$d2aa6c54a5925f01 && y instanceof $2edaa75788d2b028$export$d2aa6c54a5925f01) return true;
            if (x instanceof $2edaa75788d2b028$export$2bd315ece9f68967 && y instanceof $2edaa75788d2b028$export$2bd315ece9f68967) return true;
            if (x instanceof $2edaa75788d2b028$export$effc3c8ae6441444 && y instanceof $2edaa75788d2b028$export$effc3c8ae6441444) return true;
            if (x instanceof $2edaa75788d2b028$export$2aa60b097ad4229c && y instanceof $2edaa75788d2b028$export$2aa60b097ad4229c) return true;
            if (x instanceof $2edaa75788d2b028$export$6367b715712a3d57 && y instanceof $2edaa75788d2b028$export$6367b715712a3d57) return true;
            if (x instanceof $2edaa75788d2b028$export$cdc54b025c52768 && y instanceof $2edaa75788d2b028$export$cdc54b025c52768) return true;
            if (x instanceof $2edaa75788d2b028$export$22b8a75286fdebd6 && y instanceof $2edaa75788d2b028$export$22b8a75286fdebd6) return true;
            return false;
        };
    }
};
var $2edaa75788d2b028$var$eq = /* #__PURE__ */ $aJhEx.eq($2edaa75788d2b028$export$7e7ad869a5fd5749);
var $2edaa75788d2b028$var$eq1 = /* #__PURE__ */ $aJhEx.eq(/* #__PURE__ */ $aJhEx.eqArray($2edaa75788d2b028$export$7e7ad869a5fd5749));
var $2edaa75788d2b028$export$98c58b176174c8b0 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $2edaa75788d2b028$export$a213bbf7b9eeb22d && y instanceof $2edaa75788d2b028$export$a213bbf7b9eeb22d) return $ibsD5.EQ.value;
            if (x instanceof $2edaa75788d2b028$export$a213bbf7b9eeb22d) return $ibsD5.LT.value;
            if (y instanceof $2edaa75788d2b028$export$a213bbf7b9eeb22d) return $ibsD5.GT.value;
            if (x instanceof $2edaa75788d2b028$export$9b589fb896e0ad32 && y instanceof $2edaa75788d2b028$export$9b589fb896e0ad32) return $ibsD5.EQ.value;
            if (x instanceof $2edaa75788d2b028$export$9b589fb896e0ad32) return $ibsD5.LT.value;
            if (y instanceof $2edaa75788d2b028$export$9b589fb896e0ad32) return $ibsD5.GT.value;
            if (x instanceof $2edaa75788d2b028$export$d2aa6c54a5925f01 && y instanceof $2edaa75788d2b028$export$d2aa6c54a5925f01) return $ibsD5.EQ.value;
            if (x instanceof $2edaa75788d2b028$export$d2aa6c54a5925f01) return $ibsD5.LT.value;
            if (y instanceof $2edaa75788d2b028$export$d2aa6c54a5925f01) return $ibsD5.GT.value;
            if (x instanceof $2edaa75788d2b028$export$2bd315ece9f68967 && y instanceof $2edaa75788d2b028$export$2bd315ece9f68967) return $ibsD5.EQ.value;
            if (x instanceof $2edaa75788d2b028$export$2bd315ece9f68967) return $ibsD5.LT.value;
            if (y instanceof $2edaa75788d2b028$export$2bd315ece9f68967) return $ibsD5.GT.value;
            if (x instanceof $2edaa75788d2b028$export$effc3c8ae6441444 && y instanceof $2edaa75788d2b028$export$effc3c8ae6441444) return $ibsD5.EQ.value;
            if (x instanceof $2edaa75788d2b028$export$effc3c8ae6441444) return $ibsD5.LT.value;
            if (y instanceof $2edaa75788d2b028$export$effc3c8ae6441444) return $ibsD5.GT.value;
            if (x instanceof $2edaa75788d2b028$export$2aa60b097ad4229c && y instanceof $2edaa75788d2b028$export$2aa60b097ad4229c) return $ibsD5.EQ.value;
            if (x instanceof $2edaa75788d2b028$export$2aa60b097ad4229c) return $ibsD5.LT.value;
            if (y instanceof $2edaa75788d2b028$export$2aa60b097ad4229c) return $ibsD5.GT.value;
            if (x instanceof $2edaa75788d2b028$export$6367b715712a3d57 && y instanceof $2edaa75788d2b028$export$6367b715712a3d57) return $ibsD5.EQ.value;
            if (x instanceof $2edaa75788d2b028$export$6367b715712a3d57) return $ibsD5.LT.value;
            if (y instanceof $2edaa75788d2b028$export$6367b715712a3d57) return $ibsD5.GT.value;
            if (x instanceof $2edaa75788d2b028$export$cdc54b025c52768 && y instanceof $2edaa75788d2b028$export$cdc54b025c52768) return $ibsD5.EQ.value;
            if (x instanceof $2edaa75788d2b028$export$cdc54b025c52768) return $ibsD5.LT.value;
            if (y instanceof $2edaa75788d2b028$export$cdc54b025c52768) return $ibsD5.GT.value;
            if (x instanceof $2edaa75788d2b028$export$22b8a75286fdebd6 && y instanceof $2edaa75788d2b028$export$22b8a75286fdebd6) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at Sudoku.Internal (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $2edaa75788d2b028$export$7e7ad869a5fd5749;
    }
};
var $2edaa75788d2b028$export$f6d442a523699f3f = /* #__PURE__ */ $f2i2N.fromCharArray(/* #__PURE__ */ $goKHx.replicate($goKHx.unfoldableArray)(81)("."));
var $2edaa75788d2b028$export$9ca0dfbaffefb65 = function(str) {
    var idxs = $2edaa75788d2b028$var$map2(function(x) {
        return 10 * x | 0;
    })($d3m1K.range(0)(8));
    var onlyDiag = function(s) {
        return function(v) {
            var $98 = $2edaa75788d2b028$var$elem(v.value1)(idxs);
            if ($98) return s + $f2i2N.singleton(v.value0);
            return s;
        };
    };
    return $2edaa75788d2b028$var$foldl(onlyDiag)("")($brrpF.zip($f2i2N.toCharArray(str))($d3m1K.range(0)(80)));
};
var $2edaa75788d2b028$export$2f0184d5df52135f = function(n) {
    return function(xs) {
        var $101 = $brrpF.null($brrpF.drop(n)(xs));
        if ($101) return $2edaa75788d2b028$var$pure2(xs);
        return $brrpF.cons($brrpF.take(n)(xs))($2edaa75788d2b028$export$2f0184d5df52135f(n)($brrpF.drop(n)(xs)));
    };
};
var $2edaa75788d2b028$export$6851d97c92089066 = {
    show: function(v) {
        if (v instanceof $2edaa75788d2b028$export$13475bbd2a37a9b4) return ".";
        if (v instanceof $2edaa75788d2b028$export$f8b00adb3272ca6) return ".";
        throw new Error("Failed pattern match at Sudoku.Internal (line 33, column 1 - line 35, column 26): " + [
            v.constructor.name
        ]);
    }
};
var $2edaa75788d2b028$export$278abc255fec8194 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $2edaa75788d2b028$export$13475bbd2a37a9b4 && y instanceof $2edaa75788d2b028$export$13475bbd2a37a9b4) return $2edaa75788d2b028$var$eq(x.value0)(y.value0);
            if (x instanceof $2edaa75788d2b028$export$f8b00adb3272ca6 && y instanceof $2edaa75788d2b028$export$f8b00adb3272ca6) return $2edaa75788d2b028$var$eq1(x.value0)(y.value0);
            return false;
        };
    }
};
var $2edaa75788d2b028$export$31b2a2dc1e09954b = /* #__PURE__ */ function() {
    return [
        $2edaa75788d2b028$export$a213bbf7b9eeb22d.value,
        $2edaa75788d2b028$export$9b589fb896e0ad32.value,
        $2edaa75788d2b028$export$d2aa6c54a5925f01.value,
        $2edaa75788d2b028$export$2bd315ece9f68967.value,
        $2edaa75788d2b028$export$effc3c8ae6441444.value,
        $2edaa75788d2b028$export$2aa60b097ad4229c.value,
        $2edaa75788d2b028$export$6367b715712a3d57.value,
        $2edaa75788d2b028$export$cdc54b025c52768.value,
        $2edaa75788d2b028$export$22b8a75286fdebd6.value
    ];
}();

});
parcelRegister("bXKNp", function(module, exports) {

$parcel$export(module.exports, "keys", () => $8b59811c1f17d1fe$export$ed97f33186d4b816);
// Generated by purs version 0.15.16

var $7FzSN = parcelRequire("7FzSN");

var $aHmxC = parcelRequire("aHmxC");

var $d5vvq = parcelRequire("d5vvq");

var $5mbCO = parcelRequire("5mbCO");
var $8b59811c1f17d1fe$export$6f6f12e098819a11 = function(x) {
    return x;
};
var $8b59811c1f17d1fe$export$3c5e6b006a1d848e = $aHmxC.traversableWithIndexMap;
var $8b59811c1f17d1fe$export$4e81f95457a4f9c5 = $aHmxC.traversableMap;
var $8b59811c1f17d1fe$export$f5ad5bc4482e056b = function(dictShow) {
    var showMap = $aHmxC.showMap(dictShow);
    return function(dictShow1) {
        return showMap(dictShow1);
    };
};
var $8b59811c1f17d1fe$export$c5313cc0fc33667c = function(dictOrd) {
    var unionWith = $aHmxC.unionWith(dictOrd);
    return function(dictSemigroup) {
        var append = $d5vvq.append(dictSemigroup);
        return {
            append: function(v) {
                return function(v1) {
                    return unionWith(append)(v)(v1);
                };
            }
        };
    };
};
var $8b59811c1f17d1fe$export$38a252bff8e0b233 = function(dictOrd) {
    return $aHmxC.plusMap(dictOrd);
};
var $8b59811c1f17d1fe$export$4d301b1aaca6e5ee = function(dictOrd) {
    var ordMap = $aHmxC.ordMap(dictOrd);
    return function(dictOrd1) {
        return ordMap(dictOrd1);
    };
};
var $8b59811c1f17d1fe$export$3a647d35f27c2c21 = function(dictOrd) {
    return $aHmxC.ord1Map(dictOrd);
};
var $8b59811c1f17d1fe$export$4eb746bad571b4ba = {
    Coercible0: function() {
        return undefined;
    }
};
var $8b59811c1f17d1fe$export$546d2468bc9efbc6 = function(dictOrd) {
    var semigroupSemigroupMap1 = $8b59811c1f17d1fe$export$c5313cc0fc33667c(dictOrd);
    return function(dictSemigroup) {
        var semigroupSemigroupMap2 = semigroupSemigroupMap1(dictSemigroup);
        return {
            mempty: $aHmxC.empty,
            Semigroup0: function() {
                return semigroupSemigroupMap2;
            }
        };
    };
};
var $8b59811c1f17d1fe$export$ed97f33186d4b816 = /* #__PURE__ */ function() {
    var $38 = $7FzSN.void($aHmxC.functorMap);
    return function($39) {
        return $5mbCO.fromMap($38($39));
    };
}();
var $8b59811c1f17d1fe$export$1096fce6f8157f49 = $aHmxC.functorWithIndexMap;
var $8b59811c1f17d1fe$export$96367dab66c5c370 = $aHmxC.functorMap;
var $8b59811c1f17d1fe$export$239aaad87589a3f0 = $aHmxC.foldableWithIndexMap;
var $8b59811c1f17d1fe$export$732ac04c4dce73f6 = $aHmxC.foldableMap;
var $8b59811c1f17d1fe$export$884432d781bab8d3 = function(dictEq) {
    var eqMap = $aHmxC.eqMap(dictEq);
    return function(dictEq1) {
        return eqMap(dictEq1);
    };
};
var $8b59811c1f17d1fe$export$64a7582da2ca8e9c = function(dictEq) {
    return $aHmxC.eq1Map(dictEq);
};
var $8b59811c1f17d1fe$export$e9f090025f05634f = function(dictOrd) {
    return $aHmxC.bindMap(dictOrd);
};
var $8b59811c1f17d1fe$export$bb3d8f5a7f1d9f6a = function(dictOrd) {
    return $aHmxC.applyMap(dictOrd);
};
var $8b59811c1f17d1fe$export$fb15286a85c58e76 = function(dictOrd) {
    return $aHmxC.altMap(dictOrd);
};

});
parcelRegister("5mbCO", function(module, exports) {

$parcel$export(module.exports, "fromMap", () => $3e680649b53148d7$export$d81aa96f14f987cc);
$parcel$export(module.exports, "foldableSet", () => $3e680649b53148d7$export$fd19c21b7e75dff0);
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $cADnC = parcelRequire("cADnC");

var $26SV5 = parcelRequire("26SV5");

var $bcJ05 = parcelRequire("bcJ05");

var $k1We4 = parcelRequire("k1We4");

var $brrpF = parcelRequire("brrpF");
var $d3m1K = parcelRequire("d3m1K");
parcelRequire("8cbRe");
var $hnZPO = parcelRequire("hnZPO");
var $8cbRe = parcelRequire("8cbRe");

var $aJhEx = parcelRequire("aJhEx");

var $dNwPt = parcelRequire("dNwPt");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $5krR0 = parcelRequire("5krR0");

var $fZenR = parcelRequire("fZenR");

var $aHmxC = parcelRequire("aHmxC");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $2XxiF = parcelRequire("2XxiF");

var $goKHx = parcelRequire("goKHx");
parcelRequire("2jM6U");
var $ivFwO = parcelRequire("ivFwO");
var $3e680649b53148d7$var$foldMap = /* #__PURE__ */ $dNwPt.foldMap($fZenR.foldableList);
var $3e680649b53148d7$var$foldl = /* #__PURE__ */ $dNwPt.foldl($fZenR.foldableList);
var $3e680649b53148d7$var$foldr = /* #__PURE__ */ $dNwPt.foldr($fZenR.foldableList);
var $3e680649b53148d7$var$map1 = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $3e680649b53148d7$var$fromFoldable1 = /* #__PURE__ */ $brrpF.fromFoldable($fZenR.foldableList);
var $3e680649b53148d7$var$unsafeIndex = /* #__PURE__ */ $brrpF.unsafeIndex();
var $3e680649b53148d7$var$bind = /* #__PURE__ */ $cADnC.bind($k1We4.bindST);
var $3e680649b53148d7$var$pure = /* #__PURE__ */ $bQdkN.pure($k1We4.applicativeST);
var $3e680649b53148d7$var$tailRecM2 = /* #__PURE__ */ $bcJ05.tailRecM2($k1We4.monadRecST);
var $3e680649b53148d7$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $3e680649b53148d7$var$$$Set = function(x) {
    return x;
};
var $3e680649b53148d7$export$971dd5b0dfd021b6 = function(dictOrd) {
    var union1 = $aHmxC.union(dictOrd);
    return function(v) {
        return function(v1) {
            return union1(v)(v1);
        };
    };
};
var $3e680649b53148d7$export$e03c1c3201ee8bb7 = function(dictOrd) {
    var alter = $aHmxC.alter(dictOrd);
    return function(a) {
        return function(v) {
            return alter($h2xUu.maybe(new $h2xUu.Just($ivFwO.unit))(function(v1) {
                return $h2xUu.Nothing.value;
            }))(a)(v);
        };
    };
};
var $3e680649b53148d7$export$e98af36a72b77685 = function(v) {
    return v;
};
var $3e680649b53148d7$var$toList = function(v) {
    return $aHmxC.keys(v);
};
var $3e680649b53148d7$export$823be24f8766da23 = function(dictUnfoldable) {
    var $127 = $5krR0.toUnfoldable(dictUnfoldable);
    return function($128) {
        return $127($3e680649b53148d7$var$toList($128));
    };
};
var $3e680649b53148d7$var$toUnfoldable1 = /* #__PURE__ */ $3e680649b53148d7$export$823be24f8766da23($goKHx.unfoldableArray);
var $3e680649b53148d7$export$346677f925de839c = function(v) {
    return $aHmxC.size(v);
};
var $3e680649b53148d7$export$439306a4dcaafbb9 = function(a) {
    return $aHmxC.singleton(a)($ivFwO.unit);
};
var $3e680649b53148d7$export$10430edbe04e7f5c = function(dictShow) {
    var show = $2XxiF.show($2XxiF.showArray(dictShow));
    return {
        show: function(s) {
            return "(fromFoldable " + (show($3e680649b53148d7$var$toUnfoldable1(s)) + ")");
        }
    };
};
var $3e680649b53148d7$export$7c6a06df4f9b9fb3 = function(dictOrd) {
    return {
        append: $3e680649b53148d7$export$971dd5b0dfd021b6(dictOrd)
    };
};
var $3e680649b53148d7$export$6a0d13241802fe80 = function(dictOrd) {
    var member1 = $aHmxC.member(dictOrd);
    return function(a) {
        return function(v) {
            return member1(a)(v);
        };
    };
};
var $3e680649b53148d7$export$dd1bc94b04021eeb = function(v) {
    return $aHmxC.isEmpty(v);
};
var $3e680649b53148d7$export$21a5ca8aa77d35ff = function(dictOrd) {
    var insert1 = $aHmxC.insert(dictOrd);
    return function(a) {
        return function(v) {
            return insert1(a)($ivFwO.unit)(v);
        };
    };
};
var $3e680649b53148d7$export$d81aa96f14f987cc = $3e680649b53148d7$var$$$Set;
var $3e680649b53148d7$export$fd19c21b7e75dff0 = {
    foldMap: function(dictMonoid) {
        var foldMap1 = $3e680649b53148d7$var$foldMap(dictMonoid);
        return function(f) {
            var $129 = foldMap1(f);
            return function($130) {
                return $129($3e680649b53148d7$var$toList($130));
            };
        };
    },
    foldl: function(f) {
        return function(x) {
            var $131 = $3e680649b53148d7$var$foldl(f)(x);
            return function($132) {
                return $131($3e680649b53148d7$var$toList($132));
            };
        };
    },
    foldr: function(f) {
        return function(x) {
            var $133 = $3e680649b53148d7$var$foldr(f)(x);
            return function($134) {
                return $133($3e680649b53148d7$var$toList($134));
            };
        };
    }
};
var $3e680649b53148d7$var$foldl1 = /* #__PURE__ */ $dNwPt.foldl($3e680649b53148d7$export$fd19c21b7e75dff0);
var $3e680649b53148d7$var$foldr1 = /* #__PURE__ */ $dNwPt.foldr($3e680649b53148d7$export$fd19c21b7e75dff0);
var $3e680649b53148d7$export$3c39a95b7a4d5e28 = function(v) {
    return $3e680649b53148d7$var$map1(function(v1) {
        return v1.key;
    })($aHmxC.findMin(v));
};
var $3e680649b53148d7$export$35f577b3da447d17 = function(v) {
    return $3e680649b53148d7$var$map1(function(v1) {
        return v1.key;
    })($aHmxC.findMax(v));
};
var $3e680649b53148d7$export$3dea766d36a8935f = function(dictOrd) {
    var filterWithKey = $aHmxC.filterWithKey(dictOrd);
    return function(f) {
        return function(v) {
            return filterWithKey(function(k) {
                return function(v1) {
                    return f(k);
                };
            })(v);
        };
    };
};
var $3e680649b53148d7$export$15038a5bf6277d57 = function(dictEq) {
    var eq = $aJhEx.eq($aHmxC.eqMap(dictEq)($aJhEx.eqUnit));
    return {
        eq: function(v) {
            return function(v1) {
                return eq(v)(v1);
            };
        }
    };
};
var $3e680649b53148d7$export$273c875222ee923d = function(dictOrd) {
    var compare = $gwBF5.compare($fZenR.ordList(dictOrd));
    var eqSet1 = $3e680649b53148d7$export$15038a5bf6277d57(dictOrd.Eq0());
    return {
        compare: function(s1) {
            return function(s2) {
                return compare($3e680649b53148d7$var$toList(s1))($3e680649b53148d7$var$toList(s2));
            };
        },
        Eq0: function() {
            return eqSet1;
        }
    };
};
var $3e680649b53148d7$export$886f72205c1e73dc = {
    eq1: function(dictEq) {
        return $aJhEx.eq($3e680649b53148d7$export$15038a5bf6277d57(dictEq));
    }
};
var $3e680649b53148d7$export$3f209a28ab615424 = {
    compare1: function(dictOrd) {
        return $gwBF5.compare($3e680649b53148d7$export$273c875222ee923d(dictOrd));
    },
    Eq10: function() {
        return $3e680649b53148d7$export$886f72205c1e73dc;
    }
};
var $3e680649b53148d7$export$6e22c362a0406a2c = $aHmxC.empty;
var $3e680649b53148d7$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var foldl2 = $dNwPt.foldl(dictFoldable);
    return function(dictOrd) {
        var insert1 = $3e680649b53148d7$export$21a5ca8aa77d35ff(dictOrd);
        return foldl2(function(m) {
            return function(a) {
                return insert1(a)(m);
            };
        })($3e680649b53148d7$export$6e22c362a0406a2c);
    };
};
var $3e680649b53148d7$var$fromFoldable2 = /* #__PURE__ */ $3e680649b53148d7$export$b7d5d9bb9ff52072($dNwPt.foldableArray);
var $3e680649b53148d7$export$bc86dfbf7795668c = function(dictOrd) {
    var compare = $gwBF5.compare(dictOrd);
    var fromFoldable3 = $3e680649b53148d7$var$fromFoldable2(dictOrd);
    return function(s1) {
        return function(s2) {
            var toArray = function($135) {
                return $3e680649b53148d7$var$fromFoldable1($3e680649b53148d7$var$toList($135));
            };
            var rs = toArray(s2);
            var rl = $d3m1K.length(rs);
            var ls = toArray(s1);
            var ll = $d3m1K.length(ls);
            var intersect = function(acc) {
                var go = function(l) {
                    return function(r) {
                        var $122 = l < ll && r < rl;
                        if ($122) {
                            var v = compare($3e680649b53148d7$var$unsafeIndex(ls)(l))($3e680649b53148d7$var$unsafeIndex(rs)(r));
                            if (v instanceof $ibsD5.EQ) return function __do() {
                                $8cbRe.push($3e680649b53148d7$var$unsafeIndex(ls)(l))(acc)();
                                return new $bcJ05.Loop({
                                    a: l + 1 | 0,
                                    b: r + 1 | 0
                                });
                            };
                            if (v instanceof $ibsD5.LT) return $3e680649b53148d7$var$pure(new $bcJ05.Loop({
                                a: l + 1 | 0,
                                b: r
                            }));
                            if (v instanceof $ibsD5.GT) return $3e680649b53148d7$var$pure(new $bcJ05.Loop({
                                a: l,
                                b: r + 1 | 0
                            }));
                            throw new Error("Failed pattern match at Data.Set (line 184, column 12 - line 189, column 43): " + [
                                v.constructor.name
                            ]);
                        }
                        return $3e680649b53148d7$var$pure(new $bcJ05.Done(acc));
                    };
                };
                return $3e680649b53148d7$var$tailRecM2(go)(0)(0);
            };
            return fromFoldable3($3e680649b53148d7$var$bind($3e680649b53148d7$var$bind($hnZPO.new)(intersect))($hnZPO.unsafeFreeze)());
        };
    };
};
var $3e680649b53148d7$export$871de8747c9eaa88 = function(dictOrd) {
    var insert1 = $3e680649b53148d7$export$21a5ca8aa77d35ff(dictOrd);
    return function(f) {
        return $3e680649b53148d7$var$foldl1(function(m) {
            return function(a) {
                return insert1(f(a))(m);
            };
        })($3e680649b53148d7$export$6e22c362a0406a2c);
    };
};
var $3e680649b53148d7$export$e70771d2e7e590a = function(dictOrd) {
    var insert1 = $3e680649b53148d7$export$21a5ca8aa77d35ff(dictOrd);
    return function(f) {
        return $3e680649b53148d7$var$foldr1(function(a) {
            return function(acc) {
                return $h2xUu.maybe(acc)(function(b) {
                    return insert1(b)(acc);
                })(f(a));
            };
        })($3e680649b53148d7$export$6e22c362a0406a2c);
    };
};
var $3e680649b53148d7$export$30c0d87180d1a2c7 = function(dictOrd) {
    var semigroupSet1 = $3e680649b53148d7$export$7c6a06df4f9b9fb3(dictOrd);
    return {
        mempty: $3e680649b53148d7$export$6e22c362a0406a2c,
        Semigroup0: function() {
            return semigroupSet1;
        }
    };
};
var $3e680649b53148d7$export$30b2db2f7030f6cf = function(dictFoldable) {
    var foldl2 = $dNwPt.foldl(dictFoldable);
    return function(dictOrd) {
        return foldl2($3e680649b53148d7$export$971dd5b0dfd021b6(dictOrd))($3e680649b53148d7$export$6e22c362a0406a2c);
    };
};
var $3e680649b53148d7$export$1822828d790e23ee = function(dictOrd) {
    var delete1 = $aHmxC.delete(dictOrd);
    return function(a) {
        return function(v) {
            return delete1(a)(v);
        };
    };
};
var $3e680649b53148d7$export$acaf96a27438246b = function(dictOrd) {
    var delete1 = $3e680649b53148d7$export$1822828d790e23ee(dictOrd);
    return function(s1) {
        return function(s2) {
            return $3e680649b53148d7$var$foldl($jhsiw.flip(delete1))(s1)($3e680649b53148d7$var$toList(s2));
        };
    };
};
var $3e680649b53148d7$export$e06bd7b1ab877a71 = function(dictOrd) {
    var difference1 = $3e680649b53148d7$export$acaf96a27438246b(dictOrd);
    return function(s1) {
        return function(s2) {
            return $3e680649b53148d7$export$dd1bc94b04021eeb(difference1(s1)(s2));
        };
    };
};
var $3e680649b53148d7$export$fed8bbb04775a01f = function(dictOrd) {
    var subset1 = $3e680649b53148d7$export$e06bd7b1ab877a71(dictOrd);
    var notEq = $aJhEx.notEq($3e680649b53148d7$export$15038a5bf6277d57(dictOrd.Eq0()));
    return function(s1) {
        return function(s2) {
            return subset1(s1)(s2) && notEq(s1)(s2);
        };
    };
};
var $3e680649b53148d7$export$6583e3e95cb5e9d1 = function(v) {
    return $aHmxC.checkValid(v);
};
var $3e680649b53148d7$export$986c2bbe7a34be0b = function(dictOrd) {
    return $3e680649b53148d7$export$e70771d2e7e590a(dictOrd)($3e680649b53148d7$var$identity);
};

});



parcelRegister("lM1z4", function(module, exports) {

$parcel$export(module.exports, "traverseRows", () => $fd9f4b5d79516886$export$d183a017f3d0b56e);
$parcel$export(module.exports, "transpose", () => $fd9f4b5d79516886$export$9cb09a71b7d66923);
$parcel$export(module.exports, "subGridsToRows", () => $fd9f4b5d79516886$export$a75c60be977fa5f1);
$parcel$export(module.exports, "replace2D", () => $fd9f4b5d79516886$export$d6b45213194821a0);
$parcel$export(module.exports, "readGrid", () => $fd9f4b5d79516886$export$8ace596bc4bf9a61);
$parcel$export(module.exports, "gridString", () => $fd9f4b5d79516886$export$11652df2f7ef903f);
$parcel$export(module.exports, "extract", () => $fd9f4b5d79516886$export$f9380c9a627682d3);
$parcel$export(module.exports, "eqGrid", () => $fd9f4b5d79516886$export$48cf6bfc83a98ac1);
$parcel$export(module.exports, "emptyGridWith", () => $fd9f4b5d79516886$export$54decea3fbb1082f);
$parcel$export(module.exports, "diagonalOf", () => $fd9f4b5d79516886$export$a9fafc4b78696fc0);
$parcel$export(module.exports, "replaceDiagonal", () => $fd9f4b5d79516886$export$88cc558b59e43ac1);
// Generated by purs version 0.15.16

var $cADnC = parcelRequire("cADnC");
parcelRequire("brrpF");
var $d3m1K = parcelRequire("d3m1K");
var $brrpF = parcelRequire("brrpF");

var $iQTlW = parcelRequire("iQTlW");

var $beQI1 = parcelRequire("beQI1");

var $aJhEx = parcelRequire("aJhEx");

var $8tuSi = parcelRequire("8tuSi");

var $dNwPt = parcelRequire("dNwPt");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");
parcelRequire("hCjGZ");
var $dbLcE = parcelRequire("dbLcE");

var $h2xUu = parcelRequire("h2xUu");

var $iVjQa = parcelRequire("iVjQa");

var $2XxiF = parcelRequire("2XxiF");

var $bqDN9 = parcelRequire("bqDN9");
parcelRequire("4Fu8m");
var $f2i2N = parcelRequire("f2i2N");
parcelRequire("d8ahy");
var $3BU4Z = parcelRequire("3BU4Z");

var $9OOYG = parcelRequire("9OOYG");

var $7O0Q4 = parcelRequire("7O0Q4");

var $41p0v = parcelRequire("41p0v");

var $624no = parcelRequire("624no");
var $fd9f4b5d79516886$var$map = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $fd9f4b5d79516886$var$traverse = /* #__PURE__ */ $9OOYG.traverse($9OOYG.traversableArray);
var $fd9f4b5d79516886$var$traverse1 = /* #__PURE__ */ $fd9f4b5d79516886$var$traverse($h2xUu.applicativeMaybe);
var $fd9f4b5d79516886$var$map1 = /* #__PURE__ */ $7FzSN.map($7FzSN.functorArray);
var $fd9f4b5d79516886$var$bindFlipped = /* #__PURE__ */ $cADnC.bindFlipped($cADnC.bindArray);
var $fd9f4b5d79516886$var$mod = /* #__PURE__ */ $8tuSi.mod($8tuSi.euclideanRingInt);
var $fd9f4b5d79516886$var$show = /* #__PURE__ */ $2XxiF.show($2XxiF.showChar);
var $fd9f4b5d79516886$var$map2 = /* #__PURE__ */ $7FzSN.map($beQI1.functorEither);
var $fd9f4b5d79516886$var$traverse2 = /* #__PURE__ */ $fd9f4b5d79516886$var$traverse($beQI1.applicativeEither);
var $fd9f4b5d79516886$var$eq2 = /* #__PURE__ */ $aJhEx.eq(/* #__PURE__ */ $aJhEx.eqArray(/* #__PURE__ */ $aJhEx.eqArray($41p0v.cellEq)));
var $fd9f4b5d79516886$var$foldl = /* #__PURE__ */ $dNwPt.foldl($dNwPt.foldableArray);
var $fd9f4b5d79516886$var$Grid = function(x) {
    return x;
};
var $fd9f4b5d79516886$export$d183a017f3d0b56e = function(f) {
    return function(v) {
        return $fd9f4b5d79516886$var$map($fd9f4b5d79516886$var$Grid)($fd9f4b5d79516886$var$traverse1(f)(v));
    };
};
var $fd9f4b5d79516886$export$9cb09a71b7d66923 = function(v) {
    return $41p0v.transpose(v);
};
var $fd9f4b5d79516886$export$a75c60be977fa5f1 = function(v) {
    var take3 = function(n) {
        var $67 = $fd9f4b5d79516886$var$map1($7O0Q4.snd);
        var $68 = $d3m1K.filter(function(v1) {
            return $dbLcE.quot(v1.value0)(3) === n;
        });
        var $69 = $brrpF.zip($d3m1K.range(0)(8));
        return function($70) {
            return $67($68($69($70)));
        };
    };
    return $fd9f4b5d79516886$var$bindFlipped(function(rs) {
        var r2 = $fd9f4b5d79516886$var$map1(function(r) {
            return take3(2)(r);
        })(rs);
        var r1 = $fd9f4b5d79516886$var$map1(function(r) {
            return take3(1)(r);
        })(rs);
        var r0 = $fd9f4b5d79516886$var$map1(function(r) {
            return take3(0)(r);
        })(rs);
        return [
            $d3m1K.concat(r0),
            $d3m1K.concat(r1),
            $d3m1K.concat(r2)
        ];
    })($41p0v.chunksOf(3)(v));
};
var $fd9f4b5d79516886$export$d6b45213194821a0 = function(i) {
    return function(v) {
        return function(v1) {
            var v3 = new $7O0Q4.Tuple($dbLcE.quot(i)(9), $fd9f4b5d79516886$var$mod(i)(9));
            return $41p0v.replaceAt(v3.value0)($41p0v.replaceAt(v3.value1)($jhsiw.const(v)))(v1);
        };
    };
};
var $fd9f4b5d79516886$export$8ace596bc4bf9a61 = function(key) {
    return function(s) {
        var readCell = function(k) {
            return function(c) {
                if (c === ".") return new $beQI1.Right(new $41p0v.Possible($41p0v.allValues));
                if ($iQTlW.otherwise) {
                    var v = $624no.fromChar(k)(c);
                    if (v instanceof $h2xUu.Just) return new $beQI1.Right(new $41p0v.Fixed(v.value0));
                    if (v instanceof $h2xUu.Nothing) return new $beQI1.Left("character " + ($fd9f4b5d79516886$var$show(c) + " is not in the key"));
                    throw new Error("Failed pattern match at Sudoku.Internal.Grid (line 42, column 19 - line 44, column 73): " + [
                        v.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Sudoku.Internal.Grid (line 39, column 3 - line 39, column 61): " + [
                    k.constructor.name,
                    c.constructor.name
                ]);
            };
        };
        var $53 = $bqDN9.length(s) !== 81;
        if ($53) return new $beQI1.Left("input must be exactly 81 characters long");
        return $fd9f4b5d79516886$var$map2($fd9f4b5d79516886$var$Grid)($fd9f4b5d79516886$var$traverse2($fd9f4b5d79516886$var$traverse2(readCell(key)))($41p0v.chunksOf(9)($f2i2N.toCharArray(s))));
    };
};
var $fd9f4b5d79516886$export$11652df2f7ef903f = function(key) {
    return function(v) {
        var cellToChar = function(v1) {
            return function(v2) {
                if (v2 instanceof $41p0v.Fixed) return $f2i2N.singleton($624no.toChar(v1)(v2.value0));
                if (v2 instanceof $41p0v.Possible) return ".";
                throw new Error("Failed pattern match at Sudoku.Internal.Grid (line 49, column 3 - line 49, column 51): " + [
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
        return $3BU4Z.joinWith("")($fd9f4b5d79516886$var$map1(function() {
            var $71 = $3BU4Z.joinWith("");
            var $72 = $fd9f4b5d79516886$var$map1(cellToChar(key));
            return function($73) {
                return $71($72($73));
            };
        }())(v));
    };
};
var $fd9f4b5d79516886$export$f9380c9a627682d3 = function(v) {
    return v;
};
var $fd9f4b5d79516886$export$48cf6bfc83a98ac1 = {
    eq: function(x) {
        return function(y) {
            return $fd9f4b5d79516886$var$eq2(x)(y);
        };
    }
};
var $fd9f4b5d79516886$export$54decea3fbb1082f = function(values) {
    return $d3m1K.replicate(9)($d3m1K.replicate(9)(new $41p0v.Possible(values)));
};
var $fd9f4b5d79516886$var$diagIdxs = /* #__PURE__ */ $fd9f4b5d79516886$var$map1(/* #__PURE__ */ $iVjQa.mul($iVjQa.semiringInt)(10))(/* #__PURE__ */ $d3m1K.range(0)(8));
var $fd9f4b5d79516886$export$a9fafc4b78696fc0 = function(v) {
    return $h2xUu.fromMaybe([])($fd9f4b5d79516886$var$traverse1($41p0v.index2D(v))($fd9f4b5d79516886$var$diagIdxs));
};
var $fd9f4b5d79516886$export$88cc558b59e43ac1 = function(row) {
    return function(grid) {
        return $fd9f4b5d79516886$var$foldl(function(g) {
            return function(v) {
                return $fd9f4b5d79516886$export$d6b45213194821a0(v.value1)(v.value0)(g);
            };
        })(grid)($brrpF.zip(row)($fd9f4b5d79516886$var$diagIdxs));
    };
};

});
parcelRegister("624no", function(module, exports) {

$parcel$export(module.exports, "toChar", () => $464653099f0f13b5$export$bafb3da1554990db);
$parcel$export(module.exports, "mkKey", () => $464653099f0f13b5$export$d09a2fcc27ac1fe);
$parcel$export(module.exports, "sudokuKey", () => $464653099f0f13b5$export$5e826c94a12a8a75);
$parcel$export(module.exports, "fromChar", () => $464653099f0f13b5$export$25b17642f68a32b6);
// Generated by purs version 0.15.16
parcelRequire("brrpF");
var $d3m1K = parcelRequire("d3m1K");
var $brrpF = parcelRequire("brrpF");

var $beQI1 = parcelRequire("beQI1");

var $dNwPt = parcelRequire("dNwPt");

var $aHmxC = parcelRequire("aHmxC");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");
parcelRequire("4Fu8m");
var $f2i2N = parcelRequire("f2i2N");

var $lqv9L = parcelRequire("lqv9L");

var $41p0v = parcelRequire("41p0v");
var $464653099f0f13b5$var$lookup = /* #__PURE__ */ $aHmxC.lookup($41p0v.ordValue);
var $464653099f0f13b5$var$nub = /* #__PURE__ */ $brrpF.nub($gwBF5.ordChar);
var $464653099f0f13b5$var$fromFoldable = /* #__PURE__ */ $aHmxC.fromFoldable($41p0v.ordValue)($dNwPt.foldableArray);
var $464653099f0f13b5$var$fromFoldable1 = /* #__PURE__ */ $aHmxC.fromFoldable($gwBF5.ordChar)($dNwPt.foldableArray);
var $464653099f0f13b5$var$lookup1 = /* #__PURE__ */ $aHmxC.lookup($gwBF5.ordChar);
var $464653099f0f13b5$var$Key = function(x) {
    return x;
};
var $464653099f0f13b5$export$bafb3da1554990db = function(v) {
    return function(v1) {
        var v3 = $464653099f0f13b5$var$lookup(v1)(v.toChar);
        if (v3 instanceof $h2xUu.Just) return v3.value0;
        if (v3 instanceof $h2xUu.Nothing) return $lqv9L.unsafeCrashWith("Key.toChar: unreachable \u2014 allValues must cover all Value constructors");
        throw new Error("Failed pattern match at Sudoku.Internal.Key (line 36, column 20 - line 38, column 101): " + [
            v3.constructor.name
        ]);
    };
};
var $464653099f0f13b5$export$d09a2fcc27ac1fe = function(s) {
    var chars = $f2i2N.toCharArray(s);
    var $17 = $d3m1K.length(chars) !== 9;
    if ($17) return new $beQI1.Left("key must be exactly 9 characters");
    var $18 = $d3m1K.length($464653099f0f13b5$var$nub(chars)) !== 9;
    if ($18) return new $beQI1.Left("key characters must be unique");
    return new $beQI1.Right({
        toChar: $464653099f0f13b5$var$fromFoldable($brrpF.zip($41p0v.allValues)(chars)),
        fromChar: $464653099f0f13b5$var$fromFoldable1($brrpF.zip(chars)($41p0v.allValues))
    });
};
var $464653099f0f13b5$export$5e826c94a12a8a75 = /* #__PURE__ */ function() {
    var v = $464653099f0f13b5$export$d09a2fcc27ac1fe("123456789");
    if (v instanceof $beQI1.Right) return v.value0;
    if (v instanceof $beQI1.Left) return $lqv9L.unsafeCrashWith(v.value0);
    throw new Error("Failed pattern match at Sudoku.Internal.Key (line 44, column 13 - line 46, column 34): " + [
        v.constructor.name
    ]);
}();
var $464653099f0f13b5$export$25b17642f68a32b6 = function(v) {
    return function(c) {
        return $464653099f0f13b5$var$lookup1(c)(v.fromChar);
    };
};
var $464653099f0f13b5$export$b0a169881b341a02 = /* #__PURE__ */ function() {
    var v = $464653099f0f13b5$export$d09a2fcc27ac1fe("ROYLGBIPV");
    if (v instanceof $beQI1.Right) return v.value0;
    if (v instanceof $beQI1.Left) return $lqv9L.unsafeCrashWith(v.value0);
    throw new Error("Failed pattern match at Sudoku.Internal.Key (line 49, column 14 - line 51, column 34): " + [
        v.constructor.name
    ]);
}();

});


parcelRegister("ekupQ", function(module, exports) {

$parcel$export(module.exports, "solve", () => $a6ea86eab5e88156$export$2865df1f26e73f8e);
$parcel$export(module.exports, "solveAll", () => $a6ea86eab5e88156$export$af71c58c84fbed2d);
$parcel$export(module.exports, "solveUnique", () => $a6ea86eab5e88156$export$fa7fe0a0de9a8507);
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $cADnC = parcelRequire("cADnC");
parcelRequire("brrpF");
var $d3m1K = parcelRequire("d3m1K");
var $brrpF = parcelRequire("brrpF");

var $iQTlW = parcelRequire("iQTlW");

var $aJhEx = parcelRequire("aJhEx");

var $dNwPt = parcelRequire("dNwPt");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $IhyKA = parcelRequire("IhyKA");

var $5krR0 = parcelRequire("5krR0");

var $fZenR = parcelRequire("fZenR");

var $bXKNp = parcelRequire("bXKNp");

var $aHmxC = parcelRequire("aHmxC");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $d5vvq = parcelRequire("d5vvq");

var $5mbCO = parcelRequire("5mbCO");

var $9OOYG = parcelRequire("9OOYG");

var $7O0Q4 = parcelRequire("7O0Q4");

var $41p0v = parcelRequire("41p0v");

var $lM1z4 = parcelRequire("lM1z4");
var $a6ea86eab5e88156$var$bind = /* #__PURE__ */ $cADnC.bind($cADnC.bindArray);
var $a6ea86eab5e88156$var$difference = /* #__PURE__ */ $brrpF.difference($41p0v.eqValue);
var $a6ea86eab5e88156$var$traverse = /* #__PURE__ */ $9OOYG.traverse($9OOYG.traversableArray)($h2xUu.applicativeMaybe);
var $a6ea86eab5e88156$var$not = /* #__PURE__ */ $IhyKA.not(/* #__PURE__ */ $IhyKA.heytingAlgebraFunction($IhyKA.heytingAlgebraBoolean));
var $a6ea86eab5e88156$var$isUnique = /* #__PURE__ */ $41p0v.isUnique($41p0v.eqValue)($41p0v.ordValue);
var $a6ea86eab5e88156$var$ordArray = /* #__PURE__ */ $gwBF5.ordArray($gwBF5.ordInt);
var $a6ea86eab5e88156$var$insertWith = /* #__PURE__ */ $aHmxC.insertWith($a6ea86eab5e88156$var$ordArray);
var $a6ea86eab5e88156$var$append = /* #__PURE__ */ $d5vvq.append($d5vvq.semigroupArray);
var $a6ea86eab5e88156$var$fromFoldable = /* #__PURE__ */ $5krR0.fromFoldable($5mbCO.foldableSet);
var $a6ea86eab5e88156$var$foldl = /* #__PURE__ */ $dNwPt.foldl($dNwPt.foldableArray);
var $a6ea86eab5e88156$var$insertWith1 = /* #__PURE__ */ $aHmxC.insertWith($41p0v.ordValue);
var $a6ea86eab5e88156$var$intersect = /* #__PURE__ */ $brrpF.intersect($41p0v.eqValue);
var $a6ea86eab5e88156$var$elem = /* #__PURE__ */ $brrpF.elem(/* #__PURE__ */ $aJhEx.eqArray($41p0v.eqValue));
var $a6ea86eab5e88156$var$bindFlipped = /* #__PURE__ */ $cADnC.bindFlipped($h2xUu.bindMaybe);
var $a6ea86eab5e88156$var$map = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $a6ea86eab5e88156$var$bind1 = /* #__PURE__ */ $cADnC.bind($h2xUu.bindMaybe);
var $a6ea86eab5e88156$var$minimumBy = /* #__PURE__ */ $dNwPt.minimumBy($dNwPt.foldableArray);
var $a6ea86eab5e88156$var$compare = /* #__PURE__ */ $gwBF5.compare($gwBF5.ordInt);
var $a6ea86eab5e88156$var$pure = /* #__PURE__ */ $bQdkN.pure($h2xUu.applicativeMaybe);
var $a6ea86eab5e88156$var$fromFoldable1 = /* #__PURE__ */ $brrpF.fromFoldable($dNwPt.foldableMaybe);
var $a6ea86eab5e88156$var$mapFlipped = /* #__PURE__ */ $7FzSN.mapFlipped($h2xUu.functorMaybe);
var $a6ea86eab5e88156$export$196af47b94d8d0a0 = /* #__PURE__ */ function() {
    function NoSolution$prime() {}
    NoSolution$prime.value = new NoSolution$prime();
    return NoSolution$prime;
}();
var $a6ea86eab5e88156$export$c37795aaebf581ba = /* #__PURE__ */ function() {
    function NotUnique$prime(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    NotUnique$prime.create = function(value0) {
        return function(value1) {
            return new NotUnique$prime(value0, value1);
        };
    };
    return NotUnique$prime;
}();
var $a6ea86eab5e88156$export$65699c5862a53503 = /* #__PURE__ */ function() {
    function AtLeast$prime(value0) {
        this.value0 = value0;
    }
    AtLeast$prime.create = function(value0) {
        return new AtLeast$prime(value0);
    };
    return AtLeast$prime;
}();
var $a6ea86eab5e88156$export$2aea618fa7c531ea = function(v) {
    if (v.length === 0) return $h2xUu.Nothing.value;
    if (v.length === 1) return new $h2xUu.Just(new $41p0v.Fixed(v[0]));
    return new $h2xUu.Just(new $41p0v.Possible(v));
};
var $a6ea86eab5e88156$export$855f5822238d5459 = function(cells) {
    var fixeds = $a6ea86eab5e88156$var$bind(cells)(function(cell) {
        if (cell instanceof $41p0v.Fixed) return [
            cell.value0
        ];
        return [];
    });
    var pruneCell = function(v) {
        if (v instanceof $41p0v.Possible) return $a6ea86eab5e88156$export$2aea618fa7c531ea($a6ea86eab5e88156$var$difference(v.value0)(fixeds));
        return new $h2xUu.Just(v);
    };
    return $a6ea86eab5e88156$var$traverse(pruneCell)(cells);
};
var $a6ea86eab5e88156$export$b28ab9c7f391bd52 = function(v) {
    if (v instanceof $41p0v.Possible) return true;
    return false;
};
var $a6ea86eab5e88156$export$bcf54dc09a8f622b = function(row) {
    var fixeds = $a6ea86eab5e88156$var$bind(row)(function(cell) {
        if (cell instanceof $41p0v.Fixed) return [
            cell.value0
        ];
        return [];
    });
    var emptyPossibles = $jhsiw.flip($d3m1K.any)(row)(function(cell) {
        if (cell instanceof $41p0v.Possible && cell.value0.length === 0) return true;
        return false;
    });
    return emptyPossibles || $a6ea86eab5e88156$var$not($a6ea86eab5e88156$var$isUnique)(fixeds);
};
var $a6ea86eab5e88156$export$aeeafec907c9b3e2 = function(v) {
    return function(v1) {
        if (v instanceof $41p0v.UniqueDiagonal) return $a6ea86eab5e88156$export$bcf54dc09a8f622b($lM1z4.diagonalOf(v1)) || $a6ea86eab5e88156$export$aeeafec907c9b3e2($41p0v.Standard.value)(v1);
        if (v instanceof $41p0v.Standard) return $d3m1K.any($a6ea86eab5e88156$export$bcf54dc09a8f622b)($lM1z4.extract(v1)) || $d3m1K.any($a6ea86eab5e88156$export$bcf54dc09a8f622b)($lM1z4.extract($lM1z4.transpose(v1))) || $d3m1K.any($a6ea86eab5e88156$export$bcf54dc09a8f622b)($lM1z4.extract($lM1z4.subGridsToRows(v1)));
        throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 158, column 1 - line 158, column 44): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $a6ea86eab5e88156$export$1a1381f52445ae67 = function(v) {
    if (v instanceof $41p0v.Fixed) return true;
    return false;
};
var $a6ea86eab5e88156$export$eeae732996cd1b22 = function(grid) {
    return $d3m1K.all($a6ea86eab5e88156$export$1a1381f52445ae67)($d3m1K.concat($lM1z4.extract(grid)));
};
var $a6ea86eab5e88156$export$3f5b31b7e4d1ed5c = function(dictMonad) {
    var bind2 = $cADnC.bind(dictMonad.Bind1());
    var pure1 = $bQdkN.pure(dictMonad.Applicative0());
    return function(dictEq) {
        var eq1 = $aJhEx.eq(dictEq);
        return function(f) {
            return function(x) {
                return bind2(f(x))(function(x$prime) {
                    var $83 = eq1(x$prime)(x);
                    if ($83) return pure1(x);
                    return $a6ea86eab5e88156$export$3f5b31b7e4d1ed5c(dictMonad)(dictEq)(f)(x$prime);
                });
            };
        };
    };
};
var $a6ea86eab5e88156$var$fixM1 = /* #__PURE__ */ $a6ea86eab5e88156$export$3f5b31b7e4d1ed5c($h2xUu.monadMaybe);
var $a6ea86eab5e88156$var$fixM2 = /* #__PURE__ */ $a6ea86eab5e88156$var$fixM1(/* #__PURE__ */ $aJhEx.eqArray($41p0v.cellEq));
var $a6ea86eab5e88156$export$dbf6db2aadc834fd = /* #__PURE__ */ function() {
    var $150 = $brrpF.fromFoldable($fZenR.foldableList);
    var $151 = $aHmxC.filterWithKey($a6ea86eab5e88156$var$ordArray)(function(is) {
        return function(xs) {
            return $d3m1K.length(is) === $d3m1K.length(xs);
        };
    });
    var $152 = $dNwPt.foldl($fZenR.foldableList)(function(acc) {
        return function(v) {
            return $a6ea86eab5e88156$var$insertWith($a6ea86eab5e88156$var$append)(v.value1)([
                v.value0
            ])(acc);
        };
    })($aHmxC.empty);
    var $153 = $aHmxC.filter($41p0v.ordValue)(function($158) {
        return function(x) {
            return x < 4;
        }($d3m1K.length($158));
    });
    var $154 = $a6ea86eab5e88156$var$foldl(function(acc) {
        return function(v) {
            return $a6ea86eab5e88156$var$foldl(function(acc$prime) {
                return function(x) {
                    return $a6ea86eab5e88156$var$insertWith1($a6ea86eab5e88156$var$append)(x)([
                        v.value0
                    ])(acc$prime);
                };
            })(acc)(v.value1);
        };
    })($aHmxC.empty);
    var $155 = $cADnC.bindFlipped($cADnC.bindArray)(function(tuple) {
        if (tuple.value1 instanceof $41p0v.Possible) return [
            new $7O0Q4.Tuple(tuple.value0, tuple.value1.value0)
        ];
        if (tuple.value1 instanceof $41p0v.Fixed) return [];
        throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 49, column 17 - line 51, column 34): " + [
            tuple.constructor.name
        ]);
    });
    var $156 = $brrpF.zip($d3m1K.range(1)(9));
    return function($157) {
        return $150($aHmxC.values($151($152(function(m) {
            return $5krR0.zip($a6ea86eab5e88156$var$fromFoldable($bXKNp.keys(m)))($aHmxC.values(m));
        }($153($154($155($156($157)))))))));
    };
}();
var $a6ea86eab5e88156$export$85db2efe48f9fa3d = function(cells) {
    var exclusives = $a6ea86eab5e88156$export$dbf6db2aadc834fd(cells);
    var allExclusives = $d3m1K.concat(exclusives);
    var pruneCell = function(v) {
        if (v instanceof $41p0v.Fixed) return new $h2xUu.Just(v);
        if (v instanceof $41p0v.Possible) {
            var intersection = $a6ea86eab5e88156$var$intersect(v.value0)(allExclusives);
            var $99 = $a6ea86eab5e88156$var$elem(intersection)(exclusives);
            if ($99) return $a6ea86eab5e88156$export$2aea618fa7c531ea(intersection);
            return new $h2xUu.Just(v);
        }
        throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 85, column 3 - line 85, column 34): " + [
            v.constructor.name
        ]);
    };
    if (exclusives.length === 0) return new $h2xUu.Just(cells);
    return $a6ea86eab5e88156$var$traverse(pruneCell)(cells);
};
var $a6ea86eab5e88156$export$3edf650a9f017b58 = function(cells) {
    return $a6ea86eab5e88156$var$bindFlipped($a6ea86eab5e88156$var$fixM2($a6ea86eab5e88156$export$85db2efe48f9fa3d))($a6ea86eab5e88156$var$fixM2($a6ea86eab5e88156$export$855f5822238d5459)(cells));
};
var $a6ea86eab5e88156$export$9651c890f693368c = function(grid$prime) {
    return $a6ea86eab5e88156$var$map($jhsiw.flip($lM1z4.replaceDiagonal)(grid$prime))($a6ea86eab5e88156$export$3edf650a9f017b58($lM1z4.diagonalOf(grid$prime)));
};
var $a6ea86eab5e88156$export$98ec83ff0ffbf43f = function(v) {
    return function(v1) {
        if (v instanceof $41p0v.UniqueDiagonal) return $a6ea86eab5e88156$var$bindFlipped($a6ea86eab5e88156$export$9651c890f693368c)($a6ea86eab5e88156$export$98ec83ff0ffbf43f($41p0v.Standard.value)(v1));
        if (v instanceof $41p0v.Standard) return $a6ea86eab5e88156$var$bind1($a6ea86eab5e88156$var$bind1($lM1z4.traverseRows($a6ea86eab5e88156$export$3edf650a9f017b58)(v1))(function() {
            var $159 = $a6ea86eab5e88156$var$map($lM1z4.transpose);
            var $160 = $lM1z4.traverseRows($a6ea86eab5e88156$export$3edf650a9f017b58);
            return function($161) {
                return $159($160($lM1z4.transpose($161)));
            };
        }()))(function() {
            var $162 = $a6ea86eab5e88156$var$map($lM1z4.subGridsToRows);
            var $163 = $lM1z4.traverseRows($a6ea86eab5e88156$export$3edf650a9f017b58);
            return function($164) {
                return $162($163($lM1z4.subGridsToRows($164)));
            };
        }());
        throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 94, column 1 - line 94, column 44): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $a6ea86eab5e88156$export$6488469c9350a11e = /* #__PURE__ */ function() {
    var $165 = $a6ea86eab5e88156$var$fixM1($lM1z4.eqGrid);
    return function($166) {
        return $165($a6ea86eab5e88156$export$98ec83ff0ffbf43f($166));
    };
}();
var $a6ea86eab5e88156$export$802db1fec2151c6 = function(v) {
    if (v instanceof $41p0v.Fixed) return 0;
    if (v instanceof $41p0v.Possible) return $d3m1K.length(v.value0);
    throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 115, column 1 - line 115, column 23): " + [
        v.constructor.name
    ]);
};
var $a6ea86eab5e88156$export$2e4e21e99e643a2 = function(grid) {
    var possibilities = $d3m1K.filter(function($167) {
        return $a6ea86eab5e88156$export$b28ab9c7f391bd52($7O0Q4.snd($167));
    })($brrpF.zip($d3m1K.range(0)(81))($d3m1K.concat($lM1z4.extract(grid))));
    var fixCell = function(v) {
        if (v.value1 instanceof $41p0v.Possible && v.value1.value0.length === 2) return new $h2xUu.Just(new $41p0v.Tuple3(v.value0, new $41p0v.Fixed(v["value1"]["value0"][0]), new $41p0v.Fixed(v["value1"]["value0"][1])));
        if (v.value1 instanceof $41p0v.Possible) return $a6ea86eab5e88156$var$map(function(x) {
            return new $41p0v.Tuple3(v.value0, new $41p0v.Fixed(x.head), new $41p0v.Possible(x.tail));
        })($brrpF.uncons(v.value1.value0));
        return $h2xUu.Nothing.value;
    };
    return $a6ea86eab5e88156$var$bind1($a6ea86eab5e88156$var$minimumBy($41p0v.on($a6ea86eab5e88156$var$compare)(function($168) {
        return $a6ea86eab5e88156$export$802db1fec2151c6($7O0Q4.snd($168));
    }))(possibilities))(function(min) {
        return $a6ea86eab5e88156$var$bind1(fixCell(min))(function(v) {
            return $a6ea86eab5e88156$var$pure(new $7O0Q4.Tuple($lM1z4.replace2D(v.value0)(v.value1)(grid), $lM1z4.replace2D(v.value0)(v.value2)(grid)));
        });
    });
};
var $a6ea86eab5e88156$export$2865df1f26e73f8e = function(v) {
    return function(grid) {
        var solve$prime = function(g) {
            if ($a6ea86eab5e88156$export$aeeafec907c9b3e2(v)(g)) return $h2xUu.Nothing.value;
            if ($a6ea86eab5e88156$export$eeae732996cd1b22(g)) return new $h2xUu.Just(g);
            if ($iQTlW.otherwise) return $a6ea86eab5e88156$var$bind1($a6ea86eab5e88156$export$2e4e21e99e643a2(g))(function(v1) {
                var v2 = $a6ea86eab5e88156$export$2865df1f26e73f8e(v)(v1.value0);
                if (v2 instanceof $h2xUu.Just) return v2;
                return $a6ea86eab5e88156$export$2865df1f26e73f8e(v)(v1.value1);
            });
            throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 173, column 3 - line 181, column 10): " + [
                g.constructor.name
            ]);
        };
        return $a6ea86eab5e88156$var$bindFlipped(solve$prime)($a6ea86eab5e88156$export$6488469c9350a11e(v)(grid));
    };
};
var $a6ea86eab5e88156$export$af71c58c84fbed2d = function(v) {
    return function(grid) {
        var solveAll$prime = function(g) {
            if ($a6ea86eab5e88156$export$aeeafec907c9b3e2(v)(g)) return [];
            if ($a6ea86eab5e88156$export$eeae732996cd1b22(g)) return [
                g
            ];
            if ($iQTlW.otherwise) return $d3m1K.concat($a6ea86eab5e88156$var$fromFoldable1($a6ea86eab5e88156$var$mapFlipped($a6ea86eab5e88156$export$2e4e21e99e643a2(g))(function(v1) {
                return $a6ea86eab5e88156$var$append($a6ea86eab5e88156$export$af71c58c84fbed2d(v)(v1.value0))($a6ea86eab5e88156$export$af71c58c84fbed2d(v)(v1.value1));
            })));
            throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 189, column 3 - line 189, column 34): " + [
                g.constructor.name
            ]);
        };
        return $d3m1K.concat($a6ea86eab5e88156$var$fromFoldable1($a6ea86eab5e88156$var$map(solveAll$prime)($a6ea86eab5e88156$export$6488469c9350a11e(v)(grid))));
    };
};
var $a6ea86eab5e88156$export$fa7fe0a0de9a8507 = function(v) {
    return function(grid) {
        var searchResult = function(v1) {
            if (v1 instanceof $a6ea86eab5e88156$export$196af47b94d8d0a0) return $41p0v.NoSolution.value;
            if (v1 instanceof $a6ea86eab5e88156$export$c37795aaebf581ba) return new $41p0v.NotUnique(v1.value0, v1.value1);
            if (v1 instanceof $a6ea86eab5e88156$export$65699c5862a53503) return new $41p0v.Unique(v1.value0);
            throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 226, column 3 - line 226, column 46): " + [
                v1.constructor.name
            ]);
        };
        var mergeSearch = function(v1) {
            return function(v2) {
                if (v1 instanceof $a6ea86eab5e88156$export$196af47b94d8d0a0) return v2;
                if (v2 instanceof $a6ea86eab5e88156$export$196af47b94d8d0a0) return v1;
                if (v1 instanceof $a6ea86eab5e88156$export$c37795aaebf581ba) return v1;
                if (v2 instanceof $a6ea86eab5e88156$export$c37795aaebf581ba) return v2;
                if (v1 instanceof $a6ea86eab5e88156$export$65699c5862a53503 && v2 instanceof $a6ea86eab5e88156$export$65699c5862a53503) return new $a6ea86eab5e88156$export$c37795aaebf581ba(v1.value0, v2.value0);
                throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 231, column 3 - line 231, column 44): " + [
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
        var solveUnique$prime = function(g) {
            return $h2xUu.fromMaybe($a6ea86eab5e88156$export$196af47b94d8d0a0.value)($a6ea86eab5e88156$var$map(solve2)($a6ea86eab5e88156$export$6488469c9350a11e(v)(g)));
        };
        var solve2 = function(g) {
            if ($a6ea86eab5e88156$export$aeeafec907c9b3e2(v)(g)) return $a6ea86eab5e88156$export$196af47b94d8d0a0.value;
            if ($a6ea86eab5e88156$export$eeae732996cd1b22(g)) return new $a6ea86eab5e88156$export$65699c5862a53503(g);
            if ($iQTlW.otherwise) {
                var v1 = $a6ea86eab5e88156$export$2e4e21e99e643a2(g);
                if (v1 instanceof $h2xUu.Nothing) return $a6ea86eab5e88156$export$196af47b94d8d0a0.value;
                if (v1 instanceof $h2xUu.Just) {
                    var v2 = solveUnique$prime(v1.value0.value0);
                    if (v2 instanceof $a6ea86eab5e88156$export$c37795aaebf581ba) return v2;
                    return mergeSearch(v2)(solveUnique$prime(v1.value0.value1));
                }
                throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 220, column 19 - line 224, column 52): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Sudoku.Internal.Solver (line 216, column 3 - line 216, column 27): " + [
                g.constructor.name
            ]);
        };
        return searchResult(solveUnique$prime(grid));
    };
};

});

parcelRegister("jy1cE", function(module, exports) {

$parcel$export(module.exports, "wordlist", () => $e3b22031058f5b0e$export$3373c55b773d2d68);
// Generated by purs version 0.15.16
var $e3b22031058f5b0e$export$3373c55b773d2d68 = [
    "abducting",
    "abduction",
    "abductors",
    "abjecting",
    "abjection",
    "abjointed",
    "ablutions",
    "abnormity",
    "abolished",
    "abolisher",
    "abruption",
    "absconder",
    "absolving",
    "absurdity",
    "abusively",
    "abutilons",
    "acheniums",
    "acidulent",
    "aconitums",
    "acquights",
    "acroliths",
    "acupoints",
    "ademption",
    "adjunctly",
    "adjusting",
    "admixture",
    "adoringly",
    "adsorbent",
    "adsorbing",
    "advection",
    "adversity",
    "adverting",
    "adviceful",
    "aepyornis",
    "aeroliths",
    "afterglow",
    "afterings",
    "agincourt",
    "aitchbone",
    "albicores",
    "alchemist",
    "alcyonium",
    "aldbourne",
    "aldeburgh",
    "aldershot",
    "alectryon",
    "alembroth",
    "algorithm",
    "almonries",
    "alongside",
    "amberoids",
    "ambiverts",
    "ambrotype",
    "ambushing",
    "amelcorns",
    "amortised",
    "amortized",
    "amortizes",
    "amphibole",
    "amphiboly",
    "amphigory",
    "amphioxus",
    "ampholyte",
    "amplitude",
    "amusingly",
    "amygdules",
    "amylopsin",
    "anchorets",
    "anchorite",
    "anchovies",
    "anchylose",
    "androcles",
    "aneuploid",
    "angelfish",
    "anguiform",
    "anguished",
    "anhydrite",
    "anhydrous",
    "ankylosed",
    "anoestrum",
    "anoretics",
    "anorexics",
    "antechoir",
    "anthropic",
    "antichlor",
    "antipodes",
    "antipoles",
    "antiquely",
    "antiserum",
    "anxiously",
    "aphorised",
    "aphorized",
    "aphorizes",
    "aphrodite",
    "apothegms",
    "archdukes",
    "archilowe",
    "archivolt",
    "archlutes",
    "arguments",
    "artichoke",
    "arytenoid",
    "ashbourne",
    "ashburton",
    "ashlering",
    "asmoulder",
    "asplenium",
    "astringed",
    "astrophel",
    "asyndetic",
    "athelings",
    "atmolysed",
    "atmolyzed",
    "atmolyzes",
    "atomizers",
    "atrophied",
    "atrophies",
    "auctioned",
    "audiphone",
    "augmentor",
    "auriscope",
    "auschwitz",
    "ausgleich",
    "authoring",
    "authorise",
    "authorism",
    "authorize",
    "autocrime",
    "autogenic",
    "autolysed",
    "autolyzed",
    "autolyzes",
    "autopsied",
    "avouching",
    "axminster",
    "ayckbourn",
    "ayurvedic",
    "bachelors",
    "backdowns",
    "backdrops",
    "backfield",
    "backfired",
    "backfires",
    "backflips",
    "backlight",
    "backsight",
    "backslide",
    "backswept",
    "backswing",
    "backsword",
    "backwords",
    "bacterium",
    "bacteroid",
    "baculites",
    "badmouths",
    "bailments",
    "balconets",
    "balconied",
    "balconies",
    "baldmoney",
    "baldricks",
    "baltimore",
    "banderols",
    "bandolier",
    "bankrupts",
    "bardlings",
    "baritones",
    "barleymow",
    "baronetcy",
    "barouches",
    "bartholdi",
    "bartholdy",
    "barytones",
    "basecourt",
    "basketful",
    "bastioned",
    "baudekins",
    "bazoukery",
    "beamingly",
    "bearishly",
    "becalming",
    "bedspring",
    "befouling",
    "beglamour",
    "behaviors",
    "behaviour",
    "beholding",
    "behowling",
    "belauding",
    "belomancy",
    "bemocking",
    "benchmark",
    "bergamots",
    "bergomask",
    "bermudans",
    "bermudian",
    "beshaming",
    "beslaving",
    "bestowing",
    "betraying",
    "bevatrons",
    "bewraying",
    "bezoardic",
    "bialystok",
    "biathlons",
    "bidentals",
    "bifurcate",
    "bilanders",
    "bimonthly",
    "binocular",
    "binuclear",
    "biographs",
    "biography",
    "birdcages",
    "birdhouse",
    "birdwatch",
    "birthdays",
    "bisulcate",
    "bivalency",
    "bivalents",
    "blackfish",
    "blackings",
    "blackmore",
    "blackouts",
    "blacktops",
    "blasphemy",
    "blazoners",
    "bleaching",
    "bleatings",
    "blighters",
    "blindages",
    "blindworm",
    "blinkards",
    "bloatings",
    "blockades",
    "blockages",
    "blockhead",
    "blockings",
    "blotchier",
    "blotching",
    "blowhards",
    "blowziest",
    "bludgeons",
    "bluecoats",
    "bluegowns",
    "blueprint",
    "bluewings",
    "blurtings",
    "boardings",
    "bohemians",
    "bolshevik",
    "bondagers",
    "boneyards",
    "bongraces",
    "bonifaces",
    "boschveld",
    "botanised",
    "botanized",
    "botanizes",
    "botchings",
    "bothering",
    "boulanger",
    "boulevard",
    "bounciest",
    "bowstring",
    "bowstrung",
    "boyfriend",
    "branchlet",
    "bratlings",
    "brawliest",
    "brawlings",
    "brawniest",
    "breaching",
    "breadnuts",
    "breakdown",
    "breakings",
    "breasting",
    "breastpin",
    "breathful",
    "breathily",
    "breathing",
    "brechtian",
    "bregmatic",
    "bridesman",
    "bridleway",
    "brigalows",
    "brighouse",
    "brightens",
    "brimstone",
    "brimstony",
    "broaching",
    "broadwise",
    "brocading",
    "bromelain",
    "bromeliad",
    "bromelias",
    "bronchial",
    "bronziest",
    "broughams",
    "browniest",
    "bruchidae",
    "brunswick",
    "brushlike",
    "brutalise",
    "brutalism",
    "brutalize",
    "brutishly",
    "brythonic",
    "bucharest",
    "buckayros",
    "bucketing",
    "buckhaven",
    "buckhorns",
    "buckishly",
    "bucklings",
    "buckramed",
    "buckthorn",
    "buckwheat",
    "budgetary",
    "buhrstone",
    "bulkheads",
    "bulwarked",
    "bumpering",
    "bunchiest",
    "bundesrat",
    "bundestag",
    "bungaloid",
    "bungalows",
    "buprestid",
    "burgonets",
    "burnished",
    "bushcraft",
    "bushwoman",
    "butcherly",
    "butlering",
    "bylanders",
    "byproduct",
    "byrewoman",
    "bystander",
    "byzantium",
    "cabinetry",
    "cabrioles",
    "cabriolet",
    "cadetship",
    "cagebirds",
    "calefying",
    "calembour",
    "califonts",
    "calthrops",
    "calumnies",
    "calutrons",
    "calvering",
    "cambering",
    "cambistry",
    "cambourne",
    "cambridge",
    "campesino",
    "campfires",
    "canefruit",
    "canephors",
    "cankerous",
    "caponiers",
    "caponised",
    "caponized",
    "caponizes",
    "caprioles",
    "capsulize",
    "captioned",
    "capturing",
    "carbonise",
    "carbonize",
    "cardphone",
    "carnosity",
    "carousing",
    "carpeting",
    "carpingly",
    "cartelism",
    "cashpoint",
    "castoreum",
    "caterings",
    "cauldrons",
    "cauliform",
    "caulkings",
    "cauterism",
    "cautioned",
    "cautioner",
    "cavendish",
    "cavernous",
    "cavorting",
    "ceanothus",
    "ceasingly",
    "cembalist",
    "cenotaphs",
    "censorial",
    "centigram",
    "centralis",
    "centroids",
    "centumvir",
    "centurial",
    "cephalous",
    "cerastium",
    "ceratodus",
    "certainly",
    "chagrined",
    "chainlets",
    "chainwork",
    "chalderns",
    "chaldrons",
    "chalkiest",
    "chalkpits",
    "chalutzim",
    "chalybite",
    "chamfrons",
    "champerty",
    "champions",
    "chandlers",
    "chandlery",
    "changeful",
    "chantries",
    "chaperons",
    "chapiters",
    "chaptrels",
    "chargeful",
    "charioted",
    "chartings",
    "charwomen",
    "charybdis",
    "chatlines",
    "chaunters",
    "chekovian",
    "chelating",
    "chelation",
    "chelators",
    "cheliform",
    "chemistry",
    "cheongsam",
    "cherimoya",
    "chernobyl",
    "cherubims",
    "cheruping",
    "chiefdoms",
    "chieftans",
    "chilterns",
    "chingford",
    "chinstrap",
    "chipboard",
    "chipmunks",
    "chlamydes",
    "chlorates",
    "chlordane",
    "chlorides",
    "chlorites",
    "chokedamp",
    "chokidars",
    "choliambs",
    "choltries",
    "chondrify",
    "chondrite",
    "chondrule",
    "choralist",
    "chordates",
    "choriambs",
    "chortling",
    "chorusing",
    "chowkidar",
    "chromakey",
    "chromates",
    "chromatid",
    "chromatin",
    "chronaxie",
    "chrysalid",
    "chunkiest",
    "churingas",
    "citranges",
    "clamoring",
    "clamoured",
    "clampdown",
    "clangours",
    "clareting",
    "clarinets",
    "clarionet",
    "claughted",
    "clavering",
    "claviform",
    "clavigers",
    "claymores",
    "clearings",
    "clearwing",
    "cleavings",
    "clepsydra",
    "clergyman",
    "clerkdoms",
    "clerkship",
    "clianthus",
    "climature",
    "clinoaxes",
    "clipboard",
    "clodpates",
    "closeting",
    "closuring",
    "clothiers",
    "clothings",
    "cloturing",
    "cloudiest",
    "cloudings",
    "clubwoman",
    "clubwomen",
    "clumpiest",
    "clunkiest",
    "clydebank",
    "coastline",
    "coaxingly",
    "cobdenism",
    "cogitable",
    "cognately",
    "cohabited",
    "cohabiter",
    "cointreau",
    "cokernuts",
    "colanders",
    "colubrids",
    "colubrine",
    "columbary",
    "columbate",
    "columbian",
    "columbine",
    "columbite",
    "columnist",
    "comatulid",
    "combating",
    "combative",
    "combinate",
    "combusted",
    "comedians",
    "comfiture",
    "compadres",
    "compander",
    "companied",
    "companies",
    "comparing",
    "comparted",
    "compendia",
    "compering",
    "competing",
    "compilers",
    "complains",
    "complaint",
    "compleats",
    "complexus",
    "compliant",
    "compliers",
    "complines",
    "complying",
    "comprints",
    "comprisal",
    "comprised",
    "compulsed",
    "computers",
    "computing",
    "comradely",
    "confervas",
    "confiders",
    "configure",
    "confirmed",
    "confiseur",
    "confiture",
    "conflated",
    "conflates",
    "confluxes",
    "congruity",
    "conjugate",
    "conjuries",
    "conspired",
    "constable",
    "construed",
    "consulage",
    "consulate",
    "consulted",
    "consulter",
    "contagium",
    "contrails",
    "contrived",
    "contrives",
    "contumely",
    "contusive",
    "convexity",
    "conveyals",
    "convulsed",
    "copulated",
    "copulates",
    "copyreads",
    "copyright",
    "corbeling",
    "cordaites",
    "cordwains",
    "cordyline",
    "corkwings",
    "cornelius",
    "cornfield",
    "cornflake",
    "cornstalk",
    "corpulent",
    "corseting",
    "corybants",
    "corydalis",
    "coryphaei",
    "coshering",
    "costively",
    "costumier",
    "costuming",
    "countable",
    "countries",
    "countrify",
    "countship",
    "couplings",
    "courantes",
    "courtesan",
    "courtezan",
    "courtings",
    "courtlike",
    "courtling",
    "courtship",
    "cousinage",
    "coverings",
    "coverlids",
    "coverslip",
    "cradlings",
    "craftsmen",
    "crankiest",
    "crapulent",
    "crawliest",
    "crawlings",
    "creations",
    "credulity",
    "cremating",
    "cremation",
    "creolians",
    "cretinous",
    "crimsoned",
    "crispated",
    "croakiest",
    "croakings",
    "croftings",
    "crotaline",
    "crotalism",
    "crotalums",
    "croupades",
    "croupiest",
    "croustade",
    "crownlets",
    "cruiseway",
    "crumbiest",
    "crumblies",
    "crumbling",
    "crumpling",
    "crusading",
    "crushable",
    "cruzadoes",
    "cryptogam",
    "cteniform",
    "ctesiphon",
    "culminate",
    "culpatory",
    "cultigens",
    "cultivars",
    "culverins",
    "cumbering",
    "cuneiform",
    "cupboards",
    "cupolaing",
    "cupolated",
    "curablity",
    "curbstone",
    "cursively",
    "curtailed",
    "curtained",
    "curtilage",
    "curtsying",
    "curvation",
    "curveting",
    "cushioned",
    "cushionet",
    "cuspidate",
    "custodial",
    "custodian",
    "custodier",
    "customary",
    "customize",
    "cyathiums",
    "cyberpunk",
    "cylinders",
    "cymbalist",
    "cymbaloes",
    "cymograph",
    "cymophane",
    "cyphering",
    "cystidean",
    "cystiform",
    "cystoidea",
    "cytoplasm",
    "dackering",
    "dalhousie",
    "daltonism",
    "dangerous",
    "dankworth",
    "darklings",
    "dartingly",
    "dashingly",
    "daughters",
    "dauphines",
    "davenport",
    "daylights",
    "dayspring",
    "debarking",
    "deboshing",
    "decamping",
    "decapolis",
    "decarbing",
    "decathlon",
    "decigrams",
    "decimator",
    "declaring",
    "declivous",
    "decupling",
    "decurions",
    "decursion",
    "decurving",
    "defamings",
    "defiantly",
    "definably",
    "deflating",
    "deflation",
    "deflators",
    "defluxion",
    "defoliant",
    "deforcing",
    "deforming",
    "deformity",
    "defouling",
    "defraying",
    "dehorting",
    "deinosaur",
    "deiparous",
    "dekabrist",
    "delacroix",
    "delapsion",
    "delousing",
    "delphinus",
    "demagnify",
    "demarking",
    "demijohns",
    "demivolts",
    "democrats",
    "demoniacs",
    "demulsify",
    "dentalium",
    "dentiform",
    "departing",
    "depictors",
    "depilator",
    "deploring",
    "deploying",
    "depluming",
    "deporting",
    "depraving",
    "depravity",
    "deprivals",
    "depurants",
    "deratings",
    "derations",
    "derivably",
    "desalting",
    "descaling",
    "descrying",
    "designful",
    "desirably",
    "desorbing",
    "desultory",
    "detaching",
    "detouring",
    "detrusion",
    "devaluing",
    "deviators",
    "deviatory",
    "deviously",
    "devouring",
    "diachylon",
    "diachylum",
    "diaglyphs",
    "dialogues",
    "dialyzers",
    "diaphones",
    "diathermy",
    "dicastery",
    "dicentras",
    "dichogamy",
    "dichromat",
    "dictyogen",
    "dielytras",
    "dinoceras",
    "diplomacy",
    "diplomate",
    "diplomats",
    "dipterans",
    "dipterous",
    "disanchor",
    "disbranch",
    "discharge",
    "discovert",
    "discovery",
    "disembark",
    "disemploy",
    "disentomb",
    "disfavour",
    "dishwater",
    "dislocate",
    "dismantle",
    "dismayful",
    "displayer",
    "disproval",
    "disproven",
    "dithecous",
    "dithyramb",
    "divalents",
    "divulgate",
    "dobermans",
    "docketing",
    "doctrinal",
    "doctrines",
    "documents",
    "dogmatics",
    "dogmatise",
    "dogmatize",
    "dominates",
    "donatives",
    "doncaster",
    "dorsiflex",
    "dosimetry",
    "douaniers",
    "doublings",
    "doubtings",
    "doughiest",
    "doughtier",
    "doughtily",
    "dovetails",
    "dowitcher",
    "downbeats",
    "downburst",
    "downplays",
    "downright",
    "downstage",
    "downstair",
    "downtimes",
    "draconism",
    "draftsmen",
    "draglines",
    "dragonets",
    "dragonfly",
    "dragonise",
    "dragonish",
    "dragonism",
    "dragonize",
    "drawknife",
    "dreamings",
    "drepanium",
    "driftages",
    "drinkable",
    "driveways",
    "dronishly",
    "dropflies",
    "dropsical",
    "droukings",
    "drumbeats",
    "drumliest",
    "drumstick",
    "duarchies",
    "dubitancy",
    "dubliners",
    "dubrovnik",
    "ducklings",
    "duckshove",
    "dukelings",
    "dulcimers",
    "dulcitone",
    "dulverton",
    "dumbarton",
    "dumpishly",
    "dumplings",
    "dunstable",
    "duplexing",
    "duplicate",
    "durations",
    "duratives",
    "dyarchies",
    "dynamiter",
    "dynamites",
    "dynamizes",
    "dyschroia",
    "dysphagic",
    "dysphonia",
    "dysphonic",
    "dysphoria",
    "dysphoric",
    "dystopian",
    "earthling",
    "earthwolf",
    "eastbound",
    "echograms",
    "echovirus",
    "ectoplasm",
    "ectropium",
    "edgbaston",
    "edinburgh",
    "educating",
    "education",
    "educators",
    "educatory",
    "eductions",
    "egyptians",
    "eidograph",
    "eightfold",
    "eightsman",
    "elkhounds",
    "elocuting",
    "embarking",
    "emblazing",
    "emblazons",
    "embodying",
    "embracing",
    "embruting",
    "embryonal",
    "embryonic",
    "embryotic",
    "emigrants",
    "emparling",
    "emplacing",
    "emplastic",
    "employing",
    "emptional",
    "emptyings",
    "emulating",
    "emulation",
    "emulators",
    "emunctory",
    "enchorial",
    "encomiast",
    "encratism",
    "endoblast",
    "endocarps",
    "endogamic",
    "endolymph",
    "endophagy",
    "endoplasm",
    "endurably",
    "englishry",
    "enhydrous",
    "entropium",
    "enviously",
    "envoyship",
    "enzymatic",
    "ephoralty",
    "epicotyls",
    "epidurals",
    "epigynous",
    "epilators",
    "epulation",
    "epulotics",
    "equations",
    "equitably",
    "equivocal",
    "eruptions",
    "eryngiums",
    "escarping",
    "escorting",
    "estimably",
    "estraying",
    "ethmoidal",
    "eucalypti",
    "eucalypts",
    "eucharist",
    "eukaryons",
    "eukaryots",
    "eulachons",
    "eupatrids",
    "euphorbia",
    "eurythmic",
    "eutrophic",
    "eutychian",
    "evocating",
    "exactions",
    "exampling",
    "exarchist",
    "excalibur",
    "excitably",
    "excluding",
    "exclusion",
    "exclusory",
    "excursion",
    "excusably",
    "exhorting",
    "exordiums",
    "expiators",
    "expiatory",
    "expirants",
    "exploding",
    "exploring",
    "exporting",
    "expulsion",
    "extruding",
    "extrusion",
    "exudation",
    "exultancy",
    "fabulised",
    "fabulized",
    "fabulizes",
    "faburdens",
    "facetious",
    "faciendum",
    "factories",
    "factoring",
    "factorise",
    "factorize",
    "faculties",
    "falchions",
    "falconers",
    "falconets",
    "falsework",
    "faltering",
    "fancywork",
    "fanlights",
    "farmhouse",
    "farthings",
    "fashioned",
    "fashioner",
    "fathering",
    "fathoming",
    "favorites",
    "favouring",
    "favourite",
    "featuring",
    "febricula",
    "fecundity",
    "feracious",
    "festilogy",
    "feudalism",
    "feudalist",
    "feudality",
    "feudatory",
    "fibrocyte",
    "fieldsman",
    "fieldwork",
    "fightable",
    "fightback",
    "figurable",
    "figurante",
    "figurants",
    "filaceous",
    "filaments",
    "filanders",
    "filatures",
    "filmgoers",
    "fireboats",
    "firewoman",
    "firsthand",
    "fisherman",
    "fishguard",
    "fishyback",
    "fixatures",
    "flagstick",
    "flagstone",
    "flamencos",
    "flamingos",
    "flashcube",
    "flatirons",
    "flatworms",
    "flaughted",
    "flaughter",
    "flaunches",
    "flaunters",
    "flauntier",
    "flavoring",
    "flavoured",
    "flections",
    "flensburg",
    "fleshworm",
    "fletching",
    "flichters",
    "flinchers",
    "floatings",
    "floriated",
    "floridean",
    "florigens",
    "flounders",
    "flouriest",
    "flourishy",
    "flowchart",
    "flowering",
    "flukeworm",
    "fluorides",
    "flyweight",
    "foamingly",
    "focalised",
    "focalized",
    "focalizes",
    "fogramite",
    "fogramity",
    "foliature",
    "folketing",
    "forasmuch",
    "forcipate",
    "forecabin",
    "forehands",
    "forekings",
    "forelands",
    "forelimbs",
    "forelying",
    "forenight",
    "foreplans",
    "foresight",
    "foreslack",
    "foresting",
    "forethink",
    "forewinds",
    "forewings",
    "forjudges",
    "forkheads",
    "formalise",
    "formalist",
    "formality",
    "formalize",
    "formating",
    "formative",
    "formiates",
    "formicant",
    "formicate",
    "formulaic",
    "formulate",
    "formulise",
    "formulist",
    "formulize",
    "fornicate",
    "forsaking",
    "forsythia",
    "fortalice",
    "fortilage",
    "fortunize",
    "fostering",
    "fothering",
    "foundries",
    "fractions",
    "fractious",
    "fragments",
    "framboise",
    "franchise",
    "frangible",
    "franticly",
    "fratching",
    "frauleins",
    "freckling",
    "frescoing",
    "freudians",
    "fricadels",
    "friesland",
    "frightens",
    "frogspawn",
    "frolicked",
    "frontages",
    "frontways",
    "frontwise",
    "frostlike",
    "frowsting",
    "frowziest",
    "frugalist",
    "frugality",
    "frumpiest",
    "fruticose",
    "fulbright",
    "fulminate",
    "fumaroles",
    "fumarolic",
    "fumigants",
    "fumigated",
    "fumigates",
    "fumigator",
    "funboards",
    "funebrial",
    "fungibles",
    "fungoidal",
    "fungosity",
    "funkholes",
    "furbelows",
    "furbished",
    "furcation",
    "furnished",
    "furtively",
    "gairfowls",
    "galumphed",
    "gapeworms",
    "garefowls",
    "garfunkel",
    "garnished",
    "gasometry",
    "gatefolds",
    "gauntries",
    "gavelkind",
    "gavelocks",
    "gazumpers",
    "gazunders",
    "gearstick",
    "gemutlich",
    "genocidal",
    "genotypic",
    "geomantic",
    "geophytic",
    "geraniums",
    "gerfalcon",
    "gericault",
    "germanish",
    "germanist",
    "germanous",
    "gerontius",
    "gerundial",
    "ghastlier",
    "ghostlier",
    "ghostlike",
    "giftwraps",
    "gipsywort",
    "girandole",
    "gladsomer",
    "gladstone",
    "glaireous",
    "glamorise",
    "glamorize",
    "glamoured",
    "glucoside",
    "glumpiest",
    "glutamine",
    "glycoside",
    "gnarliest",
    "gnostical",
    "goatherds",
    "godfather",
    "godparent",
    "goldcrest",
    "goldfinch",
    "goldminer",
    "goldsmith",
    "goldspink",
    "goldstein",
    "goldstick",
    "goldwater",
    "gorbachev",
    "gorblimey",
    "goslarite",
    "gourmands",
    "goutflies",
    "gradients",
    "grandiose",
    "granulite",
    "granulose",
    "grapeshot",
    "graphemic",
    "graphicly",
    "graphiums",
    "graticule",
    "graunched",
    "graunches",
    "gravitons",
    "grewhound",
    "greyhound",
    "grinstead",
    "grouchily",
    "groundsel",
    "groupable",
    "growliest",
    "grumphies",
    "grumpiest",
    "grundyism",
    "grunewald",
    "guardsmen",
    "gueridons",
    "guidepost",
    "guildsman",
    "guimbards",
    "gumshield",
    "gunmakers",
    "gunmetals",
    "gunpowder",
    "gymnastic",
    "gynaecium",
    "gynaecoid",
    "gynoecium",
    "gyrations",
    "gyrfalcon",
    "gyroplane",
    "habitudes",
    "hackbolts",
    "hackliest",
    "hacqueton",
    "hailstone",
    "hailstorm",
    "hairstyle",
    "halftones",
    "halicores",
    "halimotes",
    "haltering",
    "hampering",
    "hamstring",
    "hamstrung",
    "handgrips",
    "handiwork",
    "handovers",
    "handsomer",
    "handspike",
    "handwrite",
    "hangbirds",
    "hangovers",
    "hapterons",
    "haquetons",
    "hardiment",
    "harlequin",
    "harmonics",
    "harmonies",
    "harmonise",
    "harmonist",
    "harmonite",
    "harmonize",
    "haruspicy",
    "havelocks",
    "haverings",
    "havocking",
    "hayfields",
    "hazelnuts",
    "headcount",
    "headfirst",
    "headlocks",
    "headrings",
    "headstick",
    "headstock",
    "heartling",
    "hecatombs",
    "hectogram",
    "hectoring",
    "hectorism",
    "heinously",
    "heliports",
    "hemingway",
    "hemolytic",
    "heptagons",
    "heralding",
    "herbalism",
    "herbalist",
    "hercogamy",
    "herdwicks",
    "heritably",
    "hesitancy",
    "hexaploid",
    "hideously",
    "hijackers",
    "hilversum",
    "histogeny",
    "histogram",
    "hivewards",
    "hoactzins",
    "hoardings",
    "hobdaying",
    "hobnailed",
    "hodiernal",
    "holdbacks",
    "holmesian",
    "homecraft",
    "homegirls",
    "homelands",
    "homewards",
    "homuncles",
    "hornbeaks",
    "hornbeams",
    "horntails",
    "horseback",
    "horsemint",
    "horseplay",
    "horsetail",
    "hospitage",
    "hourplate",
    "housemaid",
    "howitzers",
    "hoydenism",
    "huckstery",
    "humanised",
    "humanized",
    "humanizes",
    "humanlike",
    "humanoids",
    "humblings",
    "humdinger",
    "humecting",
    "humpbacks",
    "hungriest",
    "hurdlings",
    "husbandly",
    "husbandry",
    "hybridoma",
    "hybridous",
    "hydrating",
    "hydration",
    "hydraulic",
    "hydrazine",
    "hydrazoic",
    "hydrogens",
    "hydronaut",
    "hydronium",
    "hydroptic",
    "hydropult",
    "hydrovane",
    "hygrodeik",
    "hylobates",
    "hymnaries",
    "hymnodist",
    "hyperbola",
    "hypericum",
    "hyperlink",
    "hypnoidal",
    "hypnotics",
    "hypnotise",
    "hypnotism",
    "hypnotize",
    "hypoblast",
    "hypocaust",
    "hypocrite",
    "hypoderma",
    "hypoderms",
    "hypomanic",
    "hypotaxis",
    "hypoxemia",
    "hypoxemic",
    "hysteroid",
    "ibuprofen",
    "ideograms",
    "ideograph",
    "idolaters",
    "ignorable",
    "ignoramus",
    "imbrangle",
    "imbrowned",
    "impastoed",
    "implanted",
    "implodent",
    "implunged",
    "implunges",
    "impockets",
    "impolders",
    "importune",
    "imposable",
    "imposture",
    "impotency",
    "impounder",
    "imprudent",
    "impugners",
    "impulsory",
    "imputable",
    "imputably",
    "inbrought",
    "inceptors",
    "inchoated",
    "inchoates",
    "inclasped",
    "inclosure",
    "incrusted",
    "incubated",
    "incubates",
    "incubator",
    "inculpate",
    "incurable",
    "incurably",
    "incurvate",
    "indecorum",
    "indraught",
    "inductors",
    "indulgers",
    "indurates",
    "inequably",
    "inexactly",
    "infectors",
    "inflamers",
    "inflators",
    "infracted",
    "infuscate",
    "ingathers",
    "ingrafted",
    "ingrately",
    "ingrowths",
    "inhaulers",
    "inhumated",
    "inhumates",
    "injectors",
    "inkholder",
    "inoculate",
    "inquorate",
    "insculped",
    "insectary",
    "insolated",
    "inspector",
    "insulated",
    "insulator",
    "insurable",
    "inswathed",
    "integrals",
    "intercoms",
    "interdash",
    "interflow",
    "interfold",
    "interlays",
    "interlock",
    "interplay",
    "intervals",
    "introduce",
    "inumbrate",
    "invocable",
    "invocated",
    "invocates",
    "involucre",
    "involuted",
    "involutes",
    "inwrought",
    "irksomely",
    "ironclads",
    "isleworth",
    "isocrymal",
    "isohyetal",
    "isotheral",
    "jacketing",
    "jacobites",
    "jailhouse",
    "jalousied",
    "jamestown",
    "jargonise",
    "jargonist",
    "jargonize",
    "jaundices",
    "jelutongs",
    "jerfalcon",
    "jerquings",
    "jestingly",
    "jockeying",
    "jockeyism",
    "jockstrap",
    "jocundity",
    "jointured",
    "jointures",
    "jokesmith",
    "joltheads",
    "jongleurs",
    "jouisance",
    "jubilance",
    "jubilancy",
    "jubilated",
    "jubilates",
    "judgeship",
    "judgments",
    "judicable",
    "judicator",
    "jumboised",
    "jumboized",
    "jumboizes",
    "jungliest",
    "junkerdom",
    "junkerism",
    "jurywoman",
    "jurywomen",
    "juxtapose",
    "kabeljous",
    "kaiserdom",
    "kalsomine",
    "kalumpits",
    "kaohsiung",
    "keyboards",
    "kidsgrove",
    "kilobytes",
    "kilograms",
    "kilohertz",
    "kingswear",
    "kitzbuhel",
    "klendusic",
    "klephtism",
    "knaveship",
    "knavishly",
    "knebworth",
    "knurliest",
    "knutsford",
    "kohlrabis",
    "kunstlied",
    "kurbashed",
    "kurdistan",
    "kvetching",
    "kyboshing",
    "kymograph",
    "labouring",
    "labourism",
    "labourist",
    "labourite",
    "labyrinth",
    "lackering",
    "lackeying",
    "ladysmith",
    "lambrusco",
    "lanciform",
    "landforms",
    "landsturm",
    "langouste",
    "lapideous",
    "larcenist",
    "larcenous",
    "latchkeys",
    "lathering",
    "lathyrism",
    "latrociny",
    "laughsome",
    "laughters",
    "launchers",
    "laundries",
    "laverocks",
    "lawgivers",
    "lawmonger",
    "layerings",
    "layperson",
    "lazybones",
    "leachings",
    "leadworts",
    "leapfrogs",
    "leasowing",
    "lecturing",
    "leftwards",
    "legations",
    "legionary",
    "lemurians",
    "lemuroids",
    "lentiform",
    "leprosity",
    "lethargic",
    "leviathon",
    "lexigrams",
    "lichenous",
    "lichgates",
    "lifeboats",
    "lifeguard",
    "ligaments",
    "ligatured",
    "ligatures",
    "lightsome",
    "limaceous",
    "lincrusta",
    "linctures",
    "lindbergh",
    "linotypes",
    "lipectomy",
    "lipograms",
    "liveryman",
    "livestock",
    "loaferish",
    "loathings",
    "locatives",
    "lochinver",
    "lochmaben",
    "locksmith",
    "lodgments",
    "logarithm",
    "lombardic",
    "longevity",
    "longitude",
    "loquacity",
    "loricated",
    "loricates",
    "lovebirds",
    "lowerings",
    "lubricant",
    "lubricate",
    "lucrative",
    "lumbering",
    "lunchtime",
    "lungworts",
    "lunkheads",
    "lustihead",
    "lutherans",
    "lutherism",
    "luxations",
    "lychgates",
    "lycosidae",
    "lymphatic",
    "lyndhurst",
    "machinery",
    "macintosh",
    "madefying",
    "magistery",
    "magnetics",
    "magnitude",
    "mahlstick",
    "maidstone",
    "mailboxes",
    "majorship",
    "makeshift",
    "maligners",
    "malingers",
    "malingery",
    "manciples",
    "mandibles",
    "mangroves",
    "manicured",
    "manicures",
    "manifesto",
    "manifolds",
    "mansfield",
    "manticore",
    "manyplies",
    "marbliest",
    "marblings",
    "marigolds",
    "marketing",
    "marlstone",
    "marveling",
    "marvelous",
    "masculine",
    "masoretic",
    "masterful",
    "mastering",
    "matfelons",
    "matronise",
    "matronize",
    "maulstick",
    "maungiest",
    "mavericks",
    "mawkishly",
    "mayflower",
    "mayorship",
    "mcpherson",
    "meandrous",
    "measuring",
    "mechanist",
    "mediators",
    "mediatory",
    "megabucks",
    "megaflops",
    "megaliths",
    "megavolts",
    "melanotic",
    "melanuric",
    "meltdowns",
    "mendacity",
    "menstrual",
    "mentorial",
    "merchants",
    "meropidan",
    "metabolic",
    "metalwork",
    "metaphors",
    "metroland",
    "micropyle",
    "microwave",
    "milkworts",
    "misaunter",
    "mischarge",
    "miscreant",
    "miserably",
    "misgovern",
    "misgrowth",
    "mishandle",
    "mishanter",
    "mislucked",
    "misplaced",
    "misplayed",
    "misquoted",
    "misreckon",
    "misrouted",
    "mockingly",
    "modelings",
    "modernist",
    "modernity",
    "modulates",
    "mogadishu",
    "moldering",
    "moldwarps",
    "molesting",
    "molybdate",
    "monachist",
    "monastery",
    "mondayish",
    "moneybags",
    "monickers",
    "monkeyish",
    "monthlies",
    "monticles",
    "monticule",
    "moralised",
    "moralized",
    "moralizes",
    "mordacity",
    "mordantly",
    "morganite",
    "morphetic",
    "mortalise",
    "mortalize",
    "mortlings",
    "moschatel",
    "mothering",
    "mouchards",
    "mouldiest",
    "mouldings",
    "mouldwarp",
    "moulinets",
    "moultings",
    "mountable",
    "mournival",
    "mousetrap",
    "moustache",
    "mouthable",
    "movieland",
    "mowburned",
    "mucilages",
    "muckering",
    "mucorales",
    "mucronate",
    "mujahedin",
    "multipeds",
    "muricated",
    "muscadine",
    "muscarine",
    "muscovite",
    "mustached",
    "mustachio",
    "mustering",
    "mutagenic",
    "mutchkins",
    "mycorhiza",
    "mylonites",
    "myographs",
    "myriadths",
    "myriapods",
    "myxovirus",
    "nailbrush",
    "narcotise",
    "narcotism",
    "narcotize",
    "narghiles",
    "nargilehs",
    "naturedly",
    "naughtier",
    "naughtily",
    "navelwort",
    "navicerts",
    "nectarous",
    "nefarious",
    "negroidal",
    "negrophil",
    "neighbors",
    "neighbour",
    "nemophila",
    "neophytic",
    "nephalism",
    "nephalist",
    "nephogram",
    "nephrotic",
    "nervously",
    "neuralgic",
    "neurochip",
    "neuroglia",
    "neuropath",
    "neurotics",
    "nickelous",
    "nicodemus",
    "nightcaps",
    "nightclub",
    "nightjars",
    "nightmare",
    "nightmary",
    "nightward",
    "nightwear",
    "noctuidae",
    "nomadizes",
    "normalise",
    "normality",
    "normalize",
    "normative",
    "nostalgic",
    "nostalgie",
    "notaphily",
    "notarised",
    "notarized",
    "notarizes",
    "nourished",
    "nucleator",
    "numerably",
    "numerical",
    "nursemaid",
    "nyctalops",
    "nymphalid",
    "nymphical",
    "nystagmic",
    "obdurates",
    "obfuscate",
    "objectify",
    "objecting",
    "objurgate",
    "obligants",
    "obligated",
    "obligates",
    "obscenity",
    "obscurant",
    "obscurely",
    "obscuring",
    "obscurity",
    "obsequial",
    "observant",
    "observing",
    "obsignate",
    "obstinacy",
    "obtainers",
    "obtruding",
    "obtrusive",
    "obverting",
    "ockhamist",
    "octupling",
    "ocularist",
    "odalisque",
    "odelsting",
    "oldenburg",
    "olfacting",
    "olfactive",
    "oligarchs",
    "oligarchy",
    "oliphants",
    "olympiads",
    "olympians",
    "omphacite",
    "onslaught",
    "operatics",
    "operating",
    "ophiurans",
    "opsimathy",
    "opthalmic",
    "orangeism",
    "ordinates",
    "organdies",
    "organised",
    "organized",
    "organizes",
    "orientals",
    "origanums",
    "orleanism",
    "orleanist",
    "orphanise",
    "orphanism",
    "orphanize",
    "ortanique",
    "osculated",
    "osnabruck",
    "ostracize",
    "outbacker",
    "outbraved",
    "outbraves",
    "outbreaks",
    "outcrying",
    "outdances",
    "outdaring",
    "outdrinks",
    "outdriven",
    "outdrives",
    "outfacing",
    "outfields",
    "outflanks",
    "outflings",
    "outflying",
    "outglared",
    "outglares",
    "outlander",
    "outlawing",
    "outlaying",
    "outlearns",
    "outlinear",
    "outpacing",
    "outparish",
    "outplayed",
    "outprayed",
    "outpriced",
    "outprices",
    "outracing",
    "outrances",
    "outranged",
    "outranges",
    "outranked",
    "outreigns",
    "outrivals",
    "outsailed",
    "outspread",
    "outspring",
    "outwalked",
    "outwardly",
    "outweighs",
    "outwicked",
    "outwinged",
    "ovalbumin",
    "overawing",
    "overbuild",
    "overbuilt",
    "overflush",
    "overfunds",
    "overhangs",
    "overhasty",
    "overhauls",
    "overjumps",
    "overkings",
    "overlusty",
    "overlying",
    "overmatch",
    "overnight",
    "overpaint",
    "overpitch",
    "overplays",
    "oversight",
    "overstain",
    "overstand",
    "overstudy",
    "overtalks",
    "overusing",
    "overwatch",
    "overwinds",
    "overwings",
    "oviductal",
    "ovulating",
    "ownership",
    "pachyderm",
    "packeting",
    "packhorse",
    "pactioned",
    "painterly",
    "paintures",
    "paintwork",
    "palebucks",
    "palinodes",
    "palmhouse",
    "palmistry",
    "paltering",
    "paludrine",
    "pandemics",
    "panderism",
    "panderous",
    "panegoism",
    "panegyric",
    "pankhurst",
    "panlogism",
    "pantheism",
    "pantihose",
    "pantofles",
    "pantoufle",
    "parboiled",
    "parbuckle",
    "parceling",
    "parchedly",
    "parchment",
    "parhelion",
    "parleying",
    "parochine",
    "parochins",
    "parodying",
    "paroquets",
    "parsimony",
    "parthenos",
    "particles",
    "pasquiler",
    "pasturing",
    "patchings",
    "patchouli",
    "patchouly",
    "patchwork",
    "pathogens",
    "pathogeny",
    "patricoes",
    "patrimony",
    "patroclus",
    "patrolmen",
    "patronise",
    "patronize",
    "pauldrons",
    "paunchier",
    "pausingly",
    "pearlings",
    "pectorals",
    "peculator",
    "peculiars",
    "pecuniary",
    "pedantism",
    "pedicular",
    "pegboards",
    "pelviform",
    "penlights",
    "pentalogy",
    "pentarchs",
    "pentarchy",
    "penultima",
    "penumbral",
    "penumbras",
    "perfuming",
    "perfusing",
    "perfusion",
    "perianths",
    "periblast",
    "peribolus",
    "permuting",
    "peronista",
    "personify",
    "pertusion",
    "peruvians",
    "pervading",
    "pervasion",
    "petronius",
    "petrosian",
    "petruchio",
    "petrushka",
    "petulancy",
    "pforzheim",
    "phacolite",
    "phagocyte",
    "pharynges",
    "pharynxes",
    "phaseolin",
    "phenakism",
    "philabegs",
    "philamots",
    "philander",
    "phlyctena",
    "phonecard",
    "phonemics",
    "phonetics",
    "phonetism",
    "phreaking",
    "physicked",
    "picayunes",
    "pickmawed",
    "pictogram",
    "pigmental",
    "pignorate",
    "pilchards",
    "pileworts",
    "pinafored",
    "pinafores",
    "pinchguts",
    "pinochles",
    "pintables",
    "piquantly",
    "piscatory",
    "pitchfork",
    "piteously",
    "placoderm",
    "plainwork",
    "planchets",
    "planetoid",
    "planished",
    "planisher",
    "planorbis",
    "planxties",
    "plastique",
    "platforms",
    "platinous",
    "platonise",
    "platonism",
    "platonize",
    "playhouse",
    "plaything",
    "playtimes",
    "pleaching",
    "pleadings",
    "plectrons",
    "plectrums",
    "plethoras",
    "plethoric",
    "pleuching",
    "plexiform",
    "plicature",
    "plighters",
    "ploughers",
    "ploughman",
    "ploughmen",
    "plowright",
    "plowshare",
    "pluckiest",
    "plumbagos",
    "plumbates",
    "plumbites",
    "plutonism",
    "pneumatic",
    "poachiest",
    "poachings",
    "pochaying",
    "pocketful",
    "pocketing",
    "pointedly",
    "polarised",
    "polarized",
    "polarizes",
    "poldering",
    "polemarch",
    "policeman",
    "polyamide",
    "polybasic",
    "polygamic",
    "polygenic",
    "polyhedra",
    "polymaths",
    "polymeric",
    "polynesia",
    "polywater",
    "pomanders",
    "ponterwyd",
    "pontlevis",
    "porcelain",
    "porklings",
    "portables",
    "portagues",
    "porthcawl",
    "posigrade",
    "postamble",
    "postfixed",
    "posturing",
    "postviral",
    "pothecary",
    "pothering",
    "potlaches",
    "pouchiest",
    "poujadism",
    "poujadist",
    "poulaines",
    "poulticed",
    "poultices",
    "poundages",
    "poutingly",
    "powdering",
    "powtering",
    "practised",
    "praiseful",
    "pranksome",
    "pratingly",
    "pratiques",
    "preachify",
    "preachily",
    "preaching",
    "predacity",
    "predating",
    "predation",
    "predicant",
    "predikant",
    "prefacing",
    "prefading",
    "preflight",
    "prelation",
    "prelatish",
    "prelatism",
    "preluding",
    "prelusion",
    "premonish",
    "premosaic",
    "premoving",
    "prenotify",
    "presbytic",
    "prestwich",
    "prestwick",
    "presuming",
    "princedom",
    "princoxes",
    "printable",
    "printhead",
    "printmake",
    "privately",
    "proactive",
    "probating",
    "probative",
    "procident",
    "proclaims",
    "prodigals",
    "producing",
    "profanely",
    "profanity",
    "profluent",
    "profundis",
    "profusely",
    "progestin",
    "prolactin",
    "prolamine",
    "prolative",
    "promulged",
    "promulges",
    "prongbuck",
    "pronuclei",
    "proseucha",
    "protamine",
    "proustian",
    "provencal",
    "proviants",
    "provident",
    "provinces",
    "prowlings",
    "proxemics",
    "proximate",
    "prozymite",
    "prudently",
    "prudishly",
    "prytaneum",
    "psalmodic",
    "pseudonym",
    "pterygial",
    "pterygium",
    "pterygoid",
    "ptolemaic",
    "ptomaines",
    "ptyalised",
    "ptyalized",
    "ptyalizes",
    "publicans",
    "published",
    "publisher",
    "puckering",
    "pugnacity",
    "pulmonary",
    "pulmonate",
    "pulmonics",
    "pulsating",
    "pulsation",
    "pulsative",
    "pulsatory",
    "pulvering",
    "pulvinate",
    "pumicated",
    "pumicates",
    "punchbowl",
    "purchased",
    "purflings",
    "purgation",
    "purgative",
    "purloined",
    "purveying",
    "pushingly",
    "pyelogram",
    "pygmalion",
    "pyramides",
    "pyramidon",
    "pyrenoids",
    "pyroclast",
    "pyrogenic",
    "pyroxenic",
    "pyruvates",
    "qinghaosu",
    "quackling",
    "quagmired",
    "quagmires",
    "quakerdom",
    "quakerish",
    "quakerism",
    "quakingly",
    "qualmiest",
    "quandries",
    "quantised",
    "quantized",
    "quantizes",
    "quantocks",
    "quartiles",
    "quartzose",
    "quatching",
    "quatorzes",
    "quavering",
    "quebracho",
    "quelching",
    "querimony",
    "queryings",
    "quetching",
    "quickbeam",
    "quicksand",
    "quickstep",
    "quodlibet",
    "racketing",
    "radicules",
    "railwomen",
    "rainbowed",
    "ramblings",
    "ramequins",
    "rampicked",
    "randomise",
    "randomize",
    "rantipole",
    "raspingly",
    "raunchily",
    "reactions",
    "rebacking",
    "rebaptism",
    "recaption",
    "recasting",
    "rechating",
    "recklings",
    "reclosing",
    "reclusion",
    "recountal",
    "recouping",
    "redacting",
    "redaction",
    "redisplay",
    "reduction",
    "refashion",
    "reflating",
    "reflation",
    "reflowing",
    "refutably",
    "regoliths",
    "rehousing",
    "reichstag",
    "reimplant",
    "relapsing",
    "relations",
    "reloading",
    "relucting",
    "remindful",
    "remolding",
    "removably",
    "repacking",
    "replacing",
    "replaying",
    "replicons",
    "reposting",
    "republics",
    "republish",
    "repulsing",
    "repulsion",
    "reputably",
    "requitals",
    "requoting",
    "rescaling",
    "reshaping",
    "resolving",
    "restyling",
    "resulting",
    "retakings",
    "retinulas",
    "revaluing",
    "revamping",
    "revictual",
    "revocably",
    "revolting",
    "revulsion",
    "rhapontic",
    "rhapsodic",
    "rheotaxis",
    "rheumatic",
    "rheumatiz",
    "rhizocaul",
    "rhodamine",
    "rhodesian",
    "rhopalism",
    "rhotacise",
    "rhotacism",
    "rhotacize",
    "ribozymes",
    "rickstand",
    "ridgeback",
    "ridgeways",
    "rightable",
    "righteous",
    "rijstafel",
    "rocketing",
    "rocklings",
    "rogueship",
    "roguishly",
    "romanised",
    "romanized",
    "romanizes",
    "romantics",
    "rompingly",
    "rompishly",
    "rondaches",
    "rondavels",
    "roqueting",
    "rosenthal",
    "roughcast",
    "roughneck",
    "rounceval",
    "roundelay",
    "roundlets",
    "rousingly",
    "routinely",
    "royalised",
    "royalized",
    "royalizes",
    "royalties",
    "rubefying",
    "rudbeckia",
    "rudiments",
    "rumbelows",
    "rumblings",
    "ruminated",
    "ruminates",
    "safelight",
    "salicetum",
    "salpiform",
    "salubrity",
    "samoyedic",
    "sanctorum",
    "sanforize",
    "sangfroid",
    "sanhedrim",
    "sapiently",
    "saprolite",
    "savouring",
    "sawdering",
    "saxonized",
    "scambling",
    "scapolite",
    "scarphing",
    "scatheful",
    "schiavone",
    "schmaltzy",
    "schnauzer",
    "schnitzel",
    "schnorkel",
    "schofield",
    "schonberg",
    "sclaunder",
    "sclerotia",
    "sclerotin",
    "scopulate",
    "scoundrel",
    "scraighed",
    "scrambled",
    "scrawling",
    "scrawming",
    "screaking",
    "screaming",
    "scrounged",
    "scrubland",
    "scrumping",
    "scrumpled",
    "scrupling",
    "scrutable",
    "scrutably",
    "scudamore",
    "sculpting",
    "scumbling",
    "scutiform",
    "scytheman",
    "searching",
    "seaworthy",
    "secluding",
    "secondary",
    "sectional",
    "sectorial",
    "sectoring",
    "securitan",
    "seduction",
    "seignoral",
    "seljukian",
    "semuncial",
    "senhorita",
    "sephardic",
    "sephardim",
    "septarium",
    "septiform",
    "sepuchral",
    "sequacity",
    "serotinal",
    "sexuality",
    "sforzandi",
    "shackling",
    "shadowier",
    "shadowing",
    "shakedown",
    "shambling",
    "shambolic",
    "shamoying",
    "shaveling",
    "shearling",
    "shiftwork",
    "shipboard",
    "shipwreck",
    "shockable",
    "shockwave",
    "shoeblack",
    "shogunate",
    "shortcake",
    "shotmaker",
    "shouldn't",
    "shoveling",
    "showbread",
    "showerful",
    "showering",
    "showplace",
    "shrinkage",
    "shrouding",
    "shrublike",
    "sickleman",
    "sidetrack",
    "sightable",
    "sightedly",
    "signatory",
    "signature",
    "signboard",
    "simpleton",
    "simulacre",
    "simulated",
    "simulator",
    "singapore",
    "sinuately",
    "siphonage",
    "siphonate",
    "siphuncle",
    "skeptical",
    "sketchily",
    "sketching",
    "sketchpad",
    "slaughter",
    "slavering",
    "slavonize",
    "sleuthing",
    "slingback",
    "slipcover",
    "sloganize",
    "slouchier",
    "slouching",
    "sloughier",
    "smatching",
    "smouching",
    "smutching",
    "snakebird",
    "snatchier",
    "snatchily",
    "snowdrift",
    "snowfield",
    "snowflake",
    "soakingly",
    "soaringly",
    "sobriquet",
    "societary",
    "socketing",
    "socratize",
    "sokemanry",
    "solarized",
    "soldering",
    "solemnify",
    "solemnity",
    "solifugae",
    "solutrean",
    "solvating",
    "something",
    "somniated",
    "songcraft",
    "sortilegy",
    "southerly",
    "southland",
    "southward",
    "southwark",
    "spadework",
    "spanglier",
    "sparingly",
    "sparkling",
    "spearmint",
    "specialty",
    "speckling",
    "speldring",
    "spermatic",
    "spermatid",
    "spherical",
    "sphincter",
    "sphygmoid",
    "spiculate",
    "spiderman",
    "spikenard",
    "spinulate",
    "splatched",
    "splendour",
    "spleuchan",
    "splintery",
    "splotched",
    "spoilbank",
    "spoliated",
    "spondulix",
    "sportable",
    "sportance",
    "sporulate",
    "sprackled",
    "sprangled",
    "sprauchle",
    "sprawling",
    "spreading",
    "sprighted",
    "sprightly",
    "springald",
    "springbok",
    "springlet",
    "sprinkled",
    "sprouting",
    "squadrone",
    "squalider",
    "squawking",
    "squeakily",
    "squeaking",
    "squealing",
    "squiralty",
    "squiredom",
    "staghound",
    "staminode",
    "staminody",
    "starchily",
    "starching",
    "staringly",
    "staunched",
    "stauncher",
    "staunchly",
    "steadying",
    "stegomyia",
    "steinbock",
    "stenopaic",
    "stepbairn",
    "stepchild",
    "sterculia",
    "sticheron",
    "stipulary",
    "stockpile",
    "stockyard",
    "stomached",
    "stomacher",
    "storyline",
    "stourhead",
    "stramping",
    "strangely",
    "strangled",
    "strapline",
    "strawlike",
    "strayling",
    "streakily",
    "streaking",
    "streaming",
    "strickled",
    "stridency",
    "strinkled",
    "stroaming",
    "strobilae",
    "strongyle",
    "strouding",
    "strychnia",
    "stumbling",
    "sturnidae",
    "styliform",
    "subacting",
    "subagency",
    "subalpine",
    "subaltern",
    "subatomic",
    "subcantor",
    "subcavity",
    "subclimax",
    "subcortex",
    "subdeacon",
    "subdermal",
    "subeditor",
    "subfamily",
    "subhedral",
    "subjacent",
    "subjoined",
    "sublating",
    "sublation",
    "sublimate",
    "sublinear",
    "submarine",
    "submatrix",
    "submental",
    "submicron",
    "subniveal",
    "subnormal",
    "suboctave",
    "subregion",
    "subrogate",
    "subtopian",
    "subtropic",
    "subwarden",
    "suckering",
    "suctorial",
    "suctorian",
    "sulcation",
    "sulfonate",
    "sulphatic",
    "sulphonic",
    "sunbathed",
    "sunbather",
    "sunflower",
    "superably",
    "superbity",
    "superbold",
    "supercoil",
    "supercold",
    "supernova",
    "superthin",
    "supinated",
    "supinator",
    "supremacy",
    "supremity",
    "surbating",
    "surcingle",
    "surfacing",
    "surgeoncy",
    "surpliced",
    "surtaxing",
    "surveying",
    "swingable",
    "swingboat",
    "switchman",
    "switchmen",
    "swordlike",
    "swordplay",
    "sycophant",
    "sylvanite",
    "symbolize",
    "sympathin",
    "sympatric",
    "symphonic",
    "symphonie",
    "sympodial",
    "syncopate",
    "syndicate",
    "syndromic",
    "synedrial",
    "synedrium",
    "synodical",
    "syphering",
    "syphiloma",
    "syringeal",
    "syrphidae",
    "tabefying",
    "tabouring",
    "tacklings",
    "tamboured",
    "tambourin",
    "tamoxifen",
    "tampering",
    "tangibles",
    "taperings",
    "tapeworms",
    "tarnished",
    "tarwhines",
    "taxidermy",
    "teachings",
    "teasingly",
    "tediously",
    "tenacious",
    "teraflops",
    "terminals",
    "thanedoms",
    "theandric",
    "theocrasy",
    "theomancy",
    "therapsid",
    "therbligs",
    "thermions",
    "thermofax",
    "thinkable",
    "thinkably",
    "thirdsman",
    "thirdsmen",
    "thirlages",
    "thornback",
    "thorndike",
    "thrasonic",
    "threadfin",
    "threading",
    "threaping",
    "threnodic",
    "throngful",
    "throwback",
    "throwings",
    "thumbkins",
    "thumblike",
    "thumbnail",
    "thuribles",
    "thwackers",
    "thwacking",
    "thylacine",
    "thyreoids",
    "thyroidal",
    "thyroxine",
    "tidemarks",
    "timenoguy",
    "timeously",
    "tiroleans",
    "tochering",
    "tonbridge",
    "topmakers",
    "topmaking",
    "touchable",
    "touchably",
    "touchings",
    "tovarisch",
    "towelings",
    "townscape",
    "towplanes",
    "tracheids",
    "trachinus",
    "trackings",
    "traducing",
    "traguline",
    "tramlines",
    "trampling",
    "trampolin",
    "trancedly",
    "trapesing",
    "trapezing",
    "trapezium",
    "trapezius",
    "trapezoid",
    "trauchled",
    "trauchles",
    "traveling",
    "travelogs",
    "trawlings",
    "treacling",
    "treadings",
    "treadling",
    "trebizond",
    "trembling",
    "trialogue",
    "triangled",
    "triangles",
    "tribesman",
    "tribunals",
    "trichomes",
    "tricksome",
    "trifocals",
    "trigamous",
    "triglyphs",
    "trigynous",
    "trionymal",
    "triplanes",
    "triumphal",
    "triumphed",
    "trochidae",
    "trochilus",
    "trochleas",
    "trondheim",
    "trophying",
    "troubling",
    "troupials",
    "truancies",
    "truckages",
    "truckings",
    "truckling",
    "truckload",
    "trunkfish",
    "tsarevich",
    "tubicolar",
    "tuckahoes",
    "tuckerbox",
    "tuckering",
    "tularemic",
    "tumblings",
    "tumefying",
    "tumescing",
    "tunbridge",
    "turbofans",
    "turkomans",
    "turmoiled",
    "turnbacks",
    "turnpikes",
    "twiformed",
    "twinklers",
    "tympanies",
    "typhoidal",
    "tyroleans",
    "udometric",
    "uitlander",
    "ulotrichy",
    "ulsterman",
    "ulverston",
    "umbratile",
    "umpirages",
    "unbaptise",
    "unbaptize",
    "unbigoted",
    "unblocked",
    "unbraised",
    "unbricked",
    "unbridles",
    "uncharged",
    "uncharges",
    "uncharity",
    "uncharmed",
    "uncharted",
    "unchrisom",
    "unclaimed",
    "unclamped",
    "unclasped",
    "unclimbed",
    "uncloaked",
    "unclothed",
    "unclothes",
    "uncordial",
    "undecimal",
    "undelight",
    "underacts",
    "undercast",
    "underclay",
    "undercoat",
    "underflow",
    "underlaps",
    "underlays",
    "underlips",
    "undermost",
    "underpays",
    "underplay",
    "underplot",
    "undershot",
    "undersoil",
    "undertows",
    "underwits",
    "unearthly",
    "unethical",
    "unfairest",
    "unfavored",
    "unfolders",
    "unfrisked",
    "unfrocked",
    "unfrosted",
    "ungarbled",
    "unghostly",
    "ungirthed",
    "ungodlier",
    "ungodlike",
    "ungravely",
    "unhastily",
    "unhoisted",
    "unholiest",
    "uniformed",
    "uniformly",
    "unimposed",
    "universal",
    "unjostled",
    "unlatched",
    "unlatches",
    "unlighted",
    "unlimbers",
    "unloaders",
    "unlocated",
    "unmarbled",
    "unmatched",
    "unmixedly",
    "unmotived",
    "unmovable",
    "unmovably",
    "unmovedly",
    "unpackers",
    "unpalsied",
    "unpatched",
    "unpiloted",
    "unplaited",
    "unpoached",
    "unpoliced",
    "unpraised",
    "unpredict",
    "unprovide",
    "unreadily",
    "unrealism",
    "unreality",
    "unridable",
    "unrivaled",
    "unsampled",
    "unscathed",
    "unscythed",
    "unshackle",
    "unshapely",
    "unshocked",
    "unshrived",
    "unsickled",
    "unsighted",
    "unsightly",
    "unsizable",
    "unskirted",
    "unsoberly",
    "unsolaced",
    "unspoiled",
    "unsprayed",
    "unstabler",
    "unstacked",
    "unstamped",
    "unstapled",
    "unstarchy",
    "unstifled",
    "unstocked",
    "unstriped",
    "unswathed",
    "untackled",
    "untackles",
    "unthreads",
    "untirable",
    "untopical",
    "untracked",
    "untrailed",
    "untypical",
    "unvisored",
    "unvizards",
    "unwariest",
    "unwarlike",
    "unwatched",
    "unwealthy",
    "unweighty",
    "unwhisked",
    "unwitched",
    "unwitches",
    "upbearing",
    "upblowing",
    "upcasting",
    "upclimbed",
    "upclosing",
    "updrawing",
    "upflowing",
    "upgathers",
    "upgrowths",
    "upheaving",
    "uphoisted",
    "upholders",
    "upholding",
    "upholster",
    "uplanders",
    "uplandish",
    "upleading",
    "uplifters",
    "uplighted",
    "uplighter",
    "uploading",
    "uplocking",
    "upmakings",
    "upminster",
    "uprighted",
    "uprightly",
    "upstaring",
    "upstaying",
    "upswaying",
    "uptearing",
    "uptowners",
    "upwafting",
    "upwhirled",
    "urbanised",
    "urbanites",
    "urbanized",
    "urbanizes",
    "urnfields",
    "urokinase",
    "uropygial",
    "vacherins",
    "vaginules",
    "vainglory",
    "valetings",
    "valkyries",
    "valorised",
    "valorized",
    "valorizes",
    "vaporised",
    "vaporized",
    "vaporizes",
    "vapouring",
    "vapourise",
    "vapourish",
    "vapourize",
    "varguenos",
    "variously",
    "varnished",
    "vasectomy",
    "vaultings",
    "vectorial",
    "vectoring",
    "vehicular",
    "velariums",
    "veracious",
    "verbalism",
    "verbalist",
    "verbality",
    "verbascum",
    "verbosity",
    "verdantly",
    "veritably",
    "verminous",
    "vermouths",
    "vernality",
    "veronicas",
    "versional",
    "verticals",
    "vesicular",
    "vestryman",
    "vesturing",
    "vetchling",
    "vexations",
    "vexatious",
    "vibrantly",
    "vinaceous",
    "vineyards",
    "vintagers",
    "violaters",
    "virgulate",
    "virulency",
    "viscounty",
    "vitascope",
    "vocalised",
    "vocaliser",
    "vocalized",
    "vocalizer",
    "vocalizes",
    "voiceband",
    "voidances",
    "volcanise",
    "volcanism",
    "volcanist",
    "volcanize",
    "voltigeur",
    "volucrine",
    "voluntary",
    "vouchsafe",
    "voyageurs",
    "voyeurism",
    "vulcanise",
    "vulcanism",
    "vulcanist",
    "vulcanite",
    "vulcanize",
    "vulgarise",
    "vulgarism",
    "vulgarity",
    "vulgarize",
    "wagnerism",
    "wagnerist",
    "wagonfuls",
    "waldhorns",
    "walkyries",
    "walpurgis",
    "waltzings",
    "wambliest",
    "wamblings",
    "wampished",
    "warblings",
    "warmingly",
    "washering",
    "wasterful",
    "wastering",
    "watchdogs",
    "waterings",
    "waterlogs",
    "wauchting",
    "waveforms",
    "wavefront",
    "waverings",
    "weaklings",
    "weighbauk",
    "welcoming",
    "welfarism",
    "welfarist",
    "westbound",
    "whackiest",
    "whackings",
    "whimbrels",
    "whinyards",
    "whipcords",
    "whipcordy",
    "whipjacks",
    "whipsnade",
    "whipstock",
    "whitbread",
    "whitecaps",
    "whitedamp",
    "whitesand",
    "whizbangs",
    "whombling",
    "wildgrave",
    "wimbledon",
    "windbreak",
    "windscale",
    "windstorm",
    "wingbeats",
    "winsomely",
    "wokingham",
    "wolfsbane",
    "womanised",
    "womaniser",
    "womanized",
    "womanizer",
    "womanizes",
    "wonderful",
    "wordsmith",
    "workbench",
    "workmanly",
    "workmates",
    "workplace",
    "workspace",
    "worktable",
    "woundable",
    "wraxlings",
    "wreathing",
    "wreckfish",
    "wreckings",
    "wrestling",
    "wristband",
    "wuthering",
    "xenocryst",
    "xenograft",
    "xenoliths",
    "xerophagy",
    "xerophily",
    "xiphosura",
    "xylocarps",
    "xylograph",
    "xylophage",
    "xylorimba",
    "xyridales",
    "yachtings",
    "yachtsmen",
    "yardstick",
    "yarmulkes",
    "yearlings",
    "yeldrocks",
    "yoldrings",
    "youngster",
    "zanthoxyl",
    "zealotism",
    "zemindars",
    "zemindary",
    "zemlinsky",
    "zeugmatic",
    "zircaloys",
    "zonuridae",
    "zygantrum",
    "zygomatic",
    "zygosperm",
    "zymogenic"
];

});



//# sourceMappingURL=worker.326ae55d.js.map
